import * as Va from "react";
import _t, { useCallback as $, useState as Z, useEffect as Pe, useMemo as V, createContext as Br, useContext as wr, useRef as we, useLayoutEffect as jb, createElement as Wb, useDebugValue as c0, Fragment as Ha, forwardRef as Et, useImperativeHandle as Kt, useId as el, memo as Ub, lazy as u0, Suspense as d0, useReducer as f0, version as h0 } from "react";
import { jsxs as O, jsx as l, Fragment as le } from "react/jsx-runtime";
import { Icon as ye } from "@hologram-dimension/icon";
import { Popover as et } from "@hologram-dimension/popover";
import { Button as Y } from "@hologram-dimension/button";
import { Link as Ae } from "@hologram-dimension/link";
import { Panel as He } from "@hologram-dimension/panel";
import { PanelNotification as fe } from "@hologram-dimension/panel-notification";
import { Loader as ur } from "@hologram-dimension/loader";
import { DropdownPanel as Kn } from "@hologram-dimension/dropdown-panel";
import wt from "clsx";
import { Chip as en } from "@hologram-dimension/chip";
import { TextInput as nn } from "@hologram-dimension/text-input";
import { Modal as qt } from "@hologram-dimension/modal";
import { useFloating as m0, size as p0, offset as g0, autoUpdate as v0, FloatingPortal as y0, FloatingOverlay as b0, FloatingFocusManager as S0, useFloatingRootContext as w0, useDismiss as I0, useRole as C0, useInteractions as P0, useId as Jn } from "@floating-ui/react";
import { BannerNotification as ze } from "@hologram-dimension/banner-notification";
import { Checkbox as Rr } from "@hologram-dimension/checkbox";
import { Workbook as Gf } from "exceljs";
import { InlineNotification as tn } from "@hologram-dimension/inline-notification";
import { Form as Gr } from "@hologram-dimension/form";
import { SelectField as Qf } from "@hologram-dimension/select-field";
import { flushSync as T0 } from "react-dom";
import { Select as Zf } from "@hologram-dimension/select";
import { DatePicker as nm } from "@hologram-dimension/date-picker";
import { FormField as mn } from "@hologram-dimension/form-field";
import { ValidationMessage as _0 } from "@hologram-dimension/validation-message";
import { useElements as E0, AddressElement as O0 } from "@stripe/react-stripe-js";
import { allCountries as N0 } from "country-region-data";
import { RadioField as Ts } from "@hologram-dimension/radio-field";
import { CheckboxField as qa } from "@hologram-dimension/checkbox-field";
import { Label as D0 } from "@hologram-dimension/label";
import { TextInputField as pn } from "@hologram-dimension/text-input-field";
import { TextareaField as Yf } from "@hologram-dimension/textarea-field";
import { Tab as _s } from "@hologram-dimension/tab";
import { Helmet as Vb } from "react-helmet";
import { DdsTypographyFontFamilyDefault as la } from "@hologram-dimension/tokens";
import { Chart as R0, LinearScale as k0, PointElement as A0, LineElement as x0, BarElement as F0, BarController as $0, Tooltip as M0, Legend as L0 } from "chart.js";
import { Scatter as j0 } from "react-chartjs-2";
import "chartjs-adapter-luxon";
import "chartjs-scale-timestack";
import { isObject as im } from "lodash";
var Hb = Symbol.for("immer-nothing"), am = Symbol.for("immer-draftable"), Je = Symbol.for("immer-state"), W0 = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function er(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = W0[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Li = Object.getPrototypeOf;
function ji(e) {
  return !!e && !!e[Je];
}
function gn(e) {
  return e ? qb(e) || Array.isArray(e) || !!e[am] || !!e.constructor?.[am] || rl(e) || nl(e) : !1;
}
var U0 = Object.prototype.constructor.toString();
function qb(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Li(e);
  if (t === null)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === U0;
}
function za(e, t) {
  tl(e) === 0 ? Reflect.ownKeys(e).forEach((r) => {
    t(r, e[r], e);
  }) : e.forEach((r, n) => t(n, r, e));
}
function tl(e) {
  const t = e[Je];
  return t ? t.type_ : Array.isArray(e) ? 1 : rl(e) ? 2 : nl(e) ? 3 : 0;
}
function Zd(e, t) {
  return tl(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function zb(e, t, r) {
  const n = tl(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function V0(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function rl(e) {
  return e instanceof Map;
}
function nl(e) {
  return e instanceof Set;
}
function Ft(e) {
  return e.copy_ || e.base_;
}
function Yd(e, t) {
  if (rl(e))
    return new Map(e);
  if (nl(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = qb(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[Je];
    let i = Reflect.ownKeys(n);
    for (let a = 0; a < i.length; a++) {
      const s = i[a], o = n[s];
      o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (n[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: o.enumerable,
        value: e[s]
      });
    }
    return Object.create(Li(e), n);
  } else {
    const n = Li(e);
    if (n !== null && r)
      return { ...e };
    const i = Object.create(n);
    return Object.assign(i, e);
  }
}
function Kf(e, t = !1) {
  return il(e) || ji(e) || !gn(e) || (tl(e) > 1 && (e.set = e.add = e.clear = e.delete = H0), Object.freeze(e), t && Object.entries(e).forEach(([r, n]) => Kf(n, !0))), e;
}
function H0() {
  er(2);
}
function il(e) {
  return Object.isFrozen(e);
}
var Kd = {};
function Zn(e) {
  const t = Kd[e];
  return t || er(0, e), t;
}
function q0(e, t) {
  Kd[e] || (Kd[e] = t);
}
var Ba;
function Fo() {
  return Ba;
}
function z0(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function sm(e, t) {
  t && (Zn("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Jd(e) {
  Xd(e), e.drafts_.forEach(B0), e.drafts_ = null;
}
function Xd(e) {
  e === Ba && (Ba = e.parent_);
}
function om(e) {
  return Ba = z0(Ba, e);
}
function B0(e) {
  const t = e[Je];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function lm(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[Je].modified_ && (Jd(t), er(4)), gn(e) && (e = $o(t, e), t.parent_ || Mo(t, e)), t.patches_ && Zn("Patches").generateReplacementPatches_(
    r[Je].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = $o(t, r, []), Jd(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Hb ? e : void 0;
}
function $o(e, t, r) {
  if (il(t))
    return t;
  const n = t[Je];
  if (!n)
    return za(
      t,
      (i, a) => cm(e, n, t, i, a, r)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return Mo(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const i = n.copy_;
    let a = i, s = !1;
    n.type_ === 3 && (a = new Set(i), i.clear(), s = !0), za(
      a,
      (o, c) => cm(e, n, i, o, c, r, s)
    ), Mo(e, i, !1), r && e.patches_ && Zn("Patches").generatePatches_(
      n,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function cm(e, t, r, n, i, a, s) {
  if (process.env.NODE_ENV !== "production" && i === r && er(5), ji(i)) {
    const o = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Zd(t.assigned_, n) ? a.concat(n) : void 0, c = $o(e, i, o);
    if (zb(r, n, c), ji(c))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else s && r.add(i);
  if (gn(i) && !il(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    $o(e, i), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && Mo(e, i);
  }
}
function Mo(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Kf(t, r);
}
function G0(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Fo(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = n, a = Jf;
  r && (i = [n], a = Ga);
  const { revoke: s, proxy: o } = Proxy.revocable(i, a);
  return n.draft_ = o, n.revoke_ = s, o;
}
var Jf = {
  get(e, t) {
    if (t === Je)
      return e;
    const r = Ft(e);
    if (!Zd(r, t))
      return Q0(e, r, t);
    const n = r[t];
    return e.finalized_ || !gn(n) ? n : n === Al(e.base_, t) ? (xl(e), e.copy_[t] = Qa(n, e)) : n;
  },
  has(e, t) {
    return t in Ft(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Ft(e));
  },
  set(e, t, r) {
    const n = Bb(Ft(e), t);
    if (n?.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = Al(Ft(e), t), a = i?.[Je];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (V0(r, i) && (r !== void 0 || Zd(e.base_, t)))
        return !0;
      xl(e), hn(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Al(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, xl(e), hn(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = Ft(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    er(11);
  },
  getPrototypeOf(e) {
    return Li(e.base_);
  },
  setPrototypeOf() {
    er(12);
  }
}, Ga = {};
za(Jf, (e, t) => {
  Ga[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Ga.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && er(13), Ga.set.call(this, e, t, void 0);
};
Ga.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && er(14), Jf.set.call(this, e[0], t, r, e[0]);
};
function Al(e, t) {
  const r = e[Je];
  return (r ? Ft(r) : e)[t];
}
function Q0(e, t, r) {
  const n = Bb(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    n.get?.call(e.draft_)
  ) : void 0;
}
function Bb(e, t) {
  if (!(t in e))
    return;
  let r = Li(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = Li(r);
  }
}
function hn(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && hn(e.parent_));
}
function xl(e) {
  e.copy_ || (e.copy_ = Yd(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var Z0 = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const a = r;
        r = t;
        const s = this;
        return function(c = a, ...u) {
          return s.produce(c, (f) => r.call(this, f, ...u));
        };
      }
      typeof r != "function" && er(6), n !== void 0 && typeof n != "function" && er(7);
      let i;
      if (gn(t)) {
        const a = om(this), s = Qa(t, void 0);
        let o = !0;
        try {
          i = r(s), o = !1;
        } finally {
          o ? Jd(a) : Xd(a);
        }
        return sm(a, n), lm(i, a);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === Hb && (i = void 0), this.autoFreeze_ && Kf(i, !0), n) {
          const a = [], s = [];
          Zn("Patches").generateReplacementPatches_(t, i, a, s), n(a, s);
        }
        return i;
      } else
        er(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (s, ...o) => this.produceWithPatches(s, (c) => t(c, ...o));
      let n, i;
      return [this.produce(t, r, (s, o) => {
        n = s, i = o;
      }), n, i];
    }, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    gn(e) || er(8), ji(e) && (e = Y0(e));
    const t = om(this), r = Qa(e, void 0);
    return r[Je].isManual_ = !0, Xd(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[Je];
    (!r || !r.isManual_) && er(9);
    const { scope_: n } = r;
    return sm(n, t), lm(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = Zn("Patches").applyPatches_;
    return ji(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function Qa(e, t) {
  const r = rl(e) ? Zn("MapSet").proxyMap_(e, t) : nl(e) ? Zn("MapSet").proxySet_(e, t) : G0(e, t);
  return (t ? t.scope_ : Fo()).drafts_.push(r), r;
}
function Y0(e) {
  return ji(e) || er(10, e), Gb(e);
}
function Gb(e) {
  if (!gn(e) || il(e))
    return e;
  const t = e[Je];
  let r;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = Yd(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    r = Yd(e, !0);
  return za(r, (n, i) => {
    zb(r, n, Gb(i));
  }), t && (t.finalized_ = !1), r;
}
function K0() {
  class e extends Map {
    constructor(c, u) {
      super(), this[Je] = {
        type_: 2,
        parent_: u,
        scope_: u ? u.scope_ : Fo(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        assigned_: void 0,
        base_: c,
        draft_: this,
        isManual_: !1,
        revoked_: !1
      };
    }
    get size() {
      return Ft(this[Je]).size;
    }
    has(c) {
      return Ft(this[Je]).has(c);
    }
    set(c, u) {
      const f = this[Je];
      return s(f), (!Ft(f).has(c) || Ft(f).get(c) !== u) && (r(f), hn(f), f.assigned_.set(c, !0), f.copy_.set(c, u), f.assigned_.set(c, !0)), this;
    }
    delete(c) {
      if (!this.has(c))
        return !1;
      const u = this[Je];
      return s(u), r(u), hn(u), u.base_.has(c) ? u.assigned_.set(c, !1) : u.assigned_.delete(c), u.copy_.delete(c), !0;
    }
    clear() {
      const c = this[Je];
      s(c), Ft(c).size && (r(c), hn(c), c.assigned_ = /* @__PURE__ */ new Map(), za(c.base_, (u) => {
        c.assigned_.set(u, !1);
      }), c.copy_.clear());
    }
    forEach(c, u) {
      const f = this[Je];
      Ft(f).forEach((g, p, d) => {
        c.call(u, this.get(p), p, this);
      });
    }
    get(c) {
      const u = this[Je];
      s(u);
      const f = Ft(u).get(c);
      if (u.finalized_ || !gn(f) || f !== u.base_.get(c))
        return f;
      const g = Qa(f, u);
      return r(u), u.copy_.set(c, g), g;
    }
    keys() {
      return Ft(this[Je]).keys();
    }
    values() {
      const c = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const u = c.next();
          return u.done ? u : {
            done: !1,
            value: this.get(u.value)
          };
        }
      };
    }
    entries() {
      const c = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const u = c.next();
          if (u.done)
            return u;
          const f = this.get(u.value);
          return {
            done: !1,
            value: [u.value, f]
          };
        }
      };
    }
    [Symbol.iterator]() {
      return this.entries();
    }
  }
  function t(o, c) {
    return new e(o, c);
  }
  function r(o) {
    o.copy_ || (o.assigned_ = /* @__PURE__ */ new Map(), o.copy_ = new Map(o.base_));
  }
  class n extends Set {
    constructor(c, u) {
      super(), this[Je] = {
        type_: 3,
        parent_: u,
        scope_: u ? u.scope_ : Fo(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        base_: c,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: !1,
        isManual_: !1
      };
    }
    get size() {
      return Ft(this[Je]).size;
    }
    has(c) {
      const u = this[Je];
      return s(u), u.copy_ ? !!(u.copy_.has(c) || u.drafts_.has(c) && u.copy_.has(u.drafts_.get(c))) : u.base_.has(c);
    }
    add(c) {
      const u = this[Je];
      return s(u), this.has(c) || (a(u), hn(u), u.copy_.add(c)), this;
    }
    delete(c) {
      if (!this.has(c))
        return !1;
      const u = this[Je];
      return s(u), a(u), hn(u), u.copy_.delete(c) || (u.drafts_.has(c) ? u.copy_.delete(u.drafts_.get(c)) : (
        /* istanbul ignore next */
        !1
      ));
    }
    clear() {
      const c = this[Je];
      s(c), Ft(c).size && (a(c), hn(c), c.copy_.clear());
    }
    values() {
      const c = this[Je];
      return s(c), a(c), c.copy_.values();
    }
    entries() {
      const c = this[Je];
      return s(c), a(c), c.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [Symbol.iterator]() {
      return this.values();
    }
    forEach(c, u) {
      const f = this.values();
      let g = f.next();
      for (; !g.done; )
        c.call(u, g.value, g.value, this), g = f.next();
    }
  }
  function i(o, c) {
    return new n(o, c);
  }
  function a(o) {
    o.copy_ || (o.copy_ = /* @__PURE__ */ new Set(), o.base_.forEach((c) => {
      if (gn(c)) {
        const u = Qa(c, o);
        o.drafts_.set(c, u), o.copy_.add(u);
      } else
        o.copy_.add(c);
    }));
  }
  function s(o) {
    o.revoked_ && er(3, JSON.stringify(Ft(o)));
  }
  q0("MapSet", { proxyMap_: t, proxySet_: i });
}
var br = new Z0(), J0 = br.produce;
br.produceWithPatches.bind(
  br
);
br.setAutoFreeze.bind(br);
br.setUseStrictShallowCopy.bind(br);
br.applyPatches.bind(br);
br.createDraft.bind(br);
br.finishDraft.bind(br);
class Xn extends Error {
}
class X0 extends Xn {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class eC extends Xn {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class tC extends Xn {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class Ei extends Xn {
}
class Qb extends Xn {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class Qt extends Xn {
}
class Cn extends Xn {
  constructor() {
    super("Zone is an abstract class");
  }
}
const ge = "numeric", qr = "short", yr = "long", Lo = {
  year: ge,
  month: ge,
  day: ge
}, Zb = {
  year: ge,
  month: qr,
  day: ge
}, rC = {
  year: ge,
  month: qr,
  day: ge,
  weekday: qr
}, Yb = {
  year: ge,
  month: yr,
  day: ge
}, Kb = {
  year: ge,
  month: yr,
  day: ge,
  weekday: yr
}, Jb = {
  hour: ge,
  minute: ge
}, Xb = {
  hour: ge,
  minute: ge,
  second: ge
}, eS = {
  hour: ge,
  minute: ge,
  second: ge,
  timeZoneName: qr
}, tS = {
  hour: ge,
  minute: ge,
  second: ge,
  timeZoneName: yr
}, rS = {
  hour: ge,
  minute: ge,
  hourCycle: "h23"
}, nS = {
  hour: ge,
  minute: ge,
  second: ge,
  hourCycle: "h23"
}, iS = {
  hour: ge,
  minute: ge,
  second: ge,
  hourCycle: "h23",
  timeZoneName: qr
}, aS = {
  hour: ge,
  minute: ge,
  second: ge,
  hourCycle: "h23",
  timeZoneName: yr
}, sS = {
  year: ge,
  month: ge,
  day: ge,
  hour: ge,
  minute: ge
}, oS = {
  year: ge,
  month: ge,
  day: ge,
  hour: ge,
  minute: ge,
  second: ge
}, lS = {
  year: ge,
  month: qr,
  day: ge,
  hour: ge,
  minute: ge
}, cS = {
  year: ge,
  month: qr,
  day: ge,
  hour: ge,
  minute: ge,
  second: ge
}, nC = {
  year: ge,
  month: qr,
  day: ge,
  weekday: qr,
  hour: ge,
  minute: ge
}, uS = {
  year: ge,
  month: yr,
  day: ge,
  hour: ge,
  minute: ge,
  timeZoneName: qr
}, dS = {
  year: ge,
  month: yr,
  day: ge,
  hour: ge,
  minute: ge,
  second: ge,
  timeZoneName: qr
}, fS = {
  year: ge,
  month: yr,
  day: ge,
  weekday: yr,
  hour: ge,
  minute: ge,
  timeZoneName: yr
}, hS = {
  year: ge,
  month: yr,
  day: ge,
  weekday: yr,
  hour: ge,
  minute: ge,
  second: ge,
  timeZoneName: yr
};
class Es {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Cn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Cn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Cn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, r) {
    throw new Cn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, r) {
    throw new Cn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new Cn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new Cn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Cn();
  }
}
let Fl = null;
class al extends Es {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Fl === null && (Fl = new al()), Fl;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: r, locale: n }) {
    return PS(t, r, n);
  }
  /** @override **/
  formatOffset(t, r) {
    return La(this.offset(t), r);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const ef = /* @__PURE__ */ new Map();
function iC(e) {
  let t = ef.get(e);
  return t === void 0 && (t = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), ef.set(e, t)), t;
}
const aC = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function sC(e, t) {
  const r = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(r), [, i, a, s, o, c, u, f] = n;
  return [s, i, a, o, c, u, f];
}
function oC(e, t) {
  const r = e.formatToParts(t), n = [];
  for (let i = 0; i < r.length; i++) {
    const { type: a, value: s } = r[i], o = aC[a];
    a === "era" ? n[o] = s : Oe(o) || (n[o] = parseInt(s, 10));
  }
  return n;
}
const $l = /* @__PURE__ */ new Map();
class vn extends Es {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    let r = $l.get(t);
    return r === void 0 && $l.set(t, r = new vn(t)), r;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    $l.clear(), ef.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = vn.isValidZone(t);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, { format: r, locale: n }) {
    return PS(t, r, n, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, r) {
    return La(this.offset(t), r);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    if (!this.valid) return NaN;
    const r = new Date(t);
    if (isNaN(r)) return NaN;
    const n = iC(this.name);
    let [i, a, s, o, c, u, f] = n.formatToParts ? oC(n, r) : sC(n, r);
    o === "BC" && (i = -Math.abs(i) + 1);
    const p = ol({
      year: i,
      month: a,
      day: s,
      hour: c === 24 ? 0 : c,
      minute: u,
      second: f,
      millisecond: 0
    });
    let d = +r;
    const h = d % 1e3;
    return d -= h >= 0 ? h : 1e3 + h, (p - d) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let um = {};
function lC(e, t = {}) {
  const r = JSON.stringify([e, t]);
  let n = um[r];
  return n || (n = new Intl.ListFormat(e, t), um[r] = n), n;
}
const tf = /* @__PURE__ */ new Map();
function rf(e, t = {}) {
  const r = JSON.stringify([e, t]);
  let n = tf.get(r);
  return n === void 0 && (n = new Intl.DateTimeFormat(e, t), tf.set(r, n)), n;
}
const nf = /* @__PURE__ */ new Map();
function cC(e, t = {}) {
  const r = JSON.stringify([e, t]);
  let n = nf.get(r);
  return n === void 0 && (n = new Intl.NumberFormat(e, t), nf.set(r, n)), n;
}
const af = /* @__PURE__ */ new Map();
function uC(e, t = {}) {
  const { base: r, ...n } = t, i = JSON.stringify([e, n]);
  let a = af.get(i);
  return a === void 0 && (a = new Intl.RelativeTimeFormat(e, t), af.set(i, a)), a;
}
let Na = null;
function dC() {
  return Na || (Na = new Intl.DateTimeFormat().resolvedOptions().locale, Na);
}
const sf = /* @__PURE__ */ new Map();
function mS(e) {
  let t = sf.get(e);
  return t === void 0 && (t = new Intl.DateTimeFormat(e).resolvedOptions(), sf.set(e, t)), t;
}
const of = /* @__PURE__ */ new Map();
function fC(e) {
  let t = of.get(e);
  if (!t) {
    const r = new Intl.Locale(e);
    t = "getWeekInfo" in r ? r.getWeekInfo() : r.weekInfo, "minimalDays" in t || (t = { ...pS, ...t }), of.set(e, t);
  }
  return t;
}
function hC(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const r = e.indexOf("-u-");
  if (r === -1)
    return [e];
  {
    let n, i;
    try {
      n = rf(e).resolvedOptions(), i = e;
    } catch {
      const c = e.substring(0, r);
      n = rf(c).resolvedOptions(), i = c;
    }
    const { numberingSystem: a, calendar: s } = n;
    return [i, a, s];
  }
}
function mC(e, t, r) {
  return (r || t) && (e.includes("-u-") || (e += "-u"), r && (e += `-ca-${r}`), t && (e += `-nu-${t}`)), e;
}
function pC(e) {
  const t = [];
  for (let r = 1; r <= 12; r++) {
    const n = ve.utc(2009, r, 1);
    t.push(e(n));
  }
  return t;
}
function gC(e) {
  const t = [];
  for (let r = 1; r <= 7; r++) {
    const n = ve.utc(2016, 11, 13 + r);
    t.push(e(n));
  }
  return t;
}
function zs(e, t, r, n) {
  const i = e.listingMode();
  return i === "error" ? null : i === "en" ? r(t) : n(t);
}
function vC(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || mS(e.locale).numberingSystem === "latn";
}
class yC {
  constructor(t, r, n) {
    this.padTo = n.padTo || 0, this.floor = n.floor || !1;
    const { padTo: i, floor: a, ...s } = n;
    if (!r || Object.keys(s).length > 0) {
      const o = { useGrouping: !1, ...n };
      n.padTo > 0 && (o.minimumIntegerDigits = n.padTo), this.inf = cC(t, o);
    }
  }
  format(t) {
    if (this.inf) {
      const r = this.floor ? Math.floor(t) : t;
      return this.inf.format(r);
    } else {
      const r = this.floor ? Math.floor(t) : nh(t, 3);
      return Ct(r, this.padTo);
    }
  }
}
class bC {
  constructor(t, r, n) {
    this.opts = n, this.originalZone = void 0;
    let i;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const s = -1 * (t.offset / 60), o = s >= 0 ? `Etc/GMT+${s}` : `Etc/GMT${s}`;
      t.offset !== 0 && vn.create(o).valid ? (i = o, this.dt = t) : (i = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, i = t.zone.name) : (i = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const a = { ...this.opts };
    a.timeZone = a.timeZone || i, this.dtf = rf(r, a);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((r) => {
      if (r.type === "timeZoneName") {
        const n = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...r,
          value: n
        };
      } else
        return r;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class SC {
  constructor(t, r, n) {
    this.opts = { style: "long", ...n }, !r && IS() && (this.rtf = uC(t, n));
  }
  format(t, r) {
    return this.rtf ? this.rtf.format(t, r) : VC(r, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, r) {
    return this.rtf ? this.rtf.formatToParts(t, r) : [];
  }
}
const pS = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Xe {
  static fromOpts(t) {
    return Xe.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, r, n, i, a = !1) {
    const s = t || it.defaultLocale, o = s || (a ? "en-US" : dC()), c = r || it.defaultNumberingSystem, u = n || it.defaultOutputCalendar, f = cf(i) || it.defaultWeekSettings;
    return new Xe(o, c, u, f, s);
  }
  static resetCache() {
    Na = null, tf.clear(), nf.clear(), af.clear(), sf.clear(), of.clear();
  }
  static fromObject({ locale: t, numberingSystem: r, outputCalendar: n, weekSettings: i } = {}) {
    return Xe.create(t, r, n, i);
  }
  constructor(t, r, n, i, a) {
    const [s, o, c] = hC(t);
    this.locale = s, this.numberingSystem = r || o || null, this.outputCalendar = n || c || null, this.weekSettings = i, this.intl = mC(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = a, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = vC(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), r = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && r ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : Xe.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      cf(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, r = !1) {
    return zs(this, t, ES, () => {
      const n = r ? { month: t, day: "numeric" } : { month: t }, i = r ? "format" : "standalone";
      return this.monthsCache[i][t] || (this.monthsCache[i][t] = pC((a) => this.extract(a, n, "month"))), this.monthsCache[i][t];
    });
  }
  weekdays(t, r = !1) {
    return zs(this, t, DS, () => {
      const n = r ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, i = r ? "format" : "standalone";
      return this.weekdaysCache[i][t] || (this.weekdaysCache[i][t] = gC(
        (a) => this.extract(a, n, "weekday")
      )), this.weekdaysCache[i][t];
    });
  }
  meridiems() {
    return zs(
      this,
      void 0,
      () => RS,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [ve.utc(2016, 11, 13, 9), ve.utc(2016, 11, 13, 19)].map(
            (r) => this.extract(r, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return zs(this, t, kS, () => {
      const r = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [ve.utc(-40, 1, 1), ve.utc(2017, 1, 1)].map(
        (n) => this.extract(n, r, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, r, n) {
    const i = this.dtFormatter(t, r), a = i.formatToParts(), s = a.find((o) => o.type.toLowerCase() === n);
    return s ? s.value : null;
  }
  numberFormatter(t = {}) {
    return new yC(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, r = {}) {
    return new bC(t, this.intl, r);
  }
  relFormatter(t = {}) {
    return new SC(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return lC(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || mS(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : CS() ? fC(this.locale) : pS;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let Ml = null;
class rr extends Es {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Ml === null && (Ml = new rr(0)), Ml;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? rr.utcInstance : new rr(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const r = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r)
        return new rr(ll(r[1], r[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${La(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${La(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, r) {
    return La(this.fixed, r);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class wC extends Es {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function kn(e, t) {
  if (Oe(e) || e === null)
    return t;
  if (e instanceof Es)
    return e;
  if (EC(e)) {
    const r = e.toLowerCase();
    return r === "default" ? t : r === "local" || r === "system" ? al.instance : r === "utc" || r === "gmt" ? rr.utcInstance : rr.parseSpecifier(r) || vn.create(e);
  } else return $n(e) ? rr.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new wC(e);
}
const Xf = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, dm = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, IC = Xf.hanidec.replace(/[\[|\]]/g, "").split("");
function CC(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let r = 0; r < e.length; r++) {
      const n = e.charCodeAt(r);
      if (e[r].search(Xf.hanidec) !== -1)
        t += IC.indexOf(e[r]);
      else
        for (const i in dm) {
          const [a, s] = dm[i];
          n >= a && n <= s && (t += n - a);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
const lf = /* @__PURE__ */ new Map();
function PC() {
  lf.clear();
}
function xr({ numberingSystem: e }, t = "") {
  const r = e || "latn";
  let n = lf.get(r);
  n === void 0 && (n = /* @__PURE__ */ new Map(), lf.set(r, n));
  let i = n.get(t);
  return i === void 0 && (i = new RegExp(`${Xf[r]}${t}`), n.set(t, i)), i;
}
let fm = () => Date.now(), hm = "system", mm = null, pm = null, gm = null, vm = 60, ym, bm = null;
class it {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return fm;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    fm = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    hm = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return kn(hm, al.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return mm;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    mm = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return pm;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    pm = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return gm;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    gm = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return bm;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    bm = cf(t);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return vm;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    vm = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return ym;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    ym = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Xe.resetCache(), vn.resetCache(), ve.resetCache(), PC();
  }
}
class Hr {
  constructor(t, r) {
    this.reason = t, this.explanation = r;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const gS = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], vS = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function Nr(e, t) {
  return new Hr(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function eh(e, t, r) {
  const n = new Date(Date.UTC(e, t - 1, r));
  e < 100 && e >= 0 && n.setUTCFullYear(n.getUTCFullYear() - 1900);
  const i = n.getUTCDay();
  return i === 0 ? 7 : i;
}
function yS(e, t, r) {
  return r + (Os(e) ? vS : gS)[t - 1];
}
function bS(e, t) {
  const r = Os(e) ? vS : gS, n = r.findIndex((a) => a < t), i = t - r[n];
  return { month: n + 1, day: i };
}
function th(e, t) {
  return (e - t + 7) % 7 + 1;
}
function jo(e, t = 4, r = 1) {
  const { year: n, month: i, day: a } = e, s = yS(n, i, a), o = th(eh(n, i, a), r);
  let c = Math.floor((s - o + 14 - t) / 7), u;
  return c < 1 ? (u = n - 1, c = Za(u, t, r)) : c > Za(n, t, r) ? (u = n + 1, c = 1) : u = n, { weekYear: u, weekNumber: c, weekday: o, ...cl(e) };
}
function Sm(e, t = 4, r = 1) {
  const { weekYear: n, weekNumber: i, weekday: a } = e, s = th(eh(n, 1, t), r), o = Ri(n);
  let c = i * 7 + a - s - 7 + t, u;
  c < 1 ? (u = n - 1, c += Ri(u)) : c > o ? (u = n + 1, c -= Ri(n)) : u = n;
  const { month: f, day: g } = bS(u, c);
  return { year: u, month: f, day: g, ...cl(e) };
}
function Ll(e) {
  const { year: t, month: r, day: n } = e, i = yS(t, r, n);
  return { year: t, ordinal: i, ...cl(e) };
}
function wm(e) {
  const { year: t, ordinal: r } = e, { month: n, day: i } = bS(t, r);
  return { year: t, month: n, day: i, ...cl(e) };
}
function Im(e, t) {
  if (!Oe(e.localWeekday) || !Oe(e.localWeekNumber) || !Oe(e.localWeekYear)) {
    if (!Oe(e.weekday) || !Oe(e.weekNumber) || !Oe(e.weekYear))
      throw new Ei(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Oe(e.localWeekday) || (e.weekday = e.localWeekday), Oe(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Oe(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function TC(e, t = 4, r = 1) {
  const n = sl(e.weekYear), i = Dr(
    e.weekNumber,
    1,
    Za(e.weekYear, t, r)
  ), a = Dr(e.weekday, 1, 7);
  return n ? i ? a ? !1 : Nr("weekday", e.weekday) : Nr("week", e.weekNumber) : Nr("weekYear", e.weekYear);
}
function _C(e) {
  const t = sl(e.year), r = Dr(e.ordinal, 1, Ri(e.year));
  return t ? r ? !1 : Nr("ordinal", e.ordinal) : Nr("year", e.year);
}
function SS(e) {
  const t = sl(e.year), r = Dr(e.month, 1, 12), n = Dr(e.day, 1, Wo(e.year, e.month));
  return t ? r ? n ? !1 : Nr("day", e.day) : Nr("month", e.month) : Nr("year", e.year);
}
function wS(e) {
  const { hour: t, minute: r, second: n, millisecond: i } = e, a = Dr(t, 0, 23) || t === 24 && r === 0 && n === 0 && i === 0, s = Dr(r, 0, 59), o = Dr(n, 0, 59), c = Dr(i, 0, 999);
  return a ? s ? o ? c ? !1 : Nr("millisecond", i) : Nr("second", n) : Nr("minute", r) : Nr("hour", t);
}
function Oe(e) {
  return typeof e > "u";
}
function $n(e) {
  return typeof e == "number";
}
function sl(e) {
  return typeof e == "number" && e % 1 === 0;
}
function EC(e) {
  return typeof e == "string";
}
function OC(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function IS() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function CS() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function NC(e) {
  return Array.isArray(e) ? e : [e];
}
function Cm(e, t, r) {
  if (e.length !== 0)
    return e.reduce((n, i) => {
      const a = [t(i), i];
      return n && r(n[0], a[0]) === n[0] ? n : a;
    }, null)[1];
}
function DC(e, t) {
  return t.reduce((r, n) => (r[n] = e[n], r), {});
}
function Wi(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function cf(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Qt("Week settings must be an object");
  if (!Dr(e.firstDay, 1, 7) || !Dr(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !Dr(t, 1, 7)))
    throw new Qt("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function Dr(e, t, r) {
  return sl(e) && e >= t && e <= r;
}
function RC(e, t) {
  return e - t * Math.floor(e / t);
}
function Ct(e, t = 2) {
  const r = e < 0;
  let n;
  return r ? n = "-" + ("" + -e).padStart(t, "0") : n = ("" + e).padStart(t, "0"), n;
}
function Dn(e) {
  if (!(Oe(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function Un(e) {
  if (!(Oe(e) || e === null || e === ""))
    return parseFloat(e);
}
function rh(e) {
  if (!(Oe(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function nh(e, t, r = !1) {
  const n = 10 ** t;
  return (r ? Math.trunc : Math.round)(e * n) / n;
}
function Os(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Ri(e) {
  return Os(e) ? 366 : 365;
}
function Wo(e, t) {
  const r = RC(t - 1, 12) + 1, n = e + (t - r) / 12;
  return r === 2 ? Os(n) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][r - 1];
}
function ol(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function Pm(e, t, r) {
  return -th(eh(e, 1, t), r) + t - 1;
}
function Za(e, t = 4, r = 1) {
  const n = Pm(e, t, r), i = Pm(e + 1, t, r);
  return (Ri(e) - n + i) / 7;
}
function uf(e) {
  return e > 99 ? e : e > it.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function PS(e, t, r, n = null) {
  const i = new Date(e), a = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  n && (a.timeZone = n);
  const s = { timeZoneName: t, ...a }, o = new Intl.DateTimeFormat(r, s).formatToParts(i).find((c) => c.type.toLowerCase() === "timezonename");
  return o ? o.value : null;
}
function ll(e, t) {
  let r = parseInt(e, 10);
  Number.isNaN(r) && (r = 0);
  const n = parseInt(t, 10) || 0, i = r < 0 || Object.is(r, -0) ? -n : n;
  return r * 60 + i;
}
function TS(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new Qt(`Invalid unit value ${e}`);
  return t;
}
function Uo(e, t) {
  const r = {};
  for (const n in e)
    if (Wi(e, n)) {
      const i = e[n];
      if (i == null) continue;
      r[t(n)] = TS(i);
    }
  return r;
}
function La(e, t) {
  const r = Math.trunc(Math.abs(e / 60)), n = Math.trunc(Math.abs(e % 60)), i = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${i}${Ct(r, 2)}:${Ct(n, 2)}`;
    case "narrow":
      return `${i}${r}${n > 0 ? `:${n}` : ""}`;
    case "techie":
      return `${i}${Ct(r, 2)}${Ct(n, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function cl(e) {
  return DC(e, ["hour", "minute", "second", "millisecond"]);
}
const kC = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], _S = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], AC = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function ES(e) {
  switch (e) {
    case "narrow":
      return [...AC];
    case "short":
      return [..._S];
    case "long":
      return [...kC];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const OS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], NS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], xC = ["M", "T", "W", "T", "F", "S", "S"];
function DS(e) {
  switch (e) {
    case "narrow":
      return [...xC];
    case "short":
      return [...NS];
    case "long":
      return [...OS];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const RS = ["AM", "PM"], FC = ["Before Christ", "Anno Domini"], $C = ["BC", "AD"], MC = ["B", "A"];
function kS(e) {
  switch (e) {
    case "narrow":
      return [...MC];
    case "short":
      return [...$C];
    case "long":
      return [...FC];
    default:
      return null;
  }
}
function LC(e) {
  return RS[e.hour < 12 ? 0 : 1];
}
function jC(e, t) {
  return DS(t)[e.weekday - 1];
}
function WC(e, t) {
  return ES(t)[e.month - 1];
}
function UC(e, t) {
  return kS(t)[e.year < 0 ? 0 : 1];
}
function VC(e, t, r = "always", n = !1) {
  const i = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, a = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (r === "auto" && a) {
    const g = e === "days";
    switch (t) {
      case 1:
        return g ? "tomorrow" : `next ${i[e][0]}`;
      case -1:
        return g ? "yesterday" : `last ${i[e][0]}`;
      case 0:
        return g ? "today" : `this ${i[e][0]}`;
    }
  }
  const s = Object.is(t, -0) || t < 0, o = Math.abs(t), c = o === 1, u = i[e], f = n ? c ? u[1] : u[2] || u[1] : c ? i[e][0] : e;
  return s ? `${o} ${f} ago` : `in ${o} ${f}`;
}
function Tm(e, t) {
  let r = "";
  for (const n of e)
    n.literal ? r += n.val : r += t(n.val);
  return r;
}
const HC = {
  D: Lo,
  DD: Zb,
  DDD: Yb,
  DDDD: Kb,
  t: Jb,
  tt: Xb,
  ttt: eS,
  tttt: tS,
  T: rS,
  TT: nS,
  TTT: iS,
  TTTT: aS,
  f: sS,
  ff: lS,
  fff: uS,
  ffff: fS,
  F: oS,
  FF: cS,
  FFF: dS,
  FFFF: hS
};
class Zt {
  static create(t, r = {}) {
    return new Zt(t, r);
  }
  static parseFormat(t) {
    let r = null, n = "", i = !1;
    const a = [];
    for (let s = 0; s < t.length; s++) {
      const o = t.charAt(s);
      o === "'" ? (n.length > 0 && a.push({ literal: i || /^\s+$/.test(n), val: n }), r = null, n = "", i = !i) : i || o === r ? n += o : (n.length > 0 && a.push({ literal: /^\s+$/.test(n), val: n }), n = o, r = o);
    }
    return n.length > 0 && a.push({ literal: i || /^\s+$/.test(n), val: n }), a;
  }
  static macroTokenToFormatOpts(t) {
    return HC[t];
  }
  constructor(t, r) {
    this.opts = r, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, r) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...r }).format();
  }
  dtFormatter(t, r = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...r });
  }
  formatDateTime(t, r) {
    return this.dtFormatter(t, r).format();
  }
  formatDateTimeParts(t, r) {
    return this.dtFormatter(t, r).formatToParts();
  }
  formatInterval(t, r) {
    return this.dtFormatter(t.start, r).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, r) {
    return this.dtFormatter(t, r).resolvedOptions();
  }
  num(t, r = 0) {
    if (this.opts.forceSimple)
      return Ct(t, r);
    const n = { ...this.opts };
    return r > 0 && (n.padTo = r), this.loc.numberFormatter(n).format(t);
  }
  formatDateTimeFromString(t, r) {
    const n = this.loc.listingMode() === "en", i = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", a = (d, h) => this.loc.extract(t, d, h), s = (d) => t.isOffsetFixed && t.offset === 0 && d.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, d.format) : "", o = () => n ? LC(t) : a({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), c = (d, h) => n ? WC(t, d) : a(h ? { month: d } : { month: d, day: "numeric" }, "month"), u = (d, h) => n ? jC(t, d) : a(
      h ? { weekday: d } : { weekday: d, month: "long", day: "numeric" },
      "weekday"
    ), f = (d) => {
      const h = Zt.macroTokenToFormatOpts(d);
      return h ? this.formatWithSystemDefault(t, h) : d;
    }, g = (d) => n ? UC(t, d) : a({ era: d }, "era"), p = (d) => {
      switch (d) {
        // ms
        case "S":
          return this.num(t.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(t.millisecond, 3);
        // seconds
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        // minutes
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        // hours
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        // offset
        case "Z":
          return s({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return s({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return s({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return t.zoneName;
        // meridiems
        case "a":
          return o();
        // dates
        case "d":
          return i ? a({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return i ? a({ day: "2-digit" }, "day") : this.num(t.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return i ? a({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return i ? a({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return c("short", !0);
        case "LLLL":
          return c("long", !0);
        case "LLLLL":
          return c("narrow", !0);
        // months - format
        case "M":
          return i ? a({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return i ? a({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return c("short", !1);
        case "MMMM":
          return c("long", !1);
        case "MMMMM":
          return c("narrow", !1);
        // years
        case "y":
          return i ? a({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return i ? a({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return i ? a({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return i ? a({ year: "numeric" }, "year") : this.num(t.year, 6);
        // eras
        case "G":
          return g("short");
        case "GG":
          return g("long");
        case "GGGGG":
          return g("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return f(d);
      }
    };
    return Tm(Zt.parseFormat(r), p);
  }
  formatDurationFromString(t, r) {
    const n = (c) => {
      switch (c[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, i = (c) => (u) => {
      const f = n(u);
      return f ? this.num(c.get(f), u.length) : u;
    }, a = Zt.parseFormat(r), s = a.reduce(
      (c, { literal: u, val: f }) => u ? c : c.concat(f),
      []
    ), o = t.shiftTo(...s.map(n).filter((c) => c));
    return Tm(a, i(o));
  }
}
const AS = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Qi(...e) {
  const t = e.reduce((r, n) => r + n.source, "");
  return RegExp(`^${t}$`);
}
function Zi(...e) {
  return (t) => e.reduce(
    ([r, n, i], a) => {
      const [s, o, c] = a(t, i);
      return [{ ...r, ...s }, o || n, c];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Yi(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [r, n] of t) {
    const i = r.exec(e);
    if (i)
      return n(i);
  }
  return [null, null];
}
function xS(...e) {
  return (t, r) => {
    const n = {};
    let i;
    for (i = 0; i < e.length; i++)
      n[e[i]] = Dn(t[r + i]);
    return [n, null, r + i];
  };
}
const FS = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, qC = `(?:${FS.source}?(?:\\[(${AS.source})\\])?)?`, ih = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, $S = RegExp(`${ih.source}${qC}`), ah = RegExp(`(?:T${$S.source})?`), zC = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, BC = /(\d{4})-?W(\d\d)(?:-?(\d))?/, GC = /(\d{4})-?(\d{3})/, QC = xS("weekYear", "weekNumber", "weekDay"), ZC = xS("year", "ordinal"), YC = /(\d{4})-(\d\d)-(\d\d)/, MS = RegExp(
  `${ih.source} ?(?:${FS.source}|(${AS.source}))?`
), KC = RegExp(`(?: ${MS.source})?`);
function ki(e, t, r) {
  const n = e[t];
  return Oe(n) ? r : Dn(n);
}
function JC(e, t) {
  return [{
    year: ki(e, t),
    month: ki(e, t + 1, 1),
    day: ki(e, t + 2, 1)
  }, null, t + 3];
}
function Ki(e, t) {
  return [{
    hours: ki(e, t, 0),
    minutes: ki(e, t + 1, 0),
    seconds: ki(e, t + 2, 0),
    milliseconds: rh(e[t + 3])
  }, null, t + 4];
}
function Ns(e, t) {
  const r = !e[t] && !e[t + 1], n = ll(e[t + 1], e[t + 2]), i = r ? null : rr.instance(n);
  return [{}, i, t + 3];
}
function Ds(e, t) {
  const r = e[t] ? vn.create(e[t]) : null;
  return [{}, r, t + 1];
}
const XC = RegExp(`^T?${ih.source}$`), eP = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function tP(e) {
  const [t, r, n, i, a, s, o, c, u] = e, f = t[0] === "-", g = c && c[0] === "-", p = (d, h = !1) => d !== void 0 && (h || d && f) ? -d : d;
  return [
    {
      years: p(Un(r)),
      months: p(Un(n)),
      weeks: p(Un(i)),
      days: p(Un(a)),
      hours: p(Un(s)),
      minutes: p(Un(o)),
      seconds: p(Un(c), c === "-0"),
      milliseconds: p(rh(u), g)
    }
  ];
}
const rP = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function sh(e, t, r, n, i, a, s) {
  const o = {
    year: t.length === 2 ? uf(Dn(t)) : Dn(t),
    month: _S.indexOf(r) + 1,
    day: Dn(n),
    hour: Dn(i),
    minute: Dn(a)
  };
  return s && (o.second = Dn(s)), e && (o.weekday = e.length > 3 ? OS.indexOf(e) + 1 : NS.indexOf(e) + 1), o;
}
const nP = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function iP(e) {
  const [
    ,
    t,
    r,
    n,
    i,
    a,
    s,
    o,
    c,
    u,
    f,
    g
  ] = e, p = sh(t, i, n, r, a, s, o);
  let d;
  return c ? d = rP[c] : u ? d = 0 : d = ll(f, g), [p, new rr(d)];
}
function aP(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const sP = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, oP = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, lP = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function _m(e) {
  const [, t, r, n, i, a, s, o] = e;
  return [sh(t, i, n, r, a, s, o), rr.utcInstance];
}
function cP(e) {
  const [, t, r, n, i, a, s, o] = e;
  return [sh(t, o, r, n, i, a, s), rr.utcInstance];
}
const uP = Qi(zC, ah), dP = Qi(BC, ah), fP = Qi(GC, ah), hP = Qi($S), LS = Zi(
  JC,
  Ki,
  Ns,
  Ds
), mP = Zi(
  QC,
  Ki,
  Ns,
  Ds
), pP = Zi(
  ZC,
  Ki,
  Ns,
  Ds
), gP = Zi(
  Ki,
  Ns,
  Ds
);
function vP(e) {
  return Yi(
    e,
    [uP, LS],
    [dP, mP],
    [fP, pP],
    [hP, gP]
  );
}
function yP(e) {
  return Yi(aP(e), [nP, iP]);
}
function bP(e) {
  return Yi(
    e,
    [sP, _m],
    [oP, _m],
    [lP, cP]
  );
}
function SP(e) {
  return Yi(e, [eP, tP]);
}
const wP = Zi(Ki);
function IP(e) {
  return Yi(e, [XC, wP]);
}
const CP = Qi(YC, KC), PP = Qi(MS), TP = Zi(
  Ki,
  Ns,
  Ds
);
function _P(e) {
  return Yi(
    e,
    [CP, LS],
    [PP, TP]
  );
}
const Em = "Invalid Duration", jS = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, EP = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...jS
}, Cr = 146097 / 400, ci = 146097 / 4800, OP = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Cr / 7,
    days: Cr,
    hours: Cr * 24,
    minutes: Cr * 24 * 60,
    seconds: Cr * 24 * 60 * 60,
    milliseconds: Cr * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Cr / 28,
    days: Cr / 4,
    hours: Cr * 24 / 4,
    minutes: Cr * 24 * 60 / 4,
    seconds: Cr * 24 * 60 * 60 / 4,
    milliseconds: Cr * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: ci / 7,
    days: ci,
    hours: ci * 24,
    minutes: ci * 24 * 60,
    seconds: ci * 24 * 60 * 60,
    milliseconds: ci * 24 * 60 * 60 * 1e3
  },
  ...jS
}, Gn = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], NP = Gn.slice(0).reverse();
function Pn(e, t, r = !1) {
  const n = {
    values: r ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new Ie(n);
}
function WS(e, t) {
  let r = t.milliseconds ?? 0;
  for (const n of NP.slice(1))
    t[n] && (r += t[n] * e[n].milliseconds);
  return r;
}
function Om(e, t) {
  const r = WS(e, t) < 0 ? -1 : 1;
  Gn.reduceRight((n, i) => {
    if (Oe(t[i]))
      return n;
    if (n) {
      const a = t[n] * r, s = e[i][n], o = Math.floor(a / s);
      t[i] += o * r, t[n] -= o * s * r;
    }
    return i;
  }, null), Gn.reduce((n, i) => {
    if (Oe(t[i]))
      return n;
    if (n) {
      const a = t[n] % 1;
      t[n] -= a, t[i] += a * e[n][i];
    }
    return i;
  }, null);
}
function DP(e) {
  const t = {};
  for (const [r, n] of Object.entries(e))
    n !== 0 && (t[r] = n);
  return t;
}
class Ie {
  /**
   * @private
   */
  constructor(t) {
    const r = t.conversionAccuracy === "longterm" || !1;
    let n = r ? OP : EP;
    t.matrix && (n = t.matrix), this.values = t.values, this.loc = t.loc || Xe.create(), this.conversionAccuracy = r ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = n, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, r) {
    return Ie.fromObject({ milliseconds: t }, r);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, r = {}) {
    if (t == null || typeof t != "object")
      throw new Qt(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new Ie({
      values: Uo(t, Ie.normalizeUnit),
      loc: Xe.fromObject(r),
      conversionAccuracy: r.conversionAccuracy,
      matrix: r.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if ($n(t))
      return Ie.fromMillis(t);
    if (Ie.isDuration(t))
      return t;
    if (typeof t == "object")
      return Ie.fromObject(t);
    throw new Qt(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, r) {
    const [n] = SP(t);
    return n ? Ie.fromObject(n, r) : Ie.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, r) {
    const [n] = IP(t);
    return n ? Ie.fromObject(n, r) : Ie.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, r = null) {
    if (!t)
      throw new Qt("need to specify a reason the Duration is invalid");
    const n = t instanceof Hr ? t : new Hr(t, r);
    if (it.throwOnInvalid)
      throw new tC(n);
    return new Ie({ invalid: n });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const r = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!r) throw new Qb(t);
    return r;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, r = {}) {
    const n = {
      ...r,
      floor: r.round !== !1 && r.floor !== !1
    };
    return this.isValid ? Zt.create(this.loc, n).formatDurationFromString(this, t) : Em;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid) return Em;
    const r = Gn.map((n) => {
      const i = this.values[n];
      return Oe(i) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: n.slice(0, -1) }).format(i);
    }).filter((n) => n);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(r);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += nh(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid) return null;
    const r = this.toMillis();
    return r < 0 || r >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, ve.fromMillis(r, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? WS(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid) return this;
    const r = Ie.fromDurationLike(t), n = {};
    for (const i of Gn)
      (Wi(r.values, i) || Wi(this.values, i)) && (n[i] = r.get(i) + this.get(i));
    return Pn(this, { values: n }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid) return this;
    const r = Ie.fromDurationLike(t);
    return this.plus(r.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid) return this;
    const r = {};
    for (const n of Object.keys(this.values))
      r[n] = TS(t(this.values[n], n));
    return Pn(this, { values: r }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[Ie.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid) return this;
    const r = { ...this.values, ...Uo(t, Ie.normalizeUnit) };
    return Pn(this, { values: r });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: r, conversionAccuracy: n, matrix: i } = {}) {
    const s = { loc: this.loc.clone({ locale: t, numberingSystem: r }), matrix: i, conversionAccuracy: n };
    return Pn(this, s);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const t = this.toObject();
    return Om(this.matrix, t), Pn(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const t = DP(this.normalize().shiftToAll().toObject());
    return Pn(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid) return this;
    if (t.length === 0)
      return this;
    t = t.map((s) => Ie.normalizeUnit(s));
    const r = {}, n = {}, i = this.toObject();
    let a;
    for (const s of Gn)
      if (t.indexOf(s) >= 0) {
        a = s;
        let o = 0;
        for (const u in n)
          o += this.matrix[u][s] * n[u], n[u] = 0;
        $n(i[s]) && (o += i[s]);
        const c = Math.trunc(o);
        r[s] = c, n[s] = (o * 1e3 - c * 1e3) / 1e3;
      } else $n(i[s]) && (n[s] = i[s]);
    for (const s in n)
      n[s] !== 0 && (r[a] += s === a ? n[s] : n[s] / this.matrix[a][s]);
    return Om(this.matrix, r), Pn(this, { values: r }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const t = {};
    for (const r of Object.keys(this.values))
      t[r] = this.values[r] === 0 ? 0 : -this.values[r];
    return Pn(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function r(n, i) {
      return n === void 0 || n === 0 ? i === void 0 || i === 0 : n === i;
    }
    for (const n of Gn)
      if (!r(this.values[n], t.values[n]))
        return !1;
    return !0;
  }
}
const ui = "Invalid Interval";
function RP(e, t) {
  return !e || !e.isValid ? ct.invalid("missing or invalid start") : !t || !t.isValid ? ct.invalid("missing or invalid end") : t < e ? ct.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class ct {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, r = null) {
    if (!t)
      throw new Qt("need to specify a reason the Interval is invalid");
    const n = t instanceof Hr ? t : new Hr(t, r);
    if (it.throwOnInvalid)
      throw new eC(n);
    return new ct({ invalid: n });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, r) {
    const n = ca(t), i = ca(r), a = RP(n, i);
    return a ?? new ct({
      start: n,
      end: i
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, r) {
    const n = Ie.fromDurationLike(r), i = ca(t);
    return ct.fromDateTimes(i, i.plus(n));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, r) {
    const n = Ie.fromDurationLike(r), i = ca(t);
    return ct.fromDateTimes(i.minus(n), i);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, r) {
    const [n, i] = (t || "").split("/", 2);
    if (n && i) {
      let a, s;
      try {
        a = ve.fromISO(n, r), s = a.isValid;
      } catch {
        s = !1;
      }
      let o, c;
      try {
        o = ve.fromISO(i, r), c = o.isValid;
      } catch {
        c = !1;
      }
      if (s && c)
        return ct.fromDateTimes(a, o);
      if (s) {
        const u = Ie.fromISO(i, r);
        if (u.isValid)
          return ct.after(a, u);
      } else if (c) {
        const u = Ie.fromISO(n, r);
        if (u.isValid)
          return ct.before(o, u);
      }
    }
    return ct.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", r) {
    if (!this.isValid) return NaN;
    const n = this.start.startOf(t, r);
    let i;
    return r?.useLocaleWeeks ? i = this.end.reconfigure({ locale: n.locale }) : i = this.end, i = i.startOf(t, r), Math.floor(i.diff(n, t).get(t)) + (i.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: r } = {}) {
    return this.isValid ? ct.fromDateTimes(t || this.s, r || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid) return [];
    const r = t.map(ca).filter((s) => this.contains(s)).sort((s, o) => s.toMillis() - o.toMillis()), n = [];
    let { s: i } = this, a = 0;
    for (; i < this.e; ) {
      const s = r[a] || this.e, o = +s > +this.e ? this.e : s;
      n.push(ct.fromDateTimes(i, o)), i = o, a += 1;
    }
    return n;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const r = Ie.fromDurationLike(t);
    if (!this.isValid || !r.isValid || r.as("milliseconds") === 0)
      return [];
    let { s: n } = this, i = 1, a;
    const s = [];
    for (; n < this.e; ) {
      const o = this.start.plus(r.mapUnits((c) => c * i));
      a = +o > +this.e ? this.e : o, s.push(ct.fromDateTimes(n, a)), n = a, i += 1;
    }
    return s;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid) return this;
    const r = this.s > t.s ? this.s : t.s, n = this.e < t.e ? this.e : t.e;
    return r >= n ? null : ct.fromDateTimes(r, n);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid) return this;
    const r = this.s < t.s ? this.s : t.s, n = this.e > t.e ? this.e : t.e;
    return ct.fromDateTimes(r, n);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [r, n] = t.sort((i, a) => i.s - a.s).reduce(
      ([i, a], s) => a ? a.overlaps(s) || a.abutsStart(s) ? [i, a.union(s)] : [i.concat([a]), s] : [i, s],
      [[], null]
    );
    return n && r.push(n), r;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let r = null, n = 0;
    const i = [], a = t.map((c) => [
      { time: c.s, type: "s" },
      { time: c.e, type: "e" }
    ]), s = Array.prototype.concat(...a), o = s.sort((c, u) => c.time - u.time);
    for (const c of o)
      n += c.type === "s" ? 1 : -1, n === 1 ? r = c.time : (r && +r != +c.time && i.push(ct.fromDateTimes(r, c.time)), r = null);
    return ct.merge(i);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return ct.xor([this].concat(t)).map((r) => this.intersection(r)).filter((r) => r && !r.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : ui;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = Lo, r = {}) {
    return this.isValid ? Zt.create(this.s.loc.clone(r), t).formatInterval(this) : ui;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : ui;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : ui;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : ui;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: r = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${r}${this.e.toFormat(t)}` : ui;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, r) {
    return this.isValid ? this.e.diff(this.s, t, r) : Ie.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return ct.fromDateTimes(t(this.s), t(this.e));
  }
}
class Bs {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = it.defaultZone) {
    const r = ve.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && r.offset !== r.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return vn.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return kn(t, it.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: r = null } = {}) {
    return (r || Xe.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: r = null } = {}) {
    return (r || Xe.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: r = null } = {}) {
    return (r || Xe.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: r = null, numberingSystem: n = null, locObj: i = null, outputCalendar: a = "gregory" } = {}) {
    return (i || Xe.create(r, n, a)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: r = null, numberingSystem: n = null, locObj: i = null, outputCalendar: a = "gregory" } = {}) {
    return (i || Xe.create(r, n, a)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: r = null, numberingSystem: n = null, locObj: i = null } = {}) {
    return (i || Xe.create(r, n, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: r = null, numberingSystem: n = null, locObj: i = null } = {}) {
    return (i || Xe.create(r, n, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return Xe.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: r = null } = {}) {
    return Xe.create(r, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: IS(), localeWeek: CS() };
  }
}
function Nm(e, t) {
  const r = (i) => i.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), n = r(t) - r(e);
  return Math.floor(Ie.fromMillis(n).as("days"));
}
function kP(e, t, r) {
  const n = [
    ["years", (c, u) => u.year - c.year],
    ["quarters", (c, u) => u.quarter - c.quarter + (u.year - c.year) * 4],
    ["months", (c, u) => u.month - c.month + (u.year - c.year) * 12],
    [
      "weeks",
      (c, u) => {
        const f = Nm(c, u);
        return (f - f % 7) / 7;
      }
    ],
    ["days", Nm]
  ], i = {}, a = e;
  let s, o;
  for (const [c, u] of n)
    r.indexOf(c) >= 0 && (s = c, i[c] = u(e, t), o = a.plus(i), o > t ? (i[c]--, e = a.plus(i), e > t && (o = e, i[c]--, e = a.plus(i))) : e = o);
  return [e, i, o, s];
}
function AP(e, t, r, n) {
  let [i, a, s, o] = kP(e, t, r);
  const c = t - i, u = r.filter(
    (g) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(g) >= 0
  );
  u.length === 0 && (s < t && (s = i.plus({ [o]: 1 })), s !== i && (a[o] = (a[o] || 0) + c / (s - i)));
  const f = Ie.fromObject(a, n);
  return u.length > 0 ? Ie.fromMillis(c, n).shiftTo(...u).plus(f) : f;
}
const xP = "missing Intl.DateTimeFormat.formatToParts support";
function Ge(e, t = (r) => r) {
  return { regex: e, deser: ([r]) => t(CC(r)) };
}
const FP = " ", US = `[ ${FP}]`, VS = new RegExp(US, "g");
function $P(e) {
  return e.replace(/\./g, "\\.?").replace(VS, US);
}
function Dm(e) {
  return e.replace(/\./g, "").replace(VS, " ").toLowerCase();
}
function Fr(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map($P).join("|")),
    deser: ([r]) => e.findIndex((n) => Dm(r) === Dm(n)) + t
  };
}
function Rm(e, t) {
  return { regex: e, deser: ([, r, n]) => ll(r, n), groups: t };
}
function Gs(e) {
  return { regex: e, deser: ([t]) => t };
}
function MP(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function LP(e, t) {
  const r = xr(t), n = xr(t, "{2}"), i = xr(t, "{3}"), a = xr(t, "{4}"), s = xr(t, "{6}"), o = xr(t, "{1,2}"), c = xr(t, "{1,3}"), u = xr(t, "{1,6}"), f = xr(t, "{1,9}"), g = xr(t, "{2,4}"), p = xr(t, "{4,6}"), d = (b) => ({ regex: RegExp(MP(b.val)), deser: ([m]) => m, literal: !0 }), v = ((b) => {
    if (e.literal)
      return d(b);
    switch (b.val) {
      // era
      case "G":
        return Fr(t.eras("short"), 0);
      case "GG":
        return Fr(t.eras("long"), 0);
      // years
      case "y":
        return Ge(u);
      case "yy":
        return Ge(g, uf);
      case "yyyy":
        return Ge(a);
      case "yyyyy":
        return Ge(p);
      case "yyyyyy":
        return Ge(s);
      // months
      case "M":
        return Ge(o);
      case "MM":
        return Ge(n);
      case "MMM":
        return Fr(t.months("short", !0), 1);
      case "MMMM":
        return Fr(t.months("long", !0), 1);
      case "L":
        return Ge(o);
      case "LL":
        return Ge(n);
      case "LLL":
        return Fr(t.months("short", !1), 1);
      case "LLLL":
        return Fr(t.months("long", !1), 1);
      // dates
      case "d":
        return Ge(o);
      case "dd":
        return Ge(n);
      // ordinals
      case "o":
        return Ge(c);
      case "ooo":
        return Ge(i);
      // time
      case "HH":
        return Ge(n);
      case "H":
        return Ge(o);
      case "hh":
        return Ge(n);
      case "h":
        return Ge(o);
      case "mm":
        return Ge(n);
      case "m":
        return Ge(o);
      case "q":
        return Ge(o);
      case "qq":
        return Ge(n);
      case "s":
        return Ge(o);
      case "ss":
        return Ge(n);
      case "S":
        return Ge(c);
      case "SSS":
        return Ge(i);
      case "u":
        return Gs(f);
      case "uu":
        return Gs(o);
      case "uuu":
        return Ge(r);
      // meridiem
      case "a":
        return Fr(t.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return Ge(a);
      case "kk":
        return Ge(g, uf);
      // weekNumber (W)
      case "W":
        return Ge(o);
      case "WW":
        return Ge(n);
      // weekdays
      case "E":
      case "c":
        return Ge(r);
      case "EEE":
        return Fr(t.weekdays("short", !1), 1);
      case "EEEE":
        return Fr(t.weekdays("long", !1), 1);
      case "ccc":
        return Fr(t.weekdays("short", !0), 1);
      case "cccc":
        return Fr(t.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Rm(new RegExp(`([+-]${o.source})(?::(${n.source}))?`), 2);
      case "ZZZ":
        return Rm(new RegExp(`([+-]${o.source})(${n.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return Gs(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return Gs(/[^\S\n\r]/);
      default:
        return d(b);
    }
  })(e) || {
    invalidReason: xP
  };
  return v.token = e, v;
}
const jP = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function WP(e, t, r) {
  const { type: n, value: i } = e;
  if (n === "literal") {
    const c = /^\s+$/.test(i);
    return {
      literal: !c,
      val: c ? " " : i
    };
  }
  const a = t[n];
  let s = n;
  n === "hour" && (t.hour12 != null ? s = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? s = "hour12" : s = "hour24" : s = r.hour12 ? "hour12" : "hour24");
  let o = jP[s];
  if (typeof o == "object" && (o = o[a]), o)
    return {
      literal: !1,
      val: o
    };
}
function UP(e) {
  return [`^${e.map((r) => r.regex).reduce((r, n) => `${r}(${n.source})`, "")}$`, e];
}
function VP(e, t, r) {
  const n = e.match(t);
  if (n) {
    const i = {};
    let a = 1;
    for (const s in r)
      if (Wi(r, s)) {
        const o = r[s], c = o.groups ? o.groups + 1 : 1;
        !o.literal && o.token && (i[o.token.val[0]] = o.deser(n.slice(a, a + c))), a += c;
      }
    return [n, i];
  } else
    return [n, {}];
}
function HP(e) {
  const t = (a) => {
    switch (a) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let r = null, n;
  return Oe(e.z) || (r = vn.create(e.z)), Oe(e.Z) || (r || (r = new rr(e.Z)), n = e.Z), Oe(e.q) || (e.M = (e.q - 1) * 3 + 1), Oe(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Oe(e.u) || (e.S = rh(e.u)), [Object.keys(e).reduce((a, s) => {
    const o = t(s);
    return o && (a[o] = e[s]), a;
  }, {}), r, n];
}
let jl = null;
function qP() {
  return jl || (jl = ve.fromMillis(1555555555555)), jl;
}
function zP(e, t) {
  if (e.literal)
    return e;
  const r = Zt.macroTokenToFormatOpts(e.val), n = BS(r, t);
  return n == null || n.includes(void 0) ? e : n;
}
function HS(e, t) {
  return Array.prototype.concat(...e.map((r) => zP(r, t)));
}
class qS {
  constructor(t, r) {
    if (this.locale = t, this.format = r, this.tokens = HS(Zt.parseFormat(r), t), this.units = this.tokens.map((n) => LP(n, t)), this.disqualifyingUnit = this.units.find((n) => n.invalidReason), !this.disqualifyingUnit) {
      const [n, i] = UP(this.units);
      this.regex = RegExp(n, "i"), this.handlers = i;
    }
  }
  explainFromTokens(t) {
    if (this.isValid) {
      const [r, n] = VP(t, this.regex, this.handlers), [i, a, s] = n ? HP(n) : [null, null, void 0];
      if (Wi(n, "a") && Wi(n, "H"))
        throw new Ei(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: t,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: r,
        matches: n,
        result: i,
        zone: a,
        specificOffset: s
      };
    } else
      return { input: t, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function zS(e, t, r) {
  return new qS(e, r).explainFromTokens(t);
}
function BP(e, t, r) {
  const { result: n, zone: i, specificOffset: a, invalidReason: s } = zS(e, t, r);
  return [n, i, a, s];
}
function BS(e, t) {
  if (!e)
    return null;
  const n = Zt.create(t, e).dtFormatter(qP()), i = n.formatToParts(), a = n.resolvedOptions();
  return i.map((s) => WP(s, e, a));
}
const Wl = "Invalid DateTime", GP = 864e13;
function Da(e) {
  return new Hr("unsupported zone", `the zone "${e.name}" is not supported`);
}
function Ul(e) {
  return e.weekData === null && (e.weekData = jo(e.c)), e.weekData;
}
function Vl(e) {
  return e.localWeekData === null && (e.localWeekData = jo(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function Vn(e, t) {
  const r = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new ve({ ...r, ...t, old: r });
}
function GS(e, t, r) {
  let n = e - t * 60 * 1e3;
  const i = r.offset(n);
  if (t === i)
    return [n, t];
  n -= (i - t) * 60 * 1e3;
  const a = r.offset(n);
  return i === a ? [n, i] : [e - Math.min(i, a) * 60 * 1e3, Math.max(i, a)];
}
function Qs(e, t) {
  e += t * 60 * 1e3;
  const r = new Date(e);
  return {
    year: r.getUTCFullYear(),
    month: r.getUTCMonth() + 1,
    day: r.getUTCDate(),
    hour: r.getUTCHours(),
    minute: r.getUTCMinutes(),
    second: r.getUTCSeconds(),
    millisecond: r.getUTCMilliseconds()
  };
}
function No(e, t, r) {
  return GS(ol(e), t, r);
}
function km(e, t) {
  const r = e.o, n = e.c.year + Math.trunc(t.years), i = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, a = {
    ...e.c,
    year: n,
    month: i,
    day: Math.min(e.c.day, Wo(n, i)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, s = Ie.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), o = ol(a);
  let [c, u] = GS(o, r, e.zone);
  return s !== 0 && (c += s, u = e.zone.offset(c)), { ts: c, o: u };
}
function di(e, t, r, n, i, a) {
  const { setZone: s, zone: o } = r;
  if (e && Object.keys(e).length !== 0 || t) {
    const c = t || o, u = ve.fromObject(e, {
      ...r,
      zone: c,
      specificOffset: a
    });
    return s ? u : u.setZone(o);
  } else
    return ve.invalid(
      new Hr("unparsable", `the input "${i}" can't be parsed as ${n}`)
    );
}
function Zs(e, t, r = !0) {
  return e.isValid ? Zt.create(Xe.create("en-US"), {
    allowZ: r,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function Hl(e, t) {
  const r = e.c.year > 9999 || e.c.year < 0;
  let n = "";
  return r && e.c.year >= 0 && (n += "+"), n += Ct(e.c.year, r ? 6 : 4), t ? (n += "-", n += Ct(e.c.month), n += "-", n += Ct(e.c.day)) : (n += Ct(e.c.month), n += Ct(e.c.day)), n;
}
function Am(e, t, r, n, i, a) {
  let s = Ct(e.c.hour);
  return t ? (s += ":", s += Ct(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !r) && (s += ":")) : s += Ct(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !r) && (s += Ct(e.c.second), (e.c.millisecond !== 0 || !n) && (s += ".", s += Ct(e.c.millisecond, 3))), i && (e.isOffsetFixed && e.offset === 0 && !a ? s += "Z" : e.o < 0 ? (s += "-", s += Ct(Math.trunc(-e.o / 60)), s += ":", s += Ct(Math.trunc(-e.o % 60))) : (s += "+", s += Ct(Math.trunc(e.o / 60)), s += ":", s += Ct(Math.trunc(e.o % 60)))), a && (s += "[" + e.zone.ianaName + "]"), s;
}
const QS = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, QP = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ZP = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ZS = ["year", "month", "day", "hour", "minute", "second", "millisecond"], YP = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], KP = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function JP(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t) throw new Qb(e);
  return t;
}
function xm(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return JP(e);
  }
}
function XP(e) {
  if (Ra === void 0 && (Ra = it.now()), e.type !== "iana")
    return e.offset(Ra);
  const t = e.name;
  let r = df.get(t);
  return r === void 0 && (r = e.offset(Ra), df.set(t, r)), r;
}
function Fm(e, t) {
  const r = kn(t.zone, it.defaultZone);
  if (!r.isValid)
    return ve.invalid(Da(r));
  const n = Xe.fromObject(t);
  let i, a;
  if (Oe(e.year))
    i = it.now();
  else {
    for (const c of ZS)
      Oe(e[c]) && (e[c] = QS[c]);
    const s = SS(e) || wS(e);
    if (s)
      return ve.invalid(s);
    const o = XP(r);
    [i, a] = No(e, o, r);
  }
  return new ve({ ts: i, zone: r, loc: n, o: a });
}
function $m(e, t, r) {
  const n = Oe(r.round) ? !0 : r.round, i = (s, o) => (s = nh(s, n || r.calendary ? 0 : 2, !0), t.loc.clone(r).relFormatter(r).format(s, o)), a = (s) => r.calendary ? t.hasSame(e, s) ? 0 : t.startOf(s).diff(e.startOf(s), s).get(s) : t.diff(e, s).get(s);
  if (r.unit)
    return i(a(r.unit), r.unit);
  for (const s of r.units) {
    const o = a(s);
    if (Math.abs(o) >= 1)
      return i(o, s);
  }
  return i(e > t ? -0 : 0, r.units[r.units.length - 1]);
}
function Mm(e) {
  let t = {}, r;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], r = Array.from(e).slice(0, e.length - 1)) : r = Array.from(e), [t, r];
}
let Ra;
const df = /* @__PURE__ */ new Map();
class ve {
  /**
   * @access private
   */
  constructor(t) {
    const r = t.zone || it.defaultZone;
    let n = t.invalid || (Number.isNaN(t.ts) ? new Hr("invalid input") : null) || (r.isValid ? null : Da(r));
    this.ts = Oe(t.ts) ? it.now() : t.ts;
    let i = null, a = null;
    if (!n)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(r))
        [i, a] = [t.old.c, t.old.o];
      else {
        const o = $n(t.o) && !t.old ? t.o : r.offset(this.ts);
        i = Qs(this.ts, o), n = Number.isNaN(i.year) ? new Hr("invalid input") : null, i = n ? null : i, a = n ? null : o;
      }
    this._zone = r, this.loc = t.loc || Xe.create(), this.invalid = n, this.weekData = null, this.localWeekData = null, this.c = i, this.o = a, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new ve({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, r] = Mm(arguments), [n, i, a, s, o, c, u] = r;
    return Fm({ year: n, month: i, day: a, hour: s, minute: o, second: c, millisecond: u }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, r] = Mm(arguments), [n, i, a, s, o, c, u] = r;
    return t.zone = rr.utcInstance, Fm({ year: n, month: i, day: a, hour: s, minute: o, second: c, millisecond: u }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, r = {}) {
    const n = OC(t) ? t.valueOf() : NaN;
    if (Number.isNaN(n))
      return ve.invalid("invalid input");
    const i = kn(r.zone, it.defaultZone);
    return i.isValid ? new ve({
      ts: n,
      zone: i,
      loc: Xe.fromObject(r)
    }) : ve.invalid(Da(i));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, r = {}) {
    if ($n(t))
      return t < -864e13 || t > GP ? ve.invalid("Timestamp out of range") : new ve({
        ts: t,
        zone: kn(r.zone, it.defaultZone),
        loc: Xe.fromObject(r)
      });
    throw new Qt(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, r = {}) {
    if ($n(t))
      return new ve({
        ts: t * 1e3,
        zone: kn(r.zone, it.defaultZone),
        loc: Xe.fromObject(r)
      });
    throw new Qt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, r = {}) {
    t = t || {};
    const n = kn(r.zone, it.defaultZone);
    if (!n.isValid)
      return ve.invalid(Da(n));
    const i = Xe.fromObject(r), a = Uo(t, xm), { minDaysInFirstWeek: s, startOfWeek: o } = Im(a, i), c = it.now(), u = Oe(r.specificOffset) ? n.offset(c) : r.specificOffset, f = !Oe(a.ordinal), g = !Oe(a.year), p = !Oe(a.month) || !Oe(a.day), d = g || p, h = a.weekYear || a.weekNumber;
    if ((d || f) && h)
      throw new Ei(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (p && f)
      throw new Ei("Can't mix ordinal dates with month/day");
    const v = h || a.weekday && !d;
    let b, m, S = Qs(c, u);
    v ? (b = YP, m = QP, S = jo(S, s, o)) : f ? (b = KP, m = ZP, S = Ll(S)) : (b = ZS, m = QS);
    let I = !1;
    for (const P of b) {
      const _ = a[P];
      Oe(_) ? I ? a[P] = m[P] : a[P] = S[P] : I = !0;
    }
    const C = v ? TC(a, s, o) : f ? _C(a) : SS(a), T = C || wS(a);
    if (T)
      return ve.invalid(T);
    const E = v ? Sm(a, s, o) : f ? wm(a) : a, [N, y] = No(E, u, n), w = new ve({
      ts: N,
      zone: n,
      o: y,
      loc: i
    });
    return a.weekday && d && t.weekday !== w.weekday ? ve.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${a.weekday} and a date of ${w.toISO()}`
    ) : w.isValid ? w : ve.invalid(w.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, r = {}) {
    const [n, i] = vP(t);
    return di(n, i, r, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, r = {}) {
    const [n, i] = yP(t);
    return di(n, i, r, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, r = {}) {
    const [n, i] = bP(t);
    return di(n, i, r, "HTTP", r);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, r, n = {}) {
    if (Oe(t) || Oe(r))
      throw new Qt("fromFormat requires an input string and a format");
    const { locale: i = null, numberingSystem: a = null } = n, s = Xe.fromOpts({
      locale: i,
      numberingSystem: a,
      defaultToEN: !0
    }), [o, c, u, f] = BP(s, t, r);
    return f ? ve.invalid(f) : di(o, c, n, `format ${r}`, t, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, r, n = {}) {
    return ve.fromFormat(t, r, n);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, r = {}) {
    const [n, i] = _P(t);
    return di(n, i, r, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, r = null) {
    if (!t)
      throw new Qt("need to specify a reason the DateTime is invalid");
    const n = t instanceof Hr ? t : new Hr(t, r);
    if (it.throwOnInvalid)
      throw new X0(n);
    return new ve({ invalid: n });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, r = {}) {
    const n = BS(t, Xe.fromObject(r));
    return n ? n.map((i) => i ? i.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, r = {}) {
    return HS(Zt.parseFormat(t), Xe.fromObject(r)).map((i) => i.val).join("");
  }
  static resetCache() {
    Ra = void 0, df.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Ul(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Ul(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Ul(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Vl(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Vl(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Vl(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Ll(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Bs.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Bs.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Bs.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Bs.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, r = 6e4, n = ol(this.c), i = this.zone.offset(n - t), a = this.zone.offset(n + t), s = this.zone.offset(n - i * r), o = this.zone.offset(n - a * r);
    if (s === o)
      return [this];
    const c = n - s * r, u = n - o * r, f = Qs(c, s), g = Qs(u, o);
    return f.hour === g.hour && f.minute === g.minute && f.second === g.second && f.millisecond === g.millisecond ? [Vn(this, { ts: c }), Vn(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Os(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Wo(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Ri(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Za(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? Za(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: r, numberingSystem: n, calendar: i } = Zt.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: r, numberingSystem: n, outputCalendar: i };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, r = {}) {
    return this.setZone(rr.instance(t), r);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(it.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: r = !1, keepCalendarTime: n = !1 } = {}) {
    if (t = kn(t, it.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let i = this.ts;
      if (r || n) {
        const a = t.offset(this.ts), s = this.toObject();
        [i] = No(s, a, t);
      }
      return Vn(this, { ts: i, zone: t });
    } else
      return ve.invalid(Da(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: r, outputCalendar: n } = {}) {
    const i = this.loc.clone({ locale: t, numberingSystem: r, outputCalendar: n });
    return Vn(this, { loc: i });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid) return this;
    const r = Uo(t, xm), { minDaysInFirstWeek: n, startOfWeek: i } = Im(r, this.loc), a = !Oe(r.weekYear) || !Oe(r.weekNumber) || !Oe(r.weekday), s = !Oe(r.ordinal), o = !Oe(r.year), c = !Oe(r.month) || !Oe(r.day), u = o || c, f = r.weekYear || r.weekNumber;
    if ((u || s) && f)
      throw new Ei(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (c && s)
      throw new Ei("Can't mix ordinal dates with month/day");
    let g;
    a ? g = Sm(
      { ...jo(this.c, n, i), ...r },
      n,
      i
    ) : Oe(r.ordinal) ? (g = { ...this.toObject(), ...r }, Oe(r.day) && (g.day = Math.min(Wo(g.year, g.month), g.day))) : g = wm({ ...Ll(this.c), ...r });
    const [p, d] = No(g, this.o, this.zone);
    return Vn(this, { ts: p, o: d });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid) return this;
    const r = Ie.fromDurationLike(t);
    return Vn(this, km(this, r));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid) return this;
    const r = Ie.fromDurationLike(t).negate();
    return Vn(this, km(this, r));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: r = !1 } = {}) {
    if (!this.isValid) return this;
    const n = {}, i = Ie.normalizeUnit(t);
    switch (i) {
      case "years":
        n.month = 1;
      // falls through
      case "quarters":
      case "months":
        n.day = 1;
      // falls through
      case "weeks":
      case "days":
        n.hour = 0;
      // falls through
      case "hours":
        n.minute = 0;
      // falls through
      case "minutes":
        n.second = 0;
      // falls through
      case "seconds":
        n.millisecond = 0;
        break;
    }
    if (i === "weeks")
      if (r) {
        const a = this.loc.getStartOfWeek(), { weekday: s } = this;
        s < a && (n.weekNumber = this.weekNumber - 1), n.weekday = a;
      } else
        n.weekday = 1;
    if (i === "quarters") {
      const a = Math.ceil(this.month / 3);
      n.month = (a - 1) * 3 + 1;
    }
    return this.set(n);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, r) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, r).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, r = {}) {
    return this.isValid ? Zt.create(this.loc.redefaultToEN(r)).formatDateTimeFromString(this, t) : Wl;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = Lo, r = {}) {
    return this.isValid ? Zt.create(this.loc.clone(r), t).formatDateTime(this) : Wl;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? Zt.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string|null}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: r = !1,
    suppressMilliseconds: n = !1,
    includeOffset: i = !0,
    extendedZone: a = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const s = t === "extended";
    let o = Hl(this, s);
    return o += "T", o += Am(this, s, r, n, i, a), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string|null}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? Hl(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Zs(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: r = !1,
    includeOffset: n = !0,
    includePrefix: i = !1,
    extendedZone: a = !1,
    format: s = "extended"
  } = {}) {
    return this.isValid ? (i ? "T" : "") + Am(
      this,
      s === "extended",
      r,
      t,
      n,
      a
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Zs(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Zs(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? Hl(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: r = !1, includeOffsetSpace: n = !0 } = {}) {
    let i = "HH:mm:ss.SSS";
    return (r || t) && (n && (i += " "), r ? i += "z" : t && (i += "ZZ")), Zs(this, i, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Wl;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid) return {};
    const r = { ...this.c };
    return t.includeConfig && (r.outputCalendar = this.outputCalendar, r.numberingSystem = this.loc.numberingSystem, r.locale = this.loc.locale), r;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, r = "milliseconds", n = {}) {
    if (!this.isValid || !t.isValid)
      return Ie.invalid("created by diffing an invalid DateTime");
    const i = { locale: this.locale, numberingSystem: this.numberingSystem, ...n }, a = NC(r).map(Ie.normalizeUnit), s = t.valueOf() > this.valueOf(), o = s ? this : t, c = s ? t : this, u = AP(o, c, a, i);
    return s ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", r = {}) {
    return this.diff(ve.now(), t, r);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(t) {
    return this.isValid ? ct.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, r, n) {
    if (!this.isValid) return !1;
    const i = t.valueOf(), a = this.setZone(t.zone, { keepLocalTime: !0 });
    return a.startOf(r, n) <= i && i <= a.endOf(r, n);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid) return null;
    const r = t.base || ve.fromObject({}, { zone: this.zone }), n = t.padding ? this < r ? -t.padding : t.padding : 0;
    let i = ["years", "months", "days", "hours", "minutes", "seconds"], a = t.unit;
    return Array.isArray(t.unit) && (i = t.unit, a = void 0), $m(r, this.plus(n), {
      ...t,
      numeric: "always",
      units: i,
      unit: a
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? $m(t.base || ve.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(ve.isDateTime))
      throw new Qt("min requires all arguments be DateTimes");
    return Cm(t, (r) => r.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(ve.isDateTime))
      throw new Qt("max requires all arguments be DateTimes");
    return Cm(t, (r) => r.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, r, n = {}) {
    const { locale: i = null, numberingSystem: a = null } = n, s = Xe.fromOpts({
      locale: i,
      numberingSystem: a,
      defaultToEN: !0
    });
    return zS(s, t, r);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, r, n = {}) {
    return ve.fromFormatExplain(t, r, n);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(t, r = {}) {
    const { locale: n = null, numberingSystem: i = null } = r, a = Xe.fromOpts({
      locale: n,
      numberingSystem: i,
      defaultToEN: !0
    });
    return new qS(a, t);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(t, r, n = {}) {
    if (Oe(t) || Oe(r))
      throw new Qt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: i = null, numberingSystem: a = null } = n, s = Xe.fromOpts({
      locale: i,
      numberingSystem: a,
      defaultToEN: !0
    });
    if (!s.equals(r.locale))
      throw new Qt(
        `fromFormatParser called with a locale of ${s}, but the format parser was created for ${r.locale}`
      );
    const { result: o, zone: c, specificOffset: u, invalidReason: f } = r.explainFromTokens(t);
    return f ? ve.invalid(f) : di(
      o,
      c,
      n,
      `format ${r.format}`,
      t,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Lo;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Zb;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return rC;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Yb;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return Kb;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Jb;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Xb;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return eS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return tS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return rS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return nS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return iS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return aS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return sS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return oS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return lS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return cS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return nC;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return uS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return dS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return fS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return hS;
  }
}
function ca(e) {
  if (ve.isDateTime(e))
    return e;
  if (e && e.valueOf && $n(e.valueOf()))
    return ve.fromJSDate(e);
  if (e && typeof e == "object")
    return ve.fromObject(e);
  throw new Qt(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const Ln = new Intl.Locale(navigator.languages[0]), ul = () => {
  const e = new Headers();
  return e.append("Content-Type", "application/json; charset=utf-8"), e;
}, ft = async ({
  url: e,
  body: t,
  throwOnError: r = !0
}) => {
  const n = await fetch(e, {
    credentials: "include",
    method: "POST",
    body: t && JSON.stringify(t),
    headers: ul()
  });
  if (!n.ok && r) {
    const a = new Error("An error occurred while saving the data.");
    throw a.info = await n.json(), a.status = n.status, a;
  }
  return await n.json();
}, YS = ({
  organizationId: e,
  action: t,
  preview: r
}) => {
  const n = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${t}${r ? "/preview" : ""}` : null;
  return $(
    async (a) => n ? await ft({
      url: n,
      body: {
        organizationId: e,
        // Url set means organizationId is set
        hologramSimIds: a
      }
    }) : void 0,
    [e, n]
  );
}, eT = ({
  organizationId: e,
  action: t,
  sims: r
}) => {
  const [n, i] = Z(), [a, s] = Z(), [o, c] = Z(!1), u = YS({ organizationId: e, action: t, preview: !0 });
  return Pe(() => {
    const g = async (p) => {
      let d;
      try {
        d = await u(p), i(d), s(void 0);
      } catch (h) {
        typeof h == "string" ? (s(h), i(void 0)) : (s(`Unknown error occurred: ${h}`), i(void 0), console.error(h));
      }
      c(!1);
    };
    !n && !o && !a && (r && r.size && r.size > 0 && e ? (c(!0), s(void 0), g([...r.keys()])) : s("Please select SIMs to take actions..."));
  }, [u, n, a, o, e, r]), {
    bulkStateResponse: V(() => n ?? {}, [n]),
    error: a,
    isLoading: o
  };
}, tT = () => $(async (t, r, n = !1) => {
  const i = new URLSearchParams({ rememberme: n ? "1" : "0" }), a = `${process.env.VITE_API_ROOT}/auth/session/?${i}`;
  return await ft({
    url: a,
    body: { email: t, password: r }
  });
}, []), rT = () => {
  const e = `${process.env.VITE_API_ROOT}/auth/totp/authenticate`;
  return $(
    async (r, n, i, a = !1) => !r || !n ? void 0 : await ft({
      url: e,
      body: { email: r, methodId: n, totpCode: i, rememberme: a }
    }),
    [e]
  );
}, Ze = async (e) => {
  const t = await fetch(e, {
    credentials: "include",
    method: "GET",
    headers: ul()
  });
  if (!t.ok) {
    const n = new Error("An error occurred while fetching the data.");
    throw n.info = await t.json(), n.status = t.status, n;
  }
  return await t.json();
};
var Ys = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ji(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ks = { exports: {} }, ql = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lm;
function nT() {
  if (Lm) return ql;
  Lm = 1;
  var e = _t;
  function t(g, p) {
    return g === p && (g !== 0 || 1 / g === 1 / p) || g !== g && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, i = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function o(g, p) {
    var d = p(), h = n({ inst: { value: d, getSnapshot: p } }), v = h[0].inst, b = h[1];
    return a(
      function() {
        v.value = d, v.getSnapshot = p, c(v) && b({ inst: v });
      },
      [g, d, p]
    ), i(
      function() {
        return c(v) && b({ inst: v }), g(function() {
          c(v) && b({ inst: v });
        });
      },
      [g]
    ), s(d), d;
  }
  function c(g) {
    var p = g.getSnapshot;
    g = g.value;
    try {
      var d = p();
      return !r(g, d);
    } catch {
      return !0;
    }
  }
  function u(g, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : o;
  return ql.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, ql;
}
var zl = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jm;
function iT() {
  return jm || (jm = 1, process.env.NODE_ENV !== "production" && function() {
    function e(d, h) {
      return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
    }
    function t(d, h) {
      f || i.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = h();
      if (!g) {
        var b = h();
        a(v, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), g = !0);
      }
      b = s({
        inst: { value: v, getSnapshot: h }
      });
      var m = b[0].inst, S = b[1];
      return c(
        function() {
          m.value = v, m.getSnapshot = h, r(m) && S({ inst: m });
        },
        [d, v, h]
      ), o(
        function() {
          return r(m) && S({ inst: m }), d(function() {
            r(m) && S({ inst: m });
          });
        },
        [d]
      ), u(v), v;
    }
    function r(d) {
      var h = d.getSnapshot;
      d = d.value;
      try {
        var v = h();
        return !a(d, v);
      } catch {
        return !0;
      }
    }
    function n(d, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = _t, a = typeof Object.is == "function" ? Object.is : e, s = i.useState, o = i.useEffect, c = i.useLayoutEffect, u = i.useDebugValue, f = !1, g = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    zl.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), zl;
}
var Wm;
function aT() {
  return Wm || (Wm = 1, process.env.NODE_ENV === "production" ? Ks.exports = nT() : Ks.exports = iT()), Ks.exports;
}
var oh = aT();
const KS = 0, JS = 1, XS = 2, Um = 3;
var Vm = Object.prototype.hasOwnProperty;
function ff(e, t) {
  var r, n;
  if (e === t) return !0;
  if (e && t && (r = e.constructor) === t.constructor) {
    if (r === Date) return e.getTime() === t.getTime();
    if (r === RegExp) return e.toString() === t.toString();
    if (r === Array) {
      if ((n = e.length) === t.length)
        for (; n-- && ff(e[n], t[n]); ) ;
      return n === -1;
    }
    if (!r || typeof e == "object") {
      n = 0;
      for (r in e)
        if (Vm.call(e, r) && ++n && !Vm.call(t, r) || !(r in t) || !ff(e[r], t[r])) return !1;
      return Object.keys(t).length === n;
    }
  }
  return e !== e && t !== t;
}
const Jr = /* @__PURE__ */ new WeakMap(), xn = () => {
}, Nt = (
  /*#__NOINLINE__*/
  xn()
), Vo = Object, Fe = (e) => e === Nt, Or = (e) => typeof e == "function", yn = (e, t) => ({
  ...e,
  ...t
}), ew = (e) => Or(e.then), Bl = {}, Js = {}, lh = "undefined", Rs = typeof window != lh, hf = typeof document != lh, sT = Rs && "Deno" in window, oT = () => Rs && typeof window.requestAnimationFrame != lh, Rn = (e, t) => {
  const r = Jr.get(e);
  return [
    // Getter
    () => !Fe(t) && e.get(t) || Bl,
    // Setter
    (n) => {
      if (!Fe(t)) {
        const i = e.get(t);
        t in Js || (Js[t] = i), r[5](t, yn(i, n), i || Bl);
      }
    },
    // Subscriber
    r[6],
    // Get server cache snapshot
    () => !Fe(t) && t in Js ? Js[t] : !Fe(t) && e.get(t) || Bl
  ];
};
let mf = !0;
const lT = () => mf, [pf, gf] = Rs && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  xn,
  xn
], cT = () => {
  const e = hf && document.visibilityState;
  return Fe(e) || e !== "hidden";
}, uT = (e) => (hf && document.addEventListener("visibilitychange", e), pf("focus", e), () => {
  hf && document.removeEventListener("visibilitychange", e), gf("focus", e);
}), dT = (e) => {
  const t = () => {
    mf = !0, e();
  }, r = () => {
    mf = !1;
  };
  return pf("online", t), pf("offline", r), () => {
    gf("online", t), gf("offline", r);
  };
}, fT = {
  isOnline: lT,
  isVisible: cT
}, hT = {
  initFocus: uT,
  initReconnect: dT
}, Hm = !_t.useId, Ya = !Rs || sT, mT = (e) => oT() ? window.requestAnimationFrame(e) : setTimeout(e, 1), ja = Ya ? Pe : jb, Gl = typeof navigator < "u" && navigator.connection, qm = !Ya && Gl && ([
  "slow-2g",
  "2g"
].includes(Gl.effectiveType) || Gl.saveData), Xs = /* @__PURE__ */ new WeakMap(), Ql = (e, t) => Vo.prototype.toString.call(e) === `[object ${t}]`;
let pT = 0;
const vf = (e) => {
  const t = typeof e, r = Ql(e, "Date"), n = Ql(e, "RegExp"), i = Ql(e, "Object");
  let a, s;
  if (Vo(e) === e && !r && !n) {
    if (a = Xs.get(e), a) return a;
    if (a = ++pT + "~", Xs.set(e, a), Array.isArray(e)) {
      for (a = "@", s = 0; s < e.length; s++)
        a += vf(e[s]) + ",";
      Xs.set(e, a);
    }
    if (i) {
      a = "#";
      const o = Vo.keys(e).sort();
      for (; !Fe(s = o.pop()); )
        Fe(e[s]) || (a += s + ":" + vf(e[s]) + ",");
      Xs.set(e, a);
    }
  } else
    a = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return a;
}, Ka = (e) => {
  if (Or(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? vf(e) : "", [
    e,
    t
  ];
};
let gT = 0;
const yf = () => ++gT;
async function tw(...e) {
  const [t, r, n, i] = e, a = yn({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let s = a.populateCache;
  const o = a.rollbackOnError;
  let c = a.optimisticData;
  const u = (p) => typeof o == "function" ? o(p) : o !== !1, f = a.throwOnError;
  if (Or(r)) {
    const p = r, d = [], h = t.keys();
    for (const v of h)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(v) && p(t.get(v)._k) && d.push(v);
    return Promise.all(d.map(g));
  }
  return g(r);
  async function g(p) {
    const [d] = Ka(p);
    if (!d) return;
    const [h, v] = Rn(t, d), [b, m, S, I] = Jr.get(t), C = () => {
      const R = b[d];
      return (Or(a.revalidate) ? a.revalidate(h().data, p) : a.revalidate !== !1) && (delete S[d], delete I[d], R && R[0]) ? R[0](XS).then(() => h().data) : h().data;
    };
    if (e.length < 3)
      return C();
    let T = n, E;
    const N = yf();
    m[d] = [
      N,
      0
    ];
    const y = !Fe(c), w = h(), P = w.data, _ = w._c, D = Fe(_) ? P : _;
    if (y && (c = Or(c) ? c(D, P) : c, v({
      data: c,
      _c: D
    })), Or(T))
      try {
        T = T(D);
      } catch (R) {
        E = R;
      }
    if (T && ew(T))
      if (T = await T.catch((R) => {
        E = R;
      }), N !== m[d][0]) {
        if (E) throw E;
        return T;
      } else E && y && u(E) && (s = !0, v({
        data: D,
        _c: Nt
      }));
    if (s && !E)
      if (Or(s)) {
        const R = s(T, D);
        v({
          data: R,
          error: Nt,
          _c: Nt
        });
      } else
        v({
          data: T,
          error: Nt,
          _c: Nt
        });
    if (m[d][1] = yf(), Promise.resolve(C()).then(() => {
      v({
        _c: Nt
      });
    }), E) {
      if (f) throw E;
      return;
    }
    return T;
  }
}
const zm = (e, t) => {
  for (const r in e)
    e[r][0] && e[r][0](t);
}, rw = (e, t) => {
  if (!Jr.has(e)) {
    const r = yn(hT, t), n = /* @__PURE__ */ Object.create(null), i = tw.bind(Nt, e);
    let a = xn;
    const s = /* @__PURE__ */ Object.create(null), o = (f, g) => {
      const p = s[f] || [];
      return s[f] = p, p.push(g), () => p.splice(p.indexOf(g), 1);
    }, c = (f, g, p) => {
      e.set(f, g);
      const d = s[f];
      if (d)
        for (const h of d)
          h(g, p);
    }, u = () => {
      if (!Jr.has(e) && (Jr.set(e, [
        n,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        i,
        c,
        o
      ]), !Ya)) {
        const f = r.initFocus(setTimeout.bind(Nt, zm.bind(Nt, n, KS))), g = r.initReconnect(setTimeout.bind(Nt, zm.bind(Nt, n, JS)));
        a = () => {
          f && f(), g && g(), Jr.delete(e);
        };
      }
    };
    return u(), [
      e,
      i,
      u,
      a
    ];
  }
  return [
    e,
    Jr.get(e)[4]
  ];
}, vT = (e, t, r, n, i) => {
  const a = r.errorRetryCount, s = i.retryCount, o = ~~((Math.random() + 0.5) * (1 << (s < 8 ? s : 8))) * r.errorRetryInterval;
  !Fe(a) && s > a || setTimeout(n, o, i);
}, yT = ff, [dl, bT] = rw(/* @__PURE__ */ new Map()), nw = yn(
  {
    // events
    onLoadingSlow: xn,
    onSuccess: xn,
    onError: xn,
    onErrorRetry: vT,
    onDiscarded: xn,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: qm ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: qm ? 5e3 : 3e3,
    // providers
    compare: yT,
    isPaused: () => !1,
    cache: dl,
    mutate: bT,
    fallback: {}
  },
  // use web preset by default
  fT
), iw = (e, t) => {
  const r = yn(e, t);
  if (t) {
    const { use: n, fallback: i } = e, { use: a, fallback: s } = t;
    n && a && (r.use = n.concat(a)), i && s && (r.fallback = yn(i, s));
  }
  return r;
}, bf = Br({}), ST = (e) => {
  const { value: t } = e, r = wr(bf), n = Or(t), i = V(() => n ? t(r) : t, [
    n,
    r,
    t
  ]), a = V(() => n ? i : iw(r, i), [
    n,
    r,
    i
  ]), s = i && i.provider, o = we(Nt);
  s && !o.current && (o.current = rw(s(a.cache || dl), i));
  const c = o.current;
  return c && (a.cache = c[0], a.mutate = c[1]), ja(() => {
    if (c)
      return c[2] && c[2](), c[3];
  }, []), Wb(bf.Provider, yn(e, {
    value: a
  }));
}, aw = "$inf$", sw = Rs && window.__SWR_DEVTOOLS_USE__, wT = sw ? window.__SWR_DEVTOOLS_USE__ : [], IT = () => {
  sw && (window.__SWR_DEVTOOLS_REACT__ = _t);
}, ow = (e) => Or(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], jn = () => yn(nw, wr(bf)), CT = (e) => (t, r, n) => e(t, r && ((...a) => {
  const [s] = Ka(t), [, , , o] = Jr.get(dl);
  if (s.startsWith(aw))
    return r(...a);
  const c = o[s];
  return Fe(c) ? r(...a) : (delete o[s], c);
}), n), PT = wT.concat(CT), TT = (e) => function(...r) {
  const n = jn(), [i, a, s] = ow(r), o = iw(n, s);
  let c = e;
  const { use: u } = o, f = (u || []).concat(PT);
  for (let g = f.length; g--; )
    c = f[g](c);
  return c(i, a || o.fetcher || null, o);
}, _T = (e, t, r) => {
  const n = t[e] || (t[e] = []);
  return n.push(r), () => {
    const i = n.indexOf(r);
    i >= 0 && (n[i] = n[n.length - 1], n.pop());
  };
}, ET = (e, t) => (...r) => {
  const [n, i, a] = ow(r), s = (a.use || []).concat(t);
  return e(n, i, {
    ...a,
    use: s
  });
};
IT();
const Zl = _t.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((e) => {
  switch (e.status) {
    case "pending":
      throw e;
    case "fulfilled":
      return e.value;
    case "rejected":
      throw e.reason;
    default:
      throw e.status = "pending", e.then((t) => {
        e.status = "fulfilled", e.value = t;
      }, (t) => {
        e.status = "rejected", e.reason = t;
      }), e;
  }
}), Yl = {
  dedupe: !0
}, OT = (e, t, r) => {
  const { cache: n, compare: i, suspense: a, fallbackData: s, revalidateOnMount: o, revalidateIfStale: c, refreshInterval: u, refreshWhenHidden: f, refreshWhenOffline: g, keepPreviousData: p } = r, [d, h, v, b] = Jr.get(n), [m, S] = Ka(e), I = we(!1), C = we(!1), T = we(m), E = we(t), N = we(r), y = () => N.current, w = () => y().isVisible() && y().isOnline(), [P, _, D, R] = Rn(n, m), x = we({}).current, F = Fe(s) ? Fe(r.fallback) ? Nt : r.fallback[m] : s, W = (ce, se) => {
    for (const pe in x) {
      const k = pe;
      if (k === "data") {
        if (!i(ce[k], se[k]) && (!Fe(ce[k]) || !i(G, se[k])))
          return !1;
      } else if (se[k] !== ce[k])
        return !1;
    }
    return !0;
  }, A = V(() => {
    const ce = !m || !t ? !1 : Fe(o) ? y().isPaused() || a ? !1 : c !== !1 : o, se = (ae) => {
      const ne = yn(ae);
      return delete ne._k, ce ? {
        isValidating: !0,
        isLoading: !0,
        ...ne
      } : ne;
    }, pe = P(), k = R(), z = se(pe), U = pe === k ? z : se(k);
    let ie = z;
    return [
      () => {
        const ae = se(P());
        return W(ae, ie) ? (ie.data = ae.data, ie.isLoading = ae.isLoading, ie.isValidating = ae.isValidating, ie.error = ae.error, ie) : (ie = ae, ae);
      },
      () => U
    ];
  }, [
    n,
    m
  ]), M = oh.useSyncExternalStore($(
    (ce) => D(m, (se, pe) => {
      W(pe, se) || ce();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      n,
      m
    ]
  ), A[0], A[1]), j = !I.current, B = d[m] && d[m].length > 0, L = M.data, H = Fe(L) ? F && ew(F) ? Zl(F) : F : L, q = M.error, te = we(H), G = p ? Fe(L) ? Fe(te.current) ? H : te.current : L : H, X = B && !Fe(q) ? !1 : j && !Fe(o) ? o : y().isPaused() ? !1 : a ? Fe(H) ? !1 : c : Fe(H) || c, re = !!(m && t && j && X), oe = Fe(M.isValidating) ? re : M.isValidating, ue = Fe(M.isLoading) ? re : M.isLoading, de = $(
    async (ce) => {
      const se = E.current;
      if (!m || !se || C.current || y().isPaused())
        return !1;
      let pe, k, z = !0;
      const U = ce || {}, ie = !v[m] || !U.dedupe, ae = () => Hm ? !C.current && m === T.current && I.current : m === T.current, ne = {
        isValidating: !1,
        isLoading: !1
      }, me = () => {
        _(ne);
      }, Te = () => {
        const Re = v[m];
        Re && Re[1] === k && delete v[m];
      }, Ce = {
        isValidating: !0
      };
      Fe(P().data) && (Ce.isLoading = !0);
      try {
        if (ie && (_(Ce), r.loadingTimeout && Fe(P().data) && setTimeout(() => {
          z && ae() && y().onLoadingSlow(m, r);
        }, r.loadingTimeout), v[m] = [
          se(S),
          yf()
        ]), [pe, k] = v[m], pe = await pe, ie && setTimeout(Te, r.dedupingInterval), !v[m] || v[m][1] !== k)
          return ie && ae() && y().onDiscarded(m), !1;
        ne.error = Nt;
        const Re = h[m];
        if (!Fe(Re) && // case 1
        (k <= Re[0] || // case 2
        k <= Re[1] || // case 3
        Re[1] === 0))
          return me(), ie && ae() && y().onDiscarded(m), !1;
        const xe = P().data;
        ne.data = i(xe, pe) ? xe : pe, ie && ae() && y().onSuccess(pe, m, r);
      } catch (Re) {
        Te();
        const xe = y(), { shouldRetryOnError: _e } = xe;
        xe.isPaused() || (ne.error = Re, ie && ae() && (xe.onError(Re, m, xe), (_e === !0 || Or(_e) && _e(Re)) && (!y().revalidateOnFocus || !y().revalidateOnReconnect || w()) && xe.onErrorRetry(Re, m, xe, ($e) => {
          const jt = d[m];
          jt && jt[0] && jt[0](Um, $e);
        }, {
          retryCount: (U.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return z = !1, me(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      m,
      n
    ]
  ), Q = $(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...ce) => tw(n, T.current, ...ce),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (ja(() => {
    E.current = t, N.current = r, Fe(L) || (te.current = L);
  }), ja(() => {
    if (!m) return;
    const ce = de.bind(Nt, Yl);
    let se = 0;
    y().revalidateOnFocus && (se = Date.now() + y().focusThrottleInterval);
    const k = _T(m, d, (z, U = {}) => {
      if (z == KS) {
        const ie = Date.now();
        y().revalidateOnFocus && ie > se && w() && (se = ie + y().focusThrottleInterval, ce());
      } else if (z == JS)
        y().revalidateOnReconnect && w() && ce();
      else {
        if (z == XS)
          return de();
        if (z == Um)
          return de(U);
      }
    });
    return C.current = !1, T.current = m, I.current = !0, _({
      _k: S
    }), X && (Fe(H) || Ya ? ce() : mT(ce)), () => {
      C.current = !0, k();
    };
  }, [
    m
  ]), ja(() => {
    let ce;
    function se() {
      const k = Or(u) ? u(P().data) : u;
      k && ce !== -1 && (ce = setTimeout(pe, k));
    }
    function pe() {
      !P().error && (f || y().isVisible()) && (g || y().isOnline()) ? de(Yl).then(se) : se();
    }
    return se(), () => {
      ce && (clearTimeout(ce), ce = -1);
    };
  }, [
    u,
    f,
    g,
    m
  ]), c0(G), a && Fe(H) && m) {
    if (!Hm && Ya)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    E.current = t, N.current = r, C.current = !1;
    const ce = b[m];
    if (!Fe(ce)) {
      const se = Q(ce);
      Zl(se);
    }
    if (Fe(q)) {
      const se = de(Yl);
      Fe(G) || (se.status = "fulfilled", se.value = !0), Zl(se);
    } else
      throw q;
  }
  return {
    mutate: Q,
    get data() {
      return x.data = !0, G;
    },
    get error() {
      return x.error = !0, q;
    },
    get isValidating() {
      return x.isValidating = !0, oe;
    },
    get isLoading() {
      return x.isLoading = !0, ue;
    }
  };
}, fl = Vo.defineProperty(ST, "defaultValue", {
  value: nw
}), je = TT(OT), NT = (e) => {
  const t = e ? `${process.env.VITE_API_ROOT}/organizations/${e}/balance` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(
    t,
    Ze
  );
  return {
    balance: V(() => r?.data ?? {}, [r]),
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
}, DT = (e) => {
  const t = e ? `${process.env.VITE_API_ROOT}/organizations/${e}/billing` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(
    t,
    Ze
  );
  return {
    billing: V(() => r?.data ?? {}, [r]),
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
}, RT = (e) => {
  const t = e ? `${process.env.VITE_API_ROOT}/organizations/${e}` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(t, Ze);
  return {
    organization: V(() => r?.data ?? {}, [r]),
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
};
var Kl, Bm;
function hl() {
  if (Bm) return Kl;
  Bm = 1;
  var e = Array.isArray;
  return Kl = e, Kl;
}
var kT = hl();
const zr = /* @__PURE__ */ Ji(kT), AT = (e) => !e.zones || zr(e.zones) ? Object.keys(e).filter((t) => t.includes("amount")).map((t) => t.replace(/amount/, "")) : Object.keys(e.zones), xT = (e) => {
  const t = new Array(e.length);
  return e.forEach((r, n) => {
    t[n] = {
      ...structuredClone(r),
      zones: AT(r),
      zoneDetails: structuredClone(r.zones)
    };
  }), t;
}, FT = (e) => e.filter((t) => t), $T = (e, t) => !t.some((r) => !e[r]), MT = (e, t, r = [], n = (i) => i.name) => {
  if (!t?.zones)
    return e;
  const i = FT(
    t.zones.map((a) => {
      if (!a)
        return;
      const o = (t.tiers[t.current_tier] ?? {})?.zones[a] ?? {}, c = t.name;
      if (r && r.length > 0) {
        const u = t.zoneDetails[a].carriers;
        if (!u || u.length === 0 || !$T(u, r))
          return;
      }
      return {
        id: t.id,
        groupId: t.groupid,
        planName: c,
        dataLimit: t.data,
        displayName: n(t),
        displayCategory: t.display_category,
        zone: a,
        perLineCharge: parseFloat(o?.amount),
        overageCharge: parseFloat(o?.overage),
        outboundSms: parseFloat(o?.sms),
        cellularCoverageRegion: t.cellular_coverage_region,
        tiers: t.tiers,
        currentTier: t.current_tier,
        variablerate: t.variablerate,
        zeroDataRate: o?.zero_data_rate_flag === 1 && o?.zero_data_rate ? parseFloat(o.zero_data_rate) : void 0,
        apns: [
          ...new Set(Object.values(o?.carriers ?? {}).map((u) => u.apn))
        ]
      };
    })
  );
  return i ? [...e, ...i] : e;
}, ml = ({
  organizationId: e,
  canLoad: t = !0,
  includezdr: r = !1,
  allZones: n = !1
}) => {
  const i = new URLSearchParams({
    orgid: e?.toString() ?? "",
    enabled: "1",
    partnerid: "1",
    limit: "1000",
    includezdr: r ? "1" : "0"
  }), a = t ? `${process.env.VITE_API_ROOT}/plans?${i}` : null, { data: s, error: o, isLoading: c, mutate: u, isValidating: f } = je(
    a,
    Ze
  );
  return {
    plans: V(() => {
      if (!s?.data)
        return [];
      const p = structuredClone(s.data).filter((b) => b.groupid !== 0), h = xT(p).reduce(
        (b, m) => MT(b, m),
        []
      ), v = [
        ...new Map(h.map((b) => [b.id, b])).values()
      ];
      return (n ? h : v).sort((b, m) => b.displayCategory === m.displayCategory ? b.id - m.id : b.displayCategory === "custom" ? -1 : 1);
    }, [s, n]),
    error: o,
    isLoading: c,
    mutate: u,
    isValidating: f
  };
};
var Ht = /* @__PURE__ */ ((e) => (e.INFLIGHT = "eureka0", e.MANAGE_SINGLE_SIM_PROFILE_SWAP = "manage_single_profile_swap", e.HIDE_TOWER_LOCATIONS = "tower_location_hidden", e.EMBED_PREFLIGHT_OVERVIEW = "embed_preflight_overview", e.FEATURE_DATA_USAGE_ALERTS = "feature_data_usage_alerts", e.FEATURE_SPACEBRIDGE_TUNNELING = "feature_spacebridge_tunneling", e.FEATURE_HOLOGRAM_CLOUD_MESSAGING = "feature_hologram_cloud_messaging", e.FEATURE_WEBHOOKS = "feature_webhooks", e.FEATURE_ROUTES = "routes", e.FEATURE_PREDEPLOYMENT = "feature_predeployment", e))(Ht || {});
const LT = (e, t, r, n, i) => {
  const a = {};
  e && (a.orgid = e.toString()), r && (a.simcardid = r), n && i && (a.billingPeriodStart = n, a.billingPeriodEnd = i);
  const s = new URLSearchParams(a), [o, c] = Z(), [u, f] = Z(), [g, p] = Z(!1), d = t && e ? `${process.env.VITE_API_ROOT}/reports/embedded/${t}?${s}` : null, h = we(null);
  return Pe(() => {
    const b = async (m) => {
      let S;
      try {
        S = await Ze(m), c(S);
      } catch (I) {
        f(typeof I == "string" ? I : "Unknown error occurred"), console.error(I);
      }
      !S && u && c({}), p(!1);
    };
    d && h.current !== d && !g && (h.current = d, p(!0), f(void 0), b(d));
  }, [o, u, g, d]), {
    embeddedReport: V(() => o?.data ?? {}, [o]),
    error: o?.error ?? u,
    isLoading: g
  };
}, Wn = (e, t = !1) => {
  const r = new URLSearchParams({ orgid: `${e}` }), n = e ? `${process.env.VITE_API_ROOT}/devices/opensessions?${r}` : `${process.env.VITE_API_ROOT}/devices/opensessions`, i = jn(), a = V(
    () => ({
      ...i,
      dedupingInterval: 5e3,
      focusThrottleInterval: 5e3,
      refreshInterval: 3e4
    }),
    [i]
  ), { data: s, error: o, isLoading: c, mutate: u, isValidating: f } = je(t ? n : null, Ze, a);
  return {
    deviceIdsWithOpenSessions: V(() => new Set(s?.data?.deviceids ?? []), [s]),
    error: o,
    isLoading: c,
    mutate: u,
    isValidating: f
  };
}, jT = ({ canLoad: e = !0, config: t }) => {
  const { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(
    e ? `${process.env.VITE_API_ROOT}/users/me` : void 0,
    Ze,
    t
  );
  return {
    me: V(() => r?.data ?? {}, [r]),
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
}, WT = ({ hologramSimId: e, simProfileId: t }) => {
  const r = e && t ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/profiles/${t}/enable` : null;
  return $(async () => r ? await ft({
    url: r,
    body: null
  }) : void 0, [r]);
}, Le = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(t, Ze);
  return {
    simDetails: V(() => {
      const c = r?.simDetails ?? {};
      return c?.fallbackInstalled && (c.fallbackEnabled = c.fallbackInstalled), c;
    }, [r]),
    error: n,
    isLoading: i,
    isValidating: s,
    mutate: a
  };
}, Mt = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/device/details` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    deviceDetails: V(() => r?.deviceDetails ?? {}, [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, ch = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/device` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    deviceOverview: V(() => r?.deviceOverview ?? {}, [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, lw = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/fallback/history` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    fallbackHistory: V(() => r?.simFallbackHistory ?? [], [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, ks = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/sessions/recent` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    mostRecentSession: V(() => r?.mostRecentSession ?? {}, [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, cw = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/profiles/history` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    profileHistory: V(() => r?.profileHistory ?? [], [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, kr = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/profiles` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    simProfiles: V(() => r?.simProfileDetails ? structuredClone(r.simProfileDetails).sort((u, f) => u.profileType === "OPERATIONAL" && f.profileType !== "OPERATIONAL" ? -1 : u.profileType !== "OPERATIONAL" && f.profileType === "OPERATIONAL" ? 1 : (u.simProfileId ?? 0) < (f.simProfileId ?? 0) ? -1 : 1) : [], [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, UT = 50, Jl = ({ filters: e, sort: t, canLoad: r, onLoadingSlow: n }) => {
  const { pagination: i, ...a } = e ?? {}, s = i?.limit ? i : { limit: UT }, o = r && (s?.offset ?? 0) >= 0 ? {
    url: `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims`,
    body: {
      ...a,
      pagination: s,
      sort: t
    }
  } : null, c = jn();
  n && (c.onLoadingSlow = n);
  const { data: u, error: f, isLoading: g, mutate: p, isValidating: d } = je(o, ft, c);
  return {
    sims: V(() => u?.sims ?? new Array(s.limit), [u, s.limit]),
    isLoading: g,
    error: f,
    mutate: p,
    isValidating: d
  };
}, Sf = (e, t, r) => {
  const n = t ? {
    url: `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/count`,
    body: {
      ...e
    }
  } : null, i = jn();
  r && (i.onLoadingSlow = r);
  const { data: a, error: s, isLoading: o, mutate: c, isValidating: u } = je(n, ft, i);
  return {
    count: a?.simCount ?? -1,
    isLoading: o,
    error: s,
    mutate: c,
    isValidating: u
  };
}, VT = (e) => !!e.hologramSimId, uw = ({ filters: e, canLoad: t, onLoadingSlow: r }) => {
  const n = t ? {
    url: `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/ids`,
    body: {
      ...e
    }
  } : null, i = jn();
  r && (i.onLoadingSlow = r);
  const { data: a, error: s, isLoading: o, isValidating: c, mutate: u } = je(n, ft, i);
  return {
    simIds: V(
      () => new Map(
        a?.hologramSimIds?.filter(VT)?.map((g) => [g.hologramSimId, g.claimed_device_id])
      ),
      [a]
    ),
    error: s,
    isLoading: o,
    isValidating: c,
    mutate: u
  };
}, ht = () => {
  const e = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/simStatuses`, t = jn(), { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(
    e,
    Ze,
    // This data should only be refreshed once per day
    { ...t, dedupingInterval: 864e5, focusThrottleInterval: 864e5 }
  ), { friendlyStatusLookup: o, internalStatusLookup: c } = V(() => {
    const p = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
    return r?.networkStatusMap?.forEach((h) => {
      h.friendlyNetworkStatus && (h.internalNetworkStatus?.forEach((v) => {
        p.set(v, h.friendlyNetworkStatus);
      }), d.set(h.friendlyNetworkStatus, new Set(h.internalNetworkStatus)));
    }), p.set("PENDING", "Pending"), { friendlyStatusLookup: p, internalStatusLookup: d };
  }, [r]), u = $(
    (p) => p === "PENDING" ? "Pending" : o.get(p) ?? "Pending",
    [o]
  ), f = $(
    (p) => [
      ...(c.get(p) ?? /* @__PURE__ */ new Set()).values()
    ],
    [c]
  );
  return {
    networkStatusGroups: V(() => r?.networkStatusGroups, [r]),
    getNetworkStatusFromFriendly: f,
    formatStatus: u,
    isLoading: i,
    error: n,
    isValidating: a,
    mutate: s
  };
}, HT = async (e) => {
  const t = await fetch(e, {
    method: "GET"
  });
  if (!t.ok) {
    const n = new Error("An error occurred while fetching the data.");
    throw n.info = await t.json(), n.status = t.status, n;
  }
  return await t.json();
}, qT = `${process.env.VITE_STATUSPAGE_URL}/api/v2/summary.json`, j3 = () => {
  const { data: e, error: t, isLoading: r, mutate: n, isValidating: i } = je(qT, HT);
  return {
    status: e,
    error: t,
    isLoading: r,
    mutate: n,
    isValidating: i
  };
}, zT = new Intl.Collator(Ln, { usage: "sort" }), Ui = zT.compare, uh = ({ filters: e, canLoad: t = !0, onLoadingSlow: r }) => {
  const n = t && ((e?.organizationIds?.length ?? 0) > 0 || (e?.hologramSimIds?.length ?? 0) > 0) ? {
    url: `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/tags`,
    body: {
      ...e
    }
  } : null, i = jn();
  r && (i.onLoadingSlow = r);
  const { data: a, error: s, isLoading: o, mutate: c, isValidating: u } = je(n, ft, i);
  return {
    tags: V(() => a?.tags ? structuredClone(a.tags).sort((p, d) => Ui(p?.name ?? "", d?.name ?? "")) : [], [a]),
    isLoading: o,
    error: s,
    mutate: c,
    isValidating: u
  };
};
function J() {
  for (var e, t = 0, r = "", n = arguments.length; t < n; t++) (e = arguments[t]) && typeof e == "string" && (r += (r && " ") + e);
  return r;
}
const dw = Br({}), mt = () => wr(dw), BT = "hyperdashboard-ApnInfoIcon-module-RkmcTq-apnInfoIcon", GT = "hyperdashboard-ApnInfoIcon-module-RkmcTq-apnName", QT = "hyperdashboard-ApnInfoIcon-module-RkmcTq-diminished", ZT = "hyperdashboard-ApnInfoIcon-module-RkmcTq-popover", YT = "hyperdashboard-ApnInfoIcon-module-RkmcTq-wrapper", fi = {
  apnInfoIcon: BT,
  apnName: GT,
  diminished: QT,
  popover: ZT,
  wrapper: YT
}, dh = ({
  profiles: e,
  className: t,
  placement: r = "bottom",
  autoPlace: n = !1
}) => {
  const { sendAnalyticsEvent: i } = mt();
  if (!e) return null;
  const a = [];
  return e.forEach((s) => {
    if (s.requiredApn && !a.find((o) => o.requiredApn === s.requiredApn)) {
      const o = e.find(
        (c) => c.installationState === "ENABLED" && c.requiredApn === s.requiredApn
      );
      o ? a.push(o) : a.push(s);
    }
  }), /* @__PURE__ */ O("div", { className: J(fi.wrapper, t), children: [
    /* @__PURE__ */ l("div", { className: fi.apnName, children: a.map(({ simProfileId: s, installationState: o, requiredApn: c }, u) => /* @__PURE__ */ O(Ha, { children: [
      o === "ENABLED" || a.length === 1 ? c : /* @__PURE__ */ l("span", { className: fi.diminished, children: c }),
      u + 1 < a.length && /* @__PURE__ */ l("span", { className: fi.diminished, children: "/" })
    ] }, s)) }),
    /* @__PURE__ */ l(
      et,
      {
        content: a.length > 1 ? "Your SIM card has profiles that require different Access Point Names (APNs). The device this SIM is in will need to switch APNs if the profile changes." : "Your device should be set to this Access Point Name (APN) based on your SIM's active profile. The APN may change if the SIM profile changes.",
        id: "apn-popover",
        className: fi.popover,
        autoPlace: n,
        placement: r,
        onOpen: () => {
          i && i(
            `Info - ${a.length > 1 ? "Required multiple APN" : "Required single APN"}`
          );
        },
        children: /* @__PURE__ */ l(
          ye,
          {
            name: "CircleInfo",
            fill: "DdsColorInteractivePrimaryDefault",
            className: fi.apnInfoIcon
          }
        )
      }
    )
  ] });
}, KT = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-banner", JT = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-bannerFlex", XT = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-bannerGrid", e_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-button", t_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-content", r_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-danger", n_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-empty", i_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-icon", a_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-nav", s_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-text", o_ = "hyperdashboard-AppNotificationBanner-module-Fc2_SW-warning", mr = {
  banner: KT,
  bannerFlex: JT,
  bannerGrid: XT,
  button: e_,
  content: t_,
  danger: r_,
  empty: n_,
  icon: i_,
  nav: a_,
  text: s_,
  warning: o_
}, W3 = ({ notifications: e }) => {
  const [t, r] = Z(0), {
    type: n,
    label: i = "Warning",
    children: a,
    href: s,
    to: o,
    action: c,
    dismissable: u = !1,
    onDismiss: f
  } = e[t], g = $(() => {
    r((h) => h + 1 >= e.length ? 0 : h + 1);
  }, [e.length]), p = n === "warning" ? "DdsColorPaletteOrange50" : "DdsColorPaletteRed86", d = e.length > 1 || u;
  return /* @__PURE__ */ O(
    "div",
    {
      className: J(
        mr.banner,
        d && mr.bannerGrid,
        !d && mr.bannerFlex,
        mr[n]
      ),
      children: [
        d && /* @__PURE__ */ l("div", { className: mr.empty }),
        /* @__PURE__ */ O("div", { className: mr.content, children: [
          /* @__PURE__ */ l(
            ye,
            {
              className: mr.icon,
              name: n === "warning" ? "Warning" : "Danger",
              fill: p
            }
          ),
          /* @__PURE__ */ O("div", { className: mr.text, children: [
            /* @__PURE__ */ O("strong", { children: [
              i,
              ":"
            ] }),
            " ",
            /* @__PURE__ */ l("span", { children: a }),
            (o || s) && c && /* @__PURE__ */ O(le, { children: [
              " ",
              s ? /* @__PURE__ */ l(
                Y,
                {
                  className: mr.button,
                  href: s,
                  variant: "tertiary",
                  target: "_blank",
                  rel: "noreferrer",
                  children: c
                }
              ) : /* @__PURE__ */ l(Y, { className: mr.button, to: o, variant: "tertiary", children: c })
            ] })
          ] })
        ] }),
        d && /* @__PURE__ */ O("div", { className: mr.nav, children: [
          u && /* @__PURE__ */ l(Y, { variant: "tertiary", className: mr.button, onClick: f, children: "Dismiss" }),
          e.length > 1 && /* @__PURE__ */ l(
            Y,
            {
              iconEnd: /* @__PURE__ */ l(ye, { name: "ChevronSingleEast", color: p }),
              variant: "tertiary",
              className: mr.button,
              onClick: g,
              children: `${t + 1} of ${e.length}`
            }
          )
        ] })
      ]
    }
  );
}, l_ = "hyperdashboard-BackgroundGradient-module-dI4k-W-backgroundImage", c_ = "hyperdashboard-BackgroundGradient-module-dI4k-W-backgroundWrapper", u_ = "hyperdashboard-BackgroundGradient-module-dI4k-W-bottom", d_ = "hyperdashboard-BackgroundGradient-module-dI4k-W-grid", f_ = "hyperdashboard-BackgroundGradient-module-dI4k-W-top", eo = {
  backgroundImage: l_,
  backgroundWrapper: c_,
  bottom: u_,
  grid: d_,
  top: f_
}, h_ = "hyperdashboard-backgrounds-module-57Y3iG-a", m_ = "hyperdashboard-backgrounds-module-57Y3iG-b", p_ = "hyperdashboard-backgrounds-module-57Y3iG-none", g_ = {
  a: h_,
  b: m_,
  default: "hyperdashboard-backgrounds-module-57Y3iG-default",
  none: p_
}, v_ = "hyperdashboard-backgrounds-desktop-module-pNb9fW-none", y_ = {
  none: v_
}, b_ = "hyperdashboard-backgrounds-tablet-module--I3jQG-none", S_ = {
  none: b_
}, w_ = (e) => {
  const {
    backgroundGradient: t,
    overlayGrid: r,
    children: n,
    className: i,
    gridAnchor: a = "top",
    backgroundClass: s,
    pinTo: o,
    overrideGridSize: c
  } = e;
  if (!t)
    return null;
  const u = {};
  return c && (u["--background-gradient-override-grid-size"] = `${c}px`), /* @__PURE__ */ O("div", { style: u, className: J(eo.backgroundWrapper, i), children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: J(
          eo.backgroundImage,
          !o && g_[t],
          o === "desktop" && y_[t],
          o === "tablet" && S_[t],
          s
        )
      }
    ),
    r && /* @__PURE__ */ l("div", { className: J(eo.grid, eo[a]) }),
    n
  ] });
}, I_ = "hyperdashboard-BorderlessPanel-module-2DDGAq-contents", C_ = "hyperdashboard-BorderlessPanel-module-2DDGAq-header", P_ = "hyperdashboard-BorderlessPanel-module-2DDGAq-tabs", T_ = "hyperdashboard-BorderlessPanel-module-2DDGAq-wrapper", to = {
  contents: I_,
  header: C_,
  tabs: P_,
  wrapper: T_
}, As = ({
  className: e,
  children: t,
  headerContents: r,
  headerClassName: n,
  contentsClassName: i,
  tabs: a,
  tabsClassname: s
}) => /* @__PURE__ */ O("div", { className: J(to.wrapper, e), children: [
  /* @__PURE__ */ l("div", { className: J(to.header, n), children: r }),
  a && /* @__PURE__ */ l("div", { className: J(to.tabs, s), children: a }),
  /* @__PURE__ */ l("div", { className: J(to.contents, i), children: t })
] });
var Gm = {
  DdsColorPaletteGrey3: "#00040f",
  DdsColorPaletteGrey10: "#14161f",
  DdsColorPaletteGrey20: "#2b2f3b",
  DdsColorPaletteGrey25: "#3a3c46",
  DdsColorPaletteGrey30: "#474a52",
  DdsColorPaletteGrey45: "#6e7079",
  DdsColorPaletteGrey50: "#797c86",
  DdsColorPaletteGrey60: "#95979e",
  DdsColorPaletteGrey75: "#bbbcc2",
  DdsColorPaletteGrey88: "#dedfe4",
  DdsColorPaletteGrey93: "#ebecef",
  DdsColorPaletteGrey98: "#f8f8fa",
  DdsColorPaletteGrey100: "#ffffff",
  DdsColorPaletteBlue10: "#090033",
  DdsColorPaletteBlue20: "#110165",
  DdsColorPaletteBlue30: "#1a0198",
  DdsColorPaletteBlue43: "#2401da",
  DdsColorPaletteBlue50: "#2a01fe",
  DdsColorPaletteBlue59: "#2f6aff",
  DdsColorPaletteBlue70: "#6692ff",
  DdsColorPaletteBlue80: "#99b6ff",
  DdsColorPaletteBlue90: "#ccdbff",
  DdsColorPaletteBlue95: "#e5edff",
  DdsColorPaletteGreen10: "#03301c",
  DdsColorPaletteGreen20: "#06603c",
  DdsColorPaletteGreen32: "#0a9959",
  DdsColorPaletteGreen43: "#0ecb76",
  DdsColorPaletteGreen50: "#0fe182",
  DdsColorPaletteGreen60: "#40f2a2",
  DdsColorPaletteGreen70: "#81f3c4",
  DdsColorPaletteGreen82: "#b1f1e2",
  DdsColorPaletteGreen90: "#cffce8",
  DdsColorPaletteGreen94: "#e2fdf1",
  DdsColorPaletteLime10: "#183300",
  DdsColorPaletteLime20: "#366501",
  DdsColorPaletteLime30: "#479801",
  DdsColorPaletteLime40: "#95cb01",
  DdsColorPaletteLime50: "#bffd11",
  DdsColorPaletteLime64: "#cdfe48",
  DdsColorPaletteLime73: "#dafe76",
  DdsColorPaletteLime80: "#e4fe9a",
  DdsColorPaletteLime90: "#ebffcc",
  DdsColorPaletteLime95: "#f5ffe5",
  DdsColorPaletteOrange10: "#2b0d08",
  DdsColorPaletteOrange20: "#561910",
  DdsColorPaletteOrange33: "#8e2a1a",
  DdsColorPaletteOrange38: "#c23200",
  DdsColorPaletteOrange50: "#ff4200",
  DdsColorPaletteOrange60: "#ff6631",
  DdsColorPaletteOrange70: "#ffb068",
  DdsColorPaletteOrange80: "#ffca99",
  DdsColorPaletteOrange90: "#ffe4cc",
  DdsColorPaletteOrange95: "#fff1e5",
  DdsColorPalettePink10: "#33001c",
  DdsColorPalettePink20: "#660039",
  DdsColorPalettePink33: "#a8005e",
  DdsColorPalettePink44: "#e0007d",
  DdsColorPalettePink55: "#ff1a99",
  DdsColorPalettePink66: "#ff54b3",
  DdsColorPalettePink70: "#ff66bb",
  DdsColorPalettePink80: "#ff99d2",
  DdsColorPalettePink90: "#ffcce8",
  DdsColorPalettePink95: "#ffe5fa",
  DdsColorPalettePurple10: "#190033",
  DdsColorPalettePurple20: "#330165",
  DdsColorPalettePurple30: "#4c0198",
  DdsColorPalettePurple40: "#6606c6",
  DdsColorPalettePurple50: "#8008f7",
  DdsColorPalettePurple60: "#a533ff",
  DdsColorPalettePurple75: "#c780ff",
  DdsColorPalettePurple80: "#d299ff",
  DdsColorPalettePurple90: "#e9ccff",
  DdsColorPalettePurple95: "#f4e5ff",
  DdsColorPaletteRed10: "#330000",
  DdsColorPaletteRed20: "#660000",
  DdsColorPaletteRed33: "#a80000",
  DdsColorPaletteRed43: "#db0000",
  DdsColorPaletteRed50: "#ff0000",
  DdsColorPaletteRed60: "#ff3333",
  DdsColorPaletteRed75: "#ff8282",
  DdsColorPaletteRed86: "#ffb8b8",
  DdsColorPaletteRed90: "#ffcccc",
  DdsColorPaletteRed95: "#ffe5e6",
  DdsColorPaletteTeal10: "#002833",
  DdsColorPaletteTeal20: "#005166",
  DdsColorPaletteTeal30: "#007999",
  DdsColorPaletteTeal40: "#099fc3",
  DdsColorPaletteTeal49: "#00ebfa",
  DdsColorPaletteTeal60: "#33daff",
  DdsColorPaletteTeal70: "#6dddf8",
  DdsColorPaletteTeal80: "#9ee9fa",
  DdsColorPaletteTeal90: "#cef4fd",
  DdsColorPaletteTeal95: "#e7f9fe",
  DdsColorPaletteYellow10: "#331c00",
  DdsColorPaletteYellow20: "#663800",
  DdsColorPaletteYellow33: "#a85d00",
  DdsColorPaletteYellow44: "#e0a500",
  DdsColorPaletteYellow50: "#ffbb00",
  DdsColorPaletteYellow66: "#ffe552",
  DdsColorPaletteYellow75: "#ffec80",
  DdsColorPaletteYellow80: "#fff099",
  DdsColorPaletteYellow90: "#fff7cc",
  DdsColorPaletteYellow95: "#fffbe5",
  DdsColorPaletteBlack: "#00040f",
  DdsColorPaletteWhite: "#ffffff",
  DdsColorTextPrimaryOndefault: "#00040f",
  DdsColorTextPrimaryOninverse: "#ffffff",
  DdsColorTextDiminishedOndefault: "#797c86",
  DdsColorTextDiminishedOninverse: "#bbbcc2",
  DdsColorTextDisabledOndefault: "#bbbcc2",
  DdsColorTextLinkDefault: "#6606c6",
  DdsColorTextLinkHover: "#330165",
  DdsColorTextLinkActive: "#4c0198",
  DdsColorTextLinkDisabled: "#d299ff",
  DdsColorTextInvalidOndefault: "#a80000",
  DdsColorTextDangerDefault: "#a80000",
  DdsColorTextDangerHover: "#660000",
  DdsColorTextDangerActive: "#330000",
  DdsColorTextDangerDisabled: "#ffb8b8",
  DdsColorTextWarningDefault: "#a85d00",
  DdsColorBorderControlDefault: "#bbbcc2",
  DdsColorBorderControlHover: "#95979e",
  DdsColorBorderControlActive: "#797c86",
  DdsColorBorderControlDisabled: "#dedfe4",
  DdsColorBorderControlInvalid: "#a80000",
  DdsColorBorderDividerDefault: "#dedfe4",
  DdsColorBorderDividerDark: "#6e7079",
  DdsColorBorderContainerDefault: "#dedfe4",
  DdsColorBorderNotificationCaution: "#ffbb00",
  DdsColorBorderNotificationError: "#a80000",
  DdsColorBorderNotificationHighlight: "#bffd11",
  DdsColorBorderNotificationNote: "#007999",
  DdsColorBorderNotificationSuccess: "#06603c",
  DdsColorBorderAdmin: "#ff8282",
  DdsColorInteractivePrimaryDefault: "#8008f7",
  DdsColorInteractivePrimaryHover: "#6606c6",
  DdsColorInteractivePrimaryActive: "#4c0198",
  DdsColorInteractivePrimaryDisabled: "#e9ccff",
  DdsColorInteractiveSecondaryDefault: "#ffffff",
  DdsColorInteractiveSecondaryHover: "#f8f8fa",
  DdsColorInteractiveSecondaryActive: "#ebecef",
  DdsColorInteractiveSecondaryDisabled: "#f8f8fa",
  DdsColorInteractiveDangerDefault: "#db0000",
  DdsColorInteractiveDangerHover: "#a80000",
  DdsColorInteractiveDangerActive: "#660000",
  DdsColorInteractiveDangerDisabled: "#ffb8b8",
  DdsColorInteractiveFocusringInner: "#ffffff",
  DdsColorInteractiveFocusringOuter: "#00040f",
  DdsColorRequiredindicator: "#a80000",
  DdsColorBackgroundDefault: "#ffffff",
  DdsColorBackgroundAlternative: "#f8f8fa",
  DdsColorBackgroundInverse: "#14161f",
  DdsColorBackgroundNotificationDanger: "#ffe5e6",
  DdsColorBackgroundNotificationError: "#ffe5e6",
  DdsColorBackgroundNotificationSuccess: "#e2fdf1",
  DdsColorBackgroundNotificationCaution: "#fff7cc",
  DdsColorBackgroundNotificationNeutral: "#f8f8fa",
  DdsColorBackgroundNotificationNote: "#e7f9fe",
  DdsColorBackgroundAdmin: "#ff8282",
  DdsColorBackgroundHighlight: "#dafe76",
  DdsColorIconDefault: "#00040f",
  DdsColorIconDiminished: "#797c86",
  DdsColorIconDanger: "#db0000",
  DdsColorIconDisabled: "#95979e",
  DdsColorIconSuccess: "#0a9959",
  DdsColorIconCaution: "#ff6631",
  DdsColorIconWarning: "#ffbb00",
  DdsColorIconNote: "#099fc3",
  DdsColorIconAdmin: "#ff8282",
  DdsColorFillNotificationError: "#db0000",
  DdsColorFillNotificationSuccess: "#0a9959",
  DdsColorFillNotificationCaution: "#ffbb00",
  DdsColorFillNotificationNote: "#099fc3",
  DdsColorFillNotificationHighlight: "#bffd11"
};
const __ = { webp: "/assets/img/hyper-sim-card.webp 711w", avif: "/assets/img/hyper-sim-card.avif 711w" }, E_ = { src: "/assets/img/hyper-sim-card.png", w: 711, h: 472 }, O_ = { sources: __, img: E_ }, N_ = { webp: "/assets/img/sim-card.webp 711w", avif: "/assets/img/sim-card.avif 711w" }, D_ = { src: "/assets/img/sim-card.png", w: 711, h: 472 }, R_ = { sources: N_, img: D_ }, k_ = "hyperdashboard-CardButton-module-pxD6ia-background", A_ = "hyperdashboard-CardButton-module-pxD6ia-backgroundGradient", x_ = "hyperdashboard-CardButton-module-pxD6ia-backgroundImage", F_ = "hyperdashboard-CardButton-module-pxD6ia-button", $_ = "hyperdashboard-CardButton-module-pxD6ia-caption", M_ = "hyperdashboard-CardButton-module-pxD6ia-contents", L_ = "hyperdashboard-CardButton-module-pxD6ia-continueButton", j_ = "hyperdashboard-CardButton-module-pxD6ia-descriptiveIcon", W_ = "hyperdashboard-CardButton-module-pxD6ia-descriptivePictureWrapper", U_ = "hyperdashboard-CardButton-module-pxD6ia-link", V_ = "hyperdashboard-CardButton-module-pxD6ia-wrapper", $r = {
  background: k_,
  backgroundGradient: A_,
  backgroundImage: x_,
  button: F_,
  caption: $_,
  contents: M_,
  continueButton: L_,
  descriptiveIcon: j_,
  descriptivePictureWrapper: W_,
  link: U_,
  wrapper: V_
}, Qm = ({
  variant: e = "link",
  className: t,
  backgroundGradient: r = "default",
  children: n,
  descriptiveIcon: i,
  descriptiveIconFill: a,
  descriptiveIconHoverFill: s,
  descriptivePicture: o,
  onClick: c,
  href: u,
  ...f
}) => {
  const g = {
    "--decriptive-icon-fill": Gm[a],
    "--decriptive-icon-hover-fill": Gm[s]
  }, p = /* @__PURE__ */ l("div", { className: J($r.wrapper, t), children: /* @__PURE__ */ l(
    w_,
    {
      backgroundGradient: r,
      backgroundClass: $r.background,
      overlayGrid: !0,
      className: $r.backgroundGradient,
      pinTo: "desktop",
      overrideGridSize: 70,
      children: /* @__PURE__ */ O("div", { className: $r.contents, children: [
        /* @__PURE__ */ l("div", { className: $r.descriptivePictureWrapper, children: o && /* @__PURE__ */ l(
          fh,
          {
            image: o === "hyper" ? O_ : R_,
            alt: "",
            setDimensions: !1,
            imgClassName: $r.backgroundImage
          }
        ) }),
        /* @__PURE__ */ l("div", { style: g, className: $r.descriptiveIcon, children: /* @__PURE__ */ l(ye, { name: i, color: "currentColor", size: "large" }) }),
        /* @__PURE__ */ l("div", { className: $r.caption, children: n }),
        /* @__PURE__ */ l("div", { className: $r.continueButton, children: /* @__PURE__ */ l(
          ye,
          {
            name: e === "link" ? "ArrowEastShort" : "Envelope",
            color: "currentColor",
            size: "large"
          }
        ) })
      ] })
    }
  ) });
  return u ? /* @__PURE__ */ l("a", { className: $r.link, href: u, ...f, children: p }) : /* @__PURE__ */ l("button", { className: $r.button, type: "button", onClick: c, children: p });
}, H_ = (e) => {
  const t = new URLSearchParams({ orgid: `${e}` }), r = e ? `${process.env.VITE_API_ROOT}/releaseflags?${t}` : null, { data: n, error: i, isLoading: a, mutate: s, isValidating: o } = je(r, Ze);
  return {
    organizationReleaseFlags: V(() => new Set(Object.values(n?.data ?? {})), [n]),
    error: i,
    isLoading: a,
    mutate: s,
    isValidating: o
  };
}, q_ = (e = !0) => {
  const { data: t, error: r, isLoading: n, mutate: i, isValidating: a } = je(e ? `${process.env.VITE_API_ROOT}/releaseflags/public` : null, Ze);
  return {
    publicReleaseFlags: V(() => new Set(Object.values(t?.data ?? {})), [t]),
    error: r,
    isLoading: n,
    mutate: i,
    isValidating: a
  };
}, fw = Br({
  isAuthenticated: !0,
  user: {},
  organizations: [],
  login: (e, t, r) => Promise.resolve(),
  loginTotp: (e) => Promise.resolve(),
  logout: () => Promise.resolve(),
  loggingIn: !1,
  loggingOut: !1,
  showMfaModal: !1,
  loadingUserDetails: !1,
  invalidate: () => {
  }
}), pl = () => wr(fw), hw = Br(void 0), Ne = () => wr(hw);
var vt = /* @__PURE__ */ ((e) => (e.ACTIVATION = "activation", e.BILLING = "billing", e.BILLING_VISIBLE = "billing_visible", e.CHANGEPLAN = "changeplan", e.DEACTIVATE = "deactivate", e.ORG_MANAGEMENT = "org_management", e.SBCONFIG = "sbconfig", e.SBTUNNEL = "sbtunnel", e))(vt || {});
const Zm = /* @__PURE__ */ new Map([
  [
    "admin",
    {
      label: "Admin",
      article: "an"
    }
  ],
  [
    "manager",
    {
      label: "Manager",
      article: "a"
    }
  ],
  [
    "editor",
    {
      label: "Editor",
      article: "an"
    }
  ],
  [
    "editor_limited",
    {
      label: "Editor Limited",
      article: "an"
    }
  ],
  [
    "placeholder",
    {
      label: "Please select the user's role",
      article: "an"
    }
  ]
]), z_ = () => Object.values(vt), U3 = (e) => e === "admin" ? z_() : e === "manager" ? [
  vt.ACTIVATION,
  vt.BILLING_VISIBLE,
  vt.CHANGEPLAN,
  vt.DEACTIVATE,
  vt.SBCONFIG,
  vt.SBTUNNEL
] : e === "editor" ? [vt.BILLING_VISIBLE, vt.SBCONFIG, vt.SBTUNNEL] : e === "editor_limited" ? [vt.SBCONFIG, vt.SBTUNNEL] : [vt.SBCONFIG, vt.SBTUNNEL], B_ = (e) => e ? e.includes(vt.ORG_MANAGEMENT) ? "admin" : e.includes(vt.ACTIVATION) && e.includes(vt.CHANGEPLAN) && e.includes(vt.DEACTIVATE) ? "manager" : e.includes(vt.BILLING_VISIBLE) ? "editor" : "editor_limited" : "editor", G_ = (e) => Zm.get(e) ?? Zm.get("editor"), Be = () => {
  const { isAuthenticated: e, organizations: t, user: r, loadingUserDetails: n, invalidate: i } = pl(), a = Ne(), s = V(
    () => t.find((I) => I.id === a),
    [a, t]
  ), o = V(
    () => s?.users.find((I) => I.id === r.id),
    [s, r.id]
  ), c = B_(o?.permissions), u = V(() => G_(c), [c]), {
    publicReleaseFlags: f,
    error: g,
    isLoading: p
  } = q_(e), {
    organizationReleaseFlags: d,
    error: h,
    isLoading: v
  } = H_(e ? a : void 0), b = V(
    () => /* @__PURE__ */ new Set([...f, ...d]),
    [d, f]
  ), m = n || p || v, S = g || h;
  return V(
    () => !e || m || S ? {
      organizationRole: c,
      organizationRoleLabel: u,
      invalidate: i,
      releaseFlags: /* @__PURE__ */ new Set(),
      isSuperAdmin: !1
    } : {
      ...r,
      isSuperAdmin: ["adm", "hdm"].includes(r.role ?? ""),
      selectedOrganization: s,
      organizationRole: c,
      organizationRoleLabel: u,
      permissions: o?.permissions ?? [],
      invalidOrg: !o,
      invalidate: i,
      releaseFlags: b
    },
    [
      e,
      m,
      S,
      c,
      u,
      i,
      r,
      s,
      o,
      b
    ]
  );
}, Q_ = "hyperdashboard-DeviceDetailsPanel-module-oYxxKG-diminished", Z_ = "hyperdashboard-DeviceDetailsPanel-module-oYxxKG-numeric", Y_ = "hyperdashboard-DeviceDetailsPanel-module-oYxxKG-panelSection", K_ = "hyperdashboard-DeviceDetailsPanel-module-oYxxKG-panelSectionColumn", J_ = "hyperdashboard-DeviceDetailsPanel-module-oYxxKG-panelSectionColumns", X_ = "hyperdashboard-DeviceDetailsPanel-module-oYxxKG-panelSectionHeading", pr = {
  diminished: Q_,
  numeric: Z_,
  panelSection: Y_,
  panelSectionColumn: K_,
  panelSectionColumns: J_,
  panelSectionHeading: X_
}, eE = ({
  hologramSimId: e,
  handleModalOpen: t,
  onSimsModified: r
}) => {
  const {
    isLoading: n,
    error: i,
    deviceDetails: a,
    isValidating: s
  } = Mt(e), {
    isLoading: o,
    error: c,
    simDetails: u,
    isValidating: f
  } = Le(e), { networkStatus: g, tunnelable: p } = u, { claimedDeviceId: d, imei: h, imeiTac: v, manufacturer: b, model: m } = a, S = i || c, I = n || o, { releaseFlags: C } = Be(), T = C.has(Ht.FEATURE_SPACEBRIDGE_TUNNELING), E = $(() => {
    t({
      modalName: "SimInventoryManageTunnelingModal",
      modalProps: {
        sims: /* @__PURE__ */ new Map([[e, d]]),
        onModalSuccess: r
      }
    });
  }, [t, e, d, r]);
  let N;
  const y = "Manage device tunneling";
  p ? N = /* @__PURE__ */ l(Ae, { type: "inline", onClick: E, ariaLabel: y, children: "Enabled" }) : g?.startsWith("DEAD") ? N = /* @__PURE__ */ l("span", { className: pr.diminished, children: "Not enabled" }) : N = /* @__PURE__ */ l(Ae, { type: "inline", onClick: E, ariaLabel: y, children: "Not enabled" });
  let w;
  return S ? w = /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading device details",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : I ? w = /* @__PURE__ */ l(fe, { children: "Loading..." }) : w = /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ O("div", { className: pr.panelSection, children: [
      /* @__PURE__ */ l("div", { className: pr.panelSectionHeading, children: "Last known device" }),
      /* @__PURE__ */ O("div", { className: pr.panelSectionColumns, children: [
        /* @__PURE__ */ l("div", { className: pr.panelSectionColumn, children: /* @__PURE__ */ l(ee, { label: "Device ID", value: d, valueClassname: pr.numeric }) }),
        /* @__PURE__ */ O("div", { className: pr.panelSectionColumn, children: [
          /* @__PURE__ */ l(
            ee,
            {
              label: "Last known IMEI",
              value: h,
              emptyStateText: "No known IMEI",
              valueClassname: pr.numeric
            }
          ),
          h && /* @__PURE__ */ l(
            ee,
            {
              label: "IMEI TAC",
              value: v,
              emptyStateText: "Not available",
              valueClassname: pr.numeric
            }
          ),
          m && b && /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(ee, { label: "Modem", value: b }),
            /* @__PURE__ */ l(ee, { label: "Hardware", value: m })
          ] })
        ] })
      ] })
    ] }),
    T && /* @__PURE__ */ O("div", { className: pr.panelSection, children: [
      /* @__PURE__ */ l("div", { className: pr.panelSectionHeading, children: "Device communication" }),
      /* @__PURE__ */ l("div", { className: pr.panelSectionColumns, children: /* @__PURE__ */ l("div", { className: pr.panelSectionColumn, children: /* @__PURE__ */ l(ee, { label: "Device tunneling", value: N }) }) })
    ] })
  ] }), /* @__PURE__ */ l(
    He,
    {
      header: g?.startsWith("DEAD") ? "Last known device details" : "Device details",
      noContentPadding: !0,
      isLoading: I || s || f,
      children: w
    }
  );
}, tE = "hyperdashboard-EmbeddedReport-module-vCS4iq-loader", rE = "hyperdashboard-EmbeddedReport-module-vCS4iq-reportIframe", nE = "hyperdashboard-EmbeddedReport-module-vCS4iq-wrapper", iE = "hyperdashboard-EmbeddedReport-module-vCS4iq-wrapperLoading", ro = {
  loader: tE,
  reportIframe: rE,
  wrapper: nE,
  wrapperLoading: iE
}, an = ({
  reportId: e,
  className: t,
  simCardId: r,
  billingPeriodStart: n,
  billingPeriodEnd: i
}) => {
  const [a, s] = Z(!0), [o, c] = Z(0), u = Ne(), { embeddedReport: f, isLoading: g, error: p } = LT(
    u,
    e,
    r,
    n,
    i
  ), { name: d, url: h } = f, v = we(null), b = $((S) => {
    if (v.current && S.source === v.current.contentWindow && S.origin === "https://app.sigmacomputing.com") {
      const { type: I, pageHeight: C } = S?.data ?? {};
      switch (I) {
        case "workbook:loaded":
          s(!1);
          break;
        case "workbook:pageheight:onchange":
          c(C);
          break;
      }
    }
  }, []);
  Pe(() => (window.addEventListener("message", b), () => window.removeEventListener("message", b)), [b]);
  const m = V(() => p ? /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading this report",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : g && !h ? null : /* @__PURE__ */ l(
    "iframe",
    {
      title: d,
      src: h,
      className: ro.reportIframe,
      style: {
        display: a ? "none" : void 0,
        height: o === 0 || a ? "100%" : `${o + 32}px`
      },
      ref: v
    }
  ), [p, g, a, d, o, h]);
  return /* @__PURE__ */ O("div", { className: J(ro.wrapper, a && ro.wrapperLoading, t), children: [
    a && /* @__PURE__ */ l(ur, { className: ro.loader }),
    m
  ] });
}, aE = "hyperdashboard-EmptyState-module-VRF0pG-wrapper", sE = {
  wrapper: aE
}, Dt = ({ text: e }) => /* @__PURE__ */ l("div", { className: sE.wrapper, children: e ?? "—" }), oE = "hyperdashboard-Field-module-gmb_Qa-animated", lE = "hyperdashboard-Field-module-gmb_Qa-columnDirection", cE = "hyperdashboard-Field-module-gmb_Qa-hidden", uE = "hyperdashboard-Field-module-gmb_Qa-label", dE = "hyperdashboard-Field-module-gmb_Qa-noValue", fE = "hyperdashboard-Field-module-gmb_Qa-value", hE = "hyperdashboard-Field-module-gmb_Qa-wrapper", Hn = {
  animated: oE,
  columnDirection: lE,
  hidden: cE,
  label: uE,
  noValue: dE,
  value: fE,
  wrapper: hE
}, ee = ({
  label: e,
  value: t,
  className: r,
  hidden: n = !1,
  animated: i = !1,
  direction: a = "row",
  labelClassName: s,
  valueClassname: o,
  emptyStateText: c,
  labelId: u,
  ...f
}) => /* @__PURE__ */ O(
  "div",
  {
    className: J(
      r,
      Hn.wrapper,
      n && Hn.hidden,
      i && Hn.animated,
      a === "column" && Hn.columnDirection
    ),
    ...f,
    children: [
      /* @__PURE__ */ l("span", { className: J(Hn.label, s), id: u, children: e }),
      /* @__PURE__ */ l("span", { className: J(Hn.value, !t && Hn.noValue, o), children: t || /* @__PURE__ */ l(Dt, { text: c }) })
    ]
  }
), mE = "hyperdashboard-ManageSimButton-module-9l6ffq-dropdownPanel", pE = "hyperdashboard-ManageSimButton-module-9l6ffq-wrapper", Ym = {
  dropdownPanel: mE,
  wrapper: pE
}, Ee = (e) => e.toLocaleString(Ln), mw = Br(void 0), Sn = () => wr(mw), gE = ({
  context: e,
  selectedSims: t,
  disabled: r,
  segmentName: n
}) => {
  const i = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: a } = Le(i), { deviceDetails: s } = Mt(i), { claimedDeviceId: o } = s ?? {}, c = Sn(), u = $(() => {
    if (!c)
      throw new Error("Legacy dashboard context is not available");
    const { endTestingAndActivate: h } = c;
    if (o)
      h(
        [o],
        e === "details" ? "SIM Details" : "SIM Inventory"
      );
    else {
      const v = [...t?.values() ?? []];
      h(
        v.filter((b) => !!b),
        e === "details" ? "SIM Details" : "SIM Inventory"
      );
    }
  }, [o, e, c, t]), { networkStatusGroups: f } = ht(), g = a.networkStatus?.includes("PENDING"), { organizationRole: p } = Be(), d = ["admin", "manager"].includes(p) && (e === "inventory" && ["all", "preflight"].includes(n ?? "") || e === "details" && !g && (f?.predeployment?.findIndex(
    (h) => a.networkStatus?.localeCompare(h) === 0
  ) ?? -1) !== -1);
  return V(
    () => d && {
      children: "End testing and activate...",
      iconStart: "Lightning",
      disabled: r,
      onClick: u,
      limit: 1e4,
      id: `sim${e}-dataplan-forceactivate`
    },
    [e, r, u, d]
  );
}, pw = ({ context: e, selectedSims: t, disabled: r, segmentName: n }) => {
  const i = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: a } = Le(i), { deviceDetails: s } = Mt(i), { claimedDeviceId: o } = s ?? {}, c = Sn(), u = $(() => {
    if (!c)
      throw new Error("Legacy dashboard context is not available");
    const { onBulkChangePlan: d } = c;
    if (o)
      d([o], e === "details" ? "SIM Details" : "SIM Inventory");
    else {
      const h = [...t?.values() ?? []];
      d(
        h.filter((v) => !!v),
        e === "details" ? "SIM Details" : "SIM Inventory"
      );
    }
  }, [o, e, c, t]), { networkStatusGroups: f } = ht(), { organizationRole: g } = Be(), p = ["admin", "manager"].includes(g) && (e === "inventory" && ["all", "active"].includes(n ?? "") || e === "details" && !!s?.claimedDeviceId && (f?.deactivated?.findIndex(
    (d) => a.networkStatus?.localeCompare(d) === 0
  ) ?? -1) === -1 && (f?.predeployment?.findIndex(
    (d) => a.networkStatus?.localeCompare(d) === 0
  ) ?? -1) === -1);
  return V(
    () => p && {
      children: "Change data plan...",
      iconStart: "CellTower",
      disabled: r,
      onClick: u,
      limit: 1e3,
      id: `sim${e}-dataplan-changeplan`
    },
    [e, r, u, p]
  );
}, vE = ({ context: e, selectedSims: t, disabled: r, onActionTaken: n }) => {
  const i = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: a } = Le(i), { deviceDetails: s } = Mt(i), { claimedDeviceId: o } = s ?? {}, { onDeactivate: c } = Sn() ?? {}, u = $(
    (d) => {
      if (d.target.tagName !== "A") {
        if (!c)
          throw new Error("Tried to deactivate outside of legacy dashboard context.");
        if (o)
          c([o]);
        else {
          const h = [...t?.values() ?? []];
          c(h.filter((v) => !!v));
        }
        n();
      }
    },
    [o, n, c, t]
  ), { networkStatusGroups: f } = ht(), { organizationRole: g } = Be(), p = ["admin", "manager"].includes(g) && (f?.deactivated?.findIndex(
    (d) => a?.networkStatus?.localeCompare(d) === 0
  ) ?? -1) === -1;
  return V(
    () => p && {
      children: e === "details" ? "Deactivate SIM" : "Deactivate SIMs",
      iconStart: "LightningSlash",
      endContent: /* @__PURE__ */ l(
        Ae,
        {
          href: "https://hologram.docs.apiary.io/#",
          target: "_blank",
          rel: "noreferrer",
          type: "inline",
          style: { whiteSpace: "nowrap" },
          children: "API docs"
        }
      ),
      disabled: r,
      onClick: u,
      limit: 10,
      type: "destructive",
      id: `sim${e}-dataplan-deactivatesim`
    },
    [e, r, u, p]
  );
}, yE = ({
  context: e,
  selectedSims: t,
  handleModalOpen: r,
  onActionTaken: n,
  onSimsModified: i,
  disabled: a
}) => {
  const s = $(() => {
    r({
      modalName: "TagManagerModal",
      modalProps: { sims: t, onModalSuccess: i }
    }), n();
  }, [n, r, i, t]), o = e === "inventory";
  return V(
    () => o && {
      children: "Manage tags...",
      iconStart: "Tag",
      disabled: a,
      onClick: s,
      limit: 1e4,
      id: `sim${e}-manage-tags`
    },
    [e, a, s, o]
  );
}, bE = ({
  context: e,
  selectedSims: t,
  disabled: r,
  handleModalOpen: n,
  onActionTaken: i,
  onSimsModified: a
}) => {
  const s = $(() => {
    n({
      modalName: "SimInventoryManageTunnelingModal",
      modalProps: { sims: t, onModalSuccess: a }
    }), i();
  }, [i, n, a, t]), o = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: c } = Le(o), { networkStatusGroups: u } = ht(), { releaseFlags: f } = Be(), p = f.has(Ht.FEATURE_SPACEBRIDGE_TUNNELING) && (u?.deactivated?.findIndex(
    (d) => c.networkStatus?.localeCompare(d) === 0
  ) ?? -1) === -1;
  return V(
    () => p && {
      children: "Manage device tunneling...",
      iconStart: "SpacebridgeEnabled",
      disabled: r,
      onClick: s,
      limit: 10,
      id: `sim${e}-manage-devicetunneling`
    },
    [e, r, s, p]
  );
}, SE = ({
  context: e,
  segmentName: t,
  selectedSims: r,
  handleModalOpen: n,
  onActionTaken: i,
  onSimsModified: a,
  disabled: s
}) => {
  const o = e === "details" && r ? [...r.keys()][0] : void 0, c = $(() => {
    n({
      modalName: "SimInventoryBulkUpdateStateModal",
      modalProps: { action: "pause", sims: r, onModalSuccess: a }
    }), i();
  }, [i, n, a, r]), { simDetails: u } = Le(e === "details" && o ? o : void 0), f = e === "inventory" && ["active", "all"].includes(t ?? "") || !!o && u.networkStatus?.localeCompare("LIVE") === 0;
  return V(
    () => f && {
      children: "Pause data usage...",
      iconStart: "Pause",
      disabled: s,
      onClick: c,
      id: `sim${e}-dataplan-pause`
    },
    [e, s, c, f]
  );
}, wE = ({ context: e, selectedSims: t, onActionTaken: r, disabled: n }) => {
  const i = e === "details" && t ? [...t.keys()][0] : void 0, { deviceDetails: a } = Mt(i), { claimedDeviceId: s } = a ?? {}, { rename: o } = Sn() ?? {}, c = $(
    (f) => {
      if (f.target.tagName !== "A") {
        if (!o)
          throw new Error("Tried to bulk rename outside of legacy dashboard context.");
        if (s)
          o([s]);
        else {
          const g = [...t?.values() ?? []];
          o(g.filter((p) => !!p));
        }
        r();
      }
    },
    [s, r, o, t]
  );
  return e !== "details" && {
    children: t?.size === 1 ? "Rename SIM..." : "Rename SIMs...",
    iconStart: "SIM",
    onClick: c,
    limit: 1e4,
    disabled: n,
    id: `sim${e}-manage-renamesims`
  };
}, IE = ({
  context: e,
  segmentName: t,
  selectedSims: r,
  handleModalOpen: n,
  onActionTaken: i,
  onSimsModified: a,
  disabled: s
}) => {
  const o = e === "details" && r ? [...r.keys()][0] : void 0, c = $(() => {
    n({
      modalName: "SimInventoryBulkUpdateStateModal",
      modalProps: { action: "resume", sims: r, onModalSuccess: a }
    }), i();
  }, [i, n, a, r]), { simDetails: u } = Le(e === "details" && o ? o : void 0), f = e === "inventory" && ["active", "all"].includes(t ?? "") || !!o && u.networkStatus?.localeCompare("PAUSED-USER") === 0;
  return V(
    () => f && {
      children: "Resume data usage...",
      iconStart: "Play",
      disabled: s,
      onClick: c,
      id: `sim${e}-dataplan-resume`
    },
    [e, s, c, f]
  );
}, CE = ({
  context: e,
  selectedSims: t,
  handleModalOpen: r,
  onActionTaken: n,
  onSimsModified: i,
  disabled: a,
  segmentName: s
}) => {
  const o = $(() => {
    r({
      modalName: "SimInventoryBulkSendMessageModal",
      modalProps: { sims: t, onModalSuccess: i }
    }), n();
  }, [n, r, i, t]), { simDetails: c } = Le(
    e === "details" && t ? [...t.keys()][0] : void 0
  ), { networkStatusGroups: u } = ht(), f = e === "inventory" && s !== "deactivated" || e === "details" && (u?.deactivated?.findIndex(
    (g) => c.networkStatus?.localeCompare(g) === 0
  ) ?? -1) === -1;
  return V(
    () => f && {
      children: t?.size === 1 ? "Send message to SIM..." : "Send message to SIMs...",
      iconStart: "Chat",
      disabled: a,
      onClick: o,
      id: `sim${e}-messaging-sendsms`
    },
    [e, a, o, t?.size, f]
  );
}, PE = ({
  context: e,
  selectedSims: t,
  disabled: r,
  handleModalOpen: n,
  onSimsModified: i,
  onActionTaken: a
}) => {
  const s = $(() => {
    n({
      modalName: "SetUsageAlertsModal",
      modalProps: { sims: t, onModalSuccess: i }
    }), a();
  }, [a, n, i, t]), o = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: c } = Le(o), { networkStatusGroups: u } = ht(), { organizationRole: f, releaseFlags: g } = Be(), p = g.has(Ht.FEATURE_DATA_USAGE_ALERTS), d = ["admin", "manager", "editor"].includes(f) && p && (u?.deactivated?.findIndex(
    (h) => c.networkStatus?.localeCompare(h) === 0
  ) ?? -1) === -1;
  return V(
    () => d && {
      id: `sim${e}-datausagelimits-updatealert`,
      disabled: r,
      iconStart: "Warning",
      children: "Set data usage alert...",
      onClick: s
    },
    [e, r, s, d]
  );
}, TE = ({
  context: e,
  selectedSims: t,
  disabled: r,
  onActionTaken: n
}) => {
  const i = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: a } = Le(i), { deviceDetails: s } = Mt(i), { claimedDeviceId: o } = s ?? {}, { setDataUsageLimits: c } = Sn() ?? {}, u = $(
    (d) => {
      if (d.target.tagName !== "A") {
        if (!c)
          throw new Error("Tried to set data usage limit outside of legacy dashboard context.");
        if (o)
          c([o]);
        else {
          const h = [...t?.values() ?? []];
          c(h.filter((v) => !!v));
        }
        n();
      }
    },
    [o, n, c, t]
  ), { networkStatusGroups: f } = ht(), { organizationRole: g } = Be(), p = ["admin", "manager", "editor"].includes(g) && (f?.deactivated?.findIndex(
    (d) => a?.networkStatus?.localeCompare(d) === 0
  ) ?? -1) === -1;
  return V(
    () => p && {
      id: `sim${e}-datausagelimits-updatelimit`,
      disabled: r,
      limit: 10,
      iconStart: "Gauge",
      children: "Set data usage limit...",
      onClick: u
    },
    [e, r, u, p]
  );
}, _E = ({
  context: e,
  selectedSims: t,
  handleModalOpen: r,
  onActionTaken: n,
  onSimsModified: i,
  disabled: a
}) => {
  const s = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: o } = Le(s), c = $(() => {
    r({
      modalName: "SimulateMessageToApi",
      modalProps: { sims: t, onModalSuccess: i }
    }), n();
  }, [n, r, i, t]), { networkStatusGroups: u } = ht(), { releaseFlags: f } = Be(), g = f.has(Ht.FEATURE_HOLOGRAM_CLOUD_MESSAGING), p = e === "details" && g && (u?.deactivated?.findIndex(
    (d) => o.networkStatus?.localeCompare(d) === 0
  ) ?? -1) === -1;
  return V(
    () => p && {
      children: "Simulate message to API...",
      iconStart: "Chat",
      disabled: a,
      onClick: c,
      id: `sim${e}-messaging-simulatemessage`
    },
    [e, a, c, p]
  );
}, gl = (e) => {
  const { isLoading: t, error: r, simDetails: n } = Le(e);
  return { showEuiccInfo: !t && !r && !!n.simType && !n.simCardId?.startsWith("UICC"), isLoading: t, error: r };
}, EE = ({
  context: e,
  selectedSims: t,
  handleModalOpen: r,
  onActionTaken: n,
  onSimsModified: i,
  disabled: a
}) => {
  const s = $(() => {
    r({
      modalName: "SimInventorySwitchProfilesModal",
      modalProps: { sims: t, onModalSuccess: i }
    }), n();
  }, [n, r, i, t]), o = e === "details" && t ? [...t.keys()][0] : void 0, { simDetails: c } = Le(o), u = gl(o), { organizationRole: f, releaseFlags: g } = Be(), d = g.has(Ht.MANAGE_SINGLE_SIM_PROFILE_SWAP) && e === "details" && u && !!c.fallbackInstalled && !!c.fallbackEnabled && ["LIVE", "TEST-ACTIVATE", "FACTORY"].includes(c.networkStatus ?? "") && (f === "manager" || f === "admin") && (c.profilesInstalledOnCard ?? 0) > 1;
  return V(
    () => d && {
      children: "Switch profiles...",
      iconStart: "SwapSIM",
      disabled: a,
      onClick: s,
      id: `sim${e}-dataplan-switchprofiles`
    },
    [e, a, s, d]
  );
}, OE = ({
  context: e,
  selectedSims: t,
  disabled: r,
  onActionTaken: n
}) => {
  const i = e === "details" && t ? [...t.keys()][0] : void 0, { deviceDetails: a } = Mt(i), { claimedDeviceId: s } = a ?? {}, { transferToOrganization: o } = Sn() ?? {}, c = $(
    (g) => {
      if (g.target.tagName !== "A") {
        if (!o)
          throw new Error("Tried to transfer to organization outside of legacy dashboard context.");
        if (s)
          o([s]);
        else {
          const p = [...t?.values() ?? []];
          o(p.filter((d) => !!d));
        }
        n();
      }
    },
    [s, n, o, t]
  ), { organizationRole: u } = Be(), f = ["admin", "manager"].includes(u);
  return V(
    () => f && {
      children: "Transfer to organization...",
      iconStart: "Transfer",
      disabled: r,
      onClick: c,
      id: `sim${e}-manage-transfertoorganization`,
      limit: 10
    },
    [e, r, c, f]
  );
}, ua = (e) => !!e, da = (e, t, r) => {
  const n = [];
  return e.forEach((i) => {
    if (i.limit && t > i.limit) {
      const a = r.get(i.limit);
      a ? a.push(i) : r.set(i.limit, [i]);
    } else
      n.push(i);
  }), n;
}, NE = ({ subtitle: e, context: t, selectedSims: r, ...n }) => {
  const i = { context: t, selectedSims: r, ...n }, a = gE(i), s = V(
    () => [a].filter(ua),
    [a]
  ), o = SE(i), c = IE(i), u = EE(i), f = V(
    () => [o, c, u].filter(ua),
    [o, c, u]
  ), g = yE(i), p = wE(i), d = CE(i), h = _E(i), v = V(
    () => [g, p, d, h].filter(
      ua
    ),
    [g, p, d, h]
  ), b = pw(i), m = PE(i), S = TE(i), I = bE(i), C = OE(i), T = V(
    () => [
      S,
      m,
      b,
      I,
      C
    ].filter(ua),
    [
      b,
      I,
      m,
      S,
      C
    ]
  ), E = vE(i), N = V(
    () => [E].filter(ua),
    [E]
  );
  return V(() => {
    const y = [], w = /* @__PURE__ */ new Map();
    let P = !1;
    const _ = da(
      s,
      r?.size ?? 0,
      w
    );
    _.length > 0 && (y.push({
      label: e,
      items: _
    }), P = !0);
    const D = da(
      f,
      r?.size ?? 0,
      w
    );
    D.length > 0 && (y.push({
      label: P ? void 0 : e,
      items: D
    }), P = !0);
    const R = da(
      v,
      r?.size ?? 0,
      w
    );
    R.length > 0 && (y.push({
      label: P ? void 0 : e,
      items: R
    }), P = !0);
    const x = da(T, r?.size ?? 0, w);
    x.length > 0 && (y.push({
      label: P ? void 0 : e,
      items: x
    }), P = !0);
    const F = da(
      N,
      r?.size ?? 0,
      w
    );
    return F.length > 0 && (y.push({
      label: P ? void 0 : e,
      items: F
    }), P = !0), w.size > 0 && [...w.entries()].sort((W, A) => A[0] - W[0]).forEach(([W, A]) => {
      y.push({
        label: `Only available for ${Ee(W)} SIMs or less`,
        items: A.map((M) => ({ ...M, disabled: !0 }))
      });
    }), y;
  }, [
    s,
    T,
    f,
    N,
    v,
    r?.size,
    e
  ]);
}, gw = ({
  buttonText: e = "Manage SIMs",
  subtitle: t,
  isLoading: r = !1,
  disabled: n = !1,
  selectedSims: i,
  context: a,
  segmentName: s,
  handleModalOpen: o,
  onSimsModified: c,
  variant: u = "secondary",
  placement: f,
  className: g
}) => {
  const [p, d] = Z(!1), h = we(null), v = p && !r, b = $(
    (I) => {
      if (v) {
        let C = !1, T = I.target;
        for (; T !== null && !C; )
          T = T.parentElement, C = T === h.current;
        C || d(!1);
      }
    },
    [v]
  );
  Pe(() => (document.body.addEventListener("click", b), () => {
    document.body.removeEventListener("click", b);
  }), [b]);
  const m = NE({
    context: a,
    segmentName: s,
    selectedSims: i,
    handleModalOpen: o,
    subtitle: t,
    disabled: n,
    onSimsModified: c,
    open: v,
    onActionTaken: () => d(!1)
  }), S = $(() => {
    d((I) => !I);
  }, []);
  return /* @__PURE__ */ l("div", { className: J(Ym.wrapper, g), ref: h, children: /* @__PURE__ */ l(
    Kn,
    {
      className: Ym.dropdownPanel,
      content: m,
      open: v,
      onOpenChange: d,
      placement: f,
      children: /* @__PURE__ */ l(
        Y,
        {
          iconEnd: v ? "ChevronSingleNorth" : "ChevronSingleSouth",
          variant: u,
          onClick: S,
          disabled: r,
          id: `sim${a}-actions-managesims`,
          children: e
        }
      )
    }
  ) });
}, fh = ({
  image: e,
  alt: t,
  className: r,
  imgClassName: n,
  setDimensions: i = !0
}) => {
  if (!e)
    return null;
  let a;
  return i && e?.img?.h && e.img.w && (a = { height: `${e.img.h}px`, width: `${e.img.w}px` }), /* @__PURE__ */ O("picture", { className: J(r), children: [
    Object.entries(e.sources).map(([s, o]) => {
      if (typeof o?.map != "function")
        return null;
      const c = o.map((u) => `${u.src}`).join(", ");
      return /* @__PURE__ */ l("source", { type: `image/${s}`, srcSet: c }, `${s}-${c}`);
    }),
    /* @__PURE__ */ l(
      "img",
      {
        src: e.img.src,
        alt: t,
        className: J(n),
        style: a,
        decoding: "async"
      }
    )
  ] });
}, DE = "hyperdashboard-ClickToCopy-module-DgcgbW-clickToCopy", RE = "hyperdashboard-ClickToCopy-module-DgcgbW-copyIcon", kE = "hyperdashboard-ClickToCopy-module-DgcgbW-copySuccess", Xl = {
  clickToCopy: DE,
  copyIcon: RE,
  copySuccess: kE
}, Ai = ({
  value: e,
  label: t,
  className: r
}) => {
  const [n, i] = Z(!1), a = (s) => {
    navigator.clipboard.writeText(s), i(!0), setTimeout(() => {
      i(!1);
    }, 1500);
  };
  return /* @__PURE__ */ O(
    "button",
    {
      type: "button",
      className: wt(Xl.clickToCopy, r),
      onClick: () => {
        a(e);
      },
      children: [
        t,
        n ? /* @__PURE__ */ l(
          ye,
          {
            name: "CircleCheckmark",
            size: "medium",
            fill: "DdsColorIconSuccess",
            className: Xl.copySuccess
          }
        ) : /* @__PURE__ */ l(ye, { className: Xl.copyIcon, name: "Copy", size: "medium", fill: "currentColor" })
      ]
    }
  );
}, AE = "hyperdashboard-ProfileAndICCID-module-NkTGOa-numeric", Km = {
  numeric: AE
}, xE = ({ profileUrl: e, hologramSimId: t }) => {
  const { simDetails: r, error: n, isLoading: i } = Le(t);
  return n ? null : i ? "Loading..." : /* @__PURE__ */ O("div", { children: [
    /* @__PURE__ */ l(
      Ae,
      {
        type: "inline",
        to: e,
        ariaLabel: "View profile",
        className: J(!r.profileName && Km.numeric),
        children: r.profileName ?? r.activeProfileIccid
      }
    ),
    r.profileName && /* @__PURE__ */ O("span", { className: Km.numeric, children: [
      " ",
      /* @__PURE__ */ l(
        Ai,
        {
          value: r.activeProfileIccid ?? "",
          label: r.activeProfileIccid
        }
      )
    ] })
  ] });
}, FE = ({ hologramSimIds: e, organizationId: t }) => {
  const r = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/name`;
  return $(
    async (i, a) => {
      if (!r || !e || e.size === 0)
        return;
      const s = {
        hologramSimIds: [...e.keys()],
        name: i,
        organizationId: t
      };
      return a !== void 0 && (s.applySuffix = a), await ft({
        url: r,
        body: s
      });
    },
    [e, t, r]
  );
}, Ir = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/billing` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    simBilling: V(() => r?.simBilling ?? {}, [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, ec = Intl.NumberFormat(Ln, { maximumFractionDigits: 0 }), Jm = Intl.NumberFormat(Ln, {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
}), $E = Intl.NumberFormat(Ln, {
  unit: "byte",
  style: "unit",
  unitDisplay: "long"
}), It = (e, t = "short", r) => {
  if (!e && e !== 0)
    return;
  const n = Number(e);
  if (t === "bytes")
    return $E.format(n);
  if (n < 1e3)
    return `${ec.format(n)} B`;
  let i = 0, a = "";
  t === "long" ? n < 2e6 ? (i = Math.round(n / 10) / 100, a = "KB") : n < 2e9 ? (i = Math.round(n / 1e4) / 100, a = "MB") : n < 2e12 ? (i = Math.round(n / 1e7) / 100, a = "GB") : (i = Math.round(n / 1e10) / 100, a = "TB") : t === "short" && (n < 1e6 ? (i = Math.round(n / 10) / 100, a = "KB") : n < 1e9 ? (i = Math.round(n / 1e4) / 100, a = "MB") : n < 1e12 ? (i = Math.round(n / 1e7) / 100, a = "GB") : (i = Math.round(n / 1e10) / 100, a = "TB"));
  let s = Jm;
  return i % 1 === 0 && (s = ec), r === "integer" && (s = ec), r === "decimal" && (s = Jm), `${s.format(i)} ${a}`;
}, ME = "hyperdashboard-IncludedDataField-module-3Msr-q-diminished", LE = {
  diminished: ME
}, vw = ({
  hologramSimId: e,
  showPauseInfo: t = !0,
  direction: r = "column"
}) => {
  const {
    simDetails: n,
    error: i,
    isLoading: a
  } = Le(e), {
    simBilling: s,
    error: o,
    isLoading: c
  } = Ir(e), {
    networkStatusGroups: u,
    isLoading: f,
    error: g
  } = ht(), p = o || i || g, d = c || a || f, { networkStatus: h } = n, { organizationBillingMethod: v, dataIncluded: b, dataUsageLimit: m, planType: S, poolDataLimit: I } = s, C = !h || !!u?.predeployment?.includes(h), T = v === "prepaid", E = v === "postpaid", N = (b ?? 0) === 0 && !I, { organizationRole: y } = Be();
  return d || p || C || !["admin", "manager", "editor"].includes(y) ? null : /* @__PURE__ */ l(
    ee,
    {
      label: "Included data",
      value: /* @__PURE__ */ O(le, { children: [
        I && `${It(I, "short")} data pool `,
        N && S,
        !N && It(b, "short"),
        " ",
        t && /* @__PURE__ */ O("span", { className: LE.diminished, children: [
          T && typeof m < "u" && m > 0 && `(pause at ${It(m, "short")})`,
          (!m || m === 0) && !E && "(no limit)"
        ] })
      ] }),
      direction: r
    }
  );
}, jE = "hyperdashboard-SimDataUsage-module-oaRlRW-byteCount", WE = "hyperdashboard-SimDataUsage-module-oaRlRW-diminished", UE = "hyperdashboard-SimDataUsage-module-oaRlRW-popover", no = {
  byteCount: jE,
  diminished: WE,
  popover: UE
}, yw = ({ hologramSimId: e }) => {
  const { simDetails: t, error: r, isLoading: n } = Le(e), { billingPeriodUsage: i, preflightUsage: a, activationTime: s } = t, o = s ? i ?? 0 : a ?? 0;
  return r ? null : n ? "Loading..." : /* @__PURE__ */ l(
    et,
    {
      className: no.popover,
      content: It(o, "bytes"),
      id: "byte-count",
      children: /* @__PURE__ */ O("div", { className: no.byteCount, children: [
        o === 0 && /* @__PURE__ */ l("span", { className: no.diminished, children: "—" }),
        o > 0 && It(o, "long", "decimal"),
        " ",
        !s && /* @__PURE__ */ l("span", { className: no.diminished, children: "of 100 KB" })
      ] })
    }
  );
};
var xs = (e) => e.type === "checkbox", Oi = (e) => e instanceof Date, Xt = (e) => e == null;
const bw = (e) => typeof e == "object";
var Rt = (e) => !Xt(e) && !Array.isArray(e) && bw(e) && !Oi(e), VE = (e) => Rt(e) && e.target ? xs(e.target) ? e.target.checked : e.target.value : e, HE = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, qE = (e, t) => e.has(HE(t)), zE = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Rt(t) && t.hasOwnProperty("isPrototypeOf");
}, hh = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Nn(e) {
  let t;
  const r = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(hh && (e instanceof Blob || e instanceof FileList)) && (r || Rt(e)))
    if (t = r ? [] : {}, !r && !zE(e))
      t = e;
    else
      for (const n in e)
        e.hasOwnProperty(n) && (t[n] = Nn(e[n]));
  else
    return e;
  return t;
}
var Fs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Pt = (e) => e === void 0, be = (e, t, r) => {
  if (!t || !Rt(e))
    return r;
  const n = Fs(t.split(/[,[\].]+?/)).reduce((i, a) => Xt(i) ? i : i[a], e);
  return Pt(n) || n === e ? Pt(e[t]) ? r : e[t] : n;
};
const Xm = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, Vr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, on = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
_t.createContext(null);
var BE = (e, t, r, n = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(i, a, {
      get: () => {
        const s = a;
        return t._proxyFormState[s] !== Vr.all && (t._proxyFormState[s] = !n || Vr.all), e[s];
      }
    });
  return i;
}, _r = (e) => Rt(e) && !Object.keys(e).length, GE = (e, t, r, n) => {
  r(e);
  const { name: i, ...a } = e;
  return _r(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((s) => t[s] === Vr.all);
}, tc = (e) => Array.isArray(e) ? e : [e];
function QE(e) {
  const t = _t.useRef(e);
  t.current = e, _t.useEffect(() => {
    const r = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
var Xr = (e) => typeof e == "string", ZE = (e, t, r, n, i) => Xr(e) ? (n && t.watch.add(e), be(r, e, i)) : Array.isArray(e) ? e.map((a) => (n && t.watch.add(a), be(r, a))) : (n && (t.watchAll = !0), r), mh = (e) => /^\w*$/.test(e), Sw = (e) => Fs(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function dt(e, t, r) {
  let n = -1;
  const i = mh(t) ? [t] : Sw(t), a = i.length, s = a - 1;
  for (; ++n < a; ) {
    const o = i[n];
    let c = r;
    if (n !== s) {
      const u = e[o];
      c = Rt(u) || Array.isArray(u) ? u : isNaN(+i[n + 1]) ? {} : [];
    }
    e[o] = c, e = e[o];
  }
  return e;
}
var YE = (e, t, r, n, i) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [n]: i || !0
  }
} : {};
const wf = (e, t, r) => {
  for (const n of r || Object.keys(e)) {
    const i = be(e, n);
    if (i) {
      const { _f: a, ...s } = i;
      if (a && t(a.name)) {
        if (a.ref.focus) {
          a.ref.focus();
          break;
        } else if (a.refs && a.refs[0].focus) {
          a.refs[0].focus();
          break;
        }
      } else Rt(s) && wf(s, t);
    }
  }
};
var ep = (e) => ({
  isOnSubmit: !e || e === Vr.onSubmit,
  isOnBlur: e === Vr.onBlur,
  isOnChange: e === Vr.onChange,
  isOnAll: e === Vr.all,
  isOnTouch: e === Vr.onTouched
}), tp = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((n) => e.startsWith(n) && /^\.\w+/.test(e.slice(n.length)))), KE = (e, t, r) => {
  const n = Fs(be(e, r));
  return dt(n, "root", t[r]), dt(e, r, n), e;
}, xi = (e) => typeof e == "boolean", ph = (e) => e.type === "file", Fn = (e) => typeof e == "function", Ho = (e) => {
  if (!hh)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Do = (e) => Xr(e), gh = (e) => e.type === "radio", qo = (e) => e instanceof RegExp;
const rp = {
  value: !1,
  isValid: !1
}, np = { value: !0, isValid: !0 };
var ww = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Pt(e[0].attributes.value) ? Pt(e[0].value) || e[0].value === "" ? np : { value: e[0].value, isValid: !0 } : np
    ) : rp;
  }
  return rp;
};
const ip = {
  isValid: !1,
  value: null
};
var Iw = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, ip) : ip;
function ap(e, t, r = "validate") {
  if (Do(e) || Array.isArray(e) && e.every(Do) || xi(e) && !e)
    return {
      type: r,
      message: Do(e) ? e : "",
      ref: t
    };
}
var hi = (e) => Rt(e) && !qo(e) ? e : {
  value: e,
  message: ""
}, sp = async (e, t, r, n, i) => {
  const { ref: a, refs: s, required: o, maxLength: c, minLength: u, min: f, max: g, pattern: p, validate: d, name: h, valueAsNumber: v, mount: b, disabled: m } = e._f, S = be(t, h);
  if (!b || m)
    return {};
  const I = s ? s[0] : a, C = (D) => {
    n && I.reportValidity && (I.setCustomValidity(xi(D) ? "" : D || ""), I.reportValidity());
  }, T = {}, E = gh(a), N = xs(a), y = E || N, w = (v || ph(a)) && Pt(a.value) && Pt(S) || Ho(a) && a.value === "" || S === "" || Array.isArray(S) && !S.length, P = YE.bind(null, h, r, T), _ = (D, R, x, F = on.maxLength, W = on.minLength) => {
    const A = D ? R : x;
    T[h] = {
      type: D ? F : W,
      message: A,
      ref: a,
      ...P(D ? F : W, A)
    };
  };
  if (i ? !Array.isArray(S) || !S.length : o && (!y && (w || Xt(S)) || xi(S) && !S || N && !ww(s).isValid || E && !Iw(s).isValid)) {
    const { value: D, message: R } = Do(o) ? { value: !!o, message: o } : hi(o);
    if (D && (T[h] = {
      type: on.required,
      message: R,
      ref: I,
      ...P(on.required, R)
    }, !r))
      return C(R), T;
  }
  if (!w && (!Xt(f) || !Xt(g))) {
    let D, R;
    const x = hi(g), F = hi(f);
    if (!Xt(S) && !isNaN(S)) {
      const W = a.valueAsNumber || S && +S;
      Xt(x.value) || (D = W > x.value), Xt(F.value) || (R = W < F.value);
    } else {
      const W = a.valueAsDate || new Date(S), A = (B) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + B), M = a.type == "time", j = a.type == "week";
      Xr(x.value) && S && (D = M ? A(S) > A(x.value) : j ? S > x.value : W > new Date(x.value)), Xr(F.value) && S && (R = M ? A(S) < A(F.value) : j ? S < F.value : W < new Date(F.value));
    }
    if ((D || R) && (_(!!D, x.message, F.message, on.max, on.min), !r))
      return C(T[h].message), T;
  }
  if ((c || u) && !w && (Xr(S) || i && Array.isArray(S))) {
    const D = hi(c), R = hi(u), x = !Xt(D.value) && S.length > +D.value, F = !Xt(R.value) && S.length < +R.value;
    if ((x || F) && (_(x, D.message, R.message), !r))
      return C(T[h].message), T;
  }
  if (p && !w && Xr(S)) {
    const { value: D, message: R } = hi(p);
    if (qo(D) && !S.match(D) && (T[h] = {
      type: on.pattern,
      message: R,
      ref: a,
      ...P(on.pattern, R)
    }, !r))
      return C(R), T;
  }
  if (d) {
    if (Fn(d)) {
      const D = await d(S, t), R = ap(D, I);
      if (R && (T[h] = {
        ...R,
        ...P(on.validate, R.message)
      }, !r))
        return C(R.message), T;
    } else if (Rt(d)) {
      let D = {};
      for (const R in d) {
        if (!_r(D) && !r)
          break;
        const x = ap(await d[R](S, t), I, R);
        x && (D = {
          ...x,
          ...P(R, x.message)
        }, C(x.message), r && (T[h] = D));
      }
      if (!_r(D) && (T[h] = {
        ref: I,
        ...D
      }, !r))
        return T;
    }
  }
  return C(!0), T;
};
function JE(e, t) {
  const r = t.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    e = Pt(e) ? n++ : e[t[n++]];
  return e;
}
function XE(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Pt(e[t]))
      return !1;
  return !0;
}
function Ut(e, t) {
  const r = Array.isArray(t) ? t : mh(t) ? [t] : Sw(t), n = r.length === 1 ? e : JE(e, r), i = r.length - 1, a = r[i];
  return n && delete n[a], i !== 0 && (Rt(n) && _r(n) || Array.isArray(n) && XE(n)) && Ut(e, r.slice(0, -1)), e;
}
function rc() {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const a of e)
        a.next && a.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((a) => a !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}
var zo = (e) => Xt(e) || !bw(e);
function Qn(e, t) {
  if (zo(e) || zo(t))
    return e === t;
  if (Oi(e) && Oi(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (const i of r) {
    const a = e[i];
    if (!n.includes(i))
      return !1;
    if (i !== "ref") {
      const s = t[i];
      if (Oi(a) && Oi(s) || Rt(a) && Rt(s) || Array.isArray(a) && Array.isArray(s) ? !Qn(a, s) : a !== s)
        return !1;
    }
  }
  return !0;
}
var Cw = (e) => e.type === "select-multiple", eO = (e) => gh(e) || xs(e), nc = (e) => Ho(e) && e.isConnected, Pw = (e) => {
  for (const t in e)
    if (Fn(e[t]))
      return !0;
  return !1;
};
function Bo(e, t = {}) {
  const r = Array.isArray(e);
  if (Rt(e) || r)
    for (const n in e)
      Array.isArray(e[n]) || Rt(e[n]) && !Pw(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, Bo(e[n], t[n])) : Xt(e[n]) || (t[n] = !0);
  return t;
}
function Tw(e, t, r) {
  const n = Array.isArray(e);
  if (Rt(e) || n)
    for (const i in e)
      Array.isArray(e[i]) || Rt(e[i]) && !Pw(e[i]) ? Pt(t) || zo(r[i]) ? r[i] = Array.isArray(e[i]) ? Bo(e[i], []) : { ...Bo(e[i]) } : Tw(e[i], Xt(t) ? {} : t[i], r[i]) : r[i] = !Qn(e[i], t[i]);
  return r;
}
var ic = (e, t) => Tw(e, t, Bo(t)), _w = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: n }) => Pt(e) ? e : t ? e === "" ? NaN : e && +e : r && Xr(e) ? new Date(e) : n ? n(e) : e;
function ac(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((r) => r.disabled) : t.disabled))
    return ph(t) ? t.files : gh(t) ? Iw(e.refs).value : Cw(t) ? [...t.selectedOptions].map(({ value: r }) => r) : xs(t) ? ww(e.refs).value : _w(Pt(t.value) ? e.ref.value : t.value, e);
}
var tO = (e, t, r, n) => {
  const i = {};
  for (const a of e) {
    const s = be(t, a);
    s && dt(i, a, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: n
  };
}, fa = (e) => Pt(e) ? e : qo(e) ? e.source : Rt(e) ? qo(e.value) ? e.value.source : e.value : e, rO = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function op(e, t, r) {
  const n = be(e, r);
  if (n || mh(r))
    return {
      error: n,
      name: r
    };
  const i = r.split(".");
  for (; i.length; ) {
    const a = i.join("."), s = be(t, a), o = be(e, a);
    if (s && !Array.isArray(s) && r !== a)
      return { name: r };
    if (o && o.type)
      return {
        name: a,
        error: o
      };
    i.pop();
  }
  return {
    name: r
  };
}
var nO = (e, t, r, n, i) => i.isOnAll ? !1 : !r && i.isOnTouch ? !(t || e) : (r ? n.isOnBlur : i.isOnBlur) ? !e : (r ? n.isOnChange : i.isOnChange) ? e : !0, iO = (e, t) => !Fs(be(e, t)).length && Ut(e, t);
const aO = {
  mode: Vr.onSubmit,
  reValidateMode: Vr.onChange,
  shouldFocusError: !0
};
function sO(e = {}, t) {
  let r = {
    ...aO,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Fn(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, i = {}, a = Rt(r.defaultValues) || Rt(r.values) ? Nn(r.defaultValues || r.values) || {} : {}, s = r.shouldUnregister ? {} : Nn(a), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, c = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, f = 0;
  const g = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, p = {
    values: rc(),
    array: rc(),
    state: rc()
  }, d = e.resetOptions && e.resetOptions.keepDirtyValues, h = ep(r.mode), v = ep(r.reValidateMode), b = r.criteriaMode === Vr.all, m = (k) => (z) => {
    clearTimeout(f), f = setTimeout(k, z);
  }, S = async (k) => {
    if (g.isValid || k) {
      const z = r.resolver ? _r((await w()).errors) : await _(i, !0);
      z !== n.isValid && p.state.next({
        isValid: z
      });
    }
  }, I = (k) => g.isValidating && p.state.next({
    isValidating: k
  }), C = (k, z = [], U, ie, ae = !0, ne = !0) => {
    if (ie && U) {
      if (o.action = !0, ne && Array.isArray(be(i, k))) {
        const me = U(be(i, k), ie.argA, ie.argB);
        ae && dt(i, k, me);
      }
      if (ne && Array.isArray(be(n.errors, k))) {
        const me = U(be(n.errors, k), ie.argA, ie.argB);
        ae && dt(n.errors, k, me), iO(n.errors, k);
      }
      if (g.touchedFields && ne && Array.isArray(be(n.touchedFields, k))) {
        const me = U(be(n.touchedFields, k), ie.argA, ie.argB);
        ae && dt(n.touchedFields, k, me);
      }
      g.dirtyFields && (n.dirtyFields = ic(a, s)), p.state.next({
        name: k,
        isDirty: R(k, z),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      dt(s, k, z);
  }, T = (k, z) => {
    dt(n.errors, k, z), p.state.next({
      errors: n.errors
    });
  }, E = (k, z, U, ie) => {
    const ae = be(i, k);
    if (ae) {
      const ne = be(s, k, Pt(U) ? be(a, k) : U);
      Pt(ne) || ie && ie.defaultChecked || z ? dt(s, k, z ? ne : ac(ae._f)) : W(k, ne), o.mount && S();
    }
  }, N = (k, z, U, ie, ae) => {
    let ne = !1, me = !1;
    const Te = {
      name: k
    };
    if (!U || ie) {
      g.isDirty && (me = n.isDirty, n.isDirty = Te.isDirty = R(), ne = me !== Te.isDirty);
      const Ce = Qn(be(a, k), z);
      me = be(n.dirtyFields, k), Ce ? Ut(n.dirtyFields, k) : dt(n.dirtyFields, k, !0), Te.dirtyFields = n.dirtyFields, ne = ne || g.dirtyFields && me !== !Ce;
    }
    if (U) {
      const Ce = be(n.touchedFields, k);
      Ce || (dt(n.touchedFields, k, U), Te.touchedFields = n.touchedFields, ne = ne || g.touchedFields && Ce !== U);
    }
    return ne && ae && p.state.next(Te), ne ? Te : {};
  }, y = (k, z, U, ie) => {
    const ae = be(n.errors, k), ne = g.isValid && xi(z) && n.isValid !== z;
    if (e.delayError && U ? (u = m(() => T(k, U)), u(e.delayError)) : (clearTimeout(f), u = null, U ? dt(n.errors, k, U) : Ut(n.errors, k)), (U ? !Qn(ae, U) : ae) || !_r(ie) || ne) {
      const me = {
        ...ie,
        ...ne && xi(z) ? { isValid: z } : {},
        errors: n.errors,
        name: k
      };
      n = {
        ...n,
        ...me
      }, p.state.next(me);
    }
    I(!1);
  }, w = async (k) => r.resolver(s, r.context, tO(k || c.mount, i, r.criteriaMode, r.shouldUseNativeValidation)), P = async (k) => {
    const { errors: z } = await w();
    if (k)
      for (const U of k) {
        const ie = be(z, U);
        ie ? dt(n.errors, U, ie) : Ut(n.errors, U);
      }
    else
      n.errors = z;
    return z;
  }, _ = async (k, z, U = {
    valid: !0
  }) => {
    for (const ie in k) {
      const ae = k[ie];
      if (ae) {
        const { _f: ne, ...me } = ae;
        if (ne) {
          const Te = c.array.has(ne.name), Ce = await sp(ae, s, b, r.shouldUseNativeValidation && !z, Te);
          if (Ce[ne.name] && (U.valid = !1, z))
            break;
          !z && (be(Ce, ne.name) ? Te ? KE(n.errors, Ce, ne.name) : dt(n.errors, ne.name, Ce[ne.name]) : Ut(n.errors, ne.name));
        }
        me && await _(me, z, U);
      }
    }
    return U.valid;
  }, D = () => {
    for (const k of c.unMount) {
      const z = be(i, k);
      z && (z._f.refs ? z._f.refs.every((U) => !nc(U)) : !nc(z._f.ref)) && X(k);
    }
    c.unMount = /* @__PURE__ */ new Set();
  }, R = (k, z) => (k && z && dt(s, k, z), !Qn(L(), a)), x = (k, z, U) => ZE(k, c, {
    ...o.mount ? s : Pt(z) ? a : Xr(k) ? { [k]: z } : z
  }, U, z), F = (k) => Fs(be(o.mount ? s : a, k, e.shouldUnregister ? be(a, k, []) : [])), W = (k, z, U = {}) => {
    const ie = be(i, k);
    let ae = z;
    if (ie) {
      const ne = ie._f;
      ne && (!ne.disabled && dt(s, k, _w(z, ne)), ae = Ho(ne.ref) && Xt(z) ? "" : z, Cw(ne.ref) ? [...ne.ref.options].forEach((me) => me.selected = ae.includes(me.value)) : ne.refs ? xs(ne.ref) ? ne.refs.length > 1 ? ne.refs.forEach((me) => (!me.defaultChecked || !me.disabled) && (me.checked = Array.isArray(ae) ? !!ae.find((Te) => Te === me.value) : ae === me.value)) : ne.refs[0] && (ne.refs[0].checked = !!ae) : ne.refs.forEach((me) => me.checked = me.value === ae) : ph(ne.ref) ? ne.ref.value = "" : (ne.ref.value = ae, ne.ref.type || p.values.next({
        name: k,
        values: { ...s }
      })));
    }
    (U.shouldDirty || U.shouldTouch) && N(k, ae, U.shouldTouch, U.shouldDirty, !0), U.shouldValidate && B(k);
  }, A = (k, z, U) => {
    for (const ie in z) {
      const ae = z[ie], ne = `${k}.${ie}`, me = be(i, ne);
      (c.array.has(k) || !zo(ae) || me && !me._f) && !Oi(ae) ? A(ne, ae, U) : W(ne, ae, U);
    }
  }, M = (k, z, U = {}) => {
    const ie = be(i, k), ae = c.array.has(k), ne = Nn(z);
    dt(s, k, ne), ae ? (p.array.next({
      name: k,
      values: { ...s }
    }), (g.isDirty || g.dirtyFields) && U.shouldDirty && p.state.next({
      name: k,
      dirtyFields: ic(a, s),
      isDirty: R(k, ne)
    })) : ie && !ie._f && !Xt(ne) ? A(k, ne, U) : W(k, ne, U), tp(k, c) && p.state.next({ ...n }), p.values.next({
      name: k,
      values: { ...s }
    }), !o.mount && t();
  }, j = async (k) => {
    const z = k.target;
    let U = z.name, ie = !0;
    const ae = be(i, U), ne = () => z.type ? ac(ae._f) : VE(k);
    if (ae) {
      let me, Te;
      const Ce = ne(), Re = k.type === Xm.BLUR || k.type === Xm.FOCUS_OUT, xe = !rO(ae._f) && !r.resolver && !be(n.errors, U) && !ae._f.deps || nO(Re, be(n.touchedFields, U), n.isSubmitted, v, h), _e = tp(U, c, Re);
      dt(s, U, Ce), Re ? (ae._f.onBlur && ae._f.onBlur(k), u && u(0)) : ae._f.onChange && ae._f.onChange(k);
      const $e = N(U, Ce, Re, !1), jt = !_r($e) || _e;
      if (!Re && p.values.next({
        name: U,
        type: k.type,
        values: { ...s }
      }), xe)
        return g.isValid && S(), jt && p.state.next({ name: U, ..._e ? {} : $e });
      if (!Re && _e && p.state.next({ ...n }), I(!0), r.resolver) {
        const { errors: dr } = await w([U]), Wt = op(n.errors, i, U), nt = op(dr, i, Wt.name || U);
        me = nt.error, U = nt.name, Te = _r(dr);
      } else
        me = (await sp(ae, s, b, r.shouldUseNativeValidation))[U], ie = isNaN(Ce) || Ce === be(s, U, Ce), ie && (me ? Te = !1 : g.isValid && (Te = await _(i, !0)));
      ie && (ae._f.deps && B(ae._f.deps), y(U, Te, me, $e));
    }
  }, B = async (k, z = {}) => {
    let U, ie;
    const ae = tc(k);
    if (I(!0), r.resolver) {
      const ne = await P(Pt(k) ? k : ae);
      U = _r(ne), ie = k ? !ae.some((me) => be(ne, me)) : U;
    } else k ? (ie = (await Promise.all(ae.map(async (ne) => {
      const me = be(i, ne);
      return await _(me && me._f ? { [ne]: me } : me);
    }))).every(Boolean), !(!ie && !n.isValid) && S()) : ie = U = await _(i);
    return p.state.next({
      ...!Xr(k) || g.isValid && U !== n.isValid ? {} : { name: k },
      ...r.resolver || !k ? { isValid: U } : {},
      errors: n.errors,
      isValidating: !1
    }), z.shouldFocus && !ie && wf(i, (ne) => ne && be(n.errors, ne), k ? ae : c.mount), ie;
  }, L = (k) => {
    const z = {
      ...a,
      ...o.mount ? s : {}
    };
    return Pt(k) ? z : Xr(k) ? be(z, k) : k.map((U) => be(z, U));
  }, H = (k, z) => ({
    invalid: !!be((z || n).errors, k),
    isDirty: !!be((z || n).dirtyFields, k),
    isTouched: !!be((z || n).touchedFields, k),
    error: be((z || n).errors, k)
  }), q = (k) => {
    k && tc(k).forEach((z) => Ut(n.errors, z)), p.state.next({
      errors: k ? n.errors : {}
    });
  }, te = (k, z, U) => {
    const ie = (be(i, k, { _f: {} })._f || {}).ref;
    dt(n.errors, k, {
      ...z,
      ref: ie
    }), p.state.next({
      name: k,
      errors: n.errors,
      isValid: !1
    }), U && U.shouldFocus && ie && ie.focus && ie.focus();
  }, G = (k, z) => Fn(k) ? p.values.subscribe({
    next: (U) => k(x(void 0, z), U)
  }) : x(k, z, !0), X = (k, z = {}) => {
    for (const U of k ? tc(k) : c.mount)
      c.mount.delete(U), c.array.delete(U), z.keepValue || (Ut(i, U), Ut(s, U)), !z.keepError && Ut(n.errors, U), !z.keepDirty && Ut(n.dirtyFields, U), !z.keepTouched && Ut(n.touchedFields, U), !r.shouldUnregister && !z.keepDefaultValue && Ut(a, U);
    p.values.next({
      values: { ...s }
    }), p.state.next({
      ...n,
      ...z.keepDirty ? { isDirty: R() } : {}
    }), !z.keepIsValid && S();
  }, re = (k, z = {}) => {
    let U = be(i, k);
    const ie = xi(z.disabled);
    return dt(i, k, {
      ...U || {},
      _f: {
        ...U && U._f ? U._f : { ref: { name: k } },
        name: k,
        mount: !0,
        ...z
      }
    }), c.mount.add(k), U ? ie && dt(s, k, z.disabled ? void 0 : be(s, k, ac(U._f))) : E(k, !0, z.value), {
      ...ie ? { disabled: z.disabled } : {},
      ...r.progressive ? {
        required: !!z.required,
        min: fa(z.min),
        max: fa(z.max),
        minLength: fa(z.minLength),
        maxLength: fa(z.maxLength),
        pattern: fa(z.pattern)
      } : {},
      name: k,
      onChange: j,
      onBlur: j,
      ref: (ae) => {
        if (ae) {
          re(k, z), U = be(i, k);
          const ne = Pt(ae.value) && ae.querySelectorAll && ae.querySelectorAll("input,select,textarea")[0] || ae, me = eO(ne), Te = U._f.refs || [];
          if (me ? Te.find((Ce) => Ce === ne) : ne === U._f.ref)
            return;
          dt(i, k, {
            _f: {
              ...U._f,
              ...me ? {
                refs: [
                  ...Te.filter(nc),
                  ne,
                  ...Array.isArray(be(a, k)) ? [{}] : []
                ],
                ref: { type: ne.type, name: k }
              } : { ref: ne }
            }
          }), E(k, !1, void 0, ne);
        } else
          U = be(i, k, {}), U._f && (U._f.mount = !1), (r.shouldUnregister || z.shouldUnregister) && !(qE(c.array, k) && o.action) && c.unMount.add(k);
      }
    };
  }, oe = () => r.shouldFocusError && wf(i, (k) => k && be(n.errors, k), c.mount), ue = (k, z) => async (U) => {
    U && (U.preventDefault && U.preventDefault(), U.persist && U.persist());
    let ie = Nn(s);
    if (p.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const { errors: ae, values: ne } = await w();
      n.errors = ae, ie = ne;
    } else
      await _(i);
    Ut(n.errors, "root"), _r(n.errors) ? (p.state.next({
      errors: {}
    }), await k(ie, U)) : (z && await z({ ...n.errors }, U), oe(), setTimeout(oe)), p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: _r(n.errors),
      submitCount: n.submitCount + 1,
      errors: n.errors
    });
  }, de = (k, z = {}) => {
    be(i, k) && (Pt(z.defaultValue) ? M(k, be(a, k)) : (M(k, z.defaultValue), dt(a, k, z.defaultValue)), z.keepTouched || Ut(n.touchedFields, k), z.keepDirty || (Ut(n.dirtyFields, k), n.isDirty = z.defaultValue ? R(k, be(a, k)) : R()), z.keepError || (Ut(n.errors, k), g.isValid && S()), p.state.next({ ...n }));
  }, Q = (k, z = {}) => {
    const U = k || a, ie = Nn(U), ae = k && !_r(k) ? ie : a;
    if (z.keepDefaultValues || (a = U), !z.keepValues) {
      if (z.keepDirtyValues || d)
        for (const ne of c.mount)
          be(n.dirtyFields, ne) ? dt(ae, ne, be(s, ne)) : M(ne, be(ae, ne));
      else {
        if (hh && Pt(k))
          for (const ne of c.mount) {
            const me = be(i, ne);
            if (me && me._f) {
              const Te = Array.isArray(me._f.refs) ? me._f.refs[0] : me._f.ref;
              if (Ho(Te)) {
                const Ce = Te.closest("form");
                if (Ce) {
                  Ce.reset();
                  break;
                }
              }
            }
          }
        i = {};
      }
      s = e.shouldUnregister ? z.keepDefaultValues ? Nn(a) : {} : Nn(ae), p.array.next({
        values: { ...ae }
      }), p.values.next({
        values: { ...ae }
      });
    }
    c = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !o.mount && t(), o.mount = !g.isValid || !!z.keepIsValid, o.watch = !!e.shouldUnregister, p.state.next({
      submitCount: z.keepSubmitCount ? n.submitCount : 0,
      isDirty: z.keepDirty ? n.isDirty : !!(z.keepDefaultValues && !Qn(k, a)),
      isSubmitted: z.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: z.keepDirtyValues ? n.dirtyFields : z.keepDefaultValues && k ? ic(a, k) : {},
      touchedFields: z.keepTouched ? n.touchedFields : {},
      errors: z.keepErrors ? n.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, he = (k, z) => Q(Fn(k) ? k(s) : k, z);
  return {
    control: {
      register: re,
      unregister: X,
      getFieldState: H,
      handleSubmit: ue,
      setError: te,
      _executeSchema: w,
      _getWatch: x,
      _getDirty: R,
      _updateValid: S,
      _removeUnmounted: D,
      _updateFieldArray: C,
      _getFieldArray: F,
      _reset: Q,
      _resetDefaultValues: () => Fn(r.defaultValues) && r.defaultValues().then((k) => {
        he(k, r.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (k) => {
        n = {
          ...n,
          ...k
        };
      },
      _subjects: p,
      _proxyFormState: g,
      get _fields() {
        return i;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return o;
      },
      set _state(k) {
        o = k;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return c;
      },
      set _names(k) {
        c = k;
      },
      get _formState() {
        return n;
      },
      set _formState(k) {
        n = k;
      },
      get _options() {
        return r;
      },
      set _options(k) {
        r = {
          ...r,
          ...k
        };
      }
    },
    trigger: B,
    register: re,
    handleSubmit: ue,
    watch: G,
    setValue: M,
    getValues: L,
    reset: he,
    resetField: de,
    clearErrors: q,
    unregister: X,
    setError: te,
    setFocus: (k, z = {}) => {
      const U = be(i, k), ie = U && U._f;
      if (ie) {
        const ae = ie.refs ? ie.refs[0] : ie.ref;
        ae.focus && (ae.focus(), z.shouldSelect && ae.select());
      }
    },
    getFieldState: H
  };
}
function Lt(e = {}) {
  const t = _t.useRef(), r = _t.useRef(), [n, i] = _t.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Fn(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: Fn(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...sO(e, () => i((s) => ({ ...s }))),
    formState: n
  });
  const a = t.current.control;
  return a._options = e, QE({
    subject: a._subjects.state,
    next: (s) => {
      GE(s, a._proxyFormState, a._updateFormState) && i({ ...a._formState });
    }
  }), _t.useEffect(() => {
    e.values && !Qn(e.values, r.current) ? (a._reset(e.values, a._options.resetOptions), r.current = e.values) : a._resetDefaultValues();
  }, [e.values, a]), _t.useEffect(() => {
    a._state.mount || (a._updateValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), t.current.formState = BE(n, a), t.current;
}
const oO = "hyperdashboard-SimNameEdit-module-iJaHAa-actions", lO = "hyperdashboard-SimNameEdit-module-iJaHAa-textInput", cO = "hyperdashboard-SimNameEdit-module-iJaHAa-wrapper", sc = {
  actions: oO,
  textInput: lO,
  wrapper: cO
}, uO = ({ existingName: e, onSave: t, onCancel: r }) => {
  const [n, i] = Z(!1), [a, s] = Z(!0), { register: o, handleSubmit: c, setFocus: u, watch: f } = Lt({
    defaultValues: { newName: e }
  }), g = $(
    (b) => {
      i(!0);
      const m = b.newName?.trim();
      if (!m || m.length === 0 || !e || m.localeCompare(e) === 0) {
        u("newName", { shouldSelect: !0 }), i(!1);
        return;
      }
      t(m);
    },
    [e, t, u]
  );
  Pe(() => {
    u("newName", { shouldSelect: !0 }), s(!1);
  }, []);
  const p = $(() => {
    if (!e) {
      r();
      return;
    }
    (f("newName")?.localeCompare(e) ?? 0) === 0 ? r() : u("newName", { shouldSelect: !0 });
  }, [e, r, u, f]), d = $(
    (b) => {
      b.key === "Escape" && (b.stopPropagation(), p());
    },
    [p]
  ), h = we(null), v = $(
    (b) => {
      a || h.current?.contains(b.target) || (b.stopPropagation(), b.preventDefault(), p());
    },
    [a, p]
  );
  return Pe(() => (document.addEventListener("keyup", d), document.addEventListener("click", v), () => {
    document.removeEventListener("keyup", d), document.removeEventListener("click", v);
  }), [d, v]), /* @__PURE__ */ O("form", { className: sc.wrapper, onSubmit: c(g), ref: h, children: [
    /* @__PURE__ */ l(
      nn,
      {
        id: "sim-new-name",
        type: "text",
        className: sc.textInput,
        inputProps: { autoComplete: "off", maxLength: 32 },
        ...o("newName")
      }
    ),
    /* @__PURE__ */ O("div", { className: sc.actions, children: [
      /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          onClick: (b) => {
            b.stopPropagation(), r();
          },
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ l(Y, { type: "submit", loading: n, children: "Save" })
    ] })
  ] });
}, lr = (e, t = "utc") => {
  if (!e)
    return;
  const r = ve.fromISO(e, { zone: t });
  if (r.isValid)
    return r;
}, Xi = ({ hologramSimId: e }) => {
  const { simDetails: t, isLoading: r, error: n } = Le(e), {
    simBilling: i,
    error: a,
    isLoading: s
  } = Ir(e), { billingPeriodEnd: o } = i, c = o ? lr(o) : void 0;
  return {
    isDeactivatedOldSim: t.networkStatus === "DEAD" && (!c || c <= ve.now()),
    isLoading: r || s,
    error: n || a
  };
}, lp = ({ action: e, organizationId: t }) => {
  const r = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/tag`;
  return $(
    async (i, a) => await ft({
      url: r,
      body: {
        action: e,
        organizationId: t,
        hologramSimIds: i,
        tagIds: a
      }
    }),
    [e, t, r]
  );
}, Ew = async ({ url: e, body: t }) => {
  const r = await fetch(e, {
    credentials: "include",
    method: "DELETE",
    body: t && JSON.stringify(t),
    headers: ul()
  });
  if (!r.ok) {
    const i = new Error("An error occurred while deleting the data.");
    throw i.info = await r.json(), i.status = r.status, i;
  }
  return await r.json();
}, dO = ({ tagId: e, orgId: t }) => {
  const r = new URLSearchParams({ orgid: `${t}` }), n = `${process.env.VITE_API_ROOT}/devices/tags/${e}?${r}`;
  return $(async () => !e || !t ? void 0 : await Ew({
    url: n,
    body: null
  }), [t, e, n]);
}, fO = ({
  filters: e,
  canLoad: t = !0,
  onLoadingSlow: r
}) => {
  const n = t && ((e?.organizationIds?.length ?? 0) > 0 || (e?.hologramSimIds?.length ?? 0) > 0) ? {
    url: `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/tags/details`,
    body: {
      ...e
    }
  } : null, i = jn();
  r && (i.onLoadingSlow = r);
  const { data: a, error: s, isLoading: o, mutate: c, isValidating: u } = je(n, ft, i);
  return {
    tags: V(() => a?.tags ? structuredClone(a.tags).sort((p, d) => Ui(p?.name ?? "", d?.name ?? "")) : [], [a]),
    isLoading: o,
    error: s,
    mutate: c,
    isValidating: u
  };
}, hO = "hyperdashboard-Pictogram-module-SEvN_W-icon", mO = "hyperdashboard-Pictogram-module-SEvN_W-wrapper", cp = {
  icon: hO,
  wrapper: mO
}, Ro = (e) => {
  const { name: t, color: r, iconClassName: n, className: i, ...a } = e;
  return /* @__PURE__ */ l("div", { className: J(cp.wrapper, i), children: /* @__PURE__ */ l(
    ye,
    {
      name: t,
      size: "large",
      fill: r,
      className: J(cp.icon, n),
      ...a
    }
  ) });
}, pO = "hyperdashboard-Table-module-tbTlSq-tableContainer", gO = "hyperdashboard-Table-module-tbTlSq-tableHeaderRow", vO = "hyperdashboard-Table-module-tbTlSq-wrapper", oc = {
  tableContainer: pO,
  tableHeaderRow: gO,
  wrapper: vO
}, yO = "hyperdashboard-TableHeaderRow-module-RvtjMW-cell", bO = {
  cell: yO
}, SO = ({ headers: e }) => e?.length ? /* @__PURE__ */ l("tr", { children: e?.map(({ key: t, className: r, width: n, children: i, ...a }) => /* @__PURE__ */ l("th", { className: J(bO.cell, r), style: { width: n }, ...a, children: i ?? null }, t)) }) : null, wO = "hyperdashboard-TableRow-module-lO20RW-cell", IO = "hyperdashboard-TableRow-module-lO20RW-row", up = {
  cell: wO,
  row: IO
}, CO = Et(({ row: e }, t) => e?.cells ? /* @__PURE__ */ l("tr", { className: J(up.row, e.className), ref: t, children: e.cells.map((r) => /* @__PURE__ */ l("td", { className: J(up.cell, r.className), ref: r.ref, children: r.children }, r.key)) }) : null), ei = ({
  className: e,
  wrapperClassName: t,
  headers: r,
  rows: n,
  theadClassName: i,
  tbodyClassName: a,
  tfootClassName: s,
  footer: o
}) => !r && !n ? null : /* @__PURE__ */ l("div", { className: J(oc.wrapper, t), children: /* @__PURE__ */ O("table", { className: J(oc.tableContainer, e), children: [
  /* @__PURE__ */ l("thead", { className: J(oc.tableHeaderRow, i), children: /* @__PURE__ */ l(SO, { headers: r }) }),
  /* @__PURE__ */ l("tbody", { className: a, children: n?.map((c) => /* @__PURE__ */ l(CO, { row: c, ref: c.ref }, c.key)) }),
  o && /* @__PURE__ */ l("tfoot", { className: s, children: o })
] }) }), Vi = (e, t = 1e3) => {
  Pe(() => {
    const r = setTimeout(() => {
      e();
    }, t);
    return () => clearTimeout(r);
  }, [t, e]);
}, lc = {
  tooltip: "This SIM is being configured for pre-deployment testing. Configuration can take up to 15 minutes. Timing varies based on network partner activity.",
  icon: "StatusTesting",
  colorVariant: "yellow"
}, dp = {
  tooltip: "This SIM is in pre-deployment testing. The SIM will auto-activate when your testing period ends, it uses 100 KB of data, or sends 10 SMS messages.",
  icon: "StatusTesting",
  colorVariant: "purple"
}, fp = {
  tooltip: "This SIM is activated and able to connect to the Hologram network.",
  icon: "StatusReady",
  colorVariant: "teal"
}, hp = {
  tooltip: "This SIM is being configured for use on the Hologram network.",
  icon: "StatusActivating",
  colorVariant: "yellow"
}, $s = (e) => {
  const { formatStatus: t, isLoading: r, error: n } = ht(), i = V(() => r || n ? /* @__PURE__ */ new Map() : new Map(
    Object.entries({
      CONNECTED: {
        tooltip: "This SIM is currently connected to our network, or has connected recently to our network and has an open data session. Real-time session info varies by carrier.",
        status: "Connected",
        icon: "StatusConnected",
        colorVariant: "lime"
      },
      "TEST-CONNECTED": {
        tooltip: "This SIM is currently connected to our network, or has connected recently to our network and has an open data session. Real-time session info varies by carrier. The SIM will auto-activate when your testing period ends, it uses 100 KB of data, or sends 10 SMS messages.",
        status: "Connected",
        icon: "StatusConnected",
        colorVariant: "lime"
      },
      INACTIVE: {
        tooltip: "This SIM is assigned to your organization, but has not been activated. Activate it at any time to start using data on the Hologram network.",
        status: t("INACTIVE"),
        icon: "StatusReady",
        colorVariant: "default"
      },
      PENDING: {
        ...hp,
        status: t("PENDING")
      },
      "TEST-AUTOACTIVATE": {
        ...dp,
        status: t("TEST-AUTOACTIVATE")
      },
      "TEST-ACTIVATE": {
        ...dp,
        status: t("TEST-ACTIVATE")
      },
      "TEST-HIBERNATE": {
        tooltip: "This SIM is in pre-deployment testing. This SIM will will hibernate until you’re ready to deploy and choose to activate after the testing period ends, it uses 100 KB of data, or sends 10 SMS messages.",
        status: t("TEST-HIBERNATE"),
        icon: "StatusTesting",
        colorVariant: "purple"
      },
      "TEST-ACTIVATE-PENDING": {
        ...lc,
        status: t("TEST-ACTIVATE-PENDING")
      },
      "TEST-HIBERNATE-PENDING": {
        ...lc,
        status: t("TEST-HIBERNATE-PENDING")
      },
      "TEST-AUTOACTIVATE-PENDING": {
        ...lc,
        status: t("TEST-AUTOACTIVATE-PENDING")
      },
      "INACTIVE-TESTED": {
        tooltip: "This SIM has used all available test data. Activate it at any time to start using data on the Hologram network.",
        status: t("INACTIVE-TESTED"),
        icon: "StatusTesting",
        colorVariant: "default"
      },
      "LIVE-PENDING": {
        ...hp,
        status: t("LIVE-PENDING")
      },
      LIVE: {
        ...fp,
        status: t("LIVE")
      },
      FACTORY: {
        ...fp,
        status: t("FACTORY")
      },
      "PAUSED-PENDING-USER": {
        tooltip: "This SIM is being paused by a member of your organization. Once paused, it will not be able to transmit data or SMS services.",
        status: t("PAUSED-PENDING-USER"),
        icon: "Pause",
        colorVariant: "lightpink"
      },
      "PAUSED-PENDING-SYS": {
        tooltip: "This SIM is being paused due to an insufficient account balance, data usage limit, SMS usage, or another reason. Once paused, it will not be able to transmit data or SMS services.",
        status: t("PAUSED-PENDING-SYS"),
        icon: "Pause",
        colorVariant: "lightpink"
      },
      "PAUSED-USER": {
        tooltip: "This SIM has been manually paused by a member of your organization. While paused, your device will not be able to send or receive data or SMS messages.",
        status: t("PAUSED-USER"),
        icon: "Pause",
        colorVariant: "pink"
      },
      "PAUSED-SYS": {
        tooltip: "This SIM has been paused and cannot use data or SMS services. Once resolved, it may take up to 10 minutes to resume activity on the Hologram network. SIMs are often paused by reaching a data usage or SMS limit, or a lack of account balance.",
        status: t("PAUSED-SYS"),
        icon: "Pause",
        colorVariant: "pink"
      },
      "DEAD-PENDING": {
        tooltip: "This SIM is being permanently deactivated. Once deactivated, it will no longer be able to transmit data or SMS services.",
        status: t("DEAD-PENDING"),
        icon: "StatusDeactivated",
        colorVariant: "black"
      },
      DEAD: {
        tooltip: "This device has been permanently deactivated from use on the Hologram network and cannot be reactivated.",
        status: t("DEAD"),
        icon: "StatusDeactivated",
        colorVariant: "black"
      }
    })
    // TODO: There's probably a way to type this so we can cleanly see missing errors. It eludes me at the moment
  ), [n, t, r]);
  return { statusInfo: V(() => {
    let s = i.get(e ?? "PENDING");
    return !(r || n) && !s && (console.error(`Got an unhandled status: ${e}`), s = i.get("PENDING")), s;
  }, [n, r, e, i]), isLoading: r, error: n };
}, PO = (e, t = 1e3) => {
  const r = we(null), n = $(() => {
    r.current && window.clearTimeout(r.current), r.current = window.setTimeout(() => {
      e();
    }, t);
  }, [e, t]);
  return Pe(
    () => () => {
      r.current && window.clearTimeout(r.current);
    },
    []
  ), n;
}, bn = ({ url: e, replacers: t }) => V(() => {
  if (!e)
    return null;
  let r = e;
  return t.forEach((n) => {
    r = r.replace(`:${n.placeholder}`, n.value);
  }), r;
}, [t, e]), TO = "hyperdashboard-TagDeleteConfirmation-module-XmR84G-contents", _O = {
  contents: TO
}, EO = ({
  tag: e,
  onConfirmed: t,
  onCancelled: r
}) => {
  const [n, i] = Z(!0);
  return /* @__PURE__ */ l(
    qt,
    {
      defaultOpen: !0,
      open: n,
      setOpen: i,
      onClosed: r,
      header: "Delete tag?",
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(Y, { variant: "secondary", onClick: () => i(!1), children: "Cancel" }),
        /* @__PURE__ */ l(Y, { variant: "delete", onClick: t, children: "Yes, delete tag" })
      ] }),
      children: /* @__PURE__ */ O("div", { className: _O.contents, children: [
        "Are you sure you want to delete the tag “",
        e.name,
        "”?",
        (e.sims?.length ?? 0) === 0 && " It has not been added to any SIMs.",
        (e.sims?.length ?? 0) > 0 && /* @__PURE__ */ O(ze, { variant: "caution", children: [
          "“",
          e.name,
          "” will be removed from ",
          e.sims.length,
          " ",
          e.sims.length === 1 ? "SIM" : "SIMs",
          "."
        ] })
      ] })
    }
  );
}, OO = ({ orgId: e }) => {
  const t = new URLSearchParams({ orgid: `${e}` }), r = `${process.env.VITE_API_ROOT}/devices/tags?${t}`;
  return $(
    async (i, a) => e ? await ft({
      url: r,
      body: { name: i, deviceids: a ?? [] }
    }) : void 0,
    [e, r]
  );
}, vh = async ({
  url: e,
  body: t,
  throwOnError: r = !0
}) => {
  const n = await fetch(e, {
    credentials: "include",
    method: "PUT",
    body: t && JSON.stringify(t),
    headers: ul()
  });
  if (!n.ok && r) {
    const a = new Error("An error occurred while saving the data.");
    throw a.info = await n.json(), a.status = n.status, a;
  }
  return await n.json();
}, NO = ({ tagId: e, orgId: t }) => {
  const r = new URLSearchParams({ orgid: `${t}` }), n = `${process.env.VITE_API_ROOT}/devices/tags/${e}/updatetagname/?${r}`;
  return $(
    async (a) => !e || !t ? void 0 : await vh({
      url: n,
      body: { name: a }
    }),
    [t, e, n]
  );
}, DO = "hyperdashboard-TagEditor-module-OqzNZa-button", RO = "hyperdashboard-TagEditor-module-OqzNZa-overlay", kO = "hyperdashboard-TagEditor-module-OqzNZa-text", AO = "hyperdashboard-TagEditor-module-OqzNZa-wrapper", ha = {
  button: DO,
  overlay: RO,
  text: kO,
  wrapper: AO
}, xO = Et(
  ({
    tag: e,
    onCancel: t,
    onSave: r,
    setTagEditor: n,
    rootContext: i,
    padLeft: a,
    onError: s,
    organizationId: o,
    usedTagNames: c,
    deviceIds: u,
    selectedSimIds: f,
    ...g
  }, p) => {
    const { register: d, handleSubmit: h, setFocus: v, getValues: b } = Lt({
      defaultValues: { newName: e?.name ?? "" }
    }), { floatingStyles: m, context: S } = m0({
      rootContext: i,
      whileElementsMounted: v0,
      middleware: [
        p0({
          apply({ elements: P, rects: _ }) {
            const D = P.floating, R = _.reference;
            D.style.height = "36px", D.style.width = `${a ? R.width - 36 : R.width - 6}px`;
          }
        }),
        g0(({ rects: P }) => ({
          mainAxis: -P.reference.height / 2 - P.floating.height / 2,
          crossAxis: a ? 10 : 1
        }))
      ]
    }), I = OO({ orgId: o }), C = NO({ tagId: e?.id, orgId: e?.orgId }), [T, E] = Z(!1);
    Pe(() => {
      setTimeout(() => {
        v("newName", { shouldSelect: !0 });
      }, 0);
    }, [v]);
    const N = $(
      async (P) => {
        if (s(null), e && P.newName === e.name) {
          v("newName", { shouldSelect: !0 });
          return;
        }
        if (P.newName.trim().length === 0) {
          v("newName");
          return;
        }
        if (c.has(P.newName.toLocaleLowerCase(Ln))) {
          s("A tag already exists with this name. Please use a different name."), v("newName", { shouldSelect: !0 });
          return;
        }
        E(!0);
        let _;
        try {
          e ? _ = await C(P.newName) : _ = await I(P.newName, u);
        } catch {
          E(!1), s("There was a problem renaming this tag. Please try again."), v("newName", { shouldSelect: !0 });
          return;
        }
        if (_?.success) {
          r(e ? { ...e, name: P.newName } : {
            name: P.newName,
            id: _.data.tags[0].id,
            orgId: o,
            selectedSimCount: f?.size ?? 0,
            sims: f && f.size ? [...f.values()].map((D) => ({ id: D })) : []
          });
          return;
        }
        s("There was a problem renaming this tag. Please try again."), E(!1), v("newName", { shouldSelect: !0 });
      },
      [
        I,
        o,
        u,
        s,
        r,
        C,
        f,
        v,
        e,
        c
      ]
    );
    Kt(
      p,
      () => ({
        trigger: () => {
          (e ? b().newName !== e.name : b().newName.trim().length > 0) ? setTimeout(() => {
            v("newName", { shouldSelect: !0 });
          }, 0) : t();
        }
      }),
      [b, t, v, e]
    );
    const { sendAnalyticsEvent: y } = mt();
    let w = "Add tag";
    return e ? w = "Rename tag" : f && f.size > 1 && (w = `Add tag to ${f.size} SIMs`), /* @__PURE__ */ l(y0, { children: /* @__PURE__ */ l(b0, { lockScroll: !0, className: ha.overlay, children: /* @__PURE__ */ l(S0, { context: S, initialFocus: n, children: /* @__PURE__ */ l("div", { ref: n, ...g, style: m, children: /* @__PURE__ */ O("form", { className: ha.wrapper, onSubmit: h(N), children: [
      /* @__PURE__ */ l(
        nn,
        {
          id: "tag-editor",
          type: "text",
          className: ha.text,
          inputProps: { autoComplete: "off", maxLength: 32 },
          ...d("newName")
        }
      ),
      /* @__PURE__ */ l(Y, { onClick: t, variant: "secondary", className: ha.button, children: "Cancel" }),
      /* @__PURE__ */ l(
        Y,
        {
          className: ha.button,
          loading: T,
          type: "submit",
          onClick: () => {
            y && y("Manage tags - Add tag");
          },
          children: w
        }
      )
    ] }) }) }) }) });
  }
), FO = "hyperdashboard-TagManager-module-z86n3G-actionButton", $O = "hyperdashboard-TagManager-module-z86n3G-actions", MO = "hyperdashboard-TagManager-module-z86n3G-addButton", LO = "hyperdashboard-TagManager-module-z86n3G-checkbox", jO = "hyperdashboard-TagManager-module-z86n3G-clearButton", WO = "hyperdashboard-TagManager-module-z86n3G-count", UO = "hyperdashboard-TagManager-module-z86n3G-countZero", VO = "hyperdashboard-TagManager-module-z86n3G-deleting", HO = "hyperdashboard-TagManager-module-z86n3G-editing", qO = "hyperdashboard-TagManager-module-z86n3G-emptyState", zO = "hyperdashboard-TagManager-module-z86n3G-header", BO = "hyperdashboard-TagManager-module-z86n3G-row", GO = "hyperdashboard-TagManager-module-z86n3G-searchWrapper", QO = "hyperdashboard-TagManager-module-z86n3G-standalone", ZO = "hyperdashboard-TagManager-module-z86n3G-subActions", YO = "hyperdashboard-TagManager-module-z86n3G-table", KO = "hyperdashboard-TagManager-module-z86n3G-tableWrapper", JO = "hyperdashboard-TagManager-module-z86n3G-tag", XO = "hyperdashboard-TagManager-module-z86n3G-tagPopoverContents", eN = "hyperdashboard-TagManager-module-z86n3G-topWrapper", tN = "hyperdashboard-TagManager-module-z86n3G-wrapper", rt = {
  actionButton: FO,
  actions: $O,
  addButton: MO,
  checkbox: LO,
  clearButton: jO,
  count: WO,
  countZero: UO,
  deleting: VO,
  editing: HO,
  emptyState: qO,
  header: zO,
  row: BO,
  searchWrapper: GO,
  standalone: QO,
  subActions: ZO,
  table: YO,
  tableWrapper: KO,
  tag: JO,
  tagPopoverContents: XO,
  topWrapper: eN,
  wrapper: tN
}, mp = (e, t) => e.selectedSimCount === 0 ? 2 : e.selectedSimCount === t.size ? 0 : 1, rN = (e) => "selectedSimCount" in e, nN = Et(
  ({
    selectedSimIds: e = /* @__PURE__ */ new Map(),
    organizationIds: t,
    className: r,
    onProcessing: n,
    onSuccess: i,
    onError: a,
    onTagsMutated: s,
    variant: o = "standalone",
    simInventoryBaseUrl: c,
    tagSelectMode: u = !1,
    onTagSelectionChanged: f,
    defaultSelection: g
  }, p) => {
    const [d, h] = Z(!1), [v, b] = Z(null), [m, S] = Z(null), [I, C] = Z(null), [T, E] = Z(/* @__PURE__ */ new Map()), [N, y] = Z(!1), [w, P] = Z(/* @__PURE__ */ new Map()), [_, D] = Z([]), R = e.size === 1, x = e.size > 0, F = V(() => [...e.values()].sort(), [e]), W = Ne(), { organizationRole: A, releaseFlags: M } = Be(), j = ["admin", "manager", "editor"].includes(A), B = M.has(Ht.FEATURE_PREDEPLOYMENT), L = V(() => W !== void 0 && (!t || t.length === 0) ? [W] : t, [W, t]), { sendAnalyticsEvent: H } = mt(), q = Ne(), te = bn({
      url: `${c}/active`,
      replacers: [{ placeholder: "orgid", value: q?.toString() ?? "" }]
    }), G = bn({
      url: `${c}/predeployment`,
      replacers: [{ placeholder: "orgid", value: q?.toString() ?? "" }]
    }), {
      watch: X,
      register: re,
      reset: oe
    } = Lt({
      defaultValues: { searchText: "" },
      mode: "onChange"
    }), { searchText: ue } = X(), {
      tags: de,
      isLoading: Q,
      error: he,
      mutate: ce
    } = fO({
      filters: {
        organizationIds: L
      },
      canLoad: !!L && L.length > 0
    });
    Pe(() => {
      s && s(de);
    }, [s, de]);
    const se = V(() => {
      let Se;
      x ? Se = structuredClone(de).map((We) => {
        if (rN(We))
          return We;
        if (!We.id)
          return {
            ...We,
            selectedSimCount: 0
          };
        const ke = We.sims?.filter((nr) => nr.id && e.has(nr.id)).length ?? 0;
        return {
          ...We,
          selectedSimCount: ke
        };
      }) : Se = structuredClone(de).map((We) => ({
        ...We,
        selectedSimCount: We.sims?.length ?? 0
      }));
      const Me = /* @__PURE__ */ new Set();
      return Se.forEach((We) => {
        We.sims?.forEach((ke) => {
          ke.claimedDeviceId && ke.id && e.has(ke.id) && Me.add(ke.claimedDeviceId);
        });
      }), Se;
    }, [x, e, de]), { sortedTags: pe, usedTagNames: k } = V(
      () => ({
        sortedTags: x || u ? se.sort((Se, Me) => {
          const We = Se.selectedSimCount ?? 0, ke = Me.selectedSimCount ?? 0;
          return We === ke ? Ui(Se.name ?? "", Me.name ?? "") : ke - We;
        }) : se.sort((Se, Me) => Ui(Se.name ?? "", Me.name ?? "")),
        usedTagNames: new Set(
          se.filter((Se) => (Se.name?.length ?? 0) > 0).map((Se) => Se.name?.toLocaleLowerCase(Ln))
        )
      }),
      [x, u, se]
    ), z = V(() => {
      if (!ue)
        return pe;
      const Se = ue.toLowerCase().trim();
      return pe.filter((Me) => Me.name?.toLowerCase().includes(Se));
    }, [ue, pe]), U = $(
      (Se, Me) => {
        if (!Se.id)
          return;
        const We = mp(Se, e);
        Me ? (We !== 0 && E(new Map(T.set(Se.id, Se))), w.delete(Se.id) && P(new Map(w))) : (We !== 2 && P(new Map(w.set(Se.id, Se))), T.delete(Se.id) && E(new Map(T)));
      },
      [T, w, e]
    );
    Pe(() => {
      if (!N && (g?.length ?? 0) > 0 && se.length > 0) {
        y(!0);
        const Se = new Set(g);
        se.forEach((Me) => {
          Me.id && Se.has(Me.id) && U(Me, !0);
        });
      }
    }, [U, g, N, se]);
    const ie = $(() => {
      S(null);
    }, []), ae = dO({
      orgId: m?.orgId,
      tagId: m?.id
    }), ne = $(async () => {
      C(null);
      let Se;
      try {
        Se = await ae();
      } catch {
        C("There was a problem deleting this tag. Please try again."), S(null);
        return;
      }
      if (Se?.success) {
        const Me = {
          tags: structuredClone(de).filter((We) => We.id !== m?.id)
        };
        S(null), ce(Me, { revalidate: !1 }), U(m, !1);
        return;
      }
      C("There was a problem deleting this tag. Please try again."), S(null);
    }, [U, ae, m, ce, de]), [me, Te] = Z(null), [Ce, Re] = Z(null), xe = we(null), _e = $(() => {
      C(""), d ? h(!1) : b(null);
    }, [d]), $e = w0({
      open: v !== null || d,
      onOpenChange: async (Se, Me, We) => {
        We === "escape-key" ? _e() : We === "outside-press" && xe.current && xe.current.trigger();
      },
      elements: {
        reference: me,
        floating: Ce
      }
    }), jt = I0($e), dr = C0($e, { role: "dialog" }), { getReferenceProps: Wt, getFloatingProps: nt } = P0([dr, jt]), fr = $(
      (Se) => {
        const Me = structuredClone(de);
        d ? Me.push(Se) : Me[de.findIndex((ke) => ke.id === Se.id)] = Se, ce({ tags: Me }, { revalidate: !1 }), d && U(Se, !0), _e();
      },
      [d, _e, U, ce, de]
    );
    Pe(() => {
      u && f && f([...T.keys()]);
    }, [f, T, u]);
    const hr = $(
      (Se, Me) => {
        Me.id && D((We) => [...We, () => U(Me, Se.target.checked)]);
      },
      [U]
    ), ai = lp({ action: "link", organizationId: W }), aa = lp({
      action: "unlink",
      organizationId: W
    }), si = $(
      async (Se, Me) => {
        let We;
        try {
          We = await Me([...e.keys()], [...Se.keys()]);
        } catch (ke) {
          return a && a(`There was a problem updating tags: ${ke}`), !1;
        }
        return !We?.success && a ? (a(We?.error ?? "Unknown error"), !1) : !0;
      },
      [a, e]
    ), oi = $(async () => {
      const Se = [];
      if (!R && _.length > 0 || T.size === 0 && w.size === 0)
        return;
      n && n(!0);
      const Me = { tags: structuredClone(de) };
      T.size > 0 && (Se.push(si(T, ai)), Me.tags = Me.tags?.map(
        (ke) => ke.id && T.has(ke.id) ? {
          ...ke,
          selectedSimCount: e.size
        } : ke
      )), w.size > 0 && (Se.push(si(w, aa)), Me.tags = Me.tags?.map(
        (ke) => ke.id && w.has(ke.id) ? {
          ...ke,
          selectedSimCount: 0
        } : ke
      )), P(/* @__PURE__ */ new Map()), E(/* @__PURE__ */ new Map()), ce(Me, { revalidate: !1 });
      const We = await Promise.all(Se);
      n && n(!1), !We.some((ke) => !ke) && i && i([...e.values()]);
    }, [
      R,
      _.length,
      T,
      w,
      n,
      de,
      ce,
      i,
      si,
      ai,
      e,
      aa
    ]), Vs = $(() => {
      if (_.length > 0)
        for (let Se = _.shift(); Se !== void 0; Se = _.shift())
          Se();
    }, [_]);
    Pe(() => {
      R && (T.size > 0 || w.size > 0) && oi();
    }, [T, w]), Vi(Vs, R ? 500 : 0), Kt(
      p,
      () => ({
        onSubmit: oi
      }),
      [oi]
    );
    const Hs = V(() => {
      if (he)
        return /* @__PURE__ */ l(
          fe,
          {
            variant: "error",
            label: "We ran into an issue loading your Tags",
            actions: /* @__PURE__ */ l(
              Y,
              {
                variant: "secondary",
                iconStart: "Sync",
                onClick: () => {
                  window.location.reload();
                },
                children: "Reload page"
              }
            ),
            children: "We will keep trying in the background or you can try to reload the page."
          }
        );
      if (Q)
        return /* @__PURE__ */ l(fe, { children: "Loading..." });
      const Se = [];
      (x || u) && Se.push({ children: "", key: "checkboxes-actions", width: 24 }), Se.push({ children: "Tag", key: "tag" }), R || Se.push({ children: "SIMs with tag", key: "sims-with-tag" }), Se.push({ children: "", key: "tag-actions" });
      const Me = z.map((ke) => {
        if (!ke?.id)
          return { key: "" };
        const { id: nr, name: sa, selectedSimCount: qs = 0 } = ke;
        let Zr = qs;
        u || (T.has(nr) ? Zr = e.size : w.has(nr) && (Zr = 0));
        const li = v?.id === nr, oa = m?.id === nr, ot = [], at = `tag-${nr}`, ir = mp(ke, e);
        if ((x || u) && ot.push({
          key: `${at}-checkbox`,
          children: /* @__PURE__ */ l(
            Rr,
            {
              disabled: li,
              defaultChecked: ir === 0 || T.has(ke.id),
              indeterminate: !u && ir === 1,
              onChange: (ar) => hr(ar, ke),
              label: "",
              className: rt.checkbox
            }
          )
        }), ot.push({
          key: `${at}-tag`,
          children: /* @__PURE__ */ l(
            et,
            {
              id: `${at}-popover`,
              content: /* @__PURE__ */ l("span", { className: rt.tagPopoverContents, children: sa }),
              tabIndex: -1,
              children: /* @__PURE__ */ l(
                en,
                {
                  iconStart: "Tag",
                  colorVariant: (ir === 0 && !w.has(ke.id) || T.has(ke.id)) && e.size > 0 && !u ? "lime" : "default",
                  className: rt.tag,
                  size: x ? "small" : "medium",
                  children: sa
                }
              )
            }
          )
        }), !R) {
          const ar = ir === 0 || T.has(ke.id) && !u && e.size > 0 ? `${Zr} (all)` : Zr.toString();
          ot.push({
            key: `${at}-sims-with-tag`,
            children: /* @__PURE__ */ l(
              "span",
              {
                className: J(rt.count, (Zr ?? 0) === 0 && rt.countZero),
                children: Zr > 0 && !B && o === "standalone" ? /* @__PURE__ */ l(Ae, { to: `${te}?tags=${ke.id}`, type: "standalone", children: ar }) : ar
              }
            )
          });
        }
        return ot.push({
          key: `${at}-actions`,
          children: /* @__PURE__ */ O("div", { className: rt.actions, children: [
            Zr > 0 && B && o === "standalone" && /* @__PURE__ */ O("div", { className: rt.subActions, children: [
              /* @__PURE__ */ l(
                Y,
                {
                  to: `${G}?tags=${ke.id}`,
                  variant: "tertiary",
                  size: "small",
                  iconEnd: "ArrowEastShort",
                  name: `predeployment-sims-tag-${nr}`,
                  className: rt.actionButton,
                  disabled: m !== null,
                  children: "Pre-deployment SIMs"
                }
              ),
              /* @__PURE__ */ l(
                Y,
                {
                  to: `${te}?tags=${ke.id}`,
                  variant: "tertiary",
                  size: "small",
                  iconEnd: "ArrowEastShort",
                  name: `active-sims-tag-${nr}`,
                  className: rt.actionButton,
                  disabled: m !== null,
                  children: "Active SIMs"
                }
              )
            ] }),
            !li && j && /* @__PURE__ */ O("div", { className: rt.subActions, children: [
              /* @__PURE__ */ l(
                Y,
                {
                  onClick: () => {
                    b(ke), H && H("Manage tags - Rename");
                  },
                  variant: "tertiary",
                  size: "small",
                  iconStart: "Pencil",
                  name: `rename-tag-${nr}`,
                  className: rt.actionButton,
                  disabled: m !== null,
                  children: "Rename"
                }
              ),
              /* @__PURE__ */ l(
                Y,
                {
                  onClick: () => {
                    S(ke), H && H("Manage tags - Delete");
                  },
                  variant: "tertiary",
                  size: "small",
                  iconStart: "Trash",
                  className: rt.actionButton,
                  disabled: m !== null,
                  children: "Delete"
                }
              )
            ] })
          ] })
        }), li ? {
          key: at,
          cells: ot,
          className: J(rt.row, rt.editing),
          ref: Te,
          ...Wt()
        } : {
          key: at,
          cells: ot,
          className: J(rt.row, oa && rt.deleting)
        };
      }), We = d ? [
        {
          key: "tag-add-new",
          cells: [
            {
              key: "add-tag-checkbox",
              children: /* @__PURE__ */ l(Rr, { disabled: !0, defaultChecked: !0, label: "", className: rt.checkbox })
            }
          ],
          className: J(rt.row, rt.editing),
          ref: Te,
          ...Wt()
        },
        ...Me
      ] : Me;
      return !d && se.length === 0 ? /* @__PURE__ */ l(
        fe,
        {
          icon: /* @__PURE__ */ l(Ro, { name: "Tag" }),
          label: "Create your first tag",
          actions: /* @__PURE__ */ l(
            Y,
            {
              iconStart: "Plus",
              onClick: () => {
                h(!0), H && H("Manage tags - Create tag");
              },
              children: "Create a tag"
            }
          ),
          children: "Tags help organize groups of SIMs within your organization for filtering and reporting."
        }
      ) : /* @__PURE__ */ O("div", { className: rt.tableWrapper, children: [
        /* @__PURE__ */ l(
          ei,
          {
            headers: Se,
            wrapperClassName: rt.table,
            theadClassName: rt.header,
            rows: We
          }
        ),
        se.length > 0 && z.length === 0 && /* @__PURE__ */ l("div", { className: rt.emptyState, children: "No matching tags found" }),
        (v !== null || d) && /* @__PURE__ */ l(
          xO,
          {
            tag: v ?? void 0,
            onCancel: _e,
            onSave: fr,
            onError: C,
            rootContext: $e,
            setTagEditor: Re,
            padLeft: x || u,
            organizationId: W,
            usedTagNames: k,
            deviceIds: F,
            selectedSimIds: e,
            ...nt({ ref: xe })
          }
        )
      ] });
    }, [
      he,
      Q,
      x,
      u,
      R,
      z,
      d,
      Wt,
      se.length,
      v,
      _e,
      fr,
      $e,
      W,
      k,
      F,
      e,
      nt,
      T,
      w,
      m,
      B,
      o,
      G,
      te,
      j,
      hr,
      H
    ]);
    return /* @__PURE__ */ O(
      "div",
      {
        className: J(rt.wrapper, r, o === "standalone" && rt.standalone),
        children: [
          I && /* @__PURE__ */ l(ze, { children: I }),
          se.length > 0 && /* @__PURE__ */ O("div", { className: rt.topWrapper, children: [
            /* @__PURE__ */ O("div", { className: rt.searchWrapper, children: [
              /* @__PURE__ */ l(
                nn,
                {
                  id: "tag-search",
                  type: "text",
                  placeholder: "Search tags...",
                  defaultValue: ue,
                  inputProps: { autoComplete: "off" },
                  iconStart: /* @__PURE__ */ l(ye, { name: "Search", size: "medium" }),
                  ...re("searchText")
                }
              ),
              ue.length > 0 && /* @__PURE__ */ l(
                Y,
                {
                  className: rt.clearButton,
                  iconStart: /* @__PURE__ */ l(ye, { name: "Close", size: "medium", fill: "DdsColorTextPrimaryOndefault" }),
                  variant: "tertiary",
                  onClick: () => oe()
                }
              )
            ] }),
            j && /* @__PURE__ */ l(
              Y,
              {
                className: rt.addButton,
                iconStart: "Tag",
                variant: "secondary",
                onClick: () => {
                  h(!0), H && H("Manage tags - Add new tag");
                },
                children: "Add a new tag"
              }
            )
          ] }),
          Hs,
          m && /* @__PURE__ */ l(
            EO,
            {
              tag: m,
              onConfirmed: ne,
              onCancelled: ie
            }
          )
        ]
      }
    );
  }
), iN = "hyperdashboard-TagManager-module-GtYn9G-wrapper", aN = {
  wrapper: iN
}, sN = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onSuccess: i,
  onError: a,
  onDone: s
}) => {
  const [o, c] = Z(t), [u, f] = Z(!1), g = we(), [p, d] = Z([]), h = $((S) => {
    f(S);
  }, []), v = $(() => {
    s && s(p), e();
  }, [p, e, s]), b = $(
    (S) => {
      n.size > 1 && (S && i && i(S), v());
    },
    [v, i, n.size]
  ), m = async (S) => {
    S.preventDefault(), g.current && await g.current.onSubmit();
  };
  return /* @__PURE__ */ l(
    qt,
    {
      className: J(r, aN.wrapper),
      header: !n.size || n.size === 1 ? "Manage tags" : `Manage tags for ${Ee(n.size)} SIMs`,
      onClosed: v,
      open: o,
      setOpen: c,
      noContentPadding: !0,
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              c(!1);
            },
            children: n.size === 1 ? "Close" : "Cancel"
          }
        ),
        n.size > 1 && /* @__PURE__ */ l(Y, { loading: u, onClick: m, variant: "primary", children: `Change tags for ${Ee(n.size)} SIMs` })
      ] }),
      children: /* @__PURE__ */ l(
        nN,
        {
          selectedSimIds: n,
          onProcessing: h,
          ref: g,
          onSuccess: b,
          onError: a,
          onTagsMutated: d,
          variant: "modal",
          simInventoryBaseUrl: "Org :orgid"
        }
      )
    }
  );
};
var Fi = /* @__PURE__ */ ((e) => (e.deviceId = "deviceId", e.orgId = "orgid", e.simId = "simId", e.batchJobId = "batchJobId", e))(Fi || {});
const cr = ({ simDetailBaseUrl: e, orgId: t, simId: r, batchJobId: n, subpage: i }) => {
  const a = V(
    () => [
      { placeholder: Fi.simId, value: r?.toString() ?? "" },
      { placeholder: Fi.orgId, value: t?.toString() ?? "" },
      { placeholder: Fi.batchJobId, value: n ?? "" }
    ],
    [n, t, r]
  );
  return bn({
    url: i ? `${e}/${i}` : e,
    replacers: a
  });
}, oN = "hyperdashboard-SimDetailsHeader-module-66EcuW-addATag", lN = "hyperdashboard-SimDetailsHeader-module-66EcuW-deviceName", cN = "hyperdashboard-SimDetailsHeader-module-66EcuW-deviceNameField", uN = "hyperdashboard-SimDetailsHeader-module-66EcuW-deviceNameFieldValue", dN = "hyperdashboard-SimDetailsHeader-module-66EcuW-deviceNameHovered", fN = "hyperdashboard-SimDetailsHeader-module-66EcuW-error", hN = "hyperdashboard-SimDetailsHeader-module-66EcuW-headerRow", mN = "hyperdashboard-SimDetailsHeader-module-66EcuW-leftColumn", pN = "hyperdashboard-SimDetailsHeader-module-66EcuW-loader", gN = "hyperdashboard-SimDetailsHeader-module-66EcuW-manageSimButton", vN = "hyperdashboard-SimDetailsHeader-module-66EcuW-moreTags", yN = "hyperdashboard-SimDetailsHeader-module-66EcuW-noDataFoundValue", bN = "hyperdashboard-SimDetailsHeader-module-66EcuW-numeric", SN = "hyperdashboard-SimDetailsHeader-module-66EcuW-pencil", wN = "hyperdashboard-SimDetailsHeader-module-66EcuW-rightColumn", IN = "hyperdashboard-SimDetailsHeader-module-66EcuW-simHeader", CN = "hyperdashboard-SimDetailsHeader-module-66EcuW-simStatus", PN = "hyperdashboard-SimDetailsHeader-module-66EcuW-tags", TN = "hyperdashboard-SimDetailsHeader-module-66EcuW-tagsField", _N = "hyperdashboard-SimDetailsHeader-module-66EcuW-tagWrapper", ut = {
  addATag: oN,
  deviceName: lN,
  deviceNameField: cN,
  deviceNameFieldValue: uN,
  deviceNameHovered: dN,
  error: fN,
  headerRow: hN,
  leftColumn: mN,
  loader: pN,
  manageSimButton: gN,
  moreTags: vN,
  noDataFoundValue: yN,
  numeric: bN,
  pencil: SN,
  rightColumn: wN,
  simHeader: IN,
  simStatus: CN,
  tags: PN,
  tagsField: TN,
  tagWrapper: _N
}, EN = ({
  hologramSimId: e,
  handleModalOpen: t,
  onSimsModified: r,
  simDetailBaseUrl: n
}) => {
  const { simDetails: i, isLoading: a, error: s } = Le(e), {
    deviceOverview: o,
    isLoading: c,
    error: u,
    mutate: f
  } = ch(e), {
    deviceDetails: g,
    isLoading: p,
    error: d
  } = Mt(e), {
    showEuiccInfo: h,
    isLoading: v,
    error: b
  } = gl(e), m = V(
    () => e ? /* @__PURE__ */ new Map([[e, g?.claimedDeviceId]]) : /* @__PURE__ */ new Map(),
    [g.claimedDeviceId, e]
  ), { networkStatus: S, activeProfileIccid: I } = i, {
    isDeactivatedOldSim: C,
    isLoading: T,
    error: E
  } = Xi({ hologramSimId: e }), { sendAnalyticsEvent: N } = mt(), { isSuperAdmin: y } = Be(), w = Ne(), { deviceIdsWithOpenSessions: P } = Wn(
    w,
    y || !!w
  ), { networkStatusGroups: _ } = ht(), D = V(() => g.claimedDeviceId && P.has(g.claimedDeviceId) && !_?.deactivated?.includes(S) ? _?.predeployment?.includes(S) ? "TEST-CONNECTED" : "CONNECTED" : S, [
    g.claimedDeviceId,
    P,
    S,
    _?.predeployment,
    _?.deactivated
  ]), [R, x] = Z(!1), [F, W] = Z(!1), A = FE({ hologramSimIds: m, organizationId: w }), M = $(
    async (ce) => {
      let se;
      try {
        se = await A(ce, !1);
      } catch (pe) {
        console.error(pe);
        return;
      }
      if (se?.success) {
        const pe = {
          deviceOverview: { ...o, deviceName: ce }
        };
        f(pe, { revalidate: !1 });
      }
      W(!1);
    },
    [o, f, A]
  ), {
    tags: j,
    isLoading: B,
    error: L,
    mutate: H
  } = uh({
    filters: { hologramSimIds: e ? [e] : [] },
    canLoad: !!e
  }), q = V(
    () => j.sort((ce, se) => Ui(ce.name ?? "", se.name ?? "")),
    [j]
  ), [te, G] = Z(!1), [X, re] = Z(!1), oe = $(
    (ce) => {
      const se = {
        tags: ce.filter((pe) => pe.selectedSimCount !== void 0 ? pe.selectedSimCount > 0 : !!pe.sims?.find((k) => k.id === e))
      };
      H(se, { revalidate: !1 });
    },
    [e, H]
  ), ue = cr({ simDetailBaseUrl: n, orgId: w, simId: e }), de = a || c || v || T || p, Q = s || u || b || E || d;
  let he;
  if (Q)
    console.error(`SIM Header API error: ${Q}`), he = /* @__PURE__ */ l(
      fe,
      {
        className: ut.error,
        variant: "error",
        label: "We ran into an issue loading the SIM details header",
        actions: /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            iconStart: "Sync",
            onClick: () => {
              window.location.reload();
            },
            children: "Reload page"
          }
        ),
        children: "We will keep trying in the background or you can try to reload the page."
      }
    );
  else if (de)
    he = /* @__PURE__ */ l(fe, { className: ut.loader, children: "Loading SIM..." });
  else {
    let ce;
    if (L)
      ce = "Error loading tags";
    else if (B)
      ce = "Loading...";
    else {
      const se = q.length - 5;
      ce = /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l("div", { className: ut.tags, children: q.slice(0, 5).map((pe) => /* @__PURE__ */ l(
          en,
          {
            iconStart: "Tag",
            size: "small",
            type: "interactive",
            forceHover: te,
            children: pe.name
          },
          pe.id
        )) }),
        se > 0 && /* @__PURE__ */ O("div", { className: ut.moreTags, children: [
          "+",
          se,
          " more"
        ] }),
        q.length === 0 ? /* @__PURE__ */ l(
          Y,
          {
            className: J(te && "static-demo-hover", ut.addATag),
            variant: "tertiary",
            onClick: () => {
            },
            iconStart: "Tag",
            title: "Manage tags",
            children: "Add a tag"
          }
        ) : /* @__PURE__ */ l(
          Y,
          {
            className: J(te && "static-demo-hover", ut.pencil),
            variant: "tertiary",
            onClick: () => {
            },
            iconStart: "Pencil",
            title: "Manage tags"
          }
        ),
        X && /* @__PURE__ */ l(
          sN,
          {
            sims: m,
            onClose: () => {
              re(!1), N && N("Manage tags - Close");
            },
            defaultOpen: !0,
            onDone: oe,
            onSuccess: r
          }
        )
      ] });
    }
    he = /* @__PURE__ */ O(le, { children: [
      /* @__PURE__ */ O("div", { className: ut.headerRow, children: [
        /* @__PURE__ */ O("div", { className: ut.leftColumn, children: [
          /* @__PURE__ */ l(
            ee,
            {
              label: "Name",
              title: "Edit SIM name",
              valueClassname: ut.deviceNameFieldValue,
              value: F ? /* @__PURE__ */ l(
                uO,
                {
                  existingName: o.deviceName,
                  onSave: M,
                  onCancel: () => {
                    W(!1);
                  }
                }
              ) : /* @__PURE__ */ O(
                "div",
                {
                  className: J(
                    ut.deviceName,
                    R && ut.deviceNameHovered
                  ),
                  children: [
                    o.deviceName,
                    /* @__PURE__ */ l(
                      Y,
                      {
                        className: J(R && "static-demo-hover", ut.pencil),
                        variant: "tertiary",
                        onClick: () => {
                        },
                        iconStart: "Pencil",
                        title: "Edit SIM name"
                      }
                    )
                  ]
                }
              ),
              direction: "column",
              className: ut.deviceNameField,
              onClick: () => {
                W(!0);
              },
              onMouseOver: () => {
                x(!0);
              },
              onMouseLeave: () => {
                x(!1);
              },
              labelId: "nameLabel",
              "aria-labelledby": "nameLabel"
            }
          ),
          /* @__PURE__ */ l(
            ee,
            {
              label: "Tags",
              valueClassname: ut.tagWrapper,
              value: ce,
              direction: "column",
              className: ut.tagsField,
              onClick: () => {
                re(!0);
              },
              onMouseOver: () => {
                G(!0);
              },
              onMouseLeave: () => {
                G(!1);
              },
              title: "Manage tags",
              labelId: "tagsLabel",
              "aria-labelledby": "tagsLabel"
            }
          )
        ] }),
        /* @__PURE__ */ l("div", { className: ut.rightColumn, children: /* @__PURE__ */ l(
          gw,
          {
            buttonText: "Manage SIM",
            selectedSims: m,
            context: "details",
            disabled: Q,
            handleModalOpen: t,
            onSimsModified: r,
            variant: "primary",
            placement: "bottom-end",
            className: ut.manageSimButton
          }
        ) })
      ] }),
      /* @__PURE__ */ l("div", { className: ut.headerRow, children: /* @__PURE__ */ O("div", { className: ut.leftColumn, children: [
        /* @__PURE__ */ l(
          ee,
          {
            label: "SIM status",
            value: /* @__PURE__ */ l(Ol, { networkState: D }),
            direction: "column",
            className: ut.simStatus
          }
        ),
        /* @__PURE__ */ l(
          ee,
          {
            label: h ? "Enabled profile ICCID" : "Profile ICCID",
            direction: "column",
            value: I && I.length > 0 ? /* @__PURE__ */ l(xE, { hologramSimId: e, profileUrl: `${ue}/profiles` }) : ""
          }
        ),
        !C && /* @__PURE__ */ O(le, { children: [
          /* @__PURE__ */ l(
            ee,
            {
              label: "Data usage",
              direction: "column",
              value: /* @__PURE__ */ l(yw, { hologramSimId: e })
            }
          ),
          /* @__PURE__ */ l(vw, { hologramSimId: e })
        ] }),
        /* @__PURE__ */ l(
          ee,
          {
            label: "SIM ID",
            direction: "column",
            value: /* @__PURE__ */ l(Ai, { value: e?.toString() ?? "", label: e }),
            valueClassname: ut.numeric
          }
        ),
        /* @__PURE__ */ l(
          ee,
          {
            label: "Last known IMEI",
            direction: "column",
            value: /* @__PURE__ */ l(
              "div",
              {
                className: J(!o.imei && ut.noDataFoundValue, ut.numeric),
                children: o.imei ? /* @__PURE__ */ l(Ai, { value: o.imei, label: o.imei }) : "Not available"
              }
            )
          }
        )
      ] }) })
    ] });
  }
  return /* @__PURE__ */ l("div", { className: ut.simHeader, children: he });
}, ON = ({ hologramSimId: e }) => {
  const { simDetails: t, error: r } = Le(e), { simProfiles: n, error: i } = kr(e);
  if (r || i)
    return null;
  let a, s;
  return t.activeProfileIccid && t.activeProfileIccid.length > 0 && (s = n.find((o) => o.iccid === t.activeProfileIccid), a = s?.publicIpAddress), a ? /* @__PURE__ */ l(ee, { label: "Public IP address", value: a }) : null;
}, Go = (e) => e?.isValid ? e.toFormat("MM-dd-yyyy") : void 0, $i = (e, t = "short") => {
  if (!e)
    return;
  const r = lr(e);
  if (r)
    switch (t) {
      case "short":
        return r.toFormat("MM-dd-yy");
      case "month":
        return r.toFormat("LLLL yyyy");
      case "long":
      default:
        return r.toFormat("MMM d, yyyy");
    }
}, bt = (e, t = "label") => {
  if (!e)
    return;
  const r = lr(e);
  if (r)
    switch (t) {
      case "table":
        return r.toFormat("MM-dd-yy hh:mm:ss a");
      case "shortlabel":
        return r.toFormat("MM-dd-yy hh:mm a ZZZZ");
      case "short":
        return r.toFormat("MM-dd-yy HH:mm:ss");
      case "24hrutc":
        return r.toFormat("MM-dd-yy HH:mm:ss ZZZZ");
      case "12hrlocal":
        return r.toLocal().toFormat("MM-dd-yy ttt");
      case "label":
      default:
        return r.toFormat("MM-dd-yy hh:mm:ss a ZZZZ");
    }
}, pp = (e, t = !1) => {
  if (e === void 0)
    return;
  let r = t ? "Test" : "Unlimited";
  if (e && !Number.isNaN(parseInt(e, 10))) {
    const n = parseInt(e, 10);
    n >= 36500 ? r = t ? "Test" : "Unlimited" : n === 90 && t ? r = "3mo" : n === 365 && t ? r = "1yr" : r = t ? `${n}d` : `${n} days`;
  }
  return r;
}, Mn = (e) => {
  if (!e || e.length === 0)
    return;
  const t = ve.fromFormat(e, "MM-dd-yyyy");
  if (t.isValid)
    return t;
};
var Yn = ((e) => (e.active = "active", e.predeployment = "predeployment", e.deactivated = "deactivated", e.details = "details", e.profiles = "profiles", e.recentSessions = "recentsessions", e.simAndDevices = "simanddevices", e.usage = "usage", e.coverage = "coverage", e.pricing = "pricing", e.tags = "tags", e.activity = "activity", e.activityHistoryDetails = `activity/:${Fi.batchJobId}/details`, e))(Yn || {});
const NN = "hyperdashboard-SimDetailsPanel-module-dgsewq-diminished", DN = "hyperdashboard-SimDetailsPanel-module-dgsewq-numeric", RN = "hyperdashboard-SimDetailsPanel-module-dgsewq-panelSection", kN = "hyperdashboard-SimDetailsPanel-module-dgsewq-panelSectionColumn", AN = "hyperdashboard-SimDetailsPanel-module-dgsewq-panelSectionColumns", xN = "hyperdashboard-SimDetailsPanel-module-dgsewq-panelSectionHeading", FN = "hyperdashboard-SimDetailsPanel-module-dgsewq-valueWithLink", $N = "hyperdashboard-SimDetailsPanel-module-dgsewq-valueWithPopover", Ue = {
  diminished: NN,
  numeric: DN,
  panelSection: RN,
  panelSectionColumn: kN,
  panelSectionColumns: AN,
  panelSectionHeading: xN,
  valueWithLink: FN,
  valueWithPopover: $N
}, MN = ({ hologramSimId: e, simDetailBaseUrl: t }) => {
  const {
    isLoading: r,
    error: n,
    simDetails: i,
    isValidating: a
  } = Le(e), {
    isLoading: s,
    error: o,
    deviceDetails: c,
    isValidating: u
  } = Mt(e), {
    showEuiccInfo: f,
    isLoading: g,
    error: p
  } = gl(e), {
    simProfiles: d,
    error: h,
    isLoading: v,
    isValidating: b
  } = kr(e), { simBilling: m } = Ir(e), {
    eid: S,
    msisdn: I,
    phoneNumber: C,
    simType: T,
    deactivationTime: E,
    // apn,
    // tunnelable,
    activationTime: N,
    preflightStartTime: y,
    expectedActivationTime: w,
    expectedPreflightDuration: P,
    // preflightDuration,
    profilesInstalledOnCard: _ = 0,
    fallbackInstalled: D,
    fallbackEnabled: R,
    sku: x,
    networkStatus: F
    // simFormat,
  } = i, W = !!y || !!w || F?.startsWith("TEST"), A = F === "TEST-HIBERNATE" || F === "TEST-AUTOACTIVATE", M = F === "INACTIVE", j = Ne(), B = cr({
    simDetailBaseUrl: t,
    orgId: j,
    simId: e,
    subpage: Yn.profiles
  }), L = cr({
    simDetailBaseUrl: t,
    orgId: j,
    simId: e,
    subpage: Yn.pricing
  }), { sendAnalyticsEvent: H } = mt(), q = r || g || v || s, te = n || p || h || o, G = V(() => {
    if (te)
      return /* @__PURE__ */ l(
        fe,
        {
          variant: "error",
          label: "We ran into an issue loading your SIM devices details",
          actions: /* @__PURE__ */ l(
            Y,
            {
              variant: "secondary",
              iconStart: "Sync",
              onClick: () => {
                window.location.reload();
              },
              children: "Reload page"
            }
          ),
          children: "We will keep trying in the background or you can try to reload the page."
        }
      );
    if (q)
      return /* @__PURE__ */ l(fe, { children: "Loading..." });
    let X;
    const re = "View profile";
    _ === 0 ? X = /* @__PURE__ */ l(Dt, {}) : _ === 1 ? X = /* @__PURE__ */ l(Ae, { type: "inline", to: B, ariaLabel: re, children: d[0].profileName }) : D ? D && !R ? (le, Ae, d.find((ce) => ce.installationState === "ENABLED")?.profileName, d.filter((ce) => ce.installationState !== "ENABLED").map((ce, se) => /* @__PURE__ */ O(Ha, { children: [
      /* @__PURE__ */ l(Ae, { type: "inline", to: B, ariaLabel: re, children: ce.profileName }),
      se + 2 < d.length && ", "
    ] }, ce.iccid))) : D && R ? X = /* @__PURE__ */ l(le, { children: d.map((ce, se) => /* @__PURE__ */ O(Ha, { children: [
      /* @__PURE__ */ l(Ae, { type: "inline", to: B, ariaLabel: re, children: ce.profileName }),
      se + 1 < d.length && ", "
    ] }, ce.iccid)) }) : X = `${_} profiles` : X = /* @__PURE__ */ l(Ae, { type: "inline", to: B, ariaLabel: re, children: d.find((ce) => ce.installationState === "ENABLED")?.profileName });
    let oe;
    const ue = () => {
      H && H("Info - Coverage type");
    };
    switch (T) {
      case "Dual-Core SIM":
        oe = /* @__PURE__ */ l(
          et,
          {
            id: "coverage-type-popover",
            content: "This SIM offers two mobile core networks, protected with network fallback. If one network fails, our technology seamlessly switches you to a backup. Hologram SIMs use eUICC technology to remotely update coverage by adding or removing profiles, without requiring you to swap the SIM in your device.",
            onOpen: ue,
            children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
          }
        );
        break;
      case "Multi-Core SIM":
        oe = /* @__PURE__ */ l(
          et,
          {
            id: "coverage-type-popover",
            content: "This SIM offers multiple mobile core networks, protected with network fallback. If one network fails, our technology seamlessly switches you to a backup. Hologram SIMs use eUICC technology to remotely update coverage by adding or removing profiles, without requiring you to swap the SIM in your device.",
            onOpen: ue,
            children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
          }
        );
        break;
      case "Single-Core SIM":
        oe = /* @__PURE__ */ l(
          et,
          {
            id: "coverage-type-popover",
            content: "Hologram SIMs use eUICC technology to remotely update coverage by adding or removing profiles, without requiring you to swap the SIM in your device.",
            onOpen: ue,
            children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
          }
        );
        break;
      default:
        oe = null;
    }
    let de;
    const Q = /* @__PURE__ */ l(
      et,
      {
        id: "outage-protection-popover",
        content: "Network fallback protects your coverage by allowing your SIM to automatically switch profiles if one profile loses connection.",
        onOpen: () => {
          H && H("Info - Outage protection");
        },
        children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
      }
    );
    R && _ >= 2 ? de = /* @__PURE__ */ O("div", { className: Ue.valueWithPopover, children: [
      /* @__PURE__ */ l(ye, { name: "Shield", fill: "DdsColorPaletteTeal40" }),
      /* @__PURE__ */ l("span", { children: "Fallback enabled" }),
      Q
    ] }) : (!R || _ === 1) && (de = /* @__PURE__ */ O("div", { className: Ue.valueWithPopover, children: [
      /* @__PURE__ */ l("span", { children: "Dual-Core capable" }),
      /* @__PURE__ */ l(
        Ae,
        {
          target: "_blank",
          rel: "noreferrer",
          type: "inline",
          href: "https://www.hologram.io/contact-sales/?utm_source=dashboard&utm_medium=application&utm_content=sim_details_dual_core_capable",
          children: "Contact Sales"
        }
      ),
      Q
    ] }));
    let he;
    return F?.endsWith("HIBERNATE") ? he = /* @__PURE__ */ l(ze, { variant: "note", children: "Your SIM is on a legacy preflight configuration. After it uses test data, it will be paused until you manually activate the SIM." }) : F?.endsWith("AUTOACTIVATE") ? he = /* @__PURE__ */ l(ze, { variant: "note", children: "Your SIM is on a legacy preflight configuration. As soon as it connects to a network for the first time it will automatically activate." }) : pp(P) === "Unlimited" ? he = /* @__PURE__ */ l(ze, { variant: "note", children: "Your SIM will be activated after 100 KB of data usage, sending 10 outgoing SMS messages, or you choose to manually activate the SIM." }) : he = /* @__PURE__ */ l(ze, { variant: "note", children: "Your SIM will be activated after your pre-deployment testing duration, 100 KB of data usage, or sending 10 outgoing SMS messages, whichever comes first." }), /* @__PURE__ */ O(le, { children: [
      F?.startsWith("DEAD") && E && /* @__PURE__ */ O("div", { className: Ue.panelSection, children: [
        /* @__PURE__ */ l("div", { className: Ue.panelSectionHeading, children: "Deactivation" }),
        /* @__PURE__ */ l(
          ee,
          {
            label: "Deactivated",
            value: /* @__PURE__ */ l(
              et,
              {
                id: "deactivated-time",
                content: bt(E, "12hrlocal"),
                children: /* @__PURE__ */ l("span", { children: bt(E, "24hrutc") })
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ O("div", { className: Ue.panelSection, children: [
        /* @__PURE__ */ l("div", { className: Ue.panelSectionHeading, children: "Coverage configuration" }),
        /* @__PURE__ */ O("div", { className: Ue.panelSectionColumns, children: [
          /* @__PURE__ */ O("div", { className: Ue.panelSectionColumn, children: [
            /* @__PURE__ */ l(
              ee,
              {
                label: "Coverage type",
                value: /* @__PURE__ */ O("div", { className: Ue.valueWithPopover, children: [
                  /* @__PURE__ */ l("span", { children: T }),
                  oe
                ] })
              }
            ),
            !!D && /* @__PURE__ */ l(ee, { label: "Outage protection", value: de }),
            !!D && !!R && /* @__PURE__ */ l(ee, { label: "Fallback timer", value: "15 minutes" })
          ] }),
          /* @__PURE__ */ O("div", { className: Ue.panelSectionColumn, children: [
            /* @__PURE__ */ l(
              ee,
              {
                label: _ > 1 ? "Installed profiles" : "Installed profile",
                value: X
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                label: "Required APN",
                value: /* @__PURE__ */ l(dh, { profiles: d, placement: "top" })
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ O("div", { className: Ue.panelSection, children: [
        /* @__PURE__ */ l("div", { className: Ue.panelSectionHeading, children: "Identifying details" }),
        /* @__PURE__ */ O("div", { className: Ue.panelSectionColumns, children: [
          /* @__PURE__ */ O("div", { className: Ue.panelSectionColumn, children: [
            /* @__PURE__ */ l(ee, { label: "SIM ID", value: e, valueClassname: Ue.numeric }),
            /* @__PURE__ */ l(ee, { label: "SIM name", value: c.deviceName }),
            /* @__PURE__ */ l(
              ee,
              {
                label: "SKU",
                value: x ? `Printed as ${x}` : null,
                emptyStateText: "Not available"
              }
            )
          ] }),
          /* @__PURE__ */ O("div", { className: Ue.panelSectionColumn, children: [
            f && /* @__PURE__ */ l(ee, { label: "eUICCID (EID)", value: S, valueClassname: Ue.numeric }),
            /* @__PURE__ */ l(
              ee,
              {
                label: d.length > 1 ? "Enabled profile MSISDN" : "MSISDN",
                value: I,
                valueClassname: Ue.numeric
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ O("div", { className: Ue.panelSection, children: [
        /* @__PURE__ */ l("div", { className: Ue.panelSectionHeading, children: W ? "Activation and pre-deployment testing" : "Activation" }),
        /* @__PURE__ */ l("div", { className: Ue.panelSectionColumns, children: /* @__PURE__ */ O("div", { className: Ue.panelSectionColumn, children: [
          (N || M) && /* @__PURE__ */ l(
            ee,
            {
              label: "Activated date",
              value: N && /* @__PURE__ */ O("div", { className: Ue.valueWithPopover, children: [
                /* @__PURE__ */ l("span", { children: /* @__PURE__ */ l(
                  et,
                  {
                    id: "activation-time",
                    content: bt(N, "12hrlocal"),
                    className: Ue.numeric,
                    children: /* @__PURE__ */ l("span", { className: Ue.numeric, children: bt(N, "24hrutc") })
                  }
                ) }),
                W && /* @__PURE__ */ l(
                  et,
                  {
                    id: "activation-time-info",
                    content: "The date your SIM was activated after reaching your pre-deployment testing duration, 100 KB of data usage, or sending 10 outgoing SMS messages, whichever came first.",
                    onOpen: () => {
                      H && H("Info - Activated date");
                    },
                    children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
                  }
                )
              ] })
            }
          ),
          W && /* @__PURE__ */ l(
            ee,
            {
              label: "Entered testing",
              value: /* @__PURE__ */ l(
                et,
                {
                  id: "activation-time",
                  content: bt(y, "12hrlocal"),
                  children: /* @__PURE__ */ l("span", { children: bt(y, "24hrutc") })
                }
              )
            }
          ),
          W && A && /* @__PURE__ */ l(
            ee,
            {
              label: "Test configuration",
              value: F?.endsWith("HIBERNATE") ? "Hibernate" : "Autoactivate"
            }
          ),
          W && !A && /* @__PURE__ */ l(
            ee,
            {
              label: "Testing duration",
              value: pp(P)
            }
          ),
          !N && w && !A && /* @__PURE__ */ l(
            ee,
            {
              label: "Target activation date",
              value: (
                // TODO: DAN TAKE A LOOK AT LUXON FOR DURATION
                /* @__PURE__ */ l(
                  et,
                  {
                    id: "activation-time",
                    content: bt(w, "12hrlocal"),
                    children: /* @__PURE__ */ O("span", { children: [
                      bt(w, "24hrutc"),
                      " (",
                      lr(w)?.toRelative({ unit: "days" }),
                      ")"
                    ] })
                  }
                )
              )
            }
          )
        ] }) }),
        !N && !M && he
      ] }),
      /* @__PURE__ */ O("div", { className: Ue.panelSection, children: [
        /* @__PURE__ */ l("div", { className: Ue.panelSectionHeading, children: "Additional configuration" }),
        /* @__PURE__ */ O("div", { className: Ue.panelSectionColumns, children: [
          /* @__PURE__ */ O("div", { className: Ue.panelSectionColumn, children: [
            /* @__PURE__ */ l(ON, { hologramSimId: e }),
            /* @__PURE__ */ l(
              ee,
              {
                label: "Outbound SMS limit",
                value: /* @__PURE__ */ O("div", { className: J(Ue.valueWithLink, Ue.numeric), children: [
                  /* @__PURE__ */ l("span", { children: W ? "10" : m.smsLimit }),
                  /* @__PURE__ */ l("span", { children: /* @__PURE__ */ l(
                    Ae,
                    {
                      href: "https://support.hologram.io/hc/en-us/articles/17463264768151-Set-a-device-s-SMS-limit?utm_source=dashboard&utm_medium=application&utm_content=sim_details_sms_limit",
                      target: "_blank",
                      rel: "noreferrer",
                      type: "inline",
                      ariaLabel: "Learn more - SMS limit",
                      children: "Learn more"
                    }
                  ) })
                ] })
              }
            )
          ] }),
          /* @__PURE__ */ l("div", { className: Ue.panelSectionColumn, children: /* @__PURE__ */ l(
            ee,
            {
              label: "Phone number",
              valueClassname: Ue.numeric,
              value: /* @__PURE__ */ O("div", { className: Ue.valueWithLink, children: [
                !C && /* @__PURE__ */ l("span", { className: Ue.diminished, children: "None" }),
                /* @__PURE__ */ l(
                  Ae,
                  {
                    to: L,
                    type: "inline",
                    ariaLabel: C ? "Phone number - Pricing link" : "Purchase phone number - Pricing link",
                    children: C || "Purchase phone number"
                  }
                )
              ] })
            }
          ) })
        ] })
      ] })
    ] });
  }, [
    N,
    E,
    c.deviceName,
    S,
    te,
    w,
    P,
    R,
    D,
    e,
    M,
    A,
    q,
    W,
    I,
    F,
    C,
    y,
    L,
    _,
    B,
    H,
    f,
    m.smsLimit,
    d,
    T,
    x
  ]);
  return /* @__PURE__ */ l(
    He,
    {
      header: i.networkStatus?.startsWith("DEAD") ? "Last known SIM details" : "SIM details",
      noContentPadding: !0,
      isLoading: q || a || b || u,
      children: G
    }
  );
}, LN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-arrowCell", jN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-eventCell", WN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-field", UN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-iccid", VN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-iccidCell", HN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-profile", qN = "hyperdashboard-SimFallbackHistory-module-HzHZQa-timeCell", Mr = {
  arrowCell: LN,
  eventCell: jN,
  field: WN,
  iccid: UN,
  iccidCell: VN,
  profile: HN,
  timeCell: qN
}, zN = [
  { children: "Event", key: "Event" },
  { children: "Date and time (UTC)", key: "Date and time (UTC)" },
  { children: "From profile ICCID", key: "From profile ICCID" },
  { children: " ", key: "arrow" },
  { children: "To profile ICCID", key: "To profile ICCID" },
  { children: " ", key: "filler" }
], BN = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    error: r,
    isLoading: n
  } = Le(e), {
    simProfiles: i,
    error: a,
    isLoading: s
  } = kr(e), {
    fallbackHistory: o,
    isLoading: c,
    error: u
  } = lw(e), f = V(() => {
    const v = {}, b = [
      "DdsColorPaletteTeal20",
      "DdsColorPaletteTeal60",
      "DdsColorPaletteTeal30",
      "DdsColorPaletteTeal40"
    ];
    return i.forEach((m) => {
      m.iccid && (v[m.iccid] = b.pop() ?? "DdsColorPaletteTeal40");
    }), v;
  }, [i]), g = r || u || a, p = n || c || s, d = !!t.fallbackInstalled;
  if (!d && o.length === 0 || d && o.length === 0 && i.length === 1)
    return null;
  let h;
  if (g)
    h = /* @__PURE__ */ l(
      fe,
      {
        variant: "error",
        label: "We ran into an issue loading your SIM fallback history",
        actions: /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            iconStart: "Sync",
            onClick: () => {
              window.location.reload();
            },
            children: "Reload page"
          }
        ),
        children: "We will keep trying in the background or you can try to reload the page."
      }
    );
  else if (p)
    h = /* @__PURE__ */ l(fe, { children: "Loading..." });
  else if (o.length === 0)
    h = /* @__PURE__ */ l(fe, { icon: "SwapSIM", children: "This SIM has not used network fallback protection yet." });
  else {
    const v = o.map((b, m) => {
      const { fallbackTime: S, fromIccid: I, fromProfileName: C, toIccid: T, toProfileName: E } = b, N = new Array(5);
      return N[0] = {
        key: E ?? m.toString(),
        children: /* @__PURE__ */ O("div", { className: Mr.eventCell, children: [
          /* @__PURE__ */ l(ye, { name: "SwapSIM", fill: T ? f[T] : "DdsColorPaletteTeal40" }),
          /* @__PURE__ */ O("span", { children: [
            "Switched to ",
            E
          ] })
        ] })
      }, N[1] = {
        key: S ?? "",
        className: Mr.timeCell,
        children: bt(S, "table")
      }, N[2] = {
        key: I ?? "",
        className: Mr.iccidCell,
        children: /* @__PURE__ */ l(
          ee,
          {
            className: Mr.field,
            direction: "column",
            labelClassName: Mr.iccid,
            valueClassname: Mr.profile,
            label: I ?? "",
            value: C ?? /* @__PURE__ */ l(Dt, {})
          }
        )
      }, N[3] = {
        key: "arrow-3",
        className: Mr.arrowCell,
        children: /* @__PURE__ */ l(ye, { size: "small", name: "ArrowEastLong", fill: "DdsColorPaletteGrey60" })
        // TODO: @DIMENSIONV2 UPDATE
      }, N[4] = {
        key: T ?? "",
        className: Mr.iccidCell,
        children: /* @__PURE__ */ l(
          ee,
          {
            className: Mr.field,
            direction: "column",
            labelClassName: Mr.iccid,
            valueClassname: Mr.profile,
            label: T ?? "",
            value: E ?? /* @__PURE__ */ l(Dt, {})
          }
        )
      }, N[5] = {
        key: "filler",
        children: " "
      }, { key: `${S}-${I}-${T}`, cells: N };
    });
    h = /* @__PURE__ */ l(ei, { headers: zN, rows: v });
  }
  return /* @__PURE__ */ l(He, { header: "Fallback history", noContentPadding: !0, isLoading: p, children: h });
}, GN = "hyperdashboard-shared-module-a0S0aW-sharedLoadingAnimation", QN = "hyperdashboard-shared-module-a0S0aW-sharedLoadingAnimationParent", Qo = {
  sharedLoadingAnimation: GN,
  sharedLoadingAnimationParent: QN
}, ZN = {
  details: "Status",
  simanddevices: "SIM and device",
  profiles: "Profiles",
  recentsessions: "Recent sessions",
  usage: "Usage reporting",
  locationhistory: "Location history",
  coverage: "Coverage",
  pricing: "Pricing",
  webhooks: "Webhooks",
  routes: "Routes"
}, YN = {
  invoices: "Invoices",
  settings: "Settings"
};
var gt = /* @__PURE__ */ ((e) => (e[e.XLSX = 0] = "XLSX", e[e.CSV = 1] = "CSV", e[e.JSON = 2] = "JSON", e))(gt || {});
const ea = (e) => {
  switch (e) {
    case 0:
      return "XLSX";
    case 1:
      return "CSV";
    case 2:
      return "JSON";
    default:
      return;
  }
}, gp = (e) => Symbol.iterator in e, vp = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), yp = (e, t) => {
  const r = e instanceof Map ? e : new Map(e.entries()), n = t instanceof Map ? t : new Map(t.entries());
  if (r.size !== n.size)
    return !1;
  for (const [i, a] of r)
    if (!Object.is(a, n.get(i)))
      return !1;
  return !0;
}, KN = (e, t) => {
  const r = e[Symbol.iterator](), n = t[Symbol.iterator]();
  let i = r.next(), a = n.next();
  for (; !i.done && !a.done; ) {
    if (!Object.is(i.value, a.value))
      return !1;
    i = r.next(), a = n.next();
  }
  return !!i.done && !!a.done;
};
function JN(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null ? !1 : !gp(e) || !gp(t) ? yp(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  ) : vp(e) && vp(t) ? yp(e, t) : KN(e, t);
}
function yh(e) {
  const t = _t.useRef(void 0);
  return (r) => {
    const n = e(r);
    return JN(t.current, n) ? t.current : t.current = n;
  };
}
const bp = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), n = (u, f) => {
    const g = typeof u == "function" ? u(t) : u;
    if (!Object.is(g, t)) {
      const p = t;
      t = f ?? (typeof g != "object" || g === null) ? g : Object.assign({}, t, g), r.forEach((d) => d(t, p));
    }
  }, i = () => t, o = { setState: n, getState: i, getInitialState: () => c, subscribe: (u) => (r.add(u), () => r.delete(u)) }, c = t = e(n, i, o);
  return o;
}, XN = (e) => e ? bp(e) : bp, eD = (e) => e;
function Ow(e, t = eD) {
  const r = _t.useSyncExternalStore(
    e.subscribe,
    () => t(e.getState()),
    () => t(e.getInitialState())
  );
  return _t.useDebugValue(r), r;
}
const Sp = (e) => {
  const t = XN(e), r = (n) => Ow(t, n);
  return Object.assign(r, t), r;
}, bh = (e) => e ? Sp(e) : Sp, Sh = Br(void 0);
function Ms(e) {
  const t = wr(Sh);
  if (!t)
    throw new Error("Missing SimInventoryStoreProvider in the tree");
  return Ow(t, e);
}
const Ar = () => Ms(yh((e) => e.filters));
var cc, wp;
function wh() {
  if (wp) return cc;
  wp = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return cc = e, cc;
}
var tD = wh();
const rD = /* @__PURE__ */ Ji(tD), Nw = ({ segmentName: e, filters: t }) => {
  if (!t)
    return !1;
  const r = Object.keys(t).filter((i) => {
    const s = t[i];
    if (!s)
      return !1;
    if (rD(s)) {
      if (Object.keys(s).length === 0)
        return !1;
    } else if (zr(s) && s.length === 0)
      return !1;
    return !0;
  });
  if (r.length === 0)
    return !1;
  let n;
  switch (e) {
    case "active":
    case "deactivated":
    case "preflight":
      n = ["organizationId"];
      break;
    case "all":
    default:
      n = [];
  }
  return r.filter((i) => !n.includes(i)).length > 0;
}, Dw = (e) => !!e?.timeframe && (e.timeframe !== "custom" || !!(e?.start && e?.end && e.start.length > 0 && e.end.length > 0)), uc = (e) => {
  if (!Dw(e))
    return;
  const t = {
    startTime: Mn(e.start)?.toUTC().startOf("day")?.toISO({}) ?? void 0,
    endTime: Mn(e.end)?.toUTC()?.endOf("day")?.toISO({}) ?? void 0
  };
  if (t.startTime && t.endTime)
    return t;
}, vl = ({ segmentName: e }) => {
  const t = Ar(), { getNetworkStatusFromFriendly: r, networkStatusGroups: n, isLoading: i, error: a } = ht(), s = Ne(), o = V(() => {
    const f = structuredClone(t) ?? {};
    return e !== "all" && (f.organizationId = s), f;
  }, [s, e, t]), { filters: c, hasFilters: u } = V(() => {
    const f = {};
    let g = !1;
    o?.organizationId && (f.organizationId = o.organizationId, g = !0), o?.deviceName && (f.deviceName = o.deviceName, g = !0), o?.iccid && (f.iccidFilterProperty = {
      iccid: o.iccid.value,
      iccidCondition: o.iccid.condition
    }, g = !0);
    const p = uc(o?.lastActive);
    p && (f.lastActiveDate = p, g = !0);
    const d = uc(o?.activationDate);
    d && (f.activationTime = d, g = !0);
    const h = uc(
      o?.targetActivationDate
    );
    if (h && (f.expectedActivationTime = h, g = !0), o?.imei && (f.imeiFilterProperty = {
      imei: o.imei.value,
      imeiCondition: o.imei.condition
    }, g = !0), o?.tags && o.tags.length > 0 && (f.tagIds = o.tags, g = !0), o?.noTags && (f.filterNoTags = o.noTags, g = !0), o?.plans && o.plans.length > 0 && (f.planID = o.plans, g = !0), o?.simStatuses && zr(o?.simStatuses) && o.simStatuses.length > 0) {
      const v = o.simStatuses?.reduce((b, m) => (r(m).forEach((S) => {
        b.add(S);
      }), b), /* @__PURE__ */ new Set());
      f.networkStatus = [...v?.values() ?? []].sort(
        (b, m) => b.localeCompare(m)
      ), g = !0;
    } else e !== "all" && (e === "active" ? f.networkStatus = n?.active : e === "preflight" ? f.networkStatus = n?.predeployment : f.networkStatus = n?.deactivated, g = !0);
    return { filters: f, hasFilters: g };
  }, [o, r, n, e]);
  return {
    filters: c,
    hasUserFilterApplied: Nw({ segmentName: e, filters: o }),
    filtersValidForAllSegment: !!c?.organizationId || (c?.iccidFilterProperty?.iccid?.length ?? 0) > 0,
    hasFilters: u,
    isLoading: i,
    error: a
  };
}, Rw = () => Ms(yh((e) => e.sorts)), nD = ({ defaultSort: e }) => {
  const t = Rw();
  return V(() => t.length === 0 ? e : [
    ...t,
    ...e.filter(
      (r) => !t.find((n) => n.property === r.property)
    )
  ], [t, e]);
}, iD = () => {
  const e = V(
    () => N0.map(([r, n]) => ({
      code: n,
      name: r
    })).sort((r, n) => r.code === "US" ? -1 : r.name.localeCompare(n.name)),
    []
  ), t = V(
    () => new Map(e.map((r) => [r.code, r.name])),
    [e]
  );
  return { countries: e, reverseCountryLookup: t };
}, aD = "hyperdashboard-ExportSims-module-s1o2kG-contactSupportLink", sD = "hyperdashboard-ExportSims-module-s1o2kG-notification", oD = "hyperdashboard-ExportSims-module-s1o2kG-wrapper", ma = {
  contactSupportLink: aD,
  notification: sD,
  wrapper: oD
}, lD = 1e4, cD = 5;
async function* uD(e, t, r, n) {
  let i = 0;
  for (; i < n.length; ) {
    const a = n[i].map(async (s) => {
      const o = {
        pagination: { disable: !0 },
        hologramSimIds: s
      };
      return r || (o.organizationId = t), await ft({
        url: e,
        body: o
      });
    });
    yield Promise.all(a), i += 1;
  }
}
const dD = ({ sims: e, organizationId: t, isSuperAdmin: r }) => {
  const n = e && (t || r) ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims` : null, i = V(() => [...e.keys()].reduce(
    (o, c, u) => {
      const f = Math.floor(u / lD);
      return o[f] || (o[f] = []), o[f].push(c), o;
    },
    []
  ).reduce((o, c, u) => {
    const f = Math.floor(u / cD);
    return o[f] || (o[f] = []), o[f].push(c), o;
  }, []), [e]);
  return $(async () => {
    if (!n || !t)
      return;
    let s = [];
    for await (const o of uD(
      n,
      t,
      r,
      i
    ))
      s = s.concat(o);
    return s;
  }, [r, t, i, n]);
};
var ko = { exports: {} };
/* @license
Papa Parse
v5.5.2
https://github.com/mholt/PapaParse
License: MIT
*/
var fD = ko.exports, Ip;
function hD() {
  return Ip || (Ip = 1, function(e, t) {
    ((r, n) => {
      e.exports = n();
    })(fD, function r() {
      var n = typeof self < "u" ? self : typeof window < "u" ? window : n !== void 0 ? n : {}, i, a = !n.document && !!n.postMessage, s = n.IS_PAPA_WORKER || !1, o = {}, c = 0, u = {};
      function f(y) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(w) {
          var P = T(w);
          P.chunkSize = parseInt(P.chunkSize), w.step || w.chunk || (P.chunkSize = null), this._handle = new v(P), (this._handle.streamer = this)._config = P;
        }.call(this, y), this.parseChunk = function(w, P) {
          var _ = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < _) {
            let R = this._config.newline;
            R || (D = this._config.quoteChar || '"', R = this._handle.guessLineEndings(w, D)), w = [...w.split(R).slice(_)].join(R);
          }
          this.isFirstChunk && N(this._config.beforeFirstChunk) && (D = this._config.beforeFirstChunk(w)) !== void 0 && (w = D), this.isFirstChunk = !1, this._halted = !1;
          var _ = this._partialLine + w, D = (this._partialLine = "", this._handle.parse(_, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            if (w = D.meta.cursor, _ = (this._finished || (this._partialLine = _.substring(w - this._baseIndex), this._baseIndex = w), D && D.data && (this._rowCount += D.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), s) n.postMessage({ results: D, workerId: u.WORKER_ID, finished: _ });
            else if (N(this._config.chunk) && !P) {
              if (this._config.chunk(D, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              this._completeResults = D = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(D.data), this._completeResults.errors = this._completeResults.errors.concat(D.errors), this._completeResults.meta = D.meta), this._completed || !_ || !N(this._config.complete) || D && D.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), _ || D && D.meta.paused || this._nextChunk(), D;
          }
          this._halted = !0;
        }, this._sendError = function(w) {
          N(this._config.error) ? this._config.error(w) : s && this._config.error && n.postMessage({ workerId: u.WORKER_ID, error: w, finished: !1 });
        };
      }
      function g(y) {
        var w;
        (y = y || {}).chunkSize || (y.chunkSize = u.RemoteChunkSize), f.call(this, y), this._nextChunk = a ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(P) {
          this._input = P, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (w = new XMLHttpRequest(), this._config.withCredentials && (w.withCredentials = this._config.withCredentials), a || (w.onload = E(this._chunkLoaded, this), w.onerror = E(this._chunkError, this)), w.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !a), this._config.downloadRequestHeaders) {
              var P, _ = this._config.downloadRequestHeaders;
              for (P in _) w.setRequestHeader(P, _[P]);
            }
            var D;
            this._config.chunkSize && (D = this._start + this._config.chunkSize - 1, w.setRequestHeader("Range", "bytes=" + this._start + "-" + D));
            try {
              w.send(this._config.downloadRequestBody);
            } catch (R) {
              this._chunkError(R.message);
            }
            a && w.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          w.readyState === 4 && (w.status < 200 || 400 <= w.status ? this._chunkError() : (this._start += this._config.chunkSize || w.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((P) => (P = P.getResponseHeader("Content-Range")) !== null ? parseInt(P.substring(P.lastIndexOf("/") + 1)) : -1)(w), this.parseChunk(w.responseText)));
        }, this._chunkError = function(P) {
          P = w.statusText || P, this._sendError(new Error(P));
        };
      }
      function p(y) {
        (y = y || {}).chunkSize || (y.chunkSize = u.LocalChunkSize), f.call(this, y);
        var w, P, _ = typeof FileReader < "u";
        this.stream = function(D) {
          this._input = D, P = D.slice || D.webkitSlice || D.mozSlice, _ ? ((w = new FileReader()).onload = E(this._chunkLoaded, this), w.onerror = E(this._chunkError, this)) : w = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var D = this._input, R = (this._config.chunkSize && (R = Math.min(this._start + this._config.chunkSize, this._input.size), D = P.call(D, this._start, R)), w.readAsText(D, this._config.encoding));
          _ || this._chunkLoaded({ target: { result: R } });
        }, this._chunkLoaded = function(D) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(D.target.result);
        }, this._chunkError = function() {
          this._sendError(w.error);
        };
      }
      function d(y) {
        var w;
        f.call(this, y = y || {}), this.stream = function(P) {
          return w = P, this._nextChunk();
        }, this._nextChunk = function() {
          var P, _;
          if (!this._finished) return P = this._config.chunkSize, w = P ? (_ = w.substring(0, P), w.substring(P)) : (_ = w, ""), this._finished = !w, this.parseChunk(_);
        };
      }
      function h(y) {
        f.call(this, y = y || {});
        var w = [], P = !0, _ = !1;
        this.pause = function() {
          f.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          f.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(D) {
          this._input = D, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          _ && w.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), w.length ? this.parseChunk(w.shift()) : P = !0;
        }, this._streamData = E(function(D) {
          try {
            w.push(typeof D == "string" ? D : D.toString(this._config.encoding)), P && (P = !1, this._checkIsFinished(), this.parseChunk(w.shift()));
          } catch (R) {
            this._streamError(R);
          }
        }, this), this._streamError = E(function(D) {
          this._streamCleanUp(), this._sendError(D);
        }, this), this._streamEnd = E(function() {
          this._streamCleanUp(), _ = !0, this._streamData("");
        }, this), this._streamCleanUp = E(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function v(y) {
        var w, P, _, D, R = Math.pow(2, 53), x = -R, F = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, W = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, A = this, M = 0, j = 0, B = !1, L = !1, H = [], q = { data: [], errors: [], meta: {} };
        function te(oe) {
          return y.skipEmptyLines === "greedy" ? oe.join("").trim() === "" : oe.length === 1 && oe[0].length === 0;
        }
        function G() {
          if (q && _ && (re("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), _ = !1), y.skipEmptyLines && (q.data = q.data.filter(function(Q) {
            return !te(Q);
          })), X()) {
            let Q = function(he, ce) {
              N(y.transformHeader) && (he = y.transformHeader(he, ce)), H.push(he);
            };
            if (q) if (Array.isArray(q.data[0])) {
              for (var oe = 0; X() && oe < q.data.length; oe++) q.data[oe].forEach(Q);
              q.data.splice(0, 1);
            } else q.data.forEach(Q);
          }
          function ue(Q, he) {
            for (var ce = y.header ? {} : [], se = 0; se < Q.length; se++) {
              var pe = se, k = Q[se], k = ((z, U) => ((ie) => (y.dynamicTypingFunction && y.dynamicTyping[ie] === void 0 && (y.dynamicTyping[ie] = y.dynamicTypingFunction(ie)), (y.dynamicTyping[ie] || y.dynamicTyping) === !0))(z) ? U === "true" || U === "TRUE" || U !== "false" && U !== "FALSE" && (((ie) => {
                if (F.test(ie) && (ie = parseFloat(ie), x < ie && ie < R))
                  return 1;
              })(U) ? parseFloat(U) : W.test(U) ? new Date(U) : U === "" ? null : U) : U)(pe = y.header ? se >= H.length ? "__parsed_extra" : H[se] : pe, k = y.transform ? y.transform(k, pe) : k);
              pe === "__parsed_extra" ? (ce[pe] = ce[pe] || [], ce[pe].push(k)) : ce[pe] = k;
            }
            return y.header && (se > H.length ? re("FieldMismatch", "TooManyFields", "Too many fields: expected " + H.length + " fields but parsed " + se, j + he) : se < H.length && re("FieldMismatch", "TooFewFields", "Too few fields: expected " + H.length + " fields but parsed " + se, j + he)), ce;
          }
          var de;
          q && (y.header || y.dynamicTyping || y.transform) && (de = 1, !q.data.length || Array.isArray(q.data[0]) ? (q.data = q.data.map(ue), de = q.data.length) : q.data = ue(q.data, 0), y.header && q.meta && (q.meta.fields = H), j += de);
        }
        function X() {
          return y.header && H.length === 0;
        }
        function re(oe, ue, de, Q) {
          oe = { type: oe, code: ue, message: de }, Q !== void 0 && (oe.row = Q), q.errors.push(oe);
        }
        N(y.step) && (D = y.step, y.step = function(oe) {
          q = oe, X() ? G() : (G(), q.data.length !== 0 && (M += oe.data.length, y.preview && M > y.preview ? P.abort() : (q.data = q.data[0], D(q, A))));
        }), this.parse = function(oe, ue, de) {
          var Q = y.quoteChar || '"', Q = (y.newline || (y.newline = this.guessLineEndings(oe, Q)), _ = !1, y.delimiter ? N(y.delimiter) && (y.delimiter = y.delimiter(oe), q.meta.delimiter = y.delimiter) : ((Q = ((he, ce, se, pe, k) => {
            var z, U, ie, ae;
            k = k || [",", "	", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
            for (var ne = 0; ne < k.length; ne++) {
              for (var me, Te = k[ne], Ce = 0, Re = 0, xe = 0, _e = (ie = void 0, new m({ comments: pe, delimiter: Te, newline: ce, preview: 10 }).parse(he)), $e = 0; $e < _e.data.length; $e++) se && te(_e.data[$e]) ? xe++ : (me = _e.data[$e].length, Re += me, ie === void 0 ? ie = me : 0 < me && (Ce += Math.abs(me - ie), ie = me));
              0 < _e.data.length && (Re /= _e.data.length - xe), (U === void 0 || Ce <= U) && (ae === void 0 || ae < Re) && 1.99 < Re && (U = Ce, z = Te, ae = Re);
            }
            return { successful: !!(y.delimiter = z), bestDelimiter: z };
          })(oe, y.newline, y.skipEmptyLines, y.comments, y.delimitersToGuess)).successful ? y.delimiter = Q.bestDelimiter : (_ = !0, y.delimiter = u.DefaultDelimiter), q.meta.delimiter = y.delimiter), T(y));
          return y.preview && y.header && Q.preview++, w = oe, P = new m(Q), q = P.parse(w, ue, de), G(), B ? { meta: { paused: !0 } } : q || { meta: { paused: !1 } };
        }, this.paused = function() {
          return B;
        }, this.pause = function() {
          B = !0, P.abort(), w = N(y.chunk) ? "" : w.substring(P.getCharIndex());
        }, this.resume = function() {
          A.streamer._halted ? (B = !1, A.streamer.parseChunk(w, !0)) : setTimeout(A.resume, 3);
        }, this.aborted = function() {
          return L;
        }, this.abort = function() {
          L = !0, P.abort(), q.meta.aborted = !0, N(y.complete) && y.complete(q), w = "";
        }, this.guessLineEndings = function(he, Q) {
          he = he.substring(0, 1048576);
          var Q = new RegExp(b(Q) + "([^]*?)" + b(Q), "gm"), de = (he = he.replace(Q, "")).split("\r"), Q = he.split(`
`), he = 1 < Q.length && Q[0].length < de[0].length;
          if (de.length === 1 || he) return `
`;
          for (var ce = 0, se = 0; se < de.length; se++) de[se][0] === `
` && ce++;
          return ce >= de.length / 2 ? `\r
` : "\r";
        };
      }
      function b(y) {
        return y.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function m(y) {
        var w = (y = y || {}).delimiter, P = y.newline, _ = y.comments, D = y.step, R = y.preview, x = y.fastMode, F = null, W = !1, A = y.quoteChar == null ? '"' : y.quoteChar, M = A;
        if (y.escapeChar !== void 0 && (M = y.escapeChar), (typeof w != "string" || -1 < u.BAD_DELIMITERS.indexOf(w)) && (w = ","), _ === w) throw new Error("Comment character same as delimiter");
        _ === !0 ? _ = "#" : (typeof _ != "string" || -1 < u.BAD_DELIMITERS.indexOf(_)) && (_ = !1), P !== `
` && P !== "\r" && P !== `\r
` && (P = `
`);
        var j = 0, B = !1;
        this.parse = function(L, H, q) {
          if (typeof L != "string") throw new Error("Input must be a string");
          var te = L.length, G = w.length, X = P.length, re = _.length, oe = N(D), ue = [], de = [], Q = [], he = j = 0;
          if (!L) return Ce();
          if (x || x !== !1 && L.indexOf(A) === -1) {
            for (var ce = L.split(P), se = 0; se < ce.length; se++) {
              if (Q = ce[se], j += Q.length, se !== ce.length - 1) j += P.length;
              else if (q) return Ce();
              if (!_ || Q.substring(0, re) !== _) {
                if (oe) {
                  if (ue = [], ae(Q.split(w)), Re(), B) return Ce();
                } else ae(Q.split(w));
                if (R && R <= se) return ue = ue.slice(0, R), Ce(!0);
              }
            }
            return Ce();
          }
          for (var pe = L.indexOf(w, j), k = L.indexOf(P, j), z = new RegExp(b(M) + b(A), "g"), U = L.indexOf(A, j); ; ) if (L[j] === A) for (U = j, j++; ; ) {
            if ((U = L.indexOf(A, U + 1)) === -1) return q || de.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: ue.length, index: j }), me();
            if (U === te - 1) return me(L.substring(j, U).replace(z, A));
            if (A === M && L[U + 1] === M) U++;
            else if (A === M || U === 0 || L[U - 1] !== M) {
              pe !== -1 && pe < U + 1 && (pe = L.indexOf(w, U + 1));
              var ie = ne((k = k !== -1 && k < U + 1 ? L.indexOf(P, U + 1) : k) === -1 ? pe : Math.min(pe, k));
              if (L.substr(U + 1 + ie, G) === w) {
                Q.push(L.substring(j, U).replace(z, A)), L[j = U + 1 + ie + G] !== A && (U = L.indexOf(A, j)), pe = L.indexOf(w, j), k = L.indexOf(P, j);
                break;
              }
              if (ie = ne(k), L.substring(U + 1 + ie, U + 1 + ie + X) === P) {
                if (Q.push(L.substring(j, U).replace(z, A)), Te(U + 1 + ie + X), pe = L.indexOf(w, j), U = L.indexOf(A, j), oe && (Re(), B)) return Ce();
                if (R && ue.length >= R) return Ce(!0);
                break;
              }
              de.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: ue.length, index: j }), U++;
            }
          }
          else if (_ && Q.length === 0 && L.substring(j, j + re) === _) {
            if (k === -1) return Ce();
            j = k + X, k = L.indexOf(P, j), pe = L.indexOf(w, j);
          } else if (pe !== -1 && (pe < k || k === -1)) Q.push(L.substring(j, pe)), j = pe + G, pe = L.indexOf(w, j);
          else {
            if (k === -1) break;
            if (Q.push(L.substring(j, k)), Te(k + X), oe && (Re(), B)) return Ce();
            if (R && ue.length >= R) return Ce(!0);
          }
          return me();
          function ae(xe) {
            ue.push(xe), he = j;
          }
          function ne(xe) {
            var _e = 0;
            return _e = xe !== -1 && (xe = L.substring(U + 1, xe)) && xe.trim() === "" ? xe.length : _e;
          }
          function me(xe) {
            return q || (xe === void 0 && (xe = L.substring(j)), Q.push(xe), j = te, ae(Q), oe && Re()), Ce();
          }
          function Te(xe) {
            j = xe, ae(Q), Q = [], k = L.indexOf(P, j);
          }
          function Ce(xe) {
            if (y.header && !H && ue.length && !W) {
              var _e = ue[0], $e = {}, jt = new Set(_e);
              let dr = !1;
              for (let Wt = 0; Wt < _e.length; Wt++) {
                let nt = _e[Wt];
                if ($e[nt = N(y.transformHeader) ? y.transformHeader(nt, Wt) : nt]) {
                  let fr, hr = $e[nt];
                  for (; fr = nt + "_" + hr, hr++, jt.has(fr); ) ;
                  jt.add(fr), _e[Wt] = fr, $e[nt]++, dr = !0, (F = F === null ? {} : F)[fr] = nt;
                } else $e[nt] = 1, _e[Wt] = nt;
                jt.add(nt);
              }
              dr && console.warn("Duplicate headers found and renamed."), W = !0;
            }
            return { data: ue, errors: de, meta: { delimiter: w, linebreak: P, aborted: B, truncated: !!xe, cursor: he + (H || 0), renamedHeaders: F } };
          }
          function Re() {
            D(Ce()), ue = [], de = [];
          }
        }, this.abort = function() {
          B = !0;
        }, this.getCharIndex = function() {
          return j;
        };
      }
      function S(y) {
        var w = y.data, P = o[w.workerId], _ = !1;
        if (w.error) P.userError(w.error, w.file);
        else if (w.results && w.results.data) {
          var D = { abort: function() {
            _ = !0, I(w.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: C, resume: C };
          if (N(P.userStep)) {
            for (var R = 0; R < w.results.data.length && (P.userStep({ data: w.results.data[R], errors: w.results.errors, meta: w.results.meta }, D), !_); R++) ;
            delete w.results;
          } else N(P.userChunk) && (P.userChunk(w.results, D, w.file), delete w.results);
        }
        w.finished && !_ && I(w.workerId, w.results);
      }
      function I(y, w) {
        var P = o[y];
        N(P.userComplete) && P.userComplete(w), P.terminate(), delete o[y];
      }
      function C() {
        throw new Error("Not implemented.");
      }
      function T(y) {
        if (typeof y != "object" || y === null) return y;
        var w, P = Array.isArray(y) ? [] : {};
        for (w in y) P[w] = T(y[w]);
        return P;
      }
      function E(y, w) {
        return function() {
          y.apply(w, arguments);
        };
      }
      function N(y) {
        return typeof y == "function";
      }
      return u.parse = function(y, w) {
        var P = (w = w || {}).dynamicTyping || !1;
        if (N(P) && (w.dynamicTypingFunction = P, P = {}), w.dynamicTyping = P, w.transform = !!N(w.transform) && w.transform, !w.worker || !u.WORKERS_SUPPORTED) return P = null, u.NODE_STREAM_INPUT, typeof y == "string" ? (y = ((_) => _.charCodeAt(0) !== 65279 ? _ : _.slice(1))(y), P = new (w.download ? g : d)(w)) : y.readable === !0 && N(y.read) && N(y.on) ? P = new h(w) : (n.File && y instanceof File || y instanceof Object) && (P = new p(w)), P.stream(y);
        (P = (() => {
          var _;
          return !!u.WORKERS_SUPPORTED && (_ = (() => {
            var D = n.URL || n.webkitURL || null, R = r.toString();
            return u.BLOB_URL || (u.BLOB_URL = D.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", R, ")();"], { type: "text/javascript" })));
          })(), (_ = new n.Worker(_)).onmessage = S, _.id = c++, o[_.id] = _);
        })()).userStep = w.step, P.userChunk = w.chunk, P.userComplete = w.complete, P.userError = w.error, w.step = N(w.step), w.chunk = N(w.chunk), w.complete = N(w.complete), w.error = N(w.error), delete w.worker, P.postMessage({ input: y, config: w, workerId: P.id });
      }, u.unparse = function(y, w) {
        var P = !1, _ = !0, D = ",", R = `\r
`, x = '"', F = x + x, W = !1, A = null, M = !1, j = ((() => {
          if (typeof w == "object") {
            if (typeof w.delimiter != "string" || u.BAD_DELIMITERS.filter(function(H) {
              return w.delimiter.indexOf(H) !== -1;
            }).length || (D = w.delimiter), typeof w.quotes != "boolean" && typeof w.quotes != "function" && !Array.isArray(w.quotes) || (P = w.quotes), typeof w.skipEmptyLines != "boolean" && typeof w.skipEmptyLines != "string" || (W = w.skipEmptyLines), typeof w.newline == "string" && (R = w.newline), typeof w.quoteChar == "string" && (x = w.quoteChar), typeof w.header == "boolean" && (_ = w.header), Array.isArray(w.columns)) {
              if (w.columns.length === 0) throw new Error("Option columns is empty");
              A = w.columns;
            }
            w.escapeChar !== void 0 && (F = w.escapeChar + x), w.escapeFormulae instanceof RegExp ? M = w.escapeFormulae : typeof w.escapeFormulae == "boolean" && w.escapeFormulae && (M = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(b(x), "g"));
        if (typeof y == "string" && (y = JSON.parse(y)), Array.isArray(y)) {
          if (!y.length || Array.isArray(y[0])) return B(null, y, W);
          if (typeof y[0] == "object") return B(A || Object.keys(y[0]), y, W);
        } else if (typeof y == "object") return typeof y.data == "string" && (y.data = JSON.parse(y.data)), Array.isArray(y.data) && (y.fields || (y.fields = y.meta && y.meta.fields || A), y.fields || (y.fields = Array.isArray(y.data[0]) ? y.fields : typeof y.data[0] == "object" ? Object.keys(y.data[0]) : []), Array.isArray(y.data[0]) || typeof y.data[0] == "object" || (y.data = [y.data])), B(y.fields || [], y.data || [], W);
        throw new Error("Unable to serialize unrecognized input");
        function B(H, q, te) {
          var G = "", X = (typeof H == "string" && (H = JSON.parse(H)), typeof q == "string" && (q = JSON.parse(q)), Array.isArray(H) && 0 < H.length), re = !Array.isArray(q[0]);
          if (X && _) {
            for (var oe = 0; oe < H.length; oe++) 0 < oe && (G += D), G += L(H[oe], oe);
            0 < q.length && (G += R);
          }
          for (var ue = 0; ue < q.length; ue++) {
            var de = (X ? H : q[ue]).length, Q = !1, he = X ? Object.keys(q[ue]).length === 0 : q[ue].length === 0;
            if (te && !X && (Q = te === "greedy" ? q[ue].join("").trim() === "" : q[ue].length === 1 && q[ue][0].length === 0), te === "greedy" && X) {
              for (var ce = [], se = 0; se < de; se++) {
                var pe = re ? H[se] : se;
                ce.push(q[ue][pe]);
              }
              Q = ce.join("").trim() === "";
            }
            if (!Q) {
              for (var k = 0; k < de; k++) {
                0 < k && !he && (G += D);
                var z = X && re ? H[k] : k;
                G += L(q[ue][z], k);
              }
              ue < q.length - 1 && (!te || 0 < de && !he) && (G += R);
            }
          }
          return G;
        }
        function L(H, q) {
          var te, G;
          return H == null ? "" : H.constructor === Date ? JSON.stringify(H).slice(1, 25) : (G = !1, M && typeof H == "string" && M.test(H) && (H = "'" + H, G = !0), te = H.toString().replace(j, F), (G = G || P === !0 || typeof P == "function" && P(H, q) || Array.isArray(P) && P[q] || ((X, re) => {
            for (var oe = 0; oe < re.length; oe++) if (-1 < X.indexOf(re[oe])) return !0;
            return !1;
          })(te, u.BAD_DELIMITERS) || -1 < te.indexOf(D) || te.charAt(0) === " " || te.charAt(te.length - 1) === " ") ? x + te + x : te);
        }
      }, u.RECORD_SEP = "", u.UNIT_SEP = "", u.BYTE_ORDER_MARK = "\uFEFF", u.BAD_DELIMITERS = ["\r", `
`, '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !a && !!n.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = m, u.ParserHandle = v, u.NetworkStreamer = g, u.FileStreamer = p, u.StringStreamer = d, u.ReadableStreamStreamer = h, n.jQuery && ((i = n.jQuery).fn.parse = function(y) {
        var w = y.config || {}, P = [];
        return this.each(function(R) {
          if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && n.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var x = 0; x < this.files.length; x++) P.push({ file: this.files[x], inputElem: this, instanceConfig: i.extend({}, w) });
        }), _(), this;
        function _() {
          if (P.length === 0) N(y.complete) && y.complete();
          else {
            var R, x, F, W, A = P[0];
            if (N(y.before)) {
              var M = y.before(A.file, A.inputElem);
              if (typeof M == "object") {
                if (M.action === "abort") return R = "AbortError", x = A.file, F = A.inputElem, W = M.reason, void (N(y.error) && y.error({ name: R }, x, F, W));
                if (M.action === "skip") return void D();
                typeof M.config == "object" && (A.instanceConfig = i.extend(A.instanceConfig, M.config));
              } else if (M === "skip") return void D();
            }
            var j = A.instanceConfig.complete;
            A.instanceConfig.complete = function(B) {
              N(j) && j(B, A.file, A.inputElem), D();
            }, u.parse(A.file, A.instanceConfig);
          }
        }
        function D() {
          P.splice(0, 1), _();
        }
      }), s && (n.onmessage = function(y) {
        y = y.data, u.WORKER_ID === void 0 && y && (u.WORKER_ID = y.workerId), typeof y.input == "string" ? n.postMessage({ workerId: u.WORKER_ID, results: u.parse(y.input, y.config), finished: !0 }) : (n.File && y.input instanceof File || y.input instanceof Object) && (y = u.parse(y.input, y.config)) && n.postMessage({ workerId: u.WORKER_ID, results: y, finished: !0 });
      }), (g.prototype = Object.create(f.prototype)).constructor = g, (p.prototype = Object.create(f.prototype)).constructor = p, (d.prototype = Object.create(d.prototype)).constructor = d, (h.prototype = Object.create(f.prototype)).constructor = h, u;
    });
  }(ko)), ko.exports;
}
var yl = hD();
const Ih = ({ blob: e, filename: t }) => {
  let r;
  try {
    const n = document.createElement("a");
    n.download = t, r = window.URL.createObjectURL(e), n.href = r, n.click();
  } catch (n) {
    return console.error(`Download file error: ${n}`), !1;
  } finally {
    window.setTimeout(() => {
      r && window.URL.revokeObjectURL(r);
    }, 0);
  }
  return !0;
}, kw = ({ data: e, filename: t, type: r }) => Ih({ blob: new Blob(zr(e) ? e : [e], { type: r }), filename: t }), bl = ({ data: e, filename: t = "download.csv" }) => kw({ data: e, filename: t, type: "text/csv;charset-UTF-8" }), Aw = ({ data: e, filename: t = "download.json" }) => kw({ data: e, filename: t, type: "application/json;charset-UTF-8" }), Ch = ({ data: e, filename: t = "download.xlsx" }) => Ih({
  blob: new Blob([e], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8"
  }),
  filename: t
}), mD = (e, t, r) => r === "active" ? e.map((n) => ({
  orgId: n.organizationId,
  orgName: n.organizationName,
  hologramSimId: n.hologramSimId,
  // eid: sim.eid,
  simName: n.deviceName,
  deviceId: n.deviceId,
  lastKnownImei: n.imei,
  //   simEuiccState: sim.euiccState,
  simNetworkState: n.networkState,
  simNetworkStatus: t(n.networkState),
  enabledProfileIccid: n.activeProfileIccid,
  enabledProfileName: n.profileName,
  enabledProfileLinkId: n.simProfileId,
  //   enabledProfileImsi: sim.imsi,
  // enabledProfileMsisdn: sim.msisdn,
  //   enabledProfileApn: sim.enabledProfileApn,
  // mostRecentNetwork: sim.mostRecentNetwork,
  // enabledProfileNetworkState: sim.enabledProfileNetworkState,
  //   mostRecentRat: sim.mostRecentRat,
  //   mostRecentSessionStartTime: sim.mostRecentSessionStartTime,
  mostRecentSessionEndTime: n.mostRecentSession,
  //   fallbackState: sim.fallbackState,
  // fallbackTimer: sim.fallbackTimer,
  //   fallbackIsPrimaryProfile: sim.fallbackIsPrimaryProfile,
  dataPlanId: n.planID,
  dataPlanName: n.planName,
  //   dataPlanIncludedDataBytes: sim.dataPlanIncludedDataBytes,
  // dataPlanMonthlyCost: sim.dataPlanMonthlyCost,
  // dataPlanDataRate: sim.dataPlanDataRate,
  //   dataPlanSmsRate: sim.smsRate,
  //   dataPlanChargeOverageEnabled: sim.chargeOverage,
  //   dataUsageLimitBytes: sim.dataLimitBytes,
  dataUsageBytes: n.billingPeriodUsage,
  //   outboundSms: sim.outboundSms,
  //   outboundSmsLimit: sim.outboundSmsLimit,
  // billingPeriodTotalCharges: sim.billingPeriodTotalCharges,
  //   billingPeriodRenewalDate: sim.billingRenewalDate,
  tagNames: n.tags?.map((i) => i.name).join(","),
  tagIds: n.tags?.map((i) => i.id).join(","),
  activationTime: n.activationTime
})) : r === "preflight" ? e.map((n) => ({
  orgId: n.organizationId,
  orgName: n.organizationName,
  hologramSimId: n.hologramSimId,
  // eid: sim.eid,
  simName: n.deviceName,
  deviceId: n.deviceId,
  lastKnownImei: n.imei,
  //   simEuiccState: sim.euiccState,
  simNetworkState: n.networkState,
  simNetworkStatus: t(n.networkState),
  enabledProfileIccid: n.activeProfileIccid,
  enabledProfileName: n.profileName,
  enabledProfileLinkId: n.simProfileId,
  //   enabledProfileImsi: sim.imsi,
  // enabledProfileMsisdn: sim.msisdn,
  //   enabledProfileApn: sim.enabledProfileApn,
  // mostRecentNetwork: sim.mostRecentNetwork,
  // enabledProfileNetworkState: sim.enabledProfileNetworkState,
  //   mostRecentRat: sim.mostRecentRat,
  //   mostRecentSessionStartTime: sim.mostRecentSessionStartTime,
  mostRecentSessionEndTime: n.mostRecentSession,
  //   fallbackState: sim.fallbackState,
  // fallbackTimer: sim.fallbackTimer,
  //   fallbackIsPrimaryProfile: sim.fallbackIsPrimaryProfile,
  dataPlanId: n.planID,
  dataPlanName: n.planName,
  //   dataPlanIncludedDataBytes: sim.dataPlanIncludedDataBytes,
  // dataPlanMonthlyCost: sim.dataPlanMonthlyCost,
  // dataPlanDataRate: sim.dataPlanDataRate,
  //   dataPlanSmsRate: sim.smsRate,
  //   dataPlanChargeOverageEnabled: sim.chargeOverage,
  //   dataUsageLimitBytes: sim.dataLimitBytes,
  dataUsageBytes: n.billingPeriodUsage,
  //   outboundSms: sim.outboundSms,
  //   outboundSmsLimit: sim.outboundSmsLimit,
  // billingPeriodTotalCharges: sim.billingPeriodTotalCharges,
  //   billingPeriodRenewalDate: sim.billingRenewalDate,
  tagNames: n.tags?.map((i) => i.name).join(","),
  tagIds: n.tags?.map((i) => i.id).join(","),
  preflightDurationDays: n.preflightDuration,
  preflightExitBehavior: n.preflightExitBehavior,
  preflightStartTime: n.preflightStartTime,
  preflightUsageBytes: n.preflightUsage,
  expectedActivationTime: n.expectedActivationTime,
  expectedPreflightDuration: n.expectedPreflightDuration,
  activationTime: n.activationTime
})) : r === "deactivated" ? e.map((n) => ({
  orgId: n.organizationId,
  orgName: n.organizationName,
  hologramSimId: n.hologramSimId,
  // eid: sim.eid,
  simName: n.deviceName,
  deviceId: n.deviceId,
  lastKnownImei: n.imei,
  //   simEuiccState: sim.euiccState,
  simNetworkState: n.networkState,
  simNetworkStatus: t(n.networkState),
  enabledProfileIccid: n.activeProfileIccid,
  enabledProfileName: n.profileName,
  enabledProfileLinkId: n.simProfileId,
  //   enabledProfileImsi: sim.imsi,
  // enabledProfileMsisdn: sim.msisdn,
  //   enabledProfileApn: sim.enabledProfileApn,
  // mostRecentNetwork: sim.mostRecentNetwork,
  // enabledProfileNetworkState: sim.enabledProfileNetworkState,
  //   mostRecentRat: sim.mostRecentRat,
  //   mostRecentSessionStartTime: sim.mostRecentSessionStartTime,
  mostRecentSessionEndTime: n.mostRecentSession,
  //   fallbackState: sim.fallbackState,
  // fallbackTimer: sim.fallbackTimer,
  //   fallbackIsPrimaryProfile: sim.fallbackIsPrimaryProfile,
  dataPlanId: n.planID,
  dataPlanName: n.planName,
  //   dataPlanIncludedDataBytes: sim.dataPlanIncludedDataBytes,
  // dataPlanMonthlyCost: sim.dataPlanMonthlyCost,
  // dataPlanDataRate: sim.dataPlanDataRate,
  //   dataPlanSmsRate: sim.smsRate,
  //   dataPlanChargeOverageEnabled: sim.chargeOverage,
  //   dataUsageLimitBytes: sim.dataLimitBytes,
  dataUsageBytes: n.billingPeriodUsage,
  //   outboundSms: sim.outboundSms,
  //   outboundSmsLimit: sim.outboundSmsLimit,
  // billingPeriodTotalCharges: sim.billingPeriodTotalCharges,
  //   billingPeriodRenewalDate: sim.billingRenewalDate,
  tagNames: n.tags?.map((i) => i.name).join(","),
  tagIds: n.tags?.map((i) => i.id).join(","),
  activationTime: n.activationTime,
  deactivationTime: n.deactivationTime
})) : e.map((n) => ({
  orgId: n.organizationId,
  orgName: n.organizationName,
  hologramSimId: n.hologramSimId,
  // eid: sim.eid,
  simName: n.deviceName,
  deviceId: n.deviceId,
  lastKnownImei: n.imei,
  //   simEuiccState: sim.euiccState,
  simNetworkState: n.networkState,
  simNetworkStatus: t(n.networkState),
  enabledProfileIccid: n.activeProfileIccid,
  enabledProfileName: n.profileName,
  enabledProfileLinkId: n.simProfileId,
  //   enabledProfileImsi: sim.imsi,
  // enabledProfileMsisdn: sim.msisdn,
  //   enabledProfileApn: sim.enabledProfileApn,
  // mostRecentNetwork: sim.mostRecentNetwork,
  // enabledProfileNetworkState: sim.enabledProfileNetworkState,
  //   mostRecentRat: sim.mostRecentRat,
  //   mostRecentSessionStartTime: sim.mostRecentSessionStartTime,
  mostRecentSessionEndTime: n.mostRecentSession,
  //   fallbackState: sim.fallbackState,
  // fallbackTimer: sim.fallbackTimer,
  //   fallbackIsPrimaryProfile: sim.fallbackIsPrimaryProfile,
  dataPlanId: n.planID,
  dataPlanName: n.planName,
  //   dataPlanIncludedDataBytes: sim.dataPlanIncludedDataBytes,
  // dataPlanMonthlyCost: sim.dataPlanMonthlyCost,
  // dataPlanDataRate: sim.dataPlanDataRate,
  //   dataPlanSmsRate: sim.smsRate,
  //   dataPlanChargeOverageEnabled: sim.chargeOverage,
  //   dataUsageLimitBytes: sim.dataLimitBytes,
  dataUsageBytes: n.billingPeriodUsage,
  //   outboundSms: sim.outboundSms,
  //   outboundSmsLimit: sim.outboundSmsLimit,
  // billingPeriodTotalCharges: sim.billingPeriodTotalCharges,
  //   billingPeriodRenewalDate: sim.billingRenewalDate,
  tagNames: n.tags?.map((i) => i.name).join(","),
  tagIds: n.tags?.map((i) => i.id).join(","),
  preflightDurationDays: n.preflightDuration,
  preflightExitBehavior: n.preflightExitBehavior,
  preflightStartTime: n.preflightStartTime,
  preflightUsageBytes: n.preflightUsage,
  expectedActivationTime: n.expectedActivationTime,
  expectedPreflightDuration: n.expectedPreflightDuration,
  activationTime: n.activationTime,
  deactivationTime: n.deactivationTime
})), pD = (e, t, r) => r === "active" ? e.map((n) => ({
  hologramSimId: n.hologramSimId,
  name: n.deviceName,
  //   eid: sim.eid,
  enabledProfileIccid: n.activeProfileIccid,
  networkStatus: t(n.networkState),
  networkState: n.networkState,
  // sku: sim.sku,
  // printedSku: sim.printedSku,
  dataUsageBytes: n.billingPeriodUsage,
  // dataLimitBytes: sim.dataLimitBytes,
  // outboundSms: sim.outboundSms,
  // outboundSmsLimit: sim.outboundSmsLimit,
  organization: {
    orgId: n.organizationId,
    orgName: n.organizationName
  },
  device: {
    deviceId: n.deviceId,
    lastKnownImei: n.imei
  },
  dataPlan: {
    dataPlanId: n.planID,
    name: n.planName
    // platformFee: sim.platformFee,
    //  includedDataBytes: sim.includedDataBytes,
    // dataUsageRate: sim.dataUsageRate,
    // smsRate: sim.smsRate,
  },
  //   profiles: [],
  mostRecentSession: {
    // startTime: sim.mostRecentSession,
    endTime: n.mostRecentSession
    // dataUsageBytes: sim.mostRecentSessionBytes,
    // network: 'T-Mobile',
    // cellTowerId: '12345',
    // approximateLatLong: '50.0000000000,-50.00000000000',
  },
  //  networkFallback: {
  // status: sim.fallbackStatus,
  // fallbackProfileLinkId: sim.fallbackProfileLinkId,
  // fallbackTimerSeconds: sim.fallbackTimerSeconds,
  //  },
  tags: n.tags,
  activationTime: n.activationTime
  // customFields: sim.customFields,
})) : r === "preflight" ? e.map((n) => ({
  hologramSimId: n.hologramSimId,
  name: n.deviceName,
  //   eid: sim.eid,
  enabledProfileIccid: n.activeProfileIccid,
  networkStatus: t(n.networkState),
  networkState: n.networkState,
  // sku: sim.sku,
  // printedSku: sim.printedSku,
  dataUsageBytes: n.billingPeriodUsage,
  // dataLimitBytes: sim.dataLimitBytes,
  // outboundSms: sim.outboundSms,
  // outboundSmsLimit: sim.outboundSmsLimit,
  organization: {
    orgId: n.organizationId,
    orgName: n.organizationName
  },
  device: {
    deviceId: n.deviceId,
    lastKnownImei: n.imei
  },
  dataPlan: {
    dataPlanId: n.planID,
    name: n.planName
    // platformFee: sim.platformFee,
    //  includedDataBytes: sim.includedDataBytes,
    // dataUsageRate: sim.dataUsageRate,
    // smsRate: sim.smsRate,
  },
  //   profiles: [],
  mostRecentSession: {
    // startTime: sim.mostRecentSession,
    endTime: n.mostRecentSession
    // dataUsageBytes: sim.mostRecentSessionBytes,
    // network: 'T-Mobile',
    // cellTowerId: '12345',
    // approximateLatLong: '50.0000000000,-50.00000000000',
  },
  //  networkFallback: {
  // status: sim.fallbackStatus,
  // fallbackProfileLinkId: sim.fallbackProfileLinkId,
  // fallbackTimerSeconds: sim.fallbackTimerSeconds,
  //  },
  tags: n.tags,
  preflight: {
    exitBehavior: n.preflightExitBehavior,
    startTime: n.preflightStartTime,
    //  expectedEndTime: sim.preflightExpectedEndTime,
    //  endTime: sim.preflightEndTime,
    expectedDurationDays: n.expectedPreflightDuration,
    durationDays: n.preflightDuration,
    //  dataLimitBytes: sim.preflightDataLimitBytes,
    usageBytes: n.preflightUsage
    // outboundSmsLimit: sim.preflightOutboundSmsLimit,
  },
  activationTime: n.activationTime
  // customFields: sim.customFields,
})) : r === "deactivated" ? e.map((n) => ({
  hologramSimId: n.hologramSimId,
  name: n.deviceName,
  //   eid: sim.eid,
  enabledProfileIccid: n.activeProfileIccid,
  networkStatus: t(n.networkState),
  networkState: n.networkState,
  // sku: sim.sku,
  // printedSku: sim.printedSku,
  dataUsageBytes: n.billingPeriodUsage,
  // dataLimitBytes: sim.dataLimitBytes,
  // outboundSms: sim.outboundSms,
  // outboundSmsLimit: sim.outboundSmsLimit,
  organization: {
    orgId: n.organizationId,
    orgName: n.organizationName
  },
  device: {
    deviceId: n.deviceId,
    lastKnownImei: n.imei
  },
  dataPlan: {
    dataPlanId: n.planID,
    name: n.planName
    // platformFee: sim.platformFee,
    //  includedDataBytes: sim.includedDataBytes,
    // dataUsageRate: sim.dataUsageRate,
    // smsRate: sim.smsRate,
  },
  //   profiles: [],
  mostRecentSession: {
    // startTime: sim.mostRecentSession,
    endTime: n.mostRecentSession
    // dataUsageBytes: sim.mostRecentSessionBytes,
    // network: 'T-Mobile',
    // cellTowerId: '12345',
    // approximateLatLong: '50.0000000000,-50.00000000000',
  },
  //  networkFallback: {
  // status: sim.fallbackStatus,
  // fallbackProfileLinkId: sim.fallbackProfileLinkId,
  // fallbackTimerSeconds: sim.fallbackTimerSeconds,
  //  },
  tags: n.tags,
  activationTime: n.activationTime,
  deactivationTime: n.deactivationTime
  // customFields: sim.customFields,
})) : e.map((n) => ({
  hologramSimId: n.hologramSimId,
  name: n.deviceName,
  //   eid: sim.eid,
  enabledProfileIccid: n.activeProfileIccid,
  networkStatus: t(n.networkState),
  networkState: n.networkState,
  // sku: sim.sku,
  // printedSku: sim.printedSku,
  dataUsageBytes: n.billingPeriodUsage,
  // dataLimitBytes: sim.dataLimitBytes,
  // outboundSms: sim.outboundSms,
  // outboundSmsLimit: sim.outboundSmsLimit,
  organization: {
    orgId: n.organizationId,
    orgName: n.organizationName
  },
  device: {
    deviceId: n.deviceId,
    lastKnownImei: n.imei
  },
  dataPlan: {
    dataPlanId: n.planID,
    name: n.planName
    // platformFee: sim.platformFee,
    //  includedDataBytes: sim.includedDataBytes,
    // dataUsageRate: sim.dataUsageRate,
    // smsRate: sim.smsRate,
  },
  //   profiles: [],
  mostRecentSession: {
    // startTime: sim.mostRecentSession,
    endTime: n.mostRecentSession
    // dataUsageBytes: sim.mostRecentSessionBytes,
    // network: 'T-Mobile',
    // cellTowerId: '12345',
    // approximateLatLong: '50.0000000000,-50.00000000000',
  },
  //  networkFallback: {
  // status: sim.fallbackStatus,
  // fallbackProfileLinkId: sim.fallbackProfileLinkId,
  // fallbackTimerSeconds: sim.fallbackTimerSeconds,
  //  },
  tags: n.tags,
  preflight: {
    exitBehavior: n.preflightExitBehavior,
    startTime: n.preflightStartTime,
    //  expectedEndTime: sim.preflightExpectedEndTime,
    //  endTime: sim.preflightEndTime,
    expectedDurationDays: n.expectedPreflightDuration,
    durationDays: n.preflightDuration,
    //  dataLimitBytes: sim.preflightDataLimitBytes,
    usageBytes: n.preflightUsage
    // outboundSmsLimit: sim.preflightOutboundSmsLimit,
  },
  activationTime: n.activationTime,
  deactivationTime: n.deactivationTime
  // customFields: sim.customFields,
})), gD = ({ sims: e, exportType: t, segmentName: r, isSuperAdmin: n }) => {
  const [i, a] = Z(!0), [s, o] = Z(!1), [c, u] = Z(null), { sendAnalyticsEvent: f, sendAnalyticsError: g } = mt(), { isLoading: p, formatStatus: d, error: h } = ht(), v = we(!1), b = Ne(), m = dD({ sims: e, organizationId: b, isSuperAdmin: n }), S = ea(t);
  return Pe(() => {
    const I = async () => {
      const C = performance.now();
      let T, E, N, y, w, P;
      try {
        const _ = await m();
        if (T = performance.now() - C, !_) {
          a(!1), u(new Error("No SIMs found"));
          return;
        }
        a(!1), o(!0);
        const D = _?.reduce(
          (W, A) => A.sims ? W.concat(A.sims) : W,
          []
        );
        E = performance.now() - C;
        let R;
        const x = ve.now(), F = x.toFormat("yyyyLLdd-hhmmssSSS");
        switch (t) {
          case gt.XLSX:
          case gt.CSV:
            if (R = mD(D, d, r), N = performance.now() - C, t === gt.XLSX) {
              const W = new Gf();
              W.creator = "Hologram", W.lastModifiedBy = "Hologram";
              const A = x.toJSDate();
              W.created = A, W.modified = A;
              const M = W.addWorksheet("SIMs");
              M.addRow(Object.keys(R[0])), M.addRows(R.map((B) => Object.values(B))), w = performance.now() - C;
              const j = await W.xlsx.writeBuffer();
              y = performance.now() - C, Ch({
                data: j,
                filename: `SIMs-${F}.xlsx`
              }), P = performance.now() - C;
            } else
              bl({ data: yl.unparse(R), filename: `SIMs-${F}.csv` }), P = performance.now() - C;
            break;
          case gt.JSON:
            R = pD(D, d, r), N = performance.now() - C, Aw({
              data: JSON.stringify(R, void 0, 1),
              filename: `SIMs-${F}.json`
            }), P = performance.now() - C;
            break;
          default:
            break;
        }
        o(!1);
      } catch (_) {
        g && g("Export SIMs error", _), u(_);
      }
      f && f(`SIMs - ${r} - Export SIMs - Export SIMs success`, {
        exportType: S,
        downloadedIn: P,
        gotSimsIn: T,
        mergedSimsIn: E,
        normalizedResultsIn: N,
        wroteXlsxToBufferIn: y,
        createdSheetIn: w
      }), a(!1);
    };
    if (h) {
      u(h);
      return;
    }
    !v.current && !p && (v.current = !0, I());
  }, [
    c,
    t,
    S,
    d,
    m,
    r,
    g,
    f,
    p,
    h
  ]), { loadingSims: i, processingExport: s, error: c };
}, vD = ({ className: e, sims: t, exportType: r, segmentName: n }) => {
  const { isSuperAdmin: i } = Be(), { error: a, loadingSims: s, processingExport: o } = gD({
    sims: t,
    exportType: r,
    segmentName: n,
    isSuperAdmin: i
  }), { sendAnalyticsEvent: c } = mt(), { hasUserFilterApplied: u } = vl({ segmentName: n }), f = ea(r);
  Pe(() => {
    c && f && c(`SIMs - ${n} - Export SIMs - Export ${f}`, {
      filtered: u,
      simCount: t.size
    });
  }, [f, n, c, u, t]);
  const g = V(() => o || s ? /* @__PURE__ */ l(
    fe,
    {
      label: `Processing ${f} export...`,
      className: J(ma.notification, Qo.sharedLoadingAnimation),
      children: "Please keep this modal open. Your export is being prepared and will download automatically in your browser once it’s ready. This could take some time to complete."
    }
  ) : a !== null ? /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "Error processing export",
      className: ma.notification,
      children: /* @__PURE__ */ O(le, { children: [
        "We ran into an issue processing your export. If this issue persists, please",
        " ",
        /* @__PURE__ */ l(
          Ae,
          {
            href: "https://support.hologram.io/hc/en-us/requests/new",
            target: "_blank",
            rel: "noreferrer",
            type: "inline",
            className: ma.contactSupportLink,
            children: "contact support"
          }
        ),
        "."
      ] })
    }
  ) : /* @__PURE__ */ l(
    fe,
    {
      label: "Export complete",
      icon: /* @__PURE__ */ l(ye, { name: "CircleCheckmark", fill: "DdsColorFillNotificationSuccess", size: "large" }),
      className: ma.notification,
      children: "Check your browser downloads to view the file."
    }
  ), [a, f, s, o]);
  return /* @__PURE__ */ l("div", { className: J(ma.wrapper, e), children: g });
}, Cp = (e) => {
  if (!e)
    return;
  const t = parseFloat(e);
  if (!Number.isNaN(t))
    return t;
}, yD = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onDone: i,
  exportType: a,
  segmentName: s
}) => {
  const [o, c] = Z(t), { sendAnalyticsEvent: u } = mt(), f = $(() => {
    i && i(), u && u(`SIMs - ${s} - Export SIMs - Close`), e();
  }, [e, i, s, u]);
  return /* @__PURE__ */ l(
    qt,
    {
      className: J(Qo.sharedLoadingAnimationParent, r),
      header: !n.size || n.size === 1 ? "Export SIM" : `Export ${Ee(n.size)} SIMs`,
      onClosed: f,
      open: o,
      setOpen: c,
      noContentPadding: !0,
      children: /* @__PURE__ */ l(vD, { sims: n, exportType: a, segmentName: s })
    }
  );
}, bD = "hyperdashboard-ExportSimsButton-module-FTHoGa-dropdownPanel", SD = "hyperdashboard-ExportSimsButton-module-FTHoGa-wrapper", Pp = {
  dropdownPanel: bD,
  wrapper: SD
}, wD = ({
  buttonText: e = "Export SIMs",
  subtitle: t,
  isLoading: r = !1,
  disabled: n = !1,
  className: i,
  selectedSims: a,
  variant: s = "secondary",
  placement: o,
  segmentName: c,
  id: u
}) => {
  const [f, g] = Z(!1), [p, d] = Z(
    null
  ), h = we(null), { sendAnalyticsEvent: v } = mt(), b = f && !r, m = $(() => {
    g((C) => !C);
  }, []), S = $((C) => {
    g(!1), d(C);
  }, []), I = V(() => {
    const C = [];
    return C.push({
      label: t,
      items: [
        {
          children: "Export to XLSX (Excel)",
          iconStart: "DownloadTray",
          disabled: n,
          onClick: () => S(gt.XLSX)
        },
        {
          children: "Export to CSV",
          iconStart: "DownloadTray",
          disabled: n,
          onClick: () => S(gt.CSV)
        },
        {
          children: "Export to JSON",
          iconStart: "DownloadTray",
          disabled: n,
          onClick: () => S(gt.JSON)
        }
      ]
    }), C;
  }, [n, S, t]);
  return Pe(() => {
    b && v && v(`SIMs - ${c} - Export SIMs`);
  }, [c, v, b]), /* @__PURE__ */ O("div", { className: J(Pp.wrapper, i), ref: h, id: u, children: [
    /* @__PURE__ */ l(
      Kn,
      {
        className: Pp.dropdownPanel,
        content: I,
        open: b,
        onOpenChange: g,
        placement: o,
        children: /* @__PURE__ */ l(
          Y,
          {
            iconEnd: b ? "ChevronSingleNorth" : "ChevronSingleSouth",
            variant: s,
            onClick: m,
            disabled: r,
            children: e
          }
        )
      }
    ),
    p !== null && a && /* @__PURE__ */ l(
      yD,
      {
        onClose: () => {
          d(null);
        },
        sims: a,
        defaultOpen: !0,
        exportType: p,
        segmentName: c
      }
    )
  ] });
}, Tp = { BASE_URL: "/", DEV: !1, MODE: "library", PROD: !0, SSR: !1, VITE_AMPLITUDE_API_KEY: "e0244a7242cae7ac96807d09a3dcf998", VITE_API_ROOT: "https://dashboard.hologram.io/api/1", VITE_BIZ_API_ROOT: "https://dashboard.hologram.io/api/2", VITE_CI_COMMIT_SHORT_SHA: "514bbfd1", VITE_ENV_NAME: "production", VITE_GOOGLE_MAPS_API_KEY: "AIzaSyCU1Tv5nEp8DgPnr0jU66ZyZ7QEt7sYroA", VITE_MAPBOX_TOKEN: "pk.eyJ1IjoiaG9sb2dyYW1lbmdpbmVlcmluZyIsImEiOiJjbHd0Z3VzNmQwM241MmpvZ2I3bHByNzBxIn0.7ZqDUuyt3aLelxG-H23gag", VITE_MKTO_MUNCHKIN_ID: "155-CBG-702", VITE_MKTO_REGISTER_FORM_ID: "1086", VITE_POSTHOG_HOST: "https://us.i.posthog.com", VITE_POSTHOG_KEY: "phc_VIiggM9thOTsAXfIZJ8KsDknZtuqZ0AByZX6PsXYK5S", VITE_STATUSPAGE_URL: "https://status.hologram.io", VITE_STRIPE_API_VERSION: "2024-06-20", VITE_STRIPE_PUB_KEY: "pk_live_4ZzEEupkY7Eit3CGM13AVK7R" }, If = /* @__PURE__ */ new Map(), io = (e) => {
  const t = If.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([r, n]) => [r, n.getState()])
  ) : {};
}, ID = (e, t, r) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(r)
    };
  const n = If.get(r.name);
  if (n)
    return { type: "tracked", store: e, ...n };
  const i = {
    connection: t.connect(r),
    stores: {}
  };
  return If.set(r.name, i), { type: "tracked", store: e, ...i };
}, CD = (e, t = {}) => (r, n, i) => {
  const { enabled: a, anonymousActionType: s, store: o, ...c } = t;
  let u;
  try {
    u = (a ?? (Tp ? "library" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!u)
    return e(r, n, i);
  const { connection: f, ...g } = ID(o, u, c);
  let p = !0;
  i.setState = (v, b, m) => {
    const S = r(v, b);
    if (!p) return S;
    const I = m === void 0 ? { type: s || "anonymous" } : typeof m == "string" ? { type: m } : m;
    return o === void 0 ? (f?.send(I, n()), S) : (f?.send(
      {
        ...I,
        type: `${o}/${I.type}`
      },
      {
        ...io(c.name),
        [o]: i.getState()
      }
    ), S);
  };
  const d = (...v) => {
    const b = p;
    p = !1, r(...v), p = b;
  }, h = e(i.setState, n, i);
  if (g.type === "untracked" ? f?.init(h) : (g.stores[g.store] = i, f?.init(
    Object.fromEntries(
      Object.entries(g.stores).map(([v, b]) => [
        v,
        v === g.store ? h : b.getState()
      ])
    )
  )), i.dispatchFromDevtools && typeof i.dispatch == "function") {
    let v = !1;
    const b = i.dispatch;
    i.dispatch = (...m) => {
      (Tp ? "library" : void 0) !== "production" && m[0].type === "__setState" && !v && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), v = !0), b(...m);
    };
  }
  return f.subscribe((v) => {
    var b;
    switch (v.type) {
      case "ACTION":
        if (typeof v.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return dc(
          v.payload,
          (m) => {
            if (m.type === "__setState") {
              if (o === void 0) {
                d(m.state);
                return;
              }
              Object.keys(m.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const S = m.state[o];
              if (S == null)
                return;
              JSON.stringify(i.getState()) !== JSON.stringify(S) && d(S);
              return;
            }
            i.dispatchFromDevtools && typeof i.dispatch == "function" && i.dispatch(m);
          }
        );
      case "DISPATCH":
        switch (v.payload.type) {
          case "RESET":
            return d(h), o === void 0 ? f?.init(i.getState()) : f?.init(io(c.name));
          case "COMMIT":
            if (o === void 0) {
              f?.init(i.getState());
              return;
            }
            return f?.init(io(c.name));
          case "ROLLBACK":
            return dc(v.state, (m) => {
              if (o === void 0) {
                d(m), f?.init(i.getState());
                return;
              }
              d(m[o]), f?.init(io(c.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return dc(v.state, (m) => {
              if (o === void 0) {
                d(m);
                return;
              }
              JSON.stringify(i.getState()) !== JSON.stringify(m[o]) && d(m[o]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: m } = v.payload, S = (b = m.computedStates.slice(-1)[0]) == null ? void 0 : b.state;
            if (!S) return;
            d(o === void 0 ? S : S[o]), f?.send(
              null,
              // FIXME no-any
              m
            );
            return;
          }
          case "PAUSE_RECORDING":
            return p = !p;
        }
        return;
    }
  }), h;
}, Ph = CD, dc = (e, t) => {
  let r;
  try {
    r = JSON.parse(e);
  } catch (n) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      n
    );
  }
  r !== void 0 && t(r);
};
function xw(e, t) {
  let r;
  try {
    r = e();
  } catch {
    return;
  }
  return {
    getItem: (i) => {
      var a;
      const s = (c) => c === null ? null : JSON.parse(c, void 0), o = (a = r.getItem(i)) != null ? a : null;
      return o instanceof Promise ? o.then(s) : s(o);
    },
    setItem: (i, a) => r.setItem(
      i,
      JSON.stringify(a, void 0)
    ),
    removeItem: (i) => r.removeItem(i)
  };
}
const Cf = (e) => (t) => {
  try {
    const r = e(t);
    return r instanceof Promise ? r : {
      then(n) {
        return Cf(n)(r);
      },
      catch(n) {
        return this;
      }
    };
  } catch (r) {
    return {
      then(n) {
        return this;
      },
      catch(n) {
        return Cf(n)(r);
      }
    };
  }
}, PD = (e, t) => (r, n, i) => {
  let a = {
    storage: xw(() => localStorage),
    partialize: (v) => v,
    version: 0,
    merge: (v, b) => ({
      ...b,
      ...v
    }),
    ...t
  }, s = !1;
  const o = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let u = a.storage;
  if (!u)
    return e(
      (...v) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`
        ), r(...v);
      },
      n,
      i
    );
  const f = () => {
    const v = a.partialize({ ...n() });
    return u.setItem(a.name, {
      state: v,
      version: a.version
    });
  }, g = i.setState;
  i.setState = (v, b) => {
    g(v, b), f();
  };
  const p = e(
    (...v) => {
      r(...v), f();
    },
    n,
    i
  );
  i.getInitialState = () => p;
  let d;
  const h = () => {
    var v, b;
    if (!u) return;
    s = !1, o.forEach((S) => {
      var I;
      return S((I = n()) != null ? I : p);
    });
    const m = ((b = a.onRehydrateStorage) == null ? void 0 : b.call(a, (v = n()) != null ? v : p)) || void 0;
    return Cf(u.getItem.bind(u))(a.name).then((S) => {
      if (S)
        if (typeof S.version == "number" && S.version !== a.version) {
          if (a.migrate) {
            const I = a.migrate(
              S.state,
              S.version
            );
            return I instanceof Promise ? I.then((C) => [!0, C]) : [!0, I];
          }
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, S.state];
      return [!1, void 0];
    }).then((S) => {
      var I;
      const [C, T] = S;
      if (d = a.merge(
        T,
        (I = n()) != null ? I : p
      ), r(d, !0), C)
        return f();
    }).then(() => {
      m?.(d, void 0), d = n(), s = !0, c.forEach((S) => S(d));
    }).catch((S) => {
      m?.(void 0, S);
    });
  };
  return i.persist = {
    setOptions: (v) => {
      a = {
        ...a,
        ...v
      }, v.storage && (u = v.storage);
    },
    clearStorage: () => {
      u?.removeItem(a.name);
    },
    getOptions: () => a,
    rehydrate: () => h(),
    hasHydrated: () => s,
    onHydrate: (v) => (o.add(v), () => {
      o.delete(v);
    }),
    onFinishHydration: (v) => (c.add(v), () => {
      c.delete(v);
    })
  }, a.skipHydration || h(), d || p;
}, Th = PD, TD = (e) => (t, r, n) => (n.setState = (i, a, ...s) => {
  const o = typeof i == "function" ? J0(i) : i;
  return t(o, a, ...s);
}, e(n.setState, r, n)), _h = TD, _p = "simInventorySelection", _D = 4, pa = { selected: {} }, Eh = bh()(
  Th(
    _h(
      Ph(
        (e) => ({
          segmentStates: structuredClone({
            all: { ...pa },
            active: { ...pa },
            deactivated: { ...pa },
            preflight: { ...pa }
          }),
          /* Selections */
          resetSelection: (t) => e(
            (r) => {
              r.segmentStates[t].selected = { ...pa.selected };
            },
            !1,
            { type: "simInventorySelection/resetSelection", segmentName: t }
          ),
          setSelectedSims: (t, r, n) => e(
            (i) => {
              const a = new Map(r);
              i.segmentStates[t].selected = {
                sims: a,
                all: n
              };
            },
            !1,
            { type: "simInventorySelection/setSelectedSims", segmentName: t, sims: r }
          ),
          addSelectedSim: (t, r) => e(
            (n) => {
              n.segmentStates[t].selected = {
                sims: new Map(n.segmentStates[t].selected.sims).set(
                  r.hologramSimId,
                  r.claimed_device_id
                ),
                all: "indeterminate"
              };
            },
            !1,
            { type: "simInventorySelection/addSelectedSim", segmentName: t, simIds: r }
          ),
          removeSelectedSim: (t, r) => e(
            (n) => {
              const i = new Map(n.segmentStates[t].selected.sims);
              i.delete(r.hologramSimId), n.segmentStates[t].selected = {
                sims: i,
                all: i.size > 0 ? "indeterminate" : void 0
              };
            },
            !1,
            { type: "simInventorySelection/removeSelectedSim", segmentName: t, simIds: r }
          )
        }),
        {
          name: _p,
          enabled: (process.env.VITE_ENV_NAME ?? "development") === "development"
        }
      )
    ),
    {
      name: _p,
      version: _D,
      storage: {
        getItem: (e) => {
          const t = sessionStorage.getItem(e);
          if (!t)
            return null;
          const { state: r } = JSON.parse(t, (n, i) => n === "sims" ? new Map(i) : i);
          return {
            state: r
          };
        },
        setItem: (e, t) => {
          const r = JSON.stringify(
            {
              state: t.state
            },
            (n, i) => n === "sims" ? Array.from(i) : i
          );
          sessionStorage.setItem(e, r);
        },
        removeItem: (e) => sessionStorage.removeItem(e)
      }
    }
  )
), Oh = (e) => Eh(
  yh((t) => t.segmentStates[e].selected)
), ED = "hyperdashboard-SimInventoryActions-module-NA9SVa-leftContent", OD = "hyperdashboard-SimInventoryActions-module-NA9SVa-placeholderText", ND = "hyperdashboard-SimInventoryActions-module-NA9SVa-rightContent", DD = "hyperdashboard-SimInventoryActions-module-NA9SVa-selectedText", RD = "hyperdashboard-SimInventoryActions-module-NA9SVa-wrapper", qn = {
  leftContent: ED,
  placeholderText: OD,
  rightContent: ND,
  selectedText: DD,
  wrapper: RD
}, kD = ({
  className: e,
  segmentName: t,
  handleModalOpen: r,
  onSimsModified: n,
  activateButtonRenderer: i
}) => {
  const {
    filters: a,
    hasFilters: s,
    hasUserFilterApplied: o,
    filtersValidForAllSegment: c,
    error: u,
    isLoading: f
  } = vl({
    segmentName: t
  }), {
    networkStatusGroups: g,
    isLoading: p,
    error: d
  } = ht(), h = {
    organizationId: a?.organizationId
  };
  t !== "all" && (t === "active" ? h.networkStatus = g?.active : t === "preflight" ? h.networkStatus = g?.predeployment : h.networkStatus = g?.deactivated);
  const v = s && (t !== "all" || c) && !(u || d) && !(f || p), {
    count: b,
    error: m,
    isLoading: S
  } = Sf(h, v && t !== "all"), {
    count: I,
    error: C,
    isLoading: T
  } = Sf(a, v), {
    simIds: E,
    isLoading: N,
    error: y
  } = uw({ filters: a, canLoad: v }), { resetSelection: w } = Eh(), P = $(() => {
    w(t);
  }, [w, t]), { all: _, sims: D } = Oh(t), R = $(() => {
    n();
  }, [n]), x = m || C || y, F = S || T || N, W = Jn(), A = Sn(), M = _ || D && D.size > 0, j = $(() => {
    if (!A)
      throw new Error("Legacy dashboard context is not available");
    if (!M)
      return;
    const { endTestingAndActivate: L } = A, H = [...D.values()];
    L(
      H.filter((q) => !!q),
      "SIM Inventory"
    );
  }, [M, A, D]), B = V(() => {
    if (x)
      return /* @__PURE__ */ l("div", { className: qn.placeholderText, children: "We ran into an issue loading your SIMs" });
    let L, H, q, te;
    switch (t) {
      case "all":
        _ === "checked" ? (L = `${Ee(I)} filtered SIMs`, H = L, q = "Manage all SIMs") : D && D.size > 0 ? (L = `${Ee(D.size)} selected ${D.size === 1 ? "SIM" : "SIMs"}`, H = L, q = `Manage ${Ee(D.size)} ${D.size === 1 ? "SIM" : "SIMs"}`) : (L = "Select SIMs to take actions", H = I > 0 ? `${Ee(I)} filtered SIMs` : "No SIMs found", q = "Manage SIMs"), o && (te = I > 0 ? `Showing ${Ee(I)} SIMs` : "No SIMs found");
        break;
      case "active":
        _ === "checked" ? (L = `${Ee(I)} ${o ? "filtered" : "active"} SIMs`, H = L, q = "Manage all SIMs") : D && D.size > 0 ? (L = `${Ee(D.size)} selected ${D.size === 1 ? "SIM" : "SIMs"}`, H = L, q = `Manage ${Ee(D.size)} ${D.size === 1 ? "SIM" : "SIMs"}`) : (L = "Select SIMs to take actions", H = I > 0 ? `${Ee(I)} ${o ? "filtered" : "active"} SIMs` : "No SIMs found", q = "Manage SIMs"), b > 0 ? te = o ? `Showing ${Ee(I)} of ${Ee(b)} ${M ? "" : "active "}SIMs` : `Showing all ${Ee(b)} ${M ? "" : "active "}SIMs` : te = "No active SIMs";
        break;
      case "preflight":
        _ === "checked" ? (L = `${Ee(I)} ${o ? "filtered" : "pre-deployment"} SIMs`, H = L, q = "Manage all SIMs") : D && D.size > 0 ? (L = `${Ee(D.size)} selected ${D.size === 1 ? "SIM" : "SIMs"}`, H = L, q = `Manage ${Ee(D.size)} ${D.size === 1 ? "SIM" : "SIMs"}`) : (L = "Select SIMs to take actions", H = I ? `${Ee(I)} ${o ? "filtered" : "pre-deployment"} SIMs` : "No SIMs found", q = "Manage SIMs"), b > 0 ? te = o ? `Showing ${Ee(I)} of ${Ee(b)} SIMs${M ? "" : " in testing"}` : `Showing all ${Ee(b)} SIMs${M ? "" : " in testing"}` : te = "No SIMs in testing";
        break;
      case "deactivated":
        _ === "checked" ? (L = `${Ee(I)} ${o ? "filtered" : "deactivated"} SIMs`, H = L, q = "Manage all SIMs") : D && D.size > 0 ? (L = `${Ee(D.size)} selected ${D.size === 1 ? "SIM" : "SIMs"}`, H = L, q = `Manage ${Ee(D.size)} ${D.size === 1 ? "SIM" : "SIMs"}`) : (L = "Select SIMs to take actions", H = I > 0 ? `${Ee(I)} ${o ? "filtered" : "deactivated"} SIMs` : "No SIMs found", q = "Manage SIMs"), b > 0 ? te = o ? `Showing ${Ee(I)} of ${Ee(b)} ${M ? "" : "deactivated "}SIMs` : `Showing all ${Ee(b)} ${M ? "" : "deactivated "}SIMs` : te = "No deactivated SIMs";
        break;
    }
    const G = D?.size ?? 0, X = !D || D.size === 0 ? E : D;
    return /* @__PURE__ */ O(le, { children: [
      /* @__PURE__ */ O("div", { className: qn.leftContent, children: [
        /* @__PURE__ */ l(
          gw,
          {
            subtitle: L,
            isLoading: F,
            buttonText: q,
            selectedSims: D,
            disabled: x || !(_ || D && D.size > 0),
            handleModalOpen: r,
            onSimsModified: n,
            context: "inventory",
            segmentName: t
          }
        ),
        !(F || x) && (G > 0 ? /* @__PURE__ */ O(le, { children: [
          /* @__PURE__ */ O("div", { className: qn.selectedText, children: [
            Ee(G),
            " selected",
            `${te ? ` (${te})` : ""}`
          ] }),
          /* @__PURE__ */ l(
            Y,
            {
              variant: "tertiary",
              onClick: P,
              className: qn.deselectAll,
              id: "siminventory-selection-deselectall",
              children: "Deselect all"
            }
          )
        ] }) : /* @__PURE__ */ l("div", { className: qn.selectedText, children: te }))
      ] }),
      /* @__PURE__ */ O("div", { className: qn.rightContent, children: [
        /* @__PURE__ */ l(et, { id: W, content: "Refresh the list of SIMs", allowPinning: !1, children: /* @__PURE__ */ l(
          Y,
          {
            iconStart: "Sync",
            variant: "secondary",
            disabled: F,
            onClick: R,
            id: "siminventory-actions-refresh"
          }
        ) }),
        /* @__PURE__ */ l(
          wD,
          {
            subtitle: H,
            isLoading: F,
            selectedSims: X,
            disabled: x || !(_ || X && X.size > 0),
            segmentName: t,
            id: "siminventory-actions-export"
          }
        ),
        t === "preflight" ? /* @__PURE__ */ l(
          Y,
          {
            iconStart: "Lightning",
            onClick: j,
            disabled: !M,
            children: M ? `Activate ${D.size} SIMs` : "Activate SIMs"
          }
        ) : i?.({
          children: "Activate SIMs",
          variant: "primary",
          id: "siminventory-actions-activate"
        })
      ] })
    ] });
  }, [
    i,
    _,
    E,
    x,
    I,
    r,
    M,
    o,
    F,
    b,
    P,
    j,
    R,
    n,
    W,
    t,
    D
  ]);
  return /* @__PURE__ */ l("div", { className: J(qn.wrapper, e), children: B });
}, AD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-helpText", xD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-helpTextBold", FD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-notification", $D = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-successes", MD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-table", LD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-tableWrapper", jD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-warnings", WD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-warningsHeader", UD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-warningsHeaderNotification", VD = "hyperdashboard-SimInventoryBulkUpdateState-module-pLYpDa-wrapper", or = {
  helpText: AD,
  helpTextBold: xD,
  notification: FD,
  successes: $D,
  table: MD,
  tableWrapper: LD,
  warnings: jD,
  warningsHeader: WD,
  warningsHeaderNotification: UD,
  wrapper: VD
}, HD = (e) => !!e?.hologramSimId, qD = ({ plural: e }) => /* @__PURE__ */ O(le, { children: [
  /* @__PURE__ */ O("div", { children: [
    "A ",
    /* @__PURE__ */ l("span", { className: or.helpTextBold, children: "pause" }),
    " command will be issued to our carrier partners for the selected ",
    e ? "SIMs" : "SIM",
    ". Paused SIMs will not be able to use cellular data or send or receive SMS messages."
  ] }),
  /* @__PURE__ */ O("div", { children: [
    /* @__PURE__ */ l("span", { className: or.helpTextBold, children: "Paused SIMs are still charged monthly" }),
    " for us to retain access to cellular carriers and platform functionality. Learn more about paused SIMs and data plans in our",
    " ",
    /* @__PURE__ */ l(
      Ae,
      {
        href: "https://support.hologram.io/hc/en-us/articles/360035213874",
        target: "_blank",
        type: "inline",
        children: "billing FAQs"
      }
    ),
    "."
  ] })
] }), zD = ({ plural: e }) => /* @__PURE__ */ O(le, { children: [
  /* @__PURE__ */ O(ze, { variant: "note", prefixOverride: "In progress", children: [
    "A ",
    /* @__PURE__ */ l("span", { className: or.helpTextBold, children: "pause" }),
    " command has been issued to our carrier partners for the selected ",
    e ? "SIMs" : "SIM",
    "."
  ] }),
  /* @__PURE__ */ O("div", { children: [
    "You should see the status of your ",
    e ? "devices" : "device",
    " update within 10 minutes. In rare cases it may take up to 24 hours. If you have any questions, please reach out to",
    " ",
    /* @__PURE__ */ l(Ae, { href: "mailto:support@hologram.io", type: "inline", children: "support@hologram.io" }),
    "."
  ] }),
  /* @__PURE__ */ O("div", { children: [
    /* @__PURE__ */ l("span", { className: or.helpTextBold, children: "Paused SIMs are still charged monthly" }),
    " for us to retain access to cellular carriers and platform functionality. Paused SIMs will not be able to use cellular data or send or receive SMS messages. Learn more about paused SIMs and data plans in our",
    " ",
    /* @__PURE__ */ l(
      Ae,
      {
        href: "https://support.hologram.io/hc/en-us/articles/360035213874",
        target: "_blank",
        type: "inline",
        children: "billing FAQs"
      }
    ),
    "."
  ] })
] }), BD = ({ plural: e }) => /* @__PURE__ */ O("div", { children: [
  "Your ",
  e ? "SIMs" : "SIM",
  " will be ready for use on our network within 10 minutes. In rare cases it may take up to 24 hours."
] }), GD = ({ plural: e }) => /* @__PURE__ */ O(le, { children: [
  /* @__PURE__ */ O(ze, { variant: "note", prefixOverride: "In progress", children: [
    "A ",
    /* @__PURE__ */ l("span", { className: or.helpTextBold, children: "resume" }),
    " command has been issued to our carrier partners for the selected ",
    e ? "SIMs" : "SIM",
    "."
  ] }),
  /* @__PURE__ */ O("div", { children: [
    "Your ",
    e ? "SIMs" : "SIM",
    " will be ready for use on our network within 10 minutes. In rare cases it may take up to 24 hours. If you have any questions, please reach out to",
    " ",
    /* @__PURE__ */ l(Ae, { href: "mailto:support@hologram.io", type: "inline", children: "support@hologram.io" }),
    "."
  ] })
] }), QD = ({ response: e, pastVerb: t }) => {
  const [r, n] = Z(!1), i = $(() => {
    n((s) => !s);
  }, []), a = $((s) => {
    (s.key === "Enter" || s.key === " ") && n((o) => !o);
  }, []);
  return e.warnedSims.size === 0 ? null : /* @__PURE__ */ O("div", { className: or.warnings, children: [
    /* @__PURE__ */ O(
      "div",
      {
        className: or.warningsHeader,
        onClick: i,
        onKeyUp: a,
        tabIndex: 0,
        role: "button",
        children: [
          /* @__PURE__ */ l(
            ye,
            {
              name: r ? "ChevronSingleSouth" : "ChevronSingleEast",
              title: r ? "Collapse" : "Expand"
            }
          ),
          /* @__PURE__ */ O(tn, { variant: "error", className: or.warningsHeaderNotification, children: [
            Ee(e.warnedSims.size),
            " ",
            e.warnedSims.size === 1 ? "SIM" : "SIMs",
            " ",
            "cannot be ",
            t,
            "."
          ] })
        ]
      }
    ),
    r && /* @__PURE__ */ l("div", { className: or.tableWrapper, children: /* @__PURE__ */ O("table", { className: or.table, children: [
      /* @__PURE__ */ l("thead", { children: /* @__PURE__ */ O("tr", { children: [
        /* @__PURE__ */ l("th", { children: "Name" }),
        /* @__PURE__ */ l("th", { children: "SIM ID" }),
        /* @__PURE__ */ l("th", { children: "Enabled profile ICCID" })
      ] }) }),
      /* @__PURE__ */ l("tbody", { children: [...e.warnedSims.values()].map((s) => /* @__PURE__ */ O("tr", { children: [
        /* @__PURE__ */ l("td", { children: s.deviceName }),
        /* @__PURE__ */ l("td", { children: s.hologramSimId }),
        /* @__PURE__ */ l("td", { children: s.activeProfileIccid })
      ] }, s.hologramSimId)) })
    ] }) })
  ] });
}, ZD = ({ response: e, verb: t }) => {
  const [r, n] = Z(!1), [i, a] = Z(!1), s = $(() => {
    e.succeededSims.size !== 0 && (n(!0), window.setTimeout(() => {
      if (e.succeededSims.size === 0) {
        n(!1);
        return;
      }
      const o = [
        "hologramSimId",
        "deviceName",
        "deviceId",
        "activeProfileIccid"
      ], c = [
        {
          hologramSimId: "SIM ID",
          deviceName: "Name",
          deviceId: "Device ID",
          activeProfileIccid: "Enabled profile ICCID"
        },
        ...e.succeededSims.values()
      ], u = yl.unparse(c, { columns: o, header: !1 }), f = ve.now().toFormat("yyyyLLdd-hhmmssSSS");
      a(
        bl({ data: u, filename: `SIMs-${t}-${f}.csv` })
      ), n(!1);
    }, 0));
  }, [t, e]);
  return e.succeededSims.size === 0 ? null : /* @__PURE__ */ O("div", { className: or.successes, children: [
    /* @__PURE__ */ O("div", { children: [
      Ee(e.succeededSims.size),
      " selected",
      " ",
      e.succeededSims.size === 1 ? "SIM" : "SIMs"
    ] }),
    /* @__PURE__ */ l(
      Y,
      {
        loading: r,
        iconStart: i ? "CheckmarkSingle" : "DownloadTray",
        variant: "secondary",
        size: "small",
        onClick: s,
        children: "Download CSV"
      }
    )
  ] });
}, YD = Et(
  ({ action: e, sims: t, onProcessing: r, onDone: n, onPreviewDone: i }, a) => {
    const s = Ne(), {
      bulkStateResponse: o,
      isLoading: c,
      error: u
    } = eT({
      action: e,
      organizationId: s,
      sims: t
    }), [f, g] = Z(), [p, d] = Z(), h = YS({ organizationId: s, action: e, preview: !1 }), v = V(
      () => new Set(
        o.succeededSIMs?.filter((N) => !!N.hologramSimId)?.map((N) => N.hologramSimId) ?? []
      ),
      [o]
    );
    Pe(() => {
      !c && !u && o.succeededSIMs && o.warningSIMs && (o.succeededSIMs?.length > 0 || o.warningSIMs?.length > 0) && i(v.size);
    }, [o, i, u, c, v]);
    const b = $(async () => {
      if (v.size === 0) {
        d("No SIMs would change state.");
        return;
      }
      r(!0);
      let N;
      try {
        N = await h([...v.keys()]), g(N), n(N?.succeededSIMs?.filter(HD).map((y) => y.hologramSimId));
      } catch (y) {
        typeof y == "string" ? d(y) : (d(`An error occurred: ${y}`), console.error(y));
      }
      !N && p && g(void 0), r(!1);
    }, [p, h, v, n, r]);
    Kt(
      a,
      () => ({
        onSubmit: b
      }),
      [b]
    );
    const m = u || p, S = t.size === 1, I = V(() => {
      const N = f ?? o, y = /* @__PURE__ */ new Map();
      N.succeededSIMs?.forEach((P) => {
        P.hologramSimId && y.set(P.hologramSimId, P);
      });
      const w = /* @__PURE__ */ new Map();
      return N.warningSIMs?.forEach((P) => {
        P?.sims && P.sims.forEach((_) => {
          _.hologramSimId && !y.has(_.hologramSimId) && w.set(_.hologramSimId, _);
        });
      }), { succeededSims: y, warnedSims: w };
    }, [f, o]);
    let C, T, E;
    switch (e) {
      case "pause":
        f ? T = /* @__PURE__ */ l(zD, { plural: (f.succeededSIMs?.length ?? 0) > 1 }) : T = /* @__PURE__ */ l(qD, { plural: !S }), E = "paused";
        break;
      case "resume":
        f ? T = /* @__PURE__ */ l(GD, { plural: (f.succeededSIMs?.length ?? 0) > 1 }) : T = /* @__PURE__ */ l(BD, { plural: !S }), E = "resumed";
        break;
      default:
        T = null, E = "acted on";
    }
    return c ? C = /* @__PURE__ */ l(ur, { children: `Checking selected ${S ? "SIM" : "SIMs"}...` }) : C = /* @__PURE__ */ O(le, { children: [
      !f && (o.succeededSIMs?.length ?? 0) === 0 ? /* @__PURE__ */ l(fe, { className: or.notification, variant: "error", children: t.size === 1 ? `The selected SIM cannot be ${E}` : `No selected SIMs can be ${E}.` }) : /* @__PURE__ */ O("div", { className: or.helpText, children: [
        m && /* @__PURE__ */ l(ze, { variant: "error", children: m }),
        T
      ] }),
      !S && /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(QD, { response: I, pastVerb: E }),
        /* @__PURE__ */ l(
          ZD,
          {
            response: I,
            verb: f ? E : e
          }
        )
      ] })
    ] }), /* @__PURE__ */ l("div", { className: or.wrapper, children: C });
  }
), Fw = "//form.asana.com/?k=HOb2iQqhGUeSG1lj_PjIKQ&d=523429734671116", KD = "//support.hologram.io/hc/en-us", Nh = "//support.hologram.io/hc/en-us/requests/new", JD = "//support.hologram.io/hc/en-us/articles/360049369994-Simulate-Data-Router-messages-from-a-device&utm_medium=application&utm_content=simulate_message_to_api", XD = "//support.hologram.io/hc/en-us/articles/360035697333-Establish-a-secure-tunnel-to-a-device-using-the-Spacebridge-desktop-client&utm_medium=application&utm_content=manage_device_tunneling", eR = "//support.hologram.io/hc/en-us/articles/360042755573-Hologram-Inflight-Enterprise", $w = "//support.hologram.io/hc/en-us/articles/360035697373-Clear-the-FPLMN-forbidden-networks-list", tR = "hyperdashboard-SimInventoryDetailsNotification-module-n_Ij7W-note", rR = "hyperdashboard-SimInventoryDetailsNotification-module-n_Ij7W-noteRight", nR = "hyperdashboard-SimInventoryDetailsNotification-module-n_Ij7W-noteWrapper", fc = {
  note: tR,
  noteRight: rR,
  noteWrapper: nR
}, V3 = ({
  navigateText: e,
  url: t,
  className: r
}) => /* @__PURE__ */ l(ze, { variant: "note", className: J(fc.note, r), children: /* @__PURE__ */ O("div", { className: fc.noteWrapper, children: [
  /* @__PURE__ */ O("div", { children: [
    "We’re improving the ways you can manage and view SIMs.",
    "  ",
    /* @__PURE__ */ l(Ae, { href: Fw, target: "_blank", rel: "noreferrer", type: "inline", children: "Share your feedback" }),
    "."
  ] }),
  /* @__PURE__ */ l("div", { className: fc.noteRight, children: /* @__PURE__ */ l(Y, { iconEnd: "ArrowEastShort", to: t, variant: "tertiary", "aria-label": "View device", children: e }) })
] }) }), iR = "hyperdashboard-filterStyles-module-JVhIEq-defaultWrapper", aR = "hyperdashboard-filterStyles-module-JVhIEq-divider", Sr = {
  defaultWrapper: iR,
  divider: aR
}, sR = "hyperdashboard-FilterAccordion-module-1YCYjq-clearButton", oR = "hyperdashboard-FilterAccordion-module-1YCYjq-expanded", lR = "hyperdashboard-FilterAccordion-module-1YCYjq-filter", cR = "hyperdashboard-FilterAccordion-module-1YCYjq-filterContent", uR = "hyperdashboard-FilterAccordion-module-1YCYjq-filterContentWrapper", dR = "hyperdashboard-FilterAccordion-module-1YCYjq-filterHeader", fR = "hyperdashboard-FilterAccordion-module-1YCYjq-filterHeaderLeftContent", hR = "hyperdashboard-FilterAccordion-module-1YCYjq-filterIcon", mR = "hyperdashboard-FilterAccordion-module-1YCYjq-filterName", ln = {
  clearButton: sR,
  expanded: oR,
  filter: lR,
  filterContent: cR,
  filterContentWrapper: uR,
  filterHeader: dR,
  filterHeaderLeftContent: fR,
  filterIcon: hR,
  filterName: mR
}, sn = ({
  className: e,
  children: t,
  onClear: r,
  label: n,
  isSet: i,
  defaultActive: a = !1
}) => {
  const [s, o] = Z(a), c = $(() => {
    o((g) => !g);
  }, []), u = $((g) => {
    g.key === "Enter" && (g.preventDefault(), o((p) => !p));
  }, []), f = $(
    (g) => {
      g.stopPropagation(), r && r();
    },
    [r]
  );
  return /* @__PURE__ */ l("div", { className: J(e), children: /* @__PURE__ */ O("div", { className: ln.filter, children: [
    /* @__PURE__ */ O(
      "div",
      {
        className: J(ln.filterHeader, s && ln.expanded),
        onClick: c,
        onKeyDown: u,
        tabIndex: 0,
        role: "button",
        "aria-label": `${n} filter`,
        "data-testid": "filterAccordionControl",
        children: [
          /* @__PURE__ */ O("div", { className: ln.filterHeaderLeftContent, children: [
            /* @__PURE__ */ l(
              ye,
              {
                className: ln.filterIcon,
                name: s ? "ChevronSingleSouth" : "ChevronSingleEast",
                fill: "DdsColorPaletteBlack"
              }
            ),
            /* @__PURE__ */ l("div", { className: ln.filterName, children: n })
          ] }),
          i && /* @__PURE__ */ l(
            Y,
            {
              className: ln.clearButton,
              variant: "tertiary",
              "aria-label": `Filter - ${n} clear`,
              onClick: f,
              children: "Clear"
            }
          )
        ]
      }
    ),
    s && /* @__PURE__ */ O("div", { className: ln.filterContentWrapper, children: [
      /* @__PURE__ */ l("hr", { className: Sr.divider }),
      /* @__PURE__ */ l("div", { className: ln.filterContent, children: t }),
      t !== void 0 && /* @__PURE__ */ l("hr", { className: Sr.divider })
    ] })
  ] }) });
}, pR = "hyperdashboard-Timeframe-module-eemJKG-formField", gR = "hyperdashboard-Timeframe-module-eemJKG-validation", vR = "hyperdashboard-Timeframe-module-eemJKG-wrapper", ao = {
  formField: pR,
  validation: gR,
  wrapper: vR
}, Dh = ({
  id: e,
  options: t,
  timeframeProps: r,
  startFieldProps: n,
  endFieldProps: i,
  invalid: a,
  validationMessage: s,
  className: o
}) => /* @__PURE__ */ O("div", { className: J(ao.wrapper, o), id: e, children: [
  /* @__PURE__ */ l(
    Zf,
    {
      id: `${e}-range`,
      options: t,
      inputProps: { "data-1p-ignore": !0, "data-lpignore": !0 },
      ...r
    }
  ),
  /* @__PURE__ */ l(
    mn,
    {
      label: "Start date",
      className: ao.formField,
      id: `${e}-start`,
      layoutDirection: "row",
      centerLabel: !0,
      children: ({ ariaDescribedbyIds: c, ariaLabel: u, primaryControlId: f }) => /* @__PURE__ */ l(
        nm,
        {
          id: f,
          "aria-describedby": c,
          "aria-label": u,
          ...n
        }
      )
    }
  ),
  /* @__PURE__ */ l(
    mn,
    {
      label: "End date",
      className: ao.formField,
      id: `${e}-end`,
      layoutDirection: "row",
      centerLabel: !0,
      children: ({ ariaDescribedbyIds: c, ariaLabel: u, primaryControlId: f }) => /* @__PURE__ */ l(
        nm,
        {
          id: f,
          "aria-describedby": c,
          "aria-label": u,
          ...i
        }
      )
    }
  ),
  s && /* @__PURE__ */ l(_0, { id: "lastActive-validation", invalid: a, className: ao.validation, children: s })
] });
var hc, Ep;
function yR() {
  if (Ep) return hc;
  Ep = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return hc = e, hc;
}
var mc, Op;
function Mw() {
  if (Op) return mc;
  Op = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return mc = e, mc;
}
var pc, Np;
function Sl() {
  if (Np) return pc;
  Np = 1;
  var e = Mw();
  function t(r, n) {
    for (var i = r.length; i--; )
      if (e(r[i][0], n))
        return i;
    return -1;
  }
  return pc = t, pc;
}
var gc, Dp;
function bR() {
  if (Dp) return gc;
  Dp = 1;
  var e = Sl(), t = Array.prototype, r = t.splice;
  function n(i) {
    var a = this.__data__, s = e(a, i);
    if (s < 0)
      return !1;
    var o = a.length - 1;
    return s == o ? a.pop() : r.call(a, s, 1), --this.size, !0;
  }
  return gc = n, gc;
}
var vc, Rp;
function SR() {
  if (Rp) return vc;
  Rp = 1;
  var e = Sl();
  function t(r) {
    var n = this.__data__, i = e(n, r);
    return i < 0 ? void 0 : n[i][1];
  }
  return vc = t, vc;
}
var yc, kp;
function wR() {
  if (kp) return yc;
  kp = 1;
  var e = Sl();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return yc = t, yc;
}
var bc, Ap;
function IR() {
  if (Ap) return bc;
  Ap = 1;
  var e = Sl();
  function t(r, n) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? (++this.size, i.push([r, n])) : i[a][1] = n, this;
  }
  return bc = t, bc;
}
var Sc, xp;
function wl() {
  if (xp) return Sc;
  xp = 1;
  var e = yR(), t = bR(), r = SR(), n = wR(), i = IR();
  function a(s) {
    var o = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++o < c; ) {
      var u = s[o];
      this.set(u[0], u[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Sc = a, Sc;
}
var wc, Fp;
function CR() {
  if (Fp) return wc;
  Fp = 1;
  var e = wl();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return wc = t, wc;
}
var Ic, $p;
function PR() {
  if ($p) return Ic;
  $p = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Ic = e, Ic;
}
var Cc, Mp;
function TR() {
  if (Mp) return Cc;
  Mp = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Cc = e, Cc;
}
var Pc, Lp;
function _R() {
  if (Lp) return Pc;
  Lp = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Pc = e, Pc;
}
var Tc, jp;
function Lw() {
  if (jp) return Tc;
  jp = 1;
  var e = typeof Ys == "object" && Ys && Ys.Object === Object && Ys;
  return Tc = e, Tc;
}
var _c, Wp;
function wn() {
  if (Wp) return _c;
  Wp = 1;
  var e = Lw(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return _c = r, _c;
}
var Ec, Up;
function Rh() {
  if (Up) return Ec;
  Up = 1;
  var e = wn(), t = e.Symbol;
  return Ec = t, Ec;
}
var Oc, Vp;
function ER() {
  if (Vp) return Oc;
  Vp = 1;
  var e = Rh(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
  function a(s) {
    var o = r.call(s, i), c = s[i];
    try {
      s[i] = void 0;
      var u = !0;
    } catch {
    }
    var f = n.call(s);
    return u && (o ? s[i] = c : delete s[i]), f;
  }
  return Oc = a, Oc;
}
var Nc, Hp;
function OR() {
  if (Hp) return Nc;
  Hp = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Nc = r, Nc;
}
var Dc, qp;
function Il() {
  if (qp) return Dc;
  qp = 1;
  var e = Rh(), t = ER(), r = OR(), n = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function s(o) {
    return o == null ? o === void 0 ? i : n : a && a in Object(o) ? t(o) : r(o);
  }
  return Dc = s, Dc;
}
var Rc, zp;
function jw() {
  if (zp) return Rc;
  zp = 1;
  var e = Il(), t = wh(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function s(o) {
    if (!t(o))
      return !1;
    var c = e(o);
    return c == n || c == i || c == r || c == a;
  }
  return Rc = s, Rc;
}
var kc, Bp;
function NR() {
  if (Bp) return kc;
  Bp = 1;
  var e = wn(), t = e["__core-js_shared__"];
  return kc = t, kc;
}
var Ac, Gp;
function DR() {
  if (Gp) return Ac;
  Gp = 1;
  var e = NR(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return Ac = r, Ac;
}
var xc, Qp;
function Ww() {
  if (Qp) return xc;
  Qp = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return xc = r, xc;
}
var Fc, Zp;
function RR() {
  if (Zp) return Fc;
  Zp = 1;
  var e = jw(), t = DR(), r = wh(), n = Ww(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, s = Function.prototype, o = Object.prototype, c = s.toString, u = o.hasOwnProperty, f = RegExp(
    "^" + c.call(u).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function g(p) {
    if (!r(p) || t(p))
      return !1;
    var d = e(p) ? f : a;
    return d.test(n(p));
  }
  return Fc = g, Fc;
}
var $c, Yp;
function kR() {
  if (Yp) return $c;
  Yp = 1;
  function e(t, r) {
    return t?.[r];
  }
  return $c = e, $c;
}
var Mc, Kp;
function ta() {
  if (Kp) return Mc;
  Kp = 1;
  var e = RR(), t = kR();
  function r(n, i) {
    var a = t(n, i);
    return e(a) ? a : void 0;
  }
  return Mc = r, Mc;
}
var Lc, Jp;
function kh() {
  if (Jp) return Lc;
  Jp = 1;
  var e = ta(), t = wn(), r = e(t, "Map");
  return Lc = r, Lc;
}
var jc, Xp;
function Cl() {
  if (Xp) return jc;
  Xp = 1;
  var e = ta(), t = e(Object, "create");
  return jc = t, jc;
}
var Wc, eg;
function AR() {
  if (eg) return Wc;
  eg = 1;
  var e = Cl();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Wc = t, Wc;
}
var Uc, tg;
function xR() {
  if (tg) return Uc;
  tg = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Uc = e, Uc;
}
var Vc, rg;
function FR() {
  if (rg) return Vc;
  rg = 1;
  var e = Cl(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    var s = this.__data__;
    if (e) {
      var o = s[a];
      return o === t ? void 0 : o;
    }
    return n.call(s, a) ? s[a] : void 0;
  }
  return Vc = i, Vc;
}
var Hc, ng;
function $R() {
  if (ng) return Hc;
  ng = 1;
  var e = Cl(), t = Object.prototype, r = t.hasOwnProperty;
  function n(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : r.call(a, i);
  }
  return Hc = n, Hc;
}
var qc, ig;
function MR() {
  if (ig) return qc;
  ig = 1;
  var e = Cl(), t = "__lodash_hash_undefined__";
  function r(n, i) {
    var a = this.__data__;
    return this.size += this.has(n) ? 0 : 1, a[n] = e && i === void 0 ? t : i, this;
  }
  return qc = r, qc;
}
var zc, ag;
function LR() {
  if (ag) return zc;
  ag = 1;
  var e = AR(), t = xR(), r = FR(), n = $R(), i = MR();
  function a(s) {
    var o = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++o < c; ) {
      var u = s[o];
      this.set(u[0], u[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, zc = a, zc;
}
var Bc, sg;
function jR() {
  if (sg) return Bc;
  sg = 1;
  var e = LR(), t = wl(), r = kh();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Bc = n, Bc;
}
var Gc, og;
function WR() {
  if (og) return Gc;
  og = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Gc = e, Gc;
}
var Qc, lg;
function Pl() {
  if (lg) return Qc;
  lg = 1;
  var e = WR();
  function t(r, n) {
    var i = r.__data__;
    return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  return Qc = t, Qc;
}
var Zc, cg;
function UR() {
  if (cg) return Zc;
  cg = 1;
  var e = Pl();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Zc = t, Zc;
}
var Yc, ug;
function VR() {
  if (ug) return Yc;
  ug = 1;
  var e = Pl();
  function t(r) {
    return e(this, r).get(r);
  }
  return Yc = t, Yc;
}
var Kc, dg;
function HR() {
  if (dg) return Kc;
  dg = 1;
  var e = Pl();
  function t(r) {
    return e(this, r).has(r);
  }
  return Kc = t, Kc;
}
var Jc, fg;
function qR() {
  if (fg) return Jc;
  fg = 1;
  var e = Pl();
  function t(r, n) {
    var i = e(this, r), a = i.size;
    return i.set(r, n), this.size += i.size == a ? 0 : 1, this;
  }
  return Jc = t, Jc;
}
var Xc, hg;
function Uw() {
  if (hg) return Xc;
  hg = 1;
  var e = jR(), t = UR(), r = VR(), n = HR(), i = qR();
  function a(s) {
    var o = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++o < c; ) {
      var u = s[o];
      this.set(u[0], u[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Xc = a, Xc;
}
var eu, mg;
function zR() {
  if (mg) return eu;
  mg = 1;
  var e = wl(), t = kh(), r = Uw(), n = 200;
  function i(a, s) {
    var o = this.__data__;
    if (o instanceof e) {
      var c = o.__data__;
      if (!t || c.length < n - 1)
        return c.push([a, s]), this.size = ++o.size, this;
      o = this.__data__ = new r(c);
    }
    return o.set(a, s), this.size = o.size, this;
  }
  return eu = i, eu;
}
var tu, pg;
function BR() {
  if (pg) return tu;
  pg = 1;
  var e = wl(), t = CR(), r = PR(), n = TR(), i = _R(), a = zR();
  function s(o) {
    var c = this.__data__ = new e(o);
    this.size = c.size;
  }
  return s.prototype.clear = t, s.prototype.delete = r, s.prototype.get = n, s.prototype.has = i, s.prototype.set = a, tu = s, tu;
}
var ru, gg;
function GR() {
  if (gg) return ru;
  gg = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return ru = t, ru;
}
var nu, vg;
function QR() {
  if (vg) return nu;
  vg = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return nu = e, nu;
}
var iu, yg;
function ZR() {
  if (yg) return iu;
  yg = 1;
  var e = Uw(), t = GR(), r = QR();
  function n(i) {
    var a = -1, s = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < s; )
      this.add(i[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, iu = n, iu;
}
var au, bg;
function YR() {
  if (bg) return au;
  bg = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return au = e, au;
}
var su, Sg;
function KR() {
  if (Sg) return su;
  Sg = 1;
  function e(t, r) {
    return t.has(r);
  }
  return su = e, su;
}
var ou, wg;
function Vw() {
  if (wg) return ou;
  wg = 1;
  var e = ZR(), t = YR(), r = KR(), n = 1, i = 2;
  function a(s, o, c, u, f, g) {
    var p = c & n, d = s.length, h = o.length;
    if (d != h && !(p && h > d))
      return !1;
    var v = g.get(s), b = g.get(o);
    if (v && b)
      return v == o && b == s;
    var m = -1, S = !0, I = c & i ? new e() : void 0;
    for (g.set(s, o), g.set(o, s); ++m < d; ) {
      var C = s[m], T = o[m];
      if (u)
        var E = p ? u(T, C, m, o, s, g) : u(C, T, m, s, o, g);
      if (E !== void 0) {
        if (E)
          continue;
        S = !1;
        break;
      }
      if (I) {
        if (!t(o, function(N, y) {
          if (!r(I, y) && (C === N || f(C, N, c, u, g)))
            return I.push(y);
        })) {
          S = !1;
          break;
        }
      } else if (!(C === T || f(C, T, c, u, g))) {
        S = !1;
        break;
      }
    }
    return g.delete(s), g.delete(o), S;
  }
  return ou = a, ou;
}
var lu, Ig;
function JR() {
  if (Ig) return lu;
  Ig = 1;
  var e = wn(), t = e.Uint8Array;
  return lu = t, lu;
}
var cu, Cg;
function XR() {
  if (Cg) return cu;
  Cg = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i, a) {
      n[++r] = [a, i];
    }), n;
  }
  return cu = e, cu;
}
var uu, Pg;
function ek() {
  if (Pg) return uu;
  Pg = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i) {
      n[++r] = i;
    }), n;
  }
  return uu = e, uu;
}
var du, Tg;
function tk() {
  if (Tg) return du;
  Tg = 1;
  var e = Rh(), t = JR(), r = Mw(), n = Vw(), i = XR(), a = ek(), s = 1, o = 2, c = "[object Boolean]", u = "[object Date]", f = "[object Error]", g = "[object Map]", p = "[object Number]", d = "[object RegExp]", h = "[object Set]", v = "[object String]", b = "[object Symbol]", m = "[object ArrayBuffer]", S = "[object DataView]", I = e ? e.prototype : void 0, C = I ? I.valueOf : void 0;
  function T(E, N, y, w, P, _, D) {
    switch (y) {
      case S:
        if (E.byteLength != N.byteLength || E.byteOffset != N.byteOffset)
          return !1;
        E = E.buffer, N = N.buffer;
      case m:
        return !(E.byteLength != N.byteLength || !_(new t(E), new t(N)));
      case c:
      case u:
      case p:
        return r(+E, +N);
      case f:
        return E.name == N.name && E.message == N.message;
      case d:
      case v:
        return E == N + "";
      case g:
        var R = i;
      case h:
        var x = w & s;
        if (R || (R = a), E.size != N.size && !x)
          return !1;
        var F = D.get(E);
        if (F)
          return F == N;
        w |= o, D.set(E, N);
        var W = n(R(E), R(N), w, P, _, D);
        return D.delete(E), W;
      case b:
        if (C)
          return C.call(E) == C.call(N);
    }
    return !1;
  }
  return du = T, du;
}
var fu, _g;
function rk() {
  if (_g) return fu;
  _g = 1;
  function e(t, r) {
    for (var n = -1, i = r.length, a = t.length; ++n < i; )
      t[a + n] = r[n];
    return t;
  }
  return fu = e, fu;
}
var hu, Eg;
function nk() {
  if (Eg) return hu;
  Eg = 1;
  var e = rk(), t = hl();
  function r(n, i, a) {
    var s = i(n);
    return t(n) ? s : e(s, a(n));
  }
  return hu = r, hu;
}
var mu, Og;
function ik() {
  if (Og) return mu;
  Og = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = 0, s = []; ++n < i; ) {
      var o = t[n];
      r(o, n, t) && (s[a++] = o);
    }
    return s;
  }
  return mu = e, mu;
}
var pu, Ng;
function ak() {
  if (Ng) return pu;
  Ng = 1;
  function e() {
    return [];
  }
  return pu = e, pu;
}
var gu, Dg;
function sk() {
  if (Dg) return gu;
  Dg = 1;
  var e = ik(), t = ak(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, a = i ? function(s) {
    return s == null ? [] : (s = Object(s), e(i(s), function(o) {
      return n.call(s, o);
    }));
  } : t;
  return gu = a, gu;
}
var vu, Rg;
function ok() {
  if (Rg) return vu;
  Rg = 1;
  function e(t, r) {
    for (var n = -1, i = Array(t); ++n < t; )
      i[n] = r(n);
    return i;
  }
  return vu = e, vu;
}
var yu, kg;
function Tl() {
  if (kg) return yu;
  kg = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return yu = e, yu;
}
var bu, Ag;
function lk() {
  if (Ag) return bu;
  Ag = 1;
  var e = Il(), t = Tl(), r = "[object Arguments]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return bu = n, bu;
}
var Su, xg;
function ck() {
  if (xg) return Su;
  xg = 1;
  var e = lk(), t = Tl(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, a = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(s) {
    return t(s) && n.call(s, "callee") && !i.call(s, "callee");
  };
  return Su = a, Su;
}
var ka = { exports: {} }, wu, Fg;
function uk() {
  if (Fg) return wu;
  Fg = 1;
  function e() {
    return !1;
  }
  return wu = e, wu;
}
ka.exports;
var $g;
function Hw() {
  return $g || ($g = 1, function(e, t) {
    var r = wn(), n = uk(), i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, s = a && a.exports === i, o = s ? r.Buffer : void 0, c = o ? o.isBuffer : void 0, u = c || n;
    e.exports = u;
  }(ka, ka.exports)), ka.exports;
}
var Iu, Mg;
function dk() {
  if (Mg) return Iu;
  Mg = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, i) {
    var a = typeof n;
    return i = i ?? e, !!i && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return Iu = r, Iu;
}
var Cu, Lg;
function qw() {
  if (Lg) return Cu;
  Lg = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Cu = t, Cu;
}
var Pu, jg;
function fk() {
  if (jg) return Pu;
  jg = 1;
  var e = Il(), t = qw(), r = Tl(), n = "[object Arguments]", i = "[object Array]", a = "[object Boolean]", s = "[object Date]", o = "[object Error]", c = "[object Function]", u = "[object Map]", f = "[object Number]", g = "[object Object]", p = "[object RegExp]", d = "[object Set]", h = "[object String]", v = "[object WeakMap]", b = "[object ArrayBuffer]", m = "[object DataView]", S = "[object Float32Array]", I = "[object Float64Array]", C = "[object Int8Array]", T = "[object Int16Array]", E = "[object Int32Array]", N = "[object Uint8Array]", y = "[object Uint8ClampedArray]", w = "[object Uint16Array]", P = "[object Uint32Array]", _ = {};
  _[S] = _[I] = _[C] = _[T] = _[E] = _[N] = _[y] = _[w] = _[P] = !0, _[n] = _[i] = _[b] = _[a] = _[m] = _[s] = _[o] = _[c] = _[u] = _[f] = _[g] = _[p] = _[d] = _[h] = _[v] = !1;
  function D(R) {
    return r(R) && t(R.length) && !!_[e(R)];
  }
  return Pu = D, Pu;
}
var Tu, Wg;
function hk() {
  if (Wg) return Tu;
  Wg = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Tu = e, Tu;
}
var Aa = { exports: {} };
Aa.exports;
var Ug;
function mk() {
  return Ug || (Ug = 1, function(e, t) {
    var r = Lw(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, a = i && i.exports === n, s = a && r.process, o = function() {
      try {
        var c = i && i.require && i.require("util").types;
        return c || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    e.exports = o;
  }(Aa, Aa.exports)), Aa.exports;
}
var _u, Vg;
function zw() {
  if (Vg) return _u;
  Vg = 1;
  var e = fk(), t = hk(), r = mk(), n = r && r.isTypedArray, i = n ? t(n) : e;
  return _u = i, _u;
}
var Eu, Hg;
function pk() {
  if (Hg) return Eu;
  Hg = 1;
  var e = ok(), t = ck(), r = hl(), n = Hw(), i = dk(), a = zw(), s = Object.prototype, o = s.hasOwnProperty;
  function c(u, f) {
    var g = r(u), p = !g && t(u), d = !g && !p && n(u), h = !g && !p && !d && a(u), v = g || p || d || h, b = v ? e(u.length, String) : [], m = b.length;
    for (var S in u)
      (f || o.call(u, S)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (S == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      d && (S == "offset" || S == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      h && (S == "buffer" || S == "byteLength" || S == "byteOffset") || // Skip index properties.
      i(S, m))) && b.push(S);
    return b;
  }
  return Eu = c, Eu;
}
var Ou, qg;
function gk() {
  if (qg) return Ou;
  qg = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
    return r === i;
  }
  return Ou = t, Ou;
}
var Nu, zg;
function vk() {
  if (zg) return Nu;
  zg = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Nu = e, Nu;
}
var Du, Bg;
function yk() {
  if (Bg) return Du;
  Bg = 1;
  var e = vk(), t = e(Object.keys, Object);
  return Du = t, Du;
}
var Ru, Gg;
function bk() {
  if (Gg) return Ru;
  Gg = 1;
  var e = gk(), t = yk(), r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return t(a);
    var s = [];
    for (var o in Object(a))
      n.call(a, o) && o != "constructor" && s.push(o);
    return s;
  }
  return Ru = i, Ru;
}
var ku, Qg;
function Sk() {
  if (Qg) return ku;
  Qg = 1;
  var e = jw(), t = qw();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return ku = r, ku;
}
var Au, Zg;
function wk() {
  if (Zg) return Au;
  Zg = 1;
  var e = pk(), t = bk(), r = Sk();
  function n(i) {
    return r(i) ? e(i) : t(i);
  }
  return Au = n, Au;
}
var xu, Yg;
function Ik() {
  if (Yg) return xu;
  Yg = 1;
  var e = nk(), t = sk(), r = wk();
  function n(i) {
    return e(i, r, t);
  }
  return xu = n, xu;
}
var Fu, Kg;
function Ck() {
  if (Kg) return Fu;
  Kg = 1;
  var e = Ik(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function i(a, s, o, c, u, f) {
    var g = o & t, p = e(a), d = p.length, h = e(s), v = h.length;
    if (d != v && !g)
      return !1;
    for (var b = d; b--; ) {
      var m = p[b];
      if (!(g ? m in s : n.call(s, m)))
        return !1;
    }
    var S = f.get(a), I = f.get(s);
    if (S && I)
      return S == s && I == a;
    var C = !0;
    f.set(a, s), f.set(s, a);
    for (var T = g; ++b < d; ) {
      m = p[b];
      var E = a[m], N = s[m];
      if (c)
        var y = g ? c(N, E, m, s, a, f) : c(E, N, m, a, s, f);
      if (!(y === void 0 ? E === N || u(E, N, o, c, f) : y)) {
        C = !1;
        break;
      }
      T || (T = m == "constructor");
    }
    if (C && !T) {
      var w = a.constructor, P = s.constructor;
      w != P && "constructor" in a && "constructor" in s && !(typeof w == "function" && w instanceof w && typeof P == "function" && P instanceof P) && (C = !1);
    }
    return f.delete(a), f.delete(s), C;
  }
  return Fu = i, Fu;
}
var $u, Jg;
function Pk() {
  if (Jg) return $u;
  Jg = 1;
  var e = ta(), t = wn(), r = e(t, "DataView");
  return $u = r, $u;
}
var Mu, Xg;
function Tk() {
  if (Xg) return Mu;
  Xg = 1;
  var e = ta(), t = wn(), r = e(t, "Promise");
  return Mu = r, Mu;
}
var Lu, ev;
function _k() {
  if (ev) return Lu;
  ev = 1;
  var e = ta(), t = wn(), r = e(t, "Set");
  return Lu = r, Lu;
}
var ju, tv;
function Ek() {
  if (tv) return ju;
  tv = 1;
  var e = ta(), t = wn(), r = e(t, "WeakMap");
  return ju = r, ju;
}
var Wu, rv;
function Ok() {
  if (rv) return Wu;
  rv = 1;
  var e = Pk(), t = kh(), r = Tk(), n = _k(), i = Ek(), a = Il(), s = Ww(), o = "[object Map]", c = "[object Object]", u = "[object Promise]", f = "[object Set]", g = "[object WeakMap]", p = "[object DataView]", d = s(e), h = s(t), v = s(r), b = s(n), m = s(i), S = a;
  return (e && S(new e(new ArrayBuffer(1))) != p || t && S(new t()) != o || r && S(r.resolve()) != u || n && S(new n()) != f || i && S(new i()) != g) && (S = function(I) {
    var C = a(I), T = C == c ? I.constructor : void 0, E = T ? s(T) : "";
    if (E)
      switch (E) {
        case d:
          return p;
        case h:
          return o;
        case v:
          return u;
        case b:
          return f;
        case m:
          return g;
      }
    return C;
  }), Wu = S, Wu;
}
var Uu, nv;
function Nk() {
  if (nv) return Uu;
  nv = 1;
  var e = BR(), t = Vw(), r = tk(), n = Ck(), i = Ok(), a = hl(), s = Hw(), o = zw(), c = 1, u = "[object Arguments]", f = "[object Array]", g = "[object Object]", p = Object.prototype, d = p.hasOwnProperty;
  function h(v, b, m, S, I, C) {
    var T = a(v), E = a(b), N = T ? f : i(v), y = E ? f : i(b);
    N = N == u ? g : N, y = y == u ? g : y;
    var w = N == g, P = y == g, _ = N == y;
    if (_ && s(v)) {
      if (!s(b))
        return !1;
      T = !0, w = !1;
    }
    if (_ && !w)
      return C || (C = new e()), T || o(v) ? t(v, b, m, S, I, C) : r(v, b, N, m, S, I, C);
    if (!(m & c)) {
      var D = w && d.call(v, "__wrapped__"), R = P && d.call(b, "__wrapped__");
      if (D || R) {
        var x = D ? v.value() : v, F = R ? b.value() : b;
        return C || (C = new e()), I(x, F, m, S, C);
      }
    }
    return _ ? (C || (C = new e()), n(v, b, m, S, I, C)) : !1;
  }
  return Uu = h, Uu;
}
var Vu, iv;
function Dk() {
  if (iv) return Vu;
  iv = 1;
  var e = Nk(), t = Tl();
  function r(n, i, a, s, o) {
    return n === i ? !0 : n == null || i == null || !t(n) && !t(i) ? n !== n && i !== i : e(n, i, a, s, r, o);
  }
  return Vu = r, Vu;
}
var Hu, av;
function Rk() {
  if (av) return Hu;
  av = 1;
  var e = Dk();
  function t(r, n) {
    return e(r, n);
  }
  return Hu = t, Hu;
}
var kk = Rk();
const Wa = /* @__PURE__ */ Ji(kk), sv = () => ({
  timeframe: "custom",
  start: "",
  end: Go(ve.now())
}), Ak = () => ({
  timeframe: "custom",
  start: Go(ve.now()),
  end: ""
}), _l = {
  organizationId: "",
  deviceName: "",
  iccid: { value: "", condition: "contains" },
  imei: { value: "", condition: "is" },
  simStatuses: [],
  tags: [],
  plans: [],
  lastActive: sv(),
  activationDate: sv(),
  targetActivationDate: Ak()
}, Qr = {
  organizationId: "Organization ID",
  deviceName: "Name",
  iccid: "Enabled profile ICCID",
  imei: "Last known IMEI",
  simStatuses: "SIM status",
  tags: "Tags",
  noTags: "",
  // Not real, no real support for this
  plans: "Data plan",
  lastActive: "Last closed session",
  activationDate: "Activation date",
  targetActivationDate: "Target activation date",
  dataUsage: "Data usage"
}, xk = () => structuredClone(_l), El = (e, t) => !t || Wa(t, _l[e]), qu = (e) => structuredClone(_l[e]), Fk = (e) => {
  const { timeframe: t } = e, r = ve.now();
  let n, i, a;
  switch (t) {
    case "custom":
    case void 0:
      return n = Mn(e.start), i = Mn(e.end), !n || !i ? void 0 : {
        startTime: n,
        endTime: i
      };
    case "thisMonth":
      return {
        startTime: r.startOf("month"),
        endTime: r.endOf("day")
      };
    case "nextMonth":
      return {
        startTime: r.endOf("day"),
        endTime: r.endOf("month")
      };
    case "thisYear":
      return {
        startTime: r.startOf("year"),
        endTime: r.endOf("day")
      };
    default:
      return t.startsWith("-") ? (a = Ie.fromISO(t.slice(1)), {
        startTime: r.minus(a),
        endTime: r.endOf("day")
      }) : (a = Ie.fromISO(t), {
        startTime: r.endOf("day"),
        endTime: r.plus(a)
      });
  }
}, ov = (e) => {
  if (!Dw(e))
    return;
  const t = Fk(e);
  if (!t)
    return;
  const r = {
    start: Go(t.startTime ?? void 0),
    end: Go(t.endTime ?? void 0)
  };
  if (r.start && r.end)
    return r;
}, $k = "Start date must be before end date.", Ah = ({
  options: e,
  filter: t,
  submit: r,
  filterPath: n,
  timeframePath: i,
  startPath: a,
  endPath: s,
  form: o,
  minDate: c,
  maxDate: u
}) => {
  const { register: f, setValue: g, getValues: p, trigger: d } = o, [h, v] = Z(a), b = V(
    () => e.map(({ label: x, value: F = "unknown", isFuture: W }) => typeof F == "string" ? {
      label: x,
      value: F ?? "unknown"
    } : W ? { label: x, value: F.toISO() ?? "unknown" } : { label: x, value: `-${F.toISO()}` }),
    [e]
  ), m = we(t?.timeframe);
  Pe(() => {
    const x = t?.timeframe;
    if (m.current !== x) {
      if (m.current = x, x && x !== "custom") {
        const F = ov(t);
        F && (g(n, {
          timeframe: x,
          ...F
        }), r());
      }
    } else if (x !== "custom" && (!t?.start || !t?.end)) {
      const F = ov(t);
      F && (g(n, {
        timeframe: x,
        ...F
      }), r());
    }
  }, [t, n, g, r]);
  const S = $(
    async (x) => {
      g(i, "custom");
      const F = x.target.name;
      v(F), await d(F) && r();
    },
    [g, r, i, d]
  ), I = $(() => {
    r();
  }, [r]), C = f(i, {
    required: !0,
    onChange: I
  }), T = p(a), E = p(s), { startDate: N, endDate: y } = V(
    () => ({ startDate: Mn(T), endDate: Mn(E) }),
    [E, T]
  ), w = $(() => N && y ? ct.fromDateTimes(N, y).isValid : !1, [y, N]), { invalid: P, validationMessage: _ } = V(() => {
    let x = !1;
    return w() || (x = N && y ? !0 : void 0), {
      invalid: x,
      validationMessage: x ? $k : void 0
    };
  }, [y, N, w]), D = {
    ...f(a, {
      onChange: S
    }),
    invalid: P && h === a || (T && T.length > 0 ? void 0 : !1),
    defaultValue: T,
    minDate: c,
    maxDate: u
  }, R = {
    ...f(s, {
      onChange: S
    }),
    invalid: P && h === s || (E && E.length > 0 ? void 0 : !1),
    defaultValue: E,
    minDate: c,
    maxDate: u
  };
  return {
    selectableOptions: b,
    timeframeProps: C,
    startFieldProps: D,
    endFieldProps: R,
    invalid: P,
    validationMessage: _
  };
}, Mk = ({ onClear: e, segmentName: t, form: r, submit: n }) => {
  const { watch: i } = r, s = Ar()?.activationDate, o = i("activationDate"), c = V(
    () => [
      { value: "custom", label: "Custom date range" },
      { value: "thisMonth", label: "This month" },
      { value: Ie.fromObject({ days: 1 }), label: "In the last day" },
      { value: Ie.fromObject({ days: 7 }), label: "In the last 7 days" },
      { value: Ie.fromObject({ days: 30 }), label: "In the last 30 days" },
      { value: Ie.fromObject({ days: 90 }), label: "In the last 90 days" },
      { value: Ie.fromObject({ days: 365 }), label: "In the last 365 days" }
    ],
    []
  ), {
    selectableOptions: u,
    timeframeProps: f,
    startFieldProps: g,
    endFieldProps: p,
    invalid: d,
    validationMessage: h
  } = Ah({
    options: c,
    filter: o,
    filterPath: "activationDate",
    timeframePath: "activationDate.timeframe",
    startPath: "activationDate.start",
    endPath: "activationDate.end",
    submit: n,
    form: r,
    maxDate: ve.now().startOf("day")
  }), v = V(
    () => !El("activationDate", s),
    [s]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: e,
      label: Qr.activationDate,
      isSet: v,
      defaultActive: v,
      children: /* @__PURE__ */ l(
        Dh,
        {
          id: "activationDate",
          options: u,
          timeframeProps: f,
          startFieldProps: g,
          endFieldProps: p,
          invalid: d,
          validationMessage: h,
          className: Sr.defaultWrapper
        }
      )
    }
  );
}, Lk = ({ form: e, onClear: t, submit: r }) => {
  const { register: n } = e, a = Ar()?.deviceName, s = n("deviceName", {
    onBlur: () => {
      r();
    }
  }), o = $(
    (c) => {
      c.key === "Enter" && r();
    },
    [r]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: t,
      label: Qr.deviceName,
      isSet: a !== void 0,
      defaultActive: a !== void 0,
      children: /* @__PURE__ */ l("div", { className: Sr.defaultWrapper, children: /* @__PURE__ */ l(
        nn,
        {
          id: "deviceName",
          onKeyUp: o,
          inputProps: { "data-1p-ignore": !0, "data-lpignore": !0 },
          ...s
        }
      ) })
    }
  );
}, jk = ({ form: e, onClear: t, submit: r }) => {
  const { register: n, getValues: i } = e, s = Ar()?.iccid?.value, o = n("iccid.value", {
    onBlur: () => {
      r();
    }
  }), { value: c } = i("iccid") ?? {}, u = $(() => {
    c && c.length > 0 && r();
  }, [c, r]), f = n("iccid.condition", {
    onChange: u
  }), g = $(
    (p) => {
      p.key === "Enter" && r();
    },
    [r]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: t,
      label: Qr.iccid,
      isSet: s !== void 0,
      defaultActive: !0,
      children: /* @__PURE__ */ O("div", { className: Sr.defaultWrapper, children: [
        /* @__PURE__ */ l(
          Qf,
          {
            label: "",
            id: "iccidCondition",
            options: [
              { label: "Is", value: "is" },
              { label: "Starts With", value: "startswith" },
              { label: "Ends With", value: "endswith" },
              { label: "Contains", value: "contains" }
            ],
            ...f
          }
        ),
        /* @__PURE__ */ l(
          nn,
          {
            id: "iccid",
            onKeyUp: g,
            inputProps: { "data-1p-ignore": !0, "data-lpignore": !0 },
            ...o
          }
        )
      ] })
    }
  );
}, Wk = ({ form: e, onClear: t, submit: r }) => {
  const { register: n, getValues: i } = e, s = Ar()?.imei?.value, o = n("imei.value", {
    onBlur: () => {
      r();
    }
  }), { value: c } = i("imei") ?? {}, u = $(() => {
    c && c.length > 0 && r();
  }, [c, r]), f = n("imei.condition", {
    onChange: u
  }), g = $(
    (p) => {
      p.key === "Enter" && r();
    },
    [r]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: t,
      label: Qr.imei,
      isSet: s !== void 0,
      defaultActive: s !== void 0,
      children: /* @__PURE__ */ O("div", { className: Sr.defaultWrapper, children: [
        /* @__PURE__ */ l(
          Qf,
          {
            label: "",
            id: "imeiCondition",
            options: [
              { label: "Is", value: "is" },
              { label: "Starts With", value: "startswith" },
              { label: "Ends With", value: "endswith" },
              { label: "Contains", value: "contains" }
            ],
            ...f
          }
        ),
        /* @__PURE__ */ l(
          nn,
          {
            id: "imei",
            onKeyUp: g,
            inputProps: { "data-1p-ignore": !0, "data-lpignore": !0 },
            ...o
          }
        )
      ] })
    }
  );
}, Uk = ({ onClear: e, segmentName: t, form: r, submit: n }) => {
  const { watch: i } = r, s = Ar()?.lastActive, o = i("lastActive"), c = V(
    () => [
      { value: "custom", label: "Custom date range" },
      { value: "thisMonth", label: "This month" },
      { value: Ie.fromObject({ days: 1 }), label: "In the last day" },
      { value: Ie.fromObject({ days: 7 }), label: "In the last 7 days" },
      { value: Ie.fromObject({ days: 30 }), label: "In the last 30 days" },
      { value: Ie.fromObject({ days: 90 }), label: "In the last 90 days" },
      { value: Ie.fromObject({ days: 365 }), label: "In the last 365 days" }
    ],
    []
  ), {
    selectableOptions: u,
    timeframeProps: f,
    startFieldProps: g,
    endFieldProps: p,
    invalid: d,
    validationMessage: h
  } = Ah({
    options: c,
    filter: o,
    filterPath: "lastActive",
    timeframePath: "lastActive.timeframe",
    startPath: "lastActive.start",
    endPath: "lastActive.end",
    submit: n,
    form: r,
    maxDate: ve.now().startOf("day")
  }), v = V(
    () => !El("lastActive", s),
    [s]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: e,
      label: Qr.lastActive,
      isSet: v,
      defaultActive: v,
      children: /* @__PURE__ */ l(
        Dh,
        {
          id: "lastActive",
          options: u,
          timeframeProps: f,
          startFieldProps: g,
          endFieldProps: p,
          invalid: d,
          validationMessage: h,
          className: Sr.defaultWrapper
        }
      )
    }
  );
}, Vk = ({ form: e, onClear: t, submit: r }) => {
  const i = Ar()?.organizationId, a = Ms((h) => h.setOrganizationIdFilter), { register: s } = e, o = s("organizationId", {
    onBlur: () => {
      r();
    }
  }), { organization: c, error: u, isLoading: f } = RT(i);
  let g;
  f ? g = `...${i}...` : u ? g = `${i}` : c?.name ? g = c.name : g = `${i}`;
  const p = $(() => {
    a(void 0), r();
  }, [a, r]), d = $(
    (h) => {
      h.key === "Enter" && r();
    },
    [r]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: t,
      label: Qr.organizationId,
      isSet: i !== void 0,
      defaultActive: i !== void 0,
      children: /* @__PURE__ */ O("div", { className: Sr.defaultWrapper, children: [
        /* @__PURE__ */ l(
          nn,
          {
            id: "organizationId",
            type: "number",
            inputProps: { "data-1p-ignore": !0, "data-lpignore": !0 },
            onKeyUp: d,
            ...o
          }
        ),
        i && /* @__PURE__ */ O(le, { children: [
          /* @__PURE__ */ l("hr", { className: Sr.divider }),
          /* @__PURE__ */ l(
            Rr,
            {
              name: i.toString(),
              defaultChecked: !0,
              label: g,
              onChange: p
            }
          )
        ] })
      ] })
    }
  );
}, Hk = "hyperdashboard-SimPlanFilter-module-aMa1NG-loadingText", qk = "hyperdashboard-SimPlanFilter-module-aMa1NG-optionWrapper", zk = "hyperdashboard-SimPlanFilter-module-aMa1NG-placeholderText", Bk = "hyperdashboard-SimPlanFilter-module-aMa1NG-planOption", Gk = "hyperdashboard-SimPlanFilter-module-aMa1NG-wrapper", ga = {
  loadingText: Hk,
  optionWrapper: qk,
  placeholderText: zk,
  planOption: Bk,
  wrapper: Gk
}, Qk = Et(
  ({ form: e, onClear: t, segmentName: r, submit: n }, i) => {
    const { register: a, setValue: s, getValues: o } = e, { plans: c, organizationId: u } = Ar(), f = Ne(), g = r === "all" ? u : f, p = !!g, { plans: d, isLoading: h, error: v, mutate: b } = ml({
      organizationId: g,
      canLoad: p
    }), m = $(() => {
      h || b();
    }, [h, b]);
    Kt(i, () => m, [m]);
    const S = o("plans"), I = $(() => {
      n();
    }, [n]), C = a("plans", {
      onChange: I
    }), T = $(
      (y) => {
        if (!s) {
          console.error("Unexpectedly missing setValue when toggling select all");
          return;
        }
        y.target.checked ? s(
          "plans",
          d.map((w) => `${w.id}`)
        ) : s("plans", void 0), n();
      },
      [d, s, n]
    ), E = !!c && zr(c) && c.length > 0, N = V(() => v ? /* @__PURE__ */ l(tn, { variant: "system-error", style: { display: "inline" }, children: "We ran into an issue loading this filter. You can try to refresh." }) : h ? /* @__PURE__ */ l("div", { className: ga.loadingText, children: "Loading..." }) : p ? /* @__PURE__ */ O(le, { children: [
      /* @__PURE__ */ l(
        Rr,
        {
          label: "Select all",
          value: "all",
          onChange: T,
          indeterminate: (S?.length ?? 0) > 0 && S.length !== d.length,
          defaultChecked: E && (S?.length ?? 0) === d.length
        },
        "all"
      ),
      /* @__PURE__ */ l("hr", { className: Sr.divider }),
      /* @__PURE__ */ l("div", { className: ga.optionWrapper, children: d.map((y) => /* @__PURE__ */ l(
        Rr,
        {
          className: ga.planOption,
          label: `${y.planName}`,
          title: `${y.planName}`,
          value: `${y.id}`,
          defaultChecked: E && c.includes(y.id),
          ...C
        },
        y.id
      )) })
    ] }) : /* @__PURE__ */ l("div", { className: ga.placeholderText, children: "Please select an organization." }), [
      C,
      v,
      T,
      p,
      h,
      E,
      d,
      S,
      c
    ]);
    return /* @__PURE__ */ l(
      sn,
      {
        onClear: t,
        label: Qr.plans,
        isSet: E,
        defaultActive: E,
        children: /* @__PURE__ */ l("div", { className: ga.wrapper, children: N })
      }
    );
  }
), Zk = "hyperdashboard-SimStatusFilter-module-keexzW-loadingText", Yk = "hyperdashboard-SimStatusFilter-module-keexzW-optionWrapper", Kk = "hyperdashboard-SimStatusFilter-module-keexzW-statusOption", Jk = "hyperdashboard-SimStatusFilter-module-keexzW-wrapper", so = {
  loadingText: Zk,
  optionWrapper: Yk,
  statusOption: Kk,
  wrapper: Jk
}, Xk = /* @__PURE__ */ new Set([
  "Connected",
  "Ready / Connected",
  // TODO: Remove
  "In testing / Connected",
  // TODO: Remove
  "Ready",
  "In testing",
  "Pending",
  "Entering testing",
  "Ready to activate",
  "Activating",
  "Pausing",
  "Paused by user",
  "Paused by system",
  "Resuming",
  "Deactivating",
  "Available"
]), eA = ({ onClear: e, segmentName: t, submit: r, form: n }) => {
  const { register: i } = n, s = Ar()?.simStatuses, o = $(() => {
    r();
  }, [r]), c = i("simStatuses", {
    onChange: o
  }), { networkStatusGroups: u, formatStatus: f, isLoading: g, error: p } = ht(), d = V(() => {
    let b;
    switch (t) {
      case "active":
        b = u?.active;
        break;
      case "preflight":
        b = u?.predeployment;
        break;
      case "deactivated":
        b = u?.deactivated;
        break;
      case "all":
      default:
        b = [
          ...u?.active ?? [],
          ...u?.predeployment ?? [],
          ...u?.deactivated ?? []
        ];
    }
    const m = /* @__PURE__ */ new Set();
    return (b ?? []).forEach((I) => {
      const C = f(I);
      C === "Ready" ? m.add("Ready / Connected") : C === "In testing" ? m.add("In testing / Connected") : m.add(C);
    }), [...new Set([...Xk].filter((I) => m.delete(I))), ...m];
  }, [f, u, t]), h = !!s && zr(s) && s.length > 0;
  let v;
  return p ? (v = /* @__PURE__ */ l(tn, { variant: "system-error", style: { display: "inline" }, children: "We ran into an issue loading this filter. You can try to refresh." }), console.error(p)) : g ? v = /* @__PURE__ */ l("div", { className: so.loadingText, children: "Loading..." }) : v = /* @__PURE__ */ l("div", { className: so.optionWrapper, children: d.map((b) => {
    const m = b.replace("Ready / Connected", "Ready").replace("In testing / Connected", "In testing");
    return /* @__PURE__ */ l(
      Rr,
      {
        className: so.statusOption,
        label: b,
        title: b,
        value: m,
        defaultChecked: h && s.includes(m),
        ...c
      },
      b
    );
  }) }), /* @__PURE__ */ l(sn, { onClear: e, label: Qr.simStatuses, isSet: h, defaultActive: !0, children: /* @__PURE__ */ l("div", { className: so.wrapper, children: v }) });
}, tA = "hyperdashboard-SimTagFilter-module-d_Zu5G-optionWrapper", rA = "hyperdashboard-SimTagFilter-module-d_Zu5G-placeholderText", nA = "hyperdashboard-SimTagFilter-module-d_Zu5G-tagOption", iA = "hyperdashboard-SimTagFilter-module-d_Zu5G-wrapper", mi = {
  optionWrapper: tA,
  placeholderText: rA,
  tagOption: nA,
  wrapper: iA
}, aA = Et(
  ({ form: e, onClear: t, segmentName: r, submit: n }, i) => {
    const { register: a, setValue: s, getValues: o } = e, { tags: c, organizationId: u } = Ar(), f = Ne(), g = r === "all" ? u : f, p = !!g, {
      networkStatusGroups: d,
      isLoading: h,
      error: v
    } = ht(), b = V(() => {
      if (r !== "all")
        return r === "active" ? d?.active : r === "preflight" ? d?.predeployment : d?.deactivated;
    }, [d, r]), {
      tags: m,
      isLoading: S,
      error: I,
      mutate: C
    } = uh({
      filters: {
        organizationIds: p ? [g] : void 0,
        networkStatus: b
      },
      canLoad: p
    }), T = $(() => {
      S || C();
    }, [C, S]);
    Kt(i, () => T, [T]);
    const E = V(() => m.filter((A) => (A.simCount ?? 0) > 0), [m]), N = I || v, y = S || h, w = o("tags"), P = V(() => !w || w.length === 0 ? w : w.filter((A) => E.find((M) => `${M.id}` === A)), [w, E]);
    Pe(() => {
      !S && (P?.length ?? 0) !== (w?.length ?? 0) && t();
    }, [t, w, P, c, m, S]);
    const _ = $(() => {
      n();
    }, [n]), D = a("tags", {
      onChange: _
    }), R = $(
      (A) => {
        if (!s) {
          console.error("Unexpectedly missing setValue when toggling select all");
          return;
        }
        A.target.checked ? s(
          "tags",
          E.map((M) => `${M.id}`)
        ) : s("tags", void 0), n();
      },
      [s, n, E]
    ), x = $(
      (A) => {
        if (!s) {
          console.error("Unexpectedly missing setValue when toggling no tags");
          return;
        }
        s("noTags", A.target.checked), n();
      },
      [s, n]
    ), F = !!c && zr(c) && c.length > 0 || !!o("noTags"), W = V(() => N ? /* @__PURE__ */ l(tn, { variant: "system-error", style: { display: "inline" }, children: "We ran into an issue loading this filter. You can try to refresh." }) : y ? /* @__PURE__ */ l("div", { className: mi.placeholderText, children: "Loading..." }) : p ? !E || E.length === 0 ? /* @__PURE__ */ l("div", { className: mi.placeholderText, children: "No tags available" }) : /* @__PURE__ */ O(le, { children: [
      /* @__PURE__ */ l(
        Rr,
        {
          label: "Select all",
          value: "all",
          onChange: R,
          indeterminate: (P?.length ?? 0) > 0 && P.length !== E.length,
          defaultChecked: F && (P?.length ?? 0) === E.length
        },
        "all"
      ),
      /* @__PURE__ */ l("hr", { className: Sr.divider }),
      /* @__PURE__ */ l("div", { className: mi.optionWrapper, children: E.map((A) => /* @__PURE__ */ l(
        Rr,
        {
          className: mi.tagOption,
          label: `${A.name} (${A.simCount})`,
          title: `${A.name} (${A.simCount})`,
          value: `${A.id}`,
          defaultChecked: F && !!A.id && c?.includes(A.id),
          ...D
        },
        A.id
      )) }),
      /* @__PURE__ */ l("hr", { className: Sr.divider }),
      /* @__PURE__ */ l(
        Rr,
        {
          label: "SIMs with no tags",
          value: "notags",
          onChange: x,
          defaultChecked: F && o("noTags")
        },
        "notags"
      )
    ] }) : /* @__PURE__ */ l("div", { className: mi.placeholderText, children: "Please select an organization" }), [
      D,
      N,
      o,
      R,
      x,
      p,
      y,
      F,
      P,
      c,
      E
    ]);
    return /* @__PURE__ */ l(
      sn,
      {
        onClear: t,
        label: Qr.tags,
        isSet: F,
        defaultActive: F,
        children: /* @__PURE__ */ l("div", { className: mi.wrapper, children: W })
      }
    );
  }
), sA = ({ onClear: e, segmentName: t, form: r, submit: n }) => {
  const { watch: i } = r, s = Ar()?.targetActivationDate, o = i("targetActivationDate"), c = V(
    () => [
      { value: "custom", label: "Custom date range" },
      { value: "nextMonth", label: "This month", isFuture: !0 },
      { value: Ie.fromObject({ days: 1 }), label: "In the next day", isFuture: !0 },
      { value: Ie.fromObject({ days: 7 }), label: "In the next 7 days", isFuture: !0 },
      { value: Ie.fromObject({ days: 30 }), label: "In the next 30 days", isFuture: !0 },
      { value: Ie.fromObject({ days: 90 }), label: "In the next 90 days", isFuture: !0 },
      { value: Ie.fromObject({ days: 365 }), label: "In the next 365 days", isFuture: !0 }
    ],
    []
  ), {
    selectableOptions: u,
    timeframeProps: f,
    startFieldProps: g,
    endFieldProps: p,
    invalid: d,
    validationMessage: h
  } = Ah({
    options: c,
    filter: o,
    filterPath: "targetActivationDate",
    timeframePath: "targetActivationDate.timeframe",
    startPath: "targetActivationDate.start",
    endPath: "targetActivationDate.end",
    submit: n,
    form: r,
    minDate: ve.now().startOf("day"),
    maxDate: null
  }), v = V(
    () => !El("targetActivationDate", s),
    [s]
  );
  return /* @__PURE__ */ l(
    sn,
    {
      onClear: e,
      label: Qr.targetActivationDate,
      isSet: v,
      defaultActive: v,
      children: /* @__PURE__ */ l(
        Dh,
        {
          id: "targetActivationDate",
          options: u,
          timeframeProps: f,
          startFieldProps: g,
          endFieldProps: p,
          invalid: d,
          validationMessage: h,
          className: Sr.defaultWrapper
        }
      )
    }
  );
}, oA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-contentWrapper", lA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-header", cA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-headerLeftContents", uA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-headerRightContents", dA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-headerWrapper", fA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-isScrolling", hA = "hyperdashboard-SimInventoryFilters-module-Sf-6OW-wrapper", zt = {
  contentWrapper: oA,
  header: lA,
  headerLeftContents: cA,
  headerRightContents: uA,
  headerWrapper: dA,
  isScrolling: fA,
  wrapper: hA
}, mA = Et(
  ({ className: e, segmentName: t }, r) => {
    const n = wr(Sh);
    if (!n)
      throw new Error("Not in SimInventoryStoreProvider context");
    const {
      resetFilters: i,
      setOrganizationIdFilter: a,
      setDeviceNameFilter: s,
      setIccidFilter: o,
      setImeiFilter: c,
      setLastActiveFilter: u,
      setActivationDateFilter: f,
      setTargetActivationDateFilter: g,
      setSimStatusFilter: p,
      setTagFilter: d,
      setNoTagFilter: h,
      setPlanFilter: v
    } = n(), b = Ar(), { sendAnalyticsEvent: m } = mt(), S = we(b);
    Pe(() => {
      const Q = S.current, he = (se, pe) => JSON.stringify(se) === JSON.stringify(pe), ce = (se) => Array.isArray(se) && se.length === 0;
      Object.keys(b).forEach((se) => {
        (typeof Q[se] === void 0 || !he(Q[se], b[se])) && !ce(b[se]) && !he(b[se], _l[se]) && b[se] && m && m(`Filter - ${Qr[se]} apply`, {
          value: b[se]
        });
      }), S.current = b;
    }, [b, m]);
    const I = Nw({ segmentName: t, filters: b }), C = $((Q) => {
      const he = xk();
      return Q && (Q.organizationId && (he.organizationId = Q.organizationId.toString()), Q.deviceName && (he.deviceName = Q.deviceName), Q.iccid?.value && Q.iccid.value.length > 0 && (he.iccid = structuredClone(Q.iccid)), Q.imei?.value && Q.imei.value.length > 0 && (he.imei = structuredClone(Q.imei)), Q.lastActive && (he.lastActive = structuredClone(Q.lastActive)), Q.activationDate && (he.activationDate = structuredClone(Q.activationDate)), Q.targetActivationDate && (he.targetActivationDate = structuredClone(Q.targetActivationDate)), Q.simStatuses && Q.simStatuses.length > 0 && (he.simStatuses = structuredClone(Q.simStatuses)), Q.tags && Q.tags.length > 0 && (he.tags = structuredClone(Q.tags).map((ce) => `${ce}`)), Q.noTags && (he.noTags = Q.noTags), Q.plans && Q.plans.length > 0 && (he.plans = structuredClone(Q.plans).map((ce) => `${ce}`))), he;
    }, []), T = Lt({
      defaultValues: C(b),
      mode: "onSubmit",
      reValidateMode: "onSubmit",
      shouldFocusError: !1
    }), E = $(
      (Q) => {
        s(Q.deviceName ?? void 0), o(Q.iccid?.value ? Q.iccid : void 0), c(Q.imei?.value ? Q.imei : void 0), u(Q.lastActive ?? void 0), f(Q.activationDate ?? void 0), g(Q.targetActivationDate ?? void 0), p(Q.simStatuses ?? void 0), d(Q.tags ? Q.tags.map((he) => parseInt(he, 10)) : void 0), h(Q.noTags ?? void 0), v(Q.plans ? Q.plans.map((he) => parseInt(he, 10)) : void 0), t !== "all" ? a(void 0) : Q.organizationId ? (a(parseInt(Q.organizationId, 10)), b.organizationId !== parseInt(Q.organizationId, 10) && d(void 0)) : (a(void 0), b.organizationId && d(void 0));
      },
      [
        s,
        o,
        c,
        g,
        u,
        f,
        p,
        d,
        h,
        v,
        t,
        a,
        b.organizationId
      ]
    ), { handleSubmit: N, reset: y, clearErrors: w } = T, P = N(E), _ = $(() => {
      i(), y();
    }, [y, i]), D = PO(P, 0), R = we(null), [x, F] = Z(!1), W = R.current, A = $(() => {
      W && F(W.scrollTop > 0);
    }, [W]);
    Pe(() => (W?.addEventListener("scroll", A), () => {
      W?.removeEventListener("scroll", A);
    }), [R, W, A]), Pe(() => {
      t !== "all" && a(void 0), y(C(b));
    }, [t, C]), Pe(() => {
      const Q = n.subscribe((he) => {
        const ce = he?.filters;
        y(C(ce));
      });
      return () => Q();
    }, [y, n, C]);
    const M = $(() => {
      p(void 0);
    }, [p]), j = $(() => {
      d(void 0), h(void 0);
    }, [h, d]), B = $(() => {
      v(void 0);
    }, [v]), L = $(() => {
      o(void 0);
    }, [o]), H = $(() => {
      w("lastActive"), u(qu("lastActive"));
    }, [w, u]), q = $(() => {
      w("activationDate"), f(qu("activationDate"));
    }, [w, f]), te = $(() => {
      w("targetActivationDate"), g(qu("targetActivationDate"));
    }, [w, g]), G = $(() => {
      c(void 0);
    }, [c]), X = $(() => {
      a(void 0), d(void 0);
    }, [a, d]), re = $(() => {
      s(void 0);
    }, [s]), oe = we(null), ue = we(null), de = $((Q) => {
      oe.current && oe.current(Q), ue.current && ue.current(Q);
    }, []);
    return Kt(r, () => de, [de]), /* @__PURE__ */ O(
      Gr,
      {
        className: J(zt.wrapper, e, x && zt.isScrolling),
        onSubmit: P,
        ref: R,
        children: [
          /* @__PURE__ */ O("div", { className: zt.headerWrapper, children: [
            /* @__PURE__ */ l("div", { className: zt.headerLeftContents, children: /* @__PURE__ */ l("span", { className: zt.header, children: "Filters" }) }),
            /* @__PURE__ */ l("div", { className: zt.headerRightContents, children: I && /* @__PURE__ */ l(Y, { variant: "tertiary", type: "reset", "aria-label": "Reset filters", onClick: _, children: "Reset" }) })
          ] }),
          t === "all" && /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            Vk,
            {
              segmentName: t,
              onClear: X,
              submit: D,
              form: T
            }
          ) }),
          /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            aA,
            {
              ref: oe,
              segmentName: t,
              onClear: j,
              submit: D,
              form: T
            }
          ) }),
          /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            eA,
            {
              segmentName: t,
              onClear: M,
              submit: D,
              form: T
            }
          ) }),
          /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            jk,
            {
              segmentName: t,
              onClear: L,
              submit: D,
              form: T
            }
          ) }),
          t !== "deactivated" && /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            Uk,
            {
              segmentName: t,
              onClear: H,
              submit: D,
              form: T
            }
          ) }),
          /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            Lk,
            {
              segmentName: t,
              onClear: re,
              submit: D,
              form: T
            }
          ) }),
          /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            Wk,
            {
              segmentName: t,
              onClear: G,
              submit: D,
              form: T
            }
          ) }),
          t !== "deactivated" && /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            Qk,
            {
              ref: ue,
              segmentName: t,
              onClear: B,
              submit: D,
              form: T
            }
          ) }),
          ["active", "all"].includes(t) && /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            Mk,
            {
              segmentName: t,
              onClear: q,
              submit: D,
              form: T
            }
          ) }),
          ["preflight", "all"].includes(t) && /* @__PURE__ */ l("div", { className: zt.contentWrapper, children: /* @__PURE__ */ l(
            sA,
            {
              segmentName: t,
              onClear: te,
              submit: D,
              form: T
            }
          ) })
        ]
      }
    );
  }
);
function pi(e, t, r) {
  let n = r.initialDeps ?? [], i;
  function a() {
    var s, o, c, u;
    let f;
    r.key && ((s = r.debug) != null && s.call(r)) && (f = Date.now());
    const g = e();
    if (!(g.length !== n.length || g.some((h, v) => n[v] !== h)))
      return i;
    n = g;
    let d;
    if (r.key && ((o = r.debug) != null && o.call(r)) && (d = Date.now()), i = t(...g), r.key && ((c = r.debug) != null && c.call(r))) {
      const h = Math.round((Date.now() - f) * 100) / 100, v = Math.round((Date.now() - d) * 100) / 100, b = v / 16, m = (S, I) => {
        for (S = String(S); S.length < I; )
          S = " " + S;
        return S;
      };
      console.info(
        `%c⏱ ${m(v, 5)} /${m(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * b, 120)
        )}deg 100% 31%);`,
        r?.key
      );
    }
    return (u = r?.onChange) == null || u.call(r, i), i;
  }
  return a.updateDeps = (s) => {
    n = s;
  }, a;
}
function zu(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const pA = (e, t) => Math.abs(e - t) <= 1, gA = (e, t, r) => {
  let n;
  return function(...i) {
    e.clearTimeout(n), n = e.setTimeout(() => t.apply(this, i), r);
  };
}, lv = (e) => {
  const { offsetWidth: t, offsetHeight: r } = e;
  return { width: t, height: r };
}, vA = (e) => e, yA = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), n = [];
  for (let i = t; i <= r; i++)
    n.push(i);
  return n;
}, bA = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  const i = (s) => {
    const { width: o, height: c } = s;
    t({ width: Math.round(o), height: Math.round(c) });
  };
  if (i(lv(r)), !n.ResizeObserver)
    return () => {
    };
  const a = new n.ResizeObserver((s) => {
    const o = () => {
      const c = s[0];
      if (c?.borderBoxSize) {
        const u = c.borderBoxSize[0];
        if (u) {
          i({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      i(lv(r));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(o) : o();
  });
  return a.observe(r, { box: "border-box" }), () => {
    a.unobserve(r);
  };
}, cv = {
  passive: !0
}, uv = typeof window > "u" ? !0 : "onscrollend" in window, SA = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  let i = 0;
  const a = e.options.useScrollendEvent && uv ? () => {
  } : gA(
    n,
    () => {
      t(i, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (f) => () => {
    const { horizontal: g, isRtl: p } = e.options;
    i = g ? r.scrollLeft * (p && -1 || 1) : r.scrollTop, a(), t(i, f);
  }, o = s(!0), c = s(!1);
  c(), r.addEventListener("scroll", o, cv);
  const u = e.options.useScrollendEvent && uv;
  return u && r.addEventListener("scrollend", c, cv), () => {
    r.removeEventListener("scroll", o), u && r.removeEventListener("scrollend", c);
  };
}, wA = (e, t, r) => {
  if (t?.borderBoxSize) {
    const n = t.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[r.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, IA = (e, {
  adjustments: t = 0,
  behavior: r
}, n) => {
  var i, a;
  const s = e + t;
  (a = (i = n.scrollElement) == null ? void 0 : i.scrollTo) == null || a.call(i, {
    [n.options.horizontal ? "left" : "top"]: s,
    behavior: r
  });
};
class CA {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((a) => {
          const s = () => {
            this._measureElement(a.target, a);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = n()) == null || i.disconnect(), r = null;
        },
        observe: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var a;
          return (a = n()) == null ? void 0 : a.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, i]) => {
        typeof i > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: vA,
        rangeExtractor: yA,
        onChange: () => {
        },
        measureElement: wA,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, i;
      (i = (n = this.options).onChange) == null || i.call(n, this, r);
    }, this.maybeNotify = pi(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, a) => {
            this.scrollAdjustments = 0, this.scrollDirection = a ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = a, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (let s = n - 1; s >= 0; s--) {
        const o = r[s];
        if (i.has(o.lane))
          continue;
        const c = a.get(
          o.lane
        );
        if (c == null || o.end > c.end ? a.set(o.lane, o) : o.end < c.end && i.set(o.lane, !0), i.size === this.options.lanes)
          break;
      }
      return a.size === this.options.lanes ? Array.from(a.values()).sort((s, o) => s.end === o.end ? s.index - o.index : s.end - o.end)[0] : void 0;
    }, this.getMeasurementOptions = pi(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, n, i, a, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: i,
        getItemKey: a,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = pi(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: i, getItemKey: a, enabled: s }, o) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((f) => {
          this.itemSizeCache.set(f.key, f.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, c);
        for (let f = c; f < r; f++) {
          const g = a(f), p = this.options.lanes === 1 ? u[f - 1] : this.getFurthestMeasurement(u, f), d = p ? p.end + this.options.gap : n + i, h = o.get(g), v = typeof h == "number" ? h : this.options.estimateSize(f), b = d + v, m = p ? p.lane : f % this.options.lanes;
          u[f] = {
            index: f,
            start: d,
            size: v,
            end: b,
            key: g,
            lane: m
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = pi(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (r, n, i, a) => this.range = r.length > 0 && n > 0 ? PA({
        measurements: r,
        outerSize: n,
        scrollOffset: i,
        lanes: a
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = pi(
      () => {
        let r = null, n = null;
        const i = this.calculateRange();
        return i && (r = i.startIndex, n = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, r, n]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          r,
          n
        ];
      },
      (r, n, i, a, s) => a === null || s === null ? [] : r({
        startIndex: a,
        endIndex: s,
        overscan: n,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, i = r.getAttribute(n);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, n) => {
      const i = this.indexFromElement(r), a = this.measurementsCache[i];
      if (!a)
        return;
      const s = a.key, o = this.elementsCache.get(s);
      o !== r && (o && this.observer.unobserve(o), this.observer.observe(r), this.elementsCache.set(s, r)), r.isConnected && this.resizeItem(i, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      const i = this.measurementsCache[r];
      if (!i)
        return;
      const a = this.itemSizeCache.get(i.key) ?? i.size, s = n - a;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(i, s, this) : i.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(i.index), this.itemSizeCache = new Map(this.itemSizeCache.set(i.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, i) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = pi(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (r, n) => {
        const i = [];
        for (let a = 0, s = r.length; a < s; a++) {
          const o = r[a], c = n[o];
          i.push(c);
        }
        return i;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return zu(
          n[Bw(
            0,
            n.length - 1,
            (i) => zu(n[i]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, n, i = 0) => {
      const a = this.getSize(), s = this.getScrollOffset();
      n === "auto" && (n = r >= s + a ? "end" : "start"), n === "center" ? r += (i - a) / 2 : n === "end" && (r -= a);
      const o = this.getTotalSize() - a;
      return Math.max(Math.min(o, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const i = this.measurementsCache[r];
      if (!i)
        return;
      const a = this.getSize(), s = this.getScrollOffset();
      if (n === "auto")
        if (i.end >= s + a - this.options.scrollPaddingEnd)
          n = "end";
        else if (i.start <= s + this.options.scrollPaddingStart)
          n = "start";
        else
          return [s, n];
      const o = n === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(o, n, i.size),
        n
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: n = "start", behavior: i } = {}) => {
      this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, n), {
        adjustments: void 0,
        behavior: i
      });
    }, this.scrollToIndex = (r, { align: n = "auto", behavior: i } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const a = this.getOffsetForIndex(r, n);
      if (!a) return;
      const [s, o] = a;
      this._scrollToOffset(s, { adjustments: void 0, behavior: i }), i !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [u] = zu(
            this.getOffsetForIndex(r, o)
          ), f = this.getScrollOffset();
          pA(u, f) || this.scrollToIndex(r, { align: o, behavior: i });
        } else
          this.scrollToIndex(r, { align: o, behavior: i });
      }));
    }, this.scrollBy = (r, { behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: n
      });
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let i;
      if (n.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0;
      else {
        const a = Array(this.options.lanes).fill(null);
        let s = n.length - 1;
        for (; s >= 0 && a.some((o) => o === null); ) {
          const o = n[s];
          a[o.lane] === null && (a[o.lane] = o.end), s--;
        }
        i = Math.max(...a.filter((o) => o !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: i
    }) => {
      this.options.scrollToFn(r, { behavior: i, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const Bw = (e, t, r, n) => {
  for (; e <= t; ) {
    const i = (e + t) / 2 | 0, a = r(i);
    if (a < n)
      e = i + 1;
    else if (a > n)
      t = i - 1;
    else
      return i;
  }
  return e > 0 ? e - 1 : 0;
};
function PA({
  measurements: e,
  outerSize: t,
  scrollOffset: r,
  lanes: n
}) {
  const i = e.length - 1, a = (c) => e[c].start;
  if (e.length <= n)
    return {
      startIndex: 0,
      endIndex: i
    };
  let s = Bw(
    0,
    i,
    a,
    r
  ), o = s;
  if (n === 1)
    for (; o < i && e[o].end < r + t; )
      o++;
  else if (n > 1) {
    const c = Array(n).fill(0);
    for (; o < i && c.some((f) => f < r + t); ) {
      const f = e[o];
      c[f.lane] = f.end, o++;
    }
    const u = Array(n).fill(r + t);
    for (; s >= 0 && u.some((f) => f >= r); ) {
      const f = e[s];
      u[f.lane] = f.start, s--;
    }
    s = Math.max(0, s - s % n), o = Math.min(i, o + (n - 1 - o % n));
  }
  return { startIndex: s, endIndex: o };
}
const dv = typeof document < "u" ? Va.useLayoutEffect : Va.useEffect;
function TA(e) {
  const t = Va.useReducer(() => ({}), {})[1], r = {
    ...e,
    onChange: (i, a) => {
      var s;
      a ? T0(t) : t(), (s = e.onChange) == null || s.call(e, i, a);
    }
  }, [n] = Va.useState(
    () => new CA(r)
  );
  return n.setOptions(r), dv(() => n._didMount(), []), dv(() => n._willUpdate()), n;
}
function fv(e) {
  return TA({
    observeElementRect: bA,
    observeElementOffset: SA,
    scrollToFn: IA,
    ...e
  });
}
const _A = "hyperdashboard-ActiveProfileIccidRenderer-module-O4KBKq-wrapper", EA = {
  wrapper: _A
}, OA = ({
  value: e,
  customProps: t
}) => {
  const { simDetailBaseUrl: r } = t, n = Ne(), i = cr({
    simDetailBaseUrl: r,
    orgId: n,
    simId: e.hologramSimId,
    subpage: Yn.profiles
  }), { sendAnalyticsEvent: a } = mt(), s = () => {
    a && a("ICCID", {
      activeProfileIccid: e.activeProfileIccid
    });
  };
  return e.activeProfileIccid ? i ? /* @__PURE__ */ l(
    Y,
    {
      className: EA.wrapper,
      variant: "tertiary",
      noPadding: !0,
      to: i,
      accessibleText: `${e.activeProfileIccid} - View profiles`,
      onClick: s,
      children: e.activeProfileIccid
    }
  ) : /* @__PURE__ */ l(Dt, {}) : /* @__PURE__ */ l(Dt, {});
}, NA = "hyperdashboard-ByteRenderer-module-WyM3eW-wrapper", DA = {
  wrapper: NA
}, xh = ({ value: e, columnValue: t }) => {
  const r = e[t], n = el();
  return typeof r != "number" || r === 0 ? /* @__PURE__ */ l(Dt, {}) : /* @__PURE__ */ l(
    et,
    {
      content: It(r, "bytes"),
      id: n,
      className: DA.wrapper,
      children: It(r, "short", "decimal")
    }
  );
}, RA = "hyperdashboard-DateRenderer-module-DEh6TW-wrapper", kA = {
  wrapper: RA
}, Fh = ({ value: e, columnValue: t }) => {
  const r = Jn(), n = e[t];
  return typeof n != "string" || n.length === 0 || n === "0101-01-01T00:00:00Z" ? /* @__PURE__ */ l(Dt, {}) : /* @__PURE__ */ l(et, { id: r, content: bt(n, "12hrlocal"), className: kA.wrapper, children: /* @__PURE__ */ l("span", { children: bt(n, "short") }) });
}, AA = "hyperdashboard-DeviceNameRenderer-module-u91I-q-wrapper", xA = {
  wrapper: AA
}, FA = ({
  value: e,
  customProps: t
}) => {
  const { simDetailBaseUrl: r } = t, n = Ne(), i = cr({ simDetailBaseUrl: r, orgId: n, simId: e.hologramSimId }), { sendAnalyticsEvent: a } = mt(), s = () => {
    a && a("SIM name", {
      deviceName: e.deviceName
    });
  };
  return !e.hologramSimId || !n ? e.deviceName ? e.deviceName : /* @__PURE__ */ l(Dt, {}) : i ? /* @__PURE__ */ l(
    Y,
    {
      variant: "tertiary",
      noPadding: !0,
      to: i,
      className: xA.wrapper,
      accessibleText: `${e.deviceName} details`,
      onClick: s,
      children: e.deviceName
    }
  ) : /* @__PURE__ */ l(Dt, {});
}, Pf = [
  "years",
  "months",
  "days",
  "hours",
  "minutes",
  "seconds"
], $A = /* @__PURE__ */ new Set(["days", "hours", "minutes", "seconds"]), MA = /* @__PURE__ */ new Set(["years", "months"]), $h = (e) => Object.fromEntries(
  Object.entries(e).filter(([, t]) => t > 0)
), LA = (e) => Ie.fromObject($h(e.toObject())), Gw = (e, t, r) => {
  const n = Pf.indexOf(t);
  return r === void 0 ? e : Pf.slice(n, n + r);
}, Qw = (e) => {
  const t = e.toObject(), r = Object.keys(t), n = r[r.length - 1];
  $A.has(n) ? t[n] = Math.ceil(t[n] ?? 0) : MA.has(n) && (t[n] = Math.floor(t[n] ?? 0));
  const i = Ie.fromObject(t).normalize().toObject();
  return Ie.fromObject($h(i));
}, va = (e, t, r, n) => {
  const i = e.shiftTo(...Gw(r, t, n));
  return LA(Qw(i));
}, gi = (e, t, r, n) => Qw(
  e.toDuration(Gw(t, r, n), {
    conversionAccuracy: "longterm"
  })
), jA = (e, t) => {
  const r = $h(e.toDuration(Pf).toObject()), n = Object.keys(r);
  if (n.length === 0)
    return Ie.fromMillis(0);
  if (e.toDuration("years").years >= 1)
    return gi(e, n, "years", t);
  const { days: i } = e.toDuration("days");
  if (i >= 90) {
    const o = gi(e, n, "months", t);
    return o.as("years") >= 1 ? va(o, "years", n, t) : o;
  }
  if (i >= 1) {
    const o = gi(e, n, "days", t);
    return o.as("days") >= 90 ? va(o, "months", n, t) : o;
  }
  const { minutes: a } = e.toDuration("minutes");
  if (a >= 90) {
    const o = gi(e, n, "hours", t);
    return o.as("days") >= 1 ? va(o, "days", n, t) : o;
  }
  if (a >= 1) {
    const o = gi(e, n, "minutes", t);
    return o.as("minutes") >= 90 ? va(o, "hours", n, t) : o;
  }
  const s = gi(e, n, "seconds", t);
  return s.as("minutes") >= 1 ? va(s, "minutes", n, t) : s;
}, Zw = ({ start: e, end: t, top: r, zone: n = "utc" }) => {
  if (!e)
    return;
  const i = it.defaultZone;
  it.defaultZone = n;
  const a = e, s = t ?? ve.now();
  if (a.zone.name !== s.zone.name)
    throw it.defaultZone = i, new Error(
      `Timezones must match: Start zone '${a.zone.name}' and end zone '${s.zone.name}' do not match.'`
    );
  const o = ct.fromDateTimes(a, s);
  if (!o.isValid)
    throw it.defaultZone = i, new Error("Invalid interval");
  const c = jA(o, r);
  return it.defaultZone = i, c;
}, Mh = (e) => {
  let t;
  try {
    t = Zw(e);
  } catch (r) {
    console.error(r);
  }
  if (t)
    return t.as("milliseconds") === 0 ? "Just now" : `${t.toHuman({ listStyle: "narrow" })} ago`;
}, WA = "hyperdashboard-DurationRenderer-module-_Wx3hW-popoverContent", UA = "hyperdashboard-DurationRenderer-module-_Wx3hW-wrapper", hv = {
  popoverContent: WA,
  wrapper: UA
}, VA = ({
  value: e,
  columnValue: t
}) => {
  const r = e[t], n = Jn();
  return typeof r != "string" || r.length === 0 || r === "0101-01-01T00:00:00Z" ? /* @__PURE__ */ l(Dt, {}) : /* @__PURE__ */ l(
    et,
    {
      id: n,
      content: /* @__PURE__ */ O("span", { className: hv.popoverContent, children: [
        bt(r),
        /* @__PURE__ */ l("br", {}),
        bt(r, "12hrlocal")
      ] }),
      className: hv.wrapper,
      children: Mh({ start: lr(r), top: 1 })
    }
  );
}, HA = ({ value: e }) => e.imei ? /* @__PURE__ */ l("div", { children: e.imei }) : /* @__PURE__ */ l(Dt, { text: "Not available" }), qA = ({ value: e }) => e.organizationName || e.organizationId ? /* @__PURE__ */ O("div", { children: [
  e.organizationName,
  " (",
  e.organizationId,
  ")"
] }) : /* @__PURE__ */ l(Dt, {}), zA = "hyperdashboard-SimStatusChip-module-Hdln3q-chip", BA = "hyperdashboard-SimStatusChip-module-Hdln3q-medium", mv = {
  chip: zA,
  medium: BA
}, Ol = ({
  networkState: e,
  className: t,
  size: r,
  popoverContent: n
}) => {
  const { statusInfo: i, isLoading: a, error: s } = $s(e), o = Jn();
  return a || s || !i?.status ? /* @__PURE__ */ l(Dt, {}) : /* @__PURE__ */ l(et, { id: o, content: n ?? i.tooltip, className: t, children: /* @__PURE__ */ l(
    en,
    {
      iconStart: i.icon ?? "StatusReady",
      colorVariant: i.colorVariant,
      className: J(mv.chip, r === "medium" && mv.medium),
      type: "interactive",
      size: r,
      children: i.status
    }
  ) });
}, GA = "hyperdashboard-SimStatusRenderer-module-ryi3qq-wrapper", QA = {
  wrapper: GA
}, ZA = ({
  value: e,
  customProps: { segmentName: t }
}) => {
  const { isSuperAdmin: r } = Be(), { filters: n, hasFilters: i } = vl({
    segmentName: t
  }), { deviceIdsWithOpenSessions: a } = Wn(
    n.organizationId,
    r && i || !!n.organizationId
  ), { networkStatusGroups: s } = ht(), o = V(() => e?.deviceId && a.has(e.deviceId) && !s?.deactivated?.includes(e.networkState) ? s?.predeployment?.includes(e.networkState) ? "TEST-CONNECTED" : "CONNECTED" : e?.networkState, [
    e?.deviceId,
    a,
    e?.networkState,
    s?.predeployment,
    s?.deactivated
  ]);
  return /* @__PURE__ */ l(Ol, { networkState: o, className: QA.wrapper });
}, oo = {
  name: "Checkbox",
  width: 36,
  value: "checkbox",
  nullsHigher: !1
}, Tn = {
  name: "Name",
  width: 240,
  value: "deviceName",
  renderer: FA,
  nullsHigher: !1
}, Bu = {
  name: "SIM status",
  width: 120,
  value: "networkState",
  nullsHigher: !1,
  renderer: ZA
}, lo = {
  name: "Enabled profile ICCID",
  width: 200,
  value: "activeProfileIccid",
  renderer: OA,
  nullsHigher: !1,
  numeric: !0
}, co = {
  name: "Last known IMEI",
  width: 140,
  value: "imei",
  renderer: HA,
  nullsHigher: !1,
  numeric: !0
}, YA = {
  name: "Device ID",
  width: 80,
  value: "deviceId",
  nullsHigher: !1,
  numeric: !0
}, Gu = {
  name: "Data plan",
  width: 260,
  value: "planName",
  nullsHigher: !1
}, pv = {
  name: "Deactivated date (UTC)",
  width: 120,
  value: "deactivationTime",
  rightAligned: !0,
  nullsHigher: !1,
  renderer: Fh,
  numeric: !0
}, gv = {
  name: "Activation date (UTC)",
  width: 120,
  value: "activationTime",
  rightAligned: !0,
  nullsHigher: !1,
  renderer: Fh,
  numeric: !0
}, KA = {
  name: "Test config",
  width: 120,
  value: "preflightExitBehavior",
  nullsHigher: !1
}, JA = {
  name: "Configuration",
  width: 120,
  value: "preflightExitBehavior",
  nullsHigher: !1
}, XA = {
  name: "Organization",
  width: 200,
  value: "organizationName",
  nullsHigher: !1,
  renderer: qA
}, uo = {
  name: "Profile name",
  width: 120,
  value: "profileName",
  nullsHigher: !1
}, _n = {
  name: "SIM ID",
  width: 80,
  value: "hologramSimId",
  nullsHigher: !1,
  numeric: !0
}, vi = {
  name: "Last closed session",
  width: 90,
  value: "mostRecentSession",
  nullsHigher: !1,
  renderer: VA,
  numeric: !0
}, vv = {
  name: "Data usage",
  width: 90,
  value: "billingPeriodUsage",
  nullsHigher: !1,
  rightAligned: !0,
  renderer: xh,
  numeric: !0
}, ex = {
  name: "Data usage",
  width: 90,
  value: "preflightUsage",
  nullsHigher: !1,
  rightAligned: !0,
  renderer: xh,
  numeric: !0
}, tx = {
  name: "Preflight usage",
  width: 90,
  value: "preflightUsage",
  nullsHigher: !1,
  rightAligned: !0,
  renderer: xh,
  numeric: !0
}, Qu = {
  name: "Target activation date",
  width: 120,
  value: "expectedActivationTime",
  nullsHigher: !0,
  renderer: Fh,
  numeric: !0
}, gr = (e, t) => ({
  property: e.value,
  ordering: t,
  nullsFirst: t === "asc" ? !e.nullsHigher : e.nullsHigher
}), Yw = ({ segmentName: e }) => V(() => {
  const t = /* @__PURE__ */ new Map();
  let r;
  switch (e) {
    case "active":
      [
        oo,
        Tn,
        Bu,
        vi,
        vv,
        lo,
        uo,
        co,
        _n,
        Gu,
        gv
      ].forEach((n) => {
        t.set(n.value, n);
      }), r = [
        gr(vi, "desc"),
        gr(Tn, "asc"),
        gr(_n, "desc")
      ];
      break;
    case "deactivated":
      [oo, Tn, lo, uo, co, _n].forEach(
        (n) => {
          t.set(n.value, n);
        }
      ), r = [
        gr(pv, "desc"),
        gr(Tn, "desc"),
        gr(_n, "desc")
      ];
      break;
    case "preflight":
      [
        oo,
        Tn,
        Bu,
        JA,
        vi,
        ex,
        Qu,
        Gu,
        lo,
        uo,
        co,
        _n
      ].forEach((n) => {
        t.set(n.value, n);
      }), r = [
        gr(vi, "desc"),
        gr(Qu, "desc"),
        gr(Tn, "asc"),
        gr(_n, "desc")
      ];
      break;
    // All
    default:
      [
        oo,
        Tn,
        XA,
        Bu,
        vi,
        vv,
        lo,
        uo,
        co,
        YA,
        _n,
        Gu,
        KA,
        tx,
        Qu,
        gv,
        pv
      ].forEach((n) => {
        t.set(n.value, n);
      }), r = [
        gr(vi, "desc"),
        gr(Tn, "asc"),
        gr(_n, "desc")
      ];
      break;
  }
  return {
    columnDefs: t,
    columnsAsRow: [...t.values()].reduce((n, i) => (n[i.value] = i.name, n), {}),
    defaultSort: r
  };
}, [e]), rx = "hyperdashboard-SimInventoryTable-module-9ID_TG-cellContent", nx = "hyperdashboard-SimInventoryTable-module-9ID_TG-cellLoading", ix = "hyperdashboard-SimInventoryTable-module-9ID_TG-checkboxCellContent", ax = "hyperdashboard-SimInventoryTable-module-9ID_TG-checkboxOuterCell", sx = "hyperdashboard-SimInventoryTable-module-9ID_TG-emptyWrapper", ox = "hyperdashboard-SimInventoryTable-module-9ID_TG-headerCellContent", lx = "hyperdashboard-SimInventoryTable-module-9ID_TG-headerOuterCell", cx = "hyperdashboard-SimInventoryTable-module-9ID_TG-headerRow", ux = "hyperdashboard-SimInventoryTable-module-9ID_TG-numeric", dx = "hyperdashboard-SimInventoryTable-module-9ID_TG-outerCell", fx = "hyperdashboard-SimInventoryTable-module-9ID_TG-rightAligned", hx = "hyperdashboard-SimInventoryTable-module-9ID_TG-row", mx = "hyperdashboard-SimInventoryTable-module-9ID_TG-scroller", px = "hyperdashboard-SimInventoryTable-module-9ID_TG-scrollWrapper", gx = "hyperdashboard-SimInventoryTable-module-9ID_TG-simInventory", yt = {
  cellContent: rx,
  cellLoading: nx,
  checkboxCellContent: ix,
  checkboxOuterCell: ax,
  emptyWrapper: sx,
  headerCellContent: ox,
  headerOuterCell: lx,
  headerRow: cx,
  numeric: ux,
  outerCell: dx,
  rightAligned: fx,
  row: hx,
  scroller: mx,
  scrollWrapper: px,
  simInventory: gx
}, vx = "hyperdashboard-LoaderCell-module-ddfACa-background", yx = "hyperdashboard-LoaderCell-module-ddfACa-noTranslate", bx = "hyperdashboard-LoaderCell-module-ddfACa-rightAligned", Sx = "hyperdashboard-LoaderCell-module-ddfACa-wrapper", fo = {
  background: vx,
  noTranslate: yx,
  rightAligned: bx,
  wrapper: Sx
}, Kw = ({
  rightAligned: e,
  noTranslate: t
}) => /* @__PURE__ */ l(
  "div",
  {
    className: J(
      fo.wrapper,
      e && fo.rightAligned,
      t && fo.noTranslate
    ),
    children: /* @__PURE__ */ l("div", { className: fo.background })
  }
), H3 = ({ children: e, analyticsContext: t }) => /* @__PURE__ */ l(dw.Provider, { value: t, children: e }), wx = () => $(async () => await ft({
  url: `${process.env.VITE_API_ROOT}/auth/sessiondestroy`,
  body: {}
}), []), Ix = (e) => {
  const t = new URLSearchParams({ limit: "1000", userid: `${e}` }), r = e ? `${process.env.VITE_API_ROOT}/organizations/?${t}` : null, { data: n, error: i, isLoading: a, mutate: s, isValidating: o } = je(r, Ze);
  return {
    organizations: V(() => n?.data ?? [], [n]),
    error: i,
    isLoading: a,
    mutate: s,
    isValidating: o
  };
}, Cx = {
  dedupingInterval: 6e4,
  focusThrottleInterval: 36e5,
  // Only check for new info every hour (or at refresh)
  loadingTimeout: 3e3,
  errorRetryInterval: 1e4,
  errorRetryCount: 3
}, q3 = ({ children: e }) => {
  const [t, r] = Z(!0), [n, i] = Z(), [a, s] = Z(!1), [o, c] = Z(!1), [u, f] = Z(void 0), [g, p] = Z(void 0), [d, h] = Z(void 0), v = tT(), b = rT(), m = wx(), S = !!n?.mfa && !t, {
    me: I,
    error: C,
    isLoading: T,
    isValidating: E,
    mutate: N
  } = jT({
    canLoad: t || !(o || a || S),
    config: {
      dedupingInterval: 6e4,
      focusThrottleInterval: 6e4,
      errorRetryInterval: 5e3,
      errorRetryCount: 0
    }
  }), { organizations: y, isLoading: w } = Ix(I.id), P = $(async () => {
    o || a || S || E || T || (t && C?.status === 403 || C?.status === 401 ? r(!1) : !t && !C && I?.id && r(!0));
  }, [
    t,
    T,
    o,
    a,
    I,
    S,
    C,
    E
  ]);
  Vi(P, 250);
  const _ = $(
    async (F, W, A = !1) => {
      c(!0), f(void 0);
      let M;
      try {
        M = await v(F, W), M?.success ? i({ ...M?.data, email: F, rememberMe: A }) : f("Invalid login attempt");
      } catch {
        f("Invalid login attempt");
      }
      !M?.data.mfa && M?.success && r(!0), c(!1);
    },
    [v]
  ), D = $(
    async (F) => {
      if (!n) {
        p("Stale login attempt");
        return;
      }
      const { email: W, email_id: A, rememberMe: M } = n;
      if (!A || A.length === 0 || !W || W.length === 0) {
        p("Stale login attempt");
        return;
      }
      let j = !1;
      p(void 0), c(!0);
      try {
        const B = await b(W, A, F, M ?? !1);
        B?.success ? (i(B?.data), j = !0) : B?.error ? typeof B.error == "string" ? p(B.error) : B.error.totpCode && p(B.error.totpCode) : p("Invalid login attempt");
      } catch (B) {
        p(`${B}`);
      }
      j && r(!0), c(!1);
    },
    [n, b]
  ), R = $(async () => {
    s(!0), h(void 0);
    try {
      await m();
    } catch (F) {
      h(`${F}`);
    }
    r(!1), i(void 0), s(!1), N();
  }, [m, N]), x = V(
    () => ({
      isAuthenticated: t,
      user: I,
      organizations: y,
      loadingUserDetails: T || w,
      showMfaModal: S,
      loggingIn: o,
      loggingOut: a,
      login: _,
      loginTotp: D,
      logout: R,
      loginResult: n,
      loginError: u,
      loginTotpError: g,
      logoutError: d,
      invalidate: N
    }),
    [
      t,
      w,
      T,
      o,
      a,
      _,
      u,
      n,
      D,
      g,
      R,
      d,
      I,
      N,
      y,
      S
    ]
  );
  return /* @__PURE__ */ l(fl, { value: Cx, children: /* @__PURE__ */ l(fw.Provider, { value: x, children: e }) });
}, z3 = ({
  children: e,
  legacyDashboardContext: t
}) => /* @__PURE__ */ l(mw.Provider, { value: t, children: e }), Px = ({ children: e, organizationId: t }) => /* @__PURE__ */ l(hw.Provider, { value: t, children: e }), yv = "simDetails", Tx = 4, B3 = bh()(
  Th(
    _h(
      Ph(
        (e) => ({
          reset: () => e(() => {
          }, !1, { type: "simDetails/reset" })
        }),
        {
          name: yv,
          enabled: (process.env.VITE_ENV_NAME ?? "development") === "development"
        }
      )
    ),
    {
      name: yv,
      version: Tx,
      migrate: (e, t) => (t < 4 && delete e.profileHistoryExpanded, e)
    }
  )
), _x = "hyperdashboard-SimInventoryTableCheckbox-module-5y7Mna-wrapper", Ex = {
  wrapper: _x
}, Ox = ({
  sim: e,
  segmentName: t,
  isHeader: r,
  allowToggle: n,
  onCheckboxToggled: i,
  onAllCheckboxToggled: a
}) => {
  const { all: s, sims: o } = Oh(t), c = $(
    (g) => {
      const { checked: p } = g.target;
      r ? a(p) : i(p, {
        hologramSimId: e.hologramSimId,
        claimed_device_id: e.deviceId
      });
    },
    [r, a, i, e.deviceId, e.hologramSimId]
  ), u = s === "checked" ? "Deselect all" : "Select all", f = /* @__PURE__ */ l(
    Rr,
    {
      className: Ex.wrapper,
      hiddenLabel: !0,
      label: r ? u : "Select SIM",
      title: r ? u : "Select SIM",
      defaultChecked: r ? s === "checked" : !!e.hologramSimId && o?.has(e.hologramSimId),
      onChange: c,
      indeterminate: r && s === "indeterminate",
      disabled: !n
    }
  );
  return r ? /* @__PURE__ */ l(et, { content: u, id: "select-deselect-all-checkbox", allowPinning: !1, children: f }) : f;
}, Nx = "hyperdashboard-SimInventoryTableHeaderCell-module-QmQHVa-headerText", Dx = "hyperdashboard-SimInventoryTableHeaderCell-module-QmQHVa-sortable", Rx = "hyperdashboard-SimInventoryTableHeaderCell-module-QmQHVa-sorted", kx = "hyperdashboard-SimInventoryTableHeaderCell-module-QmQHVa-sortIcon", Ax = "hyperdashboard-SimInventoryTableHeaderCell-module-QmQHVa-wrapper", yi = {
  headerText: Nx,
  sortable: Dx,
  sorted: Rx,
  sortIcon: kx,
  wrapper: Ax
}, Jw = ["testConfig", "configuration"], xx = [...Jw], bv = (e) => xx.includes(e) ? Jw.includes(e) ? ["preflightDuration", "preflightExitBehavior"] : [e] : [e], Fx = ({
  children: e,
  segmentName: t,
  columnValue: r
}) => {
  const { columnDefs: n } = Yw({ segmentName: t }), i = n.get(r), a = Rw(), s = V(() => bv(r), [r]), o = a.filter((b) => s.includes(b.property)), { sendAnalyticsEvent: c } = mt(), f = o[0]?.ordering, g = Ms((b) => b.setSort);
  let p;
  switch (f) {
    case "asc":
      p = "ArrowTriangleNorth";
      break;
    case "desc":
      p = "ArrowTriangleSouth";
      break;
    default:
      p = "ArrowTriangleNorthSouth";
      break;
  }
  const d = $(() => {
    let b;
    switch (f) {
      case "asc":
        b = i?.rightAligned ? void 0 : "desc";
        break;
      case "desc":
        b = i?.rightAligned ? "asc" : void 0;
        break;
      default:
        b = i?.rightAligned ? "desc" : "asc";
        break;
    }
    let m;
    switch (b) {
      case "asc":
        m = !i?.nullsHigher;
        break;
      case "desc":
        m = !!i?.nullsHigher;
        break;
      default:
        m = void 0;
        break;
    }
    const S = bv(r);
    g(b === void 0 ? void 0 : S.map((I) => ({
      property: I,
      ordering: b,
      nullsFirst: m
    }))), c && c(`Sort - ${e} ${b ?? "default"}`);
  }, [r, i, g, f, e, c]), h = $(() => {
    d();
  }, [d]), v = $(
    (b) => {
      (b.key === " " || b.key === "Enter") && d();
    },
    [d]
  );
  return i ? /* @__PURE__ */ O(
    "div",
    {
      className: J(yi.wrapper, yi.sortable, f && yi.sorted),
      onClick: h,
      onKeyUp: v,
      tabIndex: 0,
      role: "button",
      "aria-label": `${e} column`,
      id: `header-cell-${i.value}`,
      children: [
        i.rightAligned && /* @__PURE__ */ l(ye, { size: "small", name: p, className: yi.sortIcon, color: "currentColor" }),
        /* @__PURE__ */ l("div", { className: yi.headerText, children: e }),
        !i.rightAligned && /* @__PURE__ */ l(ye, { size: "small", name: p, className: yi.sortIcon, color: "currentColor" })
      ]
    }
  ) : null;
}, $x = ({
  sim: e,
  segmentName: t,
  ColumnRenderer: r,
  isHeader: n,
  customRendererProps: i,
  columnValue: a,
  allowToggle: s,
  onCheckboxToggled: o,
  onAllCheckboxToggled: c
}) => {
  const u = a !== "checkbox" ? e[a] : void 0;
  return a === "checkbox" ? /* @__PURE__ */ l(
    Ox,
    {
      isHeader: n,
      sim: e,
      segmentName: t,
      allowToggle: s,
      onCheckboxToggled: o,
      onAllCheckboxToggled: c
    }
  ) : n ? /* @__PURE__ */ l(Fx, { segmentName: t, columnValue: a, children: u }) : r ? /* @__PURE__ */ l(
    r,
    {
      value: e,
      columnValue: a,
      customProps: { ...i, isHeader: n }
    }
  ) : typeof u == "string" ? u.length === 0 ? /* @__PURE__ */ l(Dt, {}) : u : zr(u) ? (process.env.VITE_ENV_NAME === "development" && console.error({
    error: "An array value should be rendered with a custom cell renderer.",
    value: u
  }), /* @__PURE__ */ l(Dt, {})) : u ?? /* @__PURE__ */ l(Dt, {});
}, Mx = ({
  sim: e,
  segmentName: t,
  measureElement: r,
  ColumnRenderer: n,
  customRendererProps: i,
  columnValue: a,
  isHeader: s,
  allowToggle: o,
  onCheckboxToggled: c,
  onAllCheckboxToggled: u,
  rightAligned: f
}) => {
  const g = !e, p = a === "checkbox";
  return /* @__PURE__ */ l(
    "div",
    {
      ref: (
        // Don't measure the loading state
        g ? void 0 : (d) => {
          d && r(d, a);
        }
      ),
      className: J(
        s && !p ? yt.headerCellContent : yt.cellContent,
        g && yt.cellLoading,
        p && yt.checkboxCellContent
      ),
      title: `${a && a !== "checkbox" && !n && !g && e[a] ? e[a] : ""}`,
      children: g ? a !== "checkbox" && /* @__PURE__ */ l(Kw, { rightAligned: f }) : /* @__PURE__ */ l(
        $x,
        {
          sim: e,
          segmentName: t,
          ColumnRenderer: n,
          customRendererProps: i,
          isHeader: s,
          columnValue: a,
          allowToggle: o,
          onCheckboxToggled: c,
          onAllCheckboxToggled: u
        }
      )
    }
  );
}, Lx = Ub(
  Mx,
  (e, t) => e.segmentName === t.segmentName && e.allowToggle === t.allowToggle && e.onCheckboxToggled === t.onCheckboxToggled && e.onAllCheckboxToggled === t.onAllCheckboxToggled && e.customRendererProps === t.customRendererProps && e.columnValue === t.columnValue && (t.ColumnRenderer || t.columnValue === "checkbox" ? Wa(e.sim, t.sim) : (e.sim && e.sim[e.columnValue]) === (t.sim && t.sim[t.columnValue]))
), jx = Et(
  ({
    sim: e,
    segmentName: t,
    virtualRow: r,
    columnVirtualizer: n,
    columnItems: i,
    columnDefs: a,
    getColumnWidth: s,
    measureElement: o,
    isHeader: c = !1,
    customRendererProps: u,
    allowToggle: f,
    onCheckboxToggled: g,
    onAllCheckboxToggled: p
  }, d) => {
    const h = {
      height: `${r.size}px`,
      minWidth: `${n.getTotalSize()}px`
    };
    return c || (h.transform = `translateY(${r.start}px)`), /* @__PURE__ */ l(
      "div",
      {
        style: h,
        "data-index": r.index,
        className: J(!c && yt.row, c && yt.headerRow),
        ref: d,
        children: i.map((v) => {
          const {
            value: b,
            renderer: m,
            rightAligned: S,
            numeric: I
          } = [...a.values()][v.index];
          return /* @__PURE__ */ l(
            "div",
            {
              "data-index": v.index,
              ref: n.measureElement,
              style: {
                width: `${s(b)}px`,
                transform: `translateX(${v.start}px)`
              },
              className: J(
                c ? yt.headerOuterCell : yt.outerCell,
                S && yt.rightAligned,
                I && yt.numeric,
                v.index === 0 && yt.checkboxOuterCell
              ),
              children: /* @__PURE__ */ l(
                Lx,
                {
                  sim: e,
                  segmentName: t,
                  measureElement: o,
                  ColumnRenderer: m,
                  customRendererProps: u,
                  isHeader: c,
                  columnValue: b,
                  allowToggle: f,
                  onCheckboxToggled: g,
                  onAllCheckboxToggled: p,
                  rightAligned: S
                }
              )
            },
            v.key
          );
        })
      }
    );
  }
), Sv = Ub(
  jx,
  (e, t) => e.sim === void 0 && t.sim === void 0 || e.segmentName === t.segmentName && e.allowToggle === t.allowToggle && e.onCheckboxToggled === t.onCheckboxToggled && e.onAllCheckboxToggled === t.onAllCheckboxToggled && e.customRendererProps === t.customRendererProps && Wa(e.sim, t.sim) && Wa(e.columnItems, t.columnItems) && // TODO: Improve performance by only checking for changes to columnItem.start
  Wa(e.getColumnWidth, t.getColumnWidth)
), sr = 100, Wx = 10, Ux = 4, Vx = 41, Zu = 32, Hx = Et(
  ({
    segmentName: e,
    className: t,
    simDetailBaseUrl: r,
    handleLinkClick: n,
    onValidatingChange: i,
    activateButtonRenderer: a
  }, s) => {
    const [o, c] = Z(0), {
      filters: u,
      hasFilters: f,
      hasUserFilterApplied: g,
      filtersValidForAllSegment: p,
      error: d,
      isLoading: h
    } = vl({
      segmentName: e
    }), { resetFilters: v } = Ms((ot) => ot), b = we(null), m = we(null), { columnDefs: S, columnsAsRow: I, defaultSort: C } = Yw({ segmentName: e }), [T, E] = Z(C), N = nD({ defaultSort: C }), y = $(() => {
      E(N);
    }, [N]);
    Vi(y, 0);
    const { isSuperAdmin: w } = Be(), {
      error: P,
      isLoading: _,
      isValidating: D,
      mutate: R
    } = Wn(
      u.organizationId,
      w && f || !!u.organizationId
    ), x = f && (e !== "all" || p) && !d && !h, {
      count: F,
      error: W,
      isLoading: A,
      mutate: M,
      isValidating: j
    } = Sf(u, x), B = x && F > 0 && !A && !W, L = fv({
      count: F,
      getScrollElement: () => b.current,
      estimateSize: () => Vx,
      overscan: Wx
    }), H = $(
      () => [...S.values()].reduce((ot, at) => (ot[at.value] = {
        width: at.value === "checkbox" ? at.width : at.width + Zu,
        measured: !1
      }, ot), {}),
      [S]
    ), [q, te] = Z(H()), G = $(
      (ot) => (q && q[ot]?.width) ?? 0,
      [q]
    ), X = $(
      (ot) => {
        const at = [...S.values()], ir = at[ot].value;
        return q && ir in q ? q[ir].width : at[ot].width;
      },
      [S, q]
    ), re = $((ot, at) => {
      const ir = Math.ceil(ot?.getBoundingClientRect().width ?? 0);
      !ir || ir === 0 || at === "checkbox" || te((ar) => {
        const kl = ar && ar[at];
        if (!kl)
          return ar;
        const tm = kl.measured ? Math.max(ir + Zu, kl.width) : ir + Zu;
        if (tm === ar[at]?.width)
          return ar;
        const rm = structuredClone(ar);
        return rm[at] = { width: tm, measured: !0 }, rm;
      });
    }, []), oe = fv({
      horizontal: !0,
      count: S.size,
      getScrollElement: () => b.current,
      estimateSize: X,
      overscan: Ux
    }), ue = oe.getVirtualItems(), de = Math.floor((L.range?.startIndex ?? 0) / sr), Q = $(() => {
      c(de);
    }, [de]);
    Vi(Q, 500);
    const he = o * sr, {
      sims: ce,
      error: se,
      mutate: pe,
      isValidating: k,
      isLoading: z
    } = Jl({
      filters: {
        ...u,
        pagination: { offset: he, limit: sr }
      },
      sort: T,
      canLoad: e !== "all" || p
      // Always load the current page, except all which should wait for one of the min required filters
    }), {
      sims: U,
      error: ie,
      mutate: ae,
      isValidating: ne,
      isLoading: me
    } = Jl({
      filters: {
        ...u,
        pagination: {
          offset: F === -1 || F < sr ? -1 : he + sr,
          limit: sr
        }
      },
      sort: T,
      canLoad: B
    }), {
      sims: Te,
      error: Ce,
      mutate: Re,
      isValidating: xe,
      isLoading: _e
    } = Jl({
      filters: {
        ...u,
        pagination: { offset: F === -1 ? -1 : he - sr, limit: sr }
      },
      sort: T,
      canLoad: B
    }), { sims: $e, blockRender: jt } = V(() => o === de ? { sims: [...Te, ...ce, ...U], blockRender: !1 } : o - 1 === de ? {
      sims: [...new Array(sr), ...Te, ...ce],
      blockRender: !1
    } : o + 1 === de ? {
      sims: [...ce, ...U, ...new Array(sr)],
      blockRender: !1
    } : o - 2 === de ? { sims: [...U, ...new Array(sr * 2)], blockRender: !1 } : o + 2 === de ? { sims: [...new Array(sr * 2), ...Te], blockRender: !1 } : { sims: new Array(sr * 3), blockRender: !0 }, [de, ce, U, o, Te]), dr = W || se || ie || Ce || d || P;
    let Wt = null, nt = null;
    const fr = V(
      () => ({
        simDetailBaseUrl: r,
        handleLinkClick: n,
        segmentName: e
      }),
      [n, e, r]
    ), hr = $(() => {
      m.current && b.current && (m.current.style.transform = `translateX(-${b.current.scrollLeft}px)`);
    }, []), { sims: ai } = Oh(e), { addSelectedSim: aa, removeSelectedSim: si, setSelectedSims: oi, resetSelection: Vs } = Eh(), {
      simIds: Hs,
      isLoading: Se,
      error: Me,
      mutate: We,
      isValidating: ke
    } = uw({ filters: u, canLoad: x }), nr = $(
      (ot) => {
        if (ot) {
          const at = new Map(Hs);
          ai && ai.forEach((ir, ar) => {
            at.set(ar, ir);
          }), oi(e, at, "checked");
        } else
          Vs(e);
      },
      [Hs, ai, Vs, e, oi]
    ), sa = $(
      (ot, at) => {
        at && (ot ? aa(e, at) : si(e, at));
      },
      [aa, si, e]
    ), qs = x && !Se && !Me && !ke, Zr = $(() => {
      M(), pe(), ae(), Re(), We(), R(), i(!0);
    }, [
      pe,
      ae,
      R,
      Re,
      We,
      M,
      i
    ]), li = j || ne || xe || k || D, oa = A || h || jt;
    return Pe(() => {
      i(
        !(oa || z || me || _e || _) && li
      );
    }, [
      oa,
      li,
      z,
      me,
      _e,
      i,
      _
    ]), Kt(s, () => Zr, [Zr]), !A && F === 0 && f && g || W?.status === 404 || d?.status === 404 ? nt = /* @__PURE__ */ l(
      fe,
      {
        className: yt.emptyWrapper,
        icon: /* @__PURE__ */ l(ye, { name: "Search", size: "large", fill: "DdsColorTextDisabledOndefault" }),
        actions: /* @__PURE__ */ l(Y, { variant: "secondary", onClick: () => v(), children: "Reset filters" }),
        children: "No SIMs match the selected filters."
      }
    ) : e === "all" && !p ? nt = /* @__PURE__ */ l(fe, { icon: "Search", className: yt.emptyWrapper, children: "Enter an organization or ICCID to find SIMs" }) : !A && F === 0 ? e === "deactivated" ? nt = /* @__PURE__ */ l(
      fe,
      {
        className: yt.emptyWrapper,
        label: "No deactivated SIMs found",
        icon: /* @__PURE__ */ l(ye, { name: "StatusDeactivated", size: "large", fill: "DdsColorTextDisabledOndefault" }),
        children: "Deactivated SIMs will be listed here. These SIMs are no longer able to use data and cannot be reactivated."
      }
    ) : e === "preflight" ? nt = /* @__PURE__ */ l(
      fe,
      {
        className: yt.emptyWrapper,
        label: "Order SIMs to get started",
        icon: /* @__PURE__ */ l(ye, { name: "StatusTesting", size: "large", fill: "DdsColorTextDisabledOndefault" }),
        actions: /* @__PURE__ */ l(
          Y,
          {
            type: "button",
            variant: "secondary",
            iconEnd: "ExternalLink",
            href: "https://www.hologram.io/contact-sales/",
            target: "_blank",
            children: "Contact the Sales Team"
          }
        ),
        children: "After you have received SIMs set up with pre-deployment testing, they will show up here."
      }
    ) : e === "active" && (nt = /* @__PURE__ */ l(
      fe,
      {
        className: yt.emptyWrapper,
        label: "Activate SIMs to get started",
        icon: /* @__PURE__ */ l(ye, { name: "StatusActivating", size: "large", fill: "DdsColorTextDisabledOndefault" }),
        actions: a?.({
          children: "Activate your first SIMs",
          variant: "primary"
        }),
        children: "Your SIMs will show up here after activation."
      }
    )) : dr ? nt = /* @__PURE__ */ l(
      fe,
      {
        className: yt.emptyWrapper,
        variant: "error",
        label: "We ran into an issue loading your SIMs",
        actions: /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            iconStart: "Sync",
            onClick: () => {
              window.location.reload();
            },
            children: "Reload page"
          }
        ),
        children: "You can try to change your filters, or reload the page."
      }
    ) : f ? oa ? nt = /* @__PURE__ */ l("div", { className: yt.emptyWrapper, children: /* @__PURE__ */ l(ur, { children: "Loading matching SIMs..." }) }) : Wt = $e && L.getVirtualItems().map((ot) => /* @__PURE__ */ l(
      Sv,
      {
        sim: $e[ot.index + -(de - 1) * sr],
        segmentName: e,
        virtualRow: ot,
        columnVirtualizer: oe,
        columnItems: ue,
        columnDefs: S,
        getColumnWidth: G,
        measureElement: re,
        customRendererProps: fr,
        allowToggle: qs,
        onCheckboxToggled: sa,
        onAllCheckboxToggled: nr
      },
      `${ot.key}`
    )) : nt = /* @__PURE__ */ l(
      fe,
      {
        className: yt.emptyWrapper,
        icon: /* @__PURE__ */ l(ye, { name: "Search", size: "large" }),
        children: "Set filters to find SIMs"
      }
    ), /* @__PURE__ */ O("div", { className: J(yt.simInventory, t), children: [
      /* @__PURE__ */ l(
        Sv,
        {
          sim: I,
          segmentName: e,
          virtualRow: { start: 0, size: 33, index: 0, end: 33, key: "", lane: 0 },
          columnVirtualizer: oe,
          columnItems: ue,
          columnDefs: S,
          getColumnWidth: G,
          measureElement: re,
          isHeader: !0,
          ref: m,
          customRendererProps: fr,
          allowToggle: qs,
          onCheckboxToggled: sa,
          onAllCheckboxToggled: nr
        },
        "header-row"
      ),
      nt,
      /* @__PURE__ */ l("div", { ref: b, className: yt.scrollWrapper, onScroll: hr, children: /* @__PURE__ */ l(
        "div",
        {
          className: yt.scroller,
          style: {
            minWidth: `${oe.getTotalSize()}px`,
            height: `${L.getTotalSize()}px`
          },
          children: Wt
        }
      ) })
    ] });
  }
), qx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-eventColumn", zx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-eventField", Bx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-eventLabel", Gx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-eventTimestamp", Qx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-eventType", Zx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-eventValue", Yx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-numeric", Kx = "hyperdashboard-SimProfileHistoryPanel-module-UW3fAW-profileColumn", kt = {
  eventColumn: qx,
  eventField: zx,
  eventLabel: Bx,
  eventTimestamp: Gx,
  eventType: Qx,
  eventValue: Zx,
  numeric: Yx,
  profileColumn: Kx
}, Jx = ({ hologramSimId: e }) => {
  const { profileHistory: t, isLoading: r, error: n, isValidating: i } = cw(e), a = V(() => {
    if (n)
      return /* @__PURE__ */ l(
        fe,
        {
          variant: "error",
          label: "We ran into an issue loading your SIM profile history",
          actions: /* @__PURE__ */ l(
            Y,
            {
              variant: "secondary",
              iconStart: "Sync",
              onClick: () => {
                window.location.reload();
              },
              children: "Reload page"
            }
          ),
          children: "We will keep trying in the background or you can try to reload the page."
        }
      );
    if (r)
      return /* @__PURE__ */ l(fe, { children: "Loading..." });
    const s = [
      { children: "Event (UTC)", key: "Event (UTC)", width: 160 }
    ], o = t.map((c) => {
      if (!c?.profiles)
        return { key: "" };
      const { eventTime: u, lifecycleEvent: f, eventProfileId: g, profiles: p } = c, d = new Array(p.length + 1), h = `${g}-${f}-${u}`;
      d[0] = {
        key: h,
        children: /* @__PURE__ */ l("div", { className: kt.eventColumn, children: /* @__PURE__ */ l(
          ee,
          {
            labelClassName: kt.eventType,
            valueClassname: kt.eventTimestamp,
            label: f ?? "",
            value: bt(u, "table"),
            direction: "column"
          }
        ) })
      };
      for (let v = s.length; v < p.length + 1; v++) {
        const b = `Profile ${v}`;
        s.push({ key: b, children: b, width: 300 });
      }
      return p.forEach((v, b) => {
        const { profileName: m, iccid: S, simProfileId: I, apn: C } = v;
        d[b + 1] = {
          key: S ?? b.toString(),
          children: /* @__PURE__ */ O("div", { className: kt.profileColumn, children: [
            /* @__PURE__ */ l(
              ee,
              {
                className: kt.eventField,
                labelClassName: kt.eventLabel,
                valueClassname: kt.eventValue,
                label: "Profile name",
                value: m
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                className: kt.eventField,
                labelClassName: kt.eventLabel,
                valueClassname: J(kt.eventValue, kt.numeric),
                label: "ICCID",
                value: S
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                className: kt.eventField,
                labelClassName: kt.eventLabel,
                valueClassname: J(kt.eventValue, kt.numeric),
                label: "Link ID",
                value: I
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                className: kt.eventField,
                labelClassName: kt.eventLabel,
                valueClassname: kt.eventValue,
                label: "Required APN",
                value: C
              }
            )
          ] })
        };
      }), s.push({ key: `trailing-${c.eventTime}`, children: null }), { key: h, cells: d };
    });
    return /* @__PURE__ */ l(ei, { headers: s, rows: o });
  }, [n, r, t]);
  return /* @__PURE__ */ l(He, { header: "Profile history", noContentPadding: !0, isLoading: r || i, children: a });
}, Xx = "hyperdashboard-SimProfiles-module-cSUB8W-accentBar", e1 = "hyperdashboard-SimProfiles-module-cSUB8W-activeProfile", t1 = "hyperdashboard-SimProfiles-module-cSUB8W-apnBanner", r1 = "hyperdashboard-SimProfiles-module-cSUB8W-connectedIcon", n1 = "hyperdashboard-SimProfiles-module-cSUB8W-connectedProfile", i1 = "hyperdashboard-SimProfiles-module-cSUB8W-deactivatedSim", a1 = "hyperdashboard-SimProfiles-module-cSUB8W-diminished", s1 = "hyperdashboard-SimProfiles-module-cSUB8W-fallbackIcon", o1 = "hyperdashboard-SimProfiles-module-cSUB8W-footerWell", l1 = "hyperdashboard-SimProfiles-module-cSUB8W-highlightedProfileName", c1 = "hyperdashboard-SimProfiles-module-cSUB8W-numeric", u1 = "hyperdashboard-SimProfiles-module-cSUB8W-panel", d1 = "hyperdashboard-SimProfiles-module-cSUB8W-popover", f1 = "hyperdashboard-SimProfiles-module-cSUB8W-profileIcon", h1 = "hyperdashboard-SimProfiles-module-cSUB8W-profileId", m1 = "hyperdashboard-SimProfiles-module-cSUB8W-readyIcon", p1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfile", g1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileDescription", v1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileFields", y1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileHeader", b1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileHeaderText", S1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileInfo", w1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileTitle", I1 = "hyperdashboard-SimProfiles-module-cSUB8W-simProfileWell", C1 = "hyperdashboard-SimProfiles-module-cSUB8W-unavailableIcon", De = {
  accentBar: Xx,
  activeProfile: e1,
  apnBanner: t1,
  connectedIcon: r1,
  connectedProfile: n1,
  deactivatedSim: i1,
  diminished: a1,
  fallbackIcon: s1,
  footerWell: o1,
  highlightedProfileName: l1,
  numeric: c1,
  panel: u1,
  popover: d1,
  profileIcon: f1,
  profileId: h1,
  readyIcon: m1,
  simProfile: p1,
  simProfileDescription: g1,
  simProfileFields: v1,
  simProfileHeader: y1,
  simProfileHeaderText: b1,
  simProfileInfo: S1,
  simProfileTitle: w1,
  simProfileWell: I1,
  unavailableIcon: C1
}, wv = /* @__PURE__ */ new Map([
  ["ENABLED", "Enabled"],
  ["DISABLED", "Disabled"],
  ["ENABLE_PENDING", "Disabled, pending switch to enabled"],
  ["DISABLE_PENDING", "Enabled, pending switch to disabled"],
  ["DOWNLOADED", "Downloaded"]
]), P1 = ({
  simProfile: e,
  fallback: t,
  fallbackProtected: r,
  connected: n = !1,
  deactivated: i = !1,
  renderApnBanner: a,
  msisdn: s,
  simDetailBaseUrl: o,
  hologramSimId: c,
  simHasMultipleProfiles: u = !1
}) => {
  const {
    iccid: f,
    installationState: g,
    networkState: p,
    simProfileId: d,
    whenCreated: h,
    requiredApn: v,
    profileName: b,
    profileType: m
  } = e, { statusInfo: S } = $s(p), I = e?.installationState === "ENABLED";
  let C = /* @__PURE__ */ l(Dt, {});
  g && (wv.has(g) ? C = wv.get(g) : C = g);
  const { profileIcon: T, profileTitle: E, profileDescription: N } = V(() => {
    let _ = null, D = "", R = "";
    return I ? (R = "Your SIM will connect to this profile when using data.", n ? (D = "Connected using the active profile", _ = /* @__PURE__ */ l("div", { className: J(De.connectedIcon, De.profileIcon), children: /* @__PURE__ */ l(ye, { name: "StatusConnected", size: "medium" }) })) : (D = i ? "Last active profile" : "Active profile", _ = /* @__PURE__ */ l("div", { className: J(De.readyIcon, De.profileIcon), children: /* @__PURE__ */ l(ye, { name: n ? "StatusConnected" : "StatusReady", size: "medium" }) }))) : t && r ? (D = "You’re protected if you lose connection", R = "You can manually switch to this profile", _ = /* @__PURE__ */ l("div", { className: J(De.fallbackIcon, De.profileIcon), children: /* @__PURE__ */ l(ye, { name: "Shield", size: "medium" }) })) : (D = "This profile is installed but unavailable", R = "This SIM requires an over-the-air update via our support team to switch profiles.", _ = /* @__PURE__ */ l("div", { className: J(De.unavailableIcon, De.profileIcon), children: /* @__PURE__ */ l(ye, { name: "Close", size: "medium" }) })), { profileIcon: _, profileTitle: D, profileDescription: R };
  }, [t, r, I, n, i]), y = !I && !(t && r), w = Ne(), P = cr({
    simDetailBaseUrl: o,
    orgId: w,
    simId: c,
    subpage: Yn.coverage
  });
  return /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ O(
      "div",
      {
        className: J(
          De.simProfile,
          I && De.activeProfile,
          n && I && De.connectedProfile,
          i && De.deactivatedSim
        ),
        children: [
          /* @__PURE__ */ l("div", { className: De.accentBar }),
          /* @__PURE__ */ O("div", { className: De.simProfileHeader, children: [
            T,
            /* @__PURE__ */ O("div", { className: De.simProfileHeaderText, children: [
              /* @__PURE__ */ l("span", { className: J(De.simProfileTitle, y && De.diminished), children: E }),
              /* @__PURE__ */ l("span", { className: De.simProfileDescription, children: N })
            ] }),
            /* @__PURE__ */ l(
              Y,
              {
                variant: "tertiary",
                to: `${P}${u ? `?profile=${d}` : ""}`,
                iconEnd: "ArrowEastShort",
                children: "Coverage and rates"
              }
            )
          ] }),
          /* @__PURE__ */ O("div", { className: De.simProfileInfo, children: [
            /* @__PURE__ */ O("div", { className: De.simProfileFields, children: [
              /* @__PURE__ */ l(
                ee,
                {
                  label: "Profile name",
                  valueClassname: J(y && De.diminished),
                  value: /* @__PURE__ */ l(
                    "span",
                    {
                      className: J(
                        (t && r || I) && De.highlightedProfileName
                      ),
                      children: b
                    }
                  )
                }
              ),
              /* @__PURE__ */ l(
                ee,
                {
                  label: "Required APN",
                  valueClassname: J(y && De.diminished),
                  value: v ? /* @__PURE__ */ l(dh, { profiles: [e], placement: "top" }) : null
                }
              ),
              /* @__PURE__ */ l(
                ee,
                {
                  label: "Network status",
                  valueClassname: J(y && De.diminished),
                  value: S?.status ?? /* @__PURE__ */ l(Dt, {})
                }
              ),
              /* @__PURE__ */ l(
                ee,
                {
                  label: "Profile/Link ID",
                  valueClassname: J(y && De.diminished, De.numeric),
                  value: /* @__PURE__ */ O("div", { className: J(De.profileId, De.numeric), children: [
                    /* @__PURE__ */ l("span", { children: d }),
                    /* @__PURE__ */ l(
                      et,
                      {
                        id: "profileId",
                        content: "Profile ID is referred to as “Link ID” in API calls.",
                        className: J(De.numeric, De.popover),
                        children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
                      }
                    )
                  ] })
                }
              )
            ] }),
            /* @__PURE__ */ O("div", { className: De.simProfileFields, children: [
              /* @__PURE__ */ l(
                ee,
                {
                  label: "ICCID",
                  valueClassname: J(y && De.diminished, De.numeric),
                  value: f
                }
              ),
              /* @__PURE__ */ l(ee, { label: "Profile status", value: C }),
              /* @__PURE__ */ l(
                ee,
                {
                  label: "Created",
                  valueClassname: J(y && De.diminished, De.numeric),
                  value: /* @__PURE__ */ l(
                    et,
                    {
                      id: "profile-created-time",
                      content: bt(h, "12hrlocal"),
                      className: De.popover,
                      children: /* @__PURE__ */ l("span", { children: bt(h, "24hrutc") })
                    }
                  )
                }
              ),
              /* @__PURE__ */ l(
                ee,
                {
                  label: "MSISDN",
                  valueClassname: J(y && De.diminished, De.numeric),
                  value: s
                }
              )
            ] })
          ] }),
          m === "BOOTSTRAP" && /* @__PURE__ */ l("div", { className: De.simProfileWell, children: "This is the ICCID printed on your SIM card. This bootstrap profile is permanently associated with this SIM." })
        ]
      }
    ),
    a && I && /* @__PURE__ */ O(ze, { variant: "reminder", className: De.apnBanner, children: [
      "Your SIM card has profiles that require different APNs. The device this SIM is in will need to switch APNs if the profile changes.",
      " ",
      /* @__PURE__ */ l(
        Ae,
        {
          href: "https://support.hologram.io/hc/en-us/articles/360035697853-How-do-I-set-the-APN-",
          target: "_blank",
          type: "inline",
          children: "Read about changing APNs."
        }
      )
    ] })
  ] });
}, T1 = ({ hologramSimId: e, simDetailBaseUrl: t }) => {
  const {
    simDetails: r,
    error: n,
    isLoading: i,
    isValidating: a
  } = Le(e), {
    simProfiles: s,
    error: o,
    isLoading: c,
    isValidating: u
  } = kr(e), {
    deviceDetails: f,
    isLoading: g,
    error: p
  } = Mt(e), { isSuperAdmin: d } = Be(), {
    error: h,
    isLoading: v,
    deviceIdsWithOpenSessions: b
  } = Wn(r.organizationId, d || !!r.organizationId), { networkStatusGroups: m, isLoading: S, error: I } = ht(), C = n || o || I || h || p, T = i || c || S || v || g, E = a || u, N = s?.length > 0 && !!r.fallbackInstalled, y = N && !!r.fallbackEnabled, w = !!r.networkStatus && !!m?.deactivated?.includes(r.networkStatus), P = V(() => {
    let R = !1, x;
    return s.forEach((F) => {
      F.requiredApn && !R && (x ? x.localeCompare(F.requiredApn) !== 0 && (R = !0) : x = F.requiredApn);
    }), R;
  }, [s]), { panelContents: _, footerWell: D } = V(() => {
    let R = null, x = null;
    const F = m?.deactivated?.includes(
      r.networkStatus
    );
    return C ? R = /* @__PURE__ */ l(
      fe,
      {
        variant: "error",
        label: "We ran into an issue loading SIM profiles",
        actions: /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            iconStart: "Sync",
            onClick: () => {
              window.location.reload();
            },
            children: "Reload page"
          }
        ),
        children: "We will keep trying in the background or you can try to reload the page."
      }
    ) : T ? R = /* @__PURE__ */ l(fe, { children: "Loading..." }) : (R = s.map((W) => /* @__PURE__ */ l(
      P1,
      {
        simProfile: W,
        fallback: N,
        fallbackProtected: y,
        connected: !!(f.claimedDeviceId && b.has(f.claimedDeviceId) && !m?.deactivated?.includes(r.networkStatus)),
        deactivated: F,
        renderApnBanner: P,
        msisdn: r.msisdn,
        simDetailBaseUrl: t,
        hologramSimId: e,
        simHasMultipleProfiles: s.length > 1
      },
      W.simProfileId
    )), !w && y && s.length >= 2 && (x = /* @__PURE__ */ O("div", { className: De.footerWell, children: [
      /* @__PURE__ */ l(ye, { name: "Shield", size: "medium" }),
      /* @__PURE__ */ O("p", { children: [
        "This SIM is protected from downtime with ",
        /* @__PURE__ */ l("strong", { children: "Outage Protection" }),
        ". If your SIM loses connection, it will try to reconnect for ",
        /* @__PURE__ */ l("strong", { children: "15 minutes" }),
        " before switching profiles."
      ] })
    ] }))), { panelContents: R, footerWell: x };
  }, [
    m?.deactivated,
    r.networkStatus,
    r.msisdn,
    C,
    T,
    s,
    w,
    y,
    N,
    f.claimedDeviceId,
    b,
    P,
    t,
    e
  ]);
  return /* @__PURE__ */ l(
    He,
    {
      header: s.length === 1 ? "Profile" : "Profiles",
      noContentPadding: !0,
      footer: D,
      footerVariant: "alternative",
      isLoading: T || E,
      children: /* @__PURE__ */ l("div", { className: De.panel, children: _ })
    }
  );
}, _1 = "hyperdashboard-SimProfileStatus-module-PqvWfW-active", E1 = "hyperdashboard-SimProfileStatus-module-PqvWfW-primary", O1 = "hyperdashboard-SimProfileStatus-module-PqvWfW-quarternary", N1 = "hyperdashboard-SimProfileStatus-module-PqvWfW-secondary", D1 = "hyperdashboard-SimProfileStatus-module-PqvWfW-tertiary", R1 = "hyperdashboard-SimProfileStatus-module-PqvWfW-wrapper", Yu = {
  active: _1,
  primary: E1,
  quarternary: O1,
  secondary: N1,
  tertiary: D1,
  wrapper: R1
}, G3 = ({
  tier: e,
  active: t = !1,
  fallback: r = !1,
  fallbackProtected: n = !1,
  className: i
}) => {
  let a, s;
  return t ? (s = "Connected using this profile", a = "CellTower") : e === "none" ? (s = "You are not protected if you lose connection.", a = "Warning") : r ? n ? (s = "You're protected if you lose connection", a = "Shield") : (s = "You are not protected if you lose connection", a = "Warning") : s = "Available but disabled", /* @__PURE__ */ O("div", { className: J(Yu.wrapper, t && Yu.active, e && Yu[e], i), children: [
    a && /* @__PURE__ */ l(ye, { name: a }),
    s
  ] });
}, ti = (e, t) => {
  const r = e ? `${process.env.VITE_API_ROOT}/devices/${e}?orgid=${t ?? ""}` : null, { data: n, error: i, isLoading: a, isValidating: s, mutate: o } = je(
    r,
    Ze
  );
  return {
    device: V(() => n?.data ?? {}, [n]),
    error: i,
    isLoading: a,
    isValidating: s,
    mutate: o
  };
}, k1 = ({
  listStyle: e = "narrow",
  ...t
}) => {
  let r;
  try {
    r = Zw(t);
  } catch (n) {
    console.error(n);
  }
  if (r)
    return r.toHuman({ listStyle: e });
}, A1 = "hyperdashboard-FieldWrapper-module-QlJgsa-indented", x1 = "hyperdashboard-FieldWrapper-module-QlJgsa-label", F1 = "hyperdashboard-FieldWrapper-module-QlJgsa-value", $1 = "hyperdashboard-FieldWrapper-module-QlJgsa-wrapper", ho = {
  indented: A1,
  label: x1,
  value: F1,
  wrapper: $1
}, bi = (e) => {
  const { label: t, value: r, indented: n, labelClassname: i } = e;
  return /* @__PURE__ */ O("div", { className: J(ho.wrapper, n && ho.indented), children: [
    /* @__PURE__ */ l("div", { className: J(ho.label, i), children: t }),
    /* @__PURE__ */ l("div", { className: ho.value, children: r })
  ] });
}, M1 = "hyperdashboard-IconWrapper-module-O6psCq-black", L1 = "hyperdashboard-IconWrapper-module-O6psCq-green", j1 = "hyperdashboard-IconWrapper-module-O6psCq-iconWrapper", W1 = "hyperdashboard-IconWrapper-module-O6psCq-iconWrapperSmall", U1 = "hyperdashboard-IconWrapper-module-O6psCq-lightpink", V1 = "hyperdashboard-IconWrapper-module-O6psCq-lime", H1 = "hyperdashboard-IconWrapper-module-O6psCq-pink", q1 = "hyperdashboard-IconWrapper-module-O6psCq-purple", z1 = "hyperdashboard-IconWrapper-module-O6psCq-teal", B1 = "hyperdashboard-IconWrapper-module-O6psCq-yellow", Ku = {
  black: M1,
  default: "hyperdashboard-IconWrapper-module-O6psCq-default",
  green: L1,
  iconWrapper: j1,
  iconWrapperSmall: W1,
  lightpink: U1,
  lime: V1,
  pink: H1,
  purple: q1,
  teal: z1,
  yellow: B1
}, ya = (e) => {
  const {
    size: t = "large",
    colorVariant: r = "default",
    iconName: n,
    elementRef: i,
    diminished: a = !1
  } = e;
  let s;
  return r === "black" ? s = "DdsColorTextPrimaryOninverse" : a && (s = "DdsColorTextDiminishedOndefault"), /* @__PURE__ */ l(
    "div",
    {
      className: J(
        Ku.iconWrapper,
        t === "small" && Ku.iconWrapperSmall,
        Ku[r]
      ),
      ref: i && i,
      children: /* @__PURE__ */ l(ye, { name: n, size: t === "small" ? "small" : void 0, fill: s })
    }
  );
}, G1 = "hyperdashboard-SimStatusPanel-module-yimuDW-black", Q1 = "hyperdashboard-SimStatusPanel-module-yimuDW-diminished", Z1 = "hyperdashboard-SimStatusPanel-module-yimuDW-endOpen", Y1 = "hyperdashboard-SimStatusPanel-module-yimuDW-green", K1 = "hyperdashboard-SimStatusPanel-module-yimuDW-lightpink", J1 = "hyperdashboard-SimStatusPanel-module-yimuDW-lime", X1 = "hyperdashboard-SimStatusPanel-module-yimuDW-line", eF = "hyperdashboard-SimStatusPanel-module-yimuDW-mapPlaceholder", tF = "hyperdashboard-SimStatusPanel-module-yimuDW-noSession", rF = "hyperdashboard-SimStatusPanel-module-yimuDW-numeric", nF = "hyperdashboard-SimStatusPanel-module-yimuDW-panelSection", iF = "hyperdashboard-SimStatusPanel-module-yimuDW-panelSectionAction", aF = "hyperdashboard-SimStatusPanel-module-yimuDW-panelSectionContent", sF = "hyperdashboard-SimStatusPanel-module-yimuDW-panelSectionContentWithLine", oF = "hyperdashboard-SimStatusPanel-module-yimuDW-pink", lF = "hyperdashboard-SimStatusPanel-module-yimuDW-purple", cF = "hyperdashboard-SimStatusPanel-module-yimuDW-recentLoadingText", uF = "hyperdashboard-SimStatusPanel-module-yimuDW-simStatusValue", dF = "hyperdashboard-SimStatusPanel-module-yimuDW-teal", fF = "hyperdashboard-SimStatusPanel-module-yimuDW-unknownCellTower", hF = "hyperdashboard-SimStatusPanel-module-yimuDW-wrapper", mF = "hyperdashboard-SimStatusPanel-module-yimuDW-yellow", Ke = {
  black: G1,
  default: "hyperdashboard-SimStatusPanel-module-yimuDW-default",
  diminished: Q1,
  endOpen: Z1,
  green: Y1,
  lightpink: K1,
  lime: J1,
  line: X1,
  mapPlaceholder: eF,
  noSession: tF,
  numeric: rF,
  panelSection: nF,
  panelSectionAction: iF,
  panelSectionContent: aF,
  panelSectionContentWithLine: sF,
  pink: oF,
  purple: lF,
  recentLoadingText: cF,
  simStatusValue: uF,
  teal: dF,
  unknownCellTower: fF,
  wrapper: hF,
  yellow: mF
}, pF = u0(() => import("./mapbox.js")), gF = ({ hologramSimId: e }) => {
  const {
    mostRecentSession: t,
    error: r,
    isLoading: n
  } = ks(e), {
    simDetails: i,
    error: a,
    isLoading: s
  } = Le(e), {
    simProfiles: o,
    error: c,
    isLoading: u
  } = kr(e), f = we(null), g = we(null), p = we(null), [d, h] = Z(0);
  Pe(() => {
    const L = () => {
      p.current && f.current && g.current && (p.current.style.top = `${f.current.offsetTop + f.current.offsetHeight / 2}px`, p.current.style.left = `${f.current.offsetLeft + f.current.clientWidth / 2 - 1}px`, h(g.current.offsetTop - f.current.offsetTop));
    };
    return window.addEventListener("resize", L), L(), () => window.removeEventListener("resize", L);
  });
  const {
    deviceDetails: v,
    isLoading: b,
    error: m
  } = Mt(e), {
    device: S,
    error: I,
    isLoading: C
  } = ti(
    i.organizationId && v.claimedDeviceId ? v.claimedDeviceId : void 0,
    i.organizationId
  ), { isSuperAdmin: T } = Be(), {
    error: E,
    isLoading: N,
    deviceIdsWithOpenSessions: y
  } = Wn(i.organizationId, T || !!i.organizationId), { networkStatusGroups: w } = ht(), P = V(() => v.claimedDeviceId && y.has(v.claimedDeviceId) && !w?.deactivated?.includes(i.networkStatus) ? w?.predeployment?.includes(i.networkStatus) ? "TEST-CONNECTED" : "CONNECTED" : i.networkStatus, [
    v.claimedDeviceId,
    y,
    i.networkStatus,
    w?.predeployment,
    w?.deactivated
  ]), _ = V(() => {
    if (P?.includes("CONNECTED") && S.lastsession && S.lastsession.active) {
      const L = S.lastsession;
      return {
        bytes: L.bytes,
        cellTowerId: L.cellid ? parseInt(L.cellid, 10) : -1,
        isReportingWindowWithUsage: L.is_reporting_window_with_usage ? parseInt(L.is_reporting_window_with_usage, 10) : 0,
        latitude: `${L.latitude}`,
        longitude: `${L.longitude}`,
        network: L.network_name,
        country: "",
        hologramSimId: e,
        sessionId: 12345,
        // Fake number to make it appear
        rat: L.radio_access_technology,
        // E.g. "2024-12-01 09:45:44". Whereas most recent session expects 2024-10-17T20:57:29Z
        startTime: L.session_begin ? ve.fromFormat(L.session_begin, "yyyy-MM-dd HH:mm:ss", {
          zone: "utc"
        }).toISO() ?? void 0 : void 0,
        lac: L.lac,
        simProfileId: L.linkid ? parseInt(L.linkid, 10) : -1,
        tadig: L.tadig
      };
    }
    return t;
  }, [S.lastsession, e, t, P]), { statusInfo: D } = $s(P), { releaseFlags: R } = Be(), x = !R.has(Ht.HIDE_TOWER_LOCATIONS);
  let F;
  const W = _.cellTowerId === -1, A = r || a || c || m || I || E, M = n || s || u || b || C || N;
  if (A)
    F = /* @__PURE__ */ l(
      bi,
      {
        label: "",
        value: /* @__PURE__ */ l(tn, { variant: "system-error", children: "Failed to load most recent session for this SIM." }),
        indented: !0
      }
    );
  else {
    let L, H, q, te, G, X;
    if (M)
      G = /* @__PURE__ */ l("div", { className: Ke.recentLoadingText, children: "Finding last session..." });
    else {
      L = _?.sessionId && /* @__PURE__ */ l(
        ee,
        {
          label: P?.includes("CONNECTED") ? "Session opened" : "Last seen",
          value: /* @__PURE__ */ l("strong", { children: Mh({
            start: lr(
              P?.includes("CONNECTED") ? _.startTime : _.endTime
            ),
            top: 2
          }) })
        }
      );
      let re;
      P?.includes("CONNECTED") ? _?.isReportingWindowWithUsage ? re = "Reporting window open" : re = "Connected" : re = /* @__PURE__ */ l(
        et,
        {
          id: "session-end-time",
          className: Ke.numeric,
          content: bt(_.endTime, "12hrlocal"),
          children: /* @__PURE__ */ l("span", { className: Ke.numeric, children: bt(_.endTime, "24hrutc") })
        }
      ), H = _?.sessionId && /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          ee,
          {
            label: "Data usage",
            valueClassname: Ke.numeric,
            value: It(_.bytes, "long", "decimal")
          }
        ),
        !!_?.isReportingWindowWithUsage && /* @__PURE__ */ l(ee, { label: "Type", value: "Reporting window" }),
        /* @__PURE__ */ l(
          ee,
          {
            label: "Session start",
            value: /* @__PURE__ */ l(
              et,
              {
                id: "session-start-time",
                className: Ke.numeric,
                content: bt(_.startTime, "12hrlocal"),
                children: /* @__PURE__ */ l("span", { className: Ke.numeric, children: bt(_.startTime, "24hrutc") })
              }
            )
          }
        ),
        /* @__PURE__ */ l(
          ee,
          {
            label: "Session end",
            valueClassname: J(
              P?.includes("CONNECTED") ? Ke.endOpen : Ke.numeric
            ),
            value: re
          }
        ),
        /* @__PURE__ */ l(
          ee,
          {
            label: "Session duration",
            valueClassname: Ke.numeric,
            value: k1({
              start: lr(_.startTime),
              end: lr(_.endTime),
              top: 2
            })
          }
        )
      ] }), q = _?.sessionId && /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(ee, { label: "Network", value: _.network }),
        /* @__PURE__ */ l(ee, { label: "RAT", value: _.rat })
      ] }), _.sessionId && (_.country ? X = /* @__PURE__ */ O(le, { children: [
        _.country,
        W && /* @__PURE__ */ O(le, { children: [
          " ",
          /* @__PURE__ */ l("span", { className: Ke.unknownCellTower, children: "(location not available for this session)" })
        ] })
      ] }) : P?.includes("CONNECTED") ? X = /* @__PURE__ */ l("span", { className: Ke.unknownCellTower, children: "Available after session close" }) : X = /* @__PURE__ */ l("span", { className: Ke.unknownCellTower, children: "Location not available" })), te = _?.sessionId && /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(ee, { label: "Country", value: X }),
        x && !W && _.latitude && _.longitude && /* @__PURE__ */ l(
          ee,
          {
            label: "Tower location",
            valueClassname: Ke.numeric,
            value: /* @__PURE__ */ l(
              Ae,
              {
                href: `https://www.google.com/maps/search/?api=1&query=${_.latitude}%2C${_.longitude}`,
                target: "_blank",
                rel: "nofollow noopener noreferrer",
                type: "inline",
                children: `${_.latitude} ${_.longitude}`
              }
            )
          }
        ),
        x && !W && /* @__PURE__ */ l(
          ee,
          {
            label: "Cell tower ID",
            valueClassname: J(
              _.cellTowerId === 0 && Ke.unknownCellTower,
              Ke.numeric
            ),
            value: _.cellTowerId === 0 ? "Unknown" : _.cellTowerId?.toString()
          }
        )
      ] });
    }
    F = /* @__PURE__ */ O(le, { children: [
      G,
      /* @__PURE__ */ l(
        bi,
        {
          label: /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ya,
              {
                elementRef: f,
                iconName: P?.includes("CONNECTED") ? "StatusConnected" : "Cloud",
                colorVariant: P?.includes("CONNECTED") ? D?.colorVariant : void 0,
                diminished: !L
              }
            ),
            P?.includes("CONNECTED") ? "Connected" : "Last connection"
          ] }),
          labelClassname: L ? void 0 : Ke.diminished,
          value: L || /* @__PURE__ */ l("div", { className: Ke.noSession, children: "No session data shared yet." })
        }
      ),
      /* @__PURE__ */ l(
        bi,
        {
          label: /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ya,
              {
                iconName: "CloudDataTransfer",
                colorVariant: P?.includes("CONNECTED") ? D?.colorVariant : void 0,
                diminished: !H
              }
            ),
            P?.includes("CONNECTED") ? "Open session" : "Last session"
          ] }),
          labelClassname: H ? void 0 : Ke.diminished,
          value: H
        }
      ),
      /* @__PURE__ */ l(
        bi,
        {
          label: /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ya,
              {
                iconName: "CellTower",
                colorVariant: P?.includes("CONNECTED") ? D?.colorVariant : void 0,
                diminished: !te
              }
            ),
            "Local tower"
          ] }),
          labelClassname: te ? void 0 : Ke.diminished,
          value: te
        }
      ),
      /* @__PURE__ */ l(
        bi,
        {
          label: /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ya,
              {
                iconName: "Compass",
                colorVariant: P?.includes("CONNECTED") ? D?.colorVariant : void 0,
                diminished: !q
              }
            ),
            "Network"
          ] }),
          labelClassname: q ? void 0 : Ke.diminished,
          value: q
        }
      ),
      /* @__PURE__ */ l(
        bi,
        {
          label: /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ya,
              {
                elementRef: g,
                iconName: "Network",
                colorVariant: P?.includes("CONNECTED") ? D?.colorVariant : void 0
              }
            ),
            "Mobile core operator"
          ] }),
          value: /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(ee, { label: "Required device APN", value: /* @__PURE__ */ l(dh, { profiles: o }) }),
            L && /* @__PURE__ */ l(
              ee,
              {
                label: "Profile name",
                value: o.find((re) => re.simProfileId === _.simProfileId)?.profileName
              }
            )
          ] })
        }
      )
    ] });
  }
  const j = Cp(_?.longitude), B = Cp(_?.latitude);
  return /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ O("div", { className: J(Ke.panelSectionContent, Ke.panelSectionContentWithLine), children: [
      /* @__PURE__ */ l(
        "svg",
        {
          ref: p,
          className: J(
            Ke.line,
            P?.includes("CONNECTED") ? Ke[D?.colorVariant] : Ke.default
          ),
          xmlns: "http://www.w3.org/2000/svg",
          width: "2",
          height: d,
          viewBox: `0 0 2 ${d}`,
          fill: "none",
          strokeDasharray: "3 3",
          strokeWidth: "1.5",
          children: /* @__PURE__ */ l("path", { d: `M1,0 L 1,${d}` })
        }
      ),
      F
    ] }),
    /* @__PURE__ */ l("div", { className: Ke.panelSectionAction, children: x && !M && !A && _?.sessionId && (!W && B && j ? /* @__PURE__ */ l(
      d0,
      {
        fallback: /* @__PURE__ */ l(fe, { className: Ke.mapPlaceholder, children: "Loading..." }),
        children: /* @__PURE__ */ l(pF, { zoom: 10, height: 240, width: 240, lat: B, long: j })
      }
    ) : /* @__PURE__ */ l(fe, { className: Ke.mapPlaceholder, children: i.profileName?.includes("USA-2") ? "Location data is not available for this network." : "Location data is not available for this session." })) })
  ] });
}, vF = ({ hologramSimId: e, simDetailBaseUrl: t }) => {
  const {
    simDetails: r,
    error: n,
    isLoading: i
  } = Le(e), { isLoading: a, error: s } = ks(e), o = Ne(), c = cr({ simDetailBaseUrl: t, orgId: o, simId: e }), u = n || s, f = i || a;
  let g;
  u ? g = /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading your SIM",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : f ? g = /* @__PURE__ */ l(fe, { children: "Loading..." }) : g = /* @__PURE__ */ l("div", { className: Ke.panelSection, children: /* @__PURE__ */ l(gF, { hologramSimId: e }) });
  const { releaseFlags: p } = Be(), d = p?.has(Ht.HIDE_TOWER_LOCATIONS) ? void 0 : " Cell tower location is an approximate crowd-sourced location based on the last session.";
  return /* @__PURE__ */ l(
    He,
    {
      header: "Last connection",
      headerActions: /* @__PURE__ */ l(Y, { variant: "tertiary", iconEnd: "ArrowEastShort", to: `${c}/usage`, noPadding: !0, children: "Session history" }),
      noContentPadding: !0,
      footer: r.profileName?.includes("USA-2") ? `Session and status data for the enabled profile is reported at most every 2 hours.${d ?? ""}` : d,
      footerVariant: "alternative",
      className: Ke.wrapper,
      isLoading: f,
      children: g
    }
  );
}, yF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-content", bF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-header", SF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-helpText", wF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-iccid", IF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-iconEast", CF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-pending", PF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-profileContent", TF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-profileName", _F = "hyperdashboard-SimSwitchProfiles-module-MonnAq-profiles", EF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-toDisable", OF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-toEnable", NF = "hyperdashboard-SimSwitchProfiles-module-MonnAq-wrapper", Vt = {
  content: yF,
  header: bF,
  helpText: SF,
  iccid: wF,
  iconEast: IF,
  pending: CF,
  profileContent: PF,
  profileName: TF,
  profiles: _F,
  toDisable: EF,
  toEnable: OF,
  wrapper: NF
}, DF = ({
  options: e,
  onProfileChange: t,
  pendingAction: r,
  selectedProfile: n,
  toDisableProfile: i,
  otherProfiles: a,
  loading: s
}) => /* @__PURE__ */ O("div", { className: Vt.profiles, children: [
  /* @__PURE__ */ O("div", { className: Vt.toDisable, children: [
    /* @__PURE__ */ l("div", { className: Vt.header, children: "Profile to disable" }),
    /* @__PURE__ */ O("div", { className: Vt.profileContent, children: [
      i?.profileName && /* @__PURE__ */ l("div", { className: Vt.profileName, children: i?.profileName }),
      /* @__PURE__ */ l("div", { className: Vt.iccid, children: i?.iccid }),
      r && /* @__PURE__ */ O("div", { className: Vt.pending, children: [
        /* @__PURE__ */ l(ye, { size: "small", name: "Warning", fill: "DdsColorFillNotificationCaution" }),
        "Pending disable"
      ] })
    ] })
  ] }),
  /* @__PURE__ */ l(
    ye,
    {
      name: "ArrowEastLong",
      fill: "DdsColorPaletteGrey60",
      className: Vt.iconEast,
      size: "medium"
    }
  ),
  /* @__PURE__ */ O("div", { className: Vt.toEnable, children: [
    /* @__PURE__ */ l("div", { className: Vt.header, children: "Profile to enable" }),
    /* @__PURE__ */ O("div", { className: Vt.profileContent, children: [
      a.length > 1 && !r ? /* @__PURE__ */ l(
        Zf,
        {
          id: "ProfileSelect",
          options: e,
          inputProps: { onChange: t },
          defaultValue: n?.simProfileId?.toString(),
          disabled: s
        }
      ) : n?.profileName && /* @__PURE__ */ l("div", { className: Vt.profileName, children: n?.profileName }),
      /* @__PURE__ */ l("div", { className: Vt.iccid, children: n?.iccid }),
      r && /* @__PURE__ */ O("div", { className: Vt.pending, children: [
        /* @__PURE__ */ l(ye, { size: "small", name: "Warning", fill: "DdsColorFillNotificationCaution" }),
        "Pending enable"
      ] })
    ] })
  ] })
] }), RF = (e) => {
  switch (e) {
    case "Profile is not downloaded":
      return "The profile you are trying to enable is not available on this SIM. If the target profile was installed recently, the installation may not be complete. If this error persists, please contact support.";
    case "SIM already has a different operation queued":
      return "Unable to switch profiles at this time. Another eUICC operation is already queued for this SIM. If this error persists, please contact support.";
    default:
      return "Unable to switch profiles at this time. Another eUICC operation may be queued or we may be experiencing system issues. If this error persists, please contact support.";
  }
}, kF = Et(
  ({ sims: e, onProcessing: t, onDone: r }, n) => {
    const i = e.size >= 1 ? [...e.keys()][0] : void 0, {
      simProfiles: a,
      isLoading: s,
      error: o
    } = kr(i), { deviceOverview: c } = ch(i), { toDisableProfile: u, otherProfiles: f, pendingAction: g } = V(() => {
      const w = a.find((D) => D.installationState === "ENABLED"), P = !!a.find(
        (D) => D.installationState?.includes("PENDING")
      ), _ = a.filter(
        (D) => D.simProfileId !== w?.simProfileId
      );
      return {
        toDisableProfile: w,
        otherProfiles: P ? [
          a.find((D) => D.installationState === "ENABLE_PENDING") ?? _[0]
        ] : _,
        pendingAction: P
      };
    }, [a]), [p, d] = Z(void 0);
    Pe(() => {
      f.length === 0 || p || d(f[0]);
    }, [f, p]);
    const h = $(
      (w) => {
        const P = f.find(
          (_) => _.simProfileId?.toString() === w.target.value
        );
        d(P);
      },
      [f]
    ), [v, b] = Z(), m = WT({
      hologramSimId: i,
      simProfileId: p?.simProfileId
    }), [S, I] = Z(!1), C = o?.message || v, T = s;
    Pe(() => {
      t(T || S);
    }, [S, T, t]), Pe(() => {
      a.length < 2 ? b("SIM is not eligible for profile switch.") : g && b(
        "This SIM is already waiting on a profile switch. Requesting more profile switch actions may cause unexpected configuration and connectivity issues."
      );
    }, [g, a]);
    const E = $(async () => {
      if (!i) {
        b("No selected SIM");
        return;
      }
      I(!0);
      try {
        await m(), r(
          [...e.keys()].map((w) => ({
            hologramSimId: w,
            newProfileName: p?.profileName ?? "",
            deviceName: c.deviceName ?? ""
          }))
        );
      } catch (w) {
        if (typeof w == "string")
          b(w);
        else if (w.info) {
          const P = w.info;
          b(`An error occurred: ${RF(P.message)}`), console.error(w);
        } else
          b(`An error occurred: ${w ?? "Unknown"}`), console.error(w);
      }
      I(!1);
    }, [i, m, r, e, p, c]);
    Kt(
      n,
      () => ({
        onSubmit: E
      }),
      [E]
    ), Pe(() => {
      C && r(void 0, C);
    }, [C, r]);
    const N = V(
      () => f.filter((w) => w.simProfileId && (w.profileName || w.iccid)).map((w) => ({
        value: w.simProfileId?.toString(),
        label: w.profileName ?? w.iccid
      })),
      [f]
    );
    let y;
    return T ? y = /* @__PURE__ */ l(ur, { children: "Checking selected SIMs..." }) : y = /* @__PURE__ */ O("div", { className: Vt.content, children: [
      C && /* @__PURE__ */ l(ze, { variant: "error", children: C }),
      /* @__PURE__ */ O("div", { className: Vt.helpText, children: [
        /* @__PURE__ */ l("p", { children: "Switching SIM profiles will change network providers, changing the carriers and coverage available to your device." }),
        /* @__PURE__ */ O("ul", { children: [
          /* @__PURE__ */ l("li", { children: "Profile changes take effect the next time the SIM connects to a network." }),
          /* @__PURE__ */ l("li", { children: "After the SIM profile changes, SIMs will be ready for use on our network within 10 minutes. In rare cases it may take up to 24 hours." })
        ] })
      ] }),
      /* @__PURE__ */ l(
        DF,
        {
          options: N,
          onProfileChange: h,
          pendingAction: g,
          selectedProfile: p,
          toDisableProfile: u,
          otherProfiles: f,
          loading: s
        }
      )
    ] }), /* @__PURE__ */ l("div", { className: Vt.wrapper, children: y });
  }
), Xw = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${e}/sms/count` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    smsCountDetails: V(() => r?.data ?? {}, [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, AF = "hyperdashboard-BillingPeriodField-module-lzC1eq-popover", xF = "hyperdashboard-BillingPeriodField-module-lzC1eq-popoverDate", FF = "hyperdashboard-BillingPeriodField-module-lzC1eq-popoverWithTooltip", mo = {
  popover: AF,
  popoverDate: xF,
  popoverWithTooltip: FF
}, eI = ({
  hologramSimId: e,
  direction: t = "column",
  label: r = "Billing period"
}) => {
  const {
    simBilling: n,
    error: i,
    isLoading: a
  } = Ir(e), { billingPeriodStart: s, billingPeriodEnd: o, simRenewalDate: c, organizationBillingMethod: u } = n, { sendAnalyticsEvent: f } = mt(), g = u === "prepaid", p = u === "postpaid", d = V(() => i ? "—" : a ? "Loading..." : /* @__PURE__ */ O("div", { className: mo.popoverWithTooltip, children: [
    p && $i(s, "month"),
    g && `${$i(s, "long")} – ${$i(o, "long")}`,
    /* @__PURE__ */ l(
      et,
      {
        className: mo.popover,
        id: "popover-sms-limit",
        content: g ? /* @__PURE__ */ O(le, { children: [
          "SIM platform fees, prepaid data, and add-on features are charged every 30 days, beginning on the day this SIM was activated.",
          " ",
          c && /* @__PURE__ */ O(le, { children: [
            "Renews",
            " ",
            /* @__PURE__ */ O("span", { className: mo.popoverDate, children: [
              bt(c, "label"),
              "."
            ] })
          ] })
        ] }) : /* @__PURE__ */ O(le, { children: [
          "Data usage is charged monthly, resetting on the 1st of the month at midnight UTC. SIM platform fees and add-on features are charged every 30 days, beginning on the day this SIM was activated.",
          " ",
          c && /* @__PURE__ */ O(le, { children: [
            "Next SIM renewal",
            " ",
            /* @__PURE__ */ O("span", { className: mo.popoverDate, children: [
              bt(c, "label"),
              "."
            ] })
          ] })
        ] }),
        onOpen: () => {
          f && f("Info - Billing period");
        },
        children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
      }
    )
  ] }), [
    o,
    s,
    p,
    g,
    f,
    i,
    a,
    c
  ]);
  return /* @__PURE__ */ l(ee, { label: r, value: d, direction: t });
}, $F = "hyperdashboard-SimUsagePanel-module-XWpu2G-diminished", MF = "hyperdashboard-SimUsagePanel-module-XWpu2G-fieldWrapper", LF = "hyperdashboard-SimUsagePanel-module-XWpu2G-numeric", jF = "hyperdashboard-SimUsagePanel-module-XWpu2G-overLimit", WF = "hyperdashboard-SimUsagePanel-module-XWpu2G-popover", UF = "hyperdashboard-SimUsagePanel-module-XWpu2G-popoverLink", VF = "hyperdashboard-SimUsagePanel-module-XWpu2G-popoverWithTooltip", Lr = {
  diminished: $F,
  fieldWrapper: MF,
  numeric: LF,
  overLimit: jF,
  popover: WF,
  popoverLink: UF,
  popoverWithTooltip: VF
}, HF = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    error: r,
    isLoading: n
  } = Le(e), {
    networkStatusGroups: i,
    isLoading: a,
    error: s
  } = ht(), {
    simBilling: o,
    error: c,
    isLoading: u
  } = Ir(e), {
    smsCountDetails: f,
    isLoading: g,
    error: p
  } = Xw(e), { count: d } = f, { networkStatus: h } = t, v = r || s || c || p, b = n || a || u || g, m = i?.predeployment?.includes(
    h
  ), { smsLimit: S } = o, { expectedActivationTime: I, expectedPreflightDuration: C } = t, { sendAnalyticsEvent: T } = mt(), E = V(() => {
    if (v)
      return /* @__PURE__ */ l(
        fe,
        {
          variant: "error",
          label: "We ran into an issue loading your SIM",
          actions: /* @__PURE__ */ l(
            Y,
            {
              variant: "secondary",
              iconStart: "Sync",
              onClick: () => {
                window.location.reload();
              },
              children: "Reload page"
            }
          ),
          children: "We will keep trying in the background or you can try to reload the page."
        }
      );
    if (b)
      return /* @__PURE__ */ l(fe, { children: "Loading..." });
    let N;
    return m ? N = 10 : N = S === -1 ? "unlimited" : S, /* @__PURE__ */ O("div", { className: Lr.fieldWrapper, children: [
      /* @__PURE__ */ l(
        ee,
        {
          label: "Data usage",
          value: /* @__PURE__ */ l(yw, { hologramSimId: e }),
          direction: "column"
        }
      ),
      /* @__PURE__ */ l(vw, { hologramSimId: e }),
      /* @__PURE__ */ l(
        ee,
        {
          label: "Outbound SMS",
          value: /* @__PURE__ */ O("div", { className: Lr.popoverWithTooltip, children: [
            /* @__PURE__ */ l(
              "span",
              {
                className: J(
                  (S ?? -1) !== -1 && (d ?? 0) > (S ?? -1) && Lr.overLimit,
                  Lr.numeric
                ),
                children: d ?? 0
              }
            ),
            " ",
            /* @__PURE__ */ O("span", { className: J(Lr.diminished, Lr.numeric), children: [
              "of ",
              N
            ] }),
            " ",
            /* @__PURE__ */ l(
              et,
              {
                className: Lr.popover,
                id: "popover-sms-limit",
                content: m ? "Your SIM will be activated after your pre-deployment testing duration, 100 KB of data usage, or sending 10 outgoing SMS messages, whichever comes first." : /* @__PURE__ */ O("span", { children: [
                  "Outbound SMS limits are set per profile on the SIM. Total outbound SMS is displayed across profiles. Please visit",
                  " ",
                  /* @__PURE__ */ l(
                    "a",
                    {
                      href: "https://support.hologram.io/hc/en-us/articles/17463264768151-Set-a-device-s-SMS-limit",
                      target: "_blank",
                      rel: "noreferrer",
                      className: Lr.popoverLink,
                      children: "this article"
                    }
                  ),
                  " ",
                  "for information on how to increase your SIM’s outbound SMS limit."
                ] }),
                onOpen: () => {
                  T && T("Info - Outbound SMS limit");
                },
                children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
              }
            )
          ] }),
          direction: "column"
        }
      ),
      !m && /* @__PURE__ */ l(eI, { hologramSimId: e }),
      m && /* @__PURE__ */ l(
        ee,
        {
          label: "Target activation date (UTC)",
          value: /* @__PURE__ */ O("div", { className: Lr.popoverWithTooltip, children: [
            C === null ? /* @__PURE__ */ l("span", { children: "Unlimited testing duration" }) : /* @__PURE__ */ O("span", { children: [
              $i(I, "long"),
              /* @__PURE__ */ O("span", { className: Lr.diminished, children: [
                " ",
                "(",
                lr(I)?.toRelative({ unit: "days" }),
                ")"
              ] })
            ] }),
            /* @__PURE__ */ l(
              et,
              {
                className: Lr.popover,
                id: "popover-target-activation",
                content: "Your SIM will be activated after your pre-deployment testing duration, 100 KB of data usage, or sending 10 outgoing SMS messages, whichever comes first.",
                onOpen: () => {
                  T && T("Info - Target activation date");
                },
                children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
              }
            )
          ] }),
          direction: "column"
        }
      )
    ] });
  }, [
    v,
    I,
    C,
    e,
    b,
    m,
    T,
    d,
    S
  ]);
  return /* @__PURE__ */ l(
    He,
    {
      header: m ? "Pre-deployment data usage" : "Usage this billing period",
      isLoading: b,
      children: E
    }
  );
}, Q3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), qF = "hyperdashboard-BillingAddress-module-SlNHaG-address", zF = {
  address: qF
}, tI = ({
  address: { name: e, line1: t, line2: r, city: n, state: i, zip: a, country: s }
}) => /* @__PURE__ */ O("div", { className: zF.address, children: [
  /* @__PURE__ */ l("span", { children: e }),
  /* @__PURE__ */ l("span", { children: t }),
  /* @__PURE__ */ l("span", { children: r }),
  /* @__PURE__ */ O("span", { children: [
    n,
    ", ",
    i,
    " ",
    a
  ] }),
  /* @__PURE__ */ l("span", { children: s })
] }), BF = "hyperdashboard-UpdateBillingAddressForm-module-K5vYta-wrapper", GF = {
  wrapper: BF
}, QF = Et(
  ({ existingAddress: e, onSubmit: t, onCancel: r }, n) => {
    const i = E0(), a = $(async () => {
      if (!i) {
        t(void 0);
        return;
      }
      const c = i.getElement("address");
      if (!c) {
        t(void 0);
        return;
      }
      const { error: u } = await i.submit();
      if (u) {
        t(void 0);
        return;
      }
      const { complete: f, value: g } = await c.getValue();
      if (f) {
        t({
          name: g.name,
          ...g.address
        });
        return;
      }
      t(void 0);
    }, [i, t]);
    Kt(
      n,
      () => ({
        onSubmit: a
      }),
      [a]
    );
    const s = $(() => {
      i?.getElement("address")?.focus();
    }, [i]), o = {
      mode: "billing",
      autocomplete: {
        mode: "google_maps_api",
        apiKey: process.env.VITE_GOOGLE_MAPS_API_KEY
      },
      defaultValues: e?.country ? {
        address: {
          line1: e?.line1,
          line2: e?.line2,
          city: e?.city,
          state: e?.state,
          postal_code: e?.zip,
          country: e?.country ?? ""
        },
        name: e?.name
      } : void 0,
      display: { name: "organization" }
    };
    return /* @__PURE__ */ l("div", { className: GF.wrapper, children: /* @__PURE__ */ l(O0, { options: o, onReady: s, onEscape: r }) });
  }
), ZF = "hyperdashboard-UpdateBillingAddress-module-v24PfG-addressContent", YF = "hyperdashboard-UpdateBillingAddress-module-v24PfG-content", KF = "hyperdashboard-UpdateBillingAddress-module-v24PfG-empty", JF = "hyperdashboard-UpdateBillingAddress-module-v24PfG-emptyUnactionable", po = {
  addressContent: ZF,
  content: YF,
  empty: KF,
  emptyUnactionable: JF
}, XF = ({
  className: e,
  updateBillingAddress: t,
  existingAddress: r,
  readOnly: n = !1,
  hasAddress: i = !!r
}) => {
  const a = we(), [s, o] = Z(!1), [c, u] = Z({
    isLoading: !1,
    serverError: null
  }), f = $(
    async (v) => {
      if (!(!v || c.isLoading)) {
        u({
          isLoading: !0,
          serverError: null
        });
        try {
          await t(v);
        } catch (b) {
          u({
            isLoading: !1,
            serverError: b
          });
          return;
        }
        u({
          isLoading: !1,
          serverError: null
        }), o(!1);
      }
    },
    [c.isLoading, t]
  ), g = async (v) => {
    v.preventDefault(), a.current && await a.current.onSubmit();
  }, p = $(() => {
    c.isLoading || o(!1);
  }, [c.isLoading]), { panelContent: d, noContentPadding: h } = V(() => s ? {
    panelContent: /* @__PURE__ */ O("div", { className: po.content, children: [
      /* @__PURE__ */ l(
        QF,
        {
          existingAddress: r,
          onSubmit: f,
          ref: a,
          onCancel: p
        }
      ),
      c.serverError && /* @__PURE__ */ l(ze, { variant: "error", children: c.serverError })
    ] }),
    noContentPadding: !1
  } : r ? {
    panelContent: /* @__PURE__ */ O("div", { className: po.addressContent, children: [
      /* @__PURE__ */ l(tI, { address: r }),
      !n && /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          onClick: () => {
            o(!0);
          },
          children: "Update billing address"
        }
      ) })
    ] }),
    noContentPadding: !1
  } : i ? {
    panelContent: "A billing address has been saved to your account.",
    noContentPadding: !1
  } : n ? {
    panelContent: /* @__PURE__ */ l(fe, { label: "No saved billing address", className: po.emptyUnactionable, children: "A billing address is required to refill your account, pay your balance, activate SIMs, and change data plans. Contact an admin in your organization to make changes or for more details." }),
    noContentPadding: !0
  } : {
    panelContent: /* @__PURE__ */ l(
      fe,
      {
        className: po.empty,
        actions: /* @__PURE__ */ l(
          Y,
          {
            iconStart: "Mailbox",
            onClick: () => {
              o(!0);
            },
            children: "Add a billing address"
          }
        ),
        children: "We require a billing address for tax and regulatory purposes"
      }
    ),
    noContentPadding: !0
  }, [
    s,
    r,
    p,
    i,
    f,
    n,
    c.serverError
  ]);
  return /* @__PURE__ */ l(
    He,
    {
      className: e,
      noContentPadding: h,
      header: "Billing address",
      contentWell: s && "We require a billing address for tax and regulatory purposes.",
      footer: i && !r && n && "Contact an admin in your organization to make changes or for more details.",
      footerVariant: s ? "default" : "alternative",
      footerActions: s ? /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(Y, { variant: "secondary", disabled: c.isLoading, onClick: p, children: "Cancel" }),
        /* @__PURE__ */ l(Y, { type: "submit", loading: c.isLoading, onClick: g, children: "Save address" })
      ] }) : void 0,
      children: d
    }
  );
}, e$ = "hyperdashboard-Apn-module-oZe9ta-apnAndSettingsWrapper", t$ = "hyperdashboard-Apn-module-oZe9ta-apns", r$ = "hyperdashboard-Apn-module-oZe9ta-apnWrapper", n$ = "hyperdashboard-Apn-module-oZe9ta-contentsWrapper", i$ = "hyperdashboard-Apn-module-oZe9ta-description", a$ = "hyperdashboard-Apn-module-oZe9ta-footerActions", s$ = "hyperdashboard-Apn-module-oZe9ta-settings", o$ = "hyperdashboard-Apn-module-oZe9ta-settingsWrapper", l$ = "hyperdashboard-Apn-module-oZe9ta-subHeader", Pr = {
  apnAndSettingsWrapper: e$,
  apns: t$,
  apnWrapper: r$,
  contentsWrapper: n$,
  description: i$,
  footerActions: a$,
  settings: s$,
  settingsWrapper: o$,
  subHeader: l$
}, Z3 = ({
  onClose: e,
  apns: t,
  defaultOpen: r = !1,
  className: n,
  isManaged: i = !1,
  showDontShowAgain: a = !1
}) => {
  const [s, o] = Z(r), [c, u] = Z(!1), f = $(() => {
    e(c);
  }, [c, e]);
  return /* @__PURE__ */ l(
    qt,
    {
      className: n,
      noContentPadding: !0,
      header: "Set device APN",
      onClosed: f,
      open: s,
      setOpen: o,
      footer: a && /* @__PURE__ */ l(
        Rr,
        {
          label: "Don’t show again",
          onChange: (g) => {
            u(g.currentTarget.checked);
          }
        }
      ),
      footerActions: /* @__PURE__ */ O("div", { className: Pr.footerActions, children: [
        /* @__PURE__ */ l(
          Y,
          {
            onClick: () => {
              o(!1);
            },
            variant: "secondary",
            children: "Close"
          }
        ),
        /* @__PURE__ */ l(
          Y,
          {
            onClick: () => {
              o(!1);
            },
            children: "Device APN is set"
          }
        )
      ] }),
      children: /* @__PURE__ */ O("div", { className: Pr.contentsWrapper, children: [
        /* @__PURE__ */ l("p", { className: Pr.description, children: "We are now activating your SIM. In order for your device to use data on the Hologram network, you will need to set the APN on your device:" }),
        /* @__PURE__ */ O("div", { className: Pr.apnAndSettingsWrapper, children: [
          /* @__PURE__ */ O("div", { className: Pr.apnWrapper, children: [
            /* @__PURE__ */ l("div", { className: Pr.subHeader, children: "APN" }),
            /* @__PURE__ */ l("div", { className: Pr.apns, children: t?.join("/") })
          ] }),
          /* @__PURE__ */ O("div", { className: Pr.settingsWrapper, children: [
            /* @__PURE__ */ l("div", { className: Pr.subHeader, children: "Settings" }),
            /* @__PURE__ */ l("div", { className: Pr.settings, children: "No APN username, password, or PIN" })
          ] })
        ] }),
        i ? /* @__PURE__ */ O("div", { className: Pr.description, children: [
          "If you have worked with our Sales Team for access to custom APNs, some of your SIMs may use different APNs. For a walkthrough and more details on APN configuration, please check our",
          " ",
          /* @__PURE__ */ l(Ae, { href: "https://support.hologram.io/hc/en-us/articles/360035697853", target: "_blank", children: "APN guides and documentation" }),
          "."
        ] }) : /* @__PURE__ */ O("div", { className: Pr.description, children: [
          "For a walkthrough and more details on APN configuration, please check our",
          " ",
          /* @__PURE__ */ l(Ae, { href: "https://support.hologram.io/hc/en-us/articles/360035697853", target: "_blank", children: "APN guides and documentation" }),
          "."
        ] })
      ] })
    }
  );
};
function c$() {
  function e(t) {
    return new Promise((r) => {
      let n = new XMLHttpRequest();
      n.open(t.method, t.url, !0), Object.keys(t.headers).forEach((o) => n.setRequestHeader(o, t.headers[o]));
      let i = (o, c) => setTimeout(() => {
        n.abort(), r({ status: 0, content: c, isTimedOut: !0 });
      }, o), a = i(t.connectTimeout, "Connection timeout"), s;
      n.onreadystatechange = () => {
        n.readyState > n.OPENED && s === void 0 && (clearTimeout(a), s = i(t.responseTimeout, "Socket timeout"));
      }, n.onerror = () => {
        n.status === 0 && (clearTimeout(a), clearTimeout(s), r({ content: n.responseText || "Network request failed", status: n.status, isTimedOut: !1 }));
      }, n.onload = () => {
        clearTimeout(a), clearTimeout(s), r({ content: n.responseText, status: n.status, isTimedOut: !1 });
      }, n.send(t.data);
    });
  }
  return { send: e };
}
function u$(e) {
  let t;
  const r = `algolia-client-js-${e.key}`;
  function n() {
    return t === void 0 && (t = e.localStorage || window.localStorage), t;
  }
  function i() {
    return JSON.parse(n().getItem(r) || "{}");
  }
  function a(o) {
    n().setItem(r, JSON.stringify(o));
  }
  function s() {
    const o = e.timeToLive ? e.timeToLive * 1e3 : null, c = i(), u = Object.fromEntries(
      Object.entries(c).filter(([, g]) => g.timestamp !== void 0)
    );
    if (a(u), !o)
      return;
    const f = Object.fromEntries(
      Object.entries(u).filter(([, g]) => {
        const p = (/* @__PURE__ */ new Date()).getTime();
        return !(g.timestamp + o < p);
      })
    );
    a(f);
  }
  return {
    get(o, c, u = {
      miss: () => Promise.resolve()
    }) {
      return Promise.resolve().then(() => (s(), i()[JSON.stringify(o)])).then((f) => Promise.all([f ? f.value : c(), f !== void 0])).then(([f, g]) => Promise.all([f, g || u.miss(f)])).then(([f]) => f);
    },
    set(o, c) {
      return Promise.resolve().then(() => {
        const u = i();
        return u[JSON.stringify(o)] = {
          timestamp: (/* @__PURE__ */ new Date()).getTime(),
          value: c
        }, n().setItem(r, JSON.stringify(u)), c;
      });
    },
    delete(o) {
      return Promise.resolve().then(() => {
        const c = i();
        delete c[JSON.stringify(o)], n().setItem(r, JSON.stringify(c));
      });
    },
    clear() {
      return Promise.resolve().then(() => {
        n().removeItem(r);
      });
    }
  };
}
function d$() {
  return {
    get(e, t, r = {
      miss: () => Promise.resolve()
    }) {
      return t().then((i) => Promise.all([i, r.miss(i)])).then(([i]) => i);
    },
    set(e, t) {
      return Promise.resolve(t);
    },
    delete(e) {
      return Promise.resolve();
    },
    clear() {
      return Promise.resolve();
    }
  };
}
function xa(e) {
  const t = [...e.caches], r = t.shift();
  return r === void 0 ? d$() : {
    get(n, i, a = {
      miss: () => Promise.resolve()
    }) {
      return r.get(n, i, a).catch(() => xa({ caches: t }).get(n, i, a));
    },
    set(n, i) {
      return r.set(n, i).catch(() => xa({ caches: t }).set(n, i));
    },
    delete(n) {
      return r.delete(n).catch(() => xa({ caches: t }).delete(n));
    },
    clear() {
      return r.clear().catch(() => xa({ caches: t }).clear());
    }
  };
}
function Ju(e = { serializable: !0 }) {
  let t = {};
  return {
    get(r, n, i = {
      miss: () => Promise.resolve()
    }) {
      const a = JSON.stringify(r);
      if (a in t)
        return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
      const s = n();
      return s.then((o) => i.miss(o)).then(() => s);
    },
    set(r, n) {
      return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
    },
    delete(r) {
      return delete t[JSON.stringify(r)], Promise.resolve();
    },
    clear() {
      return t = {}, Promise.resolve();
    }
  };
}
function f$(e) {
  const t = {
    value: `Algolia for JavaScript (${e})`,
    add(r) {
      const n = `; ${r.segment}${r.version !== void 0 ? ` (${r.version})` : ""}`;
      return t.value.indexOf(n) === -1 && (t.value = `${t.value}${n}`), t;
    }
  };
  return t;
}
function h$(e, t, r = "WithinHeaders") {
  const n = {
    "x-algolia-api-key": t,
    "x-algolia-application-id": e
  };
  return {
    headers() {
      return r === "WithinHeaders" ? n : {};
    },
    queryParameters() {
      return r === "WithinQueryParameters" ? n : {};
    }
  };
}
function m$({ algoliaAgents: e, client: t, version: r }) {
  const n = f$(r).add({
    segment: t,
    version: r
  });
  return e.forEach((i) => n.add(i)), n;
}
function p$() {
  return {
    debug(e, t) {
      return Promise.resolve();
    },
    info(e, t) {
      return Promise.resolve();
    },
    error(e, t) {
      return Promise.resolve();
    }
  };
}
var Iv = 2 * 60 * 1e3;
function Cv(e, t = "up") {
  const r = Date.now();
  function n() {
    return t === "up" || Date.now() - r > Iv;
  }
  function i() {
    return t === "timed out" && Date.now() - r <= Iv;
  }
  return { ...e, status: t, lastUpdate: r, isUp: n, isTimedOut: i };
}
var rI = class extends Error {
  name = "AlgoliaError";
  constructor(e, t) {
    super(e), t && (this.name = t);
  }
}, nI = class extends rI {
  stackTrace;
  constructor(e, t, r) {
    super(e, r), this.stackTrace = t;
  }
}, g$ = class extends nI {
  constructor(e) {
    super(
      "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support.",
      e,
      "RetryError"
    );
  }
}, Tf = class extends nI {
  status;
  constructor(e, t, r, n = "ApiError") {
    super(e, r, n), this.status = t;
  }
}, v$ = class extends rI {
  response;
  constructor(e, t) {
    super(e, "DeserializationError"), this.response = t;
  }
}, y$ = class extends Tf {
  error;
  constructor(e, t, r, n) {
    super(e, t, n, "DetailedApiError"), this.error = r;
  }
};
function b$(e) {
  const t = e;
  for (let r = e.length - 1; r > 0; r--) {
    const n = Math.floor(Math.random() * (r + 1)), i = e[r];
    t[r] = e[n], t[n] = i;
  }
  return t;
}
function S$(e, t, r) {
  const n = w$(r);
  let i = `${e.protocol}://${e.url}${e.port ? `:${e.port}` : ""}/${t.charAt(0) === "/" ? t.substring(1) : t}`;
  return n.length && (i += `?${n}`), i;
}
function w$(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).sort().map(
    (t) => `${t}=${encodeURIComponent(
      Object.prototype.toString.call(e[t]) === "[object Array]" ? e[t].join(",") : e[t]
    ).replace(/\+/g, "%20")}`
  ).join("&");
}
function I$(e, t) {
  if (e.method === "GET" || e.data === void 0 && t.data === void 0)
    return;
  const r = Array.isArray(e.data) ? e.data : { ...e.data, ...t.data };
  return JSON.stringify(r);
}
function C$(e, t, r) {
  const n = {
    Accept: "application/json",
    ...e,
    ...t,
    ...r
  }, i = {};
  return Object.keys(n).forEach((a) => {
    const s = n[a];
    i[a.toLowerCase()] = s;
  }), i;
}
function P$(e) {
  try {
    return JSON.parse(e.content);
  } catch (t) {
    throw new v$(t.message, e);
  }
}
function T$({ content: e, status: t }, r) {
  try {
    const n = JSON.parse(e);
    return "error" in n ? new y$(n.message, t, n.error, r) : new Tf(n.message, t, r);
  } catch {
  }
  return new Tf(e, t, r);
}
function _$({ isTimedOut: e, status: t }) {
  return !e && ~~t === 0;
}
function E$({ isTimedOut: e, status: t }) {
  return e || _$({ isTimedOut: e, status: t }) || ~~(t / 100) !== 2 && ~~(t / 100) !== 4;
}
function O$({ status: e }) {
  return ~~(e / 100) === 2;
}
function N$(e) {
  return e.map((t) => iI(t));
}
function iI(e) {
  const t = e.request.headers["x-algolia-api-key"] ? { "x-algolia-api-key": "*****" } : {};
  return {
    ...e,
    request: {
      ...e.request,
      headers: {
        ...e.request.headers,
        ...t
      }
    }
  };
}
function D$({
  hosts: e,
  hostsCache: t,
  baseHeaders: r,
  logger: n,
  baseQueryParameters: i,
  algoliaAgent: a,
  timeouts: s,
  requester: o,
  requestsCache: c,
  responsesCache: u
}) {
  async function f(d) {
    const h = await Promise.all(
      d.map((I) => t.get(I, () => Promise.resolve(Cv(I))))
    ), v = h.filter((I) => I.isUp()), b = h.filter((I) => I.isTimedOut()), m = [...v, ...b];
    return {
      hosts: m.length > 0 ? m : d,
      getTimeout(I, C) {
        return (b.length === 0 && I === 0 ? 1 : b.length + 3 + I) * C;
      }
    };
  }
  async function g(d, h, v = !0) {
    const b = [], m = I$(d, h), S = C$(r, d.headers, h.headers), I = d.method === "GET" ? {
      ...d.data,
      ...h.data
    } : {}, C = {
      ...i,
      ...d.queryParameters,
      ...I
    };
    if (a.value && (C["x-algolia-agent"] = a.value), h && h.queryParameters)
      for (const w of Object.keys(h.queryParameters))
        !h.queryParameters[w] || Object.prototype.toString.call(h.queryParameters[w]) === "[object Object]" ? C[w] = h.queryParameters[w] : C[w] = h.queryParameters[w].toString();
    let T = 0;
    const E = async (w, P) => {
      const _ = w.pop();
      if (_ === void 0)
        throw new g$(N$(b));
      const D = { ...s, ...h.timeouts }, R = {
        data: m,
        headers: S,
        method: d.method,
        url: S$(_, d.path, C),
        connectTimeout: P(T, D.connect),
        responseTimeout: P(T, v ? D.read : D.write)
      }, x = (W) => {
        const A = {
          request: R,
          response: W,
          host: _,
          triesLeft: w.length
        };
        return b.push(A), A;
      }, F = await o.send(R);
      if (E$(F)) {
        const W = x(F);
        return F.isTimedOut && T++, n.info("Retryable failure", iI(W)), await t.set(_, Cv(_, F.isTimedOut ? "timed out" : "down")), E(w, P);
      }
      if (O$(F))
        return P$(F);
      throw x(F), T$(F, b);
    }, N = e.filter(
      (w) => w.accept === "readWrite" || (v ? w.accept === "read" : w.accept === "write")
    ), y = await f(N);
    return E([...y.hosts].reverse(), y.getTimeout);
  }
  function p(d, h = {}) {
    const v = d.useReadTransporter || d.method === "GET";
    if (!v)
      return g(d, h, v);
    const b = () => g(d, h);
    if ((h.cacheable || d.cacheable) !== !0)
      return b();
    const S = {
      request: d,
      requestOptions: h,
      transporter: {
        queryParameters: i,
        headers: r
      }
    };
    return u.get(
      S,
      () => c.get(
        S,
        () => (
          /**
           * Finally, if there is no request in progress with the same key,
           * this `createRetryableRequest()` will actually trigger the
           * retryable request.
           */
          c.set(S, b()).then(
            (I) => Promise.all([c.delete(S), I]),
            (I) => Promise.all([c.delete(S), Promise.reject(I)])
          ).then(([I, C]) => C)
        )
      ),
      {
        /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */
        miss: (I) => u.set(S, I)
      }
    );
  }
  return {
    hostsCache: t,
    requester: o,
    timeouts: s,
    logger: n,
    algoliaAgent: a,
    baseHeaders: r,
    baseQueryParameters: i,
    hosts: e,
    request: p,
    requestsCache: c,
    responsesCache: u
  };
}
var aI = "5.25.0";
function R$(e) {
  return [
    {
      url: `${e}-dsn.algolia.net`,
      accept: "read",
      protocol: "https"
    },
    {
      url: `${e}.algolia.net`,
      accept: "write",
      protocol: "https"
    }
  ].concat(
    b$([
      {
        url: `${e}-1.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${e}-2.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${e}-3.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      }
    ])
  );
}
function k$({
  appId: e,
  apiKey: t,
  authMode: r,
  algoliaAgents: n,
  ...i
}) {
  const a = h$(e, t, r), s = D$({
    hosts: R$(e),
    ...i,
    algoliaAgent: m$({
      algoliaAgents: n,
      client: "Lite",
      version: aI
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...a.headers(),
      ...i.baseHeaders
    },
    baseQueryParameters: {
      ...a.queryParameters(),
      ...i.baseQueryParameters
    }
  });
  return {
    transporter: s,
    /**
     * The `appId` currently in use.
     */
    appId: e,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: t,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([s.requestsCache.clear(), s.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return s.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(o, c) {
      s.algoliaAgent.add({ segment: o, version: c });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: o }) {
      !r || r === "WithinHeaders" ? s.baseHeaders["x-algolia-api-key"] = o : s.baseQueryParameters["x-algolia-api-key"] = o;
    },
    /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `hits`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForHits(o, c) {
      return this.search(o, c);
    },
    /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `facets`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForFacets(o, c) {
      return this.search(o, c);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: o, parameters: c, body: u }, f) {
      if (!o)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const h = {
        method: "POST",
        path: "/{path}".replace("{path}", o),
        queryParameters: c || {},
        headers: {},
        data: u || {}
      };
      return s.request(h, f);
    },
    /**
     * Retrieves recommendations from selected AI models.
     *
     * Required API Key ACLs:
     *  - search
     * @param getRecommendationsParams - The getRecommendationsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRecommendations(o, c) {
      if (o && Array.isArray(o) && (o = {
        requests: o
      }), !o)
        throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
      if (!o.requests)
        throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
      const p = {
        method: "POST",
        path: "/1/indexes/*/recommendations",
        queryParameters: {},
        headers: {},
        data: o,
        useReadTransporter: !0,
        cacheable: !0
      };
      return s.request(p, c);
    },
    /**
     * Sends multiple search requests to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.  Use the helper `searchForHits` or `searchForFacets` to get the results in a more convenient format, if you already know the return type you want.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    search(o, c) {
      if (o && Array.isArray(o) && (o = {
        requests: o.map(({ params: h, ...v }) => v.type === "facet" ? {
          ...v,
          ...h,
          type: "facet"
        } : {
          ...v,
          ...h,
          facet: void 0,
          maxFacetHits: void 0,
          facetQuery: void 0
        })
      }), !o)
        throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
      if (!o.requests)
        throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
      const p = {
        method: "POST",
        path: "/1/indexes/*/queries",
        queryParameters: {},
        headers: {},
        data: o,
        useReadTransporter: !0,
        cacheable: !0
      };
      return s.request(p, c);
    }
  };
}
function A$(e, t, r) {
  return k$({
    appId: e,
    apiKey: t,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: p$(),
    requester: c$(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: Ju(),
    requestsCache: Ju({ serializable: !1 }),
    hostsCache: xa({
      caches: [u$({ key: `${aI}-${e}` }), Ju()]
    }),
    ...r
  });
}
const _f = "7.15.7";
var Xu, Pv;
function Lh() {
  if (Pv) return Xu;
  Pv = 1;
  function e() {
    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
  }
  Xu = e, e.prototype._events = void 0, e.prototype._maxListeners = void 0, e.defaultMaxListeners = 10, e.prototype.setMaxListeners = function(a) {
    if (!r(a) || a < 0 || isNaN(a))
      throw TypeError("n must be a positive number");
    return this._maxListeners = a, this;
  }, e.prototype.emit = function(a) {
    var s, o, c, u, f, g;
    if (this._events || (this._events = {}), a === "error" && (!this._events.error || n(this._events.error) && !this._events.error.length)) {
      if (s = arguments[1], s instanceof Error)
        throw s;
      var p = new Error('Uncaught, unspecified "error" event. (' + s + ")");
      throw p.context = s, p;
    }
    if (o = this._events[a], i(o))
      return !1;
    if (t(o))
      switch (arguments.length) {
        // fast cases
        case 1:
          o.call(this);
          break;
        case 2:
          o.call(this, arguments[1]);
          break;
        case 3:
          o.call(this, arguments[1], arguments[2]);
          break;
        // slower
        default:
          u = Array.prototype.slice.call(arguments, 1), o.apply(this, u);
      }
    else if (n(o))
      for (u = Array.prototype.slice.call(arguments, 1), g = o.slice(), c = g.length, f = 0; f < c; f++)
        g[f].apply(this, u);
    return !0;
  }, e.prototype.addListener = function(a, s) {
    var o;
    if (!t(s))
      throw TypeError("listener must be a function");
    return this._events || (this._events = {}), this._events.newListener && this.emit(
      "newListener",
      a,
      t(s.listener) ? s.listener : s
    ), this._events[a] ? n(this._events[a]) ? this._events[a].push(s) : this._events[a] = [this._events[a], s] : this._events[a] = s, n(this._events[a]) && !this._events[a].warned && (i(this._maxListeners) ? o = e.defaultMaxListeners : o = this._maxListeners, o && o > 0 && this._events[a].length > o && (this._events[a].warned = !0, console.error(
      "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
      this._events[a].length
    ), typeof console.trace == "function" && console.trace())), this;
  }, e.prototype.on = e.prototype.addListener, e.prototype.once = function(a, s) {
    if (!t(s))
      throw TypeError("listener must be a function");
    var o = !1;
    function c() {
      this.removeListener(a, c), o || (o = !0, s.apply(this, arguments));
    }
    return c.listener = s, this.on(a, c), this;
  }, e.prototype.removeListener = function(a, s) {
    var o, c, u, f;
    if (!t(s))
      throw TypeError("listener must be a function");
    if (!this._events || !this._events[a])
      return this;
    if (o = this._events[a], u = o.length, c = -1, o === s || t(o.listener) && o.listener === s)
      delete this._events[a], this._events.removeListener && this.emit("removeListener", a, s);
    else if (n(o)) {
      for (f = u; f-- > 0; )
        if (o[f] === s || o[f].listener && o[f].listener === s) {
          c = f;
          break;
        }
      if (c < 0)
        return this;
      o.length === 1 ? (o.length = 0, delete this._events[a]) : o.splice(c, 1), this._events.removeListener && this.emit("removeListener", a, s);
    }
    return this;
  }, e.prototype.removeAllListeners = function(a) {
    var s, o;
    if (!this._events)
      return this;
    if (!this._events.removeListener)
      return arguments.length === 0 ? this._events = {} : this._events[a] && delete this._events[a], this;
    if (arguments.length === 0) {
      for (s in this._events)
        s !== "removeListener" && this.removeAllListeners(s);
      return this.removeAllListeners("removeListener"), this._events = {}, this;
    }
    if (o = this._events[a], t(o))
      this.removeListener(a, o);
    else if (o)
      for (; o.length; )
        this.removeListener(a, o[o.length - 1]);
    return delete this._events[a], this;
  }, e.prototype.listeners = function(a) {
    var s;
    return !this._events || !this._events[a] ? s = [] : t(this._events[a]) ? s = [this._events[a]] : s = this._events[a].slice(), s;
  }, e.prototype.listenerCount = function(a) {
    if (this._events) {
      var s = this._events[a];
      if (t(s))
        return 1;
      if (s)
        return s.length;
    }
    return 0;
  }, e.listenerCount = function(a, s) {
    return a.listenerCount(s);
  };
  function t(a) {
    return typeof a == "function";
  }
  function r(a) {
    return typeof a == "number";
  }
  function n(a) {
    return typeof a == "object" && a !== null;
  }
  function i(a) {
    return a === void 0;
  }
  return Xu;
}
var ed, Tv;
function sI() {
  if (Tv) return ed;
  Tv = 1;
  function e(t, r) {
    t.prototype = Object.create(r.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  }
  return ed = e, ed;
}
var td, _v;
function x$() {
  if (_v) return td;
  _v = 1;
  var e = Lh(), t = sI();
  function r(n, i, a) {
    this.main = n, this.fn = i, this.recommendFn = a, this.lastResults = null, this.lastRecommendResults = null;
  }
  return t(r, e), r.prototype.detach = function() {
    this.removeAllListeners(), this.main.detachDerivedHelper(this);
  }, r.prototype.getModifiedState = function(n) {
    return this.fn(n);
  }, r.prototype.getModifiedRecommendState = function(n) {
    return this.recommendFn(n);
  }, td = r, td;
}
var rd, Ev;
function jh() {
  if (Ev) return rd;
  Ev = 1;
  function e(r) {
    return typeof r != "string" ? r : String(r).replace(/^-/, "\\-");
  }
  function t(r) {
    return typeof r != "string" ? r : r.replace(/^\\-/, "-");
  }
  return rd = {
    escapeFacetValue: e,
    unescapeFacetValue: t
  }, rd;
}
var nd, Ov;
function Wh() {
  if (Ov) return nd;
  Ov = 1;
  function e(i) {
    return typeof i == "object" && i !== null ? r(Array.isArray(i) ? [] : {}, i) : i;
  }
  function t(i) {
    return typeof i == "function" || Array.isArray(i) || Object.prototype.toString.call(i) === "[object Object]";
  }
  function r(i, a) {
    if (i === a)
      return i;
    for (var s in a)
      if (!(!Object.prototype.hasOwnProperty.call(a, s) || s === "__proto__" || s === "constructor")) {
        var o = a[s], c = i[s];
        typeof c < "u" && typeof o > "u" || (t(c) && t(o) ? i[s] = r(c, o) : i[s] = e(o));
      }
    return i;
  }
  function n(i) {
    t(i) || (i = {});
    for (var a = 1, s = arguments.length; a < s; a++) {
      var o = arguments[a];
      t(o) && r(i, o);
    }
    return i;
  }
  return nd = n, nd;
}
var id, Nv;
function Uh() {
  if (Nv) return id;
  Nv = 1;
  function e(t) {
    return t && Object.keys(t).length > 0;
  }
  return id = e, id;
}
var ad, Dv;
function Vh() {
  if (Dv) return ad;
  Dv = 1;
  function e(t, r) {
    if (t === null) return {};
    var n = {}, i = Object.keys(t), a, s;
    for (s = 0; s < i.length; s++)
      a = i[s], !(r.indexOf(a) >= 0) && (n[a] = t[a]);
    return n;
  }
  return ad = e, ad;
}
var sd, Rv;
function oI() {
  if (Rv) return sd;
  Rv = 1;
  function e(t) {
    t = t || {}, this.params = t.params || [];
  }
  return e.prototype = {
    constructor: e,
    addParams: function(t) {
      var r = this.params.slice();
      return r.push(t), new e({ params: r });
    },
    removeParams: function(t) {
      return new e({
        params: this.params.filter(function(r) {
          return r.$$id !== t;
        })
      });
    },
    addFrequentlyBoughtTogether: function(t) {
      return this.addParams(
        Object.assign({}, t, { model: "bought-together" })
      );
    },
    addRelatedProducts: function(t) {
      return this.addParams(
        Object.assign({}, t, { model: "related-products" })
      );
    },
    addTrendingItems: function(t) {
      return this.addParams(
        Object.assign({}, t, { model: "trending-items" })
      );
    },
    addTrendingFacets: function(t) {
      return this.addParams(
        Object.assign({}, t, { model: "trending-facets" })
      );
    },
    addLookingSimilar: function(t) {
      return this.addParams(
        Object.assign({}, t, { model: "looking-similar" })
      );
    },
    _buildQueries: function(t, r) {
      return this.params.filter(function(n) {
        return r[n.$$id] === void 0;
      }).map(function(n) {
        var i = Object.assign({}, n, {
          indexName: t,
          // @TODO: remove this if it ever gets handled by the API
          threshold: n.threshold || 0
        });
        return delete i.$$id, i;
      });
    }
  }, sd = e, sd;
}
var od, kv;
function lI() {
  if (kv) return od;
  kv = 1;
  function e(t, r) {
    this._state = t, this._rawResults = {};
    var n = this;
    t.params.forEach(function(i) {
      var a = i.$$id;
      n[a] = r[a], n._rawResults[a] = r[a];
    });
  }
  return e.prototype = {
    constructor: e
  }, od = e, od;
}
var ld, Av;
function F$() {
  if (Av) return ld;
  Av = 1;
  var e = Wh();
  function t(n) {
    return Object.keys(n).sort().reduce(function(i, a) {
      return i[a] = n[a], i;
    }, {});
  }
  var r = {
    /**
     * Get all the queries to send to the client, those queries can used directly
     * with the Algolia client.
     * @private
     * @param  {string} index The name of the index
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object[]} The queries
     */
    _getQueries: function(i, a) {
      var s = [];
      return s.push({
        indexName: i,
        params: r._getHitsSearchParams(a)
      }), a.getRefinedDisjunctiveFacets().forEach(function(o) {
        s.push({
          indexName: i,
          params: r._getDisjunctiveFacetSearchParams(
            a,
            o
          )
        });
      }), a.getRefinedHierarchicalFacets().forEach(function(o) {
        var c = a.getHierarchicalFacetByName(o), u = a.getHierarchicalRefinement(o), f = a._getHierarchicalFacetSeparator(c);
        if (u.length > 0 && u[0].split(f).length > 1) {
          var g = u[0].split(f).slice(0, -1).reduce(function(d, h, v) {
            return d.concat({
              attribute: c.attributes[v],
              value: v === 0 ? h : [d[d.length - 1].value, h].join(f)
            });
          }, []);
          g.forEach(function(p, d) {
            var h = r._getDisjunctiveFacetSearchParams(
              a,
              p.attribute,
              d === 0
            );
            function v(S) {
              return c.attributes.some(function(I) {
                return I === S.split(":")[0];
              });
            }
            var b = (h.facetFilters || []).reduce(
              function(S, I) {
                if (Array.isArray(I)) {
                  var C = I.filter(function(T) {
                    return !v(T);
                  });
                  C.length > 0 && S.push(C);
                }
                return typeof I == "string" && !v(I) && S.push(I), S;
              },
              []
            ), m = g[d - 1];
            d > 0 ? h.facetFilters = b.concat(
              m.attribute + ":" + m.value
            ) : b.length > 0 ? h.facetFilters = b : delete h.facetFilters, s.push({ indexName: i, params: h });
          });
        }
      }), s;
    },
    /**
     * Get all the queries to send to the client, those queries can used directly
     * with the Algolia client.
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object[]} The queries
     */
    _getCompositionQueries: function(i) {
      return [
        {
          compositionID: i.index,
          requestBody: {
            params: r._getCompositionHitsSearchParams(i)
          }
        }
      ];
    },
    /**
     * Build search parameters used to fetch hits
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object.<string, any>} The search parameters for hits
     */
    _getHitsSearchParams: function(n) {
      var i = n.facets.concat(n.disjunctiveFacets).concat(r._getHitsHierarchicalFacetsAttributes(n)).sort(), a = r._getFacetFilters(n), s = r._getNumericFilters(n), o = r._getTagFilters(n), c = {};
      return i.length > 0 && (c.facets = i.indexOf("*") > -1 ? ["*"] : i), o.length > 0 && (c.tagFilters = o), a.length > 0 && (c.facetFilters = a), s.length > 0 && (c.numericFilters = s), t(e({}, n.getQueryParams(), c));
    },
    /**
     * Build search parameters used to fetch hits
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object.<string, any>} The search parameters for hits
     */
    _getCompositionHitsSearchParams: function(n) {
      var i = n.facets.concat(
        n.disjunctiveFacets.map(function(f) {
          return n.disjunctiveFacetsRefinements && n.disjunctiveFacetsRefinements[f] && n.disjunctiveFacetsRefinements[f].length > 0 ? "disjunctive(" + f + ")" : f;
        })
      ).concat(r._getHitsHierarchicalFacetsAttributes(n)).sort(), a = r._getFacetFilters(n), s = r._getNumericFilters(n), o = r._getTagFilters(n), c = {};
      i.length > 0 && (c.facets = i.indexOf("*") > -1 ? ["*"] : i), o.length > 0 && (c.tagFilters = o), a.length > 0 && (c.facetFilters = a), s.length > 0 && (c.numericFilters = s);
      var u = n.getQueryParams();
      return delete u.highlightPreTag, delete u.highlightPostTag, delete u.index, t(e({}, u, c));
    },
    /**
     * Build search parameters used to fetch a disjunctive facet
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @param  {string} facet the associated facet name
     * @param  {boolean} hierarchicalRootLevel ?? FIXME
     * @return {object} The search parameters for a disjunctive facet
     */
    _getDisjunctiveFacetSearchParams: function(n, i, a) {
      var s = r._getFacetFilters(
        n,
        i,
        a
      ), o = r._getNumericFilters(n, i), c = r._getTagFilters(n), u = {
        hitsPerPage: 0,
        page: 0,
        analytics: !1,
        clickAnalytics: !1
      };
      c.length > 0 && (u.tagFilters = c);
      var f = n.getHierarchicalFacetByName(i);
      return f ? u.facets = r._getDisjunctiveHierarchicalFacetAttribute(
        n,
        f,
        a
      ) : u.facets = i, o.length > 0 && (u.numericFilters = o), s.length > 0 && (u.facetFilters = s), t(e({}, n.getQueryParams(), u));
    },
    /**
     * Return the numeric filters in an algolia request fashion
     * @private
     * @param {SearchParameters} state the state from which to get the filters
     * @param {string} [facetName] the name of the attribute for which the filters should be excluded
     * @return {string[]} the numeric filters in the algolia format
     */
    _getNumericFilters: function(n, i) {
      if (n.numericFilters)
        return n.numericFilters;
      var a = [];
      return Object.keys(n.numericRefinements).forEach(function(s) {
        var o = n.numericRefinements[s] || {};
        Object.keys(o).forEach(function(c) {
          var u = o[c] || [];
          i !== s && u.forEach(function(f) {
            if (Array.isArray(f)) {
              var g = f.map(function(p) {
                return s + c + p;
              });
              a.push(g);
            } else
              a.push(s + c + f);
          });
        });
      }), a;
    },
    /**
     * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
     * @private
     * @param {SearchParameters} state the state from which to get the filters
     * @return {string} Tag filters in a single string
     */
    _getTagFilters: function(n) {
      return n.tagFilters ? n.tagFilters : n.tagRefinements.join(",");
    },
    /**
     * Build facetFilters parameter based on current refinements. The array returned
     * contains strings representing the facet filters in the algolia format.
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @param  {string} [facet] if set, the current disjunctive facet
     * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
     * @return {array.<string>} The facet filters in the algolia format
     */
    _getFacetFilters: function(n, i, a) {
      var s = [], o = n.facetsRefinements || {};
      Object.keys(o).sort().forEach(function(g) {
        var p = o[g] || [];
        p.slice().sort().forEach(function(d) {
          s.push(g + ":" + d);
        });
      });
      var c = n.facetsExcludes || {};
      Object.keys(c).sort().forEach(function(g) {
        var p = c[g] || [];
        p.sort().forEach(function(d) {
          s.push(g + ":-" + d);
        });
      });
      var u = n.disjunctiveFacetsRefinements || {};
      Object.keys(u).sort().forEach(function(g) {
        var p = u[g] || [];
        if (!(g === i || !p || p.length === 0)) {
          var d = [];
          p.slice().sort().forEach(function(h) {
            d.push(g + ":" + h);
          }), s.push(d);
        }
      });
      var f = n.hierarchicalFacetsRefinements || {};
      return Object.keys(f).sort().forEach(function(g) {
        var p = f[g] || [], d = p[0];
        if (d !== void 0) {
          var h = n.getHierarchicalFacetByName(g), v = n._getHierarchicalFacetSeparator(h), b = n._getHierarchicalRootPath(h), m, S;
          if (i === g) {
            if (d.indexOf(v) === -1 || !b && a === !0 || b && b.split(v).length === d.split(v).length)
              return;
            b ? (S = b.split(v).length - 1, d = b) : (S = d.split(v).length - 2, d = d.slice(0, d.lastIndexOf(v))), m = h.attributes[S];
          } else
            S = d.split(v).length - 1, m = h.attributes[S];
          m && s.push([m + ":" + d]);
        }
      }), s;
    },
    _getHitsHierarchicalFacetsAttributes: function(n) {
      var i = [];
      return n.hierarchicalFacets.reduce(
        // ask for as much levels as there's hierarchical refinements
        function(s, o) {
          var c = n.getHierarchicalRefinement(
            o.name
          )[0];
          if (!c)
            return s.push(o.attributes[0]), s;
          var u = n._getHierarchicalFacetSeparator(o), f = c.split(u).length, g = o.attributes.slice(0, f + 1);
          return s.concat(g);
        },
        i
      );
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(n, i, a) {
      var s = n._getHierarchicalFacetSeparator(i);
      if (a === !0) {
        var o = n._getHierarchicalRootPath(i), c = 0;
        return o && (c = o.split(s).length), [i.attributes[c]];
      }
      var u = n.getHierarchicalRefinement(i.name)[0] || "", f = u.split(s).length - 1;
      return i.attributes.slice(0, f + 1);
    },
    getSearchForFacetQuery: function(n, i, a, s) {
      var o = s.isDisjunctiveFacet(n) ? s.clearRefinements(n) : s, c = {
        facetQuery: i,
        facetName: n
      };
      return typeof a == "number" && (c.maxFacetHits = a), t(
        e(
          {},
          r._getHitsSearchParams(o),
          c
        )
      );
    }
  };
  return ld = r, ld;
}
var cd, xv;
function Hh() {
  return xv || (xv = 1, cd = function() {
    var t = Array.prototype.slice.call(arguments);
    return t.reduceRight(function(r, n) {
      return Object.keys(Object(n)).forEach(function(i) {
        n[i] !== void 0 && (r[i] !== void 0 && delete r[i], r[i] = n[i]);
      }), r;
    }, {});
  }), cd;
}
var ud, Fv;
function Ls() {
  return Fv || (Fv = 1, ud = function(t, r) {
    if (Array.isArray(t)) {
      for (var n = 0; n < t.length; n++)
        if (r(t[n]))
          return t[n];
    }
  }), ud;
}
var dd, $v;
function $$() {
  if ($v) return dd;
  $v = 1;
  function e(t, r) {
    return t.filter(function(n, i) {
      return r.indexOf(n) > -1 && t.indexOf(n) === i;
    });
  }
  return dd = e, dd;
}
var fd, Mv;
function M$() {
  if (Mv) return fd;
  Mv = 1;
  function e(t) {
    if (typeof t == "number")
      return t;
    if (typeof t == "string")
      return parseFloat(t);
    if (Array.isArray(t))
      return t.map(e);
    throw new Error(
      "The value should be a number, a parsable string or an array of those."
    );
  }
  return fd = e, fd;
}
var hd, Lv;
function L$() {
  return Lv || (Lv = 1, hd = function(t) {
    return t === null ? !1 : /^[a-zA-Z0-9_-]{1,64}$/.test(t);
  }), hd;
}
var md, jv;
function j$() {
  if (jv) return md;
  jv = 1;
  var e = Hh(), t = Uh(), r = Vh(), n = {
    /**
     * Adds a refinement to a RefinementList
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} value the value of the refinement, if the value is not a string it will be converted
     * @return {RefinementList} a new and updated refinement list
     */
    addRefinement: function(a, s, o) {
      if (n.isRefined(a, s, o))
        return a;
      var c = "" + o, u = a[s] ? a[s].concat(c) : [c], f = {};
      return f[s] = u, e(f, a);
    },
    /**
     * Removes refinement(s) for an attribute:
     *  - if the value is specified removes the refinement for the value on the attribute
     *  - if no value is specified removes all the refinements for this attribute
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} [value] the value of the refinement
     * @return {RefinementList} a new and updated refinement lst
     */
    removeRefinement: function(a, s, o) {
      if (o === void 0)
        return n.clearRefinement(a, function(u, f) {
          return s === f;
        });
      var c = "" + o;
      return n.clearRefinement(a, function(u, f) {
        return s === f && c === u;
      });
    },
    /**
     * Toggles the refinement value for an attribute.
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} value the value of the refinement
     * @return {RefinementList} a new and updated list
     */
    toggleRefinement: function(a, s, o) {
      if (o === void 0)
        throw new Error("toggleRefinement should be used with a value");
      return n.isRefined(a, s, o) ? n.removeRefinement(a, s, o) : n.addRefinement(a, s, o);
    },
    /**
     * Clear all or parts of a RefinementList. Depending on the arguments, three
     * kinds of behavior can happen:
     *  - if no attribute is provided: clears the whole list
     *  - if an attribute is provided as a string: clears the list for the specific attribute
     *  - if an attribute is provided as a function: discards the elements for which the function returns true
     * @param {RefinementList} refinementList the initial list
     * @param {string} [attribute] the attribute or function to discard
     * @param {string} [refinementType] optional parameter to give more context to the attribute function
     * @return {RefinementList} a new and updated refinement list
     */
    clearRefinement: function(a, s, o) {
      if (s === void 0)
        return t(a) ? {} : a;
      if (typeof s == "string")
        return r(a, [s]);
      if (typeof s == "function") {
        var c = !1, u = Object.keys(a).reduce(
          function(f, g) {
            var p = a[g] || [], d = p.filter(function(h) {
              return !s(h, g, o);
            });
            return d.length !== p.length && (c = !0), f[g] = d, f;
          },
          {}
        );
        return c ? u : a;
      }
    },
    /**
     * Test if the refinement value is used for the attribute. If no refinement value
     * is provided, test if the refinementList contains any refinement for the
     * given attribute.
     * @param {RefinementList} refinementList the list of refinement
     * @param {string} attribute name of the attribute
     * @param {string} [refinementValue] value of the filter/refinement
     * @return {boolean} true if the attribute is refined, false otherwise
     */
    isRefined: function(a, s, o) {
      var c = !!a[s] && a[s].length > 0;
      if (o === void 0 || !c)
        return c;
      var u = "" + o;
      return a[s].indexOf(u) !== -1;
    }
  };
  return md = n, md;
}
var pd, Wv;
function cI() {
  if (Wv) return pd;
  Wv = 1;
  var e = Hh(), t = Ls(), r = $$(), n = Wh(), i = Uh(), a = Vh(), s = M$(), o = L$(), c = j$();
  function u(p, d) {
    return Array.isArray(p) && Array.isArray(d) ? p.length === d.length && p.every(function(h, v) {
      return u(d[v], h);
    }) : p === d;
  }
  function f(p, d) {
    return t(p, function(h) {
      return u(h, d);
    });
  }
  function g(p) {
    var d = p ? g._parseNumbers(p) : {};
    d.userToken !== void 0 && !o(d.userToken) && console.warn(
      "[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"
    ), this.facets = d.facets || [], this.disjunctiveFacets = d.disjunctiveFacets || [], this.hierarchicalFacets = d.hierarchicalFacets || [], this.facetsRefinements = d.facetsRefinements || {}, this.facetsExcludes = d.facetsExcludes || {}, this.disjunctiveFacetsRefinements = d.disjunctiveFacetsRefinements || {}, this.numericRefinements = d.numericRefinements || {}, this.tagRefinements = d.tagRefinements || [], this.hierarchicalFacetsRefinements = d.hierarchicalFacetsRefinements || {};
    var h = this;
    Object.keys(d).forEach(function(v) {
      var b = g.PARAMETERS.indexOf(v) !== -1, m = d[v] !== void 0;
      !b && m && (h[v] = d[v]);
    });
  }
  return g.PARAMETERS = Object.keys(new g()), g._parseNumbers = function(p) {
    if (p instanceof g) return p;
    var d = {}, h = [
      "aroundPrecision",
      "aroundRadius",
      "getRankingInfo",
      "minWordSizefor2Typos",
      "minWordSizefor1Typo",
      "page",
      "maxValuesPerFacet",
      "distinct",
      "minimumAroundRadius",
      "hitsPerPage",
      "minProximity"
    ];
    if (h.forEach(function(b) {
      var m = p[b];
      if (typeof m == "string") {
        var S = parseFloat(m);
        d[b] = isNaN(S) ? m : S;
      }
    }), Array.isArray(p.insideBoundingBox) && (d.insideBoundingBox = p.insideBoundingBox.map(function(b) {
      return Array.isArray(b) ? b.map(function(m) {
        return parseFloat(m);
      }) : b;
    })), p.numericRefinements) {
      var v = {};
      Object.keys(p.numericRefinements).forEach(function(b) {
        var m = p.numericRefinements[b] || {};
        v[b] = {}, Object.keys(m).forEach(function(S) {
          var I = m[S], C = I.map(function(T) {
            return Array.isArray(T) ? T.map(function(E) {
              return typeof E == "string" ? parseFloat(E) : E;
            }) : typeof T == "string" ? parseFloat(T) : T;
          });
          v[b][S] = C;
        });
      }), d.numericRefinements = v;
    }
    return n(p, d);
  }, g.make = function(d) {
    var h = new g(d), v = d.hierarchicalFacets || [];
    return v.forEach(function(b) {
      if (b.rootPath) {
        var m = h.getHierarchicalRefinement(b.name);
        m.length > 0 && m[0].indexOf(b.rootPath) !== 0 && (h = h.clearRefinements(b.name)), m = h.getHierarchicalRefinement(b.name), m.length === 0 && (h = h.toggleHierarchicalFacetRefinement(
          b.name,
          b.rootPath
        ));
      }
    }), h;
  }, g.validate = function(p, d) {
    var h = d || {};
    return p.tagFilters && h.tagRefinements && h.tagRefinements.length > 0 ? new Error(
      "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method."
    ) : p.tagRefinements.length > 0 && h.tagFilters ? new Error(
      "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method."
    ) : p.numericFilters && h.numericRefinements && i(h.numericRefinements) ? new Error(
      "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
    ) : i(p.numericRefinements) && h.numericFilters ? new Error(
      "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
    ) : null;
  }, g.prototype = {
    constructor: g,
    /**
     * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
     * @method
     * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
     * - If not given, means to clear all the filters.
     * - If `string`, means to clear all refinements for the `attribute` named filter.
     * - If `function`, means to clear all the refinements that return truthy values.
     * @return {SearchParameters} new instance with filters cleared
     */
    clearRefinements: function(d) {
      var h = {
        numericRefinements: this._clearNumericRefinements(d),
        facetsRefinements: c.clearRefinement(
          this.facetsRefinements,
          d,
          "conjunctiveFacet"
        ),
        facetsExcludes: c.clearRefinement(
          this.facetsExcludes,
          d,
          "exclude"
        ),
        disjunctiveFacetsRefinements: c.clearRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          "disjunctiveFacet"
        ),
        hierarchicalFacetsRefinements: c.clearRefinement(
          this.hierarchicalFacetsRefinements,
          d,
          "hierarchicalFacet"
        )
      };
      return h.numericRefinements === this.numericRefinements && h.facetsRefinements === this.facetsRefinements && h.facetsExcludes === this.facetsExcludes && h.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && h.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(h);
    },
    /**
     * Remove all the refined tags from the SearchParameters
     * @method
     * @return {SearchParameters} new instance with tags cleared
     */
    clearTags: function() {
      return this.tagFilters === void 0 && this.tagRefinements.length === 0 ? this : this.setQueryParameters({
        tagFilters: void 0,
        tagRefinements: []
      });
    },
    /**
     * Set the index.
     * @method
     * @param {string} index the index name
     * @return {SearchParameters} new instance
     */
    setIndex: function(d) {
      return d === this.index ? this : this.setQueryParameters({
        index: d
      });
    },
    /**
     * Query setter
     * @method
     * @param {string} newQuery value for the new query
     * @return {SearchParameters} new instance
     */
    setQuery: function(d) {
      return d === this.query ? this : this.setQueryParameters({
        query: d
      });
    },
    /**
     * Page setter
     * @method
     * @param {number} newPage new page number
     * @return {SearchParameters} new instance
     */
    setPage: function(d) {
      return d === this.page ? this : this.setQueryParameters({
        page: d
      });
    },
    /**
     * Facets setter
     * The facets are the simple facets, used for conjunctive (and) faceting.
     * @method
     * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
     * @return {SearchParameters} new instance
     */
    setFacets: function(d) {
      return this.setQueryParameters({
        facets: d
      });
    },
    /**
     * Disjunctive facets setter
     * Change the list of disjunctive (or) facets the helper chan handle.
     * @method
     * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
     * @return {SearchParameters} new instance
     */
    setDisjunctiveFacets: function(d) {
      return this.setQueryParameters({
        disjunctiveFacets: d
      });
    },
    /**
     * HitsPerPage setter
     * Hits per page represents the number of hits retrieved for this query
     * @method
     * @param {number} n number of hits retrieved per page of results
     * @return {SearchParameters} new instance
     */
    setHitsPerPage: function(d) {
      return this.hitsPerPage === d ? this : this.setQueryParameters({
        hitsPerPage: d
      });
    },
    /**
     * typoTolerance setter
     * Set the value of typoTolerance
     * @method
     * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
     * @return {SearchParameters} new instance
     */
    setTypoTolerance: function(d) {
      return this.typoTolerance === d ? this : this.setQueryParameters({
        typoTolerance: d
      });
    },
    /**
     * Add a numeric filter for a given attribute
     * When value is an array, they are combined with OR
     * When value is a single value, it will combined with AND
     * @method
     * @param {string} attribute attribute to set the filter on
     * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
     * @param {number | number[]} value value of the filter
     * @return {SearchParameters} new instance
     * @example
     * // for price = 50 or 40
     * state.addNumericRefinement('price', '=', [50, 40]);
     * @example
     * // for size = 38 and 40
     * state.addNumericRefinement('size', '=', 38);
     * state.addNumericRefinement('size', '=', 40);
     */
    addNumericRefinement: function(p, d, h) {
      var v = s(h);
      if (this.isNumericRefined(p, d, v)) return this;
      var b = n({}, this.numericRefinements);
      return b[p] = n({}, b[p]), b[p][d] ? (b[p][d] = b[p][d].slice(), b[p][d].push(v)) : b[p][d] = [v], this.setQueryParameters({
        numericRefinements: b
      });
    },
    /**
     * Get the list of conjunctive refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getConjunctiveRefinements: function(p) {
      return this.isConjunctiveFacet(p) ? this.facetsRefinements[p] || [] : [];
    },
    /**
     * Get the list of disjunctive refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getDisjunctiveRefinements: function(p) {
      return this.isDisjunctiveFacet(p) ? this.disjunctiveFacetsRefinements[p] || [] : [];
    },
    /**
     * Get the list of hierarchical refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getHierarchicalRefinement: function(p) {
      return this.hierarchicalFacetsRefinements[p] || [];
    },
    /**
     * Get the list of exclude refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getExcludeRefinements: function(p) {
      return this.isConjunctiveFacet(p) ? this.facetsExcludes[p] || [] : [];
    },
    /**
     * Remove all the numeric filter for a given (attribute, operator)
     * @method
     * @param {string} attribute attribute to set the filter on
     * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
     * @param {number} [number] the value to be removed
     * @return {SearchParameters} new instance
     */
    removeNumericRefinement: function(p, d, h) {
      var v = h;
      return v !== void 0 ? this.isNumericRefined(p, d, v) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(b, m) {
          return m === p && b.op === d && u(b.val, s(v));
        })
      }) : this : d !== void 0 ? this.isNumericRefined(p, d) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(b, m) {
          return m === p && b.op === d;
        })
      }) : this : this.isNumericRefined(p) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(b, m) {
          return m === p;
        })
      }) : this;
    },
    /**
     * Get the list of numeric refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {SearchParameters.OperatorList} list of refinements
     */
    getNumericRefinements: function(p) {
      return this.numericRefinements[p] || {};
    },
    /**
     * Return the current refinement for the (attribute, operator)
     * @param {string} attribute attribute in the record
     * @param {string} operator operator applied on the refined values
     * @return {Array.<number|number[]>} refined values
     */
    getNumericRefinement: function(p, d) {
      return this.numericRefinements[p] && this.numericRefinements[p][d];
    },
    /**
     * Clear numeric filters.
     * @method
     * @private
     * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
     * - If not given, means to clear all the filters.
     * - If `string`, means to clear all refinements for the `attribute` named filter.
     * - If `function`, means to clear all the refinements that return truthy values.
     * @return {Object.<string, OperatorList>} new numeric refinements
     */
    _clearNumericRefinements: function(d) {
      if (d === void 0)
        return i(this.numericRefinements) ? {} : this.numericRefinements;
      if (typeof d == "string")
        return a(this.numericRefinements, [d]);
      if (typeof d == "function") {
        var h = !1, v = this.numericRefinements, b = Object.keys(v).reduce(
          function(m, S) {
            var I = v[S], C = {};
            return I = I || {}, Object.keys(I).forEach(function(T) {
              var E = I[T] || [], N = [];
              E.forEach(function(y) {
                var w = d(
                  { val: y, op: T },
                  S,
                  "numeric"
                );
                w || N.push(y);
              }), N.length !== E.length && (h = !0), C[T] = N;
            }), m[S] = C, m;
          },
          {}
        );
        return h ? b : this.numericRefinements;
      }
    },
    /**
     * Add a facet to the facets attribute of the helper configuration, if it
     * isn't already present.
     * @method
     * @param {string} facet facet name to add
     * @return {SearchParameters} new instance
     */
    addFacet: function(d) {
      return this.isConjunctiveFacet(d) ? this : this.setQueryParameters({
        facets: this.facets.concat([d])
      });
    },
    /**
     * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
     * configuration, if it isn't already present.
     * @method
     * @param {string} facet disjunctive facet name to add
     * @return {SearchParameters} new instance
     */
    addDisjunctiveFacet: function(d) {
      return this.isDisjunctiveFacet(d) ? this : this.setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.concat([d])
      });
    },
    /**
     * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
     * configuration.
     * @method
     * @param {object} hierarchicalFacet hierarchical facet to add
     * @return {SearchParameters} new instance
     * @throws will throw an error if a hierarchical facet with the same name was already declared
     */
    addHierarchicalFacet: function(d) {
      if (this.isHierarchicalFacet(d.name))
        throw new Error(
          "Cannot declare two hierarchical facets with the same name: `" + d.name + "`"
        );
      return this.setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.concat([d])
      });
    },
    /**
     * Add a refinement on a "normal" facet
     * @method
     * @param {string} facet attribute to apply the faceting on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addFacetRefinement: function(d, h) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return c.isRefined(this.facetsRefinements, d, h) ? this : this.setQueryParameters({
        facetsRefinements: c.addRefinement(
          this.facetsRefinements,
          d,
          h
        )
      });
    },
    /**
     * Exclude a value from a "normal" facet
     * @method
     * @param {string} facet attribute to apply the exclusion on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addExcludeRefinement: function(d, h) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return c.isRefined(this.facetsExcludes, d, h) ? this : this.setQueryParameters({
        facetsExcludes: c.addRefinement(
          this.facetsExcludes,
          d,
          h
        )
      });
    },
    /**
     * Adds a refinement on a disjunctive facet.
     * @method
     * @param {string} facet attribute to apply the faceting on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addDisjunctiveFacetRefinement: function(d, h) {
      if (!this.isDisjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return c.isRefined(this.disjunctiveFacetsRefinements, d, h) ? this : this.setQueryParameters({
        disjunctiveFacetsRefinements: c.addRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          h
        )
      });
    },
    /**
     * addTagRefinement adds a tag to the list used to filter the results
     * @param {string} tag tag to be added
     * @return {SearchParameters} new instance
     */
    addTagRefinement: function(d) {
      if (this.isTagRefined(d)) return this;
      var h = {
        tagRefinements: this.tagRefinements.concat(d)
      };
      return this.setQueryParameters(h);
    },
    /**
     * Remove a facet from the facets attribute of the helper configuration, if it
     * is present.
     * @method
     * @param {string} facet facet name to remove
     * @return {SearchParameters} new instance
     */
    removeFacet: function(d) {
      return this.isConjunctiveFacet(d) ? this.clearRefinements(d).setQueryParameters({
        facets: this.facets.filter(function(h) {
          return h !== d;
        })
      }) : this;
    },
    /**
     * Remove a disjunctive facet from the disjunctiveFacets attribute of the
     * helper configuration, if it is present.
     * @method
     * @param {string} facet disjunctive facet name to remove
     * @return {SearchParameters} new instance
     */
    removeDisjunctiveFacet: function(d) {
      return this.isDisjunctiveFacet(d) ? this.clearRefinements(d).setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.filter(function(h) {
          return h !== d;
        })
      }) : this;
    },
    /**
     * Remove a hierarchical facet from the hierarchicalFacets attribute of the
     * helper configuration, if it is present.
     * @method
     * @param {string} facet hierarchical facet name to remove
     * @return {SearchParameters} new instance
     */
    removeHierarchicalFacet: function(d) {
      return this.isHierarchicalFacet(d) ? this.clearRefinements(d).setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.filter(function(h) {
          return h.name !== d;
        })
      }) : this;
    },
    /**
     * Remove a refinement set on facet. If a value is provided, it will clear the
     * refinement for the given value, otherwise it will clear all the refinement
     * values for the faceted attribute.
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} [value] value used to filter
     * @return {SearchParameters} new instance
     */
    removeFacetRefinement: function(d, h) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return c.isRefined(this.facetsRefinements, d, h) ? this.setQueryParameters({
        facetsRefinements: c.removeRefinement(
          this.facetsRefinements,
          d,
          h
        )
      }) : this;
    },
    /**
     * Remove a negative refinement on a facet
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} value value used to filter
     * @return {SearchParameters} new instance
     */
    removeExcludeRefinement: function(d, h) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return c.isRefined(this.facetsExcludes, d, h) ? this.setQueryParameters({
        facetsExcludes: c.removeRefinement(
          this.facetsExcludes,
          d,
          h
        )
      }) : this;
    },
    /**
     * Remove a refinement on a disjunctive facet
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} value value used to filter
     * @return {SearchParameters} new instance
     */
    removeDisjunctiveFacetRefinement: function(d, h) {
      if (!this.isDisjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return c.isRefined(this.disjunctiveFacetsRefinements, d, h) ? this.setQueryParameters({
        disjunctiveFacetsRefinements: c.removeRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          h
        )
      }) : this;
    },
    /**
     * Remove a tag from the list of tag refinements
     * @method
     * @param {string} tag the tag to remove
     * @return {SearchParameters} new instance
     */
    removeTagRefinement: function(d) {
      if (!this.isTagRefined(d)) return this;
      var h = {
        tagRefinements: this.tagRefinements.filter(function(v) {
          return v !== d;
        })
      };
      return this.setQueryParameters(h);
    },
    /**
     * Generic toggle refinement method to use with facet, disjunctive facets
     * and hierarchical facets
     * @param  {string} facet the facet to refine
     * @param  {string} value the associated value
     * @return {SearchParameters} new instance
     * @throws will throw an error if the facet is not declared in the settings of the helper
     * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
     */
    toggleRefinement: function(d, h) {
      return this.toggleFacetRefinement(d, h);
    },
    /**
     * Generic toggle refinement method to use with facet, disjunctive facets
     * and hierarchical facets
     * @param  {string} facet the facet to refine
     * @param  {string} value the associated value
     * @return {SearchParameters} new instance
     * @throws will throw an error if the facet is not declared in the settings of the helper
     */
    toggleFacetRefinement: function(d, h) {
      if (this.isHierarchicalFacet(d))
        return this.toggleHierarchicalFacetRefinement(d, h);
      if (this.isConjunctiveFacet(d))
        return this.toggleConjunctiveFacetRefinement(d, h);
      if (this.isDisjunctiveFacet(d))
        return this.toggleDisjunctiveFacetRefinement(d, h);
      throw new Error(
        "Cannot refine the undeclared facet " + d + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets"
      );
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleConjunctiveFacetRefinement: function(d, h) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        facetsRefinements: c.toggleRefinement(
          this.facetsRefinements,
          d,
          h
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleExcludeFacetRefinement: function(d, h) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        facetsExcludes: c.toggleRefinement(
          this.facetsExcludes,
          d,
          h
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleDisjunctiveFacetRefinement: function(d, h) {
      if (!this.isDisjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        disjunctiveFacetsRefinements: c.toggleRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          h
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleHierarchicalFacetRefinement: function(d, h) {
      if (!this.isHierarchicalFacet(d))
        throw new Error(
          d + " is not defined in the hierarchicalFacets attribute of the helper configuration"
        );
      var v = this._getHierarchicalFacetSeparator(
        this.getHierarchicalFacetByName(d)
      ), b = {}, m = this.hierarchicalFacetsRefinements[d] !== void 0 && this.hierarchicalFacetsRefinements[d].length > 0 && // remove current refinement:
      // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
      (this.hierarchicalFacetsRefinements[d][0] === h || // remove a parent refinement of the current refinement:
      //  - refinement was 'beer > IPA > Flying dog'
      //  - call is toggleRefine('beer > IPA')
      //  - refinement should be `beer`
      this.hierarchicalFacetsRefinements[d][0].indexOf(
        h + v
      ) === 0);
      return m ? h.indexOf(v) === -1 ? b[d] = [] : b[d] = [h.slice(0, h.lastIndexOf(v))] : b[d] = [h], this.setQueryParameters({
        hierarchicalFacetsRefinements: e(
          b,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Adds a refinement on a hierarchical facet.
     * @param {string} facet the facet name
     * @param {string} path the hierarchical facet path
     * @return {SearchParameter} the new state
     * @throws Error if the facet is not defined or if the facet is refined
     */
    addHierarchicalFacetRefinement: function(p, d) {
      if (this.isHierarchicalFacetRefined(p))
        throw new Error(p + " is already refined.");
      if (!this.isHierarchicalFacet(p))
        throw new Error(
          p + " is not defined in the hierarchicalFacets attribute of the helper configuration."
        );
      var h = {};
      return h[p] = [d], this.setQueryParameters({
        hierarchicalFacetsRefinements: e(
          h,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Removes the refinement set on a hierarchical facet.
     * @param {string} facet the facet name
     * @return {SearchParameter} the new state
     * @throws Error if the facet is not defined or if the facet is not refined
     */
    removeHierarchicalFacetRefinement: function(p) {
      if (!this.isHierarchicalFacetRefined(p))
        return this;
      var d = {};
      return d[p] = [], this.setQueryParameters({
        hierarchicalFacetsRefinements: e(
          d,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Switch the tag refinement
     * @method
     * @param {string} tag the tag to remove or add
     * @return {SearchParameters} new instance
     */
    toggleTagRefinement: function(d) {
      return this.isTagRefined(d) ? this.removeTagRefinement(d) : this.addTagRefinement(d);
    },
    /**
     * Test if the facet name is from one of the disjunctive facets
     * @method
     * @param {string} facet facet name to test
     * @return {boolean} true if facet is a disjunctive facet
     */
    isDisjunctiveFacet: function(p) {
      return this.disjunctiveFacets.indexOf(p) > -1;
    },
    /**
     * Test if the facet name is from one of the hierarchical facets
     * @method
     * @param {string} facetName facet name to test
     * @return {boolean} true if facetName is a hierarchical facet
     */
    isHierarchicalFacet: function(p) {
      return this.getHierarchicalFacetByName(p) !== void 0;
    },
    /**
     * Test if the facet name is from one of the conjunctive/normal facets
     * @method
     * @param {string} facet facet name to test
     * @return {boolean} true if facet is a conjunctive facet
     */
    isConjunctiveFacet: function(p) {
      return this.facets.indexOf(p) > -1;
    },
    /**
     * Returns true if the facet is refined, either for a specific value or in
     * general.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value, optional value. If passed will test that this value
     * is filtering the given facet.
     * @return {boolean} returns true if refined
     */
    isFacetRefined: function(d, h) {
      return this.isConjunctiveFacet(d) ? c.isRefined(this.facetsRefinements, d, h) : !1;
    },
    /**
     * Returns true if the facet contains exclusions or if a specific value is
     * excluded.
     *
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} [value] optional value. If passed will test that this value
     * is filtering the given facet.
     * @return {boolean} returns true if refined
     */
    isExcludeRefined: function(d, h) {
      return this.isConjunctiveFacet(d) ? c.isRefined(this.facetsExcludes, d, h) : !1;
    },
    /**
     * Returns true if the facet contains a refinement, or if a value passed is a
     * refinement for the facet.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value optional, will test if the value is used for refinement
     * if there is one, otherwise will test if the facet contains any refinement
     * @return {boolean} true if the facet is refined
     */
    isDisjunctiveFacetRefined: function(d, h) {
      return this.isDisjunctiveFacet(d) ? c.isRefined(
        this.disjunctiveFacetsRefinements,
        d,
        h
      ) : !1;
    },
    /**
     * Returns true if the facet contains a refinement, or if a value passed is a
     * refinement for the facet.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value optional, will test if the value is used for refinement
     * if there is one, otherwise will test if the facet contains any refinement
     * @return {boolean} true if the facet is refined
     */
    isHierarchicalFacetRefined: function(d, h) {
      if (!this.isHierarchicalFacet(d))
        return !1;
      var v = this.getHierarchicalRefinement(d);
      return h ? v.indexOf(h) !== -1 : v.length > 0;
    },
    /**
     * Test if the triple (attribute, operator, value) is already refined.
     * If only the attribute and the operator are provided, it tests if the
     * contains any refinement value.
     * @method
     * @param {string} attribute attribute for which the refinement is applied
     * @param {string} [operator] operator of the refinement
     * @param {string} [value] value of the refinement
     * @return {boolean} true if it is refined
     */
    isNumericRefined: function(d, h, v) {
      if (v === void 0 && h === void 0)
        return !!this.numericRefinements[d];
      var b = this.numericRefinements[d] && this.numericRefinements[d][h] !== void 0;
      if (v === void 0 || !b)
        return b;
      var m = s(v), S = f(this.numericRefinements[d][h], m) !== void 0;
      return b && S;
    },
    /**
     * Returns true if the tag refined, false otherwise
     * @method
     * @param {string} tag the tag to check
     * @return {boolean} true if tag is refined
     */
    isTagRefined: function(d) {
      return this.tagRefinements.indexOf(d) !== -1;
    },
    /**
     * Returns the list of all disjunctive facets refined
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {string[]} returns the list of refinements
     */
    getRefinedDisjunctiveFacets: function() {
      var d = this, h = r(
        Object.keys(this.numericRefinements).filter(function(v) {
          return Object.keys(d.numericRefinements[v]).length > 0;
        }),
        this.disjunctiveFacets
      );
      return Object.keys(this.disjunctiveFacetsRefinements).filter(function(v) {
        return d.disjunctiveFacetsRefinements[v].length > 0;
      }).concat(h).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
     * Returns the list of all disjunctive facets refined
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {string[]} returns the list of refinements
     */
    getRefinedHierarchicalFacets: function() {
      var d = this;
      return r(
        // enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(h) {
          return h.name;
        }),
        Object.keys(this.hierarchicalFacetsRefinements).filter(function(h) {
          return d.hierarchicalFacetsRefinements[h].length > 0;
        })
      ).sort();
    },
    /**
     * Returned the list of all disjunctive facets not refined
     * @method
     * @return {string[]} returns the list of facets that are not refined
     */
    getUnrefinedDisjunctiveFacets: function() {
      var p = this.getRefinedDisjunctiveFacets();
      return this.disjunctiveFacets.filter(function(d) {
        return p.indexOf(d) === -1;
      });
    },
    managedParameters: [
      "index",
      "facets",
      "disjunctiveFacets",
      "facetsRefinements",
      "hierarchicalFacets",
      "facetsExcludes",
      "disjunctiveFacetsRefinements",
      "numericRefinements",
      "tagRefinements",
      "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function() {
      var d = this.managedParameters, h = {}, v = this;
      return Object.keys(this).forEach(function(b) {
        var m = v[b];
        d.indexOf(b) === -1 && m !== void 0 && (h[b] = m);
      }), h;
    },
    /**
     * Let the user set a specific value for a given parameter. Will return the
     * same instance if the parameter is invalid or if the value is the same as the
     * previous one.
     * @method
     * @param {string} parameter the parameter name
     * @param {any} value the value to be set, must be compliant with the definition
     * of the attribute on the object
     * @return {SearchParameters} the updated state
     */
    setQueryParameter: function(d, h) {
      if (this[d] === h) return this;
      var v = {};
      return v[d] = h, this.setQueryParameters(v);
    },
    /**
     * Let the user set any of the parameters with a plain object.
     * @method
     * @param {object} params all the keys and the values to be updated
     * @return {SearchParameters} a new updated instance
     */
    setQueryParameters: function(d) {
      if (!d) return this;
      var h = g.validate(this, d);
      if (h)
        throw h;
      var v = this, b = g._parseNumbers(d), m = Object.keys(this).reduce(function(I, C) {
        return I[C] = v[C], I;
      }, {}), S = Object.keys(b).reduce(
        function(I, C) {
          var T = I[C] !== void 0, E = b[C] !== void 0;
          return T && !E ? a(I, [C]) : (E && (I[C] = b[C]), I);
        },
        m
      );
      return new this.constructor(S);
    },
    /**
     * Returns a new instance with the page reset. Two scenarios possible:
     * the page is omitted -> return the given instance
     * the page is set -> return a new instance with a page of 0
     * @return {SearchParameters} a new updated instance
     */
    resetPage: function() {
      return this.page === void 0 ? this : this.setPage(0);
    },
    /**
     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.separator or `>` as default
     */
    _getHierarchicalFacetSortBy: function(p) {
      return p.sortBy || ["isRefined:desc", "name:asc"];
    },
    /**
     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.separator or `>` as default
     */
    _getHierarchicalFacetSeparator: function(p) {
      return p.separator || " > ";
    },
    /**
     * Helper function to get the hierarchicalFacet prefix path or null
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.rootPath or null as default
     */
    _getHierarchicalRootPath: function(p) {
      return p.rootPath || null;
    },
    /**
     * Helper function to check if we show the parent level of the hierarchicalFacet
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
     */
    _getHierarchicalShowParentLevel: function(p) {
      return typeof p.showParentLevel == "boolean" ? p.showParentLevel : !0;
    },
    /**
     * Helper function to get the hierarchicalFacet by it's name
     * @param  {string} hierarchicalFacetName the hierarchicalFacet name
     * @return {object} a hierarchicalFacet
     */
    getHierarchicalFacetByName: function(p) {
      return t(this.hierarchicalFacets, function(d) {
        return d.name === p;
      });
    },
    /**
     * Get the current breadcrumb for a hierarchical facet, as an array
     * @param  {string} facetName Hierarchical facet name
     * @return {array.<string>} the path as an array of string
     */
    getHierarchicalFacetBreadcrumb: function(p) {
      if (!this.isHierarchicalFacet(p))
        return [];
      var d = this.getHierarchicalRefinement(p)[0];
      if (!d) return [];
      var h = this._getHierarchicalFacetSeparator(
        this.getHierarchicalFacetByName(p)
      ), v = d.split(h);
      return v.map(function(b) {
        return b.trim();
      });
    },
    toString: function() {
      return JSON.stringify(this, null, 2);
    }
  }, pd = g, pd;
}
var gd, Uv;
function W$() {
  return Uv || (Uv = 1, gd = function(t) {
    return Array.isArray(t) ? t.filter(Boolean) : [];
  }), gd;
}
var vd, Vv;
function U$() {
  return Vv || (Vv = 1, vd = function(t, r) {
    if (!Array.isArray(t))
      return -1;
    for (var n = 0; n < t.length; n++)
      if (r(t[n]))
        return n;
    return -1;
  }), vd;
}
var yd, Hv;
function uI() {
  if (Hv) return yd;
  Hv = 1;
  var e = Ls();
  return yd = function(r, n) {
    var i = (n || []).map(function(a) {
      return a.split(":");
    });
    return r.reduce(
      function(s, o) {
        var c = o.split(":"), u = e(
          i,
          function(f) {
            return f[0] === c[0];
          }
        );
        return c.length > 1 || !u ? (s[0].push(c[0]), s[1].push(c[1]), s) : (s[0].push(u[0]), s[1].push(u[1]), s);
      },
      [[], []]
    );
  }, yd;
}
var bd, qv;
function V$() {
  if (qv) return bd;
  qv = 1;
  function e() {
    var t = Array.prototype.slice.call(arguments);
    return t.reduceRight(function(r, n) {
      return Object.keys(Object(n)).forEach(function(i) {
        var a = typeof r[i] == "number" ? r[i] : 0, s = n[i];
        s !== void 0 && s >= a && (r[i] !== void 0 && delete r[i], r[i] = s);
      }), r;
    }, {});
  }
  return bd = e, bd;
}
var Sd, zv;
function dI() {
  if (zv) return Sd;
  zv = 1;
  function e(r, n) {
    if (r !== n) {
      var i = r !== void 0, a = r === null, s = n !== void 0, o = n === null;
      if (!o && r > n || a && s || !i)
        return 1;
      if (!a && r < n || o && i || !s)
        return -1;
    }
    return 0;
  }
  function t(r, n, i) {
    if (!Array.isArray(r))
      return [];
    Array.isArray(i) || (i = []);
    var a = r.map(function(s, o) {
      return {
        criteria: n.map(function(c) {
          return s[c];
        }),
        index: o,
        value: s
      };
    });
    return a.sort(function(o, c) {
      for (var u = -1; ++u < o.criteria.length; ) {
        var f = e(o.criteria[u], c.criteria[u]);
        if (f)
          return u >= i.length ? f : i[u] === "desc" ? -f : f;
      }
      return o.index - c.index;
    }), a.map(function(s) {
      return s.value;
    });
  }
  return Sd = t, Sd;
}
var wd, Bv;
function H$() {
  if (Bv) return wd;
  Bv = 1, wd = s;
  var e = jh(), t = Ls(), r = uI(), n = dI(), i = e.escapeFacetValue, a = e.unescapeFacetValue;
  function s(f) {
    return function(p, d) {
      var h = f.hierarchicalFacets[d], v = f.hierarchicalFacetsRefinements[h.name] && f.hierarchicalFacetsRefinements[h.name][0] || "", b = f._getHierarchicalFacetSeparator(h), m = f._getHierarchicalRootPath(h), S = f._getHierarchicalShowParentLevel(h), I = r(
        f._getHierarchicalFacetSortBy(h)
      ), C = p.every(function(N) {
        return N.exhaustive;
      }), T = o(
        I,
        b,
        m,
        S,
        v
      ), E = p;
      return m && (E = p.slice(
        m.split(b).length
      )), E.reduce(T, {
        name: f.hierarchicalFacets[d].name,
        count: null,
        // root level, no count
        isRefined: !0,
        // root level, always refined
        path: null,
        // root level, no path
        escapedValue: null,
        exhaustive: C,
        data: null
      });
    };
  }
  function o(f, g, p, d, h) {
    return function(b, m, S) {
      var I = b;
      if (S > 0) {
        var C = 0;
        for (I = b; C < S; ) {
          var T = I && Array.isArray(I.data) ? I.data : [];
          I = t(T, function(N) {
            return N.isRefined;
          }), C++;
        }
      }
      if (I) {
        var E = Object.keys(m.data).map(function(N) {
          return [N, m.data[N]];
        }).filter(function(N) {
          var y = N[0];
          return c(
            y,
            I.path || p,
            h,
            g,
            p,
            d
          );
        });
        I.data = n(
          E.map(function(N) {
            var y = N[0], w = N[1];
            return u(
              w,
              y,
              g,
              a(h),
              m.exhaustive
            );
          }),
          f[0],
          f[1]
        );
      }
      return b;
    };
  }
  function c(f, g, p, d, h, v) {
    return h && (f.indexOf(h) !== 0 || h === f) ? !1 : !h && f.indexOf(d) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    h && f.split(d).length - h.split(d).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    f.indexOf(d) === -1 && p.indexOf(d) === -1 || // currentRefinement is a child of the facet value
    p.indexOf(f) === 0 || // facetValue is a child of the current parent, add it
    f.indexOf(g + d) === 0 && (v || f.indexOf(p) === 0);
  }
  function u(f, g, p, d, h) {
    var v = g.split(p);
    return {
      name: v[v.length - 1].trim(),
      path: g,
      escapedValue: i(g),
      count: f,
      isRefined: d === g || d.indexOf(g + p) === 0,
      exhaustive: h,
      data: null
    };
  }
  return wd;
}
var Id, Gv;
function fI() {
  if (Gv) return Id;
  Gv = 1;
  var e = W$(), t = Hh(), r = jh(), n = Ls(), i = U$(), a = uI(), s = V$(), o = dI(), c = r.escapeFacetValue, u = r.unescapeFacetValue, f = H$();
  function g(y) {
    var w = {};
    return y.forEach(function(P, _) {
      w[P] = _;
    }), w;
  }
  function p(y, w, P) {
    w && w[P] && (y.stats = w[P]);
  }
  function d(y, w) {
    return n(
      y,
      function(_) {
        var D = _.attributes || [];
        return D.indexOf(w) > -1;
      }
    );
  }
  function h(y, w, P) {
    var _ = w[0] || {};
    this._rawResults = w;
    var D = this;
    Object.keys(_).forEach(function(j) {
      D[j] = _[j];
    });
    var R = t(P, {
      persistHierarchicalRootCount: !1
    });
    Object.keys(R).forEach(function(j) {
      D[j] = R[j];
    }), this.processingTimeMS = w.reduce(function(j, B) {
      return B.processingTimeMS === void 0 ? j : j + B.processingTimeMS;
    }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = y.hierarchicalFacets.map(
      function() {
        return [];
      }
    ), this.facets = [];
    var x = y.getRefinedDisjunctiveFacets(), F = g(y.facets), W = g(y.disjunctiveFacets), A = 1, M = _.facets || {};
    Object.keys(M).forEach(function(j) {
      var B = M[j], L = d(
        y.hierarchicalFacets,
        j
      );
      if (L) {
        var H = L.attributes.indexOf(j), q = i(y.hierarchicalFacets, function(re) {
          return re.name === L.name;
        });
        D.hierarchicalFacets[q][H] = {
          attribute: j,
          data: B,
          exhaustive: _.exhaustiveFacetsCount
        };
      } else {
        var te = y.disjunctiveFacets.indexOf(j) !== -1, G = y.facets.indexOf(j) !== -1, X;
        te && (X = W[j], D.disjunctiveFacets[X] = {
          name: j,
          data: B,
          exhaustive: _.exhaustiveFacetsCount
        }, p(
          D.disjunctiveFacets[X],
          _.facets_stats,
          j
        )), G && (X = F[j], D.facets[X] = {
          name: j,
          data: B,
          exhaustive: _.exhaustiveFacetsCount
        }, p(
          D.facets[X],
          _.facets_stats,
          j
        ));
      }
    }), this.hierarchicalFacets = e(this.hierarchicalFacets), x.forEach(function(j) {
      var B = w[A], L = B && B.facets ? B.facets : {}, H = y.getHierarchicalFacetByName(j);
      Object.keys(L).forEach(function(q) {
        var te = L[q], G;
        if (H) {
          G = i(y.hierarchicalFacets, function(oe) {
            return oe.name === H.name;
          });
          var X = i(
            D.hierarchicalFacets[G],
            function(oe) {
              return oe.attribute === q;
            }
          );
          if (X === -1)
            return;
          D.hierarchicalFacets[G][X].data = D.persistHierarchicalRootCount ? s(
            D.hierarchicalFacets[G][X].data,
            te
          ) : t(
            te,
            D.hierarchicalFacets[G][X].data
          );
        } else {
          G = W[q];
          var re = _.facets && _.facets[q] || {};
          D.disjunctiveFacets[G] = {
            name: q,
            data: s(re, te),
            exhaustive: B.exhaustiveFacetsCount
          }, p(
            D.disjunctiveFacets[G],
            B.facets_stats,
            q
          ), y.disjunctiveFacetsRefinements[q] && y.disjunctiveFacetsRefinements[q].forEach(function(oe) {
            !D.disjunctiveFacets[G].data[oe] && y.disjunctiveFacetsRefinements[q].indexOf(
              u(oe)
            ) > -1 && (D.disjunctiveFacets[G].data[oe] = 0);
          });
        }
      }), A++;
    }), y.getRefinedHierarchicalFacets().forEach(function(j) {
      var B = y.getHierarchicalFacetByName(j), L = y._getHierarchicalFacetSeparator(B), H = y.getHierarchicalRefinement(j);
      H.length === 0 || H[0].split(L).length < 2 || w.slice(A).forEach(function(q) {
        var te = q && q.facets ? q.facets : {};
        Object.keys(te).forEach(function(G) {
          var X = te[G], re = i(y.hierarchicalFacets, function(Q) {
            return Q.name === B.name;
          }), oe = i(
            D.hierarchicalFacets[re],
            function(Q) {
              return Q.attribute === G;
            }
          );
          if (oe !== -1) {
            var ue = {};
            if (H.length > 0 && !D.persistHierarchicalRootCount) {
              var de = H[0].split(L)[0];
              ue[de] = D.hierarchicalFacets[re][oe].data[de];
            }
            D.hierarchicalFacets[re][oe].data = t(
              ue,
              X,
              D.hierarchicalFacets[re][oe].data
            );
          }
        }), A++;
      });
    }), Object.keys(y.facetsExcludes).forEach(function(j) {
      var B = y.facetsExcludes[j], L = F[j];
      D.facets[L] = {
        name: j,
        data: M[j],
        exhaustive: _.exhaustiveFacetsCount
      }, B.forEach(function(H) {
        D.facets[L] = D.facets[L] || { name: j }, D.facets[L].data = D.facets[L].data || {}, D.facets[L].data[H] = 0;
      });
    }), this.hierarchicalFacets = this.hierarchicalFacets.map(
      f(y)
    ), this.facets = e(this.facets), this.disjunctiveFacets = e(this.disjunctiveFacets), this._state = y;
  }
  h.prototype.getFacetByName = function(y) {
    function w(P) {
      return P.name === y;
    }
    return n(this.facets, w) || n(this.disjunctiveFacets, w) || n(this.hierarchicalFacets, w);
  };
  function v(y, w) {
    function P(M) {
      return M.name === w;
    }
    if (y._state.isConjunctiveFacet(w)) {
      var _ = n(y.facets, P);
      return _ ? Object.keys(_.data).map(function(M) {
        var j = c(M);
        return {
          name: M,
          escapedValue: j,
          count: _.data[M],
          isRefined: y._state.isFacetRefined(w, j),
          isExcluded: y._state.isExcludeRefined(w, M)
        };
      }) : [];
    } else if (y._state.isDisjunctiveFacet(w)) {
      var D = n(y.disjunctiveFacets, P);
      return D ? Object.keys(D.data).map(function(M) {
        var j = c(M);
        return {
          name: M,
          escapedValue: j,
          count: D.data[M],
          isRefined: y._state.isDisjunctiveFacetRefined(w, j)
        };
      }) : [];
    } else if (y._state.isHierarchicalFacet(w)) {
      var R = n(y.hierarchicalFacets, P);
      if (!R) return R;
      var x = y._state.getHierarchicalFacetByName(w), F = y._state._getHierarchicalFacetSeparator(x), W = u(
        y._state.getHierarchicalRefinement(w)[0] || ""
      );
      W.indexOf(x.rootPath) === 0 && (W = W.replace(
        x.rootPath + F,
        ""
      ));
      var A = W.split(F);
      return A.unshift(w), b(R, A, 0), R;
    }
  }
  function b(y, w, P) {
    y.isRefined = y.name === (w[P] && w[P].trim()), y.data && y.data.forEach(function(_) {
      b(_, w, P + 1);
    });
  }
  function m(y, w, P, _) {
    if (_ = _ || 0, Array.isArray(w))
      return y(w, P[_]);
    if (!w.data || w.data.length === 0)
      return w;
    var D = w.data.map(function(F) {
      return m(y, F, P, _ + 1);
    }), R = y(D, P[_]), x = t({ data: R }, w);
    return x;
  }
  h.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"];
  function S(y, w) {
    return w.sort(y);
  }
  function I(y, w) {
    var P = [], _ = [], D = w.hide || [], R = w.order || [], x = R.reduce(function(A, M, j) {
      return A[M] = j, A;
    }, {});
    y.forEach(function(A) {
      var M = A.path || A.name, j = D.indexOf(M) > -1;
      !j && x[M] !== void 0 ? P[x[M]] = A : j || _.push(A);
    }), P = P.filter(function(A) {
      return A;
    });
    var F = w.sortRemainingBy, W;
    return F === "hidden" ? P : (F === "alpha" ? W = [
      ["path", "name"],
      ["asc", "asc"]
    ] : W = [["count"], ["desc"]], P.concat(
      o(_, W[0], W[1])
    ));
  }
  function C(y, w) {
    return y.renderingContent && y.renderingContent.facetOrdering && y.renderingContent.facetOrdering.values && y.renderingContent.facetOrdering.values[w];
  }
  h.prototype.getFacetValues = function(y, w) {
    var P = v(this, y);
    if (P) {
      var _ = t(w, {
        sortBy: h.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(w && w.sortBy)
      }), D = this, R;
      if (Array.isArray(P))
        R = [y];
      else {
        var x = D._state.getHierarchicalFacetByName(P.name);
        R = x.attributes;
      }
      return m(
        function(F, W) {
          if (_.facetOrdering) {
            var A = C(D, W);
            if (A)
              return I(F, A);
          }
          if (Array.isArray(_.sortBy)) {
            var M = a(_.sortBy, h.DEFAULT_SORT);
            return o(F, M[0], M[1]);
          } else if (typeof _.sortBy == "function")
            return S(_.sortBy, F);
          throw new Error(
            "options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function"
          );
        },
        P,
        R
      );
    }
  }, h.prototype.getFacetStats = function(y) {
    if (this._state.isConjunctiveFacet(y))
      return T(this.facets, y);
    if (this._state.isDisjunctiveFacet(y))
      return T(this.disjunctiveFacets, y);
  };
  function T(y, w) {
    var P = n(y, function(_) {
      return _.name === w;
    });
    return P && P.stats;
  }
  h.prototype.getRefinements = function() {
    var y = this._state, w = this, P = [];
    return Object.keys(y.facetsRefinements).forEach(function(_) {
      y.facetsRefinements[_].forEach(function(D) {
        P.push(
          E(y, "facet", _, D, w.facets)
        );
      });
    }), Object.keys(y.facetsExcludes).forEach(function(_) {
      y.facetsExcludes[_].forEach(function(D) {
        P.push(
          E(y, "exclude", _, D, w.facets)
        );
      });
    }), Object.keys(y.disjunctiveFacetsRefinements).forEach(function(_) {
      y.disjunctiveFacetsRefinements[_].forEach(function(D) {
        P.push(
          E(
            y,
            "disjunctive",
            _,
            D,
            w.disjunctiveFacets
          )
        );
      });
    }), Object.keys(y.hierarchicalFacetsRefinements).forEach(function(_) {
      y.hierarchicalFacetsRefinements[_].forEach(function(D) {
        P.push(
          N(
            y,
            _,
            D,
            w.hierarchicalFacets
          )
        );
      });
    }), Object.keys(y.numericRefinements).forEach(function(_) {
      var D = y.numericRefinements[_];
      Object.keys(D).forEach(function(R) {
        D[R].forEach(function(x) {
          P.push({
            type: "numeric",
            attributeName: _,
            name: x,
            numericValue: x,
            operator: R
          });
        });
      });
    }), y.tagRefinements.forEach(function(_) {
      P.push({ type: "tag", attributeName: "_tags", name: _ });
    }), P;
  };
  function E(y, w, P, _, D) {
    var R = n(D, function(W) {
      return W.name === P;
    }), x = R && R.data && R.data[_] ? R.data[_] : 0, F = R && R.exhaustive || !1;
    return {
      type: w,
      attributeName: P,
      name: _,
      count: x,
      exhaustive: F
    };
  }
  function N(y, w, P, _) {
    var D = y.getHierarchicalFacetByName(w), R = y._getHierarchicalFacetSeparator(D), x = P.split(R), F = n(_, function(B) {
      return B.name === w;
    }), W = x.reduce(function(B, L) {
      var H = B && n(B.data, function(q) {
        return q.name === L;
      });
      return H !== void 0 ? H : B;
    }, F), A = W && W.count || 0, M = W && W.exhaustive || !1, j = W && W.path || "";
    return {
      type: "hierarchical",
      attributeName: w,
      name: j,
      count: A,
      exhaustive: M
    };
  }
  return Id = h, Id;
}
var Cd, Qv;
function q$() {
  return Qv || (Qv = 1, Cd = function(t) {
    return t.reduce(function(r, n) {
      return r.concat(n);
    }, []);
  }), Cd;
}
var Pd, Zv;
function z$() {
  if (Zv) return Pd;
  Zv = 1;
  var e = Ls(), t = q$();
  function r(i, a) {
    var s = [];
    return Object.keys(i).forEach(function(o) {
      i[o].count < 2 && (i[o].indexSum += 100), s.push({
        objectID: o,
        avgOfIndices: i[o].indexSum / a
      });
    }), s.sort(function(o, c) {
      return o.avgOfIndices > c.avgOfIndices ? 1 : -1;
    });
  }
  function n(i, a) {
    var s = {};
    a.forEach(function(u) {
      u.forEach(function(f, g) {
        i.includes(f.objectID) || (s[f.objectID] ? s[f.objectID] = {
          indexSum: s[f.objectID].indexSum + g,
          count: s[f.objectID].count + 1
        } : s[f.objectID] = { indexSum: g, count: 1 });
      });
    });
    var o = r(s, a.length), c = o.reduce(
      function(u, f) {
        var g = e(t(a), function(p) {
          return p.objectID === f.objectID;
        });
        return g ? u.concat(g) : u;
      },
      []
    );
    return c;
  }
  return Pd = n, Pd;
}
var Td, Yv;
function hI() {
  return Yv || (Yv = 1, Td = "3.25.0"), Td;
}
var _d, Kv;
function B$() {
  if (Kv) return _d;
  Kv = 1;
  var e = Lh(), t = x$(), r = jh().escapeFacetValue, n = sI(), i = Wh(), a = Uh(), s = Vh(), o = oI(), c = lI(), u = F$(), f = cI(), g = fI(), p = z$(), d = hI();
  function h(m, S, I, C) {
    typeof m.addAlgoliaAgent == "function" && m.addAlgoliaAgent("JS Helper (" + d + ")"), this.setClient(m);
    var T = I || {};
    T.index = S, this.state = f.make(T), this.recommendState = new o({
      params: T.recommendState
    }), this.lastResults = null, this.lastRecommendResults = null, this._queryId = 0, this._recommendQueryId = 0, this._lastQueryIdReceived = -1, this._lastRecommendQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0, this._currentNbRecommendQueries = 0, this._searchResultsOptions = C, this._recommendCache = {};
  }
  n(h, e), h.prototype.search = function() {
    return this._search({ onlyWithDerivedHelpers: !1 }), this;
  }, h.prototype.searchOnlyWithDerivedHelpers = function() {
    return this._search({ onlyWithDerivedHelpers: !0 }), this;
  }, h.prototype.searchWithComposition = function() {
    return this._runComposition({ onlyWithDerivedHelpers: !0 }), this;
  }, h.prototype.recommend = function() {
    return this._recommend(), this;
  }, h.prototype.getQuery = function() {
    var m = this.state;
    return u._getHitsSearchParams(m);
  }, h.prototype.searchOnce = function(m, S) {
    var I = m ? this.state.setQueryParameters(m) : this.state, C = u._getQueries(I.index, I), T = this;
    if (this._currentNbQueries++, this.emit("searchOnce", {
      state: I
    }), S) {
      this.client.search(C).then(function(E) {
        T._currentNbQueries--, T._currentNbQueries === 0 && T.emit("searchQueueEmpty"), S(null, new g(I, E.results), I);
      }).catch(function(E) {
        T._currentNbQueries--, T._currentNbQueries === 0 && T.emit("searchQueueEmpty"), S(E, null, I);
      });
      return;
    }
    return this.client.search(C).then(
      function(E) {
        return T._currentNbQueries--, T._currentNbQueries === 0 && T.emit("searchQueueEmpty"), {
          content: new g(I, E.results),
          state: I,
          _originalResponse: E
        };
      },
      function(E) {
        throw T._currentNbQueries--, T._currentNbQueries === 0 && T.emit("searchQueueEmpty"), E;
      }
    );
  }, h.prototype.findAnswers = function(m) {
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var S = this.state, I = this.derivedHelpers[0];
    if (!I)
      return Promise.resolve([]);
    var C = I.getModifiedState(S), T = i(
      {
        attributesForPrediction: m.attributesForPrediction,
        nbHits: m.nbHits
      },
      {
        params: s(u._getHitsSearchParams(C), [
          "attributesToSnippet",
          "hitsPerPage",
          "restrictSearchableAttributes",
          "snippetEllipsisText"
        ])
      }
    ), E = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex != "function")
      throw new Error(E);
    var N = this.client.initIndex(C.index);
    if (typeof N.findAnswers != "function")
      throw new Error(E);
    return N.findAnswers(C.query, m.queryLanguages, T);
  }, h.prototype.searchForFacetValues = function(m, S, I, C) {
    var T = typeof this.client.searchForFacetValues == "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets != "function", E = typeof this.client.initIndex == "function";
    if (!T && !E && typeof this.client.search != "function")
      throw new Error(
        "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues"
      );
    var N = this.state.setQueryParameters(C || {}), y = N.isDisjunctiveFacet(m), w = u.getSearchForFacetQuery(
      m,
      S,
      I,
      N
    );
    this._currentNbQueries++;
    var P = this, _;
    return T ? _ = this.client.searchForFacetValues([
      { indexName: N.index, params: w }
    ]) : E ? _ = this.client.initIndex(N.index).searchForFacetValues(w) : (delete w.facetName, _ = this.client.search([
      {
        type: "facet",
        facet: m,
        indexName: N.index,
        params: w
      }
    ]).then(function(R) {
      return R.results[0];
    })), this.emit("searchForFacetValues", {
      state: N,
      facet: m,
      query: S
    }), _.then(
      function(R) {
        return P._currentNbQueries--, P._currentNbQueries === 0 && P.emit("searchQueueEmpty"), R = Array.isArray(R) ? R[0] : R, R.facetHits.forEach(function(x) {
          x.escapedValue = r(x.value), x.isRefined = y ? N.isDisjunctiveFacetRefined(m, x.escapedValue) : N.isFacetRefined(m, x.escapedValue);
        }), R;
      },
      function(D) {
        throw P._currentNbQueries--, P._currentNbQueries === 0 && P.emit("searchQueueEmpty"), D;
      }
    );
  }, h.prototype.searchForCompositionFacetValues = function(m, S, I, C) {
    if (typeof this.client.searchForFacetValues != "function")
      throw new Error(
        "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues"
      );
    var T = this.state.setQueryParameters(C || {}), E = T.isDisjunctiveFacet(m);
    this._currentNbQueries++;
    var N = this, y;
    return y = this.client.searchForFacetValues({
      compositionID: T.index,
      facetName: m,
      searchForFacetValuesRequest: {
        params: {
          query: S,
          maxFacetHits: I,
          searchQuery: u._getCompositionHitsSearchParams(T)
        }
      }
    }), this.emit("searchForFacetValues", {
      state: T,
      facet: m,
      query: S
    }), y.then(
      function(P) {
        return N._currentNbQueries--, N._currentNbQueries === 0 && N.emit("searchQueueEmpty"), P = P.results[0], P.facetHits.forEach(function(_) {
          _.escapedValue = r(_.value), _.isRefined = E ? T.isDisjunctiveFacetRefined(m, _.escapedValue) : T.isFacetRefined(m, _.escapedValue);
        }), P;
      },
      function(w) {
        throw N._currentNbQueries--, N._currentNbQueries === 0 && N.emit("searchQueueEmpty"), w;
      }
    );
  }, h.prototype.setQuery = function(m) {
    return this._change({
      state: this.state.resetPage().setQuery(m),
      isPageReset: !0
    }), this;
  }, h.prototype.clearRefinements = function(m) {
    return this._change({
      state: this.state.resetPage().clearRefinements(m),
      isPageReset: !0
    }), this;
  }, h.prototype.clearTags = function() {
    return this._change({
      state: this.state.resetPage().clearTags(),
      isPageReset: !0
    }), this;
  }, h.prototype.addDisjunctiveFacetRefinement = function(m, S) {
    return this._change({
      state: this.state.resetPage().addDisjunctiveFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
  }, h.prototype.addHierarchicalFacetRefinement = function(m, S) {
    return this._change({
      state: this.state.resetPage().addHierarchicalFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.addNumericRefinement = function(m, S, I) {
    return this._change({
      state: this.state.resetPage().addNumericRefinement(m, S, I),
      isPageReset: !0
    }), this;
  }, h.prototype.addFacetRefinement = function(m, S) {
    return this._change({
      state: this.state.resetPage().addFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
  }, h.prototype.addFacetExclusion = function(m, S) {
    return this._change({
      state: this.state.resetPage().addExcludeRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
  }, h.prototype.addTag = function(m) {
    return this._change({
      state: this.state.resetPage().addTagRefinement(m),
      isPageReset: !0
    }), this;
  }, h.prototype.addFrequentlyBoughtTogether = function(m) {
    return this._recommendChange({
      state: this.recommendState.addFrequentlyBoughtTogether(m)
    }), this;
  }, h.prototype.addRelatedProducts = function(m) {
    return this._recommendChange({
      state: this.recommendState.addRelatedProducts(m)
    }), this;
  }, h.prototype.addTrendingItems = function(m) {
    return this._recommendChange({
      state: this.recommendState.addTrendingItems(m)
    }), this;
  }, h.prototype.addTrendingFacets = function(m) {
    return this._recommendChange({
      state: this.recommendState.addTrendingFacets(m)
    }), this;
  }, h.prototype.addLookingSimilar = function(m) {
    return this._recommendChange({
      state: this.recommendState.addLookingSimilar(m)
    }), this;
  }, h.prototype.removeNumericRefinement = function(m, S, I) {
    return this._change({
      state: this.state.resetPage().removeNumericRefinement(m, S, I),
      isPageReset: !0
    }), this;
  }, h.prototype.removeDisjunctiveFacetRefinement = function(m, S) {
    return this._change({
      state: this.state.resetPage().removeDisjunctiveFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
  }, h.prototype.removeHierarchicalFacetRefinement = function(m) {
    return this._change({
      state: this.state.resetPage().removeHierarchicalFacetRefinement(m),
      isPageReset: !0
    }), this;
  }, h.prototype.removeFacetRefinement = function(m, S) {
    return this._change({
      state: this.state.resetPage().removeFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
  }, h.prototype.removeFacetExclusion = function(m, S) {
    return this._change({
      state: this.state.resetPage().removeExcludeRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
  }, h.prototype.removeTag = function(m) {
    return this._change({
      state: this.state.resetPage().removeTagRefinement(m),
      isPageReset: !0
    }), this;
  }, h.prototype.removeFrequentlyBoughtTogether = function(m) {
    return this._recommendChange({
      state: this.recommendState.removeParams(m)
    }), this;
  }, h.prototype.removeRelatedProducts = function(m) {
    return this._recommendChange({
      state: this.recommendState.removeParams(m)
    }), this;
  }, h.prototype.removeTrendingItems = function(m) {
    return this._recommendChange({
      state: this.recommendState.removeParams(m)
    }), this;
  }, h.prototype.removeTrendingFacets = function(m) {
    return this._recommendChange({
      state: this.recommendState.removeParams(m)
    }), this;
  }, h.prototype.removeLookingSimilar = function(m) {
    return this._recommendChange({
      state: this.recommendState.removeParams(m)
    }), this;
  }, h.prototype.toggleFacetExclusion = function(m, S) {
    return this._change({
      state: this.state.resetPage().toggleExcludeFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
  }, h.prototype.toggleRefinement = function(m, S) {
    return this.toggleFacetRefinement(m, S);
  }, h.prototype.toggleFacetRefinement = function(m, S) {
    return this._change({
      state: this.state.resetPage().toggleFacetRefinement(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
  }, h.prototype.toggleTag = function(m) {
    return this._change({
      state: this.state.resetPage().toggleTagRefinement(m),
      isPageReset: !0
    }), this;
  }, h.prototype.nextPage = function() {
    var m = this.state.page || 0;
    return this.setPage(m + 1);
  }, h.prototype.previousPage = function() {
    var m = this.state.page || 0;
    return this.setPage(m - 1);
  };
  function v(m) {
    if (m < 0) throw new Error("Page requested below 0.");
    return this._change({
      state: this.state.setPage(m),
      isPageReset: !1
    }), this;
  }
  h.prototype.setCurrentPage = v, h.prototype.setPage = v, h.prototype.setIndex = function(m) {
    return this._change({
      state: this.state.resetPage().setIndex(m),
      isPageReset: !0
    }), this;
  }, h.prototype.setQueryParameter = function(m, S) {
    return this._change({
      state: this.state.resetPage().setQueryParameter(m, S),
      isPageReset: !0
    }), this;
  }, h.prototype.setState = function(m) {
    return this._change({
      state: f.make(m),
      isPageReset: !1
    }), this;
  }, h.prototype.overrideStateWithoutTriggeringChangeEvent = function(m) {
    return this.state = new f(m), this;
  }, h.prototype.hasRefinements = function(m) {
    return a(this.state.getNumericRefinements(m)) ? !0 : this.state.isConjunctiveFacet(m) ? this.state.isFacetRefined(m) : this.state.isDisjunctiveFacet(m) ? this.state.isDisjunctiveFacetRefined(m) : this.state.isHierarchicalFacet(m) ? this.state.isHierarchicalFacetRefined(m) : !1;
  }, h.prototype.isExcluded = function(m, S) {
    return this.state.isExcludeRefined(m, S);
  }, h.prototype.isDisjunctiveRefined = function(m, S) {
    return this.state.isDisjunctiveFacetRefined(m, S);
  }, h.prototype.hasTag = function(m) {
    return this.state.isTagRefined(m);
  }, h.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
  }, h.prototype.getIndex = function() {
    return this.state.index;
  };
  function b() {
    return this.state.page;
  }
  return h.prototype.getCurrentPage = b, h.prototype.getPage = b, h.prototype.getTags = function() {
    return this.state.tagRefinements;
  }, h.prototype.getRefinements = function(m) {
    var S = [];
    if (this.state.isConjunctiveFacet(m)) {
      var I = this.state.getConjunctiveRefinements(m);
      I.forEach(function(N) {
        S.push({
          value: N,
          type: "conjunctive"
        });
      });
      var C = this.state.getExcludeRefinements(m);
      C.forEach(function(N) {
        S.push({
          value: N,
          type: "exclude"
        });
      });
    } else if (this.state.isDisjunctiveFacet(m)) {
      var T = this.state.getDisjunctiveRefinements(m);
      T.forEach(function(N) {
        S.push({
          value: N,
          type: "disjunctive"
        });
      });
    }
    var E = this.state.getNumericRefinements(m);
    return Object.keys(E).forEach(function(N) {
      var y = E[N];
      S.push({
        value: y,
        operator: N,
        type: "numeric"
      });
    }), S;
  }, h.prototype.getNumericRefinement = function(m, S) {
    return this.state.getNumericRefinement(m, S);
  }, h.prototype.getHierarchicalFacetBreadcrumb = function(m) {
    return this.state.getHierarchicalFacetBreadcrumb(m);
  }, h.prototype._search = function(m) {
    var S = this.state, I = [], C = [];
    m.onlyWithDerivedHelpers || (C = u._getQueries(S.index, S), I.push({
      state: S,
      queriesCount: C.length,
      helper: this
    }), this.emit("search", {
      state: S,
      results: this.lastResults
    }));
    var T = this.derivedHelpers.map(function(y) {
      var w = y.getModifiedState(S), P = w.index ? u._getQueries(w.index, w) : [];
      return I.push({
        state: w,
        queriesCount: P.length,
        helper: y
      }), y.emit("search", {
        state: w,
        results: y.lastResults
      }), P;
    }), E = Array.prototype.concat.apply(C, T), N = this._queryId++;
    if (this._currentNbQueries++, !E.length)
      return Promise.resolve({ results: [] }).then(
        this._dispatchAlgoliaResponse.bind(this, I, N)
      );
    try {
      this.client.search(E).then(this._dispatchAlgoliaResponse.bind(this, I, N)).catch(this._dispatchAlgoliaError.bind(this, N));
    } catch (y) {
      this.emit("error", {
        error: y
      });
    }
  }, h.prototype._runComposition = function() {
    var m = this.state, S = [], I = [], C = this.derivedHelpers.map(function(y) {
      var w = y.getModifiedState(m), P = u._getCompositionQueries(w);
      return S.push({
        state: w,
        queriesCount: P.length,
        helper: y
      }), y.emit("search", {
        state: w,
        results: y.lastResults
      }), P;
    }), T = Array.prototype.concat.apply(I, C), E = this._queryId++;
    if (this._currentNbQueries++, !T.length)
      return Promise.resolve({ results: [] }).then(
        this._dispatchAlgoliaResponse.bind(this, S, E)
      );
    if (T.length > 1)
      throw new Error("Only one query is allowed when using a composition.");
    var N = T[0];
    try {
      this.client.search(N).then(this._dispatchAlgoliaResponse.bind(this, S, E)).catch(this._dispatchAlgoliaError.bind(this, E));
    } catch (y) {
      this.emit("error", {
        error: y
      });
    }
  }, h.prototype._recommend = function() {
    var m = this.state, S = this.recommendState, I = this.getIndex(), C = [{ state: S, index: I, helper: this }], T = S.params.map(function(P) {
      return P.$$id;
    });
    this.emit("fetch", {
      recommend: {
        state: S,
        results: this.lastRecommendResults
      }
    });
    var E = this._recommendCache, N = this.derivedHelpers.map(function(P) {
      var _ = P.getModifiedState(m).index;
      if (!_)
        return [];
      var D = P.getModifiedRecommendState(
        new o()
      );
      return C.push({
        state: D,
        index: _,
        helper: P
      }), T = Array.prototype.concat.apply(
        T,
        D.params.map(function(R) {
          return R.$$id;
        })
      ), P.emit("fetch", {
        recommend: {
          state: D,
          results: P.lastRecommendResults
        }
      }), D._buildQueries(_, E);
    }), y = Array.prototype.concat.apply(
      this.recommendState._buildQueries(I, E),
      N
    );
    if (y.length !== 0) {
      if (y.length > 0 && typeof this.client.getRecommendations > "u") {
        console.warn(
          "Please update algoliasearch/lite to the latest version in order to use recommend widgets."
        );
        return;
      }
      var w = this._recommendQueryId++;
      this._currentNbRecommendQueries++;
      try {
        this.client.getRecommendations(y).then(this._dispatchRecommendResponse.bind(this, w, C, T)).catch(this._dispatchRecommendError.bind(this, w));
      } catch (P) {
        this.emit("error", {
          error: P
        });
      }
    }
  }, h.prototype._dispatchAlgoliaResponse = function(m, S, I) {
    var C = this;
    if (!(S < this._lastQueryIdReceived)) {
      this._currentNbQueries -= S - this._lastQueryIdReceived, this._lastQueryIdReceived = S, this._currentNbQueries === 0 && this.emit("searchQueueEmpty");
      var T = I.results.slice(), E = Object.keys(I).reduce(function(N, y) {
        return y !== "results" && (N[y] = I[y]), N;
      }, {});
      Object.keys(E).length <= 0 && (E = void 0), m.forEach(function(N) {
        var y = N.state, w = N.queriesCount, P = N.helper, _ = T.splice(0, w);
        if (!y.index) {
          P.emit("result", {
            results: null,
            state: y
          });
          return;
        }
        P.lastResults = new g(
          y,
          _,
          C._searchResultsOptions
        ), E !== void 0 && (P.lastResults._rawContent = E), P.emit("result", {
          results: P.lastResults,
          state: y
        });
      });
    }
  }, h.prototype._dispatchRecommendResponse = function(m, S, I, C) {
    if (!(m < this._lastRecommendQueryIdReceived)) {
      this._currentNbRecommendQueries -= m - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = m, this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty");
      var T = this._recommendCache, E = {};
      I.filter(function(y) {
        return T[y] === void 0;
      }).forEach(function(y, w) {
        E[y] || (E[y] = []), E[y].push(w);
      }), Object.keys(E).forEach(function(y) {
        var w = E[y], P = C.results[w[0]];
        if (w.length === 1) {
          T[y] = P;
          return;
        }
        T[y] = Object.assign({}, P, {
          hits: p(
            I,
            w.map(function(_) {
              return C.results[_].hits;
            })
          )
        });
      });
      var N = {};
      I.forEach(function(y) {
        N[y] = T[y];
      }), S.forEach(function(y) {
        var w = y.state, P = y.helper;
        if (!y.index) {
          P.emit("recommend:result", {
            results: null,
            state: w
          });
          return;
        }
        P.lastRecommendResults = new c(w, N), P.emit("recommend:result", {
          recommend: {
            results: P.lastRecommendResults,
            state: w
          }
        });
      });
    }
  }, h.prototype._dispatchAlgoliaError = function(m, S) {
    m < this._lastQueryIdReceived || (this._currentNbQueries -= m - this._lastQueryIdReceived, this._lastQueryIdReceived = m, this.emit("error", {
      error: S
    }), this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
  }, h.prototype._dispatchRecommendError = function(m, S) {
    m < this._lastRecommendQueryIdReceived || (this._currentNbRecommendQueries -= m - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = m, this.emit("error", {
      error: S
    }), this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty"));
  }, h.prototype.containsRefinement = function(m, S, I, C) {
    return m || S.length !== 0 || I.length !== 0 || C.length !== 0;
  }, h.prototype._hasDisjunctiveRefinements = function(m) {
    return this.state.disjunctiveRefinements[m] && this.state.disjunctiveRefinements[m].length > 0;
  }, h.prototype._change = function(m) {
    var S = m.state, I = m.isPageReset;
    S !== this.state && (this.state = S, this.emit("change", {
      state: this.state,
      results: this.lastResults,
      isPageReset: I
    }));
  }, h.prototype._recommendChange = function(m) {
    var S = m.state;
    S !== this.recommendState && (this.recommendState = S, this.emit("recommend:change", {
      search: {
        results: this.lastResults,
        state: this.state
      },
      recommend: {
        results: this.lastRecommendResults,
        state: this.recommendState
      }
    }));
  }, h.prototype.clearCache = function() {
    return this.client.clearCache && this.client.clearCache(), this;
  }, h.prototype.setClient = function(m) {
    return this.client === m ? this : (typeof m.addAlgoliaAgent == "function" && m.addAlgoliaAgent("JS Helper (" + d + ")"), this.client = m, this);
  }, h.prototype.getClient = function() {
    return this.client;
  }, h.prototype.derive = function(m, S) {
    var I = new t(this, m, S);
    return this.derivedHelpers.push(I), I;
  }, h.prototype.detachDerivedHelper = function(m) {
    var S = this.derivedHelpers.indexOf(m);
    if (S === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(S, 1);
  }, h.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
  }, _d = h, _d;
}
var Ed, Jv;
function G$() {
  if (Jv) return Ed;
  Jv = 1;
  var e = B$(), t = oI(), r = lI(), n = cI(), i = fI();
  function a(s, o, c, u) {
    return new e(s, o, c, u);
  }
  return a.version = hI(), a.AlgoliaSearchHelper = e, a.SearchParameters = n, a.RecommendParameters = t, a.SearchResults = i, a.RecommendResults = r, Ed = a, Ed;
}
var Q$ = G$();
const Gt = /* @__PURE__ */ Ji(Q$);
var Z$ = 0;
function Y$(e) {
  e.dependsOn === "recommend" && (e.$$id = Z$++);
}
function Xv(e) {
  return e.toString().charAt(0).toUpperCase() + e.toString().slice(1);
}
function Tt() {
}
var ey = Tt, qe = Tt;
process.env.NODE_ENV === "development" && (ey = function(t) {
  console.warn("[InstantSearch.js]: ".concat(t.trim()));
}, qe = function(t, r) {
  if (!t) {
    var n = qe.cache[r];
    n || (qe.cache[r] = !0, process.env.NODE_ENV === "development" && ey(r));
  }
}, qe.cache = {});
var K$ = Object.keys;
function J$(e) {
  return tM(e) || eM(e) || mI(e) || X$();
}
function X$() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eM(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function tM(e) {
  if (Array.isArray(e)) return Ef(e);
}
function ba(e, t) {
  return iM(e) || nM(e, t) || mI(e, t) || rM();
}
function rM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mI(e, t) {
  if (e) {
    if (typeof e == "string") return Ef(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ef(e, t);
  }
}
function Ef(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function nM(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function iM(e) {
  if (Array.isArray(e)) return e;
}
function aM(e) {
  switch (e) {
    case "range":
      return [];
    case "menu":
      return ["menu", "menuSelect"];
    default:
      return [e];
  }
}
var sM = {
  query: {
    connectors: ["connectSearchBox"],
    widgets: ["ais.searchBox", "ais.autocomplete", "ais.voiceSearch"]
  },
  refinementList: {
    connectors: ["connectRefinementList"],
    widgets: ["ais.refinementList"]
  },
  menu: {
    connectors: ["connectMenu"],
    widgets: ["ais.menu"]
  },
  hierarchicalMenu: {
    connectors: ["connectHierarchicalMenu"],
    widgets: ["ais.hierarchicalMenu"]
  },
  numericMenu: {
    connectors: ["connectNumericMenu"],
    widgets: ["ais.numericMenu"]
  },
  ratingMenu: {
    connectors: ["connectRatingMenu"],
    widgets: ["ais.ratingMenu"]
  },
  range: {
    connectors: ["connectRange"],
    widgets: ["ais.rangeInput", "ais.rangeSlider", "ais.range"]
  },
  toggle: {
    connectors: ["connectToggleRefinement"],
    widgets: ["ais.toggleRefinement"]
  },
  geoSearch: {
    connectors: ["connectGeoSearch"],
    widgets: ["ais.geoSearch"]
  },
  sortBy: {
    connectors: ["connectSortBy"],
    widgets: ["ais.sortBy"]
  },
  page: {
    connectors: ["connectPagination"],
    widgets: ["ais.pagination", "ais.infiniteHits"]
  },
  hitsPerPage: {
    connectors: ["connectHitsPerPage"],
    widgets: ["ais.hitsPerPage"]
  },
  configure: {
    connectors: ["connectConfigure"],
    widgets: ["ais.configure"]
  },
  places: {
    connectors: [],
    widgets: ["ais.places"]
  }
};
function pI(e) {
  var t = e.index, r = e.indexUiState, n = t.getWidgets().map(function(a) {
    return a.$$type;
  }).filter(Boolean), i = K$(r).reduce(function(a, s) {
    var o = sM[s];
    if (!o)
      return a;
    var c = o.widgets;
    return c && !c.some(function(u) {
      return n.includes(u);
    }) && a.push([s, {
      connectors: o.connectors,
      widgets: o.widgets.map(function(u) {
        return u.split("ais.")[1];
      })
    }]), a;
  }, []);
  process.env.NODE_ENV === "development" && qe(i.length === 0, 'The UI state for the index "'.concat(t.getIndexId(), '" is not consistent with the widgets mounted.\n\nThis can happen when the UI state is specified via `initialUiState`, `routing` or `setUiState` but that the widgets responsible for this state were not added. This results in those query parameters not being sent to the API.\n\nTo fully reflect the state, some widgets need to be added to the index "').concat(t.getIndexId(), `":

`).concat(i.map(function(a) {
    var s, o = ba(a, 2), c = o[0], u = o[1].widgets;
    return "- `".concat(c, "` needs one of these widgets: ").concat((s = []).concat.apply(s, J$(u.map(function(f) {
      return aM(f);
    }))).map(function(f) {
      return '"'.concat(f, '"');
    }).join(", "));
  }).join(`
`), `

If you do not wish to display widgets but still want to support their search parameters, you can mount "virtual widgets" that don't render anything:

\`\`\`
`).concat(i.filter(function(a) {
    var s = ba(a, 2);
    s[0];
    var o = s[1].connectors;
    return o.length > 0;
  }).map(function(a) {
    var s = ba(a, 2);
    s[0];
    var o = s[1], c = o.connectors, u = o.widgets, f = Xv(u[0]), g = c[0];
    return "const virtual".concat(f, " = ").concat(g, "(() => null);");
  }).join(`
`), `

search.addWidgets([
  `).concat(i.filter(function(a) {
    var s = ba(a, 2);
    s[0];
    var o = s[1].connectors;
    return o.length > 0;
  }).map(function(a) {
    var s = ba(a, 2);
    s[0];
    var o = s[1].widgets, c = Xv(o[0]);
    return "virtual".concat(c, "({ /* ... */ })");
  }).join(`,
  `), `
]);
\`\`\`

If you're using custom widgets that do set these query parameters, we recommend using connectors instead.

See https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/js/#customize-the-complete-ui-of-the-widgets`));
}
function oM(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function ra(e, t) {
  if (e === void 0 || typeof e != "function")
    throw new Error("The render function is not valid (received type ".concat(oM(e), `).

`).concat(t));
}
function ty(e) {
  var t = e.helper, r = e.attributesToClear, n = r === void 0 ? [] : r, i = t.state.setPage(0);
  return i = n.reduce(function(a, s) {
    return i.isNumericRefined(s) ? a.removeNumericRefinement(s) : i.isHierarchicalFacet(s) ? a.removeHierarchicalFacetRefinement(s) : i.isDisjunctiveFacet(s) ? a.removeDisjunctiveFacetRefinement(s) : i.isConjunctiveFacet(s) ? a.removeFacetRefinement(s) : a;
  }, i), n.indexOf("query") !== -1 && (i = i.setQuery("")), i;
}
var lM = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, gI = /[&<>"']/g, cM = RegExp(gI.source);
function uM(e) {
  return e && cM.test(e) ? e.replace(gI, function(t) {
    return lM[t];
  }) : e;
}
var dM = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}, vI = /&(amp|quot|lt|gt|#39);/g, fM = RegExp(vI.source);
function yI(e) {
  return e && fM.test(e) ? e.replace(vI, function(t) {
    return dM[t];
  }) : e;
}
function Of(e) {
  "@babel/helpers - typeof";
  return Of = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Of(e);
}
function hM(e) {
  return e === null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function mM(e) {
  return Of(e) === "object" && e !== null;
}
function bI(e) {
  if (!mM(e) || hM(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Ja(e) {
  "@babel/helpers - typeof";
  return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ja(e);
}
function pM(e) {
  if (e == null) throw new TypeError("Cannot destructure " + e);
}
function Nf() {
  return Nf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nf.apply(this, arguments);
}
function ry(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ni(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ry(Object(r), !0).forEach(function(n) {
      SI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ry(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function SI(e, t, r) {
  return t = gM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gM(e) {
  var t = vM(e, "string");
  return Ja(t) == "symbol" ? t : String(t);
}
function vM(e, t) {
  if (Ja(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ja(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Hi = {
  highlightPreTag: "__ais-highlight__",
  highlightPostTag: "__/ais-highlight__"
}, Yt = {
  highlightPreTag: "<mark>",
  highlightPostTag: "</mark>"
};
function wI(e) {
  return uM(e).replace(new RegExp(Hi.highlightPreTag, "g"), Yt.highlightPreTag).replace(new RegExp(Hi.highlightPostTag, "g"), Yt.highlightPostTag);
}
function Zo(e) {
  return bI(e) && typeof e.value != "string" ? Object.keys(e).reduce(function(t, r) {
    return Ni(Ni({}, t), {}, SI({}, r, Zo(e[r])));
  }, {}) : Array.isArray(e) ? e.map(Zo) : Ni(Ni({}, e), {}, {
    value: wI(e.value)
  });
}
function yM(e) {
  return e.__escaped === void 0 && (e = e.map(function(t) {
    var r = Nf({}, (pM(t), t));
    return r._highlightResult && (r._highlightResult = Zo(r._highlightResult)), r._snippetResult && (r._snippetResult = Zo(r._snippetResult)), r;
  }), e.__escaped = !0), e;
}
function bM(e) {
  return e.map(function(t) {
    return Ni(Ni({}, t), {}, {
      highlighted: wI(t.highlighted)
    });
  });
}
function II(e) {
  var t = Yt.highlightPreTag, r = Yt.highlightPostTag;
  return e.map(function(n) {
    return n.isHighlighted ? t + n.value + r : n.value;
  }).join("");
}
function SM(e, t, r) {
  return e.state.isHierarchicalFacet(t) ? e.state.isHierarchicalFacetRefined(t, r) : e.state.isConjunctiveFacet(t) ? e.state.isFacetRefined(t, r) : e.state.isDisjunctiveFacetRefined(t, r);
}
function ny(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ny(Object(r), !0).forEach(function(n) {
      IM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ny(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function IM(e, t, r) {
  return t = CM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CM(e) {
  var t = PM(e, "string");
  return qi(t) == "symbol" ? t : String(t);
}
function PM(e, t) {
  if (qi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (qi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qi(e) {
  "@babel/helpers - typeof";
  return qi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qi(e);
}
function TM(e, t) {
  return NM(e) || OM(e, t) || EM(e, t) || _M();
}
function _M() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EM(e, t) {
  if (e) {
    if (typeof e == "string") return iy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return iy(e, t);
  }
}
function iy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function OM(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function NM(e) {
  if (Array.isArray(e)) return e;
}
function CI(e) {
  var t = e.instantSearchInstance, r = e.helper, n = e.attribute, i = e.widgetType, a = function() {
    for (var o = arguments.length, c = new Array(o), u = 0; u < o; u++)
      c[u] = arguments[u];
    var f = c[1], g = c[2], p = g === void 0 ? "Filter Applied" : g, d = c[3], h = d === void 0 ? {} : d, v = c[0].split(":"), b = TM(v, 2), m = b[0], S = b[1], I = typeof n == "string" ? n : n(f);
    if (c.length === 1 && qi(c[0]) === "object")
      t.sendEventToInsights(c[0]);
    else if (m === "click" && c.length >= 2 && c.length <= 4) {
      if (!SM(r, I, f)) {
        var C;
        t.sendEventToInsights({
          insightsMethod: "clickedFilters",
          widgetType: i,
          eventType: m,
          eventModifier: S,
          payload: wM({
            eventName: p,
            index: ((C = r.lastResults) === null || C === void 0 ? void 0 : C.index) || r.state.index,
            filters: ["".concat(I, ":").concat(f)]
          }, h),
          attribute: I
        });
      }
    } else if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass between two and four arguments like:
  sendEvent('click', facetValue, eventName?, additionalData?);

If you want to send a custom payload, you can pass one object: sendEvent(customPayload);
`);
  };
  return a;
}
function PI(e) {
  return btoa(encodeURIComponent(JSON.stringify(e)));
}
function ay(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Od(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ay(Object(r), !0).forEach(function(n) {
      DM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ay(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DM(e, t, r) {
  return t = RM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function RM(e) {
  var t = kM(e, "string");
  return zi(t) == "symbol" ? t : String(t);
}
function kM(e, t) {
  if (zi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (zi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function AM(e, t) {
  return MM(e) || $M(e, t) || FM(e, t) || xM();
}
function xM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FM(e, t) {
  if (e) {
    if (typeof e == "string") return sy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return sy(e, t);
  }
}
function sy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function $M(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function MM(e) {
  if (Array.isArray(e)) return e;
}
function zi(e) {
  "@babel/helpers - typeof";
  return zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zi(e);
}
function LM(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, r = [], n = 0; n < Math.ceil(e.length / t); n++)
    r.push(e.slice(n * t, (n + 1) * t));
  return r;
}
function TI(e) {
  var t = e.helper, r = e.widgetType, n = e.methodName, i = e.args, a = e.instantSearchInstance;
  if (i.length === 1 && zi(i[0]) === "object")
    return [i[0]];
  var s = i[0].split(":"), o = AM(s, 2), c = o[0], u = o[1], f = i[1], g = i[2], p = i[3] || {};
  if (!f) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass hit or hits as the second argument like:
  `.concat(n, `(eventType, hit);
  `));
    return [];
  }
  if ((c === "click" || c === "conversion") && !g) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass eventName as the third argument for 'click' or 'conversion' events like:
  `.concat(n, `('click', hit, 'Product Purchased');

  To learn more about event naming: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/in-depth/clicks-conversions-best-practices/
  `));
    return [];
  }
  var d = Array.isArray(f) ? f : [f];
  if (d.length === 0)
    return [];
  var h = d[0].__queryID, v = LM(d), b = v.map(function(S) {
    return S.map(function(I) {
      return I.objectID;
    });
  }), m = v.map(function(S) {
    return S.map(function(I) {
      return I.__position;
    });
  });
  if (c === "view")
    return a.status !== "idle" ? [] : v.map(function(S, I) {
      var C;
      return {
        insightsMethod: "viewedObjectIDs",
        widgetType: r,
        eventType: c,
        payload: Od({
          eventName: g || "Hits Viewed",
          index: ((C = t.lastResults) === null || C === void 0 ? void 0 : C.index) || t.state.index,
          objectIDs: b[I]
        }, p),
        hits: S,
        eventModifier: u
      };
    });
  if (c === "click")
    return v.map(function(S, I) {
      var C;
      return {
        insightsMethod: "clickedObjectIDsAfterSearch",
        widgetType: r,
        eventType: c,
        payload: Od({
          eventName: g || "Hit Clicked",
          index: ((C = t.lastResults) === null || C === void 0 ? void 0 : C.index) || t.state.index,
          queryID: h,
          objectIDs: b[I],
          positions: m[I]
        }, p),
        hits: S,
        eventModifier: u
      };
    });
  if (c === "conversion")
    return v.map(function(S, I) {
      var C;
      return {
        insightsMethod: "convertedObjectIDsAfterSearch",
        widgetType: r,
        eventType: c,
        payload: Od({
          eventName: g || "Hit Converted",
          index: ((C = t.lastResults) === null || C === void 0 ? void 0 : C.index) || t.state.index,
          queryID: h,
          objectIDs: b[I]
        }, p),
        hits: S,
        eventModifier: u
      };
    });
  if (process.env.NODE_ENV === "development")
    throw new Error('eventType("'.concat(c, `") is not supported.
    If you want to send a custom payload, you can pass one object: `).concat(n, `(customPayload);
    `));
  return [];
}
function jM(e) {
  var t = e.instantSearchInstance, r = e.helper, n = e.widgetType, i = {}, a = void 0, s = function() {
    for (var c = arguments.length, u = new Array(c), f = 0; f < c; f++)
      u[f] = arguments[f];
    var g = TI({
      widgetType: n,
      helper: r,
      methodName: "sendEvent",
      args: u,
      instantSearchInstance: t
    });
    g.forEach(function(p) {
      p.eventType === "click" && p.eventModifier === "internal" && i[p.eventType] || (i[p.eventType] = !0, t.sendEventToInsights(p));
    }), clearTimeout(a), a = setTimeout(function() {
      i = {};
    }, 0);
  };
  return s;
}
function WM(e) {
  var t = e.helper, r = e.widgetType, n = e.instantSearchInstance, i = function() {
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    var u = TI({
      widgetType: r,
      helper: t,
      methodName: "bindEvent",
      args: o,
      instantSearchInstance: n
    });
    return u.length ? "data-insights-event=".concat(PI(u)) : "";
  };
  return i;
}
function tr(e) {
  return e.$$type === "ais.index";
}
function Df(e, t) {
  var r = e[t.getIndexId()] || {};
  process.env.NODE_ENV === "development" && pI({
    index: t,
    indexUiState: r
  }), t.getHelper().setState(t.getWidgetSearchParameters(t.getHelper().state, {
    uiState: r
  })), t.getWidgets().filter(tr).forEach(function(n) {
    return Df(e, n);
  });
}
var UM = Promise.resolve();
function Sa(e) {
  var t = null, r = !1, n = function() {
    for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
      s[o] = arguments[o];
    t === null && (t = UM.then(function() {
      if (t = null, r) {
        r = !1;
        return;
      }
      e.apply(void 0, s);
    }));
  };
  return n.wait = function() {
    if (t === null)
      throw new Error("The deferred function should be called before calling `wait()`");
    return t;
  }, n.cancel = function() {
    t !== null && (r = !0);
  }, n;
}
function Yo(e) {
  var t = e.name, r = e.connector, n = r === void 0 ? !1 : r;
  return ["https://www.algolia.com/doc/api-reference/widgets/", t, "/js/", n ? "#connector" : ""].join("");
}
function In() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t.map(function(i) {
    return Yo(i);
  }).join(", ");
  return function(i) {
    return [i, "See documentation: ".concat(n)].filter(Boolean).join(`

`);
  };
}
function VM(e) {
  return typeof e == "string" ? e.replace(/^\\-/, "-") : e;
}
function HM(e) {
  return typeof e == "number" && e < 0 || typeof e == "string" ? String(e).replace(/^-/, "\\-") : e;
}
function Xa(e, t) {
  for (var r, n = 0; n < e.length; n++)
    if (r = e[n], t(r, n, e))
      return r;
}
function qM(e, t) {
  if (!Array.isArray(e))
    return -1;
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
  return -1;
}
function oy(e) {
  if (e.appId && e.apiKey)
    return [e.appId, e.apiKey];
  if (e.transporter) {
    var t = e.transporter, r = t.headers || t.baseHeaders, n = t.queryParameters || t.baseQueryParameters, i = "x-algolia-application-id", a = "x-algolia-api-key", s = r[i] || n[i], o = r[a] || n[a];
    return [s, o];
  } else
    return [e.applicationID, e.apiKey];
}
function qh(e) {
  var t = Yt.highlightPostTag, r = Yt.highlightPreTag, n = e.split(r), i = n.shift(), a = i ? [{
    value: i,
    isHighlighted: !1
  }] : [];
  return n.forEach(function(s) {
    var o = s.split(t);
    a.push({
      value: o[0],
      isHighlighted: !0
    }), o[1] !== "" && a.push({
      value: o[1],
      isHighlighted: !1
    });
  }), a;
}
var zM = new RegExp(/\w/i);
function BM(e, t) {
  var r, n, i = e[t], a = ((r = e[t + 1]) === null || r === void 0 ? void 0 : r.isHighlighted) || !0, s = ((n = e[t - 1]) === null || n === void 0 ? void 0 : n.isHighlighted) || !0;
  return !zM.test(yI(i.value)) && s === a ? s : i.isHighlighted;
}
function js(e, t) {
  var r = Array.isArray(t) ? t : t.split(".");
  return r.reduce(function(n, i) {
    return n && n[i];
  }, e);
}
function Nd(e, t, r, n) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = {
    type: t,
    attribute: r,
    name: n,
    escapedValue: HM(n)
  }, s = Xa(i, function(d) {
    return d.name === r;
  }), o;
  if (t === "hierarchical") {
    for (var c = e.getHierarchicalFacetByName(r), u = n.split(c.separator), f = function(h) {
      return function(v) {
        return h[v];
      };
    }, g = function(h) {
      s = s && s.data && Xa(Object.keys(s.data).map(f(s.data)), function(v) {
        return v.name === u[h];
      });
    }, p = 0; s !== void 0 && p < u.length; ++p)
      g(p);
    o = s && s.count;
  } else
    o = s && s.data && s.data[a.name];
  return o !== void 0 && (a.count = o), s && s.exhaustive !== void 0 && (a.exhaustive = s.exhaustive), a;
}
function GM(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = e || {}, i = [], a = t.facetsRefinements, s = a === void 0 ? {} : a, o = t.facetsExcludes, c = o === void 0 ? {} : o, u = t.disjunctiveFacetsRefinements, f = u === void 0 ? {} : u, g = t.hierarchicalFacetsRefinements, p = g === void 0 ? {} : g, d = t.numericRefinements, h = d === void 0 ? {} : d, v = t.tagRefinements, b = v === void 0 ? [] : v;
  return Object.keys(s).forEach(function(m) {
    var S = s[m];
    S.forEach(function(I) {
      i.push(Nd(t, "facet", m, I, n.facets));
    });
  }), Object.keys(c).forEach(function(m) {
    var S = c[m];
    S.forEach(function(I) {
      i.push({
        type: "exclude",
        attribute: m,
        name: I,
        exclude: !0
      });
    });
  }), Object.keys(f).forEach(function(m) {
    var S = f[m];
    S.forEach(function(I) {
      i.push(Nd(
        t,
        "disjunctive",
        m,
        // We unescape any disjunctive refined values with `unescapeFacetValue` because
        // they can be escaped on negative numeric values with `escapeFacetValue`.
        VM(I),
        n.disjunctiveFacets
      ));
    });
  }), Object.keys(p).forEach(function(m) {
    var S = p[m];
    S.forEach(function(I) {
      i.push(Nd(t, "hierarchical", m, I, n.hierarchicalFacets));
    });
  }), Object.keys(h).forEach(function(m) {
    var S = h[m];
    Object.keys(S).forEach(function(I) {
      var C = I, T = S[C], E = Array.isArray(T) ? T : [T];
      E.forEach(function(N) {
        i.push({
          type: "numeric",
          attribute: m,
          name: "".concat(N),
          numericValue: N,
          operator: C
        });
      });
    });
  }), b.forEach(function(m) {
    i.push({
      type: "tag",
      attribute: "_tags",
      name: m
    });
  }), r && t.query && t.query.trim() && i.push({
    attribute: "query",
    type: "query",
    name: t.query,
    query: t.query
  }), i;
}
function es(e) {
  "@babel/helpers - typeof";
  return es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, es(e);
}
function ly(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ly(Object(r), !0).forEach(function(n) {
      QM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ly(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function QM(e, t, r) {
  return t = ZM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ZM(e) {
  var t = YM(e, "string");
  return es(t) == "symbol" ? t : String(t);
}
function YM(e, t) {
  if (es(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (es(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function KM(e, t, r) {
  return e.map(function(n, i) {
    return cy(cy({}, n), {}, {
      __position: r * t + i + 1
    });
  });
}
function ts(e) {
  "@babel/helpers - typeof";
  return ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ts(e);
}
function uy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uy(Object(r), !0).forEach(function(n) {
      JM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function JM(e, t, r) {
  return t = XM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function XM(e) {
  var t = eL(e, "string");
  return ts(t) == "symbol" ? t : String(t);
}
function eL(e, t) {
  if (ts(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ts(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tL(e, t) {
  return t ? e.map(function(r) {
    return dy(dy({}, r), {}, {
      __queryID: t
    });
  }) : e;
}
function rs(e) {
  "@babel/helpers - typeof";
  return rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rs(e);
}
function fy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fy(Object(r), !0).forEach(function(n) {
      rL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rL(e, t, r) {
  return t = nL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nL(e) {
  var t = iL(e, "string");
  return rs(t) == "symbol" ? t : String(t);
}
function iL(e, t) {
  if (rs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (rs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function aL(e, t) {
  var r = Object.keys(t).reduce(function(n, i) {
    var a = t[i];
    return a.recommendResults ? hy(hy({}, n), a.recommendResults.results) : n;
  }, {});
  e._recommendCache = r;
}
function ns(e) {
  "@babel/helpers - typeof";
  return ns = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ns(e);
}
function sL(e, t) {
  return uL(e) || cL(e, t) || lL(e, t) || oL();
}
function oL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lL(e, t) {
  if (e) {
    if (typeof e == "string") return my(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return my(e, t);
  }
}
function my(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function cL(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function uL(e) {
  if (Array.isArray(e)) return e;
}
function py(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? py(Object(r), !0).forEach(function(n) {
      _I(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : py(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _I(e, t, r) {
  return t = dL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dL(e) {
  var t = fL(e, "string");
  return ns(t) == "symbol" ? t : String(t);
}
function fL(e, t) {
  if (ns(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ns(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hL(e, t) {
  if (t && !((!("transporter" in e) || e._cacheHydrated) && (!e._useCache || typeof e.addAlgoliaAgent != "function"))) {
    var r = [Object.keys(t).reduce(function(s, o) {
      var c = t[o], u = c.state, f = c.requestParams, g = c.results, p = g && u ? g.map(function(d, h) {
        return wa({
          indexName: u.index || d.index
        }, f != null && f[h] || d.params ? {
          params: Dd(f?.[h] || mL(d.params))
        } : {});
      }) : [];
      return s.concat(p);
    }, [])], n = Object.keys(t).reduce(function(s, o) {
      var c = t[o].results;
      return c ? s.concat(c) : s;
    }, []);
    if ("transporter" in e && !e._cacheHydrated) {
      e._cacheHydrated = !0;
      var i = e.search.bind(e);
      e.search = function(s) {
        for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)
          c[u - 1] = arguments[u];
        var f = Array.isArray(s) ? (
          // search client
          s.map(function(g) {
            return wa(wa({}, g), {}, {
              params: Dd(g.params)
            });
          })
        ) : (
          // composition client
          Dd(s.requestBody.params)
        );
        return e.transporter.responsesCache.get({
          method: "search",
          args: [f].concat(c)
        }, function() {
          return i.apply(void 0, [s].concat(c));
        });
      }, e.transporter.responsesCache.set({
        method: "search",
        args: r
      }, {
        results: n
      });
    }
    if (!("transporter" in e)) {
      var a = "/1/indexes/*/queries_body_".concat(JSON.stringify({
        requests: r
      }));
      e.cache = wa(wa({}, e.cache), {}, _I({}, a, JSON.stringify({
        results: Object.keys(t).map(function(s) {
          return t[s].results;
        })
      })));
    }
  }
}
function mL(e) {
  return e.split("&").reduce(function(t, r) {
    var n = r.split("="), i = sL(n, 2), a = i[0], s = i[1];
    return t[a] = s ? decodeURIComponent(s) : "", t;
  }, {});
}
function Dd(e) {
  var t = function(i) {
    return Object.prototype.toString.call(i) === "[object Object]" || Object.prototype.toString.call(i) === "[object Array]";
  }, r = function(i) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
      s[o - 1] = arguments[o];
    var c = 0;
    return i.replace(/%s/g, function() {
      return encodeURIComponent(s[c++]);
    });
  };
  return Object.keys(e).map(function(n) {
    return r("%s=%s", n, t(e[n]) ? JSON.stringify(e[n]) : e[n]);
  }).join("&");
}
function gy(e) {
  return e !== Object(e);
}
function zh(e, t) {
  if (e === t)
    return !0;
  if (gy(e) || gy(t) || typeof e == "function" || typeof t == "function")
    return e === t;
  if (Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (var r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (!(i in t) || !zh(e[i], t[i]))
      return !1;
  }
  return !0;
}
function EI(e, t) {
  t(e), e.getWidgets().forEach(function(r) {
    tr(r) && EI(r, t);
  });
}
function OI(e) {
  return e.filter(function(t, r, n) {
    return n.indexOf(t) === r;
  });
}
function is(e) {
  "@babel/helpers - typeof";
  return is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, is(e);
}
var pL = ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"];
function vy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vy(Object(r), !0).forEach(function(n) {
      gL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gL(e, t, r) {
  return t = vL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vL(e) {
  var t = yL(e, "string");
  return is(t) == "symbol" ? t : String(t);
}
function yL(e, t) {
  if (is(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (is(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bL(e, t) {
  if (e == null) return {};
  var r = SL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function SL(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var wL = function(t, r) {
  r.facets, r.disjunctiveFacets, r.facetsRefinements, r.facetsExcludes, r.disjunctiveFacetsRefinements, r.numericRefinements, r.tagRefinements, r.hierarchicalFacets, r.hierarchicalFacetsRefinements, r.ruleContexts;
  var n = bL(r, pL);
  return t.setQueryParameters(n);
}, IL = function(t, r) {
  return r.facets.reduce(function(n, i) {
    return n.addFacet(i);
  }, t);
}, CL = function(t, r) {
  return r.disjunctiveFacets.reduce(function(n, i) {
    return n.addDisjunctiveFacet(i);
  }, t);
}, PL = function(t, r) {
  return t.setQueryParameters({
    hierarchicalFacets: r.hierarchicalFacets.reduce(function(n, i) {
      var a = qM(n, function(o) {
        return o.name === i.name;
      });
      if (a === -1)
        return n.concat(i);
      var s = n.slice();
      return s.splice(a, 1, i), s;
    }, t.hierarchicalFacets)
  });
}, TL = function(t, r) {
  return r.tagRefinements.reduce(function(n, i) {
    return n.addTagRefinement(i);
  }, t);
}, _L = function(t, r) {
  return t.setQueryParameters({
    facetsRefinements: rn(rn({}, t.facetsRefinements), r.facetsRefinements)
  });
}, EL = function(t, r) {
  return t.setQueryParameters({
    facetsExcludes: rn(rn({}, t.facetsExcludes), r.facetsExcludes)
  });
}, OL = function(t, r) {
  return t.setQueryParameters({
    disjunctiveFacetsRefinements: rn(rn({}, t.disjunctiveFacetsRefinements), r.disjunctiveFacetsRefinements)
  });
}, NL = function(t, r) {
  return t.setQueryParameters({
    numericRefinements: rn(rn({}, t.numericRefinements), r.numericRefinements)
  });
}, DL = function(t, r) {
  return t.setQueryParameters({
    hierarchicalFacetsRefinements: rn(rn({}, t.hierarchicalFacetsRefinements), r.hierarchicalFacetsRefinements)
  });
}, RL = function(t, r) {
  var n = OI([].concat(t.ruleContexts).concat(r.ruleContexts).filter(Boolean));
  return n.length > 0 ? t.setQueryParameters({
    ruleContexts: n
  }) : t;
}, Ua = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return r.reduce(function(i, a) {
    var s = DL(i, a), o = PL(s, a), c = TL(o, a), u = NL(c, a), f = OL(u, a), g = EL(f, a), p = _L(g, a), d = CL(p, a), h = RL(d, a), v = IL(h, a);
    return wL(v, a);
  });
};
function Fa(e, t, r) {
  var n = t.getHelper();
  return {
    uiState: r,
    helper: n,
    parent: t,
    instantSearchInstance: e,
    state: n.state,
    renderState: e.renderState,
    templatesConfig: e.templatesConfig,
    createURL: t.createURL,
    scopedResults: [],
    searchMetadata: {
      isSearchStalled: e.status === "stalled"
    },
    status: e.status,
    error: e.error
  };
}
function yy(e, t, r) {
  var n = t.getResultsForWidget(r), i = t.getHelper();
  return {
    helper: i,
    parent: t,
    instantSearchInstance: e,
    results: n,
    scopedResults: t.getScopedResults(),
    state: n && "_state" in n ? n._state : i.state,
    renderState: e.renderState,
    templatesConfig: e.templatesConfig,
    createURL: t.createURL,
    searchMetadata: {
      isSearchStalled: e.status === "stalled"
    },
    status: e.status,
    error: e.error
  };
}
function kL(e) {
  for (var t = e.getParent(), r = [e.getHelper().state]; t !== null; )
    r = [t.getHelper().state].concat(r), t = t.getParent();
  return r;
}
function as(e) {
  "@babel/helpers - typeof";
  return as = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, as(e);
}
function by(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function go(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? by(Object(r), !0).forEach(function(n) {
      AL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : by(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function AL(e, t, r) {
  return t = xL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xL(e) {
  var t = FL(e, "string");
  return as(t) == "symbol" ? t : String(t);
}
function FL(e, t) {
  if (as(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (as(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function NI(e) {
  return e.some(function(t) {
    return t.isHighlighted;
  }) ? e.map(function(t, r) {
    return go(go({}, t), {}, {
      isHighlighted: !BM(e, r)
    });
  }) : e.map(function(t) {
    return go(go({}, t), {}, {
      isHighlighted: !1
    });
  });
}
function An(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    fallback: function() {
    }
  }, r = t.fallback;
  return typeof window > "u" ? r() : e({
    window
  });
}
function ss(e) {
  "@babel/helpers - typeof";
  return ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ss(e);
}
function Sy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sy(Object(r), !0).forEach(function(n) {
      DI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DI(e, t, r) {
  return t = $L(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $L(e) {
  var t = ML(e, "string");
  return ss(t) == "symbol" ? t : String(t);
}
function ML(e, t) {
  if (ss(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ss(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var LL = In({
  name: "configure",
  connector: !0
});
function wy(e, t) {
  return e.setQueryParameters(Object.keys(t.searchParameters).reduce(function(r, n) {
    return xt(xt({}, r), {}, DI({}, n, void 0));
  }, {}));
}
var jL = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Tt, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  return function(n) {
    if (!n || !bI(n.searchParameters))
      throw new Error(LL("The `searchParameters` option expects an object."));
    var i = {};
    function a(s) {
      return function(o) {
        var c = wy(s.state, n), u = Ua(c, new Gt.SearchParameters(o));
        n.searchParameters = o, s.setState(u).search();
      };
    }
    return {
      $$type: "ais.configure",
      init: function(o) {
        var c = o.instantSearchInstance;
        t(xt(xt({}, this.getWidgetRenderState(o)), {}, {
          instantSearchInstance: c
        }), !0);
      },
      render: function(o) {
        var c = o.instantSearchInstance;
        t(xt(xt({}, this.getWidgetRenderState(o)), {}, {
          instantSearchInstance: c
        }), !1);
      },
      dispose: function(o) {
        var c = o.state;
        return r(), wy(c, n);
      },
      getRenderState: function(o, c) {
        var u, f = this.getWidgetRenderState(c);
        return xt(xt({}, o), {}, {
          configure: xt(xt({}, f), {}, {
            widgetParams: xt(xt({}, f.widgetParams), {}, {
              searchParameters: Ua(new Gt.SearchParameters((u = o.configure) === null || u === void 0 ? void 0 : u.widgetParams.searchParameters), new Gt.SearchParameters(f.widgetParams.searchParameters)).getQueryParams()
            })
          })
        });
      },
      getWidgetRenderState: function(o) {
        var c = o.helper;
        return i.refine || (i.refine = a(c)), {
          refine: i.refine,
          widgetParams: n
        };
      },
      getWidgetSearchParameters: function(o, c) {
        var u = c.uiState;
        return Ua(o, new Gt.SearchParameters(xt(xt({}, u.configure), n.searchParameters)));
      },
      getWidgetUiState: function(o) {
        return xt(xt({}, o), {}, {
          configure: xt(xt({}, o.configure), n.searchParameters)
        });
      }
    };
  };
};
function Rf(e) {
  "@babel/helpers - typeof";
  return Rf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rf(e);
}
var Iy = Object.prototype.hasOwnProperty;
function Bi(e, t, r) {
  if (r != null && r(e, t))
    return !0;
  var n, i;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((i = e.length) === t.length)
        for (; i-- && Bi(e[i], t[i], r); ) ;
      return i === -1;
    }
    if (!n || Rf(e) === "object") {
      i = 0;
      for (n in e)
        if (Iy.call(e, n) && ++i && !Iy.call(t, n) || !(n in t) || !Bi(e[n], t[n], r)) return !1;
      return Object.keys(t).length === i;
    }
  }
  return e !== e && t !== t;
}
function Cy(e) {
  var t, r, n;
  return new Gt.SearchResults(e, [{
    query: (t = e.query) !== null && t !== void 0 ? t : "",
    page: (r = e.page) !== null && r !== void 0 ? r : 0,
    hitsPerPage: (n = e.hitsPerPage) !== null && n !== void 0 ? n : 20,
    hits: [],
    nbHits: 0,
    nbPages: 0,
    params: "",
    exhaustiveNbHits: !0,
    exhaustiveFacetsCount: !0,
    processingTimeMS: 0,
    index: e.index
  }], {
    /** used by connectors to prevent persisting these results */
    __isArtificial: !0
  });
}
function os(e) {
  "@babel/helpers - typeof";
  return os = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, os(e);
}
function Py(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ty(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Py(Object(r), !0).forEach(function(n) {
      WL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Py(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WL(e, t, r) {
  return t = UL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UL(e) {
  var t = VL(e, "string");
  return os(t) == "symbol" ? t : String(t);
}
function VL(e, t) {
  if (os(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (os(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kf(e) {
  var t = e.getHelper(), r = (
    // On SSR, we get the results injected on the Index.
    e.getResults() || // On the browser, we create fallback results based on the helper state.
    Cy(t.state)
  ), n = e.getScopedResults().map(function(i) {
    var a = i.indexId === e.getIndexId() ? r : Cy(i.helper.state);
    return Ty(Ty({}, i), {}, {
      // We keep `results` from being `null`.
      results: i.results || a
    });
  });
  return {
    results: r,
    scopedResults: n,
    recommendResults: t.lastRecommendResults
  };
}
var Bh = /* @__PURE__ */ Br(null);
process.env.NODE_ENV === "development" && (Bh.displayName = "Index");
function RI(e, t) {
  if (!e) {
    if (process.env.NODE_ENV !== "development")
      throw new Error("Invariant failed");
    if (process.env.NODE_ENV === "development")
      throw new Error("[InstantSearch] ".concat(typeof t == "function" ? t() : t));
  }
}
function Gh() {
  var e = wr(Bh);
  return RI(e !== null, "The <Index> component must be used within <InstantSearch>."), e;
}
var Qh = /* @__PURE__ */ Br(null);
process.env.NODE_ENV === "development" && (Qh.displayName = "InstantSearch");
function Ws() {
  var e = wr(Qh);
  return RI(e !== null, "Hooks must be used inside the <InstantSearch> component.\n\nThey are not compatible with the `react-instantsearch-core@6.x` and `react-instantsearch-dom` packages, so make sure to use the <InstantSearch> component from `react-instantsearch-core@7.x`."), e;
}
var kI = /* @__PURE__ */ Br(null);
process.env.NODE_ENV === "development" && (kI.displayName = "InstantSearchServer");
function AI() {
  return wr(kI);
}
var xI = /* @__PURE__ */ Br(null);
process.env.NODE_ENV === "development" && (xI.displayName = "InstantSearchSSR");
function FI() {
  return wr(xI);
}
function HL(e, t) {
  return GL(e) || BL(e, t) || zL(e, t) || qL();
}
function qL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zL(e, t) {
  if (e) {
    if (typeof e == "string") return _y(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _y(e, t);
  }
}
function _y(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function BL(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function GL(e) {
  if (Array.isArray(e)) return e;
}
function Ey(e) {
  var t = Z(function() {
    return e;
  }), r = HL(t, 2), n = r[0], i = r[1];
  return Bi(n, e) || i(e), n;
}
var QL = "use", Oy = Va[QL], $I = typeof window < "u" ? jb : Pe, ZL = /* @__PURE__ */ Br(null);
function MI() {
  return wr(ZL);
}
function YL(e) {
  var t, r = e.widget, n = e.parentIndex, i = e.props, a = e.shouldSsr, s = MI(), o = we(i);
  Pe(function() {
    o.current = i;
  }, [i]);
  var c = we(r);
  Pe(function() {
    c.current = r;
  }, [r]);
  var u = we(null), f = a && !n.getWidgets().includes(r), g = Ws();
  if ($I(function() {
    var d = c.current;
    if (!u.current)
      a || n.addWidgets([r]);
    else {
      clearTimeout(u.current);
      var h = Bi(i, o.current);
      h || (n.removeWidgets([d]), n.addWidgets([r]));
    }
    return function() {
      u.current = setTimeout(function() {
        g._schedule(function() {
          g._preventWidgetCleanup || n.removeWidgets([d]);
        });
      });
    };
  }, [n, r, a, g, i]), (f || (s == null || (t = s.current) === null || t === void 0 ? void 0 : t.status) === "pending") && n.addWidgets([r]), typeof window > "u" && s !== null && s !== void 0 && s.current && // We need the widgets contained in the index to be added before we trigger the search request.
  r.$$type !== "ais.index") {
    var p;
    Oy(s.current), r.$$type !== "ais.dynamicWidgets" && (p = g.helper) !== null && p !== void 0 && p.lastResults && Oy(s.current);
  }
}
function ls(e) {
  "@babel/helpers - typeof";
  return ls = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ls(e);
}
var KL = ["instantSearchInstance", "widgetParams"], JL = ["widgetParams"];
function XL(e, t) {
  return nj(e) || rj(e, t) || tj(e, t) || ej();
}
function ej() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tj(e, t) {
  if (e) {
    if (typeof e == "string") return Ny(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ny(e, t);
  }
}
function Ny(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function rj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function nj(e) {
  if (Array.isArray(e)) return e;
}
function Dy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ry(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dy(Object(r), !0).forEach(function(n) {
      ij(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ij(e, t, r) {
  return t = aj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aj(e) {
  var t = sj(e, "string");
  return ls(t) == "symbol" ? t : String(t);
}
function sj(e, t) {
  if (ls(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ls(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ky(e, t) {
  if (e == null) return {};
  var r = oj(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function oj(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function ri(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = AI(), i = FI(), a = Ws(), s = Gh(), o = Ey(t), c = Ey(r), u = we(!0), f = we(null), g = we(a.status), p = V(function() {
    var m = e(function(S, I) {
      if (I) {
        u.current = !0;
        return;
      }
      if (u.current) {
        var C = S.instantSearchInstance;
        S.widgetParams;
        var T = ky(S, KL);
        (!Bi(T, f.current, function(E, N) {
          return E?.constructor === Function && N?.constructor === Function;
        }) || C.status !== g.current) && (b(T), f.current = T, g.current = C.status);
      }
    }, function() {
      u.current = !1;
    });
    return Ry(Ry({}, m(o)), c);
  }, [e, o, c]), d = Z(function() {
    if (p.getWidgetRenderState) {
      var m, S = s.getHelper(), I = s.getWidgetUiState({})[s.getIndexId()];
      S.state = ((m = p.getWidgetSearchParameters) === null || m === void 0 ? void 0 : m.call(p, S.state, {
        uiState: I
      })) || S.state;
      var C = kf(s), T = C.results, E = C.scopedResults, N = C.recommendResults, y = p.getWidgetRenderState({
        helper: S,
        parent: s,
        instantSearchInstance: a,
        results: p.dependsOn === "recommend" && N && i ? N[i.recommendIdx.current++] : T,
        scopedResults: E,
        state: S.state,
        renderState: a.renderState,
        templatesConfig: a.templatesConfig,
        createURL: s.createURL,
        searchMetadata: {
          isSearchStalled: a.status === "stalled"
        },
        status: a.status,
        error: a.error
      });
      y.widgetParams;
      var w = ky(y, JL);
      return w;
    }
    return {};
  }), h = XL(d, 2), v = h[0], b = h[1];
  return YL({
    widget: p,
    parentIndex: s,
    props: o,
    shouldSsr: !!n
  }), v;
}
function lj(e, t) {
  return ri(jL, {
    searchParameters: e
  }, t);
}
function cs(e) {
  "@babel/helpers - typeof";
  return cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cs(e);
}
function Ay(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cj(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ay(Object(r), !0).forEach(function(n) {
      uj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ay(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uj(e, t, r) {
  return t = dj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dj(e) {
  var t = fj(e, "string");
  return cs(t) == "symbol" ? t : String(t);
}
function fj(e, t) {
  if (cs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (cs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hj(e) {
  return lj(cj({}, e), {
    $$widgetType: "ais.configure"
  }), null;
}
var xy = {
  current: {}
};
function Zh(e, t) {
  if (process.env.NODE_ENV === "development" && !e) {
    var r = t.trim(), n = xy.current[r];
    if (!n) {
      xy.current[r] = !0;
      var i = "[InstantSearch] ".concat(r);
      console.warn(i);
      try {
        throw new Error(i);
      } catch {
      }
    }
  }
}
function us(e) {
  "@babel/helpers - typeof";
  return us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, us(e);
}
var mj = ["initialSearchParameters"], pj = ["initialRecommendParameters"];
function Fy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fy(Object(r), !0).forEach(function(n) {
      Di(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Di(e, t, r) {
  return t = gj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gj(e) {
  var t = vj(e, "string");
  return us(t) == "symbol" ? t : String(t);
}
function vj(e, t) {
  if (us(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (us(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function LI(e) {
  return wj(e) || Sj(e) || bj(e) || yj();
}
function yj() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bj(e, t) {
  if (e) {
    if (typeof e == "string") return Af(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Af(e, t);
  }
}
function Sj(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wj(e) {
  if (Array.isArray(e)) return Af(e);
}
function Af(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function jI(e, t) {
  if (e == null) return {};
  var r = Ij(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ij(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var Ia = In({
  name: "index-widget"
});
function WI(e, t) {
  var r = t.state, n = t.recommendState, i = t.isPageReset, a = t._uiState;
  r !== e.state && (e.state = r, e.emit("change", {
    state: e.state,
    results: e.lastResults,
    isPageReset: i,
    _uiState: a
  })), n !== e.recommendState && (e.recommendState = n);
}
function Ca(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return e.reduce(function(n, i) {
    return tr(i) || !i.getWidgetUiState && !i.getWidgetState ? n : i.getWidgetUiState ? i.getWidgetUiState(n, t) : i.getWidgetState(n, t);
  }, r);
}
function Pa(e, t) {
  var r = t.initialSearchParameters, n = jI(t, mj);
  return e.reduce(function(i, a) {
    return !a.getWidgetSearchParameters || tr(a) ? i : a.dependsOn === "search" && a.getWidgetParameters ? a.getWidgetParameters(i, n) : a.getWidgetSearchParameters(i, n);
  }, r);
}
function $y(e, t) {
  var r = t.initialRecommendParameters, n = jI(t, pj);
  return e.reduce(function(i, a) {
    return !tr(a) && a.dependsOn === "recommend" && a.getWidgetParameters ? a.getWidgetParameters(i, n) : i;
  }, r);
}
function UI(e) {
  var t = e.filter(tr);
  t.length !== 0 && t.forEach(function(r) {
    var n = r.getHelper();
    WI(n, {
      state: n.state.resetPage(),
      recommendState: n.recommendState,
      isPageReset: !0
    }), UI(r.getWidgets());
  });
}
function VI(e) {
  var t = e.filter(tr);
  return t.reduce(function(r, n) {
    return r.concat.apply(r, [{
      indexId: n.getIndexId(),
      results: n.getResults(),
      helper: n.getHelper()
    }].concat(LI(VI(n.getWidgets()))));
  }, []);
}
var Cj = function(t) {
  if (t === void 0 || t.indexName === void 0)
    throw new Error(Ia("The `indexName` option is required."));
  var r = t.indexName, n = t.indexId, i = n === void 0 ? r : n, a = [], s = {}, o = null, c = null, u = null, f = null, g = null, p = !1, d = !1;
  return {
    $$type: "ais.index",
    $$widgetType: "ais.index",
    getIndexName: function() {
      return r;
    },
    getIndexId: function() {
      return i;
    },
    getHelper: function() {
      return u;
    },
    getResults: function() {
      var v;
      return (v = f) !== null && v !== void 0 && v.lastResults ? (f.lastResults._state = u.state, f.lastResults) : null;
    },
    getResultsForWidget: function(v) {
      var b;
      return v.dependsOn !== "recommend" || tr(v) || v.$$id === void 0 ? this.getResults() : (b = u) !== null && b !== void 0 && b.lastRecommendResults ? u.lastRecommendResults[v.$$id] : null;
    },
    getPreviousState: function() {
      return g;
    },
    getScopedResults: function() {
      var v = this.getParent(), b;
      return v ? b = v.getWidgets() : r.length === 0 ? b = this.getWidgets() : b = [this], VI(b);
    },
    getParent: function() {
      return c;
    },
    createURL: function(v) {
      return typeof v == "function" ? o._createURL(Di({}, i, v(s))) : o._createURL(Di({}, i, Ca(a, {
        searchParameters: v,
        helper: u
      })));
    },
    getWidgets: function() {
      return a;
    },
    addWidgets: function(v) {
      var b = this;
      if (!Array.isArray(v))
        throw new Error(Ia("The `addWidgets` method expects an array of widgets."));
      if (v.some(function(m) {
        return typeof m.init != "function" && typeof m.render != "function";
      }))
        throw new Error(Ia("The widget definition expects a `render` and/or an `init` method."));
      return v.forEach(function(m) {
        tr(m) || (o && m.dependsOn === "recommend" ? o._hasRecommendWidget = !0 : o ? o._hasSearchWidget = !0 : m.dependsOn === "recommend" ? p = !0 : d = !0, Y$(m));
      }), a = a.concat(v), o && v.length && (WI(u, {
        state: Pa(a, {
          uiState: s,
          initialSearchParameters: u.state
        }),
        recommendState: $y(a, {
          uiState: s,
          initialRecommendParameters: u.recommendState
        }),
        _uiState: s
      }), v.forEach(function(m) {
        if (m.getRenderState) {
          var S = m.getRenderState(o.renderState[b.getIndexId()] || {}, Fa(o, b, o._initialUiState));
          Rd({
            renderState: S,
            instantSearchInstance: o,
            parent: b
          });
        }
      }), v.forEach(function(m) {
        m.init && m.init(Fa(o, b, o._initialUiState));
      }), o.scheduleSearch()), this;
    },
    removeWidgets: function(v) {
      var b = this;
      if (!Array.isArray(v))
        throw new Error(Ia("The `removeWidgets` method expects an array of widgets."));
      if (v.some(function(T) {
        return typeof T.dispose != "function";
      }))
        throw new Error(Ia("The widget definition expects a `dispose` method."));
      if (a = a.filter(function(T) {
        return v.indexOf(T) === -1;
      }), a.forEach(function(T) {
        tr(T) || (o && T.dependsOn === "recommend" ? o._hasRecommendWidget = !0 : o ? o._hasSearchWidget = !0 : T.dependsOn === "recommend" ? p = !0 : d = !0);
      }), o && v.length) {
        var m = v.reduce(function(T, E) {
          var N = E.dispose({
            helper: u,
            state: T.cleanedSearchState,
            recommendState: T.cleanedRecommendState,
            parent: b
          });
          return N instanceof Gt.RecommendParameters ? T.cleanedRecommendState = N : N && (T.cleanedSearchState = N), T;
        }, {
          cleanedSearchState: u.state,
          cleanedRecommendState: u.recommendState
        }), S = m.cleanedSearchState, I = m.cleanedRecommendState, C = o.future.preserveSharedStateOnUnmount ? Pa(a, {
          uiState: s,
          initialSearchParameters: new Gt.SearchParameters({
            index: this.getIndexName()
          })
        }) : Pa(a, {
          uiState: Ca(a, {
            searchParameters: S,
            helper: u
          }),
          initialSearchParameters: S
        });
        s = Ca(a, {
          searchParameters: C,
          helper: u
        }), u.setState(C), u.recommendState = I, a.length && o.scheduleSearch();
      }
      return this;
    },
    init: function(v) {
      var b = this, m, S = v.instantSearchInstance, I = v.parent, C = v.uiState;
      if (u === null) {
        o = S, c = I, s = C[i] || {};
        var T = S.mainHelper, E = Pa(a, {
          uiState: s,
          initialSearchParameters: new Gt.SearchParameters({
            index: r
          })
        }), N = $y(a, {
          uiState: s,
          initialRecommendParameters: new Gt.RecommendParameters()
        });
        u = Gt({}, E.index, E), u.recommendState = N, u.search = function() {
          return S.onStateChange ? (S.onStateChange({
            uiState: S.mainIndex.getWidgetUiState({}),
            setUiState: function(D) {
              return S.setUiState(D, !1);
            }
          }), T) : T.search();
        }, u.searchWithoutTriggeringOnStateChange = function() {
          return T.search();
        }, u.searchForFacetValues = function(_, D, R, x) {
          var F = u.state.setQueryParameters(x);
          return T.searchForFacetValues(_, D, R, F);
        }, f = T.derive(function() {
          return Ua.apply(void 0, [T.state].concat(LI(kL(b))));
        }, function() {
          return b.getHelper().recommendState;
        });
        var y = (m = S._initialResults) === null || m === void 0 ? void 0 : m[this.getIndexId()];
        if (y != null && y.results) {
          var w = new Gt.SearchResults(new Gt.SearchParameters(y.state), y.results);
          f.lastResults = w, u.lastResults = w;
        }
        if (y != null && y.recommendResults) {
          var P = new Gt.RecommendResults(new Gt.RecommendParameters({
            params: y.recommendResults.params
          }), y.recommendResults.results);
          f.lastRecommendResults = P, u.lastRecommendResults = P;
        }
        u.on("change", function(_) {
          var D = _.isPageReset;
          D && UI(a);
        }), f.on("search", function() {
          S.scheduleStalledRender(), process.env.NODE_ENV === "development" && pI({
            index: b,
            indexUiState: s
          });
        }), f.on("result", function(_) {
          var D = _.results;
          S.scheduleRender(), u.lastResults = D, g = D?._state;
        }), f.on("recommend:result", function(_) {
          var D = _.recommend;
          S.scheduleRender(), u.lastRecommendResults = D.results;
        }), a.forEach(function(_) {
          if (_.getRenderState) {
            var D = _.getRenderState(S.renderState[b.getIndexId()] || {}, Fa(S, b, C));
            Rd({
              renderState: D,
              instantSearchInstance: S,
              parent: b
            });
          }
        }), a.forEach(function(_) {
          process.env.NODE_ENV === "development" && qe(
            // if it has NO getWidgetState or if it has getWidgetUiState, we don't warn
            // aka we warn if there's _only_ getWidgetState
            !_.getWidgetState || !!_.getWidgetUiState,
            "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."
          ), _.init && _.init(Fa(S, b, C));
        }), u.on("change", function(_) {
          var D = _.state, R = _._uiState;
          s = Ca(a, {
            searchParameters: D,
            helper: u
          }, R || {}), S.onStateChange || S.onInternalStateChange();
        }), y && S.scheduleRender(), p && (S._hasRecommendWidget = !0), d && (S._hasSearchWidget = !0);
      }
    },
    render: function(v) {
      var b, m = this, S = v.instantSearchInstance;
      S.status === "error" && !S.mainHelper.hasPendingRequests() && g && u.setState(g);
      var I = this.getResults() || (b = f) !== null && b !== void 0 && b.lastRecommendResults ? a : a.filter(tr);
      I = I.filter(function(C) {
        return C.shouldRender ? C.shouldRender({
          instantSearchInstance: S
        }) : !0;
      }), I.forEach(function(C) {
        if (C.getRenderState) {
          var T = C.getRenderState(S.renderState[m.getIndexId()] || {}, yy(S, m, C));
          Rd({
            renderState: T,
            instantSearchInstance: S,
            parent: m
          });
        }
      }), I.forEach(function(C) {
        C.render && C.render(yy(S, m, C));
      });
    },
    dispose: function() {
      var v = this, b, m;
      a.forEach(function(S) {
        S.dispose && u && S.dispose({
          helper: u,
          state: u.state,
          recommendState: u.recommendState,
          parent: v
        });
      }), o = null, c = null, (b = u) === null || b === void 0 || b.removeAllListeners(), u = null, (m = f) === null || m === void 0 || m.detach(), f = null;
    },
    getWidgetUiState: function(v) {
      return a.filter(tr).reduce(function(b, m) {
        return m.getWidgetUiState(b);
      }, Yr(Yr({}, v), {}, Di({}, i, Yr(Yr({}, v[i]), s))));
    },
    getWidgetState: function(v) {
      return process.env.NODE_ENV === "development" && qe(!1, "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."), this.getWidgetUiState(v);
    },
    getWidgetSearchParameters: function(v, b) {
      var m = b.uiState;
      return Pa(a, {
        uiState: m,
        initialSearchParameters: v
      });
    },
    refreshUiState: function() {
      s = Ca(a, {
        searchParameters: this.getHelper().state,
        helper: this.getHelper()
      }, s);
    },
    setIndexUiState: function(v) {
      var b = typeof v == "function" ? v(s) : v;
      o.setUiState(function(m) {
        return Yr(Yr({}, m), {}, Di({}, i, b));
      });
    }
  };
};
function Rd(e) {
  var t = e.renderState, r = e.instantSearchInstance, n = e.parent, i = n ? n.getIndexId() : r.mainIndex.getIndexId();
  r.renderState = Yr(Yr({}, r.renderState), {}, Di({}, i, Yr(Yr({}, r.renderState[i]), t)));
}
function Pj(e, t) {
  return Oj(e) || Ej(e, t) || _j(e, t) || Tj();
}
function Tj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _j(e, t) {
  if (e) {
    if (typeof e == "string") return My(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return My(e, t);
  }
}
function My(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Ej(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function Oj(e) {
  if (Array.isArray(e)) return e;
}
function Nj() {
  var e = f0(function(n) {
    return n + 1;
  }, 0), t = Pj(e, 2), r = t[1];
  return r;
}
var Dj = Lh();
const Rj = /* @__PURE__ */ Ji(Dj);
var kj = "ais", Nl = function(t) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = r.descendantName, i = r.modifierName, a = n ? "-".concat(n) : "", s = i ? "--".concat(i) : "";
    return "".concat(kj, "-").concat(t).concat(a).concat(s);
  };
}, Aj = Nl("Highlight");
function xj(e) {
  var t = e.attribute, r = e.highlightedTagName, n = r === void 0 ? "mark" : r, i = e.hit, a = e.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && qe(!1, "`instantsearch.highlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Highlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = js(i._highlightResult, t);
  process.env.NODE_ENV === "development" && qe(o, 'Could not enable highlight for "'.concat(t, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var c = o || {}, u = c.value, f = u === void 0 ? "" : u, g = Aj({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return f.replace(new RegExp(Yt.highlightPreTag, "g"), "<".concat(n, ' class="').concat(g, '">')).replace(new RegExp(Yt.highlightPostTag, "g"), "</".concat(n, ">"));
}
var Fj = Nl("ReverseHighlight");
function $j(e) {
  var t = e.attribute, r = e.highlightedTagName, n = r === void 0 ? "mark" : r, i = e.hit, a = e.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && qe(!1, "`instantsearch.reverseHighlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseHighlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = js(i._highlightResult, t);
  process.env.NODE_ENV === "development" && qe(o, 'Could not enable reverse highlight for "'.concat(t, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var c = o || {}, u = c.value, f = u === void 0 ? "" : u, g = Fj({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), p = II(NI(qh(f)));
  return p.replace(new RegExp(Yt.highlightPreTag, "g"), "<".concat(n, ' class="').concat(g, '">')).replace(new RegExp(Yt.highlightPostTag, "g"), "</".concat(n, ">"));
}
var Mj = Nl("Snippet");
function Lj(e) {
  var t = e.attribute, r = e.highlightedTagName, n = r === void 0 ? "mark" : r, i = e.hit, a = e.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && qe(!1, "`instantsearch.snippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Snippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = js(i._snippetResult, t);
  process.env.NODE_ENV === "development" && qe(o, 'Could not enable snippet for "'.concat(t, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var c = o || {}, u = c.value, f = u === void 0 ? "" : u, g = Mj({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return f.replace(new RegExp(Yt.highlightPreTag, "g"), "<".concat(n, ' class="').concat(g, '">')).replace(new RegExp(Yt.highlightPostTag, "g"), "</".concat(n, ">"));
}
var jj = Nl("ReverseSnippet");
function Wj(e) {
  var t = e.attribute, r = e.highlightedTagName, n = r === void 0 ? "mark" : r, i = e.hit, a = e.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && qe(!1, "`instantsearch.reverseSnippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseSnippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var o = js(i._snippetResult, t);
  process.env.NODE_ENV === "development" && qe(o, 'Could not enable reverse snippet for "'.concat(t, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var c = o || {}, u = c.value, f = u === void 0 ? "" : u, g = jj({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), p = II(NI(qh(f)));
  return p.replace(new RegExp(Yt.highlightPreTag, "g"), "<".concat(n, ' class="').concat(g, '">')).replace(new RegExp(Yt.highlightPostTag, "g"), "</".concat(n, ">"));
}
function xf(e) {
  "@babel/helpers - typeof";
  return xf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xf(e);
}
function Uj(e) {
  var t = e.method, r = e.payload;
  if (xf(r) !== "object")
    throw new Error("The insights helper expects the payload to be an object.");
  var n;
  try {
    n = PI(r);
  } catch {
    throw new Error("Could not JSON serialize the payload object.");
  }
  return 'data-insights-method="'.concat(t, '" data-insights-payload="').concat(n, '"');
}
function Vj(e, t) {
  return process.env.NODE_ENV === "development" && qe(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), Uj({
    method: e,
    payload: t
  });
}
function Ff(e) {
  "@babel/helpers - typeof";
  return Ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ff(e);
}
var Hj = "_ALGOLIA";
function qj(e) {
  if (!((typeof document > "u" ? "undefined" : Ff(document)) !== "object" || typeof document.cookie != "string"))
    for (var t = "".concat(e, "="), r = document.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var i = r[n]; i.charAt(0) === " "; )
        i = i.substring(1);
      if (i.indexOf(t) === 0)
        return i.substring(t.length, i.length);
    }
}
function zj() {
  return qj(Hj);
}
function Bj() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    var t = Math.random() * 16 | 0, r = e === "x" ? t : t & 3 | 8;
    return r.toString(16);
  });
}
function ds(e) {
  "@babel/helpers - typeof";
  return ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ds(e);
}
function Ly(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ly(Object(r), !0).forEach(function(n) {
      Gj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ly(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gj(e, t, r) {
  return t = Qj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Qj(e) {
  var t = Zj(e, "string");
  return ds(t) == "symbol" ? t : String(t);
}
function Zj(e, t) {
  if (ds(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ds(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dn(e, t) {
  return Jj(e) || Kj(e, t) || HI(e, t) || Yj();
}
function Yj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        c = !1;
      } else for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function Jj(e) {
  if (Array.isArray(e)) return e;
}
function Xj(e) {
  return rW(e) || tW(e) || HI(e) || eW();
}
function eW() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HI(e, t) {
  if (e) {
    if (typeof e == "string") return $f(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $f(e, t);
  }
}
function tW(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function rW(e) {
  if (Array.isArray(e)) return $f(e);
}
function $f(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var qI = "2.17.2", nW = "https://cdn.jsdelivr.net/npm/search-insights@".concat(qI, "/dist/search-insights.min.js");
function jy() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.insightsClient, r = e.insightsInitParams, n = e.onEvent, i = e.$$internal, a = i === void 0 ? !1 : i, s = e.$$automatic, o = s === void 0 ? !1 : s, c = t;
  !t && t !== null && An(function(f) {
    var g = f.window, p = g.AlgoliaAnalyticsObject || "aa";
    typeof p == "string" && (c = g[p]), c || (g.AlgoliaAnalyticsObject = p, g[p] || (g[p] = function() {
      g[p].queue || (g[p].queue = []);
      for (var d = arguments.length, h = new Array(d), v = 0; v < d; v++)
        h[v] = arguments[v];
      g[p].queue.push(h);
    }, g[p].version = qI, g[p].shouldAddScript = !0), c = g[p]);
  });
  var u = c || Tt;
  return function(f) {
    var g = f.instantSearchInstance, p = g.middleware.filter(function(w) {
      return w.instance.$$type === "ais.insights" && w.instance.$$internal;
    }).map(function(w) {
      return w.creator;
    });
    g.unuse.apply(g, Xj(p));
    var d = oy(g.client), h = dn(d, 2), v = h[0], b = h[1];
    process.env.NODE_ENV === "development" && qe(!!(v && b), "could not extract Algolia credentials from searchClient in insights middleware.");
    var m = void 0, S = void 0, I = void 0, C = u.queue;
    if (Array.isArray(C)) {
      var T = ["setUserToken", "init"].map(function(w) {
        var P = Xa(C.slice().reverse(), function(R) {
          var x = dn(R, 1), F = x[0];
          return F === w;
        }) || [], _ = dn(P, 2), D = _[1];
        return D;
      }), E = dn(T, 2);
      S = E[0], m = E[1];
    }
    u("getUserToken", null, function(w, P) {
      I = Uy(P);
    }), (r || !Wy(u)) && u("init", zn({
      appId: v,
      apiKey: b,
      partial: !0
    }, r));
    var N, y;
    return {
      $$type: "ais.insights",
      $$internal: a,
      $$automatic: o,
      onStateChange: function() {
      },
      subscribe: function() {
        if (u.shouldAddScript) {
          var P = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
          try {
            var _ = document.createElement("script");
            _.async = !0, _.src = nW, _.onerror = function() {
              g.emit("error", new Error(P));
            }, document.body.appendChild(_), u.shouldAddScript = !1;
          } catch {
            u.shouldAddScript = !1, g.emit("error", new Error(P));
          }
        }
      },
      started: function() {
        u("addAlgoliaAgent", "insights-middleware"), y = g.mainHelper;
        var P = u.queue;
        if (Array.isArray(P)) {
          var _ = ["setUserToken", "init"].map(function(G) {
            var X = Xa(P.slice().reverse(), function(ue) {
              var de = dn(ue, 1), Q = de[0];
              return Q === G;
            }) || [], re = dn(X, 2), oe = re[1];
            return oe;
          }), D = dn(_, 2);
          S = D[0], m = D[1];
        }
        N = iW(g), o || y.overrideStateWithoutTriggeringChangeEvent(zn(zn({}, y.state), {}, {
          clickAnalytics: !0
        })), a || g.scheduleSearch();
        var R = function(X) {
          var re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, oe = Uy(X);
          if (!oe)
            return;
          var ue = y.state.userToken;
          function de() {
            y.overrideStateWithoutTriggeringChangeEvent(zn(zn({}, y.state), {}, {
              userToken: oe
            })), ue && ue !== X && g.scheduleSearch();
          }
          re ? de() : setTimeout(de, 0);
        };
        function x(G) {
          R(G, !0), u("setUserToken", G);
        }
        var F = void 0, W = zj();
        if (W)
          F = W;
        else {
          var A = "anonymous-".concat(Bj());
          F = A;
        }
        var M, j = N.userToken;
        if (r != null && r.userToken && (M = r.userToken), M)
          x(M);
        else if (j)
          x(j);
        else if (I)
          x(I);
        else if (S)
          x(S);
        else if (F) {
          var B;
          if (x(F), r != null && r.useCookie || (B = m) !== null && B !== void 0 && B.useCookie) {
            var L;
            aW(F, r?.cookieDuration || ((L = m) === null || L === void 0 ? void 0 : L.cookieDuration));
          }
        }
        u("onUserTokenChange", function(G) {
          return R(G, !0);
        }, {
          immediate: !0
        });
        var H = u;
        Wy(u) && (H = function(X, re) {
          var oe = oy(g.client), ue = dn(oe, 2), de = ue[0], Q = ue[1], he = {
            headers: {
              "X-Algolia-Application-Id": de,
              "X-Algolia-API-Key": Q
            }
          };
          return u(X, re, he);
        });
        var q = /* @__PURE__ */ new Set(), te;
        g.mainHelper.derivedHelpers[0].on("result", function(G) {
          var X = G.results;
          X && (!X.queryID || X.queryID !== te) && (te = X.queryID, q.clear());
        }), g.sendEventToInsights = function(G) {
          if (n)
            n(G, H);
          else if (G.insightsMethod) {
            if (G.insightsMethod === "viewedObjectIDs") {
              var X = G.payload, re = X.objectIDs.filter(function(oe) {
                return !q.has(oe);
              });
              if (re.length === 0)
                return;
              re.forEach(function(oe) {
                return q.add(oe);
              }), X.objectIDs = re;
            }
            G.payload.algoliaSource = ["instantsearch"], o && G.payload.algoliaSource.push("instantsearch-automatic"), G.eventModifier === "internal" && G.payload.algoliaSource.push("instantsearch-internal"), H(G.insightsMethod, G.payload), process.env.NODE_ENV === "development" && qe(!!y.state.userToken, `
Cannot send event to Algolia Insights because \`userToken\` is not set.

See documentation: https://www.algolia.com/doc/guides/building-search-ui/going-further/send-insights-events/js/#setting-the-usertoken
`);
          } else
            process.env.NODE_ENV === "development" && qe(!1, "Cannot send event to Algolia Insights because `insightsMethod` option is missing.");
        };
      },
      unsubscribe: function() {
        u("onUserTokenChange", void 0), g.sendEventToInsights = Tt, y && N && (y.overrideStateWithoutTriggeringChangeEvent(zn(zn({}, y.state), N)), g.scheduleSearch());
      }
    };
  };
}
function iW(e) {
  var t, r, n = ((t = e._initialResults) === null || t === void 0 || (r = t[e.indexName]) === null || r === void 0 ? void 0 : r.state) || {}, i = e.mainHelper.state;
  return {
    userToken: n.userToken || i.userToken,
    clickAnalytics: n.clickAnalytics || i.clickAnalytics
  };
}
function aW(e, t) {
  var r = 2592e6, n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + (t || r * 6));
  var i = "expires=".concat(n.toUTCString());
  document.cookie = "_ALGOLIA=".concat(e, ";").concat(i, ";path=/");
}
function Wy(e) {
  var t = (e.version || "").split(".").map(Number), r = dn(t, 2), n = r[0], i = r[1], a = n >= 3, s = n === 2 && i >= 6, o = n === 1 && i >= 10;
  return a || s || o;
}
function Uy(e) {
  if (e)
    return typeof e == "number" ? e.toString() : e;
}
function zI(e, t, r) {
  var n = Fa(t, t.mainIndex, t._initialUiState);
  e.forEach(function(i) {
    var a = {};
    if (i.getWidgetRenderState) {
      var s = i.getWidgetRenderState(n);
      s && s.widgetParams && (a = s.widgetParams);
    }
    var o = Object.keys(a).filter(function(c) {
      return a[c] !== void 0;
    });
    r.widgets.push({
      type: i.$$type,
      widgetType: i.$$widgetType,
      params: o
    }), i.$$type === "ais.index" && zI(i.getWidgets(), t, r);
  });
}
function sW() {
  return An(function(e) {
    var t, r, n = e.window;
    return ((t = n.navigator) === null || t === void 0 || (r = t.userAgent) === null || r === void 0 ? void 0 : r.indexOf("Algolia Crawler")) > -1;
  }, {
    fallback: function() {
      return !1;
    }
  });
}
function oW() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.$$internal, r = t === void 0 ? !1 : t;
  return function(n) {
    var i = n.instantSearchInstance, a = {
      widgets: []
    }, s = document.createElement("meta"), o = document.querySelector("head");
    return s.name = "instantsearch:widgets", {
      $$type: "ais.metadata",
      $$internal: r,
      onStateChange: function() {
      },
      subscribe: function() {
        setTimeout(function() {
          var u = i.client;
          a.ua = u.transporter && u.transporter.userAgent ? u.transporter.userAgent.value : u._ua, zI(i.mainIndex.getWidgets(), i, a), i.middleware.forEach(function(f) {
            return a.widgets.push({
              middleware: !0,
              type: f.instance.$$type,
              internal: f.instance.$$internal
            });
          }), s.content = JSON.stringify(a), o.appendChild(s);
        }, 0);
      },
      started: function() {
      },
      unsubscribe: function() {
        s.remove();
      }
    };
  };
}
var kd, Vy;
function Yh() {
  if (Vy) return kd;
  Vy = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return kd = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, kd;
}
var Ad, Hy;
function BI() {
  if (Hy) return Ad;
  Hy = 1;
  var e = Yh(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var v = [], b = 0; b < 256; ++b)
      v.push("%" + ((b < 16 ? "0" : "") + b.toString(16)).toUpperCase());
    return v;
  }(), i = function(b) {
    for (; b.length > 1; ) {
      var m = b.pop(), S = m.obj[m.prop];
      if (r(S)) {
        for (var I = [], C = 0; C < S.length; ++C)
          typeof S[C] < "u" && I.push(S[C]);
        m.obj[m.prop] = I;
      }
    }
  }, a = function(b, m) {
    for (var S = m && m.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, I = 0; I < b.length; ++I)
      typeof b[I] < "u" && (S[I] = b[I]);
    return S;
  }, s = function v(b, m, S) {
    if (!m)
      return b;
    if (typeof m != "object") {
      if (r(b))
        b.push(m);
      else if (b && typeof b == "object")
        (S && (S.plainObjects || S.allowPrototypes) || !t.call(Object.prototype, m)) && (b[m] = !0);
      else
        return [b, m];
      return b;
    }
    if (!b || typeof b != "object")
      return [b].concat(m);
    var I = b;
    return r(b) && !r(m) && (I = a(b, S)), r(b) && r(m) ? (m.forEach(function(C, T) {
      if (t.call(b, T)) {
        var E = b[T];
        E && typeof E == "object" && C && typeof C == "object" ? b[T] = v(E, C, S) : b.push(C);
      } else
        b[T] = C;
    }), b) : Object.keys(m).reduce(function(C, T) {
      var E = m[T];
      return t.call(C, T) ? C[T] = v(C[T], E, S) : C[T] = E, C;
    }, I);
  }, o = function(b, m) {
    return Object.keys(m).reduce(function(S, I) {
      return S[I] = m[I], S;
    }, b);
  }, c = function(v, b, m) {
    var S = v.replace(/\+/g, " ");
    if (m === "iso-8859-1")
      return S.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(S);
    } catch {
      return S;
    }
  }, u = function(b, m, S, I, C) {
    if (b.length === 0)
      return b;
    var T = b;
    if (typeof b == "symbol" ? T = Symbol.prototype.toString.call(b) : typeof b != "string" && (T = String(b)), S === "iso-8859-1")
      return escape(T).replace(/%u[0-9a-f]{4}/gi, function(w) {
        return "%26%23" + parseInt(w.slice(2), 16) + "%3B";
      });
    for (var E = "", N = 0; N < T.length; ++N) {
      var y = T.charCodeAt(N);
      if (y === 45 || y === 46 || y === 95 || y === 126 || y >= 48 && y <= 57 || y >= 65 && y <= 90 || y >= 97 && y <= 122 || C === e.RFC1738 && (y === 40 || y === 41)) {
        E += T.charAt(N);
        continue;
      }
      if (y < 128) {
        E = E + n[y];
        continue;
      }
      if (y < 2048) {
        E = E + (n[192 | y >> 6] + n[128 | y & 63]);
        continue;
      }
      if (y < 55296 || y >= 57344) {
        E = E + (n[224 | y >> 12] + n[128 | y >> 6 & 63] + n[128 | y & 63]);
        continue;
      }
      N += 1, y = 65536 + ((y & 1023) << 10 | T.charCodeAt(N) & 1023), E += n[240 | y >> 18] + n[128 | y >> 12 & 63] + n[128 | y >> 6 & 63] + n[128 | y & 63];
    }
    return E;
  }, f = function(b) {
    for (var m = [{ obj: { o: b }, prop: "o" }], S = [], I = 0; I < m.length; ++I)
      for (var C = m[I], T = C.obj[C.prop], E = Object.keys(T), N = 0; N < E.length; ++N) {
        var y = E[N], w = T[y];
        typeof w == "object" && w !== null && S.indexOf(w) === -1 && (m.push({ obj: T, prop: y }), S.push(w));
      }
    return i(m), b;
  }, g = function(b) {
    return Object.prototype.toString.call(b) === "[object RegExp]";
  }, p = function(b) {
    return !b || typeof b != "object" ? !1 : !!(b.constructor && b.constructor.isBuffer && b.constructor.isBuffer(b));
  }, d = function(b, m) {
    return [].concat(b, m);
  }, h = function(b, m) {
    if (r(b)) {
      for (var S = [], I = 0; I < b.length; I += 1)
        S.push(m(b[I]));
      return S;
    }
    return m(b);
  };
  return Ad = {
    arrayToObject: a,
    assign: o,
    combine: d,
    compact: f,
    decode: c,
    encode: u,
    isBuffer: p,
    isRegExp: g,
    maybeMap: h,
    merge: s
  }, Ad;
}
var xd, qy;
function lW() {
  if (qy) return xd;
  qy = 1;
  var e = BI(), t = Yh(), r = Object.prototype.hasOwnProperty, n = {
    brackets: function(v) {
      return v + "[]";
    },
    comma: "comma",
    indices: function(v, b) {
      return v + "[" + b + "]";
    },
    repeat: function(v) {
      return v;
    }
  }, i = Array.isArray, a = String.prototype.split, s = Array.prototype.push, o = function(h, v) {
    s.apply(h, i(v) ? v : [v]);
  }, c = Date.prototype.toISOString, u = t.default, f = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: e.encode,
    encodeValuesOnly: !1,
    format: u,
    formatter: t.formatters[u],
    // deprecated
    indices: !1,
    serializeDate: function(v) {
      return c.call(v);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, g = function(v) {
    return typeof v == "string" || typeof v == "number" || typeof v == "boolean" || typeof v == "symbol" || typeof v == "bigint";
  }, p = function h(v, b, m, S, I, C, T, E, N, y, w, P, _, D) {
    var R = v;
    if (typeof T == "function" ? R = T(b, R) : R instanceof Date ? R = y(R) : m === "comma" && i(R) && (R = e.maybeMap(R, function(G) {
      return G instanceof Date ? y(G) : G;
    })), R === null) {
      if (S)
        return C && !_ ? C(b, f.encoder, D, "key", w) : b;
      R = "";
    }
    if (g(R) || e.isBuffer(R)) {
      if (C) {
        var x = _ ? b : C(b, f.encoder, D, "key", w);
        if (m === "comma" && _) {
          for (var F = a.call(String(R), ","), W = "", A = 0; A < F.length; ++A)
            W += (A === 0 ? "" : ",") + P(C(F[A], f.encoder, D, "value", w));
          return [P(x) + "=" + W];
        }
        return [P(x) + "=" + P(C(R, f.encoder, D, "value", w))];
      }
      return [P(b) + "=" + P(String(R))];
    }
    var M = [];
    if (typeof R > "u")
      return M;
    var j;
    if (m === "comma" && i(R))
      j = [{ value: R.length > 0 ? R.join(",") || null : void 0 }];
    else if (i(T))
      j = T;
    else {
      var B = Object.keys(R);
      j = E ? B.sort(E) : B;
    }
    for (var L = 0; L < j.length; ++L) {
      var H = j[L], q = typeof H == "object" && typeof H.value < "u" ? H.value : R[H];
      if (!(I && q === null)) {
        var te = i(R) ? typeof m == "function" ? m(b, H) : b : b + (N ? "." + H : "[" + H + "]");
        o(M, h(
          q,
          te,
          m,
          S,
          I,
          C,
          T,
          E,
          N,
          y,
          w,
          P,
          _,
          D
        ));
      }
    }
    return M;
  }, d = function(v) {
    if (!v)
      return f;
    if (v.encoder !== null && typeof v.encoder < "u" && typeof v.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var b = v.charset || f.charset;
    if (typeof v.charset < "u" && v.charset !== "utf-8" && v.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var m = t.default;
    if (typeof v.format < "u") {
      if (!r.call(t.formatters, v.format))
        throw new TypeError("Unknown format option provided.");
      m = v.format;
    }
    var S = t.formatters[m], I = f.filter;
    return (typeof v.filter == "function" || i(v.filter)) && (I = v.filter), {
      addQueryPrefix: typeof v.addQueryPrefix == "boolean" ? v.addQueryPrefix : f.addQueryPrefix,
      allowDots: typeof v.allowDots > "u" ? f.allowDots : !!v.allowDots,
      charset: b,
      charsetSentinel: typeof v.charsetSentinel == "boolean" ? v.charsetSentinel : f.charsetSentinel,
      delimiter: typeof v.delimiter > "u" ? f.delimiter : v.delimiter,
      encode: typeof v.encode == "boolean" ? v.encode : f.encode,
      encoder: typeof v.encoder == "function" ? v.encoder : f.encoder,
      encodeValuesOnly: typeof v.encodeValuesOnly == "boolean" ? v.encodeValuesOnly : f.encodeValuesOnly,
      filter: I,
      format: m,
      formatter: S,
      serializeDate: typeof v.serializeDate == "function" ? v.serializeDate : f.serializeDate,
      skipNulls: typeof v.skipNulls == "boolean" ? v.skipNulls : f.skipNulls,
      sort: typeof v.sort == "function" ? v.sort : null,
      strictNullHandling: typeof v.strictNullHandling == "boolean" ? v.strictNullHandling : f.strictNullHandling
    };
  };
  return xd = function(h, v) {
    var b = h, m = d(v), S, I;
    typeof m.filter == "function" ? (I = m.filter, b = I("", b)) : i(m.filter) && (I = m.filter, S = I);
    var C = [];
    if (typeof b != "object" || b === null)
      return "";
    var T;
    v && v.arrayFormat in n ? T = v.arrayFormat : v && "indices" in v ? T = v.indices ? "indices" : "repeat" : T = "indices";
    var E = n[T];
    S || (S = Object.keys(b)), m.sort && S.sort(m.sort);
    for (var N = 0; N < S.length; ++N) {
      var y = S[N];
      m.skipNulls && b[y] === null || o(C, p(
        b[y],
        y,
        E,
        m.strictNullHandling,
        m.skipNulls,
        m.encode ? m.encoder : null,
        m.filter,
        m.sort,
        m.allowDots,
        m.serializeDate,
        m.format,
        m.formatter,
        m.encodeValuesOnly,
        m.charset
      ));
    }
    var w = C.join(m.delimiter), P = m.addQueryPrefix === !0 ? "?" : "";
    return m.charsetSentinel && (m.charset === "iso-8859-1" ? P += "utf8=%26%2310003%3B&" : P += "utf8=%E2%9C%93&"), w.length > 0 ? P + w : "";
  }, xd;
}
var Fd, zy;
function cW() {
  if (zy) return Fd;
  zy = 1;
  var e = BI(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowPrototypes: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, i = function(p) {
    return p.replace(/&#(\d+);/g, function(d, h) {
      return String.fromCharCode(parseInt(h, 10));
    });
  }, a = function(p, d) {
    return p && typeof p == "string" && d.comma && p.indexOf(",") > -1 ? p.split(",") : p;
  }, s = "utf8=%26%2310003%3B", o = "utf8=%E2%9C%93", c = function(d, h) {
    var v = {}, b = h.ignoreQueryPrefix ? d.replace(/^\?/, "") : d, m = h.parameterLimit === 1 / 0 ? void 0 : h.parameterLimit, S = b.split(h.delimiter, m), I = -1, C, T = h.charset;
    if (h.charsetSentinel)
      for (C = 0; C < S.length; ++C)
        S[C].indexOf("utf8=") === 0 && (S[C] === o ? T = "utf-8" : S[C] === s && (T = "iso-8859-1"), I = C, C = S.length);
    for (C = 0; C < S.length; ++C)
      if (C !== I) {
        var E = S[C], N = E.indexOf("]="), y = N === -1 ? E.indexOf("=") : N + 1, w, P;
        y === -1 ? (w = h.decoder(E, n.decoder, T, "key"), P = h.strictNullHandling ? null : "") : (w = h.decoder(E.slice(0, y), n.decoder, T, "key"), P = e.maybeMap(
          a(E.slice(y + 1), h),
          function(_) {
            return h.decoder(_, n.decoder, T, "value");
          }
        )), P && h.interpretNumericEntities && T === "iso-8859-1" && (P = i(P)), E.indexOf("[]=") > -1 && (P = r(P) ? [P] : P), t.call(v, w) ? v[w] = e.combine(v[w], P) : v[w] = P;
      }
    return v;
  }, u = function(p, d, h, v) {
    for (var b = v ? d : a(d, h), m = p.length - 1; m >= 0; --m) {
      var S, I = p[m];
      if (I === "[]" && h.parseArrays)
        S = [].concat(b);
      else {
        S = h.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var C = I.charAt(0) === "[" && I.charAt(I.length - 1) === "]" ? I.slice(1, -1) : I, T = parseInt(C, 10);
        !h.parseArrays && C === "" ? S = { 0: b } : !isNaN(T) && I !== C && String(T) === C && T >= 0 && h.parseArrays && T <= h.arrayLimit ? (S = [], S[T] = b) : C !== "__proto__" && (S[C] = b);
      }
      b = S;
    }
    return b;
  }, f = function(d, h, v, b) {
    if (d) {
      var m = v.allowDots ? d.replace(/\.([^.[]+)/g, "[$1]") : d, S = /(\[[^[\]]*])/, I = /(\[[^[\]]*])/g, C = v.depth > 0 && S.exec(m), T = C ? m.slice(0, C.index) : m, E = [];
      if (T) {
        if (!v.plainObjects && t.call(Object.prototype, T) && !v.allowPrototypes)
          return;
        E.push(T);
      }
      for (var N = 0; v.depth > 0 && (C = I.exec(m)) !== null && N < v.depth; ) {
        if (N += 1, !v.plainObjects && t.call(Object.prototype, C[1].slice(1, -1)) && !v.allowPrototypes)
          return;
        E.push(C[1]);
      }
      return C && E.push("[" + m.slice(C.index) + "]"), u(E, h, v, b);
    }
  }, g = function(d) {
    if (!d)
      return n;
    if (d.decoder !== null && d.decoder !== void 0 && typeof d.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof d.charset < "u" && d.charset !== "utf-8" && d.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var h = typeof d.charset > "u" ? n.charset : d.charset;
    return {
      allowDots: typeof d.allowDots > "u" ? n.allowDots : !!d.allowDots,
      allowPrototypes: typeof d.allowPrototypes == "boolean" ? d.allowPrototypes : n.allowPrototypes,
      arrayLimit: typeof d.arrayLimit == "number" ? d.arrayLimit : n.arrayLimit,
      charset: h,
      charsetSentinel: typeof d.charsetSentinel == "boolean" ? d.charsetSentinel : n.charsetSentinel,
      comma: typeof d.comma == "boolean" ? d.comma : n.comma,
      decoder: typeof d.decoder == "function" ? d.decoder : n.decoder,
      delimiter: typeof d.delimiter == "string" || e.isRegExp(d.delimiter) ? d.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof d.depth == "number" || d.depth === !1 ? +d.depth : n.depth,
      ignoreQueryPrefix: d.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof d.interpretNumericEntities == "boolean" ? d.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof d.parameterLimit == "number" ? d.parameterLimit : n.parameterLimit,
      parseArrays: d.parseArrays !== !1,
      plainObjects: typeof d.plainObjects == "boolean" ? d.plainObjects : n.plainObjects,
      strictNullHandling: typeof d.strictNullHandling == "boolean" ? d.strictNullHandling : n.strictNullHandling
    };
  };
  return Fd = function(p, d) {
    var h = g(d);
    if (p === "" || p === null || typeof p > "u")
      return h.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var v = typeof p == "string" ? c(p, h) : p, b = h.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, m = Object.keys(v), S = 0; S < m.length; ++S) {
      var I = m[S], C = f(I, v[I], h, typeof p == "string");
      b = e.merge(b, C, h);
    }
    return e.compact(b);
  }, Fd;
}
var $d, By;
function uW() {
  if (By) return $d;
  By = 1;
  var e = lW(), t = cW(), r = Yh();
  return $d = {
    formats: r,
    parse: t,
    stringify: e
  }, $d;
}
var dW = uW();
const Gy = /* @__PURE__ */ Ji(dW);
function fs(e) {
  "@babel/helpers - typeof";
  return fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fs(e);
}
function fW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hW(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, GI(n.key), n);
  }
}
function mW(e, t, r) {
  return t && hW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Jt(e, t, r) {
  return t = GI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function GI(e) {
  var t = pW(e, "string");
  return fs(t) == "symbol" ? t : String(t);
}
function pW(e, t) {
  if (fs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Qy = function(t) {
  t && (window.document.title = t);
}, gW = /* @__PURE__ */ function() {
  function e(t) {
    var r = this, n = t.windowTitle, i = t.writeDelay, a = i === void 0 ? 400 : i, s = t.createURL, o = t.parseURL, c = t.getLocation, u = t.start, f = t.dispose, g = t.push, p = t.cleanUrlOnDispose;
    fW(this, e), Jt(this, "$$type", "ais.browser"), Jt(this, "windowTitle", void 0), Jt(this, "writeDelay", void 0), Jt(this, "_createURL", void 0), Jt(this, "parseURL", void 0), Jt(this, "getLocation", void 0), Jt(this, "writeTimer", void 0), Jt(this, "_onPopState", void 0), Jt(this, "inPopState", !1), Jt(this, "isDisposed", !1), Jt(this, "latestAcknowledgedHistory", 0), Jt(this, "_start", void 0), Jt(this, "_dispose", void 0), Jt(this, "_push", void 0), Jt(this, "_cleanUrlOnDispose", void 0), this.windowTitle = n, this.writeTimer = void 0, this.writeDelay = a, this._createURL = s, this.parseURL = o, this.getLocation = c, this._start = u, this._dispose = f, this._push = g, this._cleanUrlOnDispose = typeof p > "u" ? !0 : p, process.env.NODE_ENV === "development" && typeof p > "u" && console.info(`Starting from the next major version, InstantSearch will not clean up the URL from active refinements when it is disposed.

We recommend setting \`cleanUrlOnDispose\` to false to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to true.

See documentation: `.concat(Yo({
      name: "history-router"
    }), "#widget-param-cleanurlondispose")), An(function(d) {
      var h = d.window, v = r.windowTitle && r.windowTitle(r.read());
      Qy(v), r.latestAcknowledgedHistory = h.history.length;
    });
  }
  return mW(e, [{
    key: "read",
    value: function() {
      return this.parseURL({
        qsModule: Gy,
        location: this.getLocation()
      });
    }
    /**
     * Pushes a search state into the URL.
     */
  }, {
    key: "write",
    value: function(r) {
      var n = this;
      An(function(i) {
        var a = i.window, s = n.createURL(r), o = n.windowTitle && n.windowTitle(r);
        n.writeTimer && clearTimeout(n.writeTimer), n.writeTimer = setTimeout(function() {
          Qy(o), n.shouldWrite(s) && (n._push ? n._push(s) : a.history.pushState(r, o || "", s), n.latestAcknowledgedHistory = a.history.length), n.inPopState = !1, n.writeTimer = void 0;
        }, n.writeDelay);
      });
    }
    /**
     * Sets a callback on the `onpopstate` event of the history API of the current page.
     * It enables the URL sync to keep track of the changes.
     */
  }, {
    key: "onUpdate",
    value: function(r) {
      var n = this;
      this._start && this._start(function() {
        r(n.read());
      }), this._onPopState = function() {
        n.writeTimer && (clearTimeout(n.writeTimer), n.writeTimer = void 0), n.inPopState = !0, r(n.read());
      }, An(function(i) {
        var a = i.window;
        a.addEventListener("popstate", n._onPopState);
      });
    }
    /**
     * Creates a complete URL from a given syncable UI state.
     *
     * It always generates the full URL, not a relative one.
     * This allows to handle cases like using a <base href>.
     * See: https://github.com/algolia/instantsearch/issues/790
     */
  }, {
    key: "createURL",
    value: function(r) {
      var n = this._createURL({
        qsModule: Gy,
        routeState: r,
        location: this.getLocation()
      });
      if (process.env.NODE_ENV === "development")
        try {
          new URL(n);
        } catch {
          process.env.NODE_ENV === "development" && qe(!1, "The URL returned by the `createURL` function is invalid.\nPlease make sure it returns an absolute URL to avoid issues, e.g: `https://algolia.com/search?query=iphone`.");
        }
      return n;
    }
    /**
     * Removes the event listener and cleans up the URL.
     */
  }, {
    key: "dispose",
    value: function() {
      var r = this;
      this._dispose && this._dispose(), this.isDisposed = !0, An(function(n) {
        var i = n.window;
        r._onPopState && i.removeEventListener("popstate", r._onPopState);
      }), this.writeTimer && clearTimeout(this.writeTimer), this._cleanUrlOnDispose && this.write({});
    }
  }, {
    key: "start",
    value: function() {
      this.isDisposed = !1;
    }
  }, {
    key: "shouldWrite",
    value: function(r) {
      var n = this;
      return An(function(i) {
        var a = i.window;
        if (n.isDisposed && !n._cleanUrlOnDispose)
          return !1;
        var s = !(n.isDisposed && n.latestAcknowledgedHistory !== a.history.length);
        return (
          // When the last state change was through popstate, the IS.js state changes,
          // but that should not write the URL.
          !n.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
          s && // When the URL is the same as the current one, we do not want to write it.
          r !== a.location.href
        );
      });
    }
  }]), e;
}();
function QI() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.createURL, r = t === void 0 ? function(h) {
    var v = h.qsModule, b = h.routeState, m = h.location, S = m.protocol, I = m.hostname, C = m.port, T = C === void 0 ? "" : C, E = m.pathname, N = m.hash, y = v.stringify(b), w = T === "" ? "" : ":".concat(T);
    return y ? "".concat(S, "//").concat(I).concat(w).concat(E, "?").concat(y).concat(N) : "".concat(S, "//").concat(I).concat(w).concat(E).concat(N);
  } : t, n = e.parseURL, i = n === void 0 ? function(h) {
    var v = h.qsModule, b = h.location;
    return v.parse(b.search.slice(1), {
      arrayLimit: 99
    });
  } : n, a = e.writeDelay, s = a === void 0 ? 400 : a, o = e.windowTitle, c = e.getLocation, u = c === void 0 ? function() {
    return An(function(h) {
      var v = h.window;
      return v.location;
    }, {
      fallback: function() {
        throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
      }
    });
  } : c, f = e.start, g = e.dispose, p = e.push, d = e.cleanUrlOnDispose;
  return new gW({
    createURL: r,
    parseURL: i,
    writeDelay: s,
    windowTitle: o,
    getLocation: u,
    start: f,
    dispose: g,
    push: p,
    cleanUrlOnDispose: d
  });
}
function hs(e) {
  "@babel/helpers - typeof";
  return hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hs(e);
}
var vW = ["configure"];
function Zy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zy(Object(r), !0).forEach(function(n) {
      Mf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Mf(e, t, r) {
  return t = yW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yW(e) {
  var t = bW(e, "string");
  return hs(t) == "symbol" ? t : String(t);
}
function bW(e, t) {
  if (hs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (hs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function SW(e, t) {
  if (e == null) return {};
  var r = wW(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function wW(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function Yy(e) {
  e.configure;
  var t = SW(e, vW);
  return t;
}
function IW() {
  return {
    $$type: "ais.simple",
    stateToRoute: function(t) {
      return Object.keys(t).reduce(function(r, n) {
        return vo(vo({}, r), {}, Mf({}, n, Yy(t[n])));
      }, {});
    },
    routeToState: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Object.keys(t).reduce(function(r, n) {
        return vo(vo({}, r), {}, Mf({}, n, Yy(t[n])));
      }, {});
    }
  };
}
function ms(e) {
  "@babel/helpers - typeof";
  return ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function Ky(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ky(Object(r), !0).forEach(function(n) {
      ZI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ky(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ZI(e, t, r) {
  return t = CW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CW(e) {
  var t = PW(e, "string");
  return ms(t) == "symbol" ? t : String(t);
}
function PW(e, t) {
  if (ms(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ms(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var TW = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.router, n = r === void 0 ? QI() : r, i = t.stateMapping, a = i === void 0 ? IW() : i, s = t.$$internal, o = s === void 0 ? !1 : s;
  return function(c) {
    var u = c.instantSearchInstance;
    function f(d) {
      var h = (
        // If only the mainIndex is initialized, we don't yet know what other
        // index widgets are used. Therefore we fall back to the initialUiState.
        // We can't indiscriminately use the initialUiState because then we
        // reintroduce state that was changed by the user.
        // When there are no widgets, we are sure the user can't yet have made
        // any changes.
        u.mainIndex.getWidgets().length === 0 ? u._initialUiState : u.mainIndex.getWidgetUiState({})
      ), v = Object.keys(d).reduce(function(m, S) {
        return yo(yo({}, m), {}, ZI({}, S, d[S]));
      }, h), b = a.stateToRoute(v);
      return n.createURL(b);
    }
    u._createURL = f;
    var g = void 0, p = u._initialUiState;
    return {
      $$type: "ais.router({router:".concat(n.$$type || "__unknown__", ", stateMapping:").concat(a.$$type || "__unknown__", "})"),
      $$internal: o,
      onStateChange: function(h) {
        var v = h.uiState, b = a.stateToRoute(v);
        (g === void 0 || !zh(g, b)) && (n.write(b), g = b);
      },
      subscribe: function() {
        process.env.NODE_ENV === "development" && qe(Object.keys(p).length === 0, "Using `initialUiState` together with routing is not recommended. The `initialUiState` will be overwritten by the URL parameters."), u._initialUiState = yo(yo({}, p), a.routeToState(n.read())), n.onUpdate(function(h) {
          u.mainIndex.getWidgets().length > 0 && u.setUiState(a.routeToState(h));
        });
      },
      started: function() {
        var h;
        (h = n.start) === null || h === void 0 || h.call(n);
      },
      unsubscribe: function() {
        n.dispose();
      }
    };
  };
};
function _W(e, t) {
  return e.toLocaleString(t);
}
function ps(e) {
  "@babel/helpers - typeof";
  return ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ps(e);
}
function Jy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jy(Object(r), !0).forEach(function(n) {
      EW(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function EW(e, t, r) {
  return t = OW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OW(e) {
  var t = NW(e, "string");
  return ps(t) == "symbol" ? t : String(t);
}
function NW(e, t) {
  if (ps(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ps(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function DW(e) {
  var t = e.numberLocale;
  return {
    formatNumber: function(n, i) {
      return _W(Number(i(n)), t);
    },
    highlight: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(xj(cn(cn({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The highlight helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseHighlight: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i($j(cn(cn({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseHighlight helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    snippet: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(Lj(cn(cn({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The snippet helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseSnippet: function(n, i) {
      try {
        var a = JSON.parse(n);
        return i(Wj(cn(cn({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseSnippet helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    insights: function(n, i) {
      try {
        var a = JSON.parse(n), s = a.method, o = a.payload;
        return i(Vj(s, cn({
          objectIDs: [this.objectID]
        }, o)));
      } catch {
        throw new Error(`
The insights helper expects a JSON object of the format:
{ "method": "method-name", "payload": { "eventName": "name of the event" } }`);
      }
    }
  };
}
const RW = "4.78.3";
function Gi(e) {
  "@babel/helpers - typeof";
  return Gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gi(e);
}
function Xy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Md(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xy(Object(r), !0).forEach(function(n) {
      Ye(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function AW(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YI(n.key), n);
  }
}
function xW(e, t, r) {
  return t && AW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function FW(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lf(e, t);
}
function Lf(e, t) {
  return Lf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Lf(e, t);
}
function $W(e) {
  var t = LW();
  return function() {
    var n = Ko(e), i;
    if (t) {
      var a = Ko(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return MW(this, i);
  };
}
function MW(e, t) {
  if (t && (Gi(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qe(e);
}
function Qe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function LW() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ko(e) {
  return Ko = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ko(e);
}
function Ye(e, t, r) {
  return t = YI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YI(e) {
  var t = jW(e, "string");
  return Gi(t) == "symbol" ? t : String(t);
}
function jW(e, t) {
  if (Gi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Gi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var jr = In({
  name: "instantsearch"
});
function WW() {
  return "#";
}
var KI = {
  preserveSharedStateOnUnmount: !1,
  persistHierarchicalRootCount: !1
}, UW = /* @__PURE__ */ function(e) {
  FW(r, e);
  var t = $W(r);
  function r(n) {
    var i, a;
    kW(this, r), a = t.call(this), Ye(Qe(a), "client", void 0), Ye(Qe(a), "indexName", void 0), Ye(Qe(a), "compositionID", void 0), Ye(Qe(a), "insightsClient", void 0), Ye(Qe(a), "onStateChange", null), Ye(Qe(a), "future", void 0), Ye(Qe(a), "helper", void 0), Ye(Qe(a), "mainHelper", void 0), Ye(Qe(a), "mainIndex", void 0), Ye(Qe(a), "started", void 0), Ye(Qe(a), "templatesConfig", void 0), Ye(Qe(a), "renderState", {}), Ye(Qe(a), "_stalledSearchDelay", void 0), Ye(Qe(a), "_searchStalledTimer", void 0), Ye(Qe(a), "_initialUiState", void 0), Ye(Qe(a), "_initialResults", void 0), Ye(Qe(a), "_createURL", void 0), Ye(Qe(a), "_searchFunction", void 0), Ye(Qe(a), "_mainHelperSearch", void 0), Ye(Qe(a), "_hasSearchWidget", !1), Ye(Qe(a), "_hasRecommendWidget", !1), Ye(Qe(a), "_insights", void 0), Ye(Qe(a), "middleware", []), Ye(Qe(a), "sendEventToInsights", void 0), Ye(Qe(a), "status", "idle"), Ye(Qe(a), "error", void 0), Ye(Qe(a), "scheduleSearch", Sa(function() {
      a.started && a.mainHelper.search();
    })), Ye(Qe(a), "scheduleRender", Sa(function() {
      var R, x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      (R = a.mainHelper) !== null && R !== void 0 && R.hasPendingRequests() || (clearTimeout(a._searchStalledTimer), a._searchStalledTimer = null, x && (a.status = "idle", a.error = void 0)), a.mainIndex.render({
        instantSearchInstance: Qe(a)
      }), a.emit("render");
    })), Ye(Qe(a), "onInternalStateChange", Sa(function() {
      var R = a.mainIndex.getWidgetUiState({});
      a.middleware.forEach(function(x) {
        var F = x.instance;
        F.onStateChange({
          uiState: R
        });
      });
    })), a.setMaxListeners(100);
    var s = n.indexName, o = s === void 0 ? "" : s, c = n.compositionID, u = n.numberLocale, f = n.initialUiState, g = f === void 0 ? {} : f, p = n.routing, d = p === void 0 ? null : p, h = n.insights, v = h === void 0 ? void 0 : h, b = n.searchFunction, m = n.stalledSearchDelay, S = m === void 0 ? 200 : m, I = n.searchClient, C = I === void 0 ? null : I, T = n.insightsClient, E = T === void 0 ? null : T, N = n.onStateChange, y = N === void 0 ? null : N, w = n.future, P = w === void 0 ? Md(Md({}, KI), n.future || {}) : w;
    if (C === null)
      throw new Error(jr("The `searchClient` option is required."));
    if (typeof C.search != "function")
      throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
    if (typeof C.addAlgoliaAgent == "function" && C.addAlgoliaAgent("instantsearch.js (".concat(RW, ")")), process.env.NODE_ENV === "development" && qe(E === null, "`insightsClient` property has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), E && typeof E != "function")
      throw new Error(jr("The `insightsClient` option should be a function."));
    if (process.env.NODE_ENV === "development" && qe(!n.searchParameters, "The `searchParameters` option is deprecated and will not be supported in InstantSearch.js 4.x.\n\nYou can replace it with the `configure` widget:\n\n```\nsearch.addWidgets([\n  configure(".concat(JSON.stringify(n.searchParameters, null, 2), `)
]);
\`\`\`

See `).concat(Yo({
      name: "configure"
    }))), process.env.NODE_ENV === "development" && ((i = n.future) === null || i === void 0 ? void 0 : i.preserveSharedStateOnUnmount) === void 0 && console.info(`Starting from the next major version, InstantSearch will change how widgets state is preserved when they are removed. InstantSearch will keep the state of unmounted widgets to be usable by other widgets with the same attribute.

We recommend setting \`future.preserveSharedStateOnUnmount\` to true to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to false.

See documentation: `.concat(Yo({
      name: "instantsearch"
    }), `#widget-param-future
          `)), a.client = C, a.future = P, a.insightsClient = E, a.indexName = o, a.compositionID = c, a.helper = null, a.mainHelper = null, a.mainIndex = Cj({
      // we use an index widget to render compositions
      // this only works because there's only one composition index allow for now
      indexName: a.compositionID || a.indexName
    }), a.onStateChange = y, a.started = !1, a.templatesConfig = {
      helpers: DW({
        numberLocale: u
      }),
      compileOptions: {}
    }, a._stalledSearchDelay = S, a._searchStalledTimer = null, a._createURL = WW, a._initialUiState = g, a._initialResults = null, a._insights = v, b && (process.env.NODE_ENV === "development" && qe(!1, "The `searchFunction` option is deprecated. Use `onStateChange` instead."), a._searchFunction = b), a.sendEventToInsights = Tt, d) {
      var _ = typeof d == "boolean" ? {} : d;
      _.$$internal = !0, a.use(TW(_));
    }
    if (v) {
      var D = typeof v == "boolean" ? {} : v;
      D.$$internal = !0, a.use(jy(D));
    }
    return sW() && a.use(oW({
      $$internal: !0
    })), a;
  }
  return xW(r, [{
    key: "_isSearchStalled",
    get: (
      /**
       * @deprecated use `status === 'stalled'` instead
       */
      function() {
        return process.env.NODE_ENV === "development" && qe(!1, '`InstantSearch._isSearchStalled` is deprecated and will be removed in InstantSearch.js 5.0.\n\nUse `InstantSearch.status === "stalled"` instead.'), this.status === "stalled";
      }
    )
  }, {
    key: "use",
    value: function() {
      for (var i = this, a = arguments.length, s = new Array(a), o = 0; o < a; o++)
        s[o] = arguments[o];
      var c = s.map(function(u) {
        var f = Md({
          $$type: "__unknown__",
          $$internal: !1,
          subscribe: Tt,
          started: Tt,
          unsubscribe: Tt,
          onStateChange: Tt
        }, u({
          instantSearchInstance: i
        }));
        return i.middleware.push({
          creator: u,
          instance: f
        }), f;
      });
      return this.started && c.forEach(function(u) {
        u.subscribe(), u.started();
      }), this;
    }
    /**
     * Removes a middleware from the InstantSearch lifecycle.
     */
  }, {
    key: "unuse",
    value: function() {
      for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
        a[s] = arguments[s];
      return this.middleware.filter(function(o) {
        return a.includes(o.creator);
      }).forEach(function(o) {
        return o.instance.unsubscribe();
      }), this.middleware = this.middleware.filter(function(o) {
        return !a.includes(o.creator);
      }), this;
    }
    // @major we shipped with EXPERIMENTAL_use, but have changed that to just `use` now
  }, {
    key: "EXPERIMENTAL_use",
    value: function() {
      return process.env.NODE_ENV === "development" && qe(!1, "The middleware API is now considered stable, so we recommend replacing `EXPERIMENTAL_use` with `use` before upgrading to the next major version."), this.use.apply(this, arguments);
    }
    /**
     * Adds a widget to the search instance.
     * A widget can be added either before or after InstantSearch has started.
     * @param widget The widget to add to InstantSearch.
     *
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`.
     */
  }, {
    key: "addWidget",
    value: function(i) {
      return process.env.NODE_ENV === "development" && qe(!1, "addWidget will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`"), this.addWidgets([i]);
    }
    /**
     * Adds multiple widgets to the search instance.
     * Widgets can be added either before or after InstantSearch has started.
     * @param widgets The array of widgets to add to InstantSearch.
     */
  }, {
    key: "addWidgets",
    value: function(i) {
      if (!Array.isArray(i))
        throw new Error(jr("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
      if (i.some(function(a) {
        return typeof a.init != "function" && typeof a.render != "function";
      }))
        throw new Error(jr("The widget definition expects a `render` and/or an `init` method."));
      if (this.compositionID && i.some(tr))
        throw new Error(jr("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
      return this.mainIndex.addWidgets(i), this;
    }
    /**
     * Removes a widget from the search instance.
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`
     * @param widget The widget instance to remove from InstantSearch.
     *
     * The widget must implement a `dispose()` method to clear its state.
     */
  }, {
    key: "removeWidget",
    value: function(i) {
      return process.env.NODE_ENV === "development" && qe(!1, "removeWidget will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`"), this.removeWidgets([i]);
    }
    /**
     * Removes multiple widgets from the search instance.
     * @param widgets Array of widgets instances to remove from InstantSearch.
     *
     * The widgets must implement a `dispose()` method to clear their states.
     */
  }, {
    key: "removeWidgets",
    value: function(i) {
      if (!Array.isArray(i))
        throw new Error(jr("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
      if (i.some(function(a) {
        return typeof a.dispose != "function";
      }))
        throw new Error(jr("The widget definition expects a `dispose` method."));
      return this.mainIndex.removeWidgets(i), this;
    }
    /**
     * Ends the initialization of InstantSearch.js and triggers the
     * first search.
     */
  }, {
    key: "start",
    value: function() {
      var i = this;
      if (this.started)
        throw new Error(jr("The `start` method has already been called once."));
      var a = this.mainHelper || Gt(this.client, this.indexName, void 0, {
        persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
      });
      if (this.compositionID && (a.searchForFacetValues = a.searchForCompositionFacetValues.bind(a)), a.search = function() {
        return i.status = "loading", i.scheduleRender(!1), process.env.NODE_ENV === "development" && qe(!!i.indexName || !!i.compositionID || i.mainIndex.getWidgets().some(tr), "No indexName provided, nor an explicit index widget in the widgets tree. This is required to be able to display results."), i._hasSearchWidget && (i.compositionID ? a.searchWithComposition() : a.searchOnlyWithDerivedHelpers()), i._hasRecommendWidget && a.recommend(), a;
      }, this._searchFunction) {
        var s = {
          search: function() {
            return new Promise(Tt);
          }
        };
        this._mainHelperSearch = a.search.bind(a), a.search = function() {
          var c = i.mainIndex.getHelper(), u = Gt(s, c.state.index, c.state);
          return u.once("search", function(f) {
            var g = f.state;
            c.overrideStateWithoutTriggeringChangeEvent(g), i._mainHelperSearch();
          }), u.on("change", function(f) {
            var g = f.state;
            c.setState(g);
          }), i._searchFunction(u), a;
        };
      }
      if (a.on("error", function(c) {
        var u = c.error;
        if (!(u instanceof Error)) {
          var f = u;
          u = Object.keys(f).reduce(function(g, p) {
            return g[p] = f[p], g;
          }, new Error(f.message));
        }
        u.error = u, i.error = u, i.status = "error", i.scheduleRender(!1), i.emit("error", u);
      }), this.mainHelper = a, this.middleware.forEach(function(c) {
        var u = c.instance;
        u.subscribe();
      }), this.mainIndex.init({
        instantSearchInstance: this,
        parent: null,
        uiState: this._initialUiState
      }), this._initialResults) {
        hL(this.client, this._initialResults), aL(this.mainHelper, this._initialResults);
        var o = this.scheduleSearch;
        this.scheduleSearch = Sa(Tt), Sa(function() {
          i.scheduleSearch = o;
        })();
      } else this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
      this.helper = this.mainIndex.getHelper(), this.started = !0, this.middleware.forEach(function(c) {
        var u = c.instance;
        u.started();
      }), typeof this._insights > "u" && a.derivedHelpers[0].once("result", function() {
        var c = i.mainIndex.getScopedResults().some(function(u) {
          var f = u.results;
          return f?._automaticInsights;
        });
        c && i.use(jy({
          $$internal: !0,
          $$automatic: !0
        }));
      });
    }
    /**
     * Removes all widgets without triggering a search afterwards.
     * @return {undefined} This method does not return anything
     */
  }, {
    key: "dispose",
    value: function() {
      var i;
      this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), (i = this.mainHelper) === null || i === void 0 || i.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function(a) {
        var s = a.instance;
        s.unsubscribe();
      });
    }
  }, {
    key: "scheduleStalledRender",
    value: function() {
      var i = this;
      this._searchStalledTimer || (this._searchStalledTimer = setTimeout(function() {
        i.status = "stalled", i.scheduleRender();
      }, this._stalledSearchDelay));
    }
    /**
     * Set the UI state and trigger a search.
     * @param uiState The next UI state or a function computing it from the current state
     * @param callOnStateChange private parameter used to know if the method is called from a state change
     */
  }, {
    key: "setUiState",
    value: function(i) {
      var a = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!this.mainHelper)
        throw new Error(jr("The `start` method needs to be called before `setUiState`."));
      this.mainIndex.refreshUiState();
      var o = typeof i == "function" ? i(this.mainIndex.getWidgetUiState({})) : i;
      this.onStateChange && s ? this.onStateChange({
        uiState: o,
        setUiState: function(u) {
          Df(typeof u == "function" ? u(o) : u, a.mainIndex), a.scheduleSearch(), a.onInternalStateChange();
        }
      }) : (Df(o, this.mainIndex), this.scheduleSearch(), this.onInternalStateChange());
    }
  }, {
    key: "getUiState",
    value: function() {
      return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({});
    }
  }, {
    key: "createURL",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!this.started)
        throw new Error(jr("The `start` method needs to be called before `createURL`."));
      return this._createURL(i);
    }
  }, {
    key: "refresh",
    value: function() {
      if (!this.mainHelper)
        throw new Error(jr("The `start` method needs to be called before `refresh`."));
      this.mainHelper.clearCache().search();
    }
  }]), r;
}(Rj);
function gs(e) {
  "@babel/helpers - typeof";
  return gs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gs(e);
}
function eb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eb(Object(r), !0).forEach(function(n) {
      VW(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function VW(e, t, r) {
  return t = HW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function HW(e) {
  var t = qW(e, "string");
  return gs(t) == "symbol" ? t : String(t);
}
function qW(e, t) {
  if (gs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (gs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rb = ["react (".concat(h0, ")"), "react-instantsearch (".concat(_f, ")"), "react-instantsearch-core (".concat(_f, ")")], nb = "react-instantsearch-server (".concat(_f, ")"), zW = function(t) {
  return t ? "next.js (".concat(t, ")") : null;
};
function BW(e) {
  var t = Nj(), r = AI(), n = FI(), i = MI(), a = n?.initialResults, s = we(e), o = r || a || i, c = we(null);
  if (n && (c = n.ssrSearchRef), c.current === null) {
    var u = new UW(e);
    u._schedule = function(b) {
      u._schedule.queue.push(b), clearTimeout(u._schedule.timer), u._schedule.timer = setTimeout(function() {
        u._schedule.queue.forEach(function(m) {
          m();
        }), u._schedule.queue = [];
      }, 0);
    }, u._schedule.queue = [], o && (u._initialResults = a || {}), ib(e.searchClient, [].concat(rb, [r && nb, zW(ZW())])), o && u.start(), r && r.notifyServer({
      search: u
    }), GW(e.routing), QW(!!i), c.current = u;
  }
  {
    var f = c.current, g = s.current;
    if (g.indexName !== e.indexName && (f.helper.setIndex(e.indexName || "").search(), s.current = e), g.searchClient !== e.searchClient && (process.env.NODE_ENV === "development" && Zh(!1, "The `searchClient` prop of `<InstantSearch>` changed between renders, which may cause more search requests than necessary. If this is an unwanted behavior, please provide a stable reference: https://www.algolia.com/doc/api-reference/widgets/instantsearch/react/#widget-param-searchclient"), ib(e.searchClient, [].concat(rb, [r && nb])), f.mainHelper.setClient(e.searchClient).search(), s.current = e), g.onStateChange !== e.onStateChange && (f.onStateChange = e.onStateChange, s.current = e), g.searchFunction !== e.searchFunction && (f._searchFunction = e.searchFunction, s.current = e), g.stalledSearchDelay !== e.stalledSearchDelay) {
      var p;
      f._stalledSearchDelay = (p = e.stalledSearchDelay) !== null && p !== void 0 ? p : 200, s.current = e;
    }
    Bi(g.future, e.future) || (f.future = tb(tb({}, KI), e.future), s.current = e);
  }
  var d = we(null), h = oh.useSyncExternalStore($(function() {
    var v = c.current;
    return d.current === null ? v.started || (v.start(), t()) : (clearTimeout(d.current), v._preventWidgetCleanup = !1), function() {
      function b() {
        v.dispose();
      }
      clearTimeout(v._schedule.timer), d.current = setTimeout(b), v._preventWidgetCleanup = !0;
    };
  }, [t]), function() {
    return c.current;
  }, function() {
    return c.current;
  });
  return h;
}
function ib(e, t) {
  typeof e.addAlgoliaAgent == "function" && t.filter(Boolean).forEach(function(r) {
    e.addAlgoliaAgent(r);
  });
}
function GW(e) {
  if (process.env.NODE_ENV === "development") {
    var t;
    if (!e || typeof window > "u" || !("__NEXT_DATA__" in window))
      return;
    var r = (
      // @ts-expect-error: _isNextRouter is only set on the Next.js router
      e !== !0 && (e == null || (t = e.router) === null || t === void 0 ? void 0 : t._isNextRouter)
    );
    process.env.NODE_ENV === "development" && Zh(r, `
You are using Next.js with InstantSearch without the "react-instantsearch-router-nextjs" package.
This package is recommended to make the routing work correctly with Next.js.
Please check its usage instructions: https://github.com/algolia/instantsearch/tree/master/packages/react-instantsearch-router-nextjs

You can ignore this warning if you are using a custom router that suits your needs, it won't be outputted in production builds.`);
  }
}
function QW(e) {
  var t;
  process.env.NODE_ENV !== "development" || typeof window > "u" || e || process.env.NODE_ENV === "development" && Zh(!(!((t = window.next) === null || t === void 0) && t.appDir), `
We've detected you are using Next.js with the App Router.
We released an **experimental** package called "react-instantsearch-nextjs" that makes SSR work with the App Router.
Please check its usage instructions: https://www.algolia.com/doc/guides/building-search-ui/going-further/server-side-rendering/react/#with-nextjs

This warning will not be outputted in production builds.`);
}
function ZW() {
  var e, t;
  return typeof window < "u" && ((e = window.next) === null || e === void 0 ? void 0 : e.version) || (typeof process < "u" ? (t = process.env) === null || t === void 0 ? void 0 : t.NEXT_RUNTIME : void 0);
}
var YW = ["children"];
function KW(e, t) {
  if (e == null) return {};
  var r = JW(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function JW(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function XW(e) {
  var t = e.children, r = KW(e, YW), n = BW(r);
  return n.started ? /* @__PURE__ */ _t.createElement(Qh.Provider, {
    value: n
  }, /* @__PURE__ */ _t.createElement(Bh.Provider, {
    value: n.mainIndex
  }, t)) : null;
}
function vs(e) {
  "@babel/helpers - typeof";
  return vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vs(e);
}
function eU(e) {
  return iU(e) || nU(e) || rU(e) || tU();
}
function tU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rU(e, t) {
  if (e) {
    if (typeof e == "string") return jf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return jf(e, t);
  }
}
function nU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function iU(e) {
  if (Array.isArray(e)) return jf(e);
}
function jf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ab(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Si(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ab(Object(r), !0).forEach(function(n) {
      aU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ab(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aU(e, t, r) {
  return t = sU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sU(e) {
  var t = oU(e, "string");
  return vs(t) == "symbol" ? t : String(t);
}
function oU(e, t) {
  if (vs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sb = In({
  name: "clear-refinements",
  connector: !0
}), lU = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  return ra(t, sb()), function(n) {
    var i = n || {}, a = i.includedAttributes, s = a === void 0 ? [] : a, o = i.excludedAttributes, c = o === void 0 ? ["query"] : o, u = i.transformItems, f = u === void 0 ? function(h) {
      return h;
    } : u;
    if (n && n.includedAttributes && n.excludedAttributes)
      throw new Error(sb("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var g = {
      refine: Tt,
      createURL: function() {
        return "";
      },
      attributesToClear: []
    }, p = function() {
      return g.refine();
    }, d = function() {
      return g.createURL();
    };
    return {
      $$type: "ais.clearRefinements",
      init: function(v) {
        var b = v.instantSearchInstance;
        t(Si(Si({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: b
        }), !0);
      },
      render: function(v) {
        var b = v.instantSearchInstance;
        t(Si(Si({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: b
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(v, b) {
        return Si(Si({}, v), {}, {
          clearRefinements: this.getWidgetRenderState(b)
        });
      },
      getWidgetRenderState: function(v) {
        var b = v.createURL, m = v.scopedResults, S = v.results;
        g.attributesToClear = m.reduce(function(C, T) {
          return C.concat(cU({
            scopedResult: T,
            includedAttributes: s,
            excludedAttributes: c,
            transformItems: f,
            results: S
          }));
        }, []), g.refine = function() {
          g.attributesToClear.forEach(function(C) {
            var T = C.helper, E = C.items;
            T.setState(ty({
              helper: T,
              attributesToClear: E
            })).search();
          });
        }, g.createURL = function() {
          return b(Ua.apply(void 0, eU(g.attributesToClear.map(function(C) {
            var T = C.helper, E = C.items;
            return ty({
              helper: T,
              attributesToClear: E
            });
          }))));
        };
        var I = g.attributesToClear.some(function(C) {
          return C.items.length > 0;
        });
        return {
          canRefine: I,
          hasRefinements: I,
          refine: p,
          createURL: d,
          widgetParams: n
        };
      }
    };
  };
};
function cU(e) {
  var t = e.scopedResult, r = e.includedAttributes, n = e.excludedAttributes, i = e.transformItems, a = e.results, s = r.indexOf("query") !== -1 || n.indexOf("query") === -1;
  return {
    helper: t.helper,
    items: i(OI(GM(t.results, t.helper.state, s).map(function(o) {
      return o.attribute;
    }).filter(function(o) {
      return (
        // If the array is empty (default case), we keep all the attributes
        r.length === 0 || // Otherwise, only add the specified attributes
        r.indexOf(o) !== -1
      );
    }).filter(function(o) {
      return (
        // If the query is included, we ignore the default `excludedAttributes = ['query']`
        o === "query" && s || // Otherwise, ignore the excluded attributes
        n.indexOf(o) === -1
      );
    })), {
      results: a
    })
  };
}
function uU(e, t) {
  return ri(lU, e, t);
}
function ys(e) {
  "@babel/helpers - typeof";
  return ys = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ys(e);
}
var dU = ["page"], fU = ["clickAnalytics", "userToken"];
function ob(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ob(Object(r), !0).forEach(function(n) {
      JI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ob(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function JI(e, t, r) {
  return t = hU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function hU(e) {
  var t = mU(e, "string");
  return ys(t) == "symbol" ? t : String(t);
}
function mU(e, t) {
  if (ys(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ys(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lb(e) {
  return yU(e) || vU(e) || gU(e) || pU();
}
function pU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gU(e, t) {
  if (e) {
    if (typeof e == "string") return Wf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Wf(e, t);
  }
}
function vU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function yU(e) {
  if (Array.isArray(e)) return Wf(e);
}
function Wf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function XI(e, t) {
  if (e == null) return {};
  var r = bU(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function bU(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var SU = In({
  name: "infinite-hits",
  connector: !0
});
function cb(e) {
  var t = e || {};
  t.page;
  var r = XI(t, dU);
  return r;
}
function bo(e) {
  var t = e || {};
  t.clickAnalytics, t.userToken;
  var r = XI(t, fU);
  return r;
}
function wU() {
  var e = null, t = null;
  return {
    read: function(n) {
      var i = n.state;
      return zh(t, cb(i)) ? e : null;
    },
    write: function(n) {
      var i = n.state, a = n.hits;
      t = cb(i), e = a;
    }
  };
}
function IU(e) {
  return Object.keys(e).map(Number).sort(function(t, r) {
    return t - r;
  }).reduce(function(t, r) {
    return t.concat(e[r]);
  }, []);
}
const CU = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  return ra(t, SU()), function(n) {
    var i = n || {}, a = i.escapeHTML, s = a === void 0 ? !0 : a, o = i.transformItems, c = o === void 0 ? function(I) {
      return I;
    } : o, u = i.cache, f = u === void 0 ? wU() : u, g, p, d, h, v = function(C, T) {
      var E = C.page, N = E === void 0 ? 0 : E, y = Object.keys(T).map(Number);
      return y.length === 0 ? N : Math.min.apply(Math, [N].concat(lb(y)));
    }, b = function(C, T) {
      var E = C.page, N = E === void 0 ? 0 : E, y = Object.keys(T).map(Number);
      return y.length === 0 ? N : Math.max.apply(Math, [N].concat(lb(y)));
    }, m = function(C) {
      return function() {
        C.overrideStateWithoutTriggeringChangeEvent(Tr(Tr({}, C.state), {}, {
          page: v(C.state, f.read({
            state: bo(C.state)
          }) || {}) - 1
        })).searchWithoutTriggeringOnStateChange();
      };
    }, S = function(C) {
      return function() {
        C.setPage(b(C.state, f.read({
          state: bo(C.state)
        }) || {}) + 1).search();
      };
    };
    return {
      $$type: "ais.infiniteHits",
      init: function(C) {
        t(Tr(Tr({}, this.getWidgetRenderState(C)), {}, {
          instantSearchInstance: C.instantSearchInstance
        }), !0);
      },
      render: function(C) {
        var T = C.instantSearchInstance, E = this.getWidgetRenderState(C);
        t(Tr(Tr({}, E), {}, {
          instantSearchInstance: T
        }), !1), d("view:internal", E.currentPageHits);
      },
      getRenderState: function(C, T) {
        return Tr(Tr({}, C), {}, {
          infiniteHits: this.getWidgetRenderState(T)
        });
      },
      getWidgetRenderState: function(C) {
        var T, E, N, y = C.results, w = C.helper, P = C.parent, _ = C.state, D = C.instantSearchInstance, R, x = [], F = P.getPreviousState() || _, W = f.read({
          state: bo(F)
        }) || {}, A = y == null || (T = y.renderingContent) === null || T === void 0 || (E = T.widgets) === null || E === void 0 || (N = E.banners) === null || N === void 0 ? void 0 : N[0];
        if (!y)
          g = m(w), p = S(w), d = jM({
            instantSearchInstance: D,
            helper: w,
            widgetType: this.$$type
          }), h = WM({
            helper: w,
            widgetType: this.$$type,
            instantSearchInstance: D
          }), R = F.page === void 0 || v(F, W) === 0;
        else {
          var M, j, B = F.page, L = B === void 0 ? 0 : B;
          s && y.hits.length > 0 && (y.hits = yM(y.hits));
          var H = KM(y.hits, y.page, y.hitsPerPage), q = tL(H, y.queryID), te = c(q, {
            results: y
          }), G = !1;
          EI(D.mainIndex, function(ue) {
            !G && ue.getWidgets().some(function(de) {
              var Q = de.$$type;
              return Q === "ais.dynamicWidgets";
            }) && (G = !0);
          });
          var X = !((M = F.disjunctiveFacets) !== null && M !== void 0 && M.length) && !(F.facets || []).filter(function(ue) {
            return ue !== "*";
          }).length && !((j = F.hierarchicalFacets) !== null && j !== void 0 && j.length);
          W[L] === void 0 && !y.__isArtificial && D.status === "idle" && !(G && X) && (W[L] = te, f.write({
            state: bo(F),
            hits: W
          })), x = te, R = v(F, W) === 0;
        }
        var re = IU(W), oe = y ? y.nbPages <= b(F, W) + 1 : !0;
        return {
          hits: re,
          items: re,
          currentPageHits: x,
          sendEvent: d,
          bindEvent: h,
          banner: A,
          results: y || void 0,
          showPrevious: g,
          showMore: p,
          isFirstPage: R,
          isLastPage: oe,
          widgetParams: n
        };
      },
      dispose: function(C) {
        var T = C.state;
        r();
        var E = T.setQueryParameter("page", void 0);
        return s ? E.setQueryParameters(Object.keys(Hi).reduce(function(N, y) {
          return Tr(Tr({}, N), {}, JI({}, y, void 0));
        }, {})) : E;
      },
      getWidgetUiState: function(C, T) {
        var E = T.searchParameters, N = E.page || 0;
        return N ? Tr(Tr({}, C), {}, {
          // The page in the UI state is incremented by one
          // to expose the user value (not `0`).
          page: N + 1
        }) : C;
      },
      getWidgetSearchParameters: function(C, T) {
        var E = T.uiState, N = C;
        s && (N = C.setQueryParameters(Hi));
        var y = E.page ? E.page - 1 : 0;
        return N.setQueryParameter("page", y);
      }
    };
  };
};
function PU(e, t) {
  return ri(CU, e, t);
}
var TU = ["name", "escapedValue", "path"];
function bs(e) {
  "@babel/helpers - typeof";
  return bs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bs(e);
}
function _U(e, t) {
  if (e == null) return {};
  var r = EU(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function EU(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function ub(e, t) {
  return RU(e) || DU(e, t) || NU(e, t) || OU();
}
function OU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NU(e, t) {
  if (e) {
    if (typeof e == "string") return db(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return db(e, t);
  }
}
function db(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function DU(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function RU(e) {
  if (Array.isArray(e)) return e;
}
function fb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fb(Object(r), !0).forEach(function(n) {
      Ao(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ao(e, t, r) {
  return t = kU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kU(e) {
  var t = AU(e, "string");
  return bs(t) == "symbol" ? t : String(t);
}
function AU(e, t) {
  if (bs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (bs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ld = In({
  name: "menu",
  connector: !0
}), hb = ["isRefined", "name:asc"], xU = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  return ra(t, Ld()), function(n) {
    var i = n || {}, a = i.attribute, s = i.limit, o = s === void 0 ? 10 : s, c = i.showMore, u = c === void 0 ? !1 : c, f = i.showMoreLimit, g = f === void 0 ? 20 : f, p = i.sortBy, d = p === void 0 ? hb : p, h = i.transformItems, v = h === void 0 ? function(y) {
      return y;
    } : h;
    if (!a)
      throw new Error(Ld("The `attribute` option is required."));
    if (u === !0 && g <= o)
      throw new Error(Ld("The `showMoreLimit` option must be greater than `limit`."));
    var b, m, S, I = !1, C = function() {
    };
    function T(y, w) {
      return function() {
        I = !I, w.render(y);
      };
    }
    function E() {
      C();
    }
    function N() {
      return I ? g : o;
    }
    return {
      $$type: "ais.menu",
      init: function(w) {
        var P = w.instantSearchInstance;
        t(Bt(Bt({}, this.getWidgetRenderState(w)), {}, {
          instantSearchInstance: P
        }), !0);
      },
      render: function(w) {
        var P = w.instantSearchInstance;
        t(Bt(Bt({}, this.getWidgetRenderState(w)), {}, {
          instantSearchInstance: P
        }), !1);
      },
      dispose: function(w) {
        var P = w.state;
        return r(), P.removeHierarchicalFacet(a).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(w, P) {
        return Bt(Bt({}, w), {}, {
          menu: Bt(Bt({}, w.menu), {}, Ao({}, a, this.getWidgetRenderState(P)))
        });
      },
      getWidgetRenderState: function(w) {
        var P = this, _ = w.results, D = w.createURL, R = w.instantSearchInstance, x = w.helper, F = [], W = !1;
        if (b || (b = CI({
          instantSearchInstance: R,
          helper: x,
          attribute: a,
          widgetType: this.$$type
        })), m || (m = function(B) {
          return D(function(L) {
            return P.getWidgetUiState(L, {
              searchParameters: x.state.resetPage().toggleFacetRefinement(a, B),
              helper: x
            });
          });
        }), S || (S = function(B) {
          var L = x.getHierarchicalFacetBreadcrumb(a), H = ub(L, 1), q = H[0];
          b("click:internal", B || q), x.toggleFacetRefinement(a, B || q).search();
        }), w.results && (C = T(w, this)), _) {
          var A = _.getFacetValues(a, {
            sortBy: d,
            facetOrdering: d === hb
          }), M = A && !Array.isArray(A) && A.data ? A.data : [];
          W = u && (I || M.length > N()), F = v(M.slice(0, N()).map(function(j) {
            var B = j.name, L = j.escapedValue;
            j.path;
            var H = _U(j, TU);
            return Bt(Bt({}, H), {}, {
              label: B,
              value: L
            });
          }), {
            results: _
          });
        }
        return {
          items: F,
          createURL: m,
          refine: S,
          sendEvent: b,
          canRefine: F.length > 0,
          widgetParams: n,
          isShowingMore: I,
          toggleShowMore: E,
          canToggleShowMore: W
        };
      },
      getWidgetUiState: function(w, P) {
        var _ = P.searchParameters, D = _.getHierarchicalFacetBreadcrumb(a), R = ub(D, 1), x = R[0];
        return FU(Bt(Bt({}, w), {}, {
          menu: Bt(Bt({}, w.menu), {}, Ao({}, a, x))
        }), a);
      },
      getWidgetSearchParameters: function(w, P) {
        var _ = P.uiState, D = _.menu && _.menu[a];
        if (w.isConjunctiveFacet(a) || w.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && qe(!1, 'Menu: Attribute "'.concat(a, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this Menu widget will not work at all.`)), w;
        var R = w.removeHierarchicalFacet(a).addHierarchicalFacet({
          name: a,
          attributes: [a]
        }), x = R.maxValuesPerFacet || 0, F = Math.max(x, u ? g : o), W = R.setQueryParameter("maxValuesPerFacet", F);
        return D ? W.addHierarchicalFacetRefinement(a, D) : W.setQueryParameters({
          hierarchicalFacetsRefinements: Bt(Bt({}, W.hierarchicalFacetsRefinements), {}, Ao({}, a, []))
        });
      }
    };
  };
};
function FU(e, t) {
  return e.menu && (e.menu[t] === void 0 && delete e.menu[t], Object.keys(e.menu).length === 0 && delete e.menu), e;
}
function $U(e, t) {
  return ri(xU, e, t);
}
function Ss(e) {
  "@babel/helpers - typeof";
  return Ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ss(e);
}
var MU = ["name", "escapedValue"], LU = ["escapedValue", "value"];
function mb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mb(Object(r), !0).forEach(function(n) {
      $a(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $a(e, t, r) {
  return t = jU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jU(e) {
  var t = WU(e, "string");
  return Ss(t) == "symbol" ? t : String(t);
}
function WU(e, t) {
  if (Ss(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ss(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pb(e, t) {
  if (e == null) return {};
  var r = UU(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function UU(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var So = In({
  name: "refinement-list",
  connector: !0
}), gb = ["isRefined", "count:desc", "name:asc"], VU = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  return ra(t, So()), function(n) {
    var i = n || {}, a = i.attribute, s = i.operator, o = s === void 0 ? "or" : s, c = i.limit, u = c === void 0 ? 10 : c, f = i.showMore, g = f === void 0 ? !1 : f, p = i.showMoreLimit, d = p === void 0 ? 20 : p, h = i.sortBy, v = h === void 0 ? gb : h, b = i.escapeFacetValues, m = b === void 0 ? !0 : b, S = i.transformItems, I = S === void 0 ? function(A) {
      return A;
    } : S;
    if (!a)
      throw new Error(So("The `attribute` option is required."));
    if (!/^(and|or)$/.test(o))
      throw new Error(So('The `operator` must one of: `"and"`, `"or"` (got "'.concat(o, '").')));
    if (g === !0 && d <= u)
      throw new Error(So("`showMoreLimit` should be greater than `limit`."));
    var C = function(M) {
      var j = M.name, B = M.escapedValue, L = pb(M, MU);
      return lt(lt({}, L), {}, {
        value: B,
        label: j,
        highlighted: j
      });
    }, T, E = [], N = !0, y, w, P = !1, _ = function() {
    };
    function D() {
      _();
    }
    function R(A, M) {
      return function() {
        P = !P, M.render(A);
      };
    }
    function x() {
      return P ? d : u;
    }
    var F = function() {
      return function() {
      };
    }, W = function(M, j) {
      return function(B) {
        return function(L) {
          var H = B.instantSearchInstance, q = B.results;
          if (L === "" && E)
            t(lt(lt({}, j.getWidgetRenderState(lt(lt({}, B), {}, {
              results: T
            }))), {}, {
              instantSearchInstance: H
            }), !1);
          else {
            var te = {
              highlightPreTag: m ? Hi.highlightPreTag : Yt.highlightPreTag,
              highlightPostTag: m ? Hi.highlightPostTag : Yt.highlightPostTag
            };
            M.searchForFacetValues(
              a,
              L,
              // We cap the `maxFacetHits` value to 100 because the Algolia API
              // doesn't support a greater number.
              // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
              Math.min(x(), 100),
              te
            ).then(function(G) {
              var X = m ? bM(G.facetHits) : G.facetHits, re = I(X.map(function(oe) {
                var ue = oe.escapedValue, de = oe.value, Q = pb(oe, LU);
                return lt(lt({}, Q), {}, {
                  value: ue,
                  label: de
                });
              }), {
                results: q
              });
              t(lt(lt({}, j.getWidgetRenderState(lt(lt({}, B), {}, {
                results: T
              }))), {}, {
                items: re,
                canToggleShowMore: !1,
                canRefine: !0,
                isFromSearch: !0,
                instantSearchInstance: H
              }), !1);
            });
          }
        };
      };
    };
    return {
      $$type: "ais.refinementList",
      init: function(M) {
        t(lt(lt({}, this.getWidgetRenderState(M)), {}, {
          instantSearchInstance: M.instantSearchInstance
        }), !0);
      },
      render: function(M) {
        t(lt(lt({}, this.getWidgetRenderState(M)), {}, {
          instantSearchInstance: M.instantSearchInstance
        }), !1);
      },
      getRenderState: function(M, j) {
        return lt(lt({}, M), {}, {
          refinementList: lt(lt({}, M.refinementList), {}, $a({}, a, this.getWidgetRenderState(j)))
        });
      },
      getWidgetRenderState: function(M) {
        var j = this, B = M.results, L = M.state, H = M.createURL, q = M.instantSearchInstance, te = M.helper, G = [], X = [];
        if ((!w || !y || !F) && (w = CI({
          instantSearchInstance: q,
          helper: te,
          attribute: a,
          widgetType: this.$$type
        }), y = function(pe) {
          w("click:internal", pe), te.toggleFacetRefinement(a, pe).search();
        }, F = W(te, this)), B) {
          var re = B.getFacetValues(a, {
            sortBy: v,
            facetOrdering: v === gb
          });
          X = re && Array.isArray(re) ? re : [], G = I(X.slice(0, x()).map(C), {
            results: B
          });
          var oe = L.maxValuesPerFacet, ue = x();
          N = oe > ue ? X.length <= ue : X.length < ue, T = B, E = G, M.results && (_ = R(M, this));
        }
        var de = F && F(M), Q = P && E.length > u, he = g && !N, ce = Q || he;
        return {
          createURL: function(pe) {
            return H(function(k) {
              return j.getWidgetUiState(k, {
                searchParameters: L.resetPage().toggleFacetRefinement(a, pe),
                helper: te
              });
            });
          },
          items: G,
          refine: y,
          searchForItems: de,
          isFromSearch: !1,
          canRefine: G.length > 0,
          widgetParams: n,
          isShowingMore: P,
          canToggleShowMore: ce,
          toggleShowMore: D,
          sendEvent: w,
          hasExhaustiveItems: N
        };
      },
      dispose: function(M) {
        var j = M.state;
        r();
        var B = j.setQueryParameter("maxValuesPerFacet", void 0);
        return o === "and" ? B.removeFacet(a) : B.removeDisjunctiveFacet(a);
      },
      getWidgetUiState: function(M, j) {
        var B = j.searchParameters, L = o === "or" ? B.getDisjunctiveRefinements(a) : B.getConjunctiveRefinements(a);
        return HU(lt(lt({}, M), {}, {
          refinementList: lt(lt({}, M.refinementList), {}, $a({}, a, L))
        }), a);
      },
      getWidgetSearchParameters: function(M, j) {
        var B = j.uiState, L = o === "or";
        if (M.isHierarchicalFacet(a))
          return process.env.NODE_ENV === "development" && qe(!1, 'RefinementList: Attribute "'.concat(a, `" is already used by another widget applying hierarchical faceting.
As this is not supported, please make sure to remove this other widget or this RefinementList widget will not work at all.`)), M;
        if (L && M.isConjunctiveFacet(a) || !L && M.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && qe(!1, 'RefinementList: Attribute "'.concat(a, `" is used by another refinement list with a different operator.
As this is not supported, please make sure to only use this attribute with one of the two operators.`)), M;
        var H = B.refinementList && B.refinementList[a], q = L ? M.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a) : M.addFacet(a).removeFacetRefinement(a), te = q.maxValuesPerFacet || 0, G = Math.max(te, g ? d : u), X = q.setQueryParameter("maxValuesPerFacet", G);
        if (!H) {
          var re = L ? "disjunctiveFacetsRefinements" : "facetsRefinements";
          return X.setQueryParameters($a({}, re, lt(lt({}, X[re]), {}, $a({}, a, []))));
        }
        return H.reduce(function(oe, ue) {
          return L ? oe.addDisjunctiveFacetRefinement(a, ue) : oe.addFacetRefinement(a, ue);
        }, X);
      }
    };
  };
};
function HU(e, t) {
  return e.refinementList && ((!e.refinementList[t] || e.refinementList[t].length === 0) && delete e.refinementList[t], Object.keys(e.refinementList).length === 0 && delete e.refinementList), e;
}
function e0(e, t) {
  return ri(VU, e, t);
}
function ws(e) {
  "@babel/helpers - typeof";
  return ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ws(e);
}
function vb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function En(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vb(Object(r), !0).forEach(function(n) {
      qU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qU(e, t, r) {
  return t = zU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zU(e) {
  var t = BU(e, "string");
  return ws(t) == "symbol" ? t : String(t);
}
function BU(e, t) {
  if (ws(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ws(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var GU = In({
  name: "search-box",
  connector: !0
}), QU = function(t, r) {
  return r(t);
}, ZU = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  return ra(t, GU()), function(n) {
    var i = n || {}, a = i.queryHook, s = a === void 0 ? QU : a, o, c;
    return {
      $$type: "ais.searchBox",
      init: function(f) {
        var g = f.instantSearchInstance;
        t(En(En({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !0);
      },
      render: function(f) {
        var g = f.instantSearchInstance;
        t(En(En({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !1);
      },
      dispose: function(f) {
        var g = f.state;
        return r(), g.setQueryParameter("query", void 0);
      },
      getRenderState: function(f, g) {
        return En(En({}, f), {}, {
          searchBox: this.getWidgetRenderState(g)
        });
      },
      getWidgetRenderState: function(f) {
        var g = f.helper, p = f.instantSearchInstance, d = f.state;
        return o || (o = function(v) {
          s(v, function(b) {
            return g.setQuery(b).search();
          });
        }, c = function() {
          g.setQuery("").search();
        }), {
          query: d.query || "",
          refine: o,
          clear: c,
          widgetParams: n,
          isSearchStalled: p.status === "stalled"
        };
      },
      getWidgetUiState: function(f, g) {
        var p = g.searchParameters, d = p.query || "";
        return d === "" || f && f.query === d ? f : En(En({}, f), {}, {
          query: d
        });
      },
      getWidgetSearchParameters: function(f, g) {
        var p = g.uiState;
        return f.setQueryParameter("query", p.query || "");
      }
    };
  };
};
function YU(e, t) {
  return ri(ZU, e, t);
}
function Is(e) {
  "@babel/helpers - typeof";
  return Is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Is(e);
}
function yb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function On(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yb(Object(r), !0).forEach(function(n) {
      KU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function KU(e, t, r) {
  return t = JU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JU(e) {
  var t = XU(e, "string");
  return Is(t) == "symbol" ? t : String(t);
}
function XU(e, t) {
  if (Is(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Is(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bb = In({
  name: "sort-by",
  connector: !0
}), eV = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tt;
  ra(t, bb());
  var n = {};
  return function(i) {
    var a = i || {}, s = a.items, o = a.transformItems, c = o === void 0 ? function(u) {
      return u;
    } : o;
    if (!Array.isArray(s))
      throw new Error(bb("The `items` option expects an array of objects."));
    return {
      $$type: "ais.sortBy",
      init: function(f) {
        var g = f.instantSearchInstance, p = this.getWidgetRenderState(f), d = p.currentRefinement, h = Xa(s, function(v) {
          return v.value === d;
        });
        process.env.NODE_ENV === "development" && qe(h !== void 0, 'The index named "'.concat(d, '" is not listed in the `items` of `sortBy`.')), t(On(On({}, p), {}, {
          instantSearchInstance: g
        }), !0);
      },
      render: function(f) {
        var g = f.instantSearchInstance;
        t(On(On({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !1);
      },
      dispose: function(f) {
        var g = f.state;
        return r(), n.initialIndex ? g.setIndex(n.initialIndex) : g;
      },
      getRenderState: function(f, g) {
        return On(On({}, f), {}, {
          sortBy: this.getWidgetRenderState(g)
        });
      },
      getWidgetRenderState: function(f) {
        var g = f.results, p = f.helper, d = f.state, h = f.parent;
        !n.initialIndex && h && (n.initialIndex = h.getIndexName()), n.setIndex || (n.setIndex = function(b) {
          p.setIndex(b).search();
        });
        var v = g ? g.nbHits === 0 : !0;
        return {
          currentRefinement: d.index,
          options: c(s, {
            results: g
          }),
          refine: n.setIndex,
          hasNoResults: v,
          canRefine: !v && s.length > 0,
          widgetParams: i
        };
      },
      getWidgetUiState: function(f, g) {
        var p = g.searchParameters, d = p.index;
        return On(On({}, f), {}, {
          sortBy: d !== n.initialIndex ? d : void 0
        });
      },
      getWidgetSearchParameters: function(f, g) {
        var p = g.uiState;
        return f.setQueryParameter("index", p.sortBy || n.initialIndex || f.index);
      }
    };
  };
};
function tV(e, t) {
  return ri(eV, e, t);
}
function rV(e, t) {
  return sV(e) || aV(e, t) || iV(e, t) || nV();
}
function nV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iV(e, t) {
  if (e) {
    if (typeof e == "string") return Sb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Sb(e, t);
  }
}
function Sb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function aV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function sV(e) {
  if (Array.isArray(e)) return e;
}
function oV() {
  var e = Ws(), t = Gh(), r = Z(function() {
    var s = kf(t);
    return {
      results: s.results,
      scopedResults: s.scopedResults
    };
  }), n = rV(r, 2), i = n[0], a = n[1];
  return Pe(function() {
    function s() {
      var o = t.getResults();
      if (o !== null)
        a({
          results: o,
          scopedResults: t.getScopedResults()
        });
      else if (e.mainIndex.getIndexName().length === 0) {
        var c = e.mainIndex.getWidgets().find(tr);
        c && a({
          results: kf(t).results,
          scopedResults: c.getScopedResults()
        });
      }
    }
    return e.addListener("render", s), function() {
      e.removeListener("render", s);
    };
  }, [e, t]), i;
}
function wb(e, t) {
  return dV(e) || uV(e, t) || cV(e, t) || lV();
}
function lV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cV(e, t) {
  if (e) {
    if (typeof e == "string") return Ib(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ib(e, t);
  }
}
function Ib(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function uV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, s, o = [], c = !0, u = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(c = (n = a.call(r)).done) && (o.push(n.value), o.length !== t); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return o;
  }
}
function dV(e) {
  if (Array.isArray(e)) return e;
}
function fV() {
  var e = Ws(), t = Gh(), r = t.getIndexId(), n = Z(function() {
    return e.getUiState();
  }), i = wb(n, 2), a = i[0], s = i[1], o = a[r], c = Z(function() {
    return e.renderState;
  }), u = wb(c, 2), f = u[0], g = u[1], p = f[r] || {}, d = $(function(v) {
    e.setUiState(v);
  }, [e]), h = $(function(v) {
    t.setIndexUiState(v);
  }, [t]);
  return Pe(function() {
    function v() {
      s(e.getUiState()), g(e.renderState);
    }
    return e.addListener("render", v), function() {
      e.removeListener("render", v);
    };
  }, [e]), {
    uiState: a,
    setUiState: d,
    indexUiState: o,
    setIndexUiState: h,
    renderState: f,
    indexRenderState: p
  };
}
function Us() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.catchError, r = Ws(), n = fV(), i = n.uiState, a = n.setUiState, s = n.indexUiState, o = n.setIndexUiState, c = n.renderState, u = n.indexRenderState, f = oV(), g = f.results, p = f.scopedResults, d = $(function() {
    for (var v = arguments.length, b = new Array(v), m = 0; m < v; m++)
      b[m] = arguments[m];
    return r.use.apply(r, b), function() {
      r.unuse.apply(r, b);
    };
  }, [r]), h = $(function() {
    r.refresh();
  }, [r]);
  return $I(function() {
    if (t) {
      var v = function() {
      };
      return r.addListener("error", v), function() {
        return r.removeListener("error", v);
      };
    }
    return function() {
    };
  }, [r, t]), {
    results: g,
    scopedResults: p,
    uiState: i,
    setUiState: a,
    indexUiState: s,
    setIndexUiState: o,
    renderState: c,
    indexRenderState: u,
    addMiddlewares: d,
    refresh: h,
    status: r.status,
    error: r.error
  };
}
function Uf() {
  return Uf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uf.apply(null, arguments);
}
function hV(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function mV(e, t) {
  if (e == null) return {};
  var r, n, i = hV(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Ma() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.reduce(function(n, i) {
    return Array.isArray(i) ? n.concat(i) : n.concat([i]);
  }, []).filter(Boolean).join(" ");
}
var pV = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
function gV(e) {
  var t = e.createElement;
  return function(n) {
    var i = n.classNames, a = n.children, s = n.highlightedTagName, o = n.isHighlighted, c = n.nonHighlightedTagName, u = o ? s : c;
    return t(u, {
      className: o ? i.highlighted : i.nonHighlighted
    }, a);
  };
}
function vV(e) {
  var t = e.createElement, r = e.Fragment, n = gV({
    createElement: t
  });
  return function(a) {
    var s = a.parts, o = a.highlightedTagName, c = o === void 0 ? "mark" : o, u = a.nonHighlightedTagName, f = u === void 0 ? "span" : u, g = a.separator, p = g === void 0 ? ", " : g, d = a.className, h = a.classNames, v = h === void 0 ? {} : h, b = mV(a, pV);
    return t("span", Uf({}, b, {
      className: Ma(v.root, d)
    }), s.map(function(m, S) {
      var I = S === s.length - 1;
      return t(r, {
        key: S
      }, m.map(function(C, T) {
        return t(n, {
          key: T,
          classNames: v,
          highlightedTagName: c,
          nonHighlightedTagName: f,
          isHighlighted: C.isHighlighted
        }, C.value);
      }), !I && t("span", {
        className: v.separator
      }, p));
    }));
  };
}
var yV = vV({
  createElement: Wb,
  Fragment: Ha
}), bV = ["classNames"];
function Vf() {
  return Vf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vf.apply(this, arguments);
}
function SV(e, t) {
  if (e == null) return {};
  var r = wV(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function wV(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function IV(e) {
  var t = e.classNames, r = t === void 0 ? {} : t, n = SV(e, bV);
  return /* @__PURE__ */ _t.createElement(yV, Vf({
    classNames: {
      root: Ma("ais-Highlight", r.root),
      highlighted: Ma("ais-Highlight-highlighted", r.highlighted),
      nonHighlighted: Ma("ais-Highlight-nonHighlighted", r.nonHighlighted),
      separator: Ma("ais-Highlight-separator", r.separator)
    }
  }, n));
}
var CV = ["hit", "attribute", "highlightedTagName", "nonHighlightedTagName", "separator"];
function Hf() {
  return Hf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hf.apply(this, arguments);
}
function PV(e, t) {
  if (e == null) return {};
  var r = TV(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function TV(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function Cb(e) {
  var t = e.hit, r = e.attribute, n = e.highlightedTagName, i = e.nonHighlightedTagName, a = e.separator, s = PV(e, CV), o = js(t._highlightResult, r) || [], c = Array.isArray(o) ? o : [o], u = c.map(function(f) {
    return qh(yI(f.value || ""));
  });
  return /* @__PURE__ */ _t.createElement(IV, Hf({}, s, {
    parts: u,
    highlightedTagName: n,
    nonHighlightedTagName: i,
    separator: a
  }));
}
const Dl = (e) => {
  const t = e ? `${process.env.VITE_API_ROOT}/plans/${e}` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(
    t,
    Ze
  );
  return {
    plan: r?.data,
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
}, _V = "hyperdashboard-SearchBox-module-feMLga-hidden", EV = "hyperdashboard-SearchBox-module-feMLga-resetButton", OV = "hyperdashboard-SearchBox-module-feMLga-textInput", NV = "hyperdashboard-SearchBox-module-feMLga-wrapper", wo = {
  hidden: _V,
  resetButton: EV,
  textInput: OV,
  wrapper: NV
}, DV = () => {
  const { status: e } = Us(), { query: t, refine: r } = YU(), n = e === "stalled", { register: i, handleSubmit: a, watch: s, reset: o } = Lt({
    defaultValues: { search: t },
    mode: "onChange"
  }), c = $(
    (f) => {
      r(f.search);
    },
    [r]
  );
  Pe(() => {
    const f = s(() => a(c)());
    return () => f.unsubscribe();
  }, [c, a, s]);
  const u = $(() => {
    o({ search: "" });
  }, [o]);
  return Pe(() => {
    (!t || t.length === 0) && o({ search: "" });
  }, [t, o]), /* @__PURE__ */ O("form", { onSubmit: a(c), className: wo.wrapper, children: [
    /* @__PURE__ */ l(
      nn,
      {
        placeholder: "Search by country or network name...",
        id: "query",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "none",
        spellCheck: "false",
        iconStart: /* @__PURE__ */ l(ye, { name: "Search", size: "medium" }),
        type: "search",
        className: wo.textInput,
        ...i("search")
      }
    ),
    /* @__PURE__ */ l(
      Y,
      {
        "aria-label": "Reset",
        type: "button",
        onClick: u,
        className: wt(wo.resetButton, (!t || n) && wo.hidden),
        iconStart: /* @__PURE__ */ l(ye, { name: "Close", size: "medium" })
      }
    )
  ] });
}, tt = (e) => {
  if (e || e === 0)
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 4
    }).format(e);
}, na = (e) => {
  const t = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/rates?orgId=${e}` : null, { data: r, error: n, isLoading: i, isValidating: a, mutate: s } = je(t, Ze);
  return {
    billingRates: V(() => r ?? {}, [r]),
    error: n,
    isLoading: i,
    isValidating: a,
    mutate: s
  };
}, Kr = "networks-v2", RV = "networks-v2_name_asc", kV = "networks-v2_country_uniq", AV = "networks-v2_rate_asc", Cs = "UKV1ENAXDY", Kh = "037e3268ecd8a9d239dbf22280879ad3", Jo = ["NR", "LTE", "CAT-M1", "NB-IOT", "WCDMA", "CDMA", "GSM"];
function t0(e) {
  return e.sort((t, r) => Jo.indexOf(t) - Jo.indexOf(r));
}
const Ti = {
  GSM: "2G",
  CDMA: "2G/3G",
  WCDMA: "3G",
  LTE: "4G LTE",
  NR: "5G",
  "CAT-M1": { short: "LTE-M", long: "LTE-M/Cat-M1" },
  "NB-IOT": "NB-IoT"
};
function Ps(e, t) {
  const r = Ti[e];
  return typeof r == "string" ? r : typeof r == "object" ? t && r[t] ? r[t] : r.short : "";
}
function xV(e) {
  return Ps(e, "short").replaceAll(/[^0-9A-z]/g, "");
}
function FV(e) {
  return Object.keys(Ti).find(
    (t) => Ti[t] === e || typeof Ti[t] == "object" && (Ti[t].short.replaceAll(/[^0-9A-z]/g, "") === e || Ti[t].long.replaceAll(/[^0-9A-z]/g, "") === e)
  ) || "";
}
function $V(e, t) {
  return t ? e.find((r) => r.offerId === parseFloat(t))?.simProfileId : null;
}
function MV(e, t) {
  return e ? t.find((r) => r.simProfileId === parseFloat(e))?.offerId?.toString() ?? null : null;
}
const LV = (e) => ({
  router: QI({ cleanUrlOnDispose: !0 }),
  stateMapping: {
    stateToRoute: (t) => {
      const r = t[Kr];
      return {
        search: r.query,
        rats: r.refinementList?.supported_rat ? r.refinementList.supported_rat.map((n) => xV(n)).join("|") : void 0,
        profile: r.menu?.offer_id ? $V(e, r.menu?.offer_id) : void 0
      };
    },
    routeToState: (t) => {
      const r = {
        [Kr]: {
          query: t.search
        }
      };
      return t.rats && (r[Kr].refinementList = {}, r[Kr].refinementList.supported_rat = t.rats.split("|").map((n) => FV(n))), t.profile && (r[Kr].menu = {}, r[Kr].menu.offer_id = MV(t.profile, e) ?? ""), r;
    }
  }
});
function r0(e, t, r) {
  const n = { rateMin: 0, rateMax: 0, isFlatRate: !0 };
  if (!e && !r)
    return n;
  if (e.rateType === "flat_rate") {
    const s = Math.max(0, r ?? 0);
    return {
      rateMin: s,
      rateMax: s,
      isFlatRate: !0
    };
  }
  const a = t?.dataRates.map((s) => {
    const o = e.data?.find((c) => c?.unc === s.objectID);
    return !o && !s.data_rate ? null : o ? s.data_rate ? Math.min(o.costPerMb ?? 1 / 0, s.data_rate) : o.costPerMb : s.data_rate;
  })?.filter((s) => s !== null).sort((s, o) => s - o);
  return a ? {
    rateMin: a[0],
    rateMax: a[a.length - 1],
    // Considered flat rate if min equals max
    isFlatRate: a[0] === a[a.length - 1]
  } : n;
}
const jV = "hyperdashboard-Hits-module-UUnJMG-bodyCell", WV = "hyperdashboard-Hits-module-UUnJMG-countryColumn", UV = "hyperdashboard-Hits-module-UUnJMG-diminished", VV = "hyperdashboard-Hits-module-UUnJMG-footerCount", HV = "hyperdashboard-Hits-module-UUnJMG-header", qV = "hyperdashboard-Hits-module-UUnJMG-headerCell", zV = "hyperdashboard-Hits-module-UUnJMG-highlight", BV = "hyperdashboard-Hits-module-UUnJMG-modalCountryColumn", GV = "hyperdashboard-Hits-module-UUnJMG-networkName", QV = "hyperdashboard-Hits-module-UUnJMG-numericColumn", ZV = "hyperdashboard-Hits-module-UUnJMG-ratList", YV = "hyperdashboard-Hits-module-UUnJMG-row", KV = "hyperdashboard-Hits-module-UUnJMG-sorted", JV = "hyperdashboard-Hits-module-UUnJMG-sortIcon", XV = "hyperdashboard-Hits-module-UUnJMG-superAdminRate", eH = "hyperdashboard-Hits-module-UUnJMG-tableFooter", tH = "hyperdashboard-Hits-module-UUnJMG-tableWrapper", Ot = {
  bodyCell: jV,
  countryColumn: WV,
  diminished: UV,
  footerCount: VV,
  header: HV,
  headerCell: qV,
  highlight: zV,
  modalCountryColumn: BV,
  networkName: GV,
  numericColumn: QV,
  ratList: ZV,
  row: YV,
  sorted: KV,
  sortIcon: JV,
  superAdminRate: XV,
  tableFooter: eH,
  tableWrapper: tH
}, ia = ({
  simProfiles: e,
  planProfiles: t
}) => V(() => e && e.length > 0 ? e.map((n) => ({
  profileName: n.profileName ?? "",
  installationState: n.installationState ?? null,
  offerId: n.offerId ?? 0
})) : t && t.length > 0 ? t.map((n) => ({
  profileName: n.name,
  installationState: null,
  offerId: n.offerId
})) : null, [e, t]), rH = (e) => {
  const {
    lastKnownNetwork: t,
    excludeColumns: r,
    columns: n,
    simProfiles: i,
    planProfiles: a,
    orgId: s,
    variant: o,
    hologramSimId: c,
    legacyPlan: u
  } = e, { items: f, results: g, isLastPage: p, showMore: d } = PU(), { status: h } = Us(), v = we(null), {
    billingRates: b,
    error: m,
    isLoading: S
  } = na(s), {
    simBilling: I,
    error: C,
    isLoading: T
  } = Ir(c), { isSuperAdmin: E } = Be(), N = $(
    (A, M) => {
      if (S || T)
        return /* @__PURE__ */ l(Kw, { noTranslate: !0 });
      if (m || C)
        return /* @__PURE__ */ l("span", { className: Ot.diminished, children: "—" });
      if (b) {
        if (b.rateType === "flat_rate")
          return tt(u ? u.overageCharge : I.dataRate ?? I.overageCharge);
        const j = b.data?.find((B) => B.unc === A);
        if (j)
          return /* @__PURE__ */ O(le, { children: [
            E && /* @__PURE__ */ l("span", { className: Ot.superAdminRate, children: "• " }),
            tt(j.costPerMb)
          ] });
      }
      return tt(M);
    },
    [
      b,
      m,
      S,
      T,
      E,
      I.dataRate,
      I.overageCharge,
      C,
      u
    ]
  );
  Pe(() => {
    if (v.current !== null) {
      const A = new IntersectionObserver(
        (M) => {
          M.forEach((j) => {
            j.isIntersecting && !p && h === "idle" && d();
          });
        },
        {
          rootMargin: "200px 0px"
        }
      );
      return A.observe(v.current), () => A.disconnect();
    }
  }, [d, p, h]);
  const y = [
    // we don't actually use the labels, but the types require it
    { label: "Most relevant", value: Kr },
    { label: "Country (asc)", value: "networks-v2_country_asc" },
    { label: "Country (desc)", value: "networks-v2_country_desc" },
    { label: "Network (asc)", value: "networks-v2_name_asc" },
    { label: "Network (desc)", value: "networks-v2_name_desc" }
  ], { refine: w } = tV({ items: y }), [P, _] = Z({ attribute: "network", direction: "asc" }), D = (A) => !P.direction || A !== P.attribute ? _({ attribute: A, direction: "asc" }) : P.direction === "asc" ? _({ attribute: A, direction: "desc" }) : _({ attribute: "network", direction: "asc" });
  Pe(() => {
    if (P.attribute === "relevant") return w(Kr);
    switch (P.attribute) {
      case "network":
        return w(`networks-v2_name_${P.direction}`);
      case "country":
      default:
        return w(`networks-v2_country_${P.direction}`);
    }
  }, [P, w]);
  const R = (A) => P.attribute === A ? P.direction === "asc" ? "ArrowTriangleNorth" : "ArrowTriangleSouth" : "ArrowTriangleNorthSouth", x = ia({ simProfiles: i, planProfiles: a }), F = n.filter((A) => r?.indexOf(A.key) ?? !0), W = V(() => {
    const A = [];
    return f.forEach((M) => {
      const {
        objectID: j,
        data_rate: B,
        code: L,
        offer_id: H,
        country: q,
        supported_rat: te
      } = M;
      A.push({
        key: j,
        className: Ot.row,
        cells: F.map((G) => {
          let X, re = null;
          switch (G.key) {
            case "name":
              X = /* @__PURE__ */ O("span", { className: Ot.networkName, children: [
                /* @__PURE__ */ l(
                  Cb,
                  {
                    attribute: "name",
                    hit: M,
                    classNames: { highlighted: Ot.highlight }
                  }
                ),
                j === t && /* @__PURE__ */ O(le, { children: [
                  " ",
                  /* @__PURE__ */ l(
                    et,
                    {
                      id: "last-seen-popover",
                      content: "This is the network this SIM last connected to.",
                      children: /* @__PURE__ */ l(en, { iconStart: "CellTower", title: "Last seen", colorVariant: "teal", children: "Last seen" })
                    }
                  )
                ] })
              ] });
              break;
            case "profile":
              X = x ? x?.find((oe) => H.includes(oe.offerId))?.profileName : "—";
              break;
            case "rate":
              X = N(L, B), re = Ot.numericColumn;
              break;
            case "country":
              X = /* @__PURE__ */ l(
                Cb,
                {
                  attribute: "country",
                  hit: M,
                  classNames: { highlighted: Ot.highlight },
                  title: q
                }
              ), re = J(
                Ot.countryColumn,
                o === "modal" && Ot.modalCountryColumn
              );
              break;
            case "rats":
              X = /* @__PURE__ */ l("div", { className: Ot.ratList, children: t0(te).map((oe) => /* @__PURE__ */ l(en, { size: "small", children: Ps(oe) }, oe)) });
              break;
          }
          return {
            key: G.key,
            children: X,
            className: J(re, Ot.bodyCell)
          };
        })
      });
    }), A;
  }, [f, F, t, N, x, o]);
  return /* @__PURE__ */ l(
    ei,
    {
      wrapperClassName: Ot.tableWrapper,
      theadClassName: Ot.header,
      headers: F.map((A) => {
        let M = A.label;
        return A.sortableAttribute && (M = /* @__PURE__ */ O(
          "button",
          {
            type: "button",
            onClick: () => D(A.sortableAttribute),
            className: J(P.attribute === A.sortableAttribute && Ot.sorted),
            children: [
              A.label,
              " ",
              /* @__PURE__ */ l(
                ye,
                {
                  size: "small",
                  name: R(A.sortableAttribute),
                  className: Ot.sortIcon,
                  color: "currentColor"
                }
              )
            ]
          }
        )), {
          key: A.key,
          children: M,
          className: J(Ot.headerCell, A.key === "rate" && Ot.numericColumn),
          width: A.width
        };
      }),
      rows: W,
      footer: /* @__PURE__ */ l("tr", { children: /* @__PURE__ */ l("td", { colSpan: n.length, ref: v, className: Ot.tableFooter, children: /* @__PURE__ */ O("span", { className: Ot.footerCount, children: [
        g?.nbHits,
        " total ",
        g?.nbHits === 1 ? "network" : "networks",
        (h === "loading" || h === "stalled") && /* @__PURE__ */ l(le, { children: " Loading…" })
      ] }) }) })
    }
  );
}, nH = "hyperdashboard-CoverageSearch-module-S-XIfW-filters", iH = "hyperdashboard-CoverageSearch-module-S-XIfW-loader", aH = "hyperdashboard-CoverageSearch-module-S-XIfW-modal", sH = "hyperdashboard-CoverageSearch-module-S-XIfW-searchControls", oH = "hyperdashboard-CoverageSearch-module-S-XIfW-searchWrapper", lH = "hyperdashboard-CoverageSearch-module-S-XIfW-wrapper", wi = {
  filters: nH,
  loader: iH,
  modal: aH,
  searchControls: sH,
  searchWrapper: oH,
  wrapper: lH
}, cH = "hyperdashboard-Results-module-sv4DLa-total", uH = "hyperdashboard-Results-module-sv4DLa-wrapper", Pb = {
  total: cH,
  wrapper: uH
}, dH = (e) => {
  const { results: t, status: r } = Us(), { totalResults: n } = e, i = r === "stalled";
  return /* @__PURE__ */ l("div", { className: Pb.wrapper, children: /* @__PURE__ */ O("span", { className: Pb.total, children: [
    i && /* @__PURE__ */ l(le, { children: "Searching…" }),
    !i && `Showing ${t.nbHits}${n ? ` of ${n}` : ""} networks`
  ] }) });
}, fH = "hyperdashboard-Filters-module-0nDkDq-title", hH = "hyperdashboard-Filters-module-0nDkDq-titleWrapper", Tb = {
  title: fH,
  titleWrapper: hH
}, mH = "hyperdashboard-ProfileFilter-module-sWjgLG-diminishedText", Xo = {
  diminishedText: mH
}, ni = ({ simProfiles: e, planProfiles: t }) => {
  const r = e && e.length > 0 ? e : t;
  return r ? `(${r.flatMap((a) => a.offerId).map((a) => `offer_id=${a}`).join(" OR ")})` : "";
}, pH = async (e) => {
  if (!e) return { networks: 0, countries: 0, dataRates: [] };
  const t = `https://${Cs}.algolia.net/1/indexes`, r = {
    "X-Algolia-Application-Id": Cs,
    "X-Algolia-API-Key": Kh,
    "Content-Type": "application/json"
  }, n = "POST", [i, a, s] = await Promise.all([
    // one API call to get total number of networks matching this filter
    fetch(`${t}/${Kr}/query`, {
      method: n,
      headers: r,
      body: JSON.stringify({ filters: e, hitsPerPage: 1 })
    }),
    // second API call to get distinct number of countries
    fetch(`${t}/${kV}/query`, {
      method: n,
      headers: r,
      body: JSON.stringify({ filters: e, hitsPerPage: 0 })
    }),
    // third API call to get all data rates in ascending order
    fetch(`${t}/${AV}/query`, {
      method: n,
      headers: r,
      body: JSON.stringify({
        filters: e,
        hitsPerPage: 1e3,
        distinct: 1,
        attributesToRetrieve: ["data_rate"],
        attributesToHighlight: []
      })
    })
  ]);
  if (!i.ok || !a.ok)
    throw new Error("Error fetching search metadata");
  const o = await i.json(), c = await a.json(), u = await s.json();
  return {
    networks: o.nbHits,
    countries: c.nbHits,
    dataRates: u.hits
  };
}, Rl = (e) => {
  const { data: t, error: r, isLoading: n } = je(e, pH);
  return {
    isLoading: n,
    error: r,
    data: t
  };
}, gH = (e) => {
  const { simProfiles: t } = e, { refine: r, items: n } = $U({
    attribute: "offer_id",
    limit: 100
  }), { indexUiState: i, setIndexUiState: a } = Us(), s = i.menu?.offer_id ?? null, o = ni({ simProfiles: t }), { data: c } = Rl(o), { sendAnalyticsEvent: u } = mt(), { register: f, handleSubmit: g, watch: p, setValue: d } = Lt({
    defaultValues: { profile: s ?? "all" },
    mode: "onChange"
  }), h = ia({ simProfiles: t }), v = $(
    (m) => {
      const { profile: S } = m;
      return S === "all" ? (u && u("Network Coverage - Filter - All profiles"), a((I) => {
        const { menu: C, ...T } = I;
        return T;
      })) : (u && u("Network Coverage - Filter - Single Profile"), r(S));
    },
    [r, a, u]
  );
  if (Pe(() => {
    const m = p(() => {
      g(v)();
    });
    return () => m.unsubscribe();
  }, [v, g, p]), Pe(() => {
    s === null && d("profile", "all");
  }, [s, d]), !h || h.length <= 1) return null;
  const b = [];
  return b.push({
    label: "This SIM",
    value: "all",
    labelNode: /* @__PURE__ */ O("span", { children: [
      "This SIM  ",
      /* @__PURE__ */ O("span", { className: Xo.diminishedText, children: [
        "(",
        c && `${c.networks}, `,
        "all profiles)"
      ] })
    ] })
  }), h.map(
    (m) => b.push({
      label: m.profileName,
      value: m.offerId.toString(),
      labelNode: /* @__PURE__ */ O("span", { children: [
        m.profileName,
        "  ",
        /* @__PURE__ */ O("span", { className: Xo.diminishedText, children: [
          "(",
          n.find((S) => S.value === m.offerId.toString())?.count ?? 0,
          m.installationState === "ENABLED" && ", active",
          ")"
        ] })
      ] })
    })
  ), /* @__PURE__ */ l(Ts, { label: "Coverage by profile", options: b, ...f("profile") });
}, vH = (e) => {
  const { planProfiles: t } = e, { refine: r, items: n } = e0({
    attribute: "offer_id",
    limit: 100
  }), { sendAnalyticsEvent: i } = mt(), { register: a } = Lt(), s = ia({ planProfiles: t }), o = V(() => {
    const c = [];
    return s?.map((u) => {
      const f = n.find((g) => g.value === u.offerId.toString());
      return c.push({
        label: u.profileName ?? "Unknown",
        value: u.offerId.toString(),
        labelNode: /* @__PURE__ */ O("span", { children: [
          u.profileName ?? /* @__PURE__ */ l("span", { className: Xo.diminishedText, children: "Unknown" }),
          "  ",
          /* @__PURE__ */ O("span", { className: Xo.diminishedText, children: [
            "(",
            f?.count ?? 0,
            u.installationState === "ENABLED" && ", active",
            ")"
          ] })
        ] }),
        defaultChecked: f?.isRefined ?? !1
      });
    }), c;
  }, [s, n]);
  return !s || s.length <= 1 ? null : /* @__PURE__ */ l(
    qa,
    {
      label: "Coverage by profile",
      options: o,
      ...a("profile"),
      onChange: ({ target: c }) => {
        r(c.value), i && c.checked && i("Network Coverage - Filter - Single Profile", {
          profile: c.value
        });
      }
    }
  );
}, yH = (e) => {
  const { simProfiles: t, planProfiles: r } = e;
  return t && t.length > 0 ? /* @__PURE__ */ l(gH, { simProfiles: t }) : r && r.length > 0 ? /* @__PURE__ */ l(vH, { planProfiles: r }) : null;
}, bH = "hyperdashboard-RefinementList-module-k-ZFxW-countryListControl", SH = "hyperdashboard-RefinementList-module-k-ZFxW-diminishedText", wH = "hyperdashboard-RefinementList-module-k-ZFxW-highlightedText", IH = "hyperdashboard-RefinementList-module-k-ZFxW-noMatches", _i = {
  countryListControl: bH,
  diminishedText: SH,
  highlightedText: wH,
  noMatches: IH
}, CH = (e) => {
  const { input: t, query: r } = e;
  if (!r)
    return t;
  const n = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), i = new RegExp(`(${n})`, "gi"), a = t.split(i);
  return /* @__PURE__ */ l(le, { children: a.map(
    (s, o) => i.test(s) ? (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ l("span", { className: _i.highlightedText, children: s }, o)
    ) : s
  ) });
}, _b = (e) => {
  const { attribute: t } = e, r = V(
    () => t === "country" ? (u, f) => {
      const g = ["United States", "Canada"];
      if (u.isRefined !== f.isRefined)
        return u.isRefined ? -1 : 1;
      const p = g.includes(u.name), d = g.includes(f.name);
      return p && d ? g.indexOf(u.name) - g.indexOf(f.name) : p ? -1 : d ? 1 : u.name.localeCompare(f.name);
    } : void 0,
    [t]
  ), { items: n, refine: i, searchForItems: a } = e0({ ...e, sortBy: r }), [s, o] = Z(""), { sendAnalyticsEvent: c } = mt();
  switch (t) {
    case "supported_rat": {
      const u = n.sort(
        (f, g) => Jo.indexOf(f.value) - Jo.indexOf(g.value)
      );
      return /* @__PURE__ */ l(
        qa,
        {
          label: "RATs",
          name: "rat-filter",
          options: u.map((f) => ({
            label: `${Ps(f.label)} (${f.count})`,
            labelNode: /* @__PURE__ */ O("span", { children: [
              Ps(f.label, "long"),
              "  ",
              /* @__PURE__ */ O("span", { className: _i.diminishedText, children: [
                "(",
                f.count,
                ")"
              ] })
            ] }),
            value: f.value,
            defaultChecked: f.isRefined
          })),
          onChange: ({ target: f }) => {
            i(f.value), c && f.checked && c("Network Coverage - Filter - RAT", {
              rat: f.value
            });
          }
        }
      );
    }
    case "country":
      return /* @__PURE__ */ O("div", { className: _i.countryListControl, children: [
        /* @__PURE__ */ l(D0, { children: "Country" }),
        /* @__PURE__ */ l(
          nn,
          {
            id: "country-search",
            type: "search",
            autocomplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: !1,
            placeholder: "Filter countries",
            iconStart: /* @__PURE__ */ l(ye, { name: "Search", size: "medium" }),
            inputProps: {
              onChange: ({ currentTarget: u }) => {
                a(u.value), o(u.value);
              }
            }
          }
        ),
        n.length > 0 ? /* @__PURE__ */ l(
          qa,
          {
            label: "Country",
            hiddenLabel: !0,
            name: "country-filter",
            options: n.map((u) => ({
              label: `${u.label} (${u.count})`,
              labelNode: /* @__PURE__ */ O("span", { children: [
                /* @__PURE__ */ l(CH, { input: u.label, query: s }),
                "  ",
                /* @__PURE__ */ O("span", { className: _i.diminishedText, children: [
                  "(",
                  u.count,
                  ")"
                ] })
              ] }),
              value: u.value,
              defaultChecked: u.isRefined,
              id: u.value
            })),
            onChange: ({ target: u }) => {
              i(u.value), c && u.checked && c("Network Coverage - Filter - Country", {
                country: u.value
              });
            }
          }
        ) : /* @__PURE__ */ l("span", { className: wt(_i.noMatches, _i.diminishedText), children: "No matches" })
      ] });
    default:
      return null;
  }
}, PH = ({ simProfiles: e, planProfiles: t }) => {
  const { canRefine: r } = uU(), { indexUiState: n, setIndexUiState: i } = Us();
  return /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ O("div", { className: Tb.titleWrapper, children: [
      /* @__PURE__ */ l("span", { className: Tb.title, children: "Filters" }),
      (r || n.query) && /* @__PURE__ */ l(
        Y,
        {
          noPadding: !0,
          variant: "tertiary",
          onClick: () => (
            // Reset all filters except sorting
            i((a) => ({ sortBy: a.sortBy }))
          ),
          children: "Reset"
        }
      )
    ] }),
    /* @__PURE__ */ l(yH, { simProfiles: e, planProfiles: t }),
    /* @__PURE__ */ l(_b, { attribute: "supported_rat", sortBy: ["name"] }),
    /* @__PURE__ */ l(_b, { attribute: "country" })
  ] });
}, TH = A$(Cs, Kh), Jh = (e) => {
  const {
    excludeColumns: t,
    lastKnownNetwork: r,
    hologramSimId: n,
    legacyPlan: i,
    variant: a = "default"
  } = e, {
    simBilling: s,
    error: o,
    isLoading: c
  } = Ir(n), {
    simProfiles: u,
    error: f,
    isLoading: g
  } = kr(n), { plan: p, error: d, isLoading: h } = Dl(i?.id), v = Ne();
  let b;
  if (i) {
    const y = i.currentTier ?? "BASE";
    b = Object.keys(
      i.tiers?.[y].zones[i.zone].carriers ?? {}
    ).map((P) => p?.profiles.find((_) => _.carrierId === Number(P))).filter((P) => P !== void 0);
  }
  const m = ni({ simProfiles: u, planProfiles: b }), { data: S, error: I, isLoading: C } = Rl(m), T = c || g || C || h, E = o || f || I || d, N = [
    { key: "name", label: "Network", sortableAttribute: "network" },
    { key: "profile", label: "Profile", width: 125 },
    { key: "rate", label: "Rate per MB", width: 100 },
    {
      key: "country",
      label: "Country",
      sortableAttribute: "country",
      width: a === "modal" ? 130 : 150
    },
    {
      key: "rats",
      label: a === "modal" ? "RAT" : "Radio Access Technologies (RAT)",
      width: a === "modal" ? 180 : 220
    }
  ];
  return !i && !n ? /* @__PURE__ */ l(fe, { variant: "error", label: "No Plan or SIM specified", children: "We cannot retrieve network coverage information" }) : T ? /* @__PURE__ */ l(ur, { className: wi.loader, children: "Loading network coverage" }) : E ? /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading the network coverage details",
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : n && !s.planId ? /* @__PURE__ */ l(fe, { variant: "error", label: "Cannot retrieve network coverage info", children: "The SIM is inactive or does have a data plan" }) : /* @__PURE__ */ O(
    XW,
    {
      searchClient: TH,
      indexName: Kr,
      future: { preserveSharedStateOnUnmount: !0 },
      routing: a === "default" ? LV(u) : void 0,
      children: [
        /* @__PURE__ */ l(
          hj,
          {
            filters: m || void 0,
            optionalFilters: r ? [`code:${r}`] : void 0
          }
        ),
        /* @__PURE__ */ O("div", { className: wt(wi.wrapper, a === "modal" && wi.modal), children: [
          /* @__PURE__ */ l("div", { className: wi.filters, children: /* @__PURE__ */ l(PH, { simProfiles: u, planProfiles: b }) }),
          /* @__PURE__ */ O("div", { className: wi.searchWrapper, children: [
            /* @__PURE__ */ O("div", { className: wi.searchControls, children: [
              /* @__PURE__ */ l(DV, {}),
              /* @__PURE__ */ l(dH, { totalResults: S?.networks })
            ] }),
            /* @__PURE__ */ l(
              rH,
              {
                columns: N,
                lastKnownNetwork: r,
                excludeColumns: t,
                simProfiles: u,
                planProfiles: b,
                orgId: n ? s.organizationId : v,
                variant: a,
                hologramSimId: n,
                legacyPlan: i
              }
            )
          ] })
        ] })
      ]
    }
  );
}, _H = (e) => {
  if (!e) return null;
  const t = e.split("-");
  if (t.length !== 6) return null;
  const [r, n, i, a, s, o] = t;
  return {
    profile: r,
    region: n,
    country: i,
    tadig: a,
    mcc: s,
    mnc: o
  };
};
async function Xh({
  filters: e,
  profiles: t,
  legacyPlan: r,
  hologramSimId: n,
  billingRates: i,
  simBilling: a,
  onSuccess: s,
  onError: o
}) {
  try {
    const c = `https://${Cs}.algolia.net/1/indexes/${RV}/query`, u = {
      "X-Algolia-Application-Id": Cs,
      "X-Algolia-API-Key": Kh,
      "Content-Type": "application/json"
    }, f = { filters: e, hitsPerPage: 1e3, distinct: !1 };
    let g = [], p = 0, d = 1;
    do {
      const S = { ...f, page: p }, I = await fetch(c, {
        method: "POST",
        headers: u,
        body: JSON.stringify(S)
      });
      if (!I.ok)
        throw new Error(`Error fetching results (page ${p})`);
      const C = await I.json();
      g = g.concat(C.hits), d = C.nbPages, p += 1;
    } while (p < d);
    const h = [];
    g.forEach((S) => {
      const { code: I, offer_id: C, supported_rat: T, data_rate: E } = S, N = _H(I);
      let y = i?.data?.find((w) => w.unc === I)?.costPerMb ?? Number(E);
      i.rateType === "flat_rate" && (a?.dataRate ? y = a.dataRate : y = r?.overageCharge), h.push({
        networkName: S.name,
        profile: t?.find((w) => C.includes(w.offerId))?.profileName ?? "Unknown",
        country: S.country,
        region: N?.region ?? "",
        networkDesignation: I,
        mcc: N?.mcc ?? "",
        mnc: N?.mnc ?? "",
        tadig: N?.tadig ?? "",
        ratePerMb: y,
        supportedRats: t0(T).map((w) => Ps(w)).join(", ")
      });
    });
    const v = ve.now(), b = v.toFormat("yyyyLLddhhmmss");
    let m;
    return n ? m = `Coverage-SIM-ID-${n}-Plan-ID-${a?.planId}-${b}` : r && (m = `Coverage-Plan-ID-${r?.id}-${b}`), async (S) => {
      switch (S) {
        case gt.XLSX: {
          const I = new Gf();
          I.creator = "Hologram", I.lastModifiedBy = "Hologram";
          const C = v.toJSDate();
          I.created = C, I.modified = C;
          const T = I.addWorksheet("Coverage");
          T.addRow(Object.keys(h[0])), T.addRows(h.map((N) => Object.values(N)));
          const E = await I.xlsx.writeBuffer();
          Ch({
            data: E,
            filename: `${m}.xlsx`
          });
          break;
        }
        case gt.CSV:
        default:
          bl({
            data: yl.unparse(h),
            filename: `${m}.csv`
          });
      }
      s?.(S);
    };
  } catch (c) {
    throw o?.(c), c;
  }
}
const EH = "hyperdashboard-CoverageSearchModal-module-DK0m9a-exportMenu", OH = "hyperdashboard-CoverageSearchModal-module-DK0m9a-modal", NH = "hyperdashboard-CoverageSearchModal-module-DK0m9a-wellActions", DH = "hyperdashboard-CoverageSearchModal-module-DK0m9a-wellContent", Io = {
  exportMenu: EH,
  modal: OH,
  wellActions: NH,
  wellContent: DH
}, Y3 = ({
  onClose: e,
  defaultOpen: t = !1,
  legacyPlan: r
}) => {
  const [n, i] = Z(t), { sendAnalyticsEvent: a, sendAnalyticsError: s } = mt(), o = Ne(), { plan: c, error: u, isLoading: f } = Dl(r?.id), {
    billingRates: g,
    error: p,
    isLoading: d
  } = na(o), h = f || d, v = u || p, [b, m] = Z(!1), [S, I] = Z(!1), C = $(() => {
    I((w) => !w);
  }, []), T = el(), E = ia({ planProfiles: c?.profiles }), N = ni({ planProfiles: c?.profiles }), y = async (w) => {
    m(!0), C();
    try {
      return await (await Xh({
        filters: N,
        profiles: E,
        legacyPlan: r,
        billingRates: g,
        onSuccess: (_) => {
          a && a("Network Coverage - Export Networks - Export Networks success", {
            exportType: ea(_)
          });
        },
        onError: (_) => {
          s && s("Export Network Coverage error", _);
        }
      }))(w), m(!1);
    } catch {
      return m(!1), !1;
    }
  };
  return /* @__PURE__ */ l(
    qt,
    {
      className: Io.modal,
      isLoading: h,
      noContentPadding: !0,
      header: `${r?.planName} – Network coverage and rates`,
      onClosed: e,
      open: n,
      setOpen: i,
      contentWell: /* @__PURE__ */ O("div", { className: Io.wellContent, children: [
        /* @__PURE__ */ l("span", { children: "Networks you can connect to are determined by your SIM and the profile(s) installed on it. Some data plans provide coverage across multiple types of SIMs and profiles." }),
        /* @__PURE__ */ l("div", { className: Io.wellActions, children: /* @__PURE__ */ l(
          Kn,
          {
            className: Io.exportMenu,
            content: [
              {
                label: "Export coverage and rates",
                items: [
                  {
                    children: "Export to XLSX (Excel)",
                    iconStart: "DownloadTray",
                    onClick: () => y(gt.XLSX)
                  },
                  {
                    children: "Export to CSV",
                    iconStart: "DownloadTray",
                    onClick: () => y(gt.CSV)
                  }
                ]
              }
            ],
            open: S,
            onOpenChange: I,
            children: /* @__PURE__ */ l(
              Y,
              {
                iconEnd: S ? "ChevronSingleNorth" : "ChevronSingleSouth",
                variant: "secondary",
                onClick: C,
                disabled: !!v || h || !!p,
                id: T,
                loading: b,
                children: "Export"
              }
            )
          }
        ) })
      ] }),
      footerVariant: "alternative",
      children: /* @__PURE__ */ l(Jh, { legacyPlan: r, variant: "modal" })
    }
  );
}, RH = "hyperdashboard-Feedback-module-4eVCza-icon", kH = "hyperdashboard-Feedback-module-4eVCza-link", AH = "hyperdashboard-Feedback-module-4eVCza-linkDescription", xH = "hyperdashboard-Feedback-module-4eVCza-linkText", FH = "hyperdashboard-Feedback-module-4eVCza-linkTitle", $H = "hyperdashboard-Feedback-module-4eVCza-linkWrapper", MH = "hyperdashboard-Feedback-module-4eVCza-pictogram", St = {
  icon: RH,
  link: kH,
  linkDescription: AH,
  linkText: xH,
  linkTitle: FH,
  linkWrapper: $H,
  pictogram: MH
}, K3 = ({ onClose: e, defaultOpen: t = !1, className: r }) => {
  const [n, i] = Z(t);
  return /* @__PURE__ */ O(
    qt,
    {
      className: r,
      noContentPadding: !0,
      header: "Help and feedback",
      onClosed: e,
      open: n,
      setOpen: i,
      children: [
        /* @__PURE__ */ l("div", { className: St.linkWrapper, children: /* @__PURE__ */ O(
          "a",
          {
            href: Nh,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "Create a support ticket",
            className: St.link,
            children: [
              /* @__PURE__ */ l("div", { className: St.pictogram, children: /* @__PURE__ */ l(Ro, { name: "SubmitTicket" }) }),
              /* @__PURE__ */ O("div", { className: St.linkText, children: [
                /* @__PURE__ */ l("p", { className: St.linkTitle, children: "Create a support ticket" }),
                /* @__PURE__ */ l("p", { className: St.linkDescription, children: "Need help? Get in touch with our support team" })
              ] }),
              /* @__PURE__ */ l("div", { className: St.icon, children: /* @__PURE__ */ l(ye, { name: "ArrowEastShort" }) })
            ]
          }
        ) }),
        /* @__PURE__ */ l("div", { className: St.linkWrapper, children: /* @__PURE__ */ O(
          "a",
          {
            href: KD,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "Help center",
            className: St.link,
            children: [
              /* @__PURE__ */ l("div", { className: St.pictogram, children: /* @__PURE__ */ l(Ro, { name: "Help" }) }),
              /* @__PURE__ */ O("div", { className: St.linkText, children: [
                /* @__PURE__ */ l("p", { className: St.linkTitle, children: "Help center" }),
                /* @__PURE__ */ l("p", { className: St.linkDescription, children: "Get advice and answers for deployments" })
              ] }),
              /* @__PURE__ */ l("div", { className: St.icon, children: /* @__PURE__ */ l(ye, { name: "ArrowEastShort" }) })
            ]
          }
        ) }),
        /* @__PURE__ */ l("div", { className: St.linkWrapper, children: /* @__PURE__ */ O(
          "a",
          {
            href: Fw,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "Share feedback",
            className: St.link,
            children: [
              /* @__PURE__ */ l("div", { className: St.pictogram, children: /* @__PURE__ */ l(Ro, { name: "Feedback" }) }),
              /* @__PURE__ */ O("div", { className: St.linkText, children: [
                /* @__PURE__ */ l("p", { className: St.linkTitle, children: "Share feedback" }),
                /* @__PURE__ */ l("p", { className: St.linkDescription, children: "Share your ideas and experiences with us" })
              ] }),
              /* @__PURE__ */ l("div", { className: St.icon, children: /* @__PURE__ */ l(ye, { name: "ArrowEastShort" }) })
            ]
          }
        ) })
      ]
    }
  );
}, LH = 1, jH = 5;
async function* WH(e, t, r, n) {
  let i = 0;
  for (; i < r.length; ) {
    const a = r[i].map(async (s) => ({ ...await vh({
      url: `${e}${s[0]}?${t}`,
      body: {
        tunnelable: n
      },
      throwOnError: !1
    }), deviceId: s[0] }));
    yield Promise.all(a), i += 1;
  }
}
const UH = ({ sims: e, organizationId: t, isSuperAdmin: r }) => {
  const n = V(
    () => r ? new URLSearchParams() : new URLSearchParams({ orgid: `${t}` }),
    [r, t]
  ), i = `${process.env.VITE_API_ROOT}/devices/`, a = V(() => [...e.values()].reduce(
    (c, u, f) => {
      const g = Math.floor(f / LH);
      return u ? (c[g] || (c[g] = []), c[g].push(u), c) : [];
    },
    []
  ).reduce((c, u, f) => {
    const g = Math.floor(f / jH);
    return c[g] || (c[g] = []), c[g].push(u), c;
  }, []), [e]);
  return $(
    async (o) => {
      let c = [];
      for await (const u of WH(
        i,
        n,
        a,
        o
      ))
        c = c.concat(u);
      return c;
    },
    [i, a, n]
  );
}, VH = "hyperdashboard-ManageTunneling-module-8eddxq-errorList", HH = "hyperdashboard-ManageTunneling-module-8eddxq-forms", qH = "hyperdashboard-ManageTunneling-module-8eddxq-wrapper", jd = {
  errorList: VH,
  forms: HH,
  wrapper: qH
}, zH = Et(
  ({ sims: e, onProcessing: t, onDone: r }, n) => {
    const i = e?.size === 1 ? e?.keys().next().value : void 0, { simDetails: a, isLoading: s } = Le(i), o = V(() => {
      let R;
      return i && !s && (R = a?.tunnelable === 1 ? "disable" : "enable"), R;
    }, [s, a?.tunnelable, i]), {
      register: c,
      watch: u,
      setValue: f,
      handleSubmit: g,
      formState: { errors: p }
    } = Lt({
      mode: "onSubmit",
      defaultValues: { newTunnelingValue: o }
    }), [d, h] = Z(), [v, b] = Z(), [m, S] = Z(), I = u("newTunnelingValue");
    Pe(() => {
      i && !s && o && !I && f("newTunnelingValue", o);
    }, [o, s, I, f, i]);
    const { isSuperAdmin: C } = Be(), T = Ne(), E = UH({ sims: e, organizationId: T, isSuperAdmin: C }), N = V(
      () => new Map([...e.entries()].map(([R, x]) => [x, R])),
      [e]
    ), y = $(
      async (R) => {
        t(!0);
        try {
          const x = await E(R.newTunnelingValue === "enable"), F = [], W = /* @__PURE__ */ new Map();
          if (x && x.forEach((A) => {
            A.success ? F.push(A.deviceId) : W.set(A.deviceId, A.error ?? "Unknown error");
          }), F.length > 0) {
            const A = `Secure tunneling ${R.newTunnelingValue === "enable" ? "enabled" : "disabled"}${e.size > 1 ? ` for ${F.length} of ${e.size} SIMs` : ""}.`;
            h(A), r(
              F.map((M) => N.get(M)).filter((M) => M !== void 0)
            );
          }
          W.size > 0 && b(W);
        } catch (x) {
          S(typeof x == "string" ? x : `An error occurred: ${x}`);
        } finally {
          t(!1);
        }
      },
      [r, t, N, e.size, E]
    ), w = g(y), P = we(null), _ = $(async () => {
      P.current?.requestSubmit();
    }, []);
    Kt(
      n,
      () => ({
        onSubmit: _
      }),
      [_]
    );
    const D = V(() => {
      if (s)
        return /* @__PURE__ */ l(ur, { children: `Checking selected ${i ? "SIM" : "SIMs"}...` });
      const R = v && v.size > 0;
      if (d || R)
        return /* @__PURE__ */ O(le, { children: [
          d && /* @__PURE__ */ l(ze, { variant: "success", children: d }),
          R && /* @__PURE__ */ O(ze, { children: [
            "Enable secure tunneling failed for ",
            v.size,
            " SIMs:",
            /* @__PURE__ */ l("ul", { className: jd.errorList, children: [...v.entries()].map(([W]) => /* @__PURE__ */ O("li", { children: [
              "SIM ID ",
              N.get(W),
              ", Device ID ",
              W
            ] }, W)) })
          ] })
        ] });
      if (m)
        return /* @__PURE__ */ l(ze, { variant: "system-error", children: m });
      const x = !(i && a?.tunnelable === 1), F = !(i && a?.tunnelable !== 1);
      return /* @__PURE__ */ O(Gr, { onSubmit: w, ref: P, children: [
        /* @__PURE__ */ l(
          Ts,
          {
            label: "Secure device tunneling",
            helpText: i ? "All selected SIMs will be updated to use this setting." : void 0,
            options: [
              {
                label: `Enable tunneling${F ? " (tunneling is enabled)" : ""}`,
                value: "enable",
                disabled: F
              },
              {
                label: `Disable tunneling${x ? " (tunneling is disabled)" : ""}`,
                value: "disable",
                disabled: x
              }
            ],
            validationMessage: p.newTunnelingValue?.message,
            invalid: !!p.newTunnelingValue,
            ...c("newTunnelingValue", {
              required: "Please select a new tunneling state"
            })
          }
        ),
        I === "disable" && /* @__PURE__ */ l(ze, { variant: "caution", children: "Disabling secure tunneling will remove the ability to communicate with devices through these SIMs using our Spacebridge client." })
      ] });
    }, [
      m,
      p.newTunnelingValue,
      s,
      v,
      I,
      w,
      c,
      a?.tunnelable,
      i,
      N,
      d
    ]);
    return /* @__PURE__ */ l("div", { className: jd.wrapper, children: /* @__PURE__ */ l("div", { className: jd.forms, children: D }) });
  }
), BH = "hyperdashboard-ManageTunneling-module-RSGPbG-footer", GH = {
  footer: BH
}, J3 = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onSuccess: i
}) => {
  const a = n?.size === 1 ? n?.keys().next().value : void 0, [s, o] = Z(t), [c, u] = Z(!1), [f, g] = Z(!1), p = we(), d = $((I) => {
    u(I);
  }, []), h = $(
    (I) => {
      g(!0), I && i(I);
    },
    [i]
  ), v = async (I) => {
    I.preventDefault(), p.current && await p.current.onSubmit();
  }, { simDetails: b, isLoading: m } = Le(a);
  let S = "Manage secure tunneling";
  return a ? m ? S = "Manage secure tunneling" : S = b.tunnelable === 1 ? "Disable secure tunneling" : "Enable secure tunneling" : S = `Manage secure tunneling for ${Ee(n.size)} SIMs`, /* @__PURE__ */ l(
    qt,
    {
      className: J(r),
      header: S,
      onClosed: e,
      open: s,
      setOpen: o,
      noContentPadding: !0,
      contentWell: /* @__PURE__ */ O(le, { children: [
        "Communicate with your devices using secure, authenticated tunnels via SSH using Spacebridge, without relying on a static IP address.",
        " ",
        /* @__PURE__ */ l(Ae, { href: XD, target: "_blank", rel: "noreferrer", type: "inline", children: "Read the secure tunneling guide" })
      ] }),
      footerActions: /* @__PURE__ */ O("div", { className: GH.footer, children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              o(!1);
            },
            children: f ? "Close" : "Cancel"
          }
        ),
        !f && /* @__PURE__ */ l(Y, { loading: c, onClick: v, variant: "primary", children: n.size === 1 ? "Update SIM" : `Update ${Ee(n.size)} SIMs` })
      ] }),
      children: /* @__PURE__ */ l(
        zH,
        {
          sims: n,
          onProcessing: d,
          ref: p,
          onDone: h
        }
      )
    }
  );
}, QH = "hyperdashboard-OrgAcceptedInvite-module-yINLxG-contentHeader", ZH = "hyperdashboard-OrgAcceptedInvite-module-yINLxG-contents", YH = "hyperdashboard-OrgAcceptedInvite-module-yINLxG-contentsWrapper", KH = "hyperdashboard-OrgAcceptedInvite-module-yINLxG-contentText", Co = {
  contentHeader: QH,
  contents: ZH,
  contentsWrapper: YH,
  contentText: KH
}, X3 = ({
  onClose: e,
  orgName: t,
  defaultOpen: r = !1,
  className: n
}) => {
  const [i, a] = Z(r);
  return /* @__PURE__ */ l(
    qt,
    {
      className: n,
      noContentPadding: !0,
      header: "Accepted invite",
      onClosed: e,
      open: i,
      setOpen: a,
      children: /* @__PURE__ */ O("div", { className: Co.contentsWrapper, children: [
        /* @__PURE__ */ l(ye, { name: "CircleCheckmark", fill: "DdsColorFillNotificationSuccess", size: "large" }),
        /* @__PURE__ */ O("div", { className: Co.contents, children: [
          /* @__PURE__ */ O("div", { className: Co.contentHeader, children: [
            "You joined ",
            t
          ] }),
          /* @__PURE__ */ l("div", { className: Co.contentText, children: "Change organizations in the top right corner of your dashboard, or change your default organization under Settings > Your Account." })
        ] })
      ] })
    }
  );
}, JH = { webp: "/assets/img/org_picker.webp 360w", avif: "/assets/img/org_picker.avif 360w" }, XH = { src: "/assets/img/org_picker.png", w: 360, h: 247 }, eq = { sources: JH, img: XH }, tq = "hyperdashboard-OrgIntro-module-_UyTIa-contents", rq = "hyperdashboard-OrgIntro-module-_UyTIa-contentsWrapper", nq = "hyperdashboard-OrgIntro-module-_UyTIa-header", iq = "hyperdashboard-OrgIntro-module-_UyTIa-headerContentsWrapper", aq = "hyperdashboard-OrgIntro-module-_UyTIa-illustration", sq = "hyperdashboard-OrgIntro-module-_UyTIa-orgNameHighlight", Ii = {
  contents: tq,
  contentsWrapper: rq,
  header: nq,
  headerContentsWrapper: iq,
  illustration: aq,
  orgNameHighlight: sq
}, e4 = ({ onClose: e, orgName: t, defaultOpen: r = !1, className: n }) => {
  const [i, a] = Z(r);
  return /* @__PURE__ */ l(
    qt,
    {
      className: n,
      noContentPadding: !0,
      header: `Welcome to your ${t} dashboard`,
      onClosed: e,
      open: i,
      setOpen: a,
      children: /* @__PURE__ */ l(
        As,
        {
          headerContents: /* @__PURE__ */ O("div", { className: Ii.headerContentsWrapper, children: [
            /* @__PURE__ */ O("p", { children: [
              "Your new ",
              /* @__PURE__ */ l("span", { className: Ii.orgNameHighlight, children: t }),
              " dashboard is ready to use. Now you can activate your first SIM cards and invite your team to collaborate."
            ] }),
            /* @__PURE__ */ l("p", { children: "Let’s get you connected." })
          ] }),
          headerClassName: Ii.header,
          contentsClassName: Ii.contents,
          children: /* @__PURE__ */ O("div", { className: Ii.contentsWrapper, children: [
            /* @__PURE__ */ l("div", { className: Ii.illustration, children: /* @__PURE__ */ l(fh, { image: eq, alt: "" }) }),
            /* @__PURE__ */ l(tn, { variant: "note", children: "You can switch to other organizations using the menu in the upper-right corner of the screen." })
          ] })
        }
      )
    }
  );
}, oq = `${process.env.VITE_API_ROOT}/devices/batch/usagelimit`, lq = (e) => $(
  async (r) => await ft({
    url: oq,
    body: {
      deviceids: e,
      datathreshold: r
    }
  }),
  [e]
), cq = "hyperdashboard-SetUsageAlerts-module-DQmWta-alertLabel", uq = "hyperdashboard-SetUsageAlerts-module-DQmWta-alertToggle", dq = "hyperdashboard-SetUsageAlerts-module-DQmWta-byteEntry", fq = "hyperdashboard-SetUsageAlerts-module-DQmWta-form", hq = "hyperdashboard-SetUsageAlerts-module-DQmWta-formField", mq = "hyperdashboard-SetUsageAlerts-module-DQmWta-forms", pq = "hyperdashboard-SetUsageAlerts-module-DQmWta-thresholdEntry", gq = "hyperdashboard-SetUsageAlerts-module-DQmWta-thresholdEntryControls", vq = "hyperdashboard-SetUsageAlerts-module-DQmWta-thresholdEntryField", yq = "hyperdashboard-SetUsageAlerts-module-DQmWta-unitEntry", bq = "hyperdashboard-SetUsageAlerts-module-DQmWta-wrapper", vr = {
  alertLabel: cq,
  alertToggle: uq,
  byteEntry: dq,
  form: fq,
  formField: hq,
  forms: mq,
  thresholdEntry: pq,
  thresholdEntryControls: gq,
  thresholdEntryField: vq,
  unitEntry: yq,
  wrapper: bq
}, qf = {
  KB: 1e3,
  MB: 1e6,
  GB: 1e9
}, Sq = Object.entries(qf).map(([e, t]) => ({
  value: t.toString(),
  label: e
})), wq = Et(
  ({ sims: e, onProcessing: t, onDone: r, onAlertingToggle: n }, i) => {
    const {
      register: a,
      handleSubmit: s,
      watch: o,
      setFocus: c,
      formState: { errors: u }
    } = Lt({
      mode: "onSubmit",
      defaultValues: { usageAlertThresholdUnit: qf.MB, usageAlertThreshold: "noalert" }
    }), f = o("usageAlertThreshold"), g = f === "alert", p = o("usageAlertThresholdBytes"), d = o("usageAlertThresholdUnit"), h = (p ?? 0) * (d ?? 0);
    Pe(() => {
      n(f);
    }, [f, n]), Pe(() => {
      g && c("usageAlertThresholdBytes");
    }, [g, c]);
    const v = V(
      () => [...e.values()].filter((y) => y !== void 0),
      [e]
    ), b = lq(v), [m, S] = Z(), I = $(
      async (y) => {
        t(!0);
        const w = g ? (y.usageAlertThresholdBytes ?? 0) * (y.usageAlertThresholdUnit ?? 0) : -1;
        try {
          await b(w);
        } catch (P) {
          S(typeof P == "string" ? P : `An error occurred: ${P}`);
        } finally {
          t(!1);
        }
        r([...e.keys()]);
      },
      [g, r, t, b, e]
    ), C = s(I), T = we(null), E = $(async () => {
      T.current?.requestSubmit();
    }, []);
    Kt(
      i,
      () => ({
        onSubmit: E
      }),
      [E]
    );
    const N = V(() => m ? /* @__PURE__ */ l(ze, { variant: "system-error", children: m }) : /* @__PURE__ */ O(Gr, { onSubmit: C, ref: T, className: vr.form, children: [
      /* @__PURE__ */ l(
        mn,
        {
          className: J(vr.formField, vr.alertLabel),
          label: "Alert behavior",
          layoutDirection: "row",
          centerLabel: !0,
          children: () => /* @__PURE__ */ l("span", { children: !g || h === 0 || Number.isNaN(h) ? /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l("strong", { children: "Do not check data usage" }),
            " for",
            " ",
            e.size === 1 ? "this SIM" : "these SIMs",
            "."
          ] }) : /* @__PURE__ */ O(le, { children: [
            e.size === 1 ? "This SIM" : "These SIMs",
            " will",
            " ",
            /* @__PURE__ */ O("strong", { children: [
              "be alerted at ",
              Ee(p),
              " ",
              Object.entries(qf).find(
                ([, y]) => y === d
              )[0]
            ] }),
            " ",
            "of data usage."
          ] }) })
        }
      ),
      /* @__PURE__ */ l(
        Ts,
        {
          className: J(vr.formField, vr.alertToggle),
          label: "Usage alert threshold",
          layoutDirection: "row",
          options: [
            { label: "Do not alert", value: "noalert" },
            { label: "Alert at a set threshold", value: "alert" }
          ],
          ...a("usageAlertThreshold")
        }
      ),
      /* @__PURE__ */ l(
        mn,
        {
          className: J(vr.formField, vr.thresholdEntryField),
          label: "Usage alert threshold",
          hiddenLabel: !0,
          layoutDirection: "row",
          invalid: !!u.usageAlertThresholdBytes,
          validationMessage: u.usageAlertThresholdBytes?.message,
          children: ({ primaryControlId: y, ariaDescribedbyIds: w, invalid: P }) => /* @__PURE__ */ l("div", { className: vr.thresholdEntry, children: /* @__PURE__ */ l("div", { className: vr.thresholdEntryControls, children: g && /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              nn,
              {
                id: y,
                ariaDescribedby: w,
                ariaLabel: "Usage alert threshold bytes",
                invalid: P,
                className: vr.byteEntry,
                type: "number",
                ...a("usageAlertThresholdBytes", {
                  valueAsNumber: !0,
                  validate: (_) => _ === void 0 || _ < 0 ? "Please enter a valid amount greater than or equal to 0." : _ !== Math.floor(_) ? "Please enter a valid whole number greater than or equal to 0." : !0
                })
              }
            ),
            /* @__PURE__ */ l(
              Zf,
              {
                id: "customAmountUnit",
                className: vr.unitEntry,
                ariaDescribedby: w,
                ariaLabel: "Usage alert threshold unit",
                options: Sq,
                ...a("usageAlertThresholdUnit", {
                  valueAsNumber: !0
                })
              }
            )
          ] }) }) })
        }
      )
    ] }), [
      g,
      m,
      u.usageAlertThresholdBytes,
      h,
      p,
      d,
      C,
      a,
      e.size
    ]);
    return /* @__PURE__ */ l("div", { className: vr.wrapper, children: /* @__PURE__ */ O("div", { className: vr.forms, children: [
      /* @__PURE__ */ l(ze, { variant: "caution", children: "Data usage alerts do not send notifications and are only found in the Action Items tab under the Home page." }),
      N
    ] }) });
  }
), t4 = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onSuccess: i
}) => {
  const [a, s] = Z(t), [o, c] = Z(!1), [u, f] = Z(!1), g = we(), p = $((m) => {
    c(m);
  }, []), d = $(
    (m) => {
      f(!0), m && i(m), e();
    },
    [e, i]
  ), h = async (m) => {
    m.preventDefault(), g.current && await g.current.onSubmit();
  }, [v, b] = Z("noalert");
  return /* @__PURE__ */ l(
    qt,
    {
      className: J(r),
      header: `Set data usage alert${n.size === 1 ? "" : ` for ${Ee(n.size)} SIMs`}`,
      onClosed: e,
      open: a,
      setOpen: s,
      noContentPadding: !0,
      contentWell: /* @__PURE__ */ O(le, { children: [
        "Monitor when your ",
        n.size === 1 ? "SIM reaches" : "SIMs reach",
        " a set threshold or amount of data usage. Data usage alerts are most often used as an early warning before reaching a data limit.",
        " ",
        /* @__PURE__ */ l(Ae, { href: eR, target: "_blank", rel: "noreferrer", type: "inline", children: "Learn more" })
      ] }),
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              s(!1);
            },
            children: u ? "Close" : "Cancel"
          }
        ),
        !u && /* @__PURE__ */ l(
          Y,
          {
            loading: o,
            onClick: h,
            variant: v === "noalert" ? "delete" : "primary",
            children: v === "noalert" ? "Remove usage threshold" : "Update usage threshold"
          }
        )
      ] }),
      children: /* @__PURE__ */ l(
        wq,
        {
          sims: n,
          onProcessing: p,
          ref: g,
          onDone: d,
          onAlertingToggle: b
        }
      )
    }
  );
}, Iq = () => {
  const e = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/message/socket`;
  return $(
    async (r) => {
      if (!e)
        return;
      const { sims: n, body: i, base64body: a, encrypted: s, port: o, protocol: c } = r, u = {
        encrypted: s,
        port: o,
        protocol: c,
        hologramSimIds: [...n.keys()]
      };
      return i ? u.data = i : a && (u.base64data = a), await ft({
        url: e,
        body: u
      });
    },
    [e]
  );
}, Cq = Et(
  ({ sims: e, onProcessing: t, onDone: r, onError: n }, i) => {
    const a = Iq(), {
      register: s,
      handleSubmit: o,
      formState: { errors: c }
    } = Lt({
      mode: "onSubmit",
      shouldFocusError: !0,
      reValidateMode: "onChange",
      defaultValues: { protocol: "TCP", port: "4010" }
    }), u = $(
      async (h) => {
        t(!0);
        let v;
        try {
          v = await a({
            body: h.data,
            port: h.port,
            protocol: h.protocol,
            sims: e
          }), v?.success ? r([...e.keys()]) : n(v?.error);
        } catch (b) {
          typeof b == "string" ? n(b) : (n(`An error occurred: ${b}`), console.error(b));
        } finally {
          t(!1);
        }
      },
      [a, r, n, t, e]
    ), f = o(u), g = we(null), p = $(async () => {
      g.current?.requestSubmit();
    }, []);
    Kt(
      i,
      () => ({
        onSubmit: p
      }),
      [p]
    );
    let d;
    return c.data && (c.data.message && c.data.message.length > 0 ? d = c.data.message : d = "The maximum data length is 160 characters."), /* @__PURE__ */ O(Gr, { onSubmit: f, ref: g, children: [
      /* @__PURE__ */ l(
        Yf,
        {
          required: !0,
          label: "Data",
          invalid: c.data !== void 0,
          validationMessage: d,
          ...s("data", { required: "Data is required", maxLength: 160 })
        }
      ),
      /* @__PURE__ */ l(
        Ts,
        {
          label: "Protocol",
          options: [
            { label: "TCP", value: "TCP" },
            { label: "UDP", value: "UDP" }
          ],
          ...s("protocol")
        }
      ),
      /* @__PURE__ */ l(pn, { label: "Port", required: !0, type: "number", ...s("port") })
    ] });
  }
), Pq = () => {
  const e = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/message/sms`;
  return $(
    async (r) => {
      if (!e)
        return;
      const { sims: n, body: i, base64body: a, fromNumber: s, phoneNumber: o } = r, c = {
        fromNumber: s,
        phoneNumber: o,
        hologramSimIds: [...n.keys()],
        ...i ? { body: i } : { base64body: a }
      };
      return await ft({
        url: e,
        body: c
      });
    },
    [e]
  );
}, Tq = "hyperdashboard-BulkSendSmsMessage-module-XLTjYW-notificationText", Eb = {
  notificationText: Tq
}, _q = Et(
  ({ sims: e, onProcessing: t, onDone: r, onError: n }, i) => {
    const a = Pq(), [s, o] = Z(!1), {
      register: c,
      handleSubmit: u,
      formState: { errors: f }
    } = Lt({
      mode: "onSubmit",
      shouldFocusError: !0,
      reValidateMode: "onChange"
    }), g = $(
      async (b) => {
        t(!0);
        let m;
        try {
          m = await a({
            body: b.message,
            fromNumber: b.fromNumber,
            sims: e
          }), m?.success ? r([...e.keys()]) : n(m?.error);
        } catch (S) {
          typeof S == "string" ? n(S) : (n(`An error occurred: ${S}`), console.error(S));
        } finally {
          t(!1);
        }
      },
      [a, r, n, t, e]
    ), p = u(g), d = we(null), h = $(async () => {
      d.current?.requestSubmit();
    }, []);
    Kt(
      i,
      () => ({
        onSubmit: h
      }),
      [h]
    );
    let v;
    return f.message && (f.message.message && f.message.message.length > 0 ? v = f.message.message : v = "The maximum message length is 160 characters."), /* @__PURE__ */ O(Gr, { onSubmit: p, ref: d, children: [
      /* @__PURE__ */ l(
        Yf,
        {
          label: "Message",
          helpText: /* @__PURE__ */ O("span", { children: [
            "Send a free message to your SIM.",
            " ",
            /* @__PURE__ */ l(
              Ae,
              {
                type: "inline",
                onClick: (b) => {
                  b.preventDefault(), o((m) => !m);
                },
                children: "Learn about sending a message"
              }
            )
          ] }),
          invalid: f.message !== void 0,
          validationMessage: v,
          ...c("message", { required: "Message is required", maxLength: 160 })
        }
      ),
      s && /* @__PURE__ */ O(ze, { variant: "note", children: [
        /* @__PURE__ */ O("span", { className: Eb.notificationText, children: [
          "All SMS messages ",
          /* @__PURE__ */ l("em", { children: "to" }),
          " Hologram SIMs are ",
          /* @__PURE__ */ l("strong", { children: "free" }),
          ". SMS rates only apply to messages sent outbound ",
          /* @__PURE__ */ l("em", { children: "from" }),
          " your device."
        ] }),
        /* @__PURE__ */ O("p", { className: Eb.notificationText, children: [
          'Messages sent from your dashboard or our REST API, by default, will contain the "from number" of our internal servers. When your device responds to this number, the message will be inserted into your data logs. To allow your device to respond to a different number, be sure to configure the "From number" below. Alternatively, you can',
          " ",
          /* @__PURE__ */ l(
            Ae,
            {
              type: "inline",
              href: "https://www.hologram.io/contact-sales/",
              target: "_blank",
              rel: "noreferrer",
              children: "contact sales"
            }
          ),
          " ",
          "to purchase a phone number for your device and text that directly from a phone (i.e. without using the dashboard or API)."
        ] })
      ] }),
      /* @__PURE__ */ l(
        pn,
        {
          label: "From number",
          optional: !0,
          helpText: "Customize the SMS sender, if you need your device to respond to a specific destination.",
          ...c("fromNumber")
        }
      )
    ] });
  }
), Eq = "hyperdashboard-SimInventoryBulkSendMessage-module-PUQ5BW-forms", Oq = "hyperdashboard-SimInventoryBulkSendMessage-module-PUQ5BW-wrapper", Ob = {
  forms: Eq,
  wrapper: Oq
}, Nq = Et(
  ({ sims: e, onProcessing: t, onDone: r, onError: n }, i) => {
    const { register: a, watch: s } = Lt({
      mode: "onChange",
      defaultValues: { method: "sms" }
    }), o = s("method"), { releaseFlags: c } = Be(), u = c.has(
      Ht.FEATURE_HOLOGRAM_CLOUD_MESSAGING
    ), f = [{ label: "SMS", value: "sms" }];
    return u && f.push({ label: "Cloud data", value: "cloudData" }), /* @__PURE__ */ l("div", { className: Ob.wrapper, children: /* @__PURE__ */ O("div", { className: Ob.forms, children: [
      /* @__PURE__ */ l(Ts, { label: "Method", options: f, ...a("method") }),
      o === "sms" && /* @__PURE__ */ l(
        _q,
        {
          sims: e,
          ref: i,
          onProcessing: t,
          onDone: r,
          onError: n
        }
      ),
      o === "cloudData" && /* @__PURE__ */ l(
        Cq,
        {
          sims: e,
          ref: i,
          onProcessing: t,
          onDone: r,
          onError: n
        }
      )
    ] }) });
  }
), Dq = "hyperdashboard-SimInventoryBulkSendMessage-module-aaO46G-wrapper", Rq = {
  wrapper: Dq
}, r4 = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onSuccess: i,
  onError: a
}) => {
  const [s, o] = Z(t), [c, u] = Z(!1), [f, g] = Z(!1), p = we(), d = $((b) => {
    u(b);
  }, []), h = $(
    (b) => {
      g(!0), b && i(b), e();
    },
    [e, i]
  ), v = async (b) => {
    b.preventDefault(), p.current && await p.current.onSubmit();
  };
  return /* @__PURE__ */ l(
    qt,
    {
      className: J(r, Rq.wrapper),
      header: n.size === 1 ? "Send message to SIM" : `Send message to ${Ee(n.size)} SIMs`,
      onClosed: e,
      open: s,
      setOpen: o,
      noContentPadding: !0,
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              o(!1);
            },
            children: f ? "Close" : "Cancel"
          }
        ),
        !f && /* @__PURE__ */ l(Y, { loading: c, onClick: v, variant: "primary", children: n.size === 1 ? "Send message" : `Send message to ${Ee(n.size)} SIMs` })
      ] }),
      children: /* @__PURE__ */ l(
        Nq,
        {
          sims: n,
          onProcessing: d,
          ref: p,
          onDone: h,
          onError: a
        }
      )
    }
  );
}, kq = "hyperdashboard-SimInventoryBulkUpdateState-module-16i5Ia-wrapper", Aq = {
  wrapper: kq
}, n4 = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  action: n,
  sims: i,
  onSuccess: a
}) => {
  const [s, o] = Z(t), [c, u] = Z(!1), [f, g] = Z(!1), [p, d] = Z(!1), [h, v] = Z(i.size), b = we(), m = $((E) => {
    u(E);
  }, []), S = $((E) => {
    g(!0), v(E);
  }, []), I = $(
    (E) => {
      d(!0), E && a(E);
    },
    [a]
  ), C = async (E) => {
    E.preventDefault(), b.current && await b.current.onSubmit();
  };
  let T;
  if (i.size === 0)
    return null;
  switch (n) {
    case "pause":
      T = "Pause";
      break;
    case "resume":
      T = "Resume";
      break;
    default:
      return null;
  }
  return /* @__PURE__ */ l(
    qt,
    {
      className: J(r, Aq.wrapper),
      header: `${T} data usage${f && h > 1 ? ` for ${Ee(h)} SIMs` : ""}`,
      onClosed: e,
      open: s,
      setOpen: o,
      noContentPadding: !0,
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              o(!1);
            },
            children: p ? "Close" : "Cancel"
          }
        ),
        !p && f && h > 0 && /* @__PURE__ */ l(
          Y,
          {
            loading: c,
            onClick: C,
            variant: i.size === 1 ? "secondary" : "primary",
            children: `${T} ${h > 1 ? `${Ee(h)} SIMs` : "SIM"}`
          }
        )
      ] }),
      children: /* @__PURE__ */ l(
        YD,
        {
          action: n,
          sims: i,
          onProcessing: m,
          ref: b,
          onDone: I,
          onPreviewDone: S
        }
      )
    }
  );
}, xq = "hyperdashboard-SimSwitchProfiles-module-n2nWUa-wrapper", Fq = {
  wrapper: xq
}, i4 = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onSuccess: i,
  onButtonClick: a
}) => {
  const [s, o] = Z(t), [c, u] = Z(), [f, g] = Z(!1), p = we(), { sendAnalyticsEvent: d, sendAnalyticsError: h } = mt(), v = $((T) => {
    g(T);
  }, []), b = $(() => {
    a("X"), o(!1);
  }, [a]), m = $(() => {
    a("Close"), o(!1);
  }, [a]), S = $(() => {
    a("Cancel"), o(!1);
  }, [a]);
  Pe(() => {
    s && d && d("SIMs - Details - Manage SIM - Switch profile");
  }, [s, d]);
  const I = $(
    (T, E) => {
      if (E) {
        u(E), h && h(E);
        return;
      }
      T && (d && d("SIMs - Details - Manage SIM - Switch profile - Success"), i(T)), b();
    },
    [b, i, h, d]
  ), C = async (T) => {
    T.preventDefault(), a("Switch profiles"), p.current && await p.current.onSubmit();
  };
  return /* @__PURE__ */ l(
    qt,
    {
      className: J(r, Fq.wrapper),
      header: "Switch profiles",
      onClosed: e,
      open: s,
      setOpen: o,
      noContentPadding: !0,
      footerActions: c ? /* @__PURE__ */ l(Y, { variant: "secondary", onClick: m, children: "Close" }) : /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(Y, { variant: "secondary", onClick: S, disabled: f, children: "Cancel" }),
        /* @__PURE__ */ l(Y, { loading: f, onClick: C, iconStart: "SwapSIM", children: "Switch profiles" })
      ] }),
      children: /* @__PURE__ */ l(kF, { sims: n, ref: p, onDone: I, onProcessing: v })
    }
  );
}, $q = (e) => {
  const t = `${process.env.VITE_API_ROOT}/csr/rdm`;
  return $(
    async (n, i) => e ? await ft({
      url: t,
      body: {
        deviceid: e,
        data: n,
        tags: i ?? []
      }
    }) : void 0,
    [e, t]
  );
}, Mq = "hyperdashboard-SimulateMessageToApi-module-se4cxW-deviceInfo", Lq = {
  deviceInfo: Mq
}, jq = Et(
  ({ sims: e, onProcessing: t, onDone: r, onError: n, topics: i, data: a }, s) => {
    const {
      register: o,
      handleSubmit: c,
      formState: { errors: u }
    } = Lt({
      mode: "onSubmit",
      defaultValues: { topics: i, data: a }
    }), f = e.keys().next().value, g = e.values().next().value, p = Ne(), { device: d } = ti(g, p), h = V(() => /* @__PURE__ */ new Set(["_RESTAPI_", `_DEVICE_${g}`]), [g]), v = $q(g), b = $(
      async (C) => {
        t(!0);
        const T = C.topics.split(",").map((E) => E.trim()).filter((E) => E.length > 0 && !h.has(E));
        try {
          const E = await v(C.data, T);
          E?.success ? r([f]) : n(E?.error);
        } catch (E) {
          typeof E == "string" ? n(E) : (n(`An error occurred: ${E}`), console.error(E));
        } finally {
          t(!1);
        }
      },
      [v, h, r, n, t, f]
    ), m = c(b), S = we(null), I = $(async () => {
      S.current?.requestSubmit();
    }, []);
    return Kt(
      s,
      () => ({
        onSubmit: I
      }),
      [I]
    ), /* @__PURE__ */ O(Gr, { onSubmit: m, ref: S, children: [
      /* @__PURE__ */ O("div", { className: Lq.deviceInfo, children: [
        d?.name && /* @__PURE__ */ l(ee, { label: "Device name", value: d.name, direction: "column" }),
        /* @__PURE__ */ l(ee, { label: "Device ID", value: g, direction: "column" })
      ] }),
      /* @__PURE__ */ l(
        pn,
        {
          label: "Topics",
          helpText: "A comma-separated list of topics to send with the simulated message. System topics, such as _DEVICE_X_, will be removed.",
          optional: !0,
          layoutDirection: "column",
          invalid: !!u.topics,
          validationMessage: u.topics?.message,
          ...o("topics")
        }
      ),
      /* @__PURE__ */ l(
        Yf,
        {
          label: "Data",
          helpText: "The data payload of the simulated message. Can be a string or valid JSON (double-quotes only).",
          required: !0,
          layoutDirection: "column",
          invalid: !!u.data,
          validationMessage: u.data?.message,
          inputProps: { rows: 5 },
          ...o("data", { required: "Data is required" })
        }
      )
    ] });
  }
), Wq = "hyperdashboard-SimulateMessageToApi-module-mUe52a-wrapper", Uq = {
  wrapper: Wq
}, a4 = ({
  onClose: e,
  defaultOpen: t = !1,
  className: r,
  sims: n,
  onSuccess: i,
  onError: a,
  data: s,
  topics: o
}) => {
  const [c, u] = Z(t), [f, g] = Z(!1), [p, d] = Z(!1), h = we(), v = $((S) => {
    g(S);
  }, []), b = $(
    (S) => {
      d(!0), S && i(S), e();
    },
    [e, i]
  ), m = async (S) => {
    S.preventDefault(), h.current && await h.current.onSubmit();
  };
  return n.size !== 1 ? null : /* @__PURE__ */ l(
    qt,
    {
      className: J(r, Uq.wrapper),
      header: "Simulate message to API",
      onClosed: e,
      open: c,
      setOpen: u,
      contentWell: /* @__PURE__ */ O(le, { children: [
        "Simulate messages from a SIM for debugging and testing.",
        " ",
        /* @__PURE__ */ l(Ae, { href: JD, target: "_blank", rel: "noreferrer", type: "inline", children: "Read more" })
      ] }),
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              u(!1);
            },
            children: p ? "Close" : "Cancel"
          }
        ),
        !p && /* @__PURE__ */ l(Y, { loading: f, onClick: m, variant: "primary", children: "Simulate message" })
      ] }),
      children: /* @__PURE__ */ l(
        jq,
        {
          sims: n,
          onProcessing: v,
          onDone: b,
          onError: a,
          ref: h,
          topics: o,
          data: s
        }
      )
    }
  );
}, Vq = () => {
}, Hq = (
  /*#__NOINLINE__*/
  Vq()
), zf = Object, Nb = (e) => e === Hq, qq = (e) => typeof e == "function", Po = /* @__PURE__ */ new WeakMap(), Wd = (e, t) => zf.prototype.toString.call(e) === `[object ${t}]`;
let zq = 0;
const Bf = (e) => {
  const t = typeof e, r = Wd(e, "Date"), n = Wd(e, "RegExp"), i = Wd(e, "Object");
  let a, s;
  if (zf(e) === e && !r && !n) {
    if (a = Po.get(e), a) return a;
    if (a = ++zq + "~", Po.set(e, a), Array.isArray(e)) {
      for (a = "@", s = 0; s < e.length; s++)
        a += Bf(e[s]) + ",";
      Po.set(e, a);
    }
    if (i) {
      a = "#";
      const o = zf.keys(e).sort();
      for (; !Nb(s = o.pop()); )
        Nb(e[s]) || (a += s + ":" + Bf(e[s]) + ",");
      Po.set(e, a);
    }
  } else
    a = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return a;
}, Bq = (e) => {
  if (qq(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? Bf(e) : "", [
    e,
    t
  ];
}, Gq = (e) => Bq(e ? e(0, null) : null)[0], Ud = Promise.resolve(), Qq = (e) => (t, r, n) => {
  const i = we(!1), { cache: a, initialSize: s = 1, revalidateAll: o = !1, persistSize: c = !1, revalidateFirstPage: u = !0, revalidateOnMount: f = !1, parallel: g = !1 } = n, [, , , p] = Jr.get(dl);
  let d;
  try {
    d = Gq(t), d && (d = aw + d);
  } catch {
  }
  const [h, v, b] = Rn(a, d), m = $(() => Fe(h()._l) ? s : h()._l, [
    a,
    d,
    s
  ]);
  oh.useSyncExternalStore($(
    (y) => d ? b(d, () => {
      y();
    }) : () => {
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      a,
      d
    ]
  ), m, m);
  const S = $(() => {
    const y = h()._l;
    return Fe(y) ? s : y;
  }, [
    d,
    s
  ]), I = we(S());
  ja(() => {
    if (!i.current) {
      i.current = !0;
      return;
    }
    d && v({
      _l: c ? I.current : S()
    });
  }, [
    d,
    a
  ]);
  const C = f && !i.current, T = e(d, async (y) => {
    const w = h()._i, P = h()._r;
    v({
      _r: Nt
    });
    const _ = [], D = S(), [R] = Rn(a, y), x = R().data, F = [];
    let W = null;
    for (let A = 0; A < D; ++A) {
      const [M, j] = Ka(t(A, g ? null : W));
      if (!M)
        break;
      const [B, L] = Rn(a, M);
      let H = B().data;
      const q = o || w || Fe(H) || u && !A && !Fe(x) || C || x && !Fe(x[A]) && !n.compare(x[A], H);
      if (r && (typeof P == "function" ? P(H, j) : q)) {
        const te = async () => {
          if (!(M in p))
            H = await r(j);
          else {
            const X = p[M];
            delete p[M], H = await X;
          }
          L({
            data: H,
            _k: j
          }), _[A] = H;
        };
        g ? F.push(te) : await te();
      } else
        _[A] = H;
      g || (W = H);
    }
    return g && await Promise.all(F.map((A) => A())), v({
      _i: Nt
    }), _;
  }, n), E = $(
    // eslint-disable-next-line func-names
    function(y, w) {
      const P = typeof w == "boolean" ? {
        revalidate: w
      } : w || {}, _ = P.revalidate !== !1;
      return d ? (_ && (Fe(y) ? v({
        _i: !0,
        _r: P.revalidate
      }) : v({
        _i: !1,
        _r: P.revalidate
      })), arguments.length ? T.mutate(y, {
        ...P,
        revalidate: _
      }) : T.mutate()) : Ud;
    },
    // swr.mutate is always the same reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      d,
      a
    ]
  ), N = $(
    (y) => {
      if (!d) return Ud;
      const [, w] = Rn(a, d);
      let P;
      if (Or(y) ? P = y(S()) : typeof y == "number" && (P = y), typeof P != "number") return Ud;
      w({
        _l: P
      }), I.current = P;
      const _ = [], [D] = Rn(a, d);
      let R = null;
      for (let x = 0; x < P; ++x) {
        const [F] = Ka(t(x, R)), [W] = Rn(a, F), A = F ? W().data : Nt;
        if (Fe(A))
          return E(D().data);
        _.push(A), R = A;
      }
      return E(_);
    },
    // exclude getKey from the dependencies, which isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      d,
      a,
      E,
      S
    ]
  );
  return {
    size: S(),
    setSize: N,
    mutate: E,
    get data() {
      return T.data;
    },
    get error() {
      return T.error;
    },
    get isValidating() {
      return T.isValidating;
    },
    get isLoading() {
      return T.isLoading;
    }
  };
}, n0 = ET(je, Qq), i0 = ({ organizationId: e, pageSize: t = 12 }) => {
  const r = $(
    (b, m) => {
      if (!e || m && !m.nextPage)
        return null;
      const S = [
        ["orgId", `${e}`],
        ["pageSize", t.toString()]
      ];
      return b !== 0 && m?.nextPage && S.push(["cursor", `${m.nextPage}`]), `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/invoices?${new URLSearchParams(S)}`;
    },
    [e, t]
  ), { data: n, setSize: i, size: a, error: s, isLoading: o, mutate: c, isValidating: u } = n0(r, Ze), f = V(
    () => n ? n.reduce((b, m) => m && m.data ? [...b, ...m.data] : b, []) : [],
    [n]
  ), g = (n?.[0]?.data?.length ?? 0) === 0, p = g || !!(n && (n[n.length - 1]?.data?.length ?? 0) < t), d = u && !!n && n.length === a, h = o || !!(a > 0 && n && (n[a - 1]?.data?.length ?? 0) === 0) && !(g || p), v = $(() => {
    i((b) => b + 1);
  }, [i]);
  return {
    invoices: f,
    end: p,
    loadMore: v,
    isEmpty: g,
    error: s,
    isLoading: o,
    isLoadingMore: h,
    mutate: c,
    isValidating: u,
    isRefreshing: d
  };
}, Zq = "hyperdashboard-sharedPage-module-oa9IBW-pageWrapper", Yq = "hyperdashboard-sharedPage-module-oa9IBW-pageWrapperScrollable", Kq = "hyperdashboard-sharedPage-module-oa9IBW-tabWrapper", Jq = "hyperdashboard-sharedPage-module-oa9IBW-viewsWrapper", Xq = "hyperdashboard-sharedPage-module-oa9IBW-viewsWrapperNoPadding", $t = {
  pageWrapper: Zq,
  pageWrapperScrollable: Yq,
  tabWrapper: Kq,
  viewsWrapper: Jq,
  viewsWrapperNoPadding: Xq
}, ii = ({ baseUrl: e, orgId: t }) => {
  const r = V(
    () => [{ placeholder: Fi.orgId, value: t?.toString() ?? "" }],
    [t]
  );
  return bn({
    url: e,
    replacers: r
  });
}, ez = (e) => {
  const t = new URLSearchParams({ orgId: `${e}` }), r = e ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/account?${t}` : null, { data: n, error: i, isLoading: a, isValidating: s, mutate: o } = je(r, Ze);
  return {
    billingAccount: V(() => n ?? {}, [n]),
    error: i,
    isLoading: a,
    isValidating: s,
    mutate: o
  };
}, tz = async (e) => {
  const t = new Headers();
  t.append("Content-Type", "application/pdf");
  const r = await fetch(e, {
    credentials: "include",
    method: "GET",
    headers: t
  });
  if (!r.ok) {
    const n = new Error("An error occurred while fetching the data.");
    throw n.status = r.status, n;
  }
  return r.blob();
}, rz = ({ orgId: e }) => $(
  async (r) => {
    if (!e)
      return;
    const n = new URLSearchParams({ orgId: `${e}` }), i = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/invoices/${r}/download?${n}`;
    return await tz(i);
  },
  [e]
), nz = ({ blob: e, filename: t = "download.pdf" }) => Ih({ blob: e, filename: t }), iz = "hyperdashboard-InvoicesPanel-module-puz4gG-actions", az = "hyperdashboard-InvoicesPanel-module-puz4gG-actionsWrapper", sz = "hyperdashboard-InvoicesPanel-module-puz4gG-contents", oz = "hyperdashboard-InvoicesPanel-module-puz4gG-due", lz = "hyperdashboard-InvoicesPanel-module-puz4gG-duePaid", cz = "hyperdashboard-InvoicesPanel-module-puz4gG-duePastDue", uz = "hyperdashboard-InvoicesPanel-module-puz4gG-header", dz = "hyperdashboard-InvoicesPanel-module-puz4gG-label", fz = "hyperdashboard-InvoicesPanel-module-puz4gG-panel", hz = "hyperdashboard-InvoicesPanel-module-puz4gG-statusChipPaid", mz = "hyperdashboard-InvoicesPanel-module-puz4gG-statusChipPastDue", pz = "hyperdashboard-InvoicesPanel-module-puz4gG-statusChipUnpaid", gz = "hyperdashboard-InvoicesPanel-module-puz4gG-table", vz = "hyperdashboard-InvoicesPanel-module-puz4gG-totalCharges", yz = "hyperdashboard-InvoicesPanel-module-puz4gG-totalChargesUnpaid", bz = "hyperdashboard-InvoicesPanel-module-puz4gG-value", pt = {
  actions: iz,
  actionsWrapper: az,
  contents: sz,
  due: oz,
  duePaid: lz,
  duePastDue: cz,
  header: uz,
  label: dz,
  panel: fz,
  statusChipPaid: hz,
  statusChipPastDue: mz,
  statusChipUnpaid: pz,
  table: gz,
  totalCharges: vz,
  totalChargesUnpaid: yz,
  value: bz
}, Sz = 12, wz = ({ legacyInvoices: e }) => {
  const t = Ne(), {
    invoices: r,
    isLoading: n,
    isValidating: i,
    error: a,
    loadMore: s,
    end: o,
    isLoadingMore: c,
    isRefreshing: u,
    isEmpty: f
  } = i0({
    organizationId: t,
    pageSize: Sz
  }), {
    billingAccount: { paymentTerm: g },
    isLoading: p,
    error: d
  } = ez(t), h = n && !f || p, v = a || d, b = rz({ orgId: t }), [m, S] = Z(/* @__PURE__ */ new Set()), I = $(
    async (T) => {
      if (T) {
        S((E) => /* @__PURE__ */ new Set([...E, T]));
        try {
          const E = await b(T);
          E && nz({ blob: E, filename: `${T}.pdf` });
        } catch (E) {
          console.error("Error downloading invoice:", E);
        } finally {
          S((E) => {
            const N = new Set(E);
            return N.delete(T), N;
          });
        }
      }
    },
    [b]
  ), C = V(() => {
    if (v)
      return /* @__PURE__ */ l(
        fe,
        {
          variant: "error",
          label: "We ran into an issue loading your SIM profile history",
          actions: /* @__PURE__ */ l(
            Y,
            {
              variant: "secondary",
              iconStart: "Sync",
              onClick: () => {
                window.location.reload();
              },
              children: "Reload page"
            }
          ),
          children: "We will keep trying in the background or you can try to reload the page."
        }
      );
    if (h)
      return /* @__PURE__ */ l(fe, { children: "Loading..." });
    if (f)
      return /* @__PURE__ */ l(fe, { icon: "Receipt", label: "No invoices available", children: " " });
    const T = [
      { children: "Invoice", key: "invoice" },
      { children: "Total charges", key: "total-charges" },
      { children: "Status", key: "status" },
      { children: "Due date", key: "due-date" },
      { children: "Actions", key: "actions", className: pt.actions }
    ];
    let E = 0, N = 0;
    const y = r.map((w) => {
      if (!w || !w.id || !w.invoiceDate)
        return null;
      let P = !0;
      w.totalCharges && w.status !== "PAID" && (w.totalCharges ?? 0) > 0 && (E += w.totalCharges, N += 1, P = !1);
      const _ = new Array(5), D = `${w.id}`;
      _[0] = {
        key: `${D}-invoice`,
        className: pt.invoice,
        children: /* @__PURE__ */ l(Ae, { onClick: () => I(w.id), children: ve.fromFormat(w.invoiceDate, "yyyy-MM-dd").toFormat("MMMM yyyy") })
      }, _[1] = {
        key: `${D}-total-charges`,
        className: J(pt.totalCharges, !P && pt.totalChargesUnpaid),
        children: tt(w.totalCharges)
      };
      let R;
      switch (w.status) {
        case "PAID":
          R = /* @__PURE__ */ l(
            en,
            {
              type: "informational",
              size: "medium",
              className: J(pt.statusChip, pt.statusChipPaid),
              iconStart: /* @__PURE__ */ l(ye, { name: "CircleCheckmark", fill: "DdsColorFillNotificationSuccess", size: "small" }),
              children: "Paid"
            }
          );
          break;
        case "PAST_DUE":
          R = /* @__PURE__ */ l(
            en,
            {
              type: "informational",
              size: "medium",
              className: J(pt.statusChip, pt.statusChipPastDue),
              iconStart: /* @__PURE__ */ l(ye, { name: "CircleAlert", fill: "DdsColorFillNotificationError", size: "small" }),
              children: "Past due"
            }
          );
          break;
        case "UNPAID":
          R = /* @__PURE__ */ l(
            en,
            {
              type: "informational",
              size: "medium",
              className: J(pt.statusChip, pt.statusChipUnpaid),
              iconStart: /* @__PURE__ */ l(ye, { name: "Warning", fill: "DdsColorPaletteOrange60", size: "small" }),
              children: "Unpaid"
            }
          );
          break;
        default:
          R = void 0;
          break;
      }
      return _[2] = {
        key: `${D}-status`,
        children: R
      }, _[3] = {
        key: `${D}-due-date`,
        children: w.paidDate ? /* @__PURE__ */ O("span", { className: pt.duePaid, children: [
          "Paid ",
          w.paidDate
        ] }) : /* @__PURE__ */ l("span", { className: w.status === "PAST_DUE" ? pt.duePastDue : pt.due, children: w.dueDate })
      }, _[4] = {
        key: `${D}-actions`,
        className: pt.actions,
        children: /* @__PURE__ */ O("div", { className: pt.actionsWrapper, children: [
          !P && w.paymentLink && /* @__PURE__ */ l(
            Y,
            {
              variant: "primary",
              iconEnd: "ExternalLink",
              href: w.paymentLink,
              target: "_blank",
              rel: "noreferrer",
              children: "Pay invoice"
            },
            "pay-invoice"
          ),
          /* @__PURE__ */ l(
            Y,
            {
              variant: "secondary",
              onClick: () => I(w.id),
              loading: m.has(w.id),
              children: "Download PDF"
            },
            "download-invoice"
          )
        ] })
      }, { key: D, cells: _ };
    });
    return /* @__PURE__ */ O("div", { className: pt.contents, children: [
      /* @__PURE__ */ O("div", { className: pt.header, children: [
        /* @__PURE__ */ l(
          ee,
          {
            label: `Total due from ${N} invoices`,
            labelClassName: pt.label,
            value: tt(E),
            valueClassname: pt.value,
            direction: "column"
          }
        ),
        /* @__PURE__ */ l(
          ee,
          {
            label: "Payment terms",
            labelClassName: pt.label,
            value: g,
            valueClassname: pt.value,
            direction: "column"
          }
        )
      ] }),
      /* @__PURE__ */ l(
        ei,
        {
          headers: T,
          rows: y.filter((w) => !!w),
          wrapperClassName: pt.table
        }
      )
    ] });
  }, [
    m,
    v,
    I,
    r,
    f,
    h,
    g
  ]);
  return /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(
      He,
      {
        header: "Invoices",
        noContentPadding: !0,
        isLoading: h || i || c || u,
        className: pt.panel,
        footerActions: o ? void 0 : /* @__PURE__ */ l(Y, { onClick: s, variant: "secondary", loading: c, children: "Load older invoices" }),
        children: C
      }
    ),
    (o || f) && e
  ] });
}, Iz = "hyperdashboard-Invoices-module-pinqua-wrapper", Cz = {
  wrapper: Iz
}, Pz = ({ legacyInvoices: e, className: t }) => /* @__PURE__ */ l("div", { className: J(Cz.wrapper, t), children: /* @__PURE__ */ l(wz, { legacyInvoices: e }) }), Tz = "hyperdashboard-Settings-module-lcxaoq-wrapper", _z = {
  wrapper: Tz
}, Ez = ({
  updateBillingAddress: e,
  billingAddress: t,
  isBillingAddressSet: r,
  className: n
}) => {
  const { permissions: i } = Be(), a = i?.includes(vt.BILLING) ?? !1, s = i?.includes(vt.BILLING_VISIBLE) ?? !1;
  return /* @__PURE__ */ l("div", { className: J(_z.wrapper, n), children: s && /* @__PURE__ */ l(
    XF,
    {
      updateBillingAddress: e,
      existingAddress: t,
      hasAddress: r,
      readOnly: !a
    }
  ) });
}, Oz = "hyperdashboard-Account-module-b3o8CW-divider", Nz = "hyperdashboard-Account-module-b3o8CW-header", Dz = "hyperdashboard-Account-module-b3o8CW-headerWrapper", Rz = "hyperdashboard-Account-module-b3o8CW-loader", kz = "hyperdashboard-Account-module-b3o8CW-viewContent", Az = "hyperdashboard-Account-module-b3o8CW-wrapper", Ci = {
  divider: Oz,
  header: Nz,
  headerWrapper: Dz,
  loader: Rz,
  viewContent: kz,
  wrapper: Az
}, s4 = ({
  className: e,
  viewKey: t,
  onNavigate: r,
  billingBaseUrl: n,
  legacyInvoices: i,
  updateBillingAddress: a,
  billingAddress: s,
  isBillingAddressSet: o
}) => {
  const c = Ne(), { isLoading: u, error: f } = i0({ organizationId: c }), g = ii({ baseUrl: n, orgId: c }), p = $(
    (h) => {
      r(h === "invoices" ? g ?? "" : `${g}/${h}`);
    },
    [r, g]
  ), d = V(() => u ? /* @__PURE__ */ l(ur, { className: Ci.loader, children: "Loading account details..." }) : f ? /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We weren’t able to load account details",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "You can try reloading the page."
    }
  ) : /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ O("div", { className: Ci.headerWrapper, children: [
      /* @__PURE__ */ l("div", { className: Ci.header, children: "Billing account" }),
      /* @__PURE__ */ l("hr", { className: Ci.divider }),
      /* @__PURE__ */ l("div", { className: $t.tabWrapper, children: Object.entries(YN).filter(
        () => (
          // TODO: Refactor to use a map of views to roles/feature flags (AI suggested this, I kind of like it)
          !0
        )
      ).map(([h, v]) => /* @__PURE__ */ l(
        _s,
        {
          id: `simdetails-tab-${h}`,
          selected: h === t,
          onClick: () => p(h),
          children: v
        },
        h
      )) })
    ] }),
    /* @__PURE__ */ l("div", { className: $t.viewsWrapper, children: /* @__PURE__ */ O("div", { className: Ci.viewContent, children: [
      t === "invoices" && /* @__PURE__ */ l(Pz, { legacyInvoices: i }),
      t === "settings" && /* @__PURE__ */ l(
        Ez,
        {
          billingAddress: s,
          updateBillingAddress: a,
          isBillingAddressSet: o
        }
      )
    ] }) })
  ] }), [
    u,
    f,
    t,
    i,
    s,
    a,
    o,
    p
  ]);
  return /* @__PURE__ */ l("div", { className: J($t.pageWrapper, Ci.wrapper, e), children: d });
}, xz = { webp: "/assets/img/pre-deployment.webp 1000w", avif: "/assets/img/pre-deployment.avif 1000w" }, Fz = { src: "/assets/img/pre-deployment.png", w: 1e3, h: 1e3 }, $z = { sources: xz, img: Fz }, Mz = "hyperdashboard-LandingEmpty-module-qzTK5a-actions", Lz = "hyperdashboard-LandingEmpty-module-qzTK5a-activate", jz = "hyperdashboard-LandingEmpty-module-qzTK5a-description", Wz = "hyperdashboard-LandingEmpty-module-qzTK5a-educationPanelContents", Uz = "hyperdashboard-LandingEmpty-module-qzTK5a-educationPanelContentsRight", Vz = "hyperdashboard-LandingEmpty-module-qzTK5a-educationPanelContentsWrapper", Hz = "hyperdashboard-LandingEmpty-module-qzTK5a-errorBanner", qz = "hyperdashboard-LandingEmpty-module-qzTK5a-errorCalloutShake", zz = "hyperdashboard-LandingEmpty-module-qzTK5a-headerContents", Bz = "hyperdashboard-LandingEmpty-module-qzTK5a-order", Gz = "hyperdashboard-LandingEmpty-module-qzTK5a-panelContents", Qz = "hyperdashboard-LandingEmpty-module-qzTK5a-start", Zz = "hyperdashboard-LandingEmpty-module-qzTK5a-title", Yz = "hyperdashboard-LandingEmpty-module-qzTK5a-tools", Kz = "hyperdashboard-LandingEmpty-module-qzTK5a-wrapper", At = {
  actions: Mz,
  activate: Lz,
  description: jz,
  educationPanelContents: Wz,
  educationPanelContentsRight: Uz,
  educationPanelContentsWrapper: Vz,
  errorBanner: Hz,
  errorCalloutShake: qz,
  headerContents: zz,
  order: Bz,
  panelContents: Gz,
  start: Qz,
  title: Zz,
  tools: Yz,
  wrapper: Kz
}, o4 = ({
  className: e,
  firstName: t,
  hasPredeploymentTesting: r = !1,
  onActivate: n,
  canActivate: i,
  canActivateErrorMessage: a,
  isManaged: s = !1,
  orgId: o,
  orgName: c,
  onButtonClick: u
}) => {
  const [f, g] = Z(!1), p = we(null), d = $(() => {
    f && g(!1);
  }, [f]);
  Vi(d, 250);
  const h = $(() => {
    if (!i) {
      p.current && (p.current.focus({ preventScroll: !1, focusVisible: !0 }), g(!0));
      return;
    }
    n();
  }, [i, n]), v = V(() => r ? /* @__PURE__ */ l(He, { className: At.start, header: "You’re set up with pre-deployment testing", children: /* @__PURE__ */ O("div", { className: At.educationPanelContentsWrapper, children: [
    /* @__PURE__ */ O("div", { className: At.educationPanelContents, children: [
      /* @__PURE__ */ l("p", { children: "Pre-deployment testing automates your activation workflows." }),
      /* @__PURE__ */ l("p", { children: "Connectivity and billing enable automatically once your SIM uses data, whether that’s at your end customer or your manufacturer. Once a SIM reaches the end of its testing period, uses 100 KB of data, or sends 10 outbound SMS messages, it will automatically activate." }),
      /* @__PURE__ */ l("p", { children: "Once your first SIMs are set up, you can view them here in your dashboard." }),
      /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "StatusTesting",
          onClick: () => u(
            "Learn more about pre-deployment testing",
            "https://support.hologram.io/hc/en-us/articles/360035696873-Pre-deployment-testing-with-Preflight"
          ),
          children: "Learn more about pre-deployment testing"
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: At.educationPanelContentsRight, children: /* @__PURE__ */ l(fh, { image: $z, setDimensions: !1, alt: "" }) })
  ] }) }) : s ? null : /* @__PURE__ */ l(
    He,
    {
      className: At.start,
      header: "Get a free Hologram SIM",
      footer: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Chat",
          onClick: () => u("Contact sales", "https://www.hologram.io/contact-sales/"),
          children: "Contact sales"
        }
      ),
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            iconStart: "Cart",
            onClick: () => u("Hologram Store", "https://store.hologram.io/"),
            children: "Hologram Store"
          }
        ),
        /* @__PURE__ */ l(
          Y,
          {
            iconStart: "SIM",
            onClick: () => u("Get a free SIM", "https://store.hologram.io/discount/freepilotsim"),
            children: "Get a free SIM"
          }
        )
      ] }),
      children: /* @__PURE__ */ O("div", { className: At.educationPanelContents, children: [
        /* @__PURE__ */ l("p", { children: "Get online this week — we’ll send you a free SIM card to get started! If you’re ready to test with a larger deployment, grab our 100 SIM pack." }),
        /* @__PURE__ */ l("p", { children: "No matter how you start, we’re here every step of the way." })
      ] })
    }
  ), [r, s, u]), b = V(() => {
    const m = encodeURIComponent(`New SIM order - ${c} (${o})`);
    return s ? `mailto:support@hologram.io?subject=${m}` : "https://store.hologram.io/";
  }, [s, o, c]);
  return /* @__PURE__ */ l(
    "div",
    {
      className: J(
        $t.pageWrapper,
        $t.pageWrapperScrollable,
        At.wrapper,
        e
      ),
      children: /* @__PURE__ */ l(
        As,
        {
          headerContents: /* @__PURE__ */ O("div", { className: At.headerContents, children: [
            /* @__PURE__ */ l("h1", { className: At.title, children: t ? `Welcome to Hologram, ${t}` : "Welcome to Hologram!" }),
            /* @__PURE__ */ l("p", { className: At.description, children: "You’re ready to get connected with a free Hologram SIM card — or activate a SIM you already have. Check out the resources below for additional reference." }),
            /* @__PURE__ */ l("div", { className: At.actions, children: /* @__PURE__ */ l(Y, { onClick: h, iconStart: "Lightning", children: "Activate your first SIM" }) })
          ] }),
          children: /* @__PURE__ */ O("div", { className: At.panelContents, children: [
            !i && /* @__PURE__ */ l("div", { className: At.errorBanner, children: /* @__PURE__ */ l(
              ze,
              {
                ref: p,
                className: J(f && At.errorCalloutShake),
                variant: "invalid",
                children: a
              }
            ) }),
            /* @__PURE__ */ l("div", { className: At.order, children: /* @__PURE__ */ l(
              Qm,
              {
                variant: s ? "form" : "link",
                descriptiveIcon: "Cart",
                descriptiveIconFill: "DdsColorPaletteTeal40",
                descriptiveIconHoverFill: "DdsColorPaletteTeal30",
                backgroundGradient: "default",
                descriptivePicture: "hyper",
                onClick: () => u("Order a Hologram SIM", b),
                children: "Order a Hologram SIM"
              }
            ) }),
            /* @__PURE__ */ l("div", { className: At.activate, children: /* @__PURE__ */ l(
              Qm,
              {
                descriptiveIcon: "Lightning",
                descriptiveIconFill: "DdsColorPaletteTeal40",
                descriptiveIconHoverFill: "DdsColorPaletteTeal30",
                backgroundGradient: "b",
                descriptivePicture: "sim",
                onClick: h,
                children: "Activate a Hologram SIM"
              }
            ) }),
            v,
            /* @__PURE__ */ l(
              He,
              {
                className: At.tools,
                header: "Tools and guides for developers",
                footerActions: /* @__PURE__ */ O(le, { children: [
                  /* @__PURE__ */ l(
                    Y,
                    {
                      variant: "secondary",
                      onClick: () => u("Explore the community", "https://community.hologram.io/"),
                      children: "Explore the community"
                    }
                  ),
                  /* @__PURE__ */ l(
                    Y,
                    {
                      variant: "secondary",
                      onClick: () => u(
                        "Read FAQs",
                        "https://support.hologram.io/hc/en-us/sections/360005468613-Frequently-Asked-Questions"
                      ),
                      children: "Read FAQs"
                    }
                  ),
                  /* @__PURE__ */ l(
                    Y,
                    {
                      variant: "secondary",
                      iconStart: "BookOpen",
                      onClick: () => u(
                        "Review our documentation",
                        "https://support.hologram.io/hc/en-us"
                      ),
                      children: "Review our documentation"
                    }
                  )
                ] }),
                children: /* @__PURE__ */ l("div", { className: At.educationPanelContents, children: /* @__PURE__ */ l("p", { children: "Learn more about connecting your devices and our REST API and SDKs." }) })
              }
            )
          ] })
        }
      )
    }
  );
}, Jz = "hyperdashboard-Login-module-k4-AOG-detailsWrapper", Xz = "hyperdashboard-Login-module-k4-AOG-wrapper", Db = {
  detailsWrapper: Jz,
  wrapper: Xz
}, eB = () => {
  const [e, t] = Z(!1), { login: r, loggingIn: n, loginError: i } = pl(), {
    formState: { errors: a, isSubmitting: s },
    handleSubmit: o,
    register: c,
    setFocus: u
  } = Lt();
  Pe(() => {
    n || u("email");
  }, [n, u]);
  const f = () => {
    t((p) => !p);
  }, g = (p) => {
    r(p.email, p.password, p.rememberme);
  };
  return n ? /* @__PURE__ */ l(le, { children: "Signing in..." }) : /* @__PURE__ */ O(
    Gr,
    {
      onSubmit: o(g),
      footerActions: /* @__PURE__ */ l(le, { children: /* @__PURE__ */ l(Y, { type: "submit", name: "Log in", loading: n || s, children: "Log in" }) }),
      children: [
        /* @__PURE__ */ l("div", { "aria-live": "assertive", children: i && /* @__PURE__ */ O(tn, { variant: "error", className: "LoginForm__Error", children: [
          "An error ocurred logging in: ",
          i
        ] }) }),
        /* @__PURE__ */ l(
          pn,
          {
            label: "Email",
            type: "email",
            invalid: !!a.email,
            validationMessage: a.email?.message,
            ...c("email", {
              required: "An email address is required."
              //   validate: {
              //     validEmail: (v) => isValidEmailValidator(v) || 'Please enter a valid email address.',
              //   },
            }),
            autocomplete: "username"
          }
        ),
        /* @__PURE__ */ O("div", { className: "password-input-with-mask-toggle", children: [
          /* @__PURE__ */ l(
            pn,
            {
              label: "Password",
              type: e ? "text" : "password",
              invalid: !!a.password,
              validationMessage: a.password?.message,
              ...c("password", {
                required: "A password is required."
              }),
              autocomplete: "current-password"
            }
          ),
          /* @__PURE__ */ l(
            Y,
            {
              "aria-live": "polite",
              className: "password-input-with-mask-toggle__button",
              onClick: f,
              variant: "tertiary",
              iconStart: /* @__PURE__ */ l(
                ye,
                {
                  className: "PasswordEye",
                  size: "medium",
                  name: e ? "Visible" : "Invisible"
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ l(
          qa,
          {
            label: "Stay logged in?",
            hiddenLabel: !0,
            options: [{ label: "Keep me logged in" }],
            ...c("rememberme")
          }
        )
      ]
    }
  );
}, To = {
  codeBlank: "Please enter the code sent to your email.",
  codeLength: "The code should be six characters long.",
  codeNumeric: "The code should only contain numbers (0-9)."
}, tB = () => {
  const [e, t] = Z("idle");
  return /* @__PURE__ */ O(le, { children: [
    e === "sent" && /* @__PURE__ */ O("p", { children: [
      "Still having trouble with your code?",
      " ",
      /* @__PURE__ */ l(
        Ae,
        {
          href: "https://support.hologram.io/hc/en-us/requests/new",
          target: "_blank",
          rel: "noreferrer",
          type: "inline",
          children: "Contact support"
        }
      )
    ] }),
    e === "sending" && /* @__PURE__ */ l("p", { children: "Sending…" }),
    e === "idle" && /* @__PURE__ */ O("p", { className: "login--footer", children: [
      "Didn't receive a code?",
      " ",
      /* @__PURE__ */ l(Y, { variant: "tertiary", onClick: async () => {
        t("sending"), t("sent");
      }, children: "Send new code" })
    ] })
  ] });
}, rB = () => {
  const { loginTotp: e, loggingIn: t, loginResult: r, loginTotpError: n } = pl(), i = r?.email, {
    formState: { errors: a },
    handleSubmit: s,
    register: o,
    setFocus: c
  } = Lt();
  Pe(() => {
    i && c("passcode");
  }, [i, c]);
  const u = V(() => {
    if (!i)
      return "";
    const g = i.indexOf("@"), p = i.slice(g), d = Array(i.slice(0, g - 1).length).fill("*").join("");
    return `${i[0]}${d}${p}`;
  }, [i]);
  return /* @__PURE__ */ O(He, { header: "Verify it's you", footerActions: /* @__PURE__ */ l(tB, {}), children: [
    i && /* @__PURE__ */ O(le, { children: [
      /* @__PURE__ */ O("p", { children: [
        "To complete your login, enter the 6-digit code sent to ",
        /* @__PURE__ */ l("strong", { children: u })
      ] }),
      /* @__PURE__ */ O(
        Gr,
        {
          onSubmit: s((g) => {
            e(g.passcode);
          }),
          footerActions: /* @__PURE__ */ l(Y, { type: "submit", loading: t, name: "Submit", children: "Submit" }),
          children: [
            n && /* @__PURE__ */ l(tn, { variant: "error", children: n }),
            /* @__PURE__ */ l(
              pn,
              {
                className: "MFA_Login_Modal_input",
                type: "tel",
                id: "form-input-passcode",
                pattern: "[0-9]{6}",
                label: "Verification code",
                placeholder: "123456",
                invalid: !!a.passcode,
                validationMessage: a.passcode?.message?.toString(),
                inputMode: "numeric",
                autocomplete: "off",
                inputProps: { maxLength: 6, "data-1p-ignore": !0, "data-lpignore": !0 },
                ...o("passcode", {
                  required: To.codeBlank,
                  pattern: {
                    value: /^\d\d\d\d\d\d$/,
                    message: To.codeNumeric
                  },
                  maxLength: {
                    value: 6,
                    message: To.codeLength
                  },
                  minLength: {
                    value: 6,
                    message: To.codeLength
                  }
                })
              }
            )
          ]
        }
      )
    ] }),
    !i && /* @__PURE__ */ O("p", { children: [
      "Please contact ",
      /* @__PURE__ */ l("a", { href: "mailto:support@hologram.io", children: "support@hologram.io" }),
      " for help."
    ] })
  ] });
}, l4 = () => {
  const [e, t] = Z(!1), r = $(() => {
    t((m) => !m);
  }, []), {
    isAuthenticated: n,
    user: i,
    logout: a,
    loggingOut: s,
    logoutError: o,
    loggingIn: c,
    showMfaModal: u,
    loginTotpError: f
  } = pl(), { isSuperAdmin: g, organizationRoleLabel: p, invalidOrg: d, selectedOrganization: h, releaseFlags: v } = Be();
  let b;
  return o ? b = /* @__PURE__ */ l(He, { header: "Login", children: /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue logging out",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We have been notified. Refresh to ensure the logout succeeded."
    }
  ) }) : s ? b = /* @__PURE__ */ l(He, { header: "Login", children: /* @__PURE__ */ l(fe, { children: "Logging out..." }) }) : u || f ? b = /* @__PURE__ */ l(rB, {}) : n ? b = /* @__PURE__ */ O(
    He,
    {
      header: "Logged in",
      footerActions: /* @__PURE__ */ l(Y, { onClick: a, variant: "secondary", children: "Logout" }),
      children: [
        /* @__PURE__ */ l(ze, { variant: "success", children: "You're logged in!" }),
        /* @__PURE__ */ l("br", {}),
        /* @__PURE__ */ O("p", { children: [
          "Welcome back, ",
          i.first,
          " ",
          i.last,
          "! You're logged in as",
          " ",
          /* @__PURE__ */ O("strong", { children: [
            i.email,
            " (",
            i.id,
            ")"
          ] }),
          "."
        ] }),
        /* @__PURE__ */ l("br", {}),
        d ? /* @__PURE__ */ l(tn, { children: "Invalid organization selected for this user. Some forms may not work" }) : /* @__PURE__ */ O("div", { className: Db.detailsWrapper, children: [
          /* @__PURE__ */ O("p", { children: [
            "You're role in",
            " ",
            /* @__PURE__ */ O("strong", { children: [
              h?.name ?? "UNKNOWN",
              " (",
              h?.id ?? "-1",
              ")"
            ] }),
            " ",
            "is ",
            p?.article ?? "an",
            " ",
            /* @__PURE__ */ l("strong", { children: p?.label ?? "unknown" }),
            "."
          ] }),
          g && /* @__PURE__ */ l(tn, { variant: "note", children: "You have super admin powers enabled for your account. Use them wisely!" }),
          /* @__PURE__ */ O("div", { children: [
            /* @__PURE__ */ l(
              Y,
              {
                onClick: r,
                variant: e ? "secondary" : "primary",
                children: `Release flags (${v.size})`
              }
            ),
            e && [...v.values()].sort(Ui).map((m) => /* @__PURE__ */ l("p", { children: m }, m))
          ] })
        ] })
      ]
    }
  ) : b = /* @__PURE__ */ l(He, { header: "Login", isLoading: c, children: /* @__PURE__ */ l(eB, {}) }), /* @__PURE__ */ l("div", { className: Db.wrapper, children: b });
}, nB = "hyperdashboard-SimCoveragePanelHeader-module-p6sdBq-diminished", iB = "hyperdashboard-SimCoveragePanelHeader-module-p6sdBq-fields", aB = "hyperdashboard-SimCoveragePanelHeader-module-p6sdBq-fieldValue", sB = "hyperdashboard-SimCoveragePanelHeader-module-p6sdBq-profiles", oB = "hyperdashboard-SimCoveragePanelHeader-module-p6sdBq-profilesLoading", Ur = {
  diminished: nB,
  fields: iB,
  fieldValue: aB,
  profiles: sB,
  profilesLoading: oB
}, lB = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    isLoading: r,
    error: n
  } = Le(e), {
    simProfiles: i,
    isLoading: a,
    error: s
  } = kr(e), {
    deviceDetails: o,
    isLoading: c,
    error: u
  } = Mt(e), { isSuperAdmin: f } = Be(), g = Ne(), { deviceIdsWithOpenSessions: p } = Wn(
    g,
    f || !!g
  ), { networkStatusGroups: d } = ht(), h = V(() => o.claimedDeviceId && p.has(o.claimedDeviceId) && !d?.deactivated?.includes(t.networkStatus) ? d?.predeployment?.includes(t.networkStatus) ? "TEST-CONNECTED" : "CONNECTED" : t.networkStatus, [
    o.claimedDeviceId,
    p,
    t.networkStatus,
    d?.predeployment,
    d?.deactivated
  ]), {
    statusInfo: v,
    isLoading: b,
    error: m
  } = $s(h), S = r || a || b || c, I = n || s || m || u;
  return S ? /* @__PURE__ */ l("span", { className: wt(Ur.diminished, Ur.profilesLoading), children: "Loading…" }) : I ? "—" : /* @__PURE__ */ l("div", { className: Ur.profiles, children: i.map((C, T) => {
    const E = C.installationState === "ENABLED";
    let N;
    return E ? N = v.icon : t.fallbackEnabled && t.fallbackInstalled && (N = "Shield"), /* @__PURE__ */ O(Ha, { children: [
      /* @__PURE__ */ l(
        en,
        {
          size: "medium",
          colorVariant: C.installationState === "ENABLED" ? v?.colorVariant : void 0,
          iconStart: N,
          children: C.profileName
        },
        C.simProfileId
      ),
      T + 1 < i.length && "+"
    ] }, C.iccid);
  }) });
}, cB = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    error: r,
    isLoading: n
  } = Le(e), { simProfiles: i, error: a } = kr(e), s = ni({ simProfiles: i }), { data: o, error: c, isLoading: u } = Rl(s), {
    billingRates: f,
    error: g,
    isLoading: p
  } = na(t.organizationId), {
    simBilling: d,
    error: h,
    isLoading: v
  } = Ir(e), b = V(
    () => r0(f, o, d.dataRate ?? d.overageCharge),
    [f, o, d]
  ), m = V(() => b.isFlatRate ? d.overageCharge ? "Overage per MB" : "Per MB rate" : "Per MB rates", [b.isFlatRate, d.overageCharge]), S = V(() => p || u || n || v ? /* @__PURE__ */ l("span", { className: Ur.diminished, children: "Loading…" }) : g || c || h ? /* @__PURE__ */ O("span", { className: Ur.diminished, children: [
    /* @__PURE__ */ l(ye, { name: "Warning", size: "small", fill: "DdsColorFillNotificationError" }),
    " Unable to load"
  ] }) : b.isFlatRate ? `${tt(b.rateMin)}` : `${tt(b.rateMin)} – ${tt(b.rateMax)}`, [
    p,
    u,
    n,
    v,
    g,
    c,
    h,
    b.isFlatRate,
    b.rateMin,
    b.rateMax
  ]);
  return c || a || g || r || h ? null : /* @__PURE__ */ O("div", { className: Ur.fields, children: [
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: "Networks",
        value: u ? /* @__PURE__ */ l("span", { className: Ur.diminished, children: "Loading…" }) : o?.networks,
        valueClassname: Ur.fieldValue
      }
    ),
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: "Countries",
        value: u ? /* @__PURE__ */ l("span", { className: Ur.diminished, children: "Loading…" }) : o?.countries,
        valueClassname: Ur.fieldValue
      }
    ),
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: m,
        value: S,
        valueClassname: Ur.fieldValue
      }
    ),
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: "Available profiles",
        value: /* @__PURE__ */ l(lB, { hologramSimId: e })
      }
    )
  ] });
}, uB = "hyperdashboard-SimCoveragePanel-module-vYKqlG-coverageWrapper", dB = "hyperdashboard-SimCoveragePanel-module-vYKqlG-exportDropdown", fB = "hyperdashboard-SimCoveragePanel-module-vYKqlG-footerLink", Vd = {
  coverageWrapper: uB,
  exportDropdown: dB,
  footerLink: fB
}, hB = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    isLoading: r,
    error: n
  } = Le(e), {
    simProfiles: i,
    isLoading: a,
    error: s
  } = kr(e), {
    simBilling: o,
    error: c,
    isLoading: u
  } = Ir(e), {
    billingRates: f,
    isLoading: g,
    error: p
  } = na(t.organizationId), {
    networkStatusGroups: d,
    isLoading: h,
    error: v
  } = ht(), b = r || a || g || u || h, m = n || s || c || v, { sendAnalyticsEvent: S, sendAnalyticsError: I } = mt(), C = ni({ simProfiles: i }), T = ia({ simProfiles: i }), [E, N] = Z(!1), [y, w] = Z(!1), P = $(() => {
    w((x) => !x);
  }, []), _ = el(), D = async (x) => {
    N(!0), P();
    try {
      return await (await Xh({
        filters: C,
        profiles: T,
        hologramSimId: e,
        billingRates: f,
        simBilling: o,
        onSuccess: (W) => {
          S && S("Network Coverage - Export Networks - Export Networks success", {
            exportType: ea(W)
          });
        },
        onError: (W) => {
          I && I("Export Network Coverage error", W);
        }
      }))(x), N(!1);
    } catch {
      return N(!1), !1;
    }
  }, R = "Network coverage and rates";
  return e ? r ? /* @__PURE__ */ l(He, { header: R, isLoading: b, children: /* @__PURE__ */ l(fe, { children: "Loading coverage information..." }) }) : m || !t.hologramSimId ? /* @__PURE__ */ l(He, { header: R, isLoading: b, children: /* @__PURE__ */ l(
    fe,
    {
      label: "No coverage information found",
      variant: "error",
      actions: /* @__PURE__ */ l(
        Y,
        {
          type: "button",
          variant: "secondary",
          iconEnd: "ExternalLink",
          href: Nh,
          target: "_blank",
          children: "Contact support"
        }
      ),
      children: "We could not retrieve network coverage information for this SIM. If this isn’t fixed after reloading this page, please reach out to our support team."
    }
  ) }) : d?.predeployment?.includes(
    t.networkStatus
  ) && !o.planId ? /* @__PURE__ */ l(He, { header: R, isLoading: b, children: /* @__PURE__ */ l(fe, { label: "This SIM does not have a data plan yet", icon: "CircleInfo", children: "Once a data plan has been assigned to this SIM, coverage and rate information will be available here." }) }) : /* @__PURE__ */ O(
    He,
    {
      header: R,
      headerActions: /* @__PURE__ */ l(
        Kn,
        {
          content: [
            {
              label: "Export coverage and rates",
              items: [
                {
                  children: "Export to XLSX (Excel)",
                  iconStart: "DownloadTray",
                  onClick: () => D(gt.XLSX)
                },
                {
                  children: "Export to CSV",
                  iconStart: "DownloadTray",
                  onClick: () => D(gt.CSV)
                }
              ]
            }
          ],
          open: y,
          onOpenChange: w,
          className: Vd.exportDropdown,
          children: /* @__PURE__ */ l(
            Y,
            {
              iconEnd: y ? "ChevronSingleNorth" : "ChevronSingleSouth",
              variant: "secondary",
              onClick: P,
              disabled: !!m || b || !!p,
              id: _,
              loading: E,
              children: "Export"
            }
          )
        }
      ),
      footer: /* @__PURE__ */ O("span", { children: [
        "Networks you can connect to are determined by the enabled profile on your SIM. You can",
        " ",
        /* @__PURE__ */ l("a", { className: Vd.footerLink, href: $w, children: "forbid or prefer networks" }),
        " ",
        "on your SIM using FPLMN/OPLMN terminal commands. Additional fields like TADIG, MCC, MNC, and UNC are available in the file export."
      ] }),
      footerVariant: "alternative",
      noContentPadding: !0,
      isLoading: b,
      children: [
        /* @__PURE__ */ l(cB, { hologramSimId: e }),
        /* @__PURE__ */ l("div", { className: Vd.coverageWrapper, children: /* @__PURE__ */ l(Jh, { hologramSimId: e }) })
      ]
    }
  ) : /* @__PURE__ */ l(He, { header: R, isLoading: b, children: /* @__PURE__ */ l(fe, { label: "No SIM selected", variant: "error", children: "Please select a SIM to view network coverage and rates" }) });
}, mB = ({ deviceId: e, organizationId: t }) => {
  const r = new URLSearchParams({ orgid: `${t}` }), n = e && t ? `${process.env.VITE_API_ROOT}/devices/${e}/addnumber?${r}` : null;
  return $(
    async (a, s = void 0) => n ? await ft({
      url: n,
      body: { areacode: s, country: a },
      throwOnError: !1
    }) : void 0,
    [n]
  );
}, pB = async ({ url: e, body: t }) => ft({ url: e, body: t, throwOnError: !1 }), gB = ({
  organizationId: e,
  deviceId: t,
  country: r,
  areaCode: n
}) => {
  const i = new URLSearchParams({ orgid: `${e}`, preview: "1" }), a = t && e ? `${process.env.VITE_API_ROOT}/devices/${t}/addnumber?${i}` : null, s = a && r ? {
    url: a,
    body: {
      areacode: n,
      country: r
    }
  } : null, { data: o, error: c, isLoading: u, isValidating: f, mutate: g } = je(s, pB);
  return {
    phoneNumberCost: V(
      () => o?.order_data?.total_cost ?? void 0,
      [o]
    ),
    error: c || o?.error,
    isLoading: u,
    isValidating: f,
    mutate: g
  };
}, vB = "hyperdashboard-PurchasePhoneNumber-module-p8YkZG-billingAddress", yB = "hyperdashboard-PurchasePhoneNumber-module-p8YkZG-contents", bB = "hyperdashboard-PurchasePhoneNumber-module-p8YkZG-country", SB = "hyperdashboard-PurchasePhoneNumber-module-p8YkZG-empty", wB = "hyperdashboard-PurchasePhoneNumber-module-p8YkZG-invalid", un = {
  billingAddress: vB,
  contents: yB,
  country: bB,
  empty: SB,
  invalid: wB
}, IB = ({
  hologramSimId: e,
  deviceId: t,
  onConfirmed: r,
  onCancelled: n
}) => {
  const [i, a] = Z(!0), [s, o] = Z(!1), [c, u] = Z(null), [f, g] = Z(null), p = Ne(), { simDetails: d, mutate: h } = Le(e), { device: v, mutate: b } = ti(t, p), { billing: m, isLoading: S, error: I } = DT(p), { balance: C, isLoading: T, error: E } = NT(p), { register: N, watch: y, setValue: w } = Lt({
    mode: "onChange",
    defaultValues: { countryCode: m.billing_address?.country ?? "", areaCode: "" }
  });
  Pe(() => {
    w("countryCode", m.billing_address?.country ?? "");
  }, [m, w]);
  const { areaCode: P, countryCode: _ } = y(), D = $(() => {
    g(P);
  }, [P]);
  Vi(D, 750);
  const {
    phoneNumberCost: R,
    isLoading: x,
    error: F
  } = gB({
    organizationId: p,
    deviceId: t,
    country: S ? void 0 : _,
    areaCode: f ?? void 0
  }), W = S || T, A = I || E, M = mB({ deviceId: t, organizationId: p }), j = $(async () => {
    u(null), o(!0);
    try {
      const te = await M(
        _,
        P ? parseInt(P, 10) : void 0
      ), G = te?.data ?? "", X = te?.order_data?.unit_cost ?? "0.0000";
      te?.success ? (h(
        { simDetails: { ...structuredClone(d), phoneNumber: G } },
        { revalidate: !1 }
        // We WILL revalidate soon, but with DMS latency it might take a few seconds. Let this sit for now
      ), b(
        {
          data: {
            ...structuredClone(v),
            phonenumber: G,
            phonenumber_cost: X
          },
          success: !0
        },
        { revalidate: !1 }
      ), r()) : u(te?.error ?? "An unknown error occurred");
    } catch (te) {
      u(`${te}`);
    }
    o(!1);
  }, [
    P,
    _,
    v,
    b,
    h,
    r,
    M,
    d
  ]), { reverseCountryLookup: B } = iD(), { billingPageUrl: L } = Sn() ?? {}, H = ii({ baseUrl: L ?? "", orgId: p }), q = V(() => W ? /* @__PURE__ */ l(ur, { children: "Checking for phone numbers..." }) : A ? (console.error(`${A}`), /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading the SIM details header",
      children: "Please try again later"
    }
  )) : /* @__PURE__ */ O(Gr, { className: un.contents, children: [
    /* @__PURE__ */ l(mn, { label: "Country", layoutDirection: "row", required: !0, children: ({ ariaDescribedbyIds: te, ariaLabel: G, primaryControlId: X }) => /* @__PURE__ */ l(
      "span",
      {
        id: X,
        "aria-describedby": te,
        "aria-label": G,
        className: un.country,
        children: m.billing_address_set ? B.get(_) : /* @__PURE__ */ l(
          "span",
          {
            className: J(un.empty, !m.billing_address_set && un.invalid),
            children: "—"
          }
        )
      }
    ) }),
    !c && !F && ["US", "CA"].includes(_) && m.billing_address_set && /* @__PURE__ */ l(
      pn,
      {
        label: "Area code",
        layoutDirection: "row",
        optional: !0,
        type: "number",
        ...N("areaCode")
      }
    ),
    /* @__PURE__ */ l(
      mn,
      {
        label: "Billing address",
        layoutDirection: "row",
        required: !0,
        className: un.billingAddress,
        children: ({ ariaDescribedbyIds: te, ariaLabel: G, primaryControlId: X }) => /* @__PURE__ */ l("div", { id: X, "aria-describedby": te, "aria-label": G, children: m.billing_address_set ? /* @__PURE__ */ l(tI, { address: m.billing_address }) : /* @__PURE__ */ l(
          "span",
          {
            className: J(un.empty, !m.billing_address_set && un.invalid),
            children: "—"
          }
        ) })
      }
    ),
    /* @__PURE__ */ l(mn, { label: "Price per month", layoutDirection: "row", children: ({ ariaDescribedbyIds: te, ariaLabel: G, primaryControlId: X }) => /* @__PURE__ */ l(
      "span",
      {
        id: X,
        "aria-describedby": te,
        "aria-label": G,
        children: R ? tt(parseInt(R, 10)) : /* @__PURE__ */ l("span", { className: un.empty, children: "—" })
      }
    ) }),
    C.has_postpay !== 1 && C.balance && /* @__PURE__ */ l(mn, { label: "Account balance", layoutDirection: "row", children: ({ ariaDescribedbyIds: te, ariaLabel: G, primaryControlId: X }) => /* @__PURE__ */ l(
      "div",
      {
        id: X,
        "aria-describedby": te,
        "aria-label": G,
        children: Ee(parseInt(C.balance, 10))
      }
    ) })
  ] }), [
    A,
    C,
    m,
    _,
    c,
    W,
    R,
    F,
    N,
    B
  ]);
  return /* @__PURE__ */ l(
    qt,
    {
      defaultOpen: !0,
      open: i,
      setOpen: a,
      onClosed: n,
      header: "Purchase phone number",
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(Y, { variant: "secondary", onClick: () => a(!1), disabled: s, children: c ? "Close" : "Cancel" }),
        !c && /* @__PURE__ */ l(
          Y,
          {
            onClick: j,
            loading: s,
            disabled: x || !!F,
            children: "Purchase phone number"
          }
        )
      ] }),
      children: /* @__PURE__ */ O("div", { className: un.contents, children: [
        q,
        F && F === "No numbers available for that country" && /* @__PURE__ */ O(ze, { variant: "error", children: [
          "No phone numbers are available for the country associated with your billing address. If your billing address is incorrect, you can change it in",
          " ",
          /* @__PURE__ */ l(Ae, { to: H, ariaLabel: "Billing settings", type: "inline", children: "Billing settings" }),
          ". For help with international numbers, please email",
          " ",
          /* @__PURE__ */ l(Ae, { href: "mailto:support@hologram.io", type: "inline", children: "support@hologram.io" }),
          "."
        ] }),
        !S && !m.billing_address_set && /* @__PURE__ */ l(ze, { variant: "error", children: "A billing address is required to purchase a phone number" }),
        c && !R && /* @__PURE__ */ l(ze, { variant: "error", children: c })
      ] })
    }
  );
}, CB = ({ deviceId: e, organizationId: t }) => {
  const r = new URLSearchParams({ orgid: `${t}` }), n = e && t ? `${process.env.VITE_API_ROOT}/devices/${e}/removenumber?${r}` : null;
  return $(async () => n ? await ft({
    url: n,
    body: {}
  }) : void 0, [n]);
}, PB = "hyperdashboard-RemovePhoneNumber-module-ppy0Dq-contents", TB = {
  contents: PB
}, _B = ({
  hologramSimId: e,
  deviceId: t,
  onConfirmed: r,
  onCancelled: n
}) => {
  const [i, a] = Z(!0), [s, o] = Z(!1), [c, u] = Z(null), f = Ne(), { simDetails: g, mutate: p } = Le(e), { device: d, mutate: h } = ti(t, f), v = CB({ deviceId: t, organizationId: f }), b = $(async () => {
    u(null), o(!0);
    try {
      (await v())?.success && (p(
        { simDetails: { ...structuredClone(g), phoneNumber: void 0 } },
        { revalidate: !1 }
        // We WILL revalidate soon, but with DMS latency it might take a few seconds. Let this sit for now
      ), h({
        data: {
          ...structuredClone(d),
          phonenumber: "",
          phonenumber_cost: "0.0000"
        },
        success: !0
      }), r());
    } catch (m) {
      u(`${m}`);
    }
    o(!1);
  }, [
    d,
    h,
    p,
    r,
    v,
    g
  ]);
  return /* @__PURE__ */ l(
    qt,
    {
      defaultOpen: !0,
      open: i,
      setOpen: a,
      onClosed: n,
      header: "Remove phone number",
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(Y, { variant: "secondary", onClick: () => a(!1), disabled: s, children: "Cancel" }),
        /* @__PURE__ */ l(Y, { variant: "destructive", onClick: b, loading: s, children: "Remove phone number" })
      ] }),
      children: /* @__PURE__ */ O("div", { className: TB.contents, children: [
        "If you remove the phone number for this SIM, the number you were using will be released and you will no longer be charged for the line. Please confirm that you no longer need it to communicate with your device.",
        c && /* @__PURE__ */ l(ze, { variant: "system-error", children: c })
      ] })
    }
  );
}, EB = ({
  hologramSimId: e,
  simDetailBaseUrl: t,
  handleModalOpen: r,
  onSimsModified: n
}) => /* @__PURE__ */ O(le, { children: [
  /* @__PURE__ */ l(MN, { hologramSimId: e, simDetailBaseUrl: t }),
  /* @__PURE__ */ l(
    eE,
    {
      hologramSimId: e,
      handleModalOpen: r,
      onSimsModified: n
    }
  )
] }), a0 = ({ hologramSimId: e }) => {
  const { simBilling: t, isLoading: r, error: n } = Ir(e), { billingPeriodStart: i, billingPeriodEnd: a } = t;
  return { simBillingPeriod: V(() => {
    const o = lr(i)?.toUnixInteger(), c = lr(a)?.toUnixInteger(), u = o ? o * 1e3 : void 0, f = c ? c * 1e3 : void 0;
    return { billingPeriodStartMs: u, billingPeriodEndMs: f };
  }, [a, i]), isLoading: r, error: n };
}, OB = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction"
}), NB = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    isLoading: r,
    error: n
  } = Le(e), {
    simBillingPeriod: i,
    isLoading: a,
    error: s
  } = a0({ hologramSimId: e }), { billingPeriodStartMs: o, billingPeriodEndMs: c } = i, {
    mostRecentSession: u,
    error: f,
    isLoading: g
  } = ks(e), {
    isDeactivatedOldSim: p,
    isLoading: d,
    error: h
  } = Xi({
    hologramSimId: e
  }), {
    simProfiles: v,
    isLoading: b,
    error: m
  } = kr(e), S = r || a || g || d || b, I = n || s || f || h || m, C = !S && !t.simCardId, T = !S && !o && !c, E = V(
    () => new Set(
      v.filter((N) => N.carrierId === 12).map((N) => N.profileName ?? "UNKNOWN")
    ),
    [v]
  );
  return I || C || T ? (C && console.error("SIM Card ID not found"), T && console.error("Billing period not found"), /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading the Device usage report",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "You can reload the page to try again"
    }
  )) : S || !t.simCardId || !o || !c ? /* @__PURE__ */ l(ur, {}) : u.sessionId ? /* @__PURE__ */ O(le, { children: [
    E.size > 0 && /* @__PURE__ */ O(ze, { variant: "caution", children: [
      "The carrier for the ",
      OB.format([...E.values()]),
      " ",
      E.size === 1 ? "profile" : "profiles",
      " on your SIM",
      " ",
      E.size === 1 ? "does" : "do",
      " not provide location data."
    ] }),
    /* @__PURE__ */ l(
      an,
      {
        reportId: 248,
        simCardId: t.simCardId,
        billingPeriodStart: o,
        billingPeriodEnd: c
      }
    )
  ] }) : p ? /* @__PURE__ */ l(fe, { icon: "CircleAlert", label: "No data usage available for this SIM", children: "This SIM may have never connected and used data, or the usage data may be older than we store for deactivated SIMs." }) : /* @__PURE__ */ l(fe, { icon: "CircleAlert", label: "This SIM hasn’t connected yet", children: "This SIM is activated and able to connect to the Hologram network, but has not yet connected to a local tower or passed data." });
}, DB = "hyperdashboard-SimAddonsPanel-module-UdFT9W-column", RB = "hyperdashboard-SimAddonsPanel-module-UdFT9W-columnAction", kB = "hyperdashboard-SimAddonsPanel-module-UdFT9W-columnName", AB = "hyperdashboard-SimAddonsPanel-module-UdFT9W-diminished", Ta = {
  column: DB,
  columnAction: RB,
  columnName: kB,
  diminished: AB
}, xB = ({
  hologramSimId: e,
  orgId: t,
  openPurchasePhoneNumberModal: r,
  openRemovePhoneNumberModal: n
}) => {
  const {
    simDetails: i,
    error: a,
    isLoading: s,
    isValidating: o
  } = Le(e), {
    deviceDetails: c,
    error: u,
    isLoading: f,
    isValidating: g
  } = Mt(e), {
    device: p,
    error: d,
    isLoading: h,
    isValidating: v
  } = ti(c.claimedDeviceId, t), { phoneNumber: b } = i, { phonenumber_cost: m } = p, S = a || u || d, I = s || f || h, C = o || g || v, T = V(() => {
    if (S)
      return /* @__PURE__ */ l(
        fe,
        {
          variant: "error",
          label: "We ran into an issue loading the SIM add-ons",
          actions: /* @__PURE__ */ l(
            Y,
            {
              variant: "secondary",
              iconStart: "Sync",
              onClick: () => {
                window.location.reload();
              },
              children: "Reload page"
            }
          ),
          children: "We will keep trying in the background or you can try to reload the page."
        }
      );
    if (I)
      return /* @__PURE__ */ l(fe, { children: "Loading Add-ons..." });
    const E = [
      {
        key: "name",
        children: "Name",
        width: 220
      },
      {
        key: "details",
        children: "Details"
      },
      {
        key: "cost",
        children: "Cost"
      },
      {
        key: "action",
        children: ""
      }
    ], N = [
      {
        key: "phone",
        cells: [
          {
            key: "phone-name",
            children: "Phone number",
            className: Ta.columnName
          },
          {
            key: "phone-details",
            className: Ta.column,
            children: b || /* @__PURE__ */ l("span", { className: Ta.diminished, children: "No phone number added to this SIM" })
          },
          {
            key: "phone-cost",
            className: Ta.column,
            children: b ? tt(parseFloat(m ?? "0")) : ""
          },
          {
            key: "phone-action",
            children: b ? /* @__PURE__ */ l(Y, { variant: "delete", onClick: n, children: "Remove" }) : /* @__PURE__ */ l(Y, { variant: "secondary", onClick: r, children: "Purchase phone number" }),
            className: Ta.columnAction
          }
        ]
      }
    ];
    return /* @__PURE__ */ l(ei, { headers: E, rows: N });
  }, [
    S,
    I,
    r,
    n,
    b,
    m
  ]);
  return /* @__PURE__ */ l(He, { header: "Add-ons", noContentPadding: !0, isLoading: I || C, children: T });
}, FB = "hyperdashboard-PanelSection-module-tcQQdq-actions", $B = "hyperdashboard-PanelSection-module-tcQQdq-aside", MB = "hyperdashboard-PanelSection-module-tcQQdq-complexWrapper", LB = "hyperdashboard-PanelSection-module-tcQQdq-fieldGroup", jB = "hyperdashboard-PanelSection-module-tcQQdq-fieldGroups", WB = "hyperdashboard-PanelSection-module-tcQQdq-heading", UB = "hyperdashboard-PanelSection-module-tcQQdq-icon", VB = "hyperdashboard-PanelSection-module-tcQQdq-notes", HB = "hyperdashboard-PanelSection-module-tcQQdq-panelSection", qB = "hyperdashboard-PanelSection-module-tcQQdq-simpleWrapper", Er = {
  actions: FB,
  aside: $B,
  complexWrapper: MB,
  fieldGroup: LB,
  fieldGroups: jB,
  heading: WB,
  icon: UB,
  notes: VB,
  panelSection: HB,
  simpleWrapper: qB
}, zB = ({
  heading: e,
  headingIcon: t,
  fieldGroup: r,
  notes: n,
  actions: i
}) => /* @__PURE__ */ O("div", { className: Er.complexWrapper, children: [
  /* @__PURE__ */ O("div", { className: Er.heading, children: [
    t && /* @__PURE__ */ l("div", { className: Er.icon, children: /* @__PURE__ */ l(ye, { name: t, size: "medium", fill: "currentColor" }) }),
    /* @__PURE__ */ l("span", { children: e })
  ] }),
  /* @__PURE__ */ l("div", { className: Er.fieldGroup, children: r }),
  (n || i) && /* @__PURE__ */ O("div", { className: Er.aside, children: [
    n && /* @__PURE__ */ l("div", { className: Er.notes, children: n }),
    i && /* @__PURE__ */ l("div", { className: Er.actions, children: i })
  ] })
] }), BB = ({
  heading: e,
  fieldGroups: t
}) => /* @__PURE__ */ O("div", { className: Er.simpleWrapper, children: [
  e && /* @__PURE__ */ l("div", { className: Er.heading, children: e }),
  /* @__PURE__ */ l("div", { className: Er.fieldGroups, children: t.map((r, n) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ l("div", { className: Er.fieldGroup, children: r }, `field-group-${n}`)
  )) })
] });
function Mi(e) {
  const { variant: t } = e;
  return /* @__PURE__ */ l("div", { className: Er.panelSection, children: t === "complex" ? /* @__PURE__ */ l(zB, { ...e }) : /* @__PURE__ */ l(BB, { ...e }) });
}
const GB = "hyperdashboard-SimPlanPanel-module-HSmiPW-diminished", QB = "hyperdashboard-SimPlanPanel-module-HSmiPW-footer", ZB = "hyperdashboard-SimPlanPanel-module-HSmiPW-hr", YB = "hyperdashboard-SimPlanPanel-module-HSmiPW-numeric", KB = "hyperdashboard-SimPlanPanel-module-HSmiPW-planName", JB = "hyperdashboard-SimPlanPanel-module-HSmiPW-popover", XB = "hyperdashboard-SimPlanPanel-module-HSmiPW-popoverWithTooltip", e2 = "hyperdashboard-SimPlanPanel-module-HSmiPW-predeploymentTotal", t2 = "hyperdashboard-SimPlanPanel-module-HSmiPW-strikethrough", r2 = "hyperdashboard-SimPlanPanel-module-HSmiPW-viewDetailsButton", st = {
  diminished: GB,
  footer: QB,
  hr: ZB,
  numeric: YB,
  planName: KB,
  popover: JB,
  popoverWithTooltip: XB,
  predeploymentTotal: e2,
  strikethrough: t2,
  viewDetailsButton: r2
}, n2 = ({
  hologramSimId: e,
  orgId: t,
  handleModalOpen: r,
  onSimsModified: n,
  simDetailBaseUrl: i,
  dataPlanUrl: a
}) => {
  const {
    simBilling: s,
    error: o,
    isLoading: c,
    isValidating: u
  } = Ir(e), {
    simDetails: f,
    error: g,
    isLoading: p,
    isValidating: d
  } = Le(e), {
    deviceDetails: h,
    error: v,
    isLoading: b,
    isValidating: m
  } = Mt(e), { claimedDeviceId: S } = h, {
    networkStatusGroups: I,
    error: C,
    isLoading: T,
    isValidating: E
  } = ht(), {
    device: N,
    error: y,
    isLoading: w,
    isValidating: P
  } = ti(S, t), {
    planId: _,
    planName: D,
    planType: R,
    planZone: x,
    smsCharge: F,
    smsLimit: W,
    overageCharge: A,
    dataAlertLimit: M,
    dataUsageLimit: j,
    dataIncluded: B,
    poolDataLimit: L,
    simRenewalDate: H,
    platformFee: q,
    dataRate: te,
    hasVariableRates: G,
    zeroDataRate: X,
    hasZeroDataRate: re
  } = s, {
    phoneNumber: oe,
    expectedActivationTime: ue,
    activationTime: de,
    preflightUsage: Q,
    billingPeriodUsage: he
  } = f, ce = de ? he ?? 0 : Q ?? 0, { phonenumber_cost: se } = N, pe = $(() => {
    r({
      modalName: "SetUsageAlertsModal",
      modalProps: {
        sims: /* @__PURE__ */ new Map([[e, S]]),
        onModalSuccess: n
      }
    });
  }, [r, e, S, n]), { networkStatus: k } = f, z = I?.predeployment?.includes(
    k
  ), U = k?.startsWith("FACTORY") || k?.startsWith("INACTIVE"), ie = g || o || v || C || y, ae = c || p || b || T || w, ne = u || d || m || E || P, me = (ce === 0 && re ? X : q ?? 0) + parseFloat(se ?? "0"), Te = R === "Pay as you go", Ce = pw({
    context: "details",
    selectedSims: /* @__PURE__ */ new Map([[e, S]]),
    disabled: !1
  }), { releaseFlags: Re } = Be(), xe = Re.has(Ht.FEATURE_DATA_USAGE_ALERTS), { sendAnalyticsEvent: _e } = mt(), { setDataUsageLimits: $e } = Sn() ?? {}, jt = () => {
    if (!$e)
      throw new Error("Tried to set data usage limit outside of legacy dashboard context.");
    S && $e([S]);
  }, dr = cr({
    simDetailBaseUrl: i,
    orgId: t,
    simId: e,
    subpage: Yn.coverage
  }), Wt = bn({
    url: a,
    replacers: [
      { placeholder: "orgid", value: t?.toString() ?? "" },
      { placeholder: "dataPlanId", value: _?.toString() ?? "" },
      { placeholder: "dataPlanZone", value: x?.toString() ?? "" }
    ]
  }), nt = V(() => G ? /* @__PURE__ */ l(Ae, { to: dr, type: "inline", children: "Varies by network" }) : Te ? /* @__PURE__ */ l(Ae, { to: dr, type: "inline", children: tt(te) }) : tt(A), [G, Te, dr, te, A]), fr = V(() => B ? It(B, "short") : L ? `${It(L, "short")} data pool` : R, [B, L, R]);
  let hr;
  return ie ? hr = /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading the SIM data plan",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : ae ? hr = /* @__PURE__ */ l(fe, { children: "Loading data plan..." }) : U ? hr = /* @__PURE__ */ l(fe, { children: "No data plan has been added to this SIM." }) : hr = /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(
      Mi,
      {
        variant: "simple",
        fieldGroups: [
          /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ee,
              {
                label: "Name",
                value: /* @__PURE__ */ O("div", { className: st.popoverWithTooltip, children: [
                  /* @__PURE__ */ l("span", { className: st.planName, children: D }),
                  /* @__PURE__ */ l(
                    et,
                    {
                      className: st.popover,
                      id: "popover-plan-id",
                      content: /* @__PURE__ */ O("span", { children: [
                        "Data plan ID: ",
                        _,
                        /* @__PURE__ */ l("br", {}),
                        "Zone: ",
                        x
                      ] }),
                      onOpen: () => {
                        _e && _e("Info - Data plan name");
                      },
                      children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
                    }
                  )
                ] })
              }
            ),
            /* @__PURE__ */ l(ee, { label: "Type", value: R })
          ] }),
          /* @__PURE__ */ l("div", { className: st.viewDetailsButton, children: /* @__PURE__ */ l(Y, { to: Wt, variant: "tertiary", iconEnd: "ArrowEastShort", children: "View details" }) })
        ]
      }
    ),
    /* @__PURE__ */ l(
      Mi,
      {
        variant: "simple",
        heading: "Data usage",
        fieldGroups: [
          /* @__PURE__ */ O(le, { children: [
            L && /* @__PURE__ */ l(
              ee,
              {
                label: "Data pool total data",
                value: It(L, "short")
              }
            ),
            /* @__PURE__ */ l(ee, { label: "Included data", value: fr }),
            /* @__PURE__ */ l(
              ee,
              {
                label: Te ? "Per MB" : "Overage per MB",
                value: nt,
                valueClassname: st.numeric
              }
            ),
            xe && (M ?? -1) >= 0 && /* @__PURE__ */ l(
              ee,
              {
                label: "Usage alert",
                value: /* @__PURE__ */ l(Ae, { type: "inline", onClick: pe, children: `Alert at ${It(M, "short")}` })
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                label: "Data limit",
                valueClassname: st.numeric,
                value: /* @__PURE__ */ l(Ae, { type: "inline", onClick: jt, children: j && j > 0 ? `Pause at ${It(j, "short")}` : "No limit" })
              }
            )
          ] }),
          /* @__PURE__ */ O(le, { children: [
            !z && /* @__PURE__ */ l(
              eI,
              {
                hologramSimId: e,
                direction: "row",
                label: "Billing period (UTC)"
              }
            ),
            z && /* @__PURE__ */ l(ee, { label: "Billing period (UTC)" }),
            /* @__PURE__ */ l(
              ee,
              {
                label: "Per outbound SMS",
                value: tt(F),
                valueClassname: st.numeric
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                label: "Outbound SMS limit",
                value: z ? 10 : W,
                valueClassname: st.numeric
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l(
      Mi,
      {
        variant: "simple",
        heading: "SIM pricing",
        fieldGroups: [
          /* @__PURE__ */ O(le, { children: [
            /* @__PURE__ */ l(
              ee,
              {
                label: "Monthly per SIM",
                value: tt(q),
                valueClassname: wt(
                  st.numeric,
                  ce === 0 && re && st.strikethrough
                )
              }
            ),
            ce === 0 && re && /* @__PURE__ */ l(
              ee,
              {
                label: "Zero-data MRC",
                value: tt(X),
                valueClassname: st.numeric
              }
            ),
            oe && /* @__PURE__ */ l(
              ee,
              {
                label: "Phone number",
                value: tt(parseFloat(se ?? "0")),
                valueClassname: st.numeric
              }
            ),
            /* @__PURE__ */ l("hr", { className: st.hr }),
            z && /* @__PURE__ */ l(
              ee,
              {
                label: "Monthly total",
                value: /* @__PURE__ */ O("div", { className: st.predeploymentTotal, children: [
                  /* @__PURE__ */ l("strong", { children: "Free until activated" }),
                  /* @__PURE__ */ l(Ol, { networkState: k })
                ] }),
                valueClassname: st.numeric
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                label: z ? "Total after activation" : "Total",
                value: /* @__PURE__ */ O(le, { children: [
                  /* @__PURE__ */ l("strong", { children: tt(me) }),
                  " ",
                  /* @__PURE__ */ O("span", { className: st.diminished, children: [
                    L && "+ data pool overage",
                    !L && Te && "+ data usage",
                    !L && !Te && "+ data overage"
                  ] })
                ] }),
                valueClassname: st.numeric
              }
            )
          ] }),
          /* @__PURE__ */ O(le, { children: [
            z && !de && ue && /* @__PURE__ */ l(
              ee,
              {
                label: "Target activation date",
                value: /* @__PURE__ */ O(le, { children: [
                  $i(ue, "long"),
                  " ",
                  /* @__PURE__ */ O("span", { className: st.diminished, children: [
                    "(",
                    lr(ue)?.toRelative({ unit: "days" }),
                    ")"
                  ] })
                ] }),
                valueClassname: st.numeric
              }
            ),
            /* @__PURE__ */ l(
              ee,
              {
                label: "Next renewal (UTC)",
                value: H ? /* @__PURE__ */ O("div", { className: st.popoverWithTooltip, children: [
                  $i(H, "long"),
                  " ",
                  /* @__PURE__ */ O("span", { className: st.diminished, children: [
                    "(",
                    lr(H)?.toRelative({ unit: "days" }),
                    ")"
                  ] }),
                  /* @__PURE__ */ l(
                    et,
                    {
                      className: st.popover,
                      id: "popover-renewal-date",
                      content: `SIM platform fees, prepaid data, and add-on features are charged every 30 days,
                beginning on the day this SIM was activated.`,
                      onOpen: () => {
                        _e && _e("Info - Next renewal");
                      },
                      children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
                    }
                  )
                ] }) : null,
                valueClassname: st.numeric
              }
            ),
            re && /* @__PURE__ */ l(
              ee,
              {
                label: "Zero-data rate",
                value: /* @__PURE__ */ O("div", { className: st.popoverWithTooltip, children: [
                  tt(X),
                  " per month",
                  /* @__PURE__ */ l(
                    et,
                    {
                      className: st.popover,
                      id: "popover-zero-data-rate",
                      content: "If your SIM sends 0 bytes of data within a billing period it will be charged at the zero-data rate.",
                      onOpen: () => {
                        _e && _e("Info - Zero-data rate");
                      },
                      children: /* @__PURE__ */ l(ye, { name: "CircleInfo", fill: "DdsColorInteractivePrimaryDefault" })
                    }
                  )
                ] }),
                valueClassname: st.numeric
              }
            )
          ] })
        ]
      }
    )
  ] }), /* @__PURE__ */ l(
    He,
    {
      header: "Data plan",
      footer: !U && /* @__PURE__ */ l("span", { className: st.footer, children: "Data usage is charged at the end of each closed session. Sessions may be aggregated to meet the minimum charge of $0.10." }),
      footerVariant: "alternative",
      noContentPadding: !0,
      headerActions: !U && Ce ? /* @__PURE__ */ l(
        Y,
        {
          onClick: Ce.onClick,
          variant: "secondary",
          iconStart: void 0,
          children: "Change data plan"
        }
      ) : void 0,
      isLoading: ae || ne,
      contentWell: z && !U && "This SIM is configured for pre-deployment testing. On activation, it will activate into this data plan and its initial billing period will begin.",
      children: hr
    }
  );
}, i2 = "hyperdashboard-SimPricingView-module-pjB9Yq-deactivated", a2 = "hyperdashboard-SimPricingView-module-pjB9Yq-error", s2 = "hyperdashboard-SimPricingView-module-pjB9Yq-loader", Hd = {
  deactivated: i2,
  error: a2,
  loader: s2
}, o2 = ({
  hologramSimId: e,
  orgId: t,
  simDetailBaseUrl: r,
  dataPlanUrl: n,
  handleModalOpen: i,
  onSimsModified: a,
  openPurchasePhoneNumberModal: s,
  openRemovePhoneNumberModal: o
}) => {
  const { isDeactivatedOldSim: c, isLoading: u, error: f } = Xi({ hologramSimId: e }), g = cr({ simDetailBaseUrl: r, orgId: t, simId: e });
  return f ? /* @__PURE__ */ l(
    fe,
    {
      className: Hd.error,
      variant: "error",
      label: "We ran into an issue loading the SIM pricing details",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : u ? /* @__PURE__ */ l(fe, { className: Hd.loader, children: "Loading SIM..." }) : c ? /* @__PURE__ */ l(
    fe,
    {
      className: Hd.deactivated,
      label: "SIM deactivated",
      icon: "StatusDeactivated",
      actions: /* @__PURE__ */ l(Y, { variant: "tertiary", iconEnd: "ArrowEastShort", to: `${g}/usage`, children: "View historical data usage" }),
      children: "This SIM has been permanently deactivated from use on the Hologram network. It can no longer use data and cannot be reactivated. The last known information for this SIM is displayed if available."
    }
  ) : /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(
      n2,
      {
        hologramSimId: e,
        orgId: t,
        handleModalOpen: i,
        onSimsModified: a,
        simDetailBaseUrl: r,
        dataPlanUrl: n
      }
    ),
    /* @__PURE__ */ l(
      xB,
      {
        hologramSimId: e,
        orgId: t,
        openPurchasePhoneNumberModal: s,
        openRemovePhoneNumberModal: o
      }
    )
  ] });
}, l2 = ({ hologramSimId: e, simDetailBaseUrl: t }) => {
  const { showEuiccInfo: r } = gl(e);
  return /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(T1, { hologramSimId: e, simDetailBaseUrl: t }),
    r && /* @__PURE__ */ l(BN, { hologramSimId: e }),
    r && /* @__PURE__ */ l(Jx, { hologramSimId: e })
  ] });
}, c2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-bannerNotification", u2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-bar", d2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-bars", f2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-chip", h2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-chipAndStatus", m2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-chipStatus", p2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-connected", g2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-deactivated", v2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-diagram", y2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-disabled", b2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-entities", S2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-entity", w2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-entityDescription", I2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-entityIcon", C2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-entityLabel", P2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-entityName", T2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-hidden", _2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-live", E2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-paused", O2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-pending", N2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-popoverStatusLabel", D2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-predeployment", R2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-status", k2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-statusDescription", A2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-statuses", x2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-statusIcon", F2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-statusLabel", $2 = "hyperdashboard-ConnectivityStatusPanel-module-IiP9wq-statusName", K = {
  bannerNotification: c2,
  bar: u2,
  bars: d2,
  chip: f2,
  chipAndStatus: h2,
  chipStatus: m2,
  connected: p2,
  deactivated: g2,
  diagram: v2,
  disabled: y2,
  entities: b2,
  entity: S2,
  entityDescription: w2,
  entityIcon: I2,
  entityLabel: C2,
  entityName: P2,
  hidden: T2,
  live: _2,
  paused: E2,
  pending: O2,
  popoverStatusLabel: N2,
  predeployment: D2,
  status: R2,
  statusDescription: k2,
  statuses: A2,
  statusIcon: x2,
  statusLabel: F2,
  statusName: $2
}, M2 = ({
  hologramSimId: e,
  // Someday, a new endpoint that returns connectivity status info
  // Until then, some manual props
  networkStatus: t,
  data: r,
  dataThisBillingPeriod: n,
  zeroByteSessions: i
}) => {
  const {
    simDetails: a,
    isLoading: s,
    error: o
  } = Le(e), {
    deviceDetails: c,
    isLoading: u,
    error: f
  } = Mt(e), { isSuperAdmin: g } = Be(), {
    error: p,
    isLoading: d,
    deviceIdsWithOpenSessions: h
  } = Wn(a.organizationId, g || !!a.organizationId), { networkStatusGroups: v } = ht(), b = V(() => c.claimedDeviceId && h.has(c.claimedDeviceId) && !v?.deactivated?.includes(a.networkStatus) ? v?.predeployment?.includes(a.networkStatus) ? "TEST-CONNECTED" : "CONNECTED" : a.networkStatus, [
    c.claimedDeviceId,
    h,
    v?.predeployment,
    a.networkStatus,
    v?.deactivated
  ]), {
    statusInfo: m,
    isLoading: S,
    error: I
  } = $s(b ?? t), C = V(() => {
    const y = {
      bars: {
        bar1: K.disabled,
        bar2: K.disabled,
        bar3: K.disabled
      },
      entities: {
        device: {
          style: K.disabled,
          icon: "Chip"
        },
        sim: {
          style: K.disabled,
          icon: "SIM"
        },
        core: {
          style: K.disabled,
          icon: "CellTower"
        },
        internet: {
          style: K.disabled,
          icon: "Network"
        }
      },
      statuses: {
        deviceToSim: null,
        simToCore: null,
        coreToInternet: null
      }
    }, w = b ?? t;
    return w && (["TEST-AUTOACTIVATE", "TEST-ACTIVATE", "TEST-CONNECTED"].includes(w) && (y.bars.bar1 = K.predeployment, y.bars.bar2 = K.predeployment, y.entities.device.style = K.predeployment, y.entities.sim.style = K.predeployment, y.entities.core.style = K.predeployment, (r || w === "TEST-CONNECTED") && (y.bars.bar3 = K.predeployment, y.entities.internet.style = K.predeployment), w === "TEST-CONNECTED" ? y.statuses.coreToInternet = {
      style: K.predeployment,
      icon: "StatusConnected",
      label: "Connected",
      text: "",
      size: "small"
    } : y.statuses.simToCore = {
      style: K.predeployment,
      icon: "StatusTesting",
      label: "Ready",
      text: w,
      size: "small"
    }), w === "LIVE-PENDING" && (y.bars.bar1 = K.pending, y.bars.bar2 = K.pending, y.entities.device.style = K.pending, y.entities.sim.style = K.pending, y.entities.core.style = K.pending, r || n ? (y.entities.device.style = K.live, y.entities.sim.style = K.live, y.bars.bar3 = K.pending, y.entities.internet.style = K.pending, y.statuses.coreToInternet = {
      style: K.pending,
      icon: "Configuring",
      label: "Configuring",
      text: w,
      size: "medium"
    }) : y.statuses.simToCore = {
      style: K.pending,
      icon: "StatusActivating",
      label: "Pending",
      // TODO: Change to "Activating" when we have complete API info
      text: w,
      size: "medium"
    }), w === "LIVE" && (y.bars.bar1 = K.live, y.bars.bar2 = K.live, y.entities.device.style = K.live, y.entities.sim.style = K.live, y.entities.core.style = K.live, y.statuses.simToCore = {
      style: K.live,
      icon: "StatusReady",
      label: "Ready",
      text: w,
      size: "small"
    }, (r || n) && (y.bars.bar2 = K.live, y.entities.core.style = K.live), n && (y.bars.bar3 = K.live, y.entities.internet.style = K.live), i && (y.bars.bar2 = K.pending, y.bars.bar3 = K.pending, y.entities.core.style = K.pending, y.entities.internet.style = K.pending, y.statuses.simToCore = {
      style: K.pending,
      icon: "ZeroData",
      label: "Zero bytes",
      text: w,
      size: "medium"
    })), w === "CONNECTED" && (y.bars.bar1 = K.connected, y.bars.bar2 = K.connected, y.bars.bar3 = K.connected, y.entities.device.style = K.connected, y.entities.sim.style = K.connected, y.entities.core.style = K.connected, y.entities.internet.style = K.connected, y.statuses.coreToInternet = {
      style: K.connected,
      icon: "StatusConnected",
      label: "Connected",
      text: w,
      size: "small"
    }), ["PAUSED-PENDING-SYS", "PAUSED-PENDING-USER"].includes(w) && (y.bars.bar1 = K.live, y.bars.bar2 = K.paused, y.entities.device.style = K.live, y.entities.sim.style = K.paused, y.entities.core.style = K.paused, y.statuses.simToCore = {
      style: K.paused,
      icon: "Autopause",
      label: "Pausing",
      text: w,
      size: "medium"
    }), ["PAUSED-SYS", "PAUSED-USER"].includes(w) && (y.bars.bar1 = K.paused, y.bars.bar2 = K.paused, y.entities.device.style = K.paused, y.entities.sim.style = K.paused, y.entities.core.style = K.paused, y.statuses.coreToInternet = {
      style: K.paused,
      icon: "Pause",
      label: "Paused",
      text: w,
      size: "small"
    }), w === "DEAD-PENDING" && (y.bars.bar1 = K.live, y.bars.bar2 = K.deactivated, y.entities.device.style = K.live, y.entities.sim.style = K.deactivated, y.entities.core.style = K.deactivated, y.statuses.simToCore = {
      style: K.deactivated,
      icon: "AutoRefill",
      label: "Deactivating",
      text: w,
      size: "medium"
    }), w === "DEAD" && (y.entities.sim.style = K.deactivated, y.statuses.deviceToSim = {
      style: K.deactivated,
      icon: "StatusDeactivated",
      label: "Deactivated",
      text: w,
      size: "medium"
    }, y.statuses.simToCore = {
      style: K.deactivated,
      icon: "StatusDeactivated",
      label: "Deactivated",
      text: w,
      size: "medium"
    })), y;
  }, [b, t, r, n, i]), T = o || f || p || I, E = s || u || d || S;
  let N;
  return E ? N = /* @__PURE__ */ l(ur, {}) : T ? N = /* @__PURE__ */ l(fe, { children: "Error loading connectivity status" }) : N = /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ O("div", { className: K.chipAndStatus, children: [
      /* @__PURE__ */ l("div", { className: K.chip, children: /* @__PURE__ */ l(
        Ol,
        {
          networkState: b ?? t,
          size: "medium",
          popoverContent: /* @__PURE__ */ O("div", { children: [
            /* @__PURE__ */ l("span", { className: K.popoverStatusLabel, children: "Network state" }),
            /* @__PURE__ */ l("br", {}),
            b ?? t
          ] })
        }
      ) }),
      /* @__PURE__ */ l("div", { className: K.chipStatus, children: m?.tooltip })
    ] }),
    i && (b ?? t) === "LIVE" && /* @__PURE__ */ l("div", { className: K.bannerNotification, children: /* @__PURE__ */ l(ze, { variant: "caution", prefixOverride: "Warning", children: "This SIM has closed sessions but has not passed any data in this billing period. This could indicate an APN configuration issue with your device." }) }),
    /* @__PURE__ */ O("div", { className: K.diagram, children: [
      /* @__PURE__ */ O("div", { className: K.bars, children: [
        /* @__PURE__ */ l("div", { className: wt(K.bar, C.bars.bar1) }),
        /* @__PURE__ */ l("div", { className: wt(K.bar, C.bars.bar2) }),
        /* @__PURE__ */ l("div", { className: wt(K.bar, C.bars.bar3) })
      ] }),
      /* @__PURE__ */ O("div", { className: K.entities, children: [
        /* @__PURE__ */ O("div", { className: wt(K.entity, C.entities.device.style), children: [
          /* @__PURE__ */ l("div", { className: K.entityIcon, children: /* @__PURE__ */ l(ye, { name: C.entities.device.icon, size: "medium", fill: "currentColor" }) }),
          /* @__PURE__ */ O("div", { className: K.entityLabel, children: [
            /* @__PURE__ */ l("span", { className: K.entityName, children: "Your device" }),
            /* @__PURE__ */ l("span", { className: K.entityDescription, children: /* @__PURE__ */ l(
              Ai,
              {
                value: c.claimedDeviceId?.toString() ?? "",
                label: /* @__PURE__ */ O(le, { children: [
                  /* @__PURE__ */ l("span", { children: /* @__PURE__ */ l("strong", { children: "Device ID" }) }),
                  /* @__PURE__ */ l("span", { children: c.claimedDeviceId })
                ] })
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ O("div", { className: wt(K.entity, C.entities.sim.style), children: [
          /* @__PURE__ */ l("div", { className: K.entityIcon, children: /* @__PURE__ */ l(ye, { name: C.entities.sim.icon, size: "medium", fill: "currentColor" }) }),
          /* @__PURE__ */ O("div", { className: K.entityLabel, children: [
            /* @__PURE__ */ l("span", { className: K.entityName, children: "Hologram SIM" }),
            /* @__PURE__ */ l("span", { className: K.entityDescription, children: /* @__PURE__ */ l(
              Ai,
              {
                value: e?.toString() ?? "",
                label: /* @__PURE__ */ O(le, { children: [
                  /* @__PURE__ */ l("span", { children: /* @__PURE__ */ l("strong", { children: "SIM ID" }) }),
                  /* @__PURE__ */ l("span", { children: e })
                ] })
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ O("div", { className: wt(K.entity, C.entities.core.style), children: [
          /* @__PURE__ */ l("div", { className: K.entityIcon, children: /* @__PURE__ */ l(ye, { name: C.entities.core.icon, size: "medium", fill: "currentColor" }) }),
          /* @__PURE__ */ O("div", { className: K.entityLabel, children: [
            /* @__PURE__ */ l("span", { className: K.entityName, children: "Mobile core operator" }),
            /* @__PURE__ */ l("span", { className: K.entityDescription, children: /* @__PURE__ */ l(
              Ai,
              {
                value: a.activeProfile?.toString() ?? "",
                label: /* @__PURE__ */ O(le, { children: [
                  /* @__PURE__ */ l("span", { children: /* @__PURE__ */ l("strong", { children: a.profileName }) }),
                  /* @__PURE__ */ O("span", { className: K.hidden, children: [
                    "Profile ID ",
                    a.activeProfile
                  ] })
                ] })
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ O("div", { className: wt(K.entity, C.entities.internet.style), children: [
          /* @__PURE__ */ l("div", { className: K.entityIcon, children: /* @__PURE__ */ l(ye, { name: C.entities.internet.icon, size: "medium", fill: "currentColor" }) }),
          /* @__PURE__ */ l("div", { className: K.entityLabel, children: /* @__PURE__ */ l("span", { className: K.entityName, children: "Internet" }) })
        ] })
      ] }),
      /* @__PURE__ */ O("div", { className: K.statuses, children: [
        /* @__PURE__ */ O(
          "div",
          {
            className: wt(
              K.status,
              C.statuses.deviceToSim?.style,
              !C.statuses.deviceToSim && K.hidden
            ),
            children: [
              /* @__PURE__ */ l("div", { className: K.statusIcon, children: /* @__PURE__ */ l(
                ye,
                {
                  name: C.statuses.deviceToSim?.icon,
                  size: C.statuses.deviceToSim?.size
                }
              ) }),
              /* @__PURE__ */ O("div", { className: K.statusLabel, children: [
                /* @__PURE__ */ l("div", { className: K.statusName, children: C.statuses.deviceToSim?.label }),
                /* @__PURE__ */ l("div", { className: wt(K.statusDescription, K.hidden), children: C.statuses.deviceToSim?.text })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ O(
          "div",
          {
            className: wt(
              K.status,
              C.statuses.simToCore?.style,
              !C.statuses.simToCore && K.hidden
            ),
            children: [
              /* @__PURE__ */ l("div", { className: K.statusIcon, children: /* @__PURE__ */ l(
                ye,
                {
                  name: C.statuses.simToCore?.icon,
                  size: C.statuses.simToCore?.size
                }
              ) }),
              /* @__PURE__ */ O("div", { className: K.statusLabel, children: [
                /* @__PURE__ */ l("div", { className: K.statusName, children: C.statuses.simToCore?.label }),
                /* @__PURE__ */ l("div", { className: wt(K.statusDescription, K.hidden), children: C.statuses.simToCore?.text })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ O(
          "div",
          {
            className: wt(
              K.status,
              C.statuses.coreToInternet?.style,
              !C.statuses.coreToInternet && K.hidden
            ),
            children: [
              /* @__PURE__ */ l("div", { className: K.statusIcon, children: /* @__PURE__ */ l(
                ye,
                {
                  name: C.statuses.coreToInternet?.icon,
                  size: C.statuses.coreToInternet?.size
                }
              ) }),
              /* @__PURE__ */ O("div", { className: K.statusLabel, children: [
                /* @__PURE__ */ l("div", { className: K.statusName, children: C.statuses.coreToInternet?.label }),
                /* @__PURE__ */ l("div", { className: wt(K.statusDescription, K.hidden), children: C.statuses.coreToInternet?.text })
              ] })
            ]
          }
        )
      ] })
    ] })
  ] }), /* @__PURE__ */ l(He, { header: "Status", noContentPadding: !0, children: N });
}, L2 = "hyperdashboard-SimStatusView-module-Oiu5mq-deactivated", j2 = "hyperdashboard-SimStatusView-module-Oiu5mq-error", W2 = "hyperdashboard-SimStatusView-module-Oiu5mq-loader", qd = {
  deactivated: L2,
  error: j2,
  loader: W2
}, U2 = ({ hologramSimId: e, simDetailBaseUrl: t }) => {
  const { isDeactivatedOldSim: r, isLoading: n, error: i } = Xi({ hologramSimId: e }), a = Ne(), s = cr({ simDetailBaseUrl: t, orgId: a, simId: e });
  return i ? (console.error(`SIM Status API error: ${i}`), /* @__PURE__ */ l(
    fe,
    {
      className: qd.error,
      variant: "error",
      label: "We ran into an issue loading the SIM status",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  )) : n ? /* @__PURE__ */ l(fe, { className: qd.loader, children: "Loading SIM..." }) : r ? /* @__PURE__ */ l(
    fe,
    {
      className: qd.deactivated,
      label: "SIM deactivated",
      icon: "StatusDeactivated",
      actions: /* @__PURE__ */ l(Y, { variant: "tertiary", iconEnd: "ArrowEastShort", to: `${s}/usage`, children: "View historical data usage" }),
      children: "This SIM has been permanently deactivated from use on the Hologram network. It can no longer use data and cannot be reactivated. The last known information for this SIM is displayed if available."
    }
  ) : /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(M2, { hologramSimId: e }),
    /* @__PURE__ */ l(vF, { hologramSimId: e, simDetailBaseUrl: t }),
    /* @__PURE__ */ l(HF, { hologramSimId: e })
  ] });
}, V2 = ({ hologramSimId: e }) => {
  const {
    simDetails: t,
    isLoading: r,
    error: n
  } = Le(e), {
    simBillingPeriod: i,
    isLoading: a,
    error: s
  } = a0({ hologramSimId: e }), { billingPeriodStartMs: o, billingPeriodEndMs: c } = i, {
    mostRecentSession: u,
    error: f,
    isLoading: g
  } = ks(e), {
    isDeactivatedOldSim: p,
    isLoading: d,
    error: h
  } = Xi({
    hologramSimId: e
  }), v = r || a || g || d, b = n || s || f || h, m = !v && !t.simCardId, S = !v && !o && !c;
  return b || m || S ? (m && console.error("SIM Card ID not found"), S && console.error("Billing period not found"), /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading the Device usage report",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "You can reload the page to try again"
    }
  )) : v || !t.simCardId || !o || !c ? /* @__PURE__ */ l(ur, {}) : u.sessionId ? /* @__PURE__ */ l(
    an,
    {
      reportId: 239,
      simCardId: t.simCardId,
      billingPeriodStart: o,
      billingPeriodEnd: c
    }
  ) : p ? /* @__PURE__ */ l(fe, { icon: "CircleAlert", label: "No data usage available for this SIM", children: "This SIM may have never connected and used data, or the usage data may be older than we store for deactivated SIMs." }) : /* @__PURE__ */ l(fe, { icon: "CircleAlert", label: "This SIM hasn’t connected yet", children: "This SIM is activated and able to connect to the Hologram network, but has not yet connected to a local tower or passed data." });
}, em = (e, t) => {
  const r = e ? `${process.env.VITE_API_ROOT}/devices/${e}/webhook?orgid=${t ?? ""}` : null, { data: n, error: i, isLoading: a, isValidating: s, mutate: o } = je(r, Ze), c = V(() => n?.data ?? {}, [n]);
  return i?.status === 400 && i?.info?.error === "Invalid DeviceWebhooks or unable to access" ? {
    deviceWebhook: c,
    error: null,
    isLoading: a,
    isValidating: s,
    mutate: o
  } : {
    deviceWebhook: c,
    error: i,
    isLoading: a,
    isValidating: s,
    mutate: o
  };
}, s0 = ({ organizationId: e, deviceId: t }) => {
  const r = new URLSearchParams({ orgid: `${e}`, deviceid: `${t}` }), n = t ? `${process.env.VITE_API_ROOT}/csr/sources?${r}` : null, { data: i, error: a, isLoading: s, isValidating: o, mutate: c } = je(n, Ze);
  return {
    allRouterCredentials: V(() => i?.data ?? [], [i]),
    error: a,
    isLoading: s,
    isValidating: o,
    mutate: c
  };
}, H2 = ({ deviceId: e }) => {
  const t = `${process.env.VITE_API_ROOT}/devices/${e}/webhook/guid`;
  return $(async () => await ft({
    url: t,
    body: {}
  }), [t]);
}, q2 = ({ deviceId: e }) => {
  const t = `${process.env.VITE_API_ROOT}/devices/${e}/webhook`;
  return $(async () => await Ew({
    url: t,
    body: {}
  }), [t]);
}, z2 = ({ deviceId: e }) => {
  const t = `${process.env.VITE_API_ROOT}/devices/${e}/webhook`;
  return $(
    async (n, i) => await ft({
      url: t,
      body: {
        port: n,
        protocol: i
      }
    }),
    [t]
  );
}, B2 = ({ deviceId: e }) => {
  const t = `${process.env.VITE_API_ROOT}/devices/${e}/webhook`;
  return $(
    async (n, i) => await vh({
      url: t,
      body: {
        port: n,
        protocol: i
      }
    }),
    [t]
  );
}, G2 = "hyperdashboard-UpdateWebhookForm-module-6QDc5a-form", Q2 = {
  form: G2
}, Z2 = ({ deviceId: e, onDone: t }) => {
  const [r, n] = Z(null), i = Ne(), { deviceWebhook: a, mutate: s } = em(e, i), o = a.url && a.url.length > 0, {
    register: c,
    handleSubmit: u,
    formState: { errors: f, isSubmitting: g }
  } = Lt({
    defaultValues: {
      port: o && a.port ? parseInt(a.port, 10) : void 0,
      protocol: o ? a.protocol : "TCP"
    }
  }), p = z2({ deviceId: e }), d = B2({ deviceId: e }), h = $(
    async (m, S) => {
      let I;
      try {
        o ? I = await d(m, S) : I = await p(m, S);
      } catch (C) {
        n(`${C}`);
      }
      I?.success && I?.data && (s({ data: I.data, success: !0 }, { revalidate: !0 }), t());
    },
    [p, o, s, t, d]
  ), v = $(
    async ({ port: m, protocol: S }) => {
      if (!m || !S) {
        n("Port and protocol are required");
        return;
      }
      n(null), await h(m, S);
    },
    [h]
  ), b = u(v);
  return /* @__PURE__ */ O(
    Gr,
    {
      className: Q2.form,
      onSubmit: b,
      footerActions: /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(Y, { type: "submit", loading: g, children: "Save" }),
        /* @__PURE__ */ l(Y, { onClick: t, variant: "secondary", children: "Cancel" })
      ] }),
      children: [
        r && /* @__PURE__ */ l(ze, { variant: "error", children: r }),
        /* @__PURE__ */ l(
          pn,
          {
            label: "Port",
            type: "number",
            invalid: !!f.port,
            validationMessage: f.port?.message,
            ...c("port", {
              valueAsNumber: !0,
              min: {
                value: 1,
                message: "Valid port number is required (1 - 65535)"
              },
              max: { value: 65535, message: "Valid port number is required (1 - 65535)" },
              required: "Port is required"
            })
          }
        ),
        /* @__PURE__ */ l(
          Qf,
          {
            label: "Protocol",
            invalid: !!f.protocol,
            validationMessage: f.protocol?.message,
            options: [
              { value: "TCP", label: "TCP" },
              { value: "UDP", label: "UDP" }
            ],
            ...c("protocol")
          }
        )
      ]
    }
  );
}, Y2 = "hyperdashboard-WebhookPanel-module-LMiE4q-url", K2 = "hyperdashboard-WebhookPanel-module-LMiE4q-webhook", Rb = {
  url: Y2,
  webhook: K2
}, J2 = ({ deviceId: e }) => {
  const t = Ne(), {
    deviceWebhook: r,
    isLoading: n,
    isValidating: i,
    mutate: a
  } = em(e, t), [s, o] = Z(!1), c = $(() => {
    r?.url && (navigator.clipboard.writeText(r.url), o(!0));
  }, [r.url]), [u, f] = Z(!1), [g, p] = Z(null), d = r.url && r.url.length > 0;
  Pe(() => {
    r?.url && o(!1);
  }, [r?.url]);
  const [h, v] = Z(!1), b = H2({ deviceId: e }), m = $(async () => {
    v(!0), p(null);
    let N;
    try {
      N = await b();
    } catch (y) {
      p(`${y}`);
    }
    N?.success && N?.data && a({ data: N.data, success: !0 }, { revalidate: !0 }), v(!1);
  }, [a, b]), [S, I] = Z(!1), C = q2({ deviceId: e }), T = $(async () => {
    I(!0), p(null);
    let N;
    try {
      N = await C();
    } catch (y) {
      p(`${y}`);
    }
    N?.success && a({ data: {}, success: !0 }, { revalidate: !0 }), I(!1);
  }, [a, C]);
  let E;
  return e ? u ? E = /* @__PURE__ */ l(
    Z2,
    {
      deviceId: e,
      onDone: () => {
        f(!1), a(void 0, { revalidate: !0 });
      }
    }
  ) : !n && d ? E = /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(ee, { label: "Port", value: r.port }),
    /* @__PURE__ */ l(ee, { label: "Protocol", value: r.protocol })
  ] }) : E = /* @__PURE__ */ l(
    ee,
    {
      label: "Setup",
      value: /* @__PURE__ */ l(
        Y,
        {
          onClick: () => {
            f(!0);
          },
          variant: "secondary",
          children: "Generate webhook"
        }
      )
    }
  ) : E = null, /* @__PURE__ */ O(
    He,
    {
      header: "Configure inbound webhook",
      contentWell: "Send messages directly to your device by issuing a POST request to a sharable endpoint.",
      isLoading: !e || n || i,
      footerActions: d && !u ? /* @__PURE__ */ O(le, { children: [
        /* @__PURE__ */ l(
          Y,
          {
            variant: "secondary",
            onClick: () => {
              f(!0);
            },
            children: "Update"
          }
        ),
        /* @__PURE__ */ l(Y, { variant: "secondary", loading: h, onClick: m, children: "Regenerate" }),
        /* @__PURE__ */ l(Y, { variant: "delete", loading: S, onClick: T, children: "Delete" })
      ] }) : void 0,
      children: [
        g && /* @__PURE__ */ l(ze, { variant: "error", children: g }),
        /* @__PURE__ */ O("div", { className: Rb.webhook, children: [
          d && /* @__PURE__ */ l(
            ee,
            {
              label: "URL",
              value: /* @__PURE__ */ O("div", { className: Rb.url, children: [
                /* @__PURE__ */ l("span", { children: r.url }),
                /* @__PURE__ */ l(
                  Y,
                  {
                    iconStart: s ? "CheckmarkSingle" : "Document",
                    onClick: c,
                    variant: "secondary"
                  }
                )
              ] })
            }
          ),
          E
        ] })
      ]
    }
  );
}, X2 = ({
  deviceId: e,
  organizationId: t
}) => {
  const r = new URLSearchParams({ orgid: `${t}` }), n = `${process.env.VITE_API_ROOT}/csr/sources?${r}`;
  return $(async () => t ? await ft({
    url: n,
    body: { deviceid: e ?? [] }
  }) : void 0, [e, t, n]);
}, e6 = ({
  deviceId: e,
  onClose: t,
  defaultOpen: r
}) => {
  const n = Ne(), i = X2({
    organizationId: n,
    deviceId: e
  }), {
    allRouterCredentials: a,
    isLoading: s,
    isValidating: o,
    mutate: c,
    error: u
  } = s0({
    organizationId: n,
    deviceId: e
  }), [f, g] = Z(!1), [p, d] = Z(null), [h, v] = Z(!1), b = V(
    () => a.length > 0 ? a[0] : void 0,
    [a]
  ), m = $(() => {
    if (!b?.devicekey) {
      d("No device key to copy.");
      return;
    }
    d(null), navigator.clipboard.writeText(b.devicekey), v(!0);
  }, [b?.devicekey]), S = $(async () => {
    g(!0), d(null);
    let I;
    try {
      I = await i();
    } catch (C) {
      d(C);
    }
    I?.success && I?.data && (v(!1), c(
      { data: [I.data, ...structuredClone(a)], success: !0 },
      { revalidate: !0 }
    )), g(!1);
  }, [a, i, c]);
  return /* @__PURE__ */ O(
    qt,
    {
      header: "Router credentials",
      footerActions: /* @__PURE__ */ O(le, { children: [
        b?.devicekey && /* @__PURE__ */ l(
          Y,
          {
            onClick: m,
            variant: "secondary",
            iconStart: h ? "CheckmarkSingle" : "Document",
            children: "Copy key"
          }
        ),
        /* @__PURE__ */ l(
          Y,
          {
            onClick: S,
            loading: f || o,
            disabled: s || !!u,
            children: "Generate new device key"
          }
        )
      ] }),
      onClosed: t,
      defaultOpen: r,
      children: [
        p || u && /* @__PURE__ */ l(ze, { variant: "system-error", children: p || u }),
        /* @__PURE__ */ l(Gr, { children: /* @__PURE__ */ l(
          pn,
          {
            inputProps: { value: b?.devicekey ?? "Not generated yet" },
            readOnly: !0,
            label: "Device key",
            layoutDirection: "row"
          }
        ) })
      ]
    }
  );
}, t6 = ({ hologramSimId: e }) => {
  const [t, r] = Z(!1), n = Ne(), {
    isLoading: i,
    error: a,
    deviceDetails: s
  } = Mt(e), o = s?.claimedDeviceId, { isLoading: c } = em(o, n), { isLoading: u, error: f } = s0({
    organizationId: n,
    deviceId: o
  }), g = i || c || u;
  return a || f ? /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading Webhook data",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(J2, { deviceId: o }),
    /* @__PURE__ */ l(He, { header: "Data engine", isLoading: g, children: /* @__PURE__ */ l(
      ee,
      {
        label: "Device key",
        value: /* @__PURE__ */ l(
          Y,
          {
            onClick: () => {
              r(!0);
            },
            variant: "secondary",
            children: "Show device key"
          }
        )
      }
    ) }),
    t && /* @__PURE__ */ l(
      e6,
      {
        deviceId: o,
        onClose: () => {
          r(!1);
        },
        defaultOpen: !0
      }
    )
  ] });
}, r6 = ({ organizationId: e, deviceId: t, tagIds: r, pageSize: n = 100 }) => {
  const i = $(
    (S, I) => {
      if (!e || I && !I.lastid)
        return null;
      const C = [
        ["orgid", `${e}`],
        ["limit", n.toString()],
        ["getdeviceinfo", "1"]
      ];
      return t && C.push(["deviceid", `${t}`]), r && r.forEach((T) => {
        C.push(["tagids", `${T}`]);
      }), S !== 0 && I?.lastid && C.push(["startafter", `${I.lastid}`]), `${process.env.VITE_API_ROOT}/usage/data?${new URLSearchParams(C)}`;
    },
    [t, e, n, r]
  ), { data: a, setSize: s, size: o, error: c, isLoading: u, mutate: f, isValidating: g } = n0(i, Ze, {
    persistSize: !0,
    dedupingInterval: 6e4,
    focusThrottleInterval: 6e4,
    refreshInterval: 6e4
  }), p = V(
    () => a ? a.reduce((S, I) => I && I.data ? [...S, ...I.data] : S, []) : [],
    [a]
  ), d = u || !!(o > 0 && a && (a[o - 1]?.data?.length ?? 0) === 0), h = (a?.[0]?.data?.length ?? 0) === 0, v = h || !!(a && (a[a.length - 1]?.data?.length ?? 0) < n), b = g && !!a && a.length === o, m = $(() => {
    s((S) => S + 1);
  }, [s]);
  return {
    usageData: p,
    end: v,
    loadMore: m,
    isEmpty: h,
    error: c,
    isLoading: u,
    isLoadingMore: d,
    mutate: f,
    isValidating: g,
    isRefreshing: b
  };
}, n6 = "hyperdashboard-SimRecentDataSessionsChartPanel-module-cIN4vG-contents", i6 = {
  contents: n6
};
R0.register([
  k0,
  A0,
  x0,
  F0,
  $0,
  M0,
  L0
]);
const a6 = ({
  mode: e,
  hologramSimId: t,
  usageData: r,
  onLoadMoreClick: n,
  loading: i,
  hasMore: a,
  simDetailBaseUrl: s,
  pageSize: o,
  usageByRecentSessionUrl: c
}) => {
  const u = Ne(), f = cr({ simDetailBaseUrl: s, orgId: u, simId: t }), g = ii({
    baseUrl: c,
    orgId: u
  }), { dataSessions: p, reportingWindowSessions: d, zeroByteSessions: h } = V(() => {
    const I = [], C = [], T = [];
    return r.forEach((E) => {
      E.bytes === 0 ? T.push(E) : E.is_reporting_window_with_usage === 1 ? C.push(E) : I.push(E);
    }), {
      dataSessions: I,
      reportingWindowSessions: C,
      zeroByteSessions: T
    };
  }, [r]), v = $((I, C, T) => {
    const E = C.datasetIndex;
    if (typeof E > "u")
      return;
    const N = T.chart, y = !N.getDatasetMeta(E).hidden;
    [N.getDatasetMeta(E), N.getDatasetMeta(E + 3)].forEach((w) => {
      w.hidden = y;
    }), N.update();
  }, []), b = V(
    () => ({
      datasets: [
        {
          label: "Data session",
          data: p.map((I) => ({
            x: ve.fromFormat(I.timestamp, "yyyy-MM-dd HH:mm:ss", {
              zone: "utc"
            }).toMillis(),
            y: I.bytes
          })),
          backgroundColor: "#099FC3",
          pointRadius: 4,
          pointStyle: "circle",
          borderSkipped: !0,
          order: 2
        },
        {
          label: "Reporting window",
          data: d.map((I) => ({
            x: ve.fromFormat(I.timestamp, "yyyy-MM-dd HH:mm:ss", {
              zone: "utc"
            }).toMillis(),
            y: I.bytes
          })),
          backgroundColor: "#005D75",
          pointRadius: 4,
          pointStyle: "rectRounded",
          order: 3
        },
        {
          label: "Zero-byte session",
          data: h.map((I) => ({
            x: ve.fromFormat(I.timestamp, "yyyy-MM-dd HH:mm:ss", {
              zone: "utc"
            }).toMillis(),
            y: I.bytes
          })),
          backgroundColor: "#2B2F3B",
          pointRadius: 5,
          pointStyle: "triangle",
          order: 1
        },
        {
          label: "",
          type: "bar",
          data: p.map((I) => ({
            x: ve.fromFormat(I.timestamp, "yyyy-MM-dd HH:mm:ss", {
              zone: "utc"
            }).toMillis(),
            y: I.bytes
          })),
          backgroundColor: "#6DDDF8",
          barPercentage: 1,
          barThickness: 1.5,
          borderSkipped: !0,
          grouped: !1,
          order: 5
        },
        {
          label: "",
          type: "bar",
          data: d.map((I) => ({
            x: ve.fromFormat(I.timestamp, "yyyy-MM-dd HH:mm:ss", {
              zone: "utc"
            }).toMillis(),
            y: I.bytes
          })),
          borderColor: "#005D75",
          barPercentage: 1,
          barThickness: 1.5,
          borderSkipped: !0,
          grouped: !1,
          order: 6
        },
        {
          label: "",
          type: "bar",
          data: h.map((I) => ({
            x: ve.fromFormat(I.timestamp, "yyyy-MM-dd HH:mm:ss", {
              zone: "utc"
            }).toMillis(),
            y: I.bytes
          })),
          backgroundColor: "#BBBCC2",
          barPercentage: 1,
          barThickness: 1.5,
          borderSkipped: !0,
          grouped: !1,
          order: 4
        }
      ]
    }),
    [p, d, h]
  ), m = V(
    () => ({
      responsive: !0,
      maintainAspectRatio: !1,
      font: {
        family: la,
        size: 14,
        weight: 400,
        style: "normal",
        lineHeight: "20px"
      },
      color: "#00040F",
      plugins: {
        legend: {
          display: !0,
          position: "top",
          align: "start",
          onClick: v,
          labels: {
            color: "#00040F",
            usePointStyle: !0,
            boxHeight: 8,
            boxWidth: 8,
            textAlign: "left",
            filter: (I) => I.text !== "",
            sort: (I, C) => {
              switch (I.text) {
                case "Data session":
                  return -1;
                case "Zero-byte session":
                  return 1;
                default:
                  return C.text === "Data session" ? 1 : -1;
              }
            }
          }
        },
        tooltip: {
          filter: (I) => I.dataset.label !== "",
          callbacks: {
            label: () => "",
            title: (I) => {
              if (I.length === 0)
                return "";
              let C, T;
              if (I.forEach((E) => {
                (!T || E.parsed?.x && E.parsed.x > T) && (T = E.parsed.x), (!C || E.parsed?.x < C) && (C = E.parsed?.x);
              }), I.length === 1)
                return ve.fromMillis(I[0].parsed?.x ?? 0, {
                  zone: "utc"
                }).toFormat("MM-dd-yy HH:mm:ss ZZZZ");
              if (C && T)
                return `${ve.fromMillis(C, {
                  zone: "utc"
                }).toFormat("MM-dd-yy HH:mm:ss ZZZZ")} - ${ve.fromMillis(T, {
                  zone: "utc"
                }).toFormat("MM-dd-yy HH:mm:ss ZZZZ")}`;
            },
            footer: (I) => {
              if (I.length === 0)
                return "";
              const C = [], T = I.reduce((N, y) => N + (y.parsed?.y ?? 0), 0), E = It(T);
              return E && C.push(E), I.length > 1 ? C.push(`${I.length} sessions`) : I[0].dataset.label && C.push(I[0].dataset.label), C;
            }
          },
          titleColor: "#ffffff",
          footerColor: "#ffffff",
          backgroundColor: "#00040F",
          titleAlign: "center",
          footerAlign: "center",
          titleFont: {
            family: la,
            size: 14,
            weight: 400,
            style: "normal"
          },
          footerFont: {
            family: la,
            size: 14,
            weight: 500,
            style: "normal"
          },
          mode: "point",
          padding: 8
        }
      },
      scales: {
        x: {
          grid: {
            color: "#E5E8EF",
            drawOnChartArea: !1,
            tickColor: "#E5E8EF",
            tickWidth: 1
          },
          // https://github.com/jkmnt/chartjs-scale-timestack?tab=readme-ov-file#options
          timestack: {
            datetime: { zone: "utc" },
            max_density: 0.5,
            density: 0.25,
            format_style: { hour12: !1, month: "long", weekday: "long", timeZone: "UTC" }
          },
          type: "timestack",
          ticks: {
            font: {
              family: la,
              size: 12,
              weight: 500,
              style: "normal",
              lineHeight: "16px"
            },
            color: "#626D8D"
          }
        },
        y: {
          beginAtZero: !0,
          grid: {
            color: "#E5E8EF",
            drawTicks: !1,
            tickWidth: 1
          },
          ticks: {
            callback: (I) => It(I, "short"),
            font: {
              family: la,
              size: 12,
              weight: 500,
              style: "normal",
              lineHeight: "16px"
            },
            color: "#626D8D",
            maxTicksLimit: 6,
            labelOffset: 2
          }
        }
      }
    }),
    [v]
  ), S = Jn();
  return /* @__PURE__ */ l(
    He,
    {
      header: `Last ${Ee(r.length)} sessions`,
      headerActions: /* @__PURE__ */ l(Y, { variant: "secondary", onClick: n, disabled: i || !a, children: `Load ${Ee(o)} more sessions` }),
      isLoading: i,
      footer: /* @__PURE__ */ O(le, { children: [
        "This chart displays up to 90 days of recent completed data sessions and reporting windows to help troubleshoot device connectivity behavior.",
        " ",
        /* @__PURE__ */ l(
          Ae,
          {
            type: "inline",
            to: e === "organization" ? g : `${f}/usage`,
            children: "View detailed usage reporting"
          }
        )
      ] }),
      footerVariant: "alternative",
      noContentPadding: !0,
      children: /* @__PURE__ */ l("div", { className: i6.contents, children: /* @__PURE__ */ l(j0, { id: S, data: b, options: m }) })
    }
  );
}, s6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-cell", o6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-duration", l6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-exportDropdown", c6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-footer", u6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-footerLeft", d6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-footerLeftText", f6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-footerRight", h6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-numeric", m6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-panel", p6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-popover", g6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-popoverContent", v6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-profileChanged", y6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-reportingWindow", b6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-rightAlign", S6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-row", w6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-tableWrapper", I6 = "hyperdashboard-SimSessionsPanel-module-JDvqga-textAndPopover", Ve = {
  cell: s6,
  duration: o6,
  exportDropdown: l6,
  footer: c6,
  footerLeft: u6,
  footerLeftText: d6,
  footerRight: f6,
  numeric: h6,
  panel: m6,
  popover: p6,
  popoverContent: g6,
  profileChanged: v6,
  reportingWindow: y6,
  rightAlign: b6,
  row: S6,
  tableWrapper: w6,
  textAndPopover: I6
}, Wr = [
  { children: "End time (UTC)", key: "endtime" },
  { children: "Start time (UTC)", key: "starttime" },
  { children: "Duration", key: "duration" },
  { children: "SIM name", key: "simname" },
  { children: "Data usage", key: "datausage", className: Ve.rightAlign },
  { children: "Profile ICCID", key: "profileiccid" },
  { children: "IMEI", key: "imei" },
  { children: "Network", key: "network" },
  { children: "RAT", key: "rat" }
], xo = ({
  children: e,
  content: t,
  className: r
}) => {
  const n = Jn();
  return /* @__PURE__ */ l(
    et,
    {
      id: n,
      content: t,
      className: J(Ve.popover, r),
      allowPinning: !1,
      children: e
    }
  );
}, kb = ({ timestamp: e, children: t }) => e.isValid ? /* @__PURE__ */ l(
  xo,
  {
    className: Ve.numeric,
    content: /* @__PURE__ */ O("div", { className: J(Ve.popoverContent, Ve.numeric), children: [
      e.toLocal().toFormat("MM-dd-yy ttt"),
      /* @__PURE__ */ l("br", {}),
      Mh({
        start: e,
        top: 2
      })
    ] }),
    children: t
  }
) : t, C6 = ({
  hologramSimId: e,
  simName: t,
  simDetailBaseUrl: r
}) => {
  const n = Ne(), i = cr({
    simDetailBaseUrl: r,
    orgId: n,
    simId: e,
    subpage: Yn.recentSessions
  });
  return /* @__PURE__ */ l(Ae, { to: i, children: t });
}, P6 = ({
  mode: e,
  hologramSimId: t,
  usageData: r,
  onLoadMoreClick: n,
  loading: i,
  hasMore: a,
  simDetailBaseUrl: s,
  pageSize: o,
  usageByRecentSessionUrl: c
}) => {
  const u = Ne(), f = cr({ simDetailBaseUrl: s, orgId: u, simId: t }), g = ii({
    baseUrl: c,
    orgId: u
  }), p = V(
    () => r.map(
      ({
        record_id: y,
        session_begin: w,
        timestamp: P,
        is_reporting_window_with_usage: _,
        devicename: D,
        bytes: R,
        sim: x,
        linkid: F,
        deviceid: W,
        imei: A,
        network_name: M,
        radio_access_technology: j,
        simcardid: B
      }) => {
        const L = ve.fromFormat(w, "yyyy-MM-dd HH:mm:ss", { zone: "utc" }), H = ve.fromFormat(P, "yyyy-MM-dd HH:mm:ss", { zone: "utc" });
        let q;
        L?.isValid && H?.isValid && (q = H.diff(L, "seconds"));
        const te = q?.isValid ? q.toFormat("hh:mm:ss") : void 0;
        return {
          recordId: y,
          sessionEnd: P,
          sessionBegin: w,
          end: H,
          start: L,
          duration: te,
          simName: D,
          isReportingWindow: _,
          dataUsageBytes: R,
          profileIccid: x,
          profileId: F,
          deviceId: W,
          imei: A,
          network: M,
          rat: j,
          hologramSimId: B
        };
      }
    ),
    [r]
  ), d = V(() => {
    let y = !1;
    const w = /* @__PURE__ */ new Map();
    return p.reverse().map(
      ({
        recordId: P,
        profileId: _,
        end: D,
        sessionEnd: R,
        start: x,
        sessionBegin: F,
        duration: W,
        isReportingWindow: A,
        simName: M,
        dataUsageBytes: j,
        profileIccid: B,
        imei: L,
        network: H,
        rat: q,
        hologramSimId: te
      }) => {
        const G = new Array(Wr.length);
        let X = !1;
        w.has(te) ? w.get(te) !== _ && (X = !0, w.set(te, _)) : w.set(te, _), X && (y = !y);
        let re = 0;
        return G[re] = {
          key: Wr[re].key,
          children: /* @__PURE__ */ l(kb, { timestamp: D, children: R }),
          className: J(Ve.cell, Ve.numeric)
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: /* @__PURE__ */ l(kb, { timestamp: x, children: F }),
          className: J(Ve.cell, Ve.numeric)
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: /* @__PURE__ */ O(le, { children: [
            W && /* @__PURE__ */ l("div", { className: Ve.numeric, children: W }),
            A === 1 && /* @__PURE__ */ O("div", { className: Ve.textAndPopover, children: [
              /* @__PURE__ */ l("span", { className: Ve.reportingWindow, children: "Reporting window" }),
              /* @__PURE__ */ l(xo, { content: "Represents total usage in the time frame. Reporting times on this network may vary.", children: /* @__PURE__ */ l(
                ye,
                {
                  name: "CircleInfo",
                  size: "small",
                  fill: "DdsColorInteractivePrimaryDefault"
                }
              ) })
            ] })
          ] }),
          className: J(Ve.cell, Ve.duration)
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: /* @__PURE__ */ l(
            C6,
            {
              hologramSimId: te,
              simName: M,
              simDetailBaseUrl: s
            }
          ),
          className: Ve.cell
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: /* @__PURE__ */ l(
            xo,
            {
              content: It(j, "bytes"),
              className: Ve.numeric,
              children: It(j)
            }
          ),
          className: J(Ve.cell, Ve.rightAlign)
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: /* @__PURE__ */ O("div", { className: J(Ve.textAndPopover, Ve.profileChanged), children: [
            /* @__PURE__ */ l("span", { className: Ve.numeric, children: B }),
            X && /* @__PURE__ */ l(xo, { content: "Enabled profile changed. This could be from a fallback event or a manual profile switch.", children: /* @__PURE__ */ l(
              ye,
              {
                name: "SwapSIM",
                fill: y ? "DdsColorPaletteTeal40" : "DdsColorPaletteTeal30"
              }
            ) })
          ] }),
          className: Ve.cell
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: L,
          className: J(Ve.cell, Ve.numeric)
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: H,
          className: Ve.cell
        }, re += 1, G[re] = {
          key: Wr[re].key,
          children: q,
          className: Ve.cell
        }, { key: `${P}`, cells: G, className: Ve.row };
      }
    ).reverse();
  }, [p, s]), [h, v] = Z(!1), b = $(() => {
    v((y) => !y);
  }, []), m = Jn(), { sendAnalyticsEvent: S, sendAnalyticsError: I } = mt(), [C, T] = Z(!1), E = $(
    async (y) => {
      v(!1);
      const w = ea(y);
      try {
        T(!0);
        const P = p.map(
          ({
            sessionEnd: R,
            sessionBegin: x,
            duration: F,
            isReportingWindow: W,
            dataUsageBytes: A,
            profileIccid: M,
            profileId: j,
            deviceId: B,
            imei: L,
            network: H,
            rat: q
          }) => ({
            endTimeUTC: R,
            startTimeUTC: x,
            duration: F,
            isReportingWindow: W,
            dataUsageBytes: A,
            profileIccid: M,
            profileId: j,
            deviceId: B,
            imei: L,
            network: H,
            rat: q
          })
        ), _ = ve.now(), D = _.toFormat("yyyyLLdd-hhmmssSSS");
        switch (y) {
          case gt.XLSX:
          case gt.CSV:
            if (y === gt.XLSX) {
              const R = new Gf();
              R.creator = "Hologram", R.lastModifiedBy = "Hologram";
              const x = _.toJSDate();
              R.created = x, R.modified = x;
              const F = R.addWorksheet("SIMs");
              F.addRow(Object.keys(P[0])), F.addRows(P.map((A) => Object.values(A)));
              const W = await R.xlsx.writeBuffer();
              Ch({
                data: W,
                filename: `Sessions-${D}.xlsx`
              });
            } else
              bl({
                data: yl.unparse(P),
                filename: `Sessions-${D}.csv`
              });
            break;
          case gt.JSON:
            Aw({
              data: JSON.stringify(P, void 0, 1),
              filename: `Sessions-${D}.json`
            });
            break;
          default:
            break;
        }
        T(!1);
      } catch (P) {
        I && I("Export SIMs error", P);
      }
      S && S("Recent sessions - Export Sessions - Export Sessions success", {
        exportType: w
      });
    },
    [p, I, S]
  ), N = V(() => {
    const y = [];
    return y.push({
      label: `Export ${Ee(r.length)} sessions`,
      items: [
        {
          children: "Export to XLSX (Excel)",
          iconStart: "DownloadTray",
          onClick: () => E(gt.XLSX)
        },
        {
          children: "Export to CSV",
          iconStart: "DownloadTray",
          onClick: () => E(gt.CSV)
        },
        {
          children: "Export to JSON",
          iconStart: "DownloadTray",
          onClick: () => E(gt.JSON)
        }
      ]
    }), y;
  }, [E, r]);
  return /* @__PURE__ */ l(
    He,
    {
      isLoading: i,
      className: Ve.panel,
      noContentPadding: !0,
      header: "Recent session details",
      headerActions: /* @__PURE__ */ l(
        Kn,
        {
          content: N,
          open: h,
          onOpenChange: v,
          className: Ve.exportDropdown,
          children: /* @__PURE__ */ l(
            Y,
            {
              iconEnd: h ? "ChevronSingleNorth" : "ChevronSingleSouth",
              variant: "secondary",
              onClick: b,
              disabled: i,
              id: m,
              loading: C,
              children: "Export"
            }
          )
        }
      ),
      footerVariant: "alternative",
      footerActions: /* @__PURE__ */ O("div", { className: Ve.footer, children: [
        /* @__PURE__ */ O("div", { className: Ve.footerLeft, children: [
          /* @__PURE__ */ l(Y, { variant: "secondary", onClick: n, disabled: i || !a, children: `Load ${Ee(o)} more sessions` }),
          /* @__PURE__ */ O("span", { className: Ve.footerLeftText, children: [
            "Showing last ",
            Ee(r.length),
            " closed data sessions"
          ] })
        ] }),
        /* @__PURE__ */ l("div", { className: Ve.footerRight, children: /* @__PURE__ */ l(
          Y,
          {
            iconEnd: "ArrowEastShort",
            variant: "tertiary",
            to: e === "organization" ? g : `${f}/usage`,
            children: "View data usage history"
          }
        ) })
      ] }),
      children: /* @__PURE__ */ l(ei, { headers: Wr, rows: d, wrapperClassName: Ve.tableWrapper })
    }
  );
}, T6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-checkboxLabel", _6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-dropdown", E6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-selectAllCheckbox", O6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-simCount", N6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-tagsButton", D6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-tagsDropdown", R6 = "hyperdashboard-SimRecentSessionsOrganization-module-VUQmZW-wrapper", Bn = {
  checkboxLabel: T6,
  dropdown: _6,
  selectAllCheckbox: E6,
  simCount: O6,
  tagsButton: N6,
  tagsDropdown: D6,
  wrapper: R6
}, k6 = ({
  refreshSessions: e,
  register: t,
  watch: r,
  setValue: n
}) => {
  const i = Ne(), [a, s] = Z(!1), o = $(() => {
    s((v) => !v);
  }, []), {
    tags: c,
    isLoading: u,
    error: f
  } = uh({
    filters: i ? { organizationIds: [i] } : void 0
  }), { selectAllTags: g, tags: p } = r(), d = V(() => new Set(p), [p]), h = V(() => {
    let v;
    return g === "1" ? v = c : d.size > 0 && (v = c.filter((b) => d.has(`${b.id}`))), !v || v.length === 0 ? "No tags selected" : `(${v.length}) ${v.map((b) => b.name).join(", ")}`;
  }, [g, d, c]);
  return u || f ? (f && console.error(f), null) : /* @__PURE__ */ O("div", { className: Bn.wrapper, children: [
    /* @__PURE__ */ l(mn, { label: "Tags", children: ({ ariaDescribedbyIds: v, ariaLabel: b, primaryControlId: m }) => /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
      Kn,
      {
        className: Bn.dropdown,
        content: /* @__PURE__ */ O("div", { className: Bn.tagsDropdown, children: [
          /* @__PURE__ */ l(
            Rr,
            {
              label: "Select all",
              value: "1",
              className: Bn.selectAllCheckbox,
              indeterminate: (!g && (p?.length ?? 0) > 0 && p.length !== c?.length) ?? 0,
              defaultChecked: g === "1",
              ...t("selectAllTags", {
                onChange: (S) => {
                  S.target.checked ? n(
                    "tags",
                    c.map((I) => `${I.id}`)
                  ) : n("tags", []);
                }
              })
            },
            "select-all"
          ),
          /* @__PURE__ */ l(
            qa,
            {
              label: "",
              options: c?.map((S) => ({
                labelNode: /* @__PURE__ */ O("div", { className: Bn.checkboxLabel, children: [
                  /* @__PURE__ */ l("span", { children: S.name }),
                  /* @__PURE__ */ O("span", { className: Bn.simCount, children: [
                    "(",
                    S.simCount,
                    ")"
                  ] })
                ] }),
                label: `${S.name} (${S.simCount})`,
                value: `${S.id}`,
                defaultChecked: !!S.id && d.has(`${S.id}`)
              })),
              ...t("tags", {
                onChange: () => {
                  g === "1" && n("selectAllTags", !1);
                }
              })
            }
          )
        ] }),
        open: a,
        onOpenChange: s,
        children: /* @__PURE__ */ l(
          Y,
          {
            id: m,
            "aria-describedby": v,
            "aria-label": b,
            variant: "secondary",
            className: Bn.tagsButton,
            onClick: o,
            iconEnd: /* @__PURE__ */ l(ye, { name: a ? "ChevronSingleNorth" : "ChevronSingleSouth", size: "small" }),
            children: h
          }
        )
      }
    ) }) }),
    /* @__PURE__ */ l(Y, { onClick: e, children: "Refresh sessions" })
  ] });
}, A6 = "hyperdashboard-SimRecentSessionsView-module-tJto4G-actions", x6 = "hyperdashboard-SimRecentSessionsView-module-tJto4G-helptext", F6 = "hyperdashboard-SimRecentSessionsView-module-tJto4G-wrapper", zd = {
  actions: A6,
  helptext: x6,
  wrapper: F6
}, $6 = ({
  mode: e,
  hologramSimId: t,
  simDetailBaseUrl: r,
  usageByRecentSessionUrl: n,
  pageSize: i
}) => {
  const a = Ne(), {
    deviceDetails: s,
    isLoading: o,
    error: c
  } = Mt(t), {
    simBilling: { billingPeriodStart: u }
  } = Ir(t), { register: f, watch: g, setValue: p } = Lt({
    defaultValues: { tags: [], selectAllTags: "" },
    mode: "onChange"
  }), { selectAllTags: d, tags: h } = g();
  Pe(() => {
  }, []);
  const v = V(() => {
    if (!(!h || h.length === 0 || d === "1"))
      return h.map((A) => parseInt(A, 10));
  }, [d, h]), {
    usageData: b,
    loadMore: m,
    mutate: S,
    isValidating: I,
    end: C,
    isEmpty: T,
    isLoadingMore: E,
    isRefreshing: N,
    isLoading: y,
    error: w
  } = r6({
    deviceId: e === "sim" ? s.claimedDeviceId : void 0,
    organizationId: a,
    pageSize: i,
    tagIds: v
  }), P = ii({ baseUrl: n, orgId: a }), _ = T ? void 0 : b[0]?.timestamp, D = V(() => {
    if (!_ || !u)
      return !1;
    const A = lr(u), M = ve.fromFormat(
      _,
      "yyyy-MM-dd HH:mm:ss",
      { zone: "utc" }
    );
    return !A?.isValid || !M.isValid ? !1 : M < A;
  }, [u, _]), R = $(() => {
    S();
  }, [S]), x = w || c, F = I || E || N, W = V(() => x ? /* @__PURE__ */ l(
    fe,
    {
      variant: "error",
      label: "We ran into an issue loading recent sessions",
      actions: /* @__PURE__ */ l(
        Y,
        {
          variant: "secondary",
          iconStart: "Sync",
          onClick: () => {
            window.location.reload();
          },
          children: "Reload page"
        }
      ),
      children: "We will keep trying in the background or you can try to reload the page."
    }
  ) : o || y ? /* @__PURE__ */ l(ur, {}) : T ? e === "organization" ? d || v && v.length > 0 ? /* @__PURE__ */ l(
    fe,
    {
      icon: "CircleInfo",
      label: "No recent sessions found for tagged SIMs",
      actions: /* @__PURE__ */ l(Y, { to: P, variant: "tertiary", iconEnd: "ArrowEastShort", children: "View session history reporting" }),
      children: "We haven’t seen any recent sessions in the last 90 days for SIMs with the tags you selected. You can find more detailed data usage history in the data usage reports."
    }
  ) : /* @__PURE__ */ l(
    fe,
    {
      icon: "CircleInfo",
      label: "No recent sessions could be found",
      actions: /* @__PURE__ */ l(Y, { to: P, variant: "tertiary", iconEnd: "ArrowEastShort", children: "View session history reporting" }),
      children: "We haven’t seen any recent sessions within the last 90 days for your fleet. Additional data usage history is available in the data usage reports."
    }
  ) : /* @__PURE__ */ l(fe, { icon: "CircleInfo", label: "This SIM hasn’t connected yet", children: "This SIM is activated and able to connect to the Hologram network, but has not yet connected to a local tower or passed data." }) : /* @__PURE__ */ O(le, { children: [
    /* @__PURE__ */ l(
      a6,
      {
        mode: e,
        hologramSimId: t,
        usageData: b,
        onLoadMoreClick: m,
        loading: F,
        hasMore: !C,
        simDetailBaseUrl: r,
        pageSize: i,
        usageByRecentSessionUrl: n
      }
    ),
    /* @__PURE__ */ l(
      P6,
      {
        mode: e,
        hologramSimId: t,
        usageData: b,
        onLoadMoreClick: m,
        loading: F,
        hasMore: !C,
        simDetailBaseUrl: r,
        pageSize: i,
        usageByRecentSessionUrl: n
      }
    ),
    /* @__PURE__ */ l("div", { className: zd.helptext, children: "Limited to the last 90 days of session data. Some networks report data usage in fixed time blocks rather than individual sessions. IMEIs are not provided for every session by every network." })
  ] }), [
    x,
    o,
    y,
    T,
    e,
    t,
    b,
    m,
    F,
    C,
    r,
    i,
    n,
    d,
    v,
    P
  ]);
  return /* @__PURE__ */ O("div", { className: zd.wrapper, children: [
    D && /* @__PURE__ */ l(ze, { variant: "caution", children: "The most recent sessions for this SIM were in a previous billing period." }),
    e === "organization" && /* @__PURE__ */ l("div", { className: zd.actions, children: /* @__PURE__ */ l(
      k6,
      {
        refreshSessions: R,
        register: f,
        watch: g,
        setValue: p
      }
    ) }),
    W
  ] });
}, M6 = "hyperdashboard-SimDetails-module-zIRdcW-bannerNotifications", L6 = "hyperdashboard-SimDetails-module-zIRdcW-divider", j6 = "hyperdashboard-SimDetails-module-zIRdcW-headerWrapper", W6 = "hyperdashboard-SimDetails-module-zIRdcW-loader", U6 = "hyperdashboard-SimDetails-module-zIRdcW-viewContent", V6 = "hyperdashboard-SimDetails-module-zIRdcW-wrapper", Pi = {
  bannerNotifications: M6,
  divider: L6,
  headerWrapper: j6,
  loader: W6,
  viewContent: U6,
  wrapper: V6
}, H6 = {
  dedupingInterval: 6e4,
  focusThrottleInterval: 3e5,
  loadingTimeout: 3e3,
  errorRetryInterval: 1e4,
  errorRetryCount: 3
}, q6 = Et(
  ({
    className: e,
    hologramSimId: t,
    viewKey: r,
    onNavigate: n,
    simDetailBaseUrl: i,
    handleModalOpen: a,
    onDeviceChange: s,
    simInventoryBaseUrl: o,
    RoutesComponent: c,
    usageByRecentSessionUrl: u,
    dataPlanUrl: f
  }, g) => {
    const {
      deviceOverview: p,
      mutate: d,
      isLoading: h
    } = ch(t), {
      simDetails: v,
      mutate: b,
      isLoading: m,
      error: S
    } = Le(t), {
      deviceDetails: I,
      isLoading: C,
      mutate: T
    } = Mt(t), {
      simProfiles: E,
      error: N,
      isLoading: y,
      mutate: w
    } = kr(t), { isDeactivatedOldSim: P, isLoading: _ } = Xi({
      hologramSimId: t
    }), { isLoading: D, mutate: R } = ti(
      v.organizationId && I.claimedDeviceId ? I.claimedDeviceId : void 0,
      v.organizationId
    ), { isSuperAdmin: x } = Be(), { isLoading: F, mutate: W } = Wn(
      v.organizationId,
      x || !!v.organizationId
    ), { mutate: A } = cw(t), { mutate: M } = lw(t), { mutate: j } = ks(t), { mutate: B } = Ir(t), { mutate: L } = Xw(t), H = !y && !N && E?.find((_e) => _e.installationState === "ENABLE_PENDING");
    Pe(() => {
      s({ ...p, ...I });
    }, [I, p, s]);
    const q = $(() => {
      d(), b(), T(), j(), w(), M(), A(), B(), L(), W(), R();
    }, [
      B,
      R,
      M,
      j,
      W,
      A,
      w,
      d,
      b,
      T,
      L
    ]);
    Kt(g, () => q, [q]);
    const te = Ne(), G = v.organizationId, X = cr({ simDetailBaseUrl: i, orgId: G, simId: t }), re = $(
      (_e) => {
        n(_e === "details" ? X ?? "" : `${X}/${_e}`);
      },
      [n, X]
    ), oe = bn({
      url: `${o}/active`,
      replacers: [{ placeholder: "orgid", value: te?.toString() ?? "" }]
    }), [ue, de] = Z(!1), [Q, he] = Z(!1), ce = $(
      () => de(!0),
      []
    ), se = $(() => he(!0), []), pe = $(
      () => de(!1),
      []
    ), k = $(() => he(!1), []), { organizationRole: z, releaseFlags: U } = Be(), ie = ["admin", "manager", "editor"].includes(z) && !P, ae = U?.has(Ht.FEATURE_ROUTES) && !P, ne = U?.has(Ht.FEATURE_WEBHOOKS) && !P, me = !U?.has(Ht.HIDE_TOWER_LOCATIONS) && !P, Te = !P, Ce = !P, Re = V(() => {
      const _e = [];
      return H && _e.push(
        /* @__PURE__ */ O(ze, { prefixOverride: "In progress", variant: "note", children: [
          "A request to switch to the ",
          H.profileName,
          " profile has been issued to our carrier partners. This request will take effect the next time your device connects to a network. Connecting should take less than 10 minutes."
        ] })
      ), _e;
    }, [H]), xe = V(() => {
      const _e = /* @__PURE__ */ l(Vb, { children: /* @__PURE__ */ l("title", { children: `${p.deviceName ?? "SIM Details"} - Hologram` }) });
      return h || m || C || F || D || _ ? /* @__PURE__ */ O(le, { children: [
        _e,
        /* @__PURE__ */ l(ur, { className: Pi.loader, children: "Loading SIM details..." })
      ] }) : S ? /* @__PURE__ */ l(
        fe,
        {
          icon: "CircleAlert",
          label: "We weren’t able to load this SIM",
          actions: /* @__PURE__ */ l(Y, { variant: "secondary", to: oe ?? "/", children: "View active SIMs" }),
          children: "You can try reloading the page, looking in the SIMs pages, or searching."
        }
      ) : v.hologramSimId ? /* @__PURE__ */ O(le, { children: [
        _e,
        /* @__PURE__ */ O("div", { className: Pi.headerWrapper, children: [
          /* @__PURE__ */ l(
            EN,
            {
              hologramSimId: t,
              onSimsModified: q,
              handleModalOpen: a,
              simDetailBaseUrl: i
            }
          ),
          /* @__PURE__ */ l("hr", { className: Pi.divider }),
          /* @__PURE__ */ l("div", { className: $t.tabWrapper, children: Object.entries(ZN).filter(([$e]) => $e === "routes" ? ae : $e === "webhooks" ? ne : $e === "pricing" ? ie : $e === "locationhistory" ? me : $e === "coverage" ? Te : $e === "recentsessions" ? Ce : !0).map(([$e, jt]) => /* @__PURE__ */ l(
            _s,
            {
              id: `simdetails-tab-${$e}`,
              selected: $e === r,
              onClick: () => re($e),
              children: jt
            },
            $e
          )) })
        ] }),
        /* @__PURE__ */ l("div", { className: $t.viewsWrapper, children: /* @__PURE__ */ O("div", { className: Pi.viewContent, children: [
          Re.length > 0 && /* @__PURE__ */ l("div", { className: Pi.bannerNotifications, children: Re }),
          r === "details" && /* @__PURE__ */ l(U2, { hologramSimId: t, simDetailBaseUrl: i }),
          r === "profiles" && /* @__PURE__ */ l(
            l2,
            {
              hologramSimId: t,
              simDetailBaseUrl: i
            }
          ),
          r === "simanddevices" && /* @__PURE__ */ l(
            EB,
            {
              hologramSimId: t,
              simDetailBaseUrl: i,
              handleModalOpen: a,
              onSimsModified: q
            }
          ),
          r === "recentsessions" && /* @__PURE__ */ l(
            $6,
            {
              hologramSimId: t,
              simDetailBaseUrl: i,
              pageSize: 100,
              mode: "sim",
              usageByRecentSessionUrl: u
            }
          ),
          r === "usage" && /* @__PURE__ */ l(V2, { hologramSimId: t }),
          r === "locationhistory" && /* @__PURE__ */ l(NB, { hologramSimId: t }),
          r === "pricing" && ie && /* @__PURE__ */ l(
            o2,
            {
              hologramSimId: t,
              simDetailBaseUrl: i,
              dataPlanUrl: f,
              orgId: G,
              handleModalOpen: a,
              onSimsModified: q,
              openPurchasePhoneNumberModal: ce,
              openRemovePhoneNumberModal: se
            }
          ),
          r === "coverage" && Te && /* @__PURE__ */ l(hB, { hologramSimId: t }),
          r === "webhooks" && ne && /* @__PURE__ */ l(t6, { hologramSimId: t }),
          r === "routes" && ae && /* @__PURE__ */ l(c, {})
        ] }) }),
        ue && /* @__PURE__ */ l(
          IB,
          {
            hologramSimId: t,
            deviceId: I.claimedDeviceId,
            onConfirmed: pe,
            onCancelled: pe
          }
        ),
        Q && /* @__PURE__ */ l(
          _B,
          {
            hologramSimId: t,
            deviceId: I.claimedDeviceId,
            onConfirmed: k,
            onCancelled: k
          }
        )
      ] }) : /* @__PURE__ */ l(
        fe,
        {
          icon: "CircleAlert",
          label: "No matching SIM found",
          actions: /* @__PURE__ */ l(Y, { variant: "secondary", to: oe ?? "/", children: "View active SIMs" }),
          children: "Check that the address or IDs you are searching for are correct."
        }
      );
    }, [
      p.deviceName,
      h,
      m,
      C,
      F,
      D,
      _,
      S,
      v.hologramSimId,
      t,
      q,
      a,
      i,
      Re,
      r,
      u,
      ie,
      G,
      ce,
      se,
      ne,
      ae,
      c,
      ue,
      I.claimedDeviceId,
      pe,
      Q,
      k,
      oe,
      me,
      Te,
      re,
      f,
      Ce
    ]);
    return /* @__PURE__ */ l(Px, { organizationId: G, children: /* @__PURE__ */ l("div", { className: J($t.pageWrapper, Pi.wrapper, e), children: xe }) });
  }
), c4 = Et((e, t) => /* @__PURE__ */ l(fl, { value: H6, children: /* @__PURE__ */ l(q6, { ref: t, ...e }) })), z6 = /* @__PURE__ */ new Set([
  "organizationId",
  "deviceName",
  "iccid",
  "imei",
  "activationDate",
  "targetActivationDate",
  "lastActive",
  "dataUsage",
  "simStatuses",
  "tags",
  "noTags",
  "plans"
]), Ab = "simInventory", o0 = 10, l0 = /* @__PURE__ */ new Set([
  "lastActive",
  "activationDate",
  "targetActivationDate"
]), B6 = /* @__PURE__ */ new Set(["iccid", "imei"]), G6 = /* @__PURE__ */ new Set(["simStatuses", "tags", "plans"]), Bd = /* @__PURE__ */ new Set(["simStatuses"]), xb = /* @__PURE__ */ new Set(["plans", "tags", "organizationId"]), Q6 = /* @__PURE__ */ new Set(["noTags"]), Z6 = () => window.location.search.slice(1), Y6 = (e) => window.history.replaceState({}, "", `?${e}`), Fb = () => window.history.replaceState({}, "", window.location.pathname), $b = (e, t) => l0.has(e), K6 = (e, t) => B6.has(e), Gd = (e) => z6.has(e), J6 = {
  getItem: (e) => {
    const t = Z6(), r = new URLSearchParams(t), n = {};
    [...r.entries()].forEach(([s, o]) => {
      const c = s;
      if (s.includes("-")) {
        const [u, f] = s.split("-");
        if (!Gd(u))
          return;
        f === "timeframe" ? n[u] = {
          ...n[u],
          timeframe: decodeURI(o)
        } : f === "start" ? n[u] = {
          ...n[u],
          start: decodeURI(o)
        } : f === "end" ? n[u] = {
          ...n[u],
          end: decodeURI(o)
        } : f === "condition" ? n[u] = {
          ...n[u],
          condition: decodeURI(o)
        } : f === "value" && (n[u] = {
          ...n[u],
          value: decodeURI(o)
        });
      } else {
        if (!Gd(c))
          return;
        G6.has(c) ? Bd.has(c) ? n[s] = o.split(",").map((u) => decodeURI(u.replaceAll("_", " "))) : xb.has(c) ? n[s] = o.split(",").map((u) => parseInt(u, 10)) : n[s] = o.split(",").map((u) => decodeURI(u)) : Bd.has(c) ? n[s] = decodeURI(o.replaceAll("_", " ")) : xb.has(c) ? n[s] = parseInt(o, 10) : Q6.has(c) ? n[s] = o === "true" : n[s] = decodeURI(o);
      }
    });
    const i = localStorage.getItem(e);
    let a = i ? JSON.parse(i) : "{}";
    if (Object.keys(n).length > 0) {
      const s = JSON.parse(a);
      s.state || (s.state = {}), s.state.filters = n, s.state.sorts || (s.state.sorts = []), s.version || (s.version = o0), a = JSON.stringify(s);
    }
    return a;
  },
  setItem: (e, t) => {
    const { state: r } = JSON.parse(t), n = Object.fromEntries(
      Object.entries(r.filters).filter(([s, o]) => o ? zr(o) ? o.length > 0 : Gd(s) ? $b(s) ? !El(s, o) : im(o) ? Object.keys(o).length > 0 : !!o : !1 : !1)
    ), i = [];
    Object.entries(n).forEach(([s, o]) => {
      zr(o) ? Bd.has(s) ? i.push([
        s,
        o.map((c) => encodeURIComponent(c.replaceAll(" ", "_"))).join(",")
      ]) : i.push([
        s,
        o.map((c) => encodeURIComponent(c)).join(",")
      ]) : $b(s) ? (i.push([`${s}-timeframe`, encodeURIComponent(o.timeframe)]), o.timeframe === "custom" && (i.push([`${s}-start`, encodeURIComponent(o.start)]), i.push([`${s}-end`, encodeURIComponent(o.end)]))) : K6(s) ? (i.push([`${s}-condition`, encodeURIComponent(o.condition)]), i.push([`${s}-value`, encodeURIComponent(o.value)])) : im(o) ? i.push([s, encodeURIComponent(JSON.stringify(o))]) : i.push([s, encodeURIComponent(o)]);
    });
    const a = i.map(([s, o]) => `${s}=${o}`).join("&");
    a && a.trim().length > 0 ? Y6(a) : Fb(), localStorage.setItem(e, JSON.stringify(t));
  },
  removeItem: (e) => {
    Fb(), localStorage.removeItem(e);
  }
}, X6 = (e) => bh()(
  Th(
    _h(
      Ph(
        (t) => ({
          filters: {},
          sorts: [],
          /* Overall */
          reset: () => t(
            (r) => {
              r.filters = {}, r.sorts = [];
            },
            !0,
            { type: "simInventory/reset" }
          ),
          /* Filters */
          resetFilters: () => t(
            (r) => {
              r.filters = {};
            },
            !1,
            { type: "simInventory/resetFilters" }
          ),
          setOrganizationIdFilter: (r) => t(
            (n) => {
              r ? n.filters.organizationId = r : delete n.filters.organizationId;
            },
            !1,
            { type: "simInventory/setOrganizationIdFilter", organizationId: r }
          ),
          setDeviceNameFilter: (r) => t(
            (n) => {
              r ? n.filters.deviceName = r : delete n.filters.deviceName;
            },
            !1,
            { type: "simInventory/setDeviceNameFilter", deviceName: r }
          ),
          setIccidFilter: (r) => t(
            (n) => {
              n.filters.iccid = r;
            },
            !1,
            { type: "simInventory/setIccidFilter", iccid: r }
          ),
          setImeiFilter: (r) => t(
            (n) => {
              n.filters.imei = r;
            },
            !1,
            { type: "simInventory/setImeiFilter", imei: r }
          ),
          setLastActiveFilter: (r) => t(
            (n) => {
              n.filters.lastActive = r;
            },
            !1,
            { type: "simInventory/setLastActiveFilter", lastActive: r }
          ),
          setActivationDateFilter: (r) => t(
            (n) => {
              n.filters.activationDate = r;
            },
            !1,
            { type: "simInventory/setActivationDateFilter", activationDate: r }
          ),
          setTargetActivationDateFilter: (r) => t(
            (n) => {
              n.filters.targetActivationDate = r;
            },
            !1,
            { type: "simInventory/setTargetActivationDateFilter", targetActivationDate: r }
          ),
          setSimStatusFilter: (r) => t(
            (n) => {
              n.filters.simStatuses = r;
            },
            !1,
            { type: "simInventory/setSimStatusFilter", simStatuses: r }
          ),
          setTagFilter: (r) => t(
            (n) => {
              n.filters.tags = r;
            },
            !1,
            { type: "simInventory/setTagFilter", tags: r }
          ),
          // TODO: Consolidate with above
          setNoTagFilter: (r) => t(
            (n) => {
              n.filters.noTags = r;
            },
            !1,
            { type: "simInventory/setNoTagFilter", noTags: r }
          ),
          setPlanFilter: (r) => t(
            (n) => {
              n.filters.plans = r;
            },
            !1,
            { type: "simInventory/setPlanFilter", plans: r }
          ),
          /* Sorts */
          resetSorts: () => t(
            (r) => {
              r.sorts = [];
            },
            !1,
            { type: "simInventory/resetSorts" }
          ),
          setSort: (r) => t(
            (n) => {
              r ? zr(r) ? n.sorts = r : n.sorts = [r] : n.sorts = [];
            },
            !1,
            { type: "simInventory/setSort" }
          )
        }),
        {
          name: `${Ab}-${e}`,
          enabled: (process.env.VITE_ENV_NAME ?? "development") === "development"
        }
      )
    ),
    {
      name: `${Ab}-${e}`,
      version: o0,
      onRehydrateStorage: () => (t, r) => {
        r || l0.forEach((n) => {
          const i = t?.filters[n], a = Mn(i?.start), s = Mn(i?.end);
          i?.timeframe === "custom" && (!a || !s || !ct.fromDateTimes(a, s).isValid) ? delete t?.filters[n] : i?.timeframe !== "custom" && (a || s) && (delete t?.filters[n]?.start, delete t?.filters[n]?.end);
        });
      },
      storage: xw(() => J6)
    }
  )
), eG = ({
  children: e,
  simInventorySegmentName: t,
  organizationId: r
}) => {
  const n = we(/* @__PURE__ */ new Map()), i = t === "all" ? t : `${r}-${t}`, a = V(() => (n.current.has(i) || n.current.set(i, X6(i)), n.current.get(i)), [i]);
  return /* @__PURE__ */ l(Sh.Provider, { value: a, children: e });
}, tG = "hyperdashboard-SimInventory-module-DhZZbW-actionBar", rG = "hyperdashboard-SimInventory-module-DhZZbW-leftSideContent", nG = "hyperdashboard-SimInventory-module-DhZZbW-rightSideContent", iG = "hyperdashboard-SimInventory-module-DhZZbW-table", aG = "hyperdashboard-SimInventory-module-DhZZbW-wrapper", _a = {
  actionBar: tG,
  leftSideContent: rG,
  rightSideContent: nG,
  table: iG,
  wrapper: aG
}, sG = {
  dedupingInterval: 6e4,
  focusThrottleInterval: 3e5,
  loadingTimeout: 3e3,
  errorRetryInterval: 1e4,
  errorRetryCount: 3
}, u4 = Et(
  ({
    segmentName: e,
    className: t,
    simDetailBaseUrl: r,
    handleLinkClick: n,
    handleModalOpen: i,
    activateButtonRenderer: a
  }, s) => {
    const o = we(null), c = we(null), [u, f] = Z(!1), g = $((v) => {
      o.current && o.current(v), c.current && c.current(v);
    }, []), p = $((v) => {
      f(v);
    }, []);
    Kt(s, () => g, [g]);
    let d;
    switch (e) {
      case "active":
        d = "Active SIMs";
        break;
      case "preflight":
        d = "Pre-deployment SIMs";
        break;
      case "deactivated":
        d = "Deactivated SIMs";
        break;
      default:
        d = "All SIMs";
        break;
    }
    const h = Ne();
    return !e || !h && e !== "all" ? null : /* @__PURE__ */ l(fl, { value: sG, children: /* @__PURE__ */ O(
      eG,
      {
        organizationId: h,
        simInventorySegmentName: e,
        children: [
          /* @__PURE__ */ l(Vb, { children: /* @__PURE__ */ l("title", { children: `${d} - Hologram` }) }),
          /* @__PURE__ */ O(
            "div",
            {
              className: J(
                $t.pageWrapper,
                Qo.sharedLoadingAnimationParent,
                _a.wrapper,
                t
              ),
              children: [
                /* @__PURE__ */ l("div", { className: _a.leftSideContent, children: /* @__PURE__ */ l(mA, { ref: c, segmentName: e }) }),
                /* @__PURE__ */ O(
                  "div",
                  {
                    className: J(
                      _a.rightSideContent,
                      u && Qo.sharedLoadingAnimation
                    ),
                    children: [
                      /* @__PURE__ */ l(
                        kD,
                        {
                          className: _a.actionBar,
                          segmentName: e,
                          handleModalOpen: i,
                          onSimsModified: g,
                          activateButtonRenderer: a
                        },
                        `actions-${e}`
                      ),
                      /* @__PURE__ */ l(
                        Hx,
                        {
                          ref: o,
                          segmentName: e,
                          className: _a.table,
                          simDetailBaseUrl: r,
                          handleLinkClick: n,
                          onValidatingChange: p,
                          activateButtonRenderer: a
                        },
                        `table-${e}`
                      )
                    ]
                  }
                )
              ]
            }
          )
        ]
      }
    ) });
  }
), oG = () => /* @__PURE__ */ l(an, { reportId: 245 }), lG = () => /* @__PURE__ */ l(an, { reportId: 246 }), cG = () => /* @__PURE__ */ l(an, { reportId: 244 }), uG = "hyperdashboard-PredeploymentTesting-module-6Lh8ca-contents", dG = "hyperdashboard-PredeploymentTesting-module-6Lh8ca-header", fG = "hyperdashboard-PredeploymentTesting-module-6Lh8ca-headerContents", hG = "hyperdashboard-PredeploymentTesting-module-6Lh8ca-tabWrapper", mG = "hyperdashboard-PredeploymentTesting-module-6Lh8ca-wrapper", Ea = {
  contents: uG,
  header: dG,
  headerContents: fG,
  tabWrapper: hG,
  wrapper: mG
}, Mb = {
  intesting: "SIMs in testing",
  exitedtesting: "Activation history",
  testinginventory: "Pre-deployment age analysis"
}, d4 = ({
  className: e,
  handleTabClick: t,
  usageBaseUrl: r,
  viewKey: n
}) => {
  const i = Ne(), a = ii({ baseUrl: r, orgId: i }), { releaseFlags: s } = Be(), o = s?.has(Ht.EMBED_PREFLIGHT_OVERVIEW);
  return /* @__PURE__ */ l("div", { className: J($t.pageWrapper, Ea.wrapper, e), children: /* @__PURE__ */ l(
    As,
    {
      headerContents: /* @__PURE__ */ l("div", { className: Ea.headerContents, children: "Pre-deployment SIMs" }),
      headerClassName: Ea.header,
      contentsClassName: Ea.contents,
      tabs: /* @__PURE__ */ l("div", { className: J($t.tabWrapper, Ea.tabWrapper), children: Object.keys(Mb).map(
        (c) => (c !== "testinginventory" || o) && /* @__PURE__ */ l(
          _s,
          {
            selected: c === n,
            onClick: () => t(`${a}/${c}`),
            children: Mb[c]
          },
          c
        )
      ) }),
      children: /* @__PURE__ */ O("div", { className: $t.viewsWrapperNoPadding, children: [
        n === "intesting" && /* @__PURE__ */ l(cG, {}),
        n === "exitedtesting" && /* @__PURE__ */ l(oG, {}),
        n === "testinginventory" && /* @__PURE__ */ l(lG, {})
      ] })
    }
  ) });
}, pG = () => /* @__PURE__ */ l(an, { reportId: 247 }), gG = () => /* @__PURE__ */ l(an, { reportId: 243 }), vG = () => /* @__PURE__ */ l(an, { reportId: 241 }), yG = () => /* @__PURE__ */ l(an, { reportId: 242 }), bG = () => /* @__PURE__ */ l(an, { reportId: 240 }), SG = "hyperdashboard-UsageReports-module-PPugla-contents", wG = "hyperdashboard-UsageReports-module-PPugla-header", IG = "hyperdashboard-UsageReports-module-PPugla-headerContents", CG = "hyperdashboard-UsageReports-module-PPugla-tabWrapper", PG = "hyperdashboard-UsageReports-module-PPugla-wrapper", Oa = {
  contents: SG,
  header: wG,
  headerContents: IG,
  tabWrapper: CG,
  wrapper: PG
}, Lb = {
  overview: "Overview",
  bysim: "By SIM",
  bysimandday: "By SIM and day",
  bylocation: "By location",
  bysession: "By session"
}, f4 = ({
  className: e,
  handleTabClick: t,
  usageBaseUrl: r,
  viewKey: n
}) => {
  const i = Ne(), a = ii({ baseUrl: r, orgId: i }), { releaseFlags: s } = Be(), o = !s?.has(Ht.HIDE_TOWER_LOCATIONS);
  return /* @__PURE__ */ l("div", { className: J($t.pageWrapper, Oa.wrapper, e), children: /* @__PURE__ */ l(
    As,
    {
      headerContents: /* @__PURE__ */ l("div", { className: Oa.headerContents, children: "Data usage for all SIMs" }),
      headerClassName: Oa.header,
      contentsClassName: Oa.contents,
      tabs: /* @__PURE__ */ l("div", { className: J($t.tabWrapper, Oa.tabWrapper), children: Object.keys(Lb).filter((c) => c !== "bylocation" || o).map((c) => /* @__PURE__ */ l(
        _s,
        {
          selected: c === n,
          onClick: () => t(`${a}/${c}`),
          children: Lb[c]
        },
        c
      )) }),
      children: /* @__PURE__ */ O("div", { className: $t.viewsWrapperNoPadding, children: [
        n === "overview" && /* @__PURE__ */ l(bG, {}),
        n === "bysim" && /* @__PURE__ */ l(vG, {}),
        n === "bysimandday" && /* @__PURE__ */ l(yG, {}),
        n === "bylocation" && /* @__PURE__ */ l(pG, {}),
        n === "bysession" && /* @__PURE__ */ l(gG, {})
      ] })
    }
  ) });
}, TG = "hyperdashboard-PlanDetailsHeader-module-FVTfhW-headerRow", _G = "hyperdashboard-PlanDetailsHeader-module-FVTfhW-nameValue", EG = "hyperdashboard-PlanDetailsHeader-module-FVTfhW-wrapper", _o = {
  headerRow: TG,
  nameValue: _G,
  wrapper: EG
}, OG = ({
  plan: e,
  simInventoryBaseUrl: t,
  staticPool: r,
  simCount: n
}) => {
  const i = Ne(), { planName: a, perLineCharge: s, dataLimit: o, variablerate: c, overageCharge: u, id: f } = e, g = bn({
    url: `${t}/active`,
    replacers: [{ placeholder: "orgid", value: i?.toString() ?? "" }]
  }), p = bn({
    url: `${t}/predeployment`,
    replacers: [{ placeholder: "orgid", value: i?.toString() ?? "" }]
  }), { releaseFlags: d } = Be(), h = d.has(Ht.FEATURE_PREDEPLOYMENT), v = V(() => r ? `${It(r.data)} data pool` : o === 0 ? "Pay as you go" : It(o), [r, o]);
  return /* @__PURE__ */ O("div", { className: _o.wrapper, children: [
    /* @__PURE__ */ l("div", { className: _o.headerRow, children: /* @__PURE__ */ l(ee, { label: "Name", value: a, direction: "column", valueClassname: _o.nameValue }) }),
    /* @__PURE__ */ O("div", { className: _o.headerRow, children: [
      /* @__PURE__ */ l(
        ee,
        {
          label: "Active SIMs",
          value: /* @__PURE__ */ l(Ae, { to: `${g}?plans=${f}`, children: n.toLocaleString() }),
          direction: "column"
        }
      ),
      h && /* @__PURE__ */ l(
        ee,
        {
          label: "Pre-deployment SIMs",
          value: /* @__PURE__ */ l(Ae, { to: `${p}?plans=${f}`, children: "View" }),
          direction: "column"
        }
      ),
      /* @__PURE__ */ l(ee, { label: "Included data", value: v, direction: "column" }),
      /* @__PURE__ */ l(
        ee,
        {
          label: o !== 0 || r ? "Overage per MB" : "Usage per MB",
          value: c ? "Varies by network" : tt(u),
          direction: "column"
        }
      ),
      /* @__PURE__ */ l(
        ee,
        {
          label: r ? "Per SIM MRC" : "Monthly recurring charge",
          value: tt(s),
          direction: "column"
        }
      ),
      r && /* @__PURE__ */ l(
        ee,
        {
          label: "Pool data MRC",
          value: tt(parseFloat(r.amount)),
          direction: "column"
        }
      ),
      /* @__PURE__ */ l(ee, { label: "Plan ID", value: f, direction: "column" })
    ] })
  ] });
}, NG = "hyperdashboard-PlanPricingPanel-module-7jYDRW-diminished", DG = "hyperdashboard-PlanPricingPanel-module-7jYDRW-notes", Eo = {
  diminished: NG,
  notes: DG
}, RG = ({
  plan: e,
  planCoverageUrl: t,
  staticPool: r,
  simCount: n
}) => {
  const i = Ne(), {
    perLineCharge: a,
    dataLimit: s,
    variablerate: o,
    overageCharge: c,
    outboundSms: u,
    zeroDataRate: f,
    id: g,
    zone: p
  } = e, d = bn({
    url: `${t}`,
    replacers: [
      { placeholder: "orgid", value: i?.toString() ?? "" },
      { placeholder: "dataPlanId", value: g.toString() },
      { placeholder: "dataPlanZone", value: p }
    ]
  }), h = V(() => r ? It(r.data) : s === 0 ? "Pay as you go" : It(s), [r, s]);
  return /* @__PURE__ */ O(He, { header: "SIM pricing", noContentPadding: !0, children: [
    /* @__PURE__ */ l(
      Mi,
      {
        variant: "complex",
        heading: "Data usage",
        headingIcon: "CloudDataTransfer",
        fieldGroup: /* @__PURE__ */ O(le, { children: [
          r && /* @__PURE__ */ l(ee, { label: "Data pool type", value: "Fixed size" }),
          /* @__PURE__ */ l(ee, { label: "Included data", value: /* @__PURE__ */ l("strong", { children: h }) }),
          r && /* @__PURE__ */ l(ee, { label: "SIMs sharing data", value: `${n} SIMs` }),
          /* @__PURE__ */ l(
            ee,
            {
              label: s > 0 || r ? "Overage per MB" : "Usage per MB",
              value: o ? /* @__PURE__ */ l(Ae, { href: d, type: "inline", children: "Varies by network" }) : tt(c)
            }
          ),
          /* @__PURE__ */ l(
            ee,
            {
              label: "Data limits",
              value: /* @__PURE__ */ l("span", { className: Eo.diminished, children: "Set per SIM" })
            }
          )
        ] }),
        notes: !o && /* @__PURE__ */ l("div", { className: Eo.notes, children: "Session charges are aggregated until reaching a minimum charge of $0.25." })
      }
    ),
    /* @__PURE__ */ l(
      Mi,
      {
        variant: "complex",
        heading: "SMS",
        headingIcon: "Chat",
        fieldGroup: /* @__PURE__ */ O(le, { children: [
          /* @__PURE__ */ l(ee, { label: "Per outbound SMS", value: tt(u) }),
          /* @__PURE__ */ l(
            ee,
            {
              label: "Per inbound SMS",
              value: /* @__PURE__ */ l("span", { className: Eo.diminished, children: "Always free" })
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ l(
      Mi,
      {
        variant: "complex",
        heading: "Monthly recurring charge",
        headingIcon: "Receipt",
        fieldGroup: /* @__PURE__ */ O(le, { children: [
          /* @__PURE__ */ l(ee, { label: "Per SIM", value: tt(a) }),
          f && /* @__PURE__ */ l(ee, { label: "Zero-data rate", value: tt(f) }),
          r && /* @__PURE__ */ l(
            ee,
            {
              label: "Pool included data",
              value: tt(parseFloat(r.amount))
            }
          )
        ] }),
        notes: f ? /* @__PURE__ */ l("div", { className: Eo.notes, children: "If your SIM sends no sessions within a billing period, it will be charged at the zero-data rate." }) : null
      }
    )
  ] });
}, kG = "hyperdashboard-PlanCoveragePanel-module-oGRr9a-coverageWrapper", AG = "hyperdashboard-PlanCoveragePanel-module-oGRr9a-exportDropdown", xG = "hyperdashboard-PlanCoveragePanel-module-oGRr9a-footerLink", Qd = {
  coverageWrapper: kG,
  exportDropdown: AG,
  footerLink: xG
}, FG = "hyperdashboard-PlanCoveragePanelHeader-module-jWa-BW-diminished", $G = "hyperdashboard-PlanCoveragePanelHeader-module-jWa-BW-fields", MG = "hyperdashboard-PlanCoveragePanelHeader-module-jWa-BW-fieldValue", LG = "hyperdashboard-PlanCoveragePanelHeader-module-jWa-BW-profiles", fn = {
  diminished: FG,
  fields: $G,
  fieldValue: MG,
  profiles: LG
}, jG = ({ profiles: e }) => /* @__PURE__ */ l("div", { className: fn.profiles, children: e?.map((t) => /* @__PURE__ */ l(en, { size: "medium", children: t.name }, t.offerId)) }), WG = ({ planId: e, zone: t }) => {
  const r = Ne(), { plans: n, isLoading: i, error: a } = ml({ organizationId: r }), s = n.find((C) => C.id === e && C.zone === t), { plan: o, isLoading: c, error: u } = Dl(e), f = ni({ planProfiles: o?.profiles }), { data: g, error: p, isLoading: d } = Rl(f), {
    billingRates: h,
    error: v,
    isLoading: b
  } = na(r), m = V(
    () => r0(h, g, s?.overageCharge),
    [h, g, s?.overageCharge]
  ), S = V(() => b || d || c || i ? /* @__PURE__ */ l("span", { className: fn.diminished, children: "Loading…" }) : v || p || u || a ? /* @__PURE__ */ O("span", { className: fn.diminished, children: [
    /* @__PURE__ */ l(ye, { name: "Warning", size: "small", fill: "DdsColorFillNotificationError" }),
    " Unable to load"
  ] }) : m.isFlatRate ? `${tt(m.rateMin)}` : `${tt(m.rateMin)} – ${tt(m.rateMax)}`, [
    b,
    d,
    c,
    i,
    v,
    p,
    u,
    a,
    m.isFlatRate,
    m.rateMin,
    m.rateMax
  ]);
  return p || v || u || a ? null : /* @__PURE__ */ O("div", { className: fn.fields, children: [
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: "Networks",
        value: d ? /* @__PURE__ */ l("span", { className: fn.diminished, children: "Loading…" }) : g?.networks,
        valueClassname: fn.fieldValue
      }
    ),
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: "Countries",
        value: d ? /* @__PURE__ */ l("span", { className: fn.diminished, children: "Loading…" }) : g?.countries,
        valueClassname: fn.fieldValue
      }
    ),
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: s?.dataLimit === 0 ? "Usage per MB" : "Overage per MB",
        value: S,
        valueClassname: fn.fieldValue
      }
    ),
    /* @__PURE__ */ l(
      ee,
      {
        direction: "column",
        label: "Available profiles",
        value: /* @__PURE__ */ l(jG, { profiles: o?.profiles })
      }
    )
  ] });
}, UG = ({ planId: e, zone: t }) => {
  const r = Ne(), {
    plans: n,
    isLoading: i,
    error: a
  } = ml({
    organizationId: r,
    allZones: !0
  }), s = n.find((_) => _.id === e && _.zone === t), {
    billingRates: o,
    isLoading: c,
    error: u
  } = na(r), { plan: f, isLoading: g, error: p } = Dl(e), d = i || c || g, h = a || u || p, { sendAnalyticsEvent: v, sendAnalyticsError: b } = mt(), m = ni({ planProfiles: f?.profiles }), S = ia({ planProfiles: f?.profiles }), [I, C] = Z(!1), [T, E] = Z(!1), N = $(() => {
    E((_) => !_);
  }, []), y = el(), w = async (_) => {
    C(!0), N();
    try {
      return await (await Xh({
        filters: m,
        profiles: S,
        legacyPlan: s,
        billingRates: o,
        onSuccess: (R) => {
          v && v("Network Coverage - Export Networks - Export Networks success", {
            exportType: ea(R)
          });
        },
        onError: (R) => {
          b && b("Export Network Coverage error", R);
        }
      }))(_), C(!1);
    } catch {
      return C(!1), !1;
    }
  }, P = "Network coverage and rates";
  return !e || !t ? /* @__PURE__ */ l(He, { header: P, isLoading: d, children: /* @__PURE__ */ l(fe, { label: "No plan selected", variant: "error", children: "Please select a plan to view network coverage and rates" }) }) : i ? /* @__PURE__ */ l(He, { header: P, isLoading: d, children: /* @__PURE__ */ l(fe, { children: "Loading coverage information..." }) }) : h || !s ? /* @__PURE__ */ l(He, { header: P, isLoading: d, children: /* @__PURE__ */ l(
    fe,
    {
      label: "No coverage information found",
      variant: "error",
      actions: /* @__PURE__ */ l(
        Y,
        {
          type: "button",
          variant: "secondary",
          iconEnd: "ExternalLink",
          href: Nh,
          target: "_blank",
          children: "Contact support"
        }
      ),
      children: "We could not retrieve network coverage information for this plan. If this isn’t fixed after reloading this page, please reach out to our support team."
    }
  ) }) : /* @__PURE__ */ O(
    He,
    {
      header: P,
      headerActions: /* @__PURE__ */ l(
        Kn,
        {
          content: [
            {
              label: "Export coverage and rates",
              items: [
                {
                  children: "Export to XLSX (Excel)",
                  iconStart: "DownloadTray",
                  onClick: () => w(gt.XLSX)
                },
                {
                  children: "Export to CSV",
                  iconStart: "DownloadTray",
                  onClick: () => w(gt.CSV)
                }
              ]
            }
          ],
          open: T,
          onOpenChange: E,
          className: Qd.exportDropdown,
          children: /* @__PURE__ */ l(
            Y,
            {
              iconEnd: T ? "ChevronSingleNorth" : "ChevronSingleSouth",
              variant: "secondary",
              onClick: N,
              disabled: !!h || d || !!u,
              id: y,
              loading: I,
              children: "Export"
            }
          )
        }
      ),
      footer: /* @__PURE__ */ O("span", { children: [
        "Networks you can connect to are determined by the enabled profile on your SIM. You can",
        " ",
        /* @__PURE__ */ l("a", { className: Qd.footerLink, href: $w, children: "forbid or prefer networks" }),
        " ",
        "on your SIM using FPLMN/OPLMN terminal commands. Additional fields like TADIG, MCC, MNC, and UNC are available in the file export."
      ] }),
      footerVariant: "alternative",
      noContentPadding: !0,
      isLoading: d,
      children: [
        /* @__PURE__ */ l(WG, { planId: e, zone: t }),
        /* @__PURE__ */ l("div", { className: Qd.coverageWrapper, children: /* @__PURE__ */ l(Jh, { legacyPlan: s }) })
      ]
    }
  );
}, VG = (e) => {
  const t = e ? `${process.env.VITE_API_ROOT}/organizations/${e}/devices/plans` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(t, Ze);
  return {
    plans: V(() => r?.data ?? [], [r]),
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
}, HG = ({ organizationId: e, canLoad: t = !0 }) => {
  const r = new URLSearchParams({
    orgid: e?.toString() ?? "",
    enabled: "1",
    limit: "1000"
  }), n = t ? `${process.env.VITE_API_ROOT}/pools?${r}` : null, { data: i, error: a, isLoading: s, mutate: o, isValidating: c } = je(
    n,
    Ze
  );
  return {
    pools: V(() => i?.data ? i.data : [], [i]),
    error: a,
    isLoading: s,
    mutate: o,
    isValidating: c
  };
}, qG = (e) => {
  const t = e ? `${process.env.VITE_API_ROOT}/pools/plans/${e}` : null, { data: r, error: n, isLoading: i, mutate: a, isValidating: s } = je(
    t,
    Ze
  );
  return {
    pool: r?.data,
    error: n,
    isLoading: i,
    mutate: a,
    isValidating: s
  };
}, zG = "hyperdashboard-Plan-module-5yMbZq-contents", BG = "hyperdashboard-Plan-module-5yMbZq-header", GG = "hyperdashboard-Plan-module-5yMbZq-tabWrapper", QG = "hyperdashboard-Plan-module-5yMbZq-wrapper", Oo = {
  contents: zG,
  header: BG,
  tabWrapper: GG,
  wrapper: QG
}, ZG = {
  dedupingInterval: 6e4,
  focusThrottleInterval: 3e5,
  loadingTimeout: 3e3,
  errorRetryInterval: 1e4,
  errorRetryCount: 3
}, YG = {
  pricing: "Pricing",
  coverage: "Coverage"
}, KG = ({
  planId: e,
  zone: t,
  viewKey: r,
  handleTabClick: n,
  simInventoryBaseUrl: i,
  planCoverageUrl: a
}) => {
  const s = Ne(), {
    plans: o,
    isLoading: c,
    error: u
  } = ml({ organizationId: s, includezdr: !0, allZones: !0 }), {
    plans: f,
    isLoading: g,
    error: p
  } = VG(s), { pools: d, isLoading: h, error: v } = HG({ organizationId: s }), b = o.find((y) => y.id === e && y.zone === t), m = f.find(
    (y) => y?.planid === b?.id && y?.zone === b?.zone
  )?.count ?? 0, S = d.find((y) => y.dataplansubscriptionid === e), { pool: I, isLoading: C, error: T } = qG(S?.poolplanid), E = u || p || v || T, N = c || g || h || C;
  return E ? /* @__PURE__ */ l(fe, { variant: "error", children: "There was a problem loading this data plan." }) : N ? /* @__PURE__ */ l(ur, { children: "Loading plan details..." }) : b ? /* @__PURE__ */ l("div", { className: wt($t.pageWrapper, Oo.wrapper), children: /* @__PURE__ */ l(
    As,
    {
      headerContents: /* @__PURE__ */ l(
        OG,
        {
          plan: b,
          simInventoryBaseUrl: i,
          staticPool: I,
          simCount: m
        }
      ),
      headerClassName: Oo.header,
      contentsClassName: $t.viewsWrapper,
      tabs: /* @__PURE__ */ l("div", { className: wt($t.tabWrapper, Oo.tabWrapper), children: Object.entries(YG).map(([y, w]) => /* @__PURE__ */ l(
        _s,
        {
          id: `plan-tab-${y}`,
          selected: y === r,
          onClick: () => n(y),
          children: w
        },
        y
      )) }),
      children: /* @__PURE__ */ O("div", { className: Oo.contents, children: [
        r === "pricing" && /* @__PURE__ */ l(
          RG,
          {
            plan: b,
            planCoverageUrl: a,
            staticPool: I,
            simCount: m
          }
        ),
        r === "coverage" && /* @__PURE__ */ l(UG, { planId: e, zone: t })
      ] })
    }
  ) }) : /* @__PURE__ */ l(fe, { children: "No matching data plan found." });
}, h4 = ({
  planId: e,
  zone: t,
  viewKey: r,
  handleTabClick: n,
  simInventoryBaseUrl: i,
  planCoverageUrl: a
}) => /* @__PURE__ */ l(fl, { value: ZG, children: /* @__PURE__ */ l(
  KG,
  {
    planId: e,
    zone: t,
    viewKey: r,
    handleTabClick: n,
    simInventoryBaseUrl: i,
    planCoverageUrl: a
  }
) });
it.defaultLocale = Ln.toString();
K0();
export {
  s4 as AccountPage,
  H3 as AnalyticsProvider,
  dh as ApnInfoIcon,
  Z3 as ApnModal,
  W3 as AppNotificationBanner,
  q3 as AuthProvider,
  w_ as BackgroundGradient,
  As as BorderlessPanel,
  Qm as CardButton,
  Y3 as CoverageSearchModal,
  eE as DeviceDetailsPanel,
  an as EmbeddedReport,
  Dt as EmptyState,
  K3 as FeedbackModal,
  ee as Field,
  sn as FilterAccordion,
  o4 as LandingEmptyPage,
  z3 as LegacyDashboardProvider,
  l4 as LoginPage,
  gw as ManageSimButton,
  J3 as ManageTunnelingModal,
  X3 as OrgAcceptedInviteModal,
  e4 as OrgIntroModal,
  pG as OrganizationLocationHistory,
  Px as OrganizationProvider,
  fh as Picture,
  h4 as PlanPage,
  d4 as PredeploymentTestingPage,
  xE as ProfileAndICCID,
  t4 as SetUsageAlertsModal,
  EB as SimAndDevicesView,
  EN as SimDetailsHeader,
  c4 as SimDetailsPage,
  MN as SimDetailsPanel,
  BN as SimFallbackHistory,
  kD as SimInventoryActions,
  r4 as SimInventoryBulkSendMessage,
  YD as SimInventoryBulkUpdateState,
  n4 as SimInventoryBulkUpdateStateModal,
  V3 as SimInventoryDetailsNotification,
  mA as SimInventoryFilters,
  u4 as SimInventoryPage,
  Hx as SimInventoryTable,
  Jx as SimProfileHistoryPanel,
  G3 as SimProfileStatus,
  T1 as SimProfiles,
  l2 as SimProfilesView,
  $6 as SimRecentSessionsView,
  Ol as SimStatusChip,
  vF as SimStatusPanel,
  U2 as SimStatusView,
  kF as SimSwitchProfiles,
  i4 as SimSwitchProfilesModal,
  HF as SimUsagePanel,
  V2 as SimUsageView,
  a4 as SimulateMessageToApi,
  ei as Table,
  Q3 as TableTypes,
  nN as TagManager,
  sN as TagManagerModal,
  Dh as Timeframe,
  XF as UpdateBillingAddress,
  QF as UpdateBillingAddressForm,
  gG as UsageBySessionView,
  yG as UsageBySimAndDayView,
  vG as UsageBySimView,
  bG as UsageOverviewView,
  oG as UsagePredeploymentActivationHistory,
  lG as UsagePredeploymentAgeAnalysis,
  cG as UsagePredeploymentTestingView,
  f4 as UsageReportsPage,
  Ui as alphabeticSortCompare,
  lr as apiDateToDateTime,
  xT as convertApiPlanToReduxPlan,
  Go as dateTimeToInputDate,
  bl as downloadCSV,
  Aw as downloadJSON,
  vt as enumPermissions,
  Ht as enumReleaseFlags,
  $i as formatDate,
  bt as formatDateTime,
  Ee as formatNumber,
  z_ as getAllPerms,
  pp as getPreflightDuration,
  It as getUserFriendlyBytes,
  Mn as inputDateToDateTime,
  G_ as labelForRole,
  MT as reducePlans,
  Cp as stringToFloat,
  B_ as translatePermissionsToRole,
  U3 as translateRoleToPermissions,
  pl as useAuth,
  NT as useBalance,
  DT as useBilling,
  YS as useBulkStateChangeCall,
  eT as useBulkStateChangePreview,
  iD as useCountries,
  LT as useEmbeddedReport,
  gl as useIsEuiccSim,
  tT as useLoginCall,
  rT as useLoginTotpCall,
  Wn as useOpenSessions,
  RT as useOrganizationDetails,
  ml as usePlans,
  Le as useSimDetails,
  B3 as useSimDetailsStore,
  Mt as useSimDeviceDetails,
  ch as useSimDeviceOverview,
  lw as useSimFallbackHistory,
  vl as useSimInventoryFilters,
  Oh as useSimInventorySelected,
  Eh as useSimInventorySelectionStore,
  nD as useSimInventorySorts,
  Ms as useSimInventoryStore,
  Ar as useSimInventoryStoredFilters,
  Rw as useSimInventoryStoredSorts,
  ks as useSimMostRecentSession,
  WT as useSimProfileEnableCall,
  cw as useSimProfileHistory,
  kr as useSimProfiles,
  ht as useSimStatuses,
  Jl as useSims,
  Sf as useSimsCount,
  uw as useSimsIds,
  j3 as useStatusPage,
  uh as useTags,
  jT as useUserDetails,
  Be as useUserInfo
};
//# sourceMappingURL=index.js.map
